webpackJsonp([230186691558513],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = whitespace
	
	var fromCode = String.fromCharCode
	var re = /\s/
	
	// Check if the given character code, or the character code at the first
	// character, is a whitespace character.
	function whitespace(character) {
	  return re.test(
	    typeof character === 'number' ? fromCode(character) : character.charAt(0)
	  )
	}


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2019, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var allLocaleData = _interopDefault(__webpack_require__(656));
	var IntlMessageFormat = _interopDefault(__webpack_require__(154));
	var IntlRelativeFormat = _interopDefault(__webpack_require__(385));
	var PropTypes = _interopDefault(__webpack_require__(7));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var hoistNonReactStatics = _interopDefault(__webpack_require__(68));
	var invariant = _interopDefault(__webpack_require__(17));
	var memoizeIntlConstructor = _interopDefault(__webpack_require__(377));
	
	// GENERATED FILE
	var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
	    var s = String(n).split("."),
	        v0 = !s[1],
	        t0 = Number(s[0]) == n,
	        n10 = t0 && s[0].slice(-1),
	        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
	  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function addLocaleData() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var locales = Array.isArray(data) ? data : [data];
	
	  locales.forEach(function (localeData) {
	    if (localeData && localeData.locale) {
	      IntlMessageFormat.__addLocaleData(localeData);
	      IntlRelativeFormat.__addLocaleData(localeData);
	    }
	  });
	}
	
	function hasLocaleData(locale) {
	  var localeParts = (locale || '').split('-');
	
	  while (localeParts.length > 0) {
	    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
	      return true;
	    }
	
	    localeParts.pop();
	  }
	
	  return false;
	}
	
	function hasIMFAndIRFLocaleData(locale) {
	  var normalizedLocale = locale && locale.toLowerCase();
	
	  return !!(IntlMessageFormat.__localeData__[normalizedLocale] && IntlRelativeFormat.__localeData__[normalizedLocale]);
	}
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	var asyncGenerator = function () {
	  function AwaitValue(value) {
	    this.value = value;
	  }
	
	  function AsyncGenerator(gen) {
	    var front, back;
	
	    function send(key, arg) {
	      return new Promise(function (resolve, reject) {
	        var request = {
	          key: key,
	          arg: arg,
	          resolve: resolve,
	          reject: reject,
	          next: null
	        };
	
	        if (back) {
	          back = back.next = request;
	        } else {
	          front = back = request;
	          resume(key, arg);
	        }
	      });
	    }
	
	    function resume(key, arg) {
	      try {
	        var result = gen[key](arg);
	        var value = result.value;
	
	        if (value instanceof AwaitValue) {
	          Promise.resolve(value.value).then(function (arg) {
	            resume("next", arg);
	          }, function (arg) {
	            resume("throw", arg);
	          });
	        } else {
	          settle(result.done ? "return" : "normal", result.value);
	        }
	      } catch (err) {
	        settle("throw", err);
	      }
	    }
	
	    function settle(type, value) {
	      switch (type) {
	        case "return":
	          front.resolve({
	            value: value,
	            done: true
	          });
	          break;
	
	        case "throw":
	          front.reject(value);
	          break;
	
	        default:
	          front.resolve({
	            value: value,
	            done: false
	          });
	          break;
	      }
	
	      front = front.next;
	
	      if (front) {
	        resume(front.key, front.arg);
	      } else {
	        back = null;
	      }
	    }
	
	    this._invoke = send;
	
	    if (typeof gen.return !== "function") {
	      this.return = undefined;
	    }
	  }
	
	  if (typeof Symbol === "function" && Symbol.asyncIterator) {
	    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
	      return this;
	    };
	  }
	
	  AsyncGenerator.prototype.next = function (arg) {
	    return this._invoke("next", arg);
	  };
	
	  AsyncGenerator.prototype.throw = function (arg) {
	    return this._invoke("throw", arg);
	  };
	
	  AsyncGenerator.prototype.return = function (arg) {
	    return this._invoke("return", arg);
	  };
	
	  return {
	    wrap: function (fn) {
	      return function () {
	        return new AsyncGenerator(fn.apply(this, arguments));
	      };
	    },
	    await: function (value) {
	      return new AwaitValue(value);
	    }
	  };
	}();
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var bool = PropTypes.bool;
	var number = PropTypes.number;
	var string = PropTypes.string;
	var func = PropTypes.func;
	var object = PropTypes.object;
	var oneOf = PropTypes.oneOf;
	var shape = PropTypes.shape;
	var any = PropTypes.any;
	var oneOfType = PropTypes.oneOfType;
	
	var localeMatcher = oneOf(['best fit', 'lookup']);
	var narrowShortLong = oneOf(['narrow', 'short', 'long']);
	var numeric2digit = oneOf(['numeric', '2-digit']);
	var funcReq = func.isRequired;
	
	var intlConfigPropTypes = {
	  locale: string,
	  timeZone: string,
	  formats: object,
	  messages: object,
	  textComponent: any,
	
	  defaultLocale: string,
	  defaultFormats: object,
	
	  onError: func
	};
	
	var intlFormatPropTypes = {
	  formatDate: funcReq,
	  formatTime: funcReq,
	  formatRelative: funcReq,
	  formatNumber: funcReq,
	  formatPlural: funcReq,
	  formatMessage: funcReq,
	  formatHTMLMessage: funcReq
	};
	
	var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
	  formatters: object,
	  now: funcReq
	}));
	
	var messageDescriptorPropTypes = {
	  id: string.isRequired,
	  description: oneOfType([string, object]),
	  defaultMessage: string
	};
	
	var dateTimeFormatPropTypes = {
	  localeMatcher: localeMatcher,
	  formatMatcher: oneOf(['basic', 'best fit']),
	
	  timeZone: string,
	  hour12: bool,
	
	  weekday: narrowShortLong,
	  era: narrowShortLong,
	  year: numeric2digit,
	  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
	  day: numeric2digit,
	  hour: numeric2digit,
	  minute: numeric2digit,
	  second: numeric2digit,
	  timeZoneName: oneOf(['short', 'long'])
	};
	
	var numberFormatPropTypes = {
	  localeMatcher: localeMatcher,
	
	  style: oneOf(['decimal', 'currency', 'percent']),
	  currency: string,
	  currencyDisplay: oneOf(['symbol', 'code', 'name']),
	  useGrouping: bool,
	
	  minimumIntegerDigits: number,
	  minimumFractionDigits: number,
	  maximumFractionDigits: number,
	  minimumSignificantDigits: number,
	  maximumSignificantDigits: number
	};
	
	var relativeFormatPropTypes = {
	  style: oneOf(['best fit', 'numeric']),
	  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year', 'second-short', 'minute-short', 'hour-short', 'day-short', 'month-short', 'year-short'])
	};
	
	var pluralFormatPropTypes = {
	  style: oneOf(['cardinal', 'ordinal'])
	};
	
	/*
	HTML escaping and shallow-equals implementations are the same as React's
	(on purpose.) Therefore, it has the following Copyright and Licensing:
	
	Copyright 2013-2014, Facebook, Inc.
	All rights reserved.
	
	This source code is licensed under the BSD-style license found in the LICENSE
	file in the root directory of React's source tree.
	*/
	
	var intlConfigPropNames = Object.keys(intlConfigPropTypes);
	
	var ESCAPED_CHARS = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  "'": '&#x27;'
	};
	
	var UNSAFE_CHARS_REGEX = /[&><"']/g;
	
	function escape(str) {
	  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
	    return ESCAPED_CHARS[match];
	  });
	}
	
	function filterProps(props, whitelist) {
	  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  return whitelist.reduce(function (filtered, name) {
	    if (props.hasOwnProperty(name)) {
	      filtered[name] = props[name];
	    } else if (defaults$$1.hasOwnProperty(name)) {
	      filtered[name] = defaults$$1[name];
	    }
	
	    return filtered;
	  }, {});
	}
	
	function invariantIntlContext() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      intl = _ref.intl;
	
	  invariant(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
	}
	
	function shallowEquals(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
	  var props = _ref2.props,
	      state = _ref2.state,
	      _ref2$context = _ref2.context,
	      context = _ref2$context === undefined ? {} : _ref2$context;
	  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var _context$intl = context.intl,
	      intl = _context$intl === undefined ? {} : _context$intl;
	  var _nextContext$intl = nextContext.intl,
	      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;
	
	
	  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
	}
	
	function createError(message, exception) {
	  var eMsg = exception ? '\n' + exception : '';
	  return '[React Intl] ' + message + eMsg;
	}
	
	function defaultErrorHandler(error) {
	  if (false) {
	    console.error(error);
	  }
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// Inspired by react-redux's `connect()` HOC factory function implementation:
	// https://github.com/rackt/react-redux
	
	function getDisplayName(Component$$1) {
	  return Component$$1.displayName || Component$$1.name || 'Component';
	}
	
	function injectIntl(WrappedComponent) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$intlPropName = options.intlPropName,
	      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var InjectIntl = function (_Component) {
	    inherits(InjectIntl, _Component);
	
	    function InjectIntl(props, context) {
	      classCallCheck(this, InjectIntl);
	
	      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));
	
	      invariantIntlContext(context);
	      return _this;
	    }
	
	    createClass(InjectIntl, [{
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        invariant(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');
	
	        return this._wrappedInstance;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        return React__default.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
	          ref: withRef ? /* istanbul ignore next */function (ref) {
	            return _this2._wrappedInstance = ref;
	          } : null
	        }));
	      }
	    }]);
	    return InjectIntl;
	  }(React.Component);
	
	  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
	  InjectIntl.contextTypes = {
	    intl: intlShape
	  };
	  InjectIntl.WrappedComponent = WrappedComponent;
	
	
	  return hoistNonReactStatics(InjectIntl, WrappedComponent);
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function defineMessages(messageDescriptors) {
	  // This simply returns what's passed-in because it's meant to be a hook for
	  // babel-plugin-react-intl.
	  return messageDescriptors;
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// This is a "hack" until a proper `intl-pluralformat` package is created.
	
	function resolveLocale(locales) {
	  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
	  return IntlMessageFormat.prototype._resolveLocale(locales);
	}
	
	function findPluralFunction(locale) {
	  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
	  return IntlMessageFormat.prototype._findPluralRuleFunction(locale);
	}
	
	var IntlPluralFormat = function IntlPluralFormat(locales) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  classCallCheck(this, IntlPluralFormat);
	
	  var useOrdinal = options.style === 'ordinal';
	  var pluralFn = findPluralFunction(resolveLocale(locales));
	
	  this.format = function (value) {
	    return pluralFn(value, useOrdinal);
	  };
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
	var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
	var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
	var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);
	
	var RELATIVE_FORMAT_THRESHOLDS = {
	  second: 60, // seconds to minute
	  minute: 60, // minutes to hour
	  hour: 24, // hours to day
	  day: 30, // days to month
	  month: 12 };
	
	function updateRelativeFormatThresholds(newThresholds) {
	  var thresholds = IntlRelativeFormat.thresholds;
	  thresholds.second = newThresholds.second;
	  thresholds.minute = newThresholds.minute;
	  thresholds.hour = newThresholds.hour;
	  thresholds.day = newThresholds.day;
	  thresholds.month = newThresholds.month;
	  thresholds['second-short'] = newThresholds['second-short'];
	  thresholds['minute-short'] = newThresholds['minute-short'];
	  thresholds['hour-short'] = newThresholds['hour-short'];
	  thresholds['day-short'] = newThresholds['day-short'];
	  thresholds['month-short'] = newThresholds['month-short'];
	}
	
	function getNamedFormat(formats, type, name, onError) {
	  var format = formats && formats[type] && formats[type][name];
	  if (format) {
	    return format;
	  }
	
	  onError(createError('No ' + type + ' format named: ' + name));
	}
	
	function formatDate(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats,
	      timeZone = config.timeZone;
	  var format = options.format;
	
	
	  var onError = config.onError || defaultErrorHandler;
	  var date = new Date(value);
	  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'date', format, onError));
	  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);
	
	  try {
	    return state.getDateTimeFormat(locale, filteredOptions).format(date);
	  } catch (e) {
	    onError(createError('Error formatting date.', e));
	  }
	
	  return String(date);
	}
	
	function formatTime(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats,
	      timeZone = config.timeZone;
	  var format = options.format;
	
	
	  var onError = config.onError || defaultErrorHandler;
	  var date = new Date(value);
	  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'time', format, onError));
	  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);
	
	  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
	    // Add default formatting options if hour, minute, or second isn't defined.
	    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
	  }
	
	  try {
	    return state.getDateTimeFormat(locale, filteredOptions).format(date);
	  } catch (e) {
	    onError(createError('Error formatting time.', e));
	  }
	
	  return String(date);
	}
	
	function formatRelative(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats;
	  var format = options.format;
	
	
	  var onError = config.onError || defaultErrorHandler;
	  var date = new Date(value);
	  var now = new Date(options.now);
	  var defaults$$1 = format && getNamedFormat(formats, 'relative', format, onError);
	  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);
	
	  // Capture the current threshold values, then temporarily override them with
	  // specific values just for this render.
	  var oldThresholds = _extends({}, IntlRelativeFormat.thresholds);
	  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);
	
	  try {
	    return state.getRelativeFormat(locale, filteredOptions).format(date, {
	      now: isFinite(now) ? now : state.now()
	    });
	  } catch (e) {
	    onError(createError('Error formatting relative time.', e));
	  } finally {
	    updateRelativeFormatThresholds(oldThresholds);
	  }
	
	  return String(date);
	}
	
	function formatNumber(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats;
	  var format = options.format;
	
	
	  var onError = config.onError || defaultErrorHandler;
	  var defaults$$1 = format && getNamedFormat(formats, 'number', format, onError);
	  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);
	
	  try {
	    return state.getNumberFormat(locale, filteredOptions).format(value);
	  } catch (e) {
	    onError(createError('Error formatting number.', e));
	  }
	
	  return String(value);
	}
	
	function formatPlural(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale;
	
	
	  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
	  var onError = config.onError || defaultErrorHandler;
	
	  try {
	    return state.getPluralFormat(locale, filteredOptions).format(value);
	  } catch (e) {
	    onError(createError('Error formatting plural.', e));
	  }
	
	  return 'other';
	}
	
	function formatMessage(config, state) {
	  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats,
	      messages = config.messages,
	      defaultLocale = config.defaultLocale,
	      defaultFormats = config.defaultFormats;
	  var id = messageDescriptor.id,
	      defaultMessage = messageDescriptor.defaultMessage;
	
	  // Produce a better error if the user calls `intl.formatMessage(element)`
	
	  if (false) {
	    invariant(!React.isValidElement(config), '[React Intl] Don\'t pass React elements to ' + 'formatMessage(), pass `.props`.');
	  }
	
	  // `id` is a required field of a Message Descriptor.
	  invariant(id, '[React Intl] An `id` must be provided to format a message.');
	
	  var message = messages && messages[id];
	  var hasValues = Object.keys(values).length > 0;
	
	  // Avoid expensive message formatting for simple messages without values. In
	  // development messages will always be formatted in case of missing values.
	  if (!hasValues && ("production") === 'production') {
	    return message || defaultMessage || id;
	  }
	
	  var formattedMessage = void 0;
	  var onError = config.onError || defaultErrorHandler;
	
	  if (message) {
	    try {
	      var formatter = state.getMessageFormat(message, locale, formats);
	
	      formattedMessage = formatter.format(values);
	    } catch (e) {
	      onError(createError('Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''), e));
	    }
	  } else {
	    // This prevents warnings from littering the console in development
	    // when no `messages` are passed into the <IntlProvider> for the
	    // default locale, and a default message is in the source.
	    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
	      onError(createError('Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '')));
	    }
	  }
	
	  if (!formattedMessage && defaultMessage) {
	    try {
	      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);
	
	      formattedMessage = _formatter.format(values);
	    } catch (e) {
	      onError(createError('Error formatting the default message for: "' + id + '"', e));
	    }
	  }
	
	  if (!formattedMessage) {
	    onError(createError('Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.')));
	  }
	
	  return formattedMessage || message || defaultMessage || id;
	}
	
	function formatHTMLMessage(config, state, messageDescriptor) {
	  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  // Process all the values before they are used when formatting the ICU
	  // Message string. Since the formatted message might be injected via
	  // `innerHTML`, all String-based values need to be HTML-escaped.
	  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
	    var value = rawValues[name];
	    escaped[name] = typeof value === 'string' ? escape(value) : value;
	    return escaped;
	  }, {});
	
	  return formatMessage(config, state, messageDescriptor, escapedValues);
	}
	
	
	
	var format = Object.freeze({
		formatDate: formatDate,
		formatTime: formatTime,
		formatRelative: formatRelative,
		formatNumber: formatNumber,
		formatPlural: formatPlural,
		formatMessage: formatMessage,
		formatHTMLMessage: formatHTMLMessage
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
	var intlFormatPropNames = Object.keys(intlFormatPropTypes);
	
	// These are not a static property on the `IntlProvider` class so the intl
	// config values can be inherited from an <IntlProvider> ancestor.
	var defaultProps = {
	  formats: {},
	  messages: {},
	  timeZone: null,
	  textComponent: 'span',
	
	  defaultLocale: 'en',
	  defaultFormats: {},
	
	  onError: defaultErrorHandler
	};
	
	var IntlProvider = function (_Component) {
	  inherits(IntlProvider, _Component);
	
	  function IntlProvider(props) {
	    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    classCallCheck(this, IntlProvider);
	
	    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));
	
	    invariant(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');
	
	    var intlContext = context.intl;
	
	    // Used to stabilize time when performing an initial rendering so that
	    // all relative times use the same reference "now" time.
	
	    var initialNow = void 0;
	    if (isFinite(props.initialNow)) {
	      initialNow = Number(props.initialNow);
	    } else {
	      // When an `initialNow` isn't provided via `props`, look to see an
	      // <IntlProvider> exists in the ancestry and call its `now()`
	      // function to propagate its value for "now".
	      initialNow = intlContext ? intlContext.now() : Date.now();
	    }
	
	    // Creating `Intl*` formatters is expensive. If there's a parent
	    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
	    // memoize the `Intl*` constructors and cache them for the lifecycle of
	    // this IntlProvider instance.
	
	    var _ref = intlContext || {},
	        _ref$formatters = _ref.formatters,
	        formatters = _ref$formatters === undefined ? {
	      getDateTimeFormat: memoizeIntlConstructor(Intl.DateTimeFormat),
	      getNumberFormat: memoizeIntlConstructor(Intl.NumberFormat),
	      getMessageFormat: memoizeIntlConstructor(IntlMessageFormat),
	      getRelativeFormat: memoizeIntlConstructor(IntlRelativeFormat),
	      getPluralFormat: memoizeIntlConstructor(IntlPluralFormat)
	    } : _ref$formatters;
	
	    _this.state = _extends({}, formatters, {
	
	      // Wrapper to provide stable "now" time for initial render.
	      now: function now() {
	        return _this._didDisplay ? Date.now() : initialNow;
	      }
	    });
	    return _this;
	  }
	
	  createClass(IntlProvider, [{
	    key: 'getConfig',
	    value: function getConfig() {
	      var intlContext = this.context.intl;
	
	      // Build a whitelisted config object from `props`, defaults, and
	      // `context.intl`, if an <IntlProvider> exists in the ancestry.
	
	      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);
	
	      // Apply default props. This must be applied last after the props have
	      // been resolved and inherited from any <IntlProvider> in the ancestry.
	      // This matches how React resolves `defaultProps`.
	      for (var propName in defaultProps) {
	        if (config[propName] === undefined) {
	          config[propName] = defaultProps[propName];
	        }
	      }
	
	      if (!hasLocaleData(config.locale)) {
	        var _config = config,
	            locale = _config.locale,
	            defaultLocale = _config.defaultLocale,
	            defaultFormats = _config.defaultFormats,
	            onError = _config.onError;
	
	
	        onError(createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.')));
	
	        // Since there's no registered locale data for `locale`, this will
	        // fallback to the `defaultLocale` to make sure things can render.
	        // The `messages` are overridden to the `defaultProps` empty object
	        // to maintain referential equality across re-renders. It's assumed
	        // each <FormattedMessage> contains a `defaultMessage` prop.
	        config = _extends({}, config, {
	          locale: defaultLocale,
	          formats: defaultFormats,
	          messages: defaultProps.messages
	        });
	      }
	
	      return config;
	    }
	  }, {
	    key: 'getBoundFormatFns',
	    value: function getBoundFormatFns(config, state) {
	      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
	        boundFormatFns[name] = format[name].bind(null, config, state);
	        return boundFormatFns;
	      }, {});
	    }
	  }, {
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var config = this.getConfig();
	
	      // Bind intl factories and current config to the format functions.
	      var boundFormatFns = this.getBoundFormatFns(config, this.state);
	
	      var _state = this.state,
	          now = _state.now,
	          formatters = objectWithoutProperties(_state, ['now']);
	
	
	      return {
	        intl: _extends({}, config, boundFormatFns, {
	          formatters: formatters,
	          now: now
	        })
	      };
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._didDisplay = true;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return React.Children.only(this.props.children);
	    }
	  }]);
	  return IntlProvider;
	}(React.Component);
	
	IntlProvider.displayName = 'IntlProvider';
	IntlProvider.contextTypes = {
	  intl: intlShape
	};
	IntlProvider.childContextTypes = {
	  intl: intlShape.isRequired
	};
	 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
	  children: PropTypes.element.isRequired,
	  initialNow: PropTypes.any
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedDate = function (_Component) {
	  inherits(FormattedDate, _Component);
	
	  function FormattedDate(props, context) {
	    classCallCheck(this, FormattedDate);
	
	    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedDate, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatDate = _context$intl.formatDate,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedDate = formatDate(value, this.props);
	
	      if (typeof children === 'function') {
	        return children(formattedDate);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedDate
	      );
	    }
	  }]);
	  return FormattedDate;
	}(React.Component);
	
	FormattedDate.displayName = 'FormattedDate';
	FormattedDate.contextTypes = {
	  intl: intlShape
	};
	 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedTime = function (_Component) {
	  inherits(FormattedTime, _Component);
	
	  function FormattedTime(props, context) {
	    classCallCheck(this, FormattedTime);
	
	    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedTime, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatTime = _context$intl.formatTime,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedTime = formatTime(value, this.props);
	
	      if (typeof children === 'function') {
	        return children(formattedTime);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedTime
	      );
	    }
	  }]);
	  return FormattedTime;
	}(React.Component);
	
	FormattedTime.displayName = 'FormattedTime';
	FormattedTime.contextTypes = {
	  intl: intlShape
	};
	 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var SECOND = 1000;
	var MINUTE = 1000 * 60;
	var HOUR = 1000 * 60 * 60;
	var DAY = 1000 * 60 * 60 * 24;
	
	// The maximum timer delay value is a 32-bit signed integer.
	// See: https://mdn.io/setTimeout
	var MAX_TIMER_DELAY = 2147483647;
	
	function selectUnits(delta) {
	  var absDelta = Math.abs(delta);
	
	  if (absDelta < MINUTE) {
	    return 'second';
	  }
	
	  if (absDelta < HOUR) {
	    return 'minute';
	  }
	
	  if (absDelta < DAY) {
	    return 'hour';
	  }
	
	  // The maximum scheduled delay will be measured in days since the maximum
	  // timer delay is less than the number of milliseconds in 25 days.
	  return 'day';
	}
	
	function getUnitDelay(units) {
	  switch (units) {
	    case 'second':
	      return SECOND;
	    case 'minute':
	      return MINUTE;
	    case 'hour':
	      return HOUR;
	    case 'day':
	      return DAY;
	    default:
	      return MAX_TIMER_DELAY;
	  }
	}
	
	function isSameDate(a, b) {
	  if (a === b) {
	    return true;
	  }
	
	  var aTime = new Date(a).getTime();
	  var bTime = new Date(b).getTime();
	
	  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
	}
	
	var FormattedRelative = function (_Component) {
	  inherits(FormattedRelative, _Component);
	
	  function FormattedRelative(props, context) {
	    classCallCheck(this, FormattedRelative);
	
	    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));
	
	    invariantIntlContext(context);
	
	    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();
	
	    // `now` is stored as state so that `render()` remains a function of
	    // props + state, instead of accessing `Date.now()` inside `render()`.
	    _this.state = { now: now };
	    return _this;
	  }
	
	  createClass(FormattedRelative, [{
	    key: 'scheduleNextUpdate',
	    value: function scheduleNextUpdate(props, state) {
	      var _this2 = this;
	
	      // Cancel and pending update because we're scheduling a new update.
	      clearTimeout(this._timer);
	
	      var value = props.value,
	          units = props.units,
	          updateInterval = props.updateInterval;
	
	      var time = new Date(value).getTime();
	
	      // If the `updateInterval` is falsy, including `0` or we don't have a
	      // valid date, then auto updates have been turned off, so we bail and
	      // skip scheduling an update.
	      if (!updateInterval || !isFinite(time)) {
	        return;
	      }
	
	      var delta = time - state.now;
	      var unitDelay = getUnitDelay(units || selectUnits(delta));
	      var unitRemainder = Math.abs(delta % unitDelay);
	
	      // We want the largest possible timer delay which will still display
	      // accurate information while reducing unnecessary re-renders. The delay
	      // should be until the next "interesting" moment, like a tick from
	      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
	      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);
	
	      this._timer = setTimeout(function () {
	        _this2.setState({ now: _this2.context.intl.now() });
	      }, delay);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scheduleNextUpdate(this.props, this.state);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref) {
	      var nextValue = _ref.value;
	
	      // When the `props.value` date changes, `state.now` needs to be updated,
	      // and the next update can be rescheduled.
	      if (!isSameDate(nextValue, this.props.value)) {
	        this.setState({ now: this.context.intl.now() });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      this.scheduleNextUpdate(nextProps, nextState);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this._timer);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatRelative = _context$intl.formatRelative,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));
	
	      if (typeof children === 'function') {
	        return children(formattedRelative);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedRelative
	      );
	    }
	  }]);
	  return FormattedRelative;
	}(React.Component);
	
	FormattedRelative.displayName = 'FormattedRelative';
	FormattedRelative.contextTypes = {
	  intl: intlShape
	};
	FormattedRelative.defaultProps = {
	  updateInterval: 1000 * 10
	};
	 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  updateInterval: PropTypes.number,
	  initialNow: PropTypes.any,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedNumber = function (_Component) {
	  inherits(FormattedNumber, _Component);
	
	  function FormattedNumber(props, context) {
	    classCallCheck(this, FormattedNumber);
	
	    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedNumber, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatNumber = _context$intl.formatNumber,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedNumber = formatNumber(value, this.props);
	
	      if (typeof children === 'function') {
	        return children(formattedNumber);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedNumber
	      );
	    }
	  }]);
	  return FormattedNumber;
	}(React.Component);
	
	FormattedNumber.displayName = 'FormattedNumber';
	FormattedNumber.contextTypes = {
	  intl: intlShape
	};
	 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedPlural = function (_Component) {
	  inherits(FormattedPlural, _Component);
	
	  function FormattedPlural(props, context) {
	    classCallCheck(this, FormattedPlural);
	
	    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedPlural, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatPlural = _context$intl.formatPlural,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          other = _props.other,
	          children = _props.children;
	
	
	      var pluralCategory = formatPlural(value, this.props);
	      var formattedPlural = this.props[pluralCategory] || other;
	
	      if (typeof children === 'function') {
	        return children(formattedPlural);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedPlural
	      );
	    }
	  }]);
	  return FormattedPlural;
	}(React.Component);
	
	FormattedPlural.displayName = 'FormattedPlural';
	FormattedPlural.contextTypes = {
	  intl: intlShape
	};
	FormattedPlural.defaultProps = {
	  style: 'cardinal'
	};
	 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	
	  other: PropTypes.node.isRequired,
	  zero: PropTypes.node,
	  one: PropTypes.node,
	  two: PropTypes.node,
	  few: PropTypes.node,
	  many: PropTypes.node,
	
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
	  if (false) {
	    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
	  }
	  return formatMessage({}, { getMessageFormat: memoizeIntlConstructor(IntlMessageFormat) }, descriptor, values);
	};
	
	var FormattedMessage = function (_Component) {
	  inherits(FormattedMessage, _Component);
	
	  function FormattedMessage(props, context) {
	    classCallCheck(this, FormattedMessage);
	
	    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));
	
	    if (!props.defaultMessage) {
	      invariantIntlContext(context);
	    }
	    return _this;
	  }
	
	  createClass(FormattedMessage, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var values = this.props.values;
	      var nextValues = nextProps.values;
	
	
	      if (!shallowEquals(nextValues, values)) {
	        return true;
	      }
	
	      // Since `values` has already been checked, we know they're not
	      // different, so the current `values` are carried over so the shallow
	      // equals comparison on the other props isn't affected by the `values`.
	      var nextPropsToCheck = _extends({}, nextProps, {
	        values: values
	      });
	
	      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        next[_key - 1] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _ref = this.context.intl || {},
	          _ref$formatMessage = _ref.formatMessage,
	          formatMessage$$1 = _ref$formatMessage === undefined ? defaultFormatMessage : _ref$formatMessage,
	          _ref$textComponent = _ref.textComponent,
	          Text = _ref$textComponent === undefined ? 'span' : _ref$textComponent;
	
	      var _props = this.props,
	          id = _props.id,
	          description = _props.description,
	          defaultMessage = _props.defaultMessage,
	          values = _props.values,
	          _props$tagName = _props.tagName,
	          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
	          children = _props.children;
	
	
	      var tokenDelimiter = void 0;
	      var tokenizedValues = void 0;
	      var elements = void 0;
	
	      var hasValues = values && Object.keys(values).length > 0;
	      if (hasValues) {
	        // Creates a token with a random UID that should not be guessable or
	        // conflict with other parts of the `message` string.
	        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);
	
	        var generateToken = function () {
	          var counter = 0;
	          return function () {
	            return 'ELEMENT-' + uid + '-' + (counter += 1);
	          };
	        }();
	
	        // Splitting with a delimiter to support IE8. When using a regex
	        // with a capture group IE8 does not include the capture group in
	        // the resulting array.
	        tokenDelimiter = '@__' + uid + '__@';
	        tokenizedValues = {};
	        elements = {};
	
	        // Iterates over the `props` to keep track of any React Element
	        // values so they can be represented by the `token` as a placeholder
	        // when the `message` is formatted. This allows the formatted
	        // message to then be broken-up into parts with references to the
	        // React Elements inserted back in.
	        Object.keys(values).forEach(function (name) {
	          var value = values[name];
	
	          if (React.isValidElement(value)) {
	            var token = generateToken();
	            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
	            elements[token] = value;
	          } else {
	            tokenizedValues[name] = value;
	          }
	        });
	      }
	
	      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	      var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);
	
	      var nodes = void 0;
	
	      var hasElements = elements && Object.keys(elements).length > 0;
	      if (hasElements) {
	        // Split the message into parts so the React Element values captured
	        // above can be inserted back into the rendered message. This
	        // approach allows messages to render with React Elements while
	        // keeping React's virtual diffing working properly.
	        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
	          return !!part;
	        }).map(function (part) {
	          return elements[part] || part;
	        });
	      } else {
	        nodes = [formattedMessage];
	      }
	
	      if (typeof children === 'function') {
	        return children.apply(undefined, toConsumableArray(nodes));
	      }
	
	      // Needs to use `createElement()` instead of JSX, otherwise React will
	      // warn about a missing `key` prop with rich-text message formatting.
	      return React.createElement.apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
	    }
	  }]);
	  return FormattedMessage;
	}(React.Component);
	
	FormattedMessage.displayName = 'FormattedMessage';
	FormattedMessage.contextTypes = {
	  intl: intlShape
	};
	FormattedMessage.defaultProps = {
	  values: {}
	};
	 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
	  values: PropTypes.object,
	  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedHTMLMessage = function (_Component) {
	  inherits(FormattedHTMLMessage, _Component);
	
	  function FormattedHTMLMessage(props, context) {
	    classCallCheck(this, FormattedHTMLMessage);
	
	    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedHTMLMessage, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var values = this.props.values;
	      var nextValues = nextProps.values;
	
	
	      if (!shallowEquals(nextValues, values)) {
	        return true;
	      }
	
	      // Since `values` has already been checked, we know they're not
	      // different, so the current `values` are carried over so the shallow
	      // equals comparison on the other props isn't affected by the `values`.
	      var nextPropsToCheck = _extends({}, nextProps, {
	        values: values
	      });
	
	      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        next[_key - 1] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatHTMLMessage = _context$intl.formatHTMLMessage,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          id = _props.id,
	          description = _props.description,
	          defaultMessage = _props.defaultMessage,
	          rawValues = _props.values,
	          _props$tagName = _props.tagName,
	          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
	          children = _props.children;
	
	
	      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);
	
	      if (typeof children === 'function') {
	        return children(formattedHTMLMessage);
	      }
	
	      // Since the message presumably has HTML in it, we need to set
	      // `innerHTML` in order for it to be rendered and not escaped by React.
	      // To be safe, all string prop values were escaped when formatting the
	      // message. It is assumed that the message is not UGC, and came from the
	      // developer making it more like a template.
	      //
	      // Note: There's a perf impact of using this component since there's no
	      // way for React to do its virtual DOM diffing.
	      var html = { __html: formattedHTMLMessage };
	      return React__default.createElement(Component$$1, { dangerouslySetInnerHTML: html });
	    }
	  }]);
	  return FormattedHTMLMessage;
	}(React.Component);
	
	FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
	FormattedHTMLMessage.contextTypes = {
	  intl: intlShape
	};
	FormattedHTMLMessage.defaultProps = {
	  values: {}
	};
	 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
	  values: PropTypes.object,
	  tagName: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(defaultLocaleData);
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(allLocaleData);
	
	exports.addLocaleData = addLocaleData;
	exports.intlShape = intlShape;
	exports.injectIntl = injectIntl;
	exports.defineMessages = defineMessages;
	exports.IntlProvider = IntlProvider;
	exports.FormattedDate = FormattedDate;
	exports.FormattedTime = FormattedTime;
	exports.FormattedRelative = FormattedRelative;
	exports.FormattedNumber = FormattedNumber;
	exports.FormattedPlural = FormattedPlural;
	exports.FormattedMessage = FormattedMessage;
	exports.FormattedHTMLMessage = FormattedHTMLMessage;


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports) {

	
	exports = module.exports = trim;
	
	function trim(str){
	  return str.replace(/^\s*|\s*$/g, '');
	}
	
	exports.left = function(str){
	  return str.replace(/^\s*/, '');
	};
	
	exports.right = function(str){
	  return str.replace(/\s*$/, '');
	};


/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Return the image URL to be displayed inside the project card
	Can be either :
	* the GitHub owner avatar (by default if no `icon` property is specified)
	* A custom SVG file if project's `icon`property is specified.
	The SVG can be stored locally (inside `www/logos` folder) or in the cloud.
	*/
	
	var isUrl = function isUrl(input) {
	  return input.startsWith('http');
	};
	
	var formatIconUrl = function formatIconUrl(input) {
	  return isUrl(input) ? input : 'https://bestofjs.org/logos/' + input;
	};
	
	var formatOwnerAvatar = function formatOwnerAvatar(owner_id, size) {
	  return 'https://avatars.githubusercontent.com/u/' + owner_id + '?v=3&s=' + size;
	};
	
	var getProjectAvatarUrl = function getProjectAvatarUrl(project, size) {
	  return project.icon ? formatIconUrl(project.icon) : formatOwnerAvatar(project.owner_id, size);
	};
	
	var Avatar = function Avatar(_ref) {
	  var project = _ref.project,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 100 : _ref$size,
	      _ref$link = _ref.link,
	      link = _ref$link === undefined ? false : _ref$link;
	  var svg = project.svg;
	
	  if (svg) return _react2.default.createElement('div', { style: { width: size }, dangerouslySetInnerHTML: { __html: svg } });
	  // Performance optimization:
	  // to avoid fetching 2 times the same avatar in 2 different sizes, we fetch only once the biggest one
	  var maxSize = Math.max(size, 50);
	  var urls = {
	    standard: getProjectAvatarUrl(project, maxSize),
	    retina: getProjectAvatarUrl(project, maxSize * 2)
	  };
	
	  var img = _react2.default.createElement('img', {
	    src: urls.standard,
	    srcSet: urls.retina + ' 2x',
	    width: size,
	    height: size,
	    alt: project.name
	  });
	
	  return link ? _react2.default.createElement(
	    'a',
	    { href: '#' + project.slug },
	    img
	  ) : img;
	};
	
	exports.default = Avatar;
	module.exports = exports['default'];

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(455);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Markdown = __webpack_require__(252);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TranslatedBlock = function TranslatedBlock(_ref) {
	  var translations = _ref.translations,
	      path = _ref.path,
	      language = _ref.language,
	      entities = _ref.entities;
	
	  var markdown = (0, _lodash2.default)(translations[language], path) || 'No translation for this path: "' + path + '"';
	  // return <div dangerouslySetInnerHTML={{ __html: html }} />
	  return _react2.default.createElement(_Markdown2.default, { source: markdown, entities: entities });
	};
	
	exports.default = TranslatedBlock;
	module.exports = exports['default'];

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 69 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = decimal
	
	// Check if the given character code, or the character code at the first
	// character, is decimal.
	function decimal(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return code >= 48 && code <= 57 /* 0-9 */
	}


/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = visit
	
	var visitParents = __webpack_require__(640)
	
	var CONTINUE = visitParents.CONTINUE
	var SKIP = visitParents.SKIP
	var EXIT = visitParents.EXIT
	
	visit.CONTINUE = CONTINUE
	visit.SKIP = SKIP
	visit.EXIT = EXIT
	
	function visit(tree, test, visitor, reverse) {
	  if (typeof test === 'function' && typeof visitor !== 'function') {
	    reverse = visitor
	    visitor = test
	    test = null
	  }
	
	  visitParents(tree, test, overload, reverse)
	
	  function overload(node, parents) {
	    var parent = parents[parents.length - 1]
	    var index = parent ? parent.children.indexOf(node) : null
	    return visitor(node, index, parent)
	  }
	}


/***/ }),
/* 77 */,
/* 78 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	/*
	Important Note:  we don't use `gatsby-transformer-remark` plugin because
	markdown content is process by `react-markdown` in order to process project 'slugs'
	*/
	module.exports = {
	  siteMetadata: {
	    title: 'JavaScript Rising Stars',
	    url: 'https://risingstars.js.org',
	    GA: 'UA-44563970-4',
	    currentYear: 2019 // used to show Twitter blurb only if we are on the page for the current year
	  },
	  plugins: [{
	    resolve: 'gatsby-source-filesystem',
	    options: {
	      name: 'translations',
	      path: __dirname + '/i18n'
	    }
	  }, {
	    resolve: 'gatsby-plugin-sass'
	  }, {
	    resolve: 'gatsby-plugin-netlify'
	  }, {
	    resolve: 'gatsby-plugin-react-helmet'
	  }]
	  // `no prefix needed when using the subdomain `.js.org`
	  // pathPrefix: `/javascript-risingstars` // needed when deployed on https://bestofjs.github.io/javascript-risingstars/
	};
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _numeral = __webpack_require__(461);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatDelta(delta) {
	  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  // return `+${delta}☆☆`
	  var numberFormat = decimals === 0 || delta < 1000 ? '0' : '0.' + '0'.repeat(decimals);
	  var formattedNumber = (0, _numeral2.default)(delta).format(numberFormat + 'a');
	  // const formattedNumber = numeral(delta).format(`0a`)
	  return formattedNumber;
	}
	
	exports.default = formatDelta;
	module.exports = exports['default'];

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var legacy = __webpack_require__(425)
	var invalid = __webpack_require__(426)
	var decimal = __webpack_require__(69)
	var hexadecimal = __webpack_require__(393)
	var alphanumerical = __webpack_require__(391)
	var decodeEntity = __webpack_require__(462)
	
	module.exports = parseEntities
	
	var own = {}.hasOwnProperty
	var fromCharCode = String.fromCharCode
	var noop = Function.prototype
	
	// Default settings.
	var defaults = {
	  warning: null,
	  reference: null,
	  text: null,
	  warningContext: null,
	  referenceContext: null,
	  textContext: null,
	  position: {},
	  additional: null,
	  attribute: false,
	  nonTerminated: true
	}
	
	// Characters.
	var tab = 9 // '\t'
	var lineFeed = 10 // '\n'
	var formFeed = 12 //  '\f'
	var space = 32 // ' '
	var ampersand = 38 //  '&'
	var semicolon = 59 //  ';'
	var lessThan = 60 //  '<'
	var equalsTo = 61 //  '='
	var numberSign = 35 //  '#'
	var uppercaseX = 88 //  'X'
	var lowercaseX = 120 //  'x'
	var replacementCharacter = 65533 // '�'
	
	// Reference types.
	var name = 'named'
	var hexa = 'hexadecimal'
	var deci = 'decimal'
	
	// Map of bases.
	var bases = {}
	
	bases[hexa] = 16
	bases[deci] = 10
	
	// Map of types to tests.
	// Each type of character reference accepts different characters.
	// This test is used to detect whether a reference has ended (as the semicolon
	// is not strictly needed).
	var tests = {}
	
	tests[name] = alphanumerical
	tests[deci] = decimal
	tests[hexa] = hexadecimal
	
	// Warning types.
	var namedNotTerminated = 1
	var numericNotTerminated = 2
	var namedEmpty = 3
	var numericEmpty = 4
	var namedUnknown = 5
	var numericDisallowed = 6
	var numericProhibited = 7
	
	// Warning messages.
	var messages = {}
	
	messages[namedNotTerminated] =
	  'Named character references must be terminated by a semicolon'
	messages[numericNotTerminated] =
	  'Numeric character references must be terminated by a semicolon'
	messages[namedEmpty] = 'Named character references cannot be empty'
	messages[numericEmpty] = 'Numeric character references cannot be empty'
	messages[namedUnknown] = 'Named character references must be known'
	messages[numericDisallowed] =
	  'Numeric character references cannot be disallowed'
	messages[numericProhibited] =
	  'Numeric character references cannot be outside the permissible Unicode range'
	
	// Wrap to ensure clean parameters are given to `parse`.
	function parseEntities(value, options) {
	  var settings = {}
	  var option
	  var key
	
	  if (!options) {
	    options = {}
	  }
	
	  for (key in defaults) {
	    option = options[key]
	    settings[key] =
	      option === null || option === undefined ? defaults[key] : option
	  }
	
	  if (settings.position.indent || settings.position.start) {
	    settings.indent = settings.position.indent || []
	    settings.position = settings.position.start
	  }
	
	  return parse(value, settings)
	}
	
	// Parse entities.
	// eslint-disable-next-line complexity
	function parse(value, settings) {
	  var additional = settings.additional
	  var nonTerminated = settings.nonTerminated
	  var handleText = settings.text
	  var handleReference = settings.reference
	  var handleWarning = settings.warning
	  var textContext = settings.textContext
	  var referenceContext = settings.referenceContext
	  var warningContext = settings.warningContext
	  var pos = settings.position
	  var indent = settings.indent || []
	  var length = value.length
	  var index = 0
	  var lines = -1
	  var column = pos.column || 1
	  var line = pos.line || 1
	  var queue = ''
	  var result = []
	  var entityCharacters
	  var namedEntity
	  var terminated
	  var characters
	  var character
	  var reference
	  var following
	  var warning
	  var reason
	  var output
	  var entity
	  var begin
	  var start
	  var type
	  var test
	  var prev
	  var next
	  var diff
	  var end
	
	  if (typeof additional === 'string') {
	    additional = additional.charCodeAt(0)
	  }
	
	  // Cache the current point.
	  prev = now()
	
	  // Wrap `handleWarning`.
	  warning = handleWarning ? parseError : noop
	
	  // Ensure the algorithm walks over the first character and the end (inclusive).
	  index--
	  length++
	
	  while (++index < length) {
	    // If the previous character was a newline.
	    if (character === lineFeed) {
	      column = indent[lines] || 1
	    }
	
	    character = value.charCodeAt(index)
	
	    if (character === ampersand) {
	      following = value.charCodeAt(index + 1)
	
	      // The behaviour depends on the identity of the next character.
	      if (
	        following === tab ||
	        following === lineFeed ||
	        following === formFeed ||
	        following === space ||
	        following === ampersand ||
	        following === lessThan ||
	        following !== following ||
	        (additional && following === additional)
	      ) {
	        // Not a character reference.
	        // No characters are consumed, and nothing is returned.
	        // This is not an error, either.
	        queue += fromCharCode(character)
	        column++
	
	        continue
	      }
	
	      start = index + 1
	      begin = start
	      end = start
	
	      if (following === numberSign) {
	        // Numerical entity.
	        end = ++begin
	
	        // The behaviour further depends on the next character.
	        following = value.charCodeAt(end)
	
	        if (following === uppercaseX || following === lowercaseX) {
	          // ASCII hex digits.
	          type = hexa
	          end = ++begin
	        } else {
	          // ASCII digits.
	          type = deci
	        }
	      } else {
	        // Named entity.
	        type = name
	      }
	
	      entityCharacters = ''
	      entity = ''
	      characters = ''
	      test = tests[type]
	      end--
	
	      while (++end < length) {
	        following = value.charCodeAt(end)
	
	        if (!test(following)) {
	          break
	        }
	
	        characters += fromCharCode(following)
	
	        // Check if we can match a legacy named reference.
	        // If so, we cache that as the last viable named reference.
	        // This ensures we do not need to walk backwards later.
	        if (type === name && own.call(legacy, characters)) {
	          entityCharacters = characters
	          entity = legacy[characters]
	        }
	      }
	
	      terminated = value.charCodeAt(end) === semicolon
	
	      if (terminated) {
	        end++
	
	        namedEntity = type === name ? decodeEntity(characters) : false
	
	        if (namedEntity) {
	          entityCharacters = characters
	          entity = namedEntity
	        }
	      }
	
	      diff = 1 + end - start
	
	      if (!terminated && !nonTerminated) {
	        // Empty.
	      } else if (!characters) {
	        // An empty (possible) entity is valid, unless it’s numeric (thus an
	        // ampersand followed by an octothorp).
	        if (type !== name) {
	          warning(numericEmpty, diff)
	        }
	      } else if (type === name) {
	        // An ampersand followed by anything unknown, and not terminated, is
	        // invalid.
	        if (terminated && !entity) {
	          warning(namedUnknown, 1)
	        } else {
	          // If theres something after an entity name which is not known, cap
	          // the reference.
	          if (entityCharacters !== characters) {
	            end = begin + entityCharacters.length
	            diff = 1 + end - begin
	            terminated = false
	          }
	
	          // If the reference is not terminated, warn.
	          if (!terminated) {
	            reason = entityCharacters ? namedNotTerminated : namedEmpty
	
	            if (settings.attribute) {
	              following = value.charCodeAt(end)
	
	              if (following === equalsTo) {
	                warning(reason, diff)
	                entity = null
	              } else if (alphanumerical(following)) {
	                entity = null
	              } else {
	                warning(reason, diff)
	              }
	            } else {
	              warning(reason, diff)
	            }
	          }
	        }
	
	        reference = entity
	      } else {
	        if (!terminated) {
	          // All non-terminated numeric entities are not rendered, and trigger a
	          // warning.
	          warning(numericNotTerminated, diff)
	        }
	
	        // When terminated and number, parse as either hexadecimal or decimal.
	        reference = parseInt(characters, bases[type])
	
	        // Trigger a warning when the parsed number is prohibited, and replace
	        // with replacement character.
	        if (prohibited(reference)) {
	          warning(numericProhibited, diff)
	          reference = fromCharCode(replacementCharacter)
	        } else if (reference in invalid) {
	          // Trigger a warning when the parsed number is disallowed, and replace
	          // by an alternative.
	          warning(numericDisallowed, diff)
	          reference = invalid[reference]
	        } else {
	          // Parse the number.
	          output = ''
	
	          // Trigger a warning when the parsed number should not be used.
	          if (disallowed(reference)) {
	            warning(numericDisallowed, diff)
	          }
	
	          // Stringify the number.
	          if (reference > 0xffff) {
	            reference -= 0x10000
	            output += fromCharCode((reference >>> (10 & 0x3ff)) | 0xd800)
	            reference = 0xdc00 | (reference & 0x3ff)
	          }
	
	          reference = output + fromCharCode(reference)
	        }
	      }
	
	      // Found it!
	      // First eat the queued characters as normal text, then eat an entity.
	      if (reference) {
	        flush()
	
	        prev = now()
	        index = end - 1
	        column += end - start + 1
	        result.push(reference)
	        next = now()
	        next.offset++
	
	        if (handleReference) {
	          handleReference.call(
	            referenceContext,
	            reference,
	            {start: prev, end: next},
	            value.slice(start - 1, end)
	          )
	        }
	
	        prev = next
	      } else {
	        // If we could not find a reference, queue the checked characters (as
	        // normal characters), and move the pointer to their end.
	        // This is possible because we can be certain neither newlines nor
	        // ampersands are included.
	        characters = value.slice(start - 1, end)
	        queue += characters
	        column += characters.length
	        index = end - 1
	      }
	    } else {
	      // Handle anything other than an ampersand, including newlines and EOF.
	      if (
	        character === 10 // Line feed
	      ) {
	        line++
	        lines++
	        column = 0
	      }
	
	      if (character === character) {
	        queue += fromCharCode(character)
	        column++
	      } else {
	        flush()
	      }
	    }
	  }
	
	  // Return the reduced nodes, and any possible warnings.
	  return result.join('')
	
	  // Get current position.
	  function now() {
	    return {
	      line: line,
	      column: column,
	      offset: index + (pos.offset || 0)
	    }
	  }
	
	  // “Throw” a parse-error: a warning.
	  function parseError(code, offset) {
	    var position = now()
	
	    position.column += offset
	    position.offset += offset
	
	    handleWarning.call(warningContext, messages[code], position, code)
	  }
	
	  // Flush `queue` (normal text).
	  // Macro invoked before each entity and at the end of `value`.
	  // Does nothing when `queue` is empty.
	  function flush() {
	    if (queue) {
	      result.push(queue)
	
	      if (handleText) {
	        handleText.call(textContext, queue, {start: prev, end: now()})
	      }
	
	      queue = ''
	    }
	  }
	}
	
	// Check if `character` is outside the permissible unicode range.
	function prohibited(code) {
	  return (code >= 0xd800 && code <= 0xdfff) || code > 0x10ffff
	}
	
	// Check if `character` is disallowed.
	function disallowed(code) {
	  return (
	    (code >= 0x0001 && code <= 0x0008) ||
	    code === 0x000b ||
	    (code >= 0x000d && code <= 0x001f) ||
	    (code >= 0x007f && code <= 0x009f) ||
	    (code >= 0xfdd0 && code <= 0xfdef) ||
	    (code & 0xffff) === 0xffff ||
	    (code & 0xffff) === 0xfffe
	  )
	}


/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */
/***/ (function(module, exports) {

	/** @license React v16.11.0
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
	60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function z(a){return y(a)===m}
	exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
	exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = interrupt;
	
	function interrupt(interruptors, tokenizers, ctx, params) {
	  var bools = ['pedantic', 'commonmark'];
	  var count = bools.length;
	  var length = interruptors.length;
	  var index = -1;
	  var interruptor;
	  var config;
	  var fn;
	  var offset;
	  var bool;
	  var ignore;
	
	  while (++index < length) {
	    interruptor = interruptors[index];
	    config = interruptor[1] || {};
	    fn = interruptor[0];
	    offset = -1;
	    ignore = false;
	
	    while (++offset < count) {
	      bool = bools[offset];
	
	      if (config[bool] !== undefined && config[bool] !== ctx.options[bool]) {
	        ignore = true;
	        break;
	      }
	    }
	
	    if (ignore) {
	      continue;
	    }
	
	    if (tokenizers[fn].apply(ctx, params)) {
	      return true;
	    }
	  }
	
	  return false;
	}


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var collapseWhiteSpace = __webpack_require__(268);
	
	module.exports = normalize;
	
	/* Normalize an identifier.  Collapses multiple white space
	 * characters into a single space, and removes casing. */
	function normalize(value) {
	  return collapseWhiteSpace(value).toLowerCase();
	}


/***/ }),
/* 120 */
/***/ (function(module, exports) {

	/*!
	 * repeat-string <https://github.com/jonschlinkert/repeat-string>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	'use strict';
	
	/**
	 * Results cache
	 */
	
	var res = '';
	var cache;
	
	/**
	 * Expose `repeat`
	 */
	
	module.exports = repeat;
	
	/**
	 * Repeat the given `string` the specified `number`
	 * of times.
	 *
	 * **Example:**
	 *
	 * ```js
	 * var repeat = require('repeat-string');
	 * repeat('A', 5);
	 * //=> AAAAA
	 * ```
	 *
	 * @param {String} `string` The string to repeat
	 * @param {Number} `number` The number of times to repeat the string
	 * @return {String} Repeated string
	 * @api public
	 */
	
	function repeat(str, num) {
	  if (typeof str !== 'string') {
	    throw new TypeError('expected a string');
	  }
	
	  // cover common, quick use cases
	  if (num === 1) return str;
	  if (num === 2) return str + str;
	
	  var max = str.length * num;
	  if (cache !== str || typeof cache === 'undefined') {
	    cache = str;
	    res = '';
	  } else if (res.length >= max) {
	    return res.substr(0, max);
	  }
	
	  while (max > res.length && num > 1) {
	    if (num & 1) {
	      res += str;
	    }
	
	    num >>= 1;
	    str += str;
	  }
	
	  res += str;
	  res = res.substr(0, max);
	  return res;
	}


/***/ }),
/* 121 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = trimTrailingLines
	
	var line = '\n'
	
	// Remove final newline characters from `value`.
	function trimTrailingLines(value) {
	  var val = String(value)
	  var index = val.length
	
	  while (val.charAt(--index) === line) {
	    // Empty
	  }
	
	  return val.slice(0, index + 1)
	}


/***/ }),
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Buttons = function Buttons(_ref) {
	  var url = _ref.url,
	      text = _ref.text;
	  return _react2.default.createElement(
	    "div",
	    { className: "share-buttons" },
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "a",
	        { className: "resp-sharing-button__link", href: "https://facebook.com/sharer/sharer.php?u=" + url, target: "_blank", "aria-label": "Share on Facebook" },
	        _react2.default.createElement(
	          "div",
	          { className: "resp-sharing-button resp-sharing-button--facebook resp-sharing-button--large" },
	          _react2.default.createElement(
	            "div",
	            { "aria-hidden": "true", className: "resp-sharing-button__icon resp-sharing-button__icon--solid" },
	            _react2.default.createElement(
	              "svg",
	              { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
	              _react2.default.createElement("path", { d: "M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z" })
	            )
	          ),
	          true && 'Facebook'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "a",
	        { className: "resp-sharing-button__link", href: "https://twitter.com/intent/tweet/?text=" + text + "&amp;url=" + url, target: "_blank", "aria-label": "Share on Twitter" },
	        _react2.default.createElement(
	          "div",
	          { className: "resp-sharing-button resp-sharing-button--twitter resp-sharing-button--large" },
	          _react2.default.createElement(
	            "div",
	            { "aria-hidden": "true", className: "resp-sharing-button__icon resp-sharing-button__icon--solid" },
	            _react2.default.createElement(
	              "svg",
	              { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
	              _react2.default.createElement("path", { d: "M23.44 4.83c-.8.37-1.5.38-2.22.02.93-.56.98-.96 1.32-2.02-.88.52-1.86.9-2.9 1.1-.82-.88-2-1.43-3.3-1.43-2.5 0-4.55 2.04-4.55 4.54 0 .36.03.7.1 1.04-3.77-.2-7.12-2-9.36-4.75-.4.67-.6 1.45-.6 2.3 0 1.56.8 2.95 2 3.77-.74-.03-1.44-.23-2.05-.57v.06c0 2.2 1.56 4.03 3.64 4.44-.67.2-1.37.2-2.06.08.58 1.8 2.26 3.12 4.25 3.16C5.78 18.1 3.37 18.74 1 18.46c2 1.3 4.4 2.04 6.97 2.04 8.35 0 12.92-6.92 12.92-12.93 0-.2 0-.4-.02-.6.9-.63 1.96-1.22 2.56-2.14z" })
	            )
	          ),
	          "Twitter"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "a",
	        { className: "resp-sharing-button__link", href: "mailto:?subject=" + text + "&amp;body=" + url, target: "_self", "aria-label": "Share by E-Mail" },
	        _react2.default.createElement(
	          "div",
	          { className: "resp-sharing-button resp-sharing-button--email resp-sharing-button--large" },
	          _react2.default.createElement(
	            "div",
	            { "aria-hidden": "true", className: "resp-sharing-button__icon resp-sharing-button__icon--solid" },
	            _react2.default.createElement(
	              "svg",
	              { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
	              _react2.default.createElement("path", { d: "M22 4H2C.9 4 0 4.9 0 6v12c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.25 14.43l-3.5 2c-.08.05-.17.07-.25.07-.17 0-.34-.1-.43-.25-.14-.24-.06-.55.18-.68l3.5-2c.24-.14.55-.06.68.18.14.24.06.55-.18.68zm4.75.07c-.1 0-.2-.03-.27-.08l-8.5-5.5c-.23-.15-.3-.46-.15-.7.15-.22.46-.3.7-.14L12 13.4l8.23-5.32c.23-.15.54-.08.7.15.14.23.07.54-.16.7l-8.5 5.5c-.08.04-.17.07-.27.07zm8.93 1.75c-.1.16-.26.25-.43.25-.08 0-.17-.02-.25-.07l-3.5-2c-.24-.13-.32-.44-.18-.68s.44-.32.68-.18l3.5 2c.24.13.32.44.18.68z" })
	            )
	          ),
	          true && 'E-Mail'
	        )
	      )
	    )
	  );
	};
	
	exports.default = Buttons;
	module.exports = exports["default"];

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _Social = __webpack_require__(124);
	
	var _Social2 = _interopRequireDefault(_Social);
	
	var _TranslatedBlock = __webpack_require__(57);
	
	var _TranslatedBlock2 = _interopRequireDefault(_TranslatedBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// const IntroductionText = styled.div`
	//   font-size: 18px;
	//   p {
	//     margin-top: 0;
	//   }
	// `
	
	// import styled from 'styled-components'
	
	var Introduction = function Introduction(_ref) {
	  var entities = _ref.entities,
	      url = _ref.url,
	      intl = _ref.intl,
	      translations = _ref.translations;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'introduction-text' },
	      _react2.default.createElement(_TranslatedBlock2.default, {
	        translations: translations,
	        language: intl.locale,
	        path: 'introduction',
	        entities: entities
	      })
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Social2.default, { url: url, text: intl.formatMessage({ id: 'social.text' }) })
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'p',
	      { style: { margin: '1rem 0 0' } },
	      _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'introduction.explanation',
	        defaultMessage: '\n          We analyzed projects coming from {link},\n        a curated list of the best projects related to the web platform.\n        ',
	        values: {
	          link: _react2.default.createElement(
	            'a',
	            { href: 'https://bestofjs.org/' },
	            'Best of JavaScript'
	          )
	        }
	      })
	    )
	  );
	};
	
	exports.default = Introduction;
	module.exports = exports['default'];

/***/ }),
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var emptyObject = __webpack_require__(48);
	var _invariant = __webpack_require__(2);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlMessageFormat = __webpack_require__(384)['default'];
	
	// Add all locale data to `IntlMessageFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(654);
	
	// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlMessageFormat;
	exports['default'] = exports;


/***/ }),
/* 155 */
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports.extend = extend;
	var hop = Object.prototype.hasOwnProperty;
	
	function extend(obj) {
	    var sources = Array.prototype.slice.call(arguments, 1),
	        i, len, source, key;
	
	    for (i = 0, len = sources.length; i < len; i += 1) {
	        source = sources[i];
	        if (!source) { continue; }
	
	        for (key in source) {
	            if (hop.call(source, key)) {
	                obj[key] = source[key];
	            }
	        }
	    }
	
	    return obj;
	}
	exports.hop = hop;
	
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 156 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = alphabetical
	
	// Check if the given character code, or the character code at the first
	// character, is alphabetical.
	function alphabetical(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return (
	    (code >= 97 && code <= 122) /* a-z */ ||
	    (code >= 65 && code <= 90) /* A-Z */
	  )
	}


/***/ }),
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(114);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  position: true,
	  gfm: true,
	  commonmark: false,
	  footnotes: false,
	  pedantic: false,
	  blocks: __webpack_require__(427)
	};


/***/ }),
/* 196 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var link = value.indexOf('[', fromIndex);
	  var image = value.indexOf('![', fromIndex);
	
	  if (image === -1) {
	    return link;
	  }
	
	  /* Link can never be `-1` if an image is found, so we don’t need
	   * to check for that :) */
	  return link < image ? link : image;
	}


/***/ }),
/* 197 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('<', fromIndex);
	}


/***/ }),
/* 198 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = indentation;
	
	/* Map of characters, and their column length,
	 * which can be used as indentation. */
	var characters = {' ': 1, '\t': 4};
	
	/* Gets indentation information for a line. */
	function indentation(value) {
	  var index = 0;
	  var indent = 0;
	  var character = value.charAt(index);
	  var stops = {};
	  var size;
	
	  while (character in characters) {
	    size = characters[character];
	
	    indent += size;
	
	    if (size > 1) {
	      indent = Math.floor(indent / size) * size;
	    }
	
	    stops[indent] = index;
	
	    character = value.charAt(++index);
	  }
	
	  return {indent: indent, stops: stops};
	}


/***/ }),
/* 199 */
/***/ (function(module, exports) {

	'use strict';
	
	var attributeName = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
	var unquoted = '[^"\'=<>`\\u0000-\\u0020]+';
	var singleQuoted = '\'[^\']*\'';
	var doubleQuoted = '"[^"]*"';
	var attributeValue = '(?:' + unquoted + '|' + singleQuoted + '|' + doubleQuoted + ')';
	var attribute = '(?:\\s+' + attributeName + '(?:\\s*=\\s*' + attributeValue + ')?)';
	var openTag = '<[A-Za-z][A-Za-z0-9\\-]*' + attribute + '*\\s*\\/?>';
	var closeTag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
	var comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
	var processing = '<[?].*?[?]>';
	var declaration = '<![A-Za-z]+\\s+[^>]*>';
	var cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
	
	exports.openCloseTag = new RegExp('^(?:' + openTag + '|' + closeTag + ')');
	
	exports.tag = new RegExp('^(?:' +
	  openTag + '|' +
	  closeTag + '|' +
	  comment + '|' +
	  processing + '|' +
	  declaration + '|' +
	  cdata +
	')');


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	  if (condition) {
	    return;
	  }
	
	  if (isProduction) {
	    throw new Error(prefix);
	  } else {
	    throw new Error(prefix + ": " + (message || ''));
	  }
	}
	
	module.exports = invariant;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var categories = __webpack_require__(415);
	var projects = __webpack_require__(416);
	
	module.exports = {
	  categories: categories,
	  projects: projects
	};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var categories = __webpack_require__(417);
	var projects = __webpack_require__(418);
	
	module.exports = {
	  categories: categories,
	  projects: projects
	};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var categories = __webpack_require__(419);
	var projects = __webpack_require__(420);
	
	module.exports = {
	  categories: categories,
	  projects: projects
	};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var categories = __webpack_require__(421);
	var projects = __webpack_require__(422);
	
	module.exports = {
	  categories: categories,
	  projects: projects
	};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(209);
	
	var _2 = _interopRequireDefault(_);
	
	var _3 = __webpack_require__(210);
	
	var _4 = _interopRequireDefault(_3);
	
	var _5 = __webpack_require__(211);
	
	var _6 = _interopRequireDefault(_5);
	
	var _7 = __webpack_require__(212);
	
	var _8 = _interopRequireDefault(_7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  year2016: _2.default,
	  year2017: _4.default,
	  year2018: _6.default,
	  year2019: _8.default
	};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = 75;
	
	var getAvatarURL = function getAvatarURL(userId) {
	  return 'https://avatars0.githubusercontent.com/u/' + userId + '?v=3&s=' + size;
	};
	
	// * ---------------- authors
	
	
	var authorWorks = {
	  'Sacha Grief': [2016, 2017, 2018],
	  'Michael Rambeau': [2016, 2017, 2018]
	};
	
	var authors = {
	  'Sacha Grief': {
	    name: 'Sacha Grief',
	    url: 'http://sachagreif.com',
	    avatar: getAvatarURL('358832'),
	    bio1: _react2.default.createElement(
	      'span',
	      null,
	      'Author of ',
	      _react2.default.createElement(
	        'a',
	        { href: 'http://discovermeteor.com/' },
	        'Discover Meteor'
	      ),
	      ' and creator of ',
	      _react2.default.createElement(
	        'a',
	        { href: 'http://vulcanjs.org/' },
	        'Vulcan'
	      ),
	      ', a React+GraphQL open-source framework.'
	    )
	  },
	  'Michael Rambeau': {
	    name: 'Michael Rambeau',
	    url: 'https://michaelrambeau.com',
	    avatar: getAvatarURL('5546996'),
	    bio1: _react2.default.createElement(
	      'span',
	      null,
	      'Creator of ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://bestofjs.org' },
	        'Best of JavaScript'
	      )
	    )
	  }
	
	  // * ---------------- translators
	
	
	};var translationWorks = {
	  2016: {
	    zh: ['Wang Shijun'],
	    ja: ['Nobuhiro Uchiyama', 'Yohei Ice', 'Shigeto Yatani']
	  },
	  2017: {
	    zh: ['Frank Xu', 'Wang Shijun'],
	    ja: ['Nobuhiro Uchiyama', 'Yohei Ice'],
	    fr: [],
	    es: ['Javier Valencia'],
	    id: ['Lobot Hijau']
	  },
	  2018: {
	    zh: ['Seognil LC'],
	    es: ['Javier Valencia']
	  },
	  2019: {
	    zh: ['Seognil LC'],
	    es: ['Javier Valencia']
	  }
	};
	
	var translators = {
	  'Nobuhiro Uchiyama': {
	    name: 'Nobuhiro Uchiyama',
	    url: 'https://github.com/azukiwasher',
	    avatar: getAvatarURL('442462'),
	    bio1: 'A generic programmer and linguist living in Osaka from Sapporo.',
	    bio2: '素朴なプログラマで言語マニア。札幌生まれの大阪在住。'
	  },
	  'Yohei Ice': {
	    name: 'Yohei Ice',
	    url: 'https://github.com/meltedice',
	    avatar: getAvatarURL('557001'),
	    bio1: 'Web application developer (Rails, React, ...)'
	  },
	  'Shigeto Yatani': {
	    name: 'Shigeto Yatani',
	    url: 'https://www.facebook.com/vanxx2',
	    avatar: getAvatarURL('572205'),
	    bio1: 'Node.js, 美味しいご飯, 酒, 料理, バスケ, ヨガ, エレクトロニカ, DJ, 園芸, DIY, プチアウトドア, 六甲山'
	  },
	
	  'Wang Shijun': {
	    name: '王仕军 (Wang Shijun)',
	    url: 'https://zhuanlan.zhihu.com/feweekly',
	    avatar: getAvatarURL('719985'),
	    bio1: _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        'a',
	        { href: 'https://zhuanlan.zhihu.com/feweekly' },
	        '\u524D\u7AEF\u5468\u520A'
	      ),
	      '\u521B\u529E\u8005'
	    )
	  },
	  'Frank Xu': {
	    name: 'Frank Xu',
	    url: 'https://github.com/frankyxhl',
	    avatar: getAvatarURL('309457'),
	    bio1: '全栈开发者、Lisp爱好者, 目前旅居日本',
	    bio2: 'Lisp lover, full stack developer living in Japan'
	  },
	  'Seognil LC': {
	    name: 'Seognil LC',
	    url: 'https://github.com/seognil',
	    avatar: getAvatarURL('5526096'),
	    bio1: '略懂点 JavaScript，做过点翻译工作',
	    bio2: _react2.default.createElement(
	      'span',
	      null,
	      '\u5199\u4E86 ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://fe.rualc.com/note/fe-development-cookbook.html' },
	        '\u524D\u7AEF\u5F00\u53D1\u5165\u95E8\u6307\u5357'
	      ),
	      ' \u548C ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://fe.rualc.com/note/js-foundation.html' },
	        'JavaScript \u5B66\u4E60\u6307\u5357'
	      )
	    )
	  },
	
	  'Javier Valencia': {
	    name: 'Javier Valencia',
	    url: 'http://www.jvalen.com',
	    avatar: getAvatarURL('4639830'),
	    bio1: _react2.default.createElement(
	      'span',
	      null,
	      'Creator of ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.pixelartcss.com/' },
	        'Pixel Art React'
	      )
	    )
	  },
	  'Lobot Hijau': {
	    name: 'Lobot Hijau',
	    url: 'http://lobothijau.com/',
	    avatar: getAvatarURL('34962330'),
	    bio1: '?'
	  }
	
	  // * ---------------- export
	
	
	};exports.default = {
	  authorWorks: authorWorks,
	  authors: authors,
	  translationWorks: translationWorks,
	  translators: translators
	};
	module.exports = exports['default'];

/***/ }),
/* 215 */,
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _en = __webpack_require__(428);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _zh = __webpack_require__(430);
	
	var _zh2 = _interopRequireDefault(_zh);
	
	var _ja = __webpack_require__(429);
	
	var _ja2 = _interopRequireDefault(_ja);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  en: _en2.default,
	  zh: _zh2.default,
	  ja: _ja2.default
	};
	module.exports = exports['default'];

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _en = __webpack_require__(431);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _zh = __webpack_require__(436);
	
	var _zh2 = _interopRequireDefault(_zh);
	
	var _ja = __webpack_require__(435);
	
	var _ja2 = _interopRequireDefault(_ja);
	
	var _fr = __webpack_require__(433);
	
	var _fr2 = _interopRequireDefault(_fr);
	
	var _es = __webpack_require__(432);
	
	var _es2 = _interopRequireDefault(_es);
	
	var _id = __webpack_require__(434);
	
	var _id2 = _interopRequireDefault(_id);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  en: _en2.default,
	  zh: _zh2.default,
	  ja: _ja2.default,
	  fr: _fr2.default,
	  es: _es2.default,
	  id: _id2.default
	};
	module.exports = exports['default'];

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _en = __webpack_require__(437);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _zh = __webpack_require__(442);
	
	var _zh2 = _interopRequireDefault(_zh);
	
	var _ja = __webpack_require__(441);
	
	var _ja2 = _interopRequireDefault(_ja);
	
	var _fr = __webpack_require__(439);
	
	var _fr2 = _interopRequireDefault(_fr);
	
	var _es = __webpack_require__(438);
	
	var _es2 = _interopRequireDefault(_es);
	
	var _id = __webpack_require__(440);
	
	var _id2 = _interopRequireDefault(_id);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  en: _en2.default,
	  zh: _zh2.default,
	  ja: _ja2.default,
	  fr: _fr2.default,
	  es: _es2.default,
	  id: _id2.default
	};
	module.exports = exports['default'];

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _en = __webpack_require__(443);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _zh = __webpack_require__(448);
	
	var _zh2 = _interopRequireDefault(_zh);
	
	var _ja = __webpack_require__(447);
	
	var _ja2 = _interopRequireDefault(_ja);
	
	var _fr = __webpack_require__(445);
	
	var _fr2 = _interopRequireDefault(_fr);
	
	var _es = __webpack_require__(444);
	
	var _es2 = _interopRequireDefault(_es);
	
	var _id = __webpack_require__(446);
	
	var _id2 = _interopRequireDefault(_id);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  en: _en2.default,
	  zh: _zh2.default,
	  ja: _ja2.default,
	  fr: _fr2.default,
	  es: _es2.default,
	  id: _id2.default
	};
	module.exports = exports['default'];

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _en = __webpack_require__(449);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _zh = __webpack_require__(454);
	
	var _zh2 = _interopRequireDefault(_zh);
	
	var _ja = __webpack_require__(453);
	
	var _ja2 = _interopRequireDefault(_ja);
	
	var _fr = __webpack_require__(451);
	
	var _fr2 = _interopRequireDefault(_fr);
	
	var _es = __webpack_require__(450);
	
	var _es2 = _interopRequireDefault(_es);
	
	var _id = __webpack_require__(452);
	
	var _id2 = _interopRequireDefault(_id);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Common messages (used every year)
	*/
	exports.default = {
	  en: _en2.default,
	  zh: _zh2.default,
	  ja: _ja2.default,
	  fr: _fr2.default,
	  es: _es2.default,
	  id: _id2.default
	};
	module.exports = exports['default'];

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _common = __webpack_require__(220);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _messages = __webpack_require__(216);
	
	var _messages2 = _interopRequireDefault(_messages);
	
	var _messages3 = __webpack_require__(217);
	
	var _messages4 = _interopRequireDefault(_messages3);
	
	var _messages5 = __webpack_require__(218);
	
	var _messages6 = _interopRequireDefault(_messages5);
	
	var _messages7 = __webpack_require__(219);
	
	var _messages8 = _interopRequireDefault(_messages7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  common: _common2.default,
	  year2016: _messages2.default,
	  year2017: _messages4.default,
	  year2018: _messages6.default,
	  year2019: _messages8.default
	};
	module.exports = exports['default'];

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactHelmet = __webpack_require__(530);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(232);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Top = __webpack_require__(249);
	
	var _Top2 = _interopRequireDefault(_Top);
	
	var _Footer = __webpack_require__(227);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _TranslatorSection = __webpack_require__(250);
	
	var _TranslatorSection2 = _interopRequireDefault(_TranslatorSection);
	
	var _Newsletter = __webpack_require__(233);
	
	var _Newsletter2 = _interopRequireDefault(_Newsletter);
	
	var _TOC = __webpack_require__(243);
	
	var _TOC2 = _interopRequireDefault(_TOC);
	
	var _Conclusion = __webpack_require__(226);
	
	var _Conclusion2 = _interopRequireDefault(_Conclusion);
	
	var _Category = __webpack_require__(225);
	
	var _Category2 = _interopRequireDefault(_Category);
	
	var _ProjectIconWall = __webpack_require__(234);
	
	var _ProjectIconWall2 = _interopRequireDefault(_ProjectIconWall);
	
	var _BgPicture = __webpack_require__(224);
	
	var _BgPicture2 = _interopRequireDefault(_BgPicture);
	
	__webpack_require__(251);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Used to generate the icon
	
	
	var Page = function (_React$Component) {
	  _inherits(Page, _React$Component);
	
	  function Page() {
	    _classCallCheck(this, Page);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Page.prototype.render = function render() {
	    var _props = this.props,
	        entities = _props.entities,
	        url = _props.url,
	        projects = _props.projects,
	        intl = _props.intl,
	        translations = _props.translations,
	        year = _props.year,
	        allYears = _props.allYears,
	        currentYear = _props.currentYear,
	        categories = _props.categories,
	        languages = _props.languages;
	
	    var locale = intl.locale;
	    var title = intl.formatMessage({ id: 'page.title' });
	    var description = intl.formatMessage({ id: 'page.description' });
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        {
	          title: title,
	          meta: [{ name: 'description', content: description }, { property: 'og:type', content: 'article' }, {
	            property: 'og:image',
	            content: '/img/' + year + '/' + intl.locale + '/rising-stars.png'
	          }],
	          htmlAttributes: { lang: intl.locale },
	          bodyAttributes: { class: 'year' + year }
	        },
	        _react2.default.createElement('link', { rel: 'shortcut icon', href: '/favicon.ico' }),
	        _react2.default.createElement('link', {
	          href: 'https://fonts.googleapis.com/css?family=Space+Mono:400,400i|Roboto+Slab:300,400,700',
	          rel: 'stylesheet'
	        })
	      ),
	      _react2.default.createElement(_Header2.default, {
	        language: intl.locale,
	        year: year,
	        availableLanguages: languages
	      }),
	      _react2.default.createElement(_Top2.default, {
	        entities: entities,
	        url: url,
	        intl: intl,
	        translations: translations,
	        categories: categories,
	        year: year,
	        allYears: allYears,
	        currentYear: currentYear
	      }),
	      false && _react2.default.createElement(_BgPicture2.default, { projects: projects.all }),
	      false && _react2.default.createElement(_ProjectIconWall2.default, {
	        projects: projects.all,
	        lang: intl.locale,
	        year: year
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'main' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-contents' },
	          _react2.default.createElement(_TOC2.default, {
	            projects: projects,
	            entities: entities,
	            url: url,
	            intl: intl,
	            translations: translations,
	            categories: categories
	          }),
	          categories.filter(function (item) {
	            return !item.disabled;
	          }).map(function (item, i) {
	            return _react2.default.createElement(_Category2.default, _extends({
	              key: item.key,
	              tag: item.key,
	              number: i + 1,
	              projects: projects,
	              entities: entities,
	              locale: locale,
	              translations: translations,
	              year: year,
	              currentYear: currentYear,
	              intl: intl,
	              hasComment: !item.availableComments || item.availableComments.includes(locale)
	            }, item));
	          }),
	          _react2.default.createElement(_Conclusion2.default, {
	            entities: entities,
	            url: url,
	            intl: intl,
	            translations: translations
	          })
	        )
	      ),
	      _react2.default.createElement(_Newsletter2.default, { intl: intl }),
	      _react2.default.createElement(_TranslatorSection2.default, {
	        language: intl.locale,
	        year: year,
	        availableLanguages: languages
	      }),
	      _react2.default.createElement(_Footer2.default, { language: intl.locale })
	    );
	  };
	
	  return Page;
	}(_react2.default.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(Page);
	module.exports = exports['default'];

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(456);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactIntl = __webpack_require__(11);
	
	var _en = __webpack_require__(532);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _zh = __webpack_require__(537);
	
	var _zh2 = _interopRequireDefault(_zh);
	
	var _ja = __webpack_require__(536);
	
	var _ja2 = _interopRequireDefault(_ja);
	
	var _fr = __webpack_require__(534);
	
	var _fr2 = _interopRequireDefault(_fr);
	
	var _es = __webpack_require__(533);
	
	var _es2 = _interopRequireDefault(_es);
	
	var _id = __webpack_require__(535);
	
	var _id2 = _interopRequireDefault(_id);
	
	var _Page = __webpack_require__(222);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _getMessages = __webpack_require__(253);
	
	var _getMessages2 = _interopRequireDefault(_getMessages);
	
	var _data = __webpack_require__(213);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _processProjectData2 = __webpack_require__(254);
	
	var _processProjectData3 = _interopRequireDefault(_processProjectData2);
	
	var _settings = __webpack_require__(424);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _allLanguages = __webpack_require__(423);
	
	var _allLanguages2 = _interopRequireDefault(_allLanguages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(78),
	    siteMetadata = _require.siteMetadata;
	
	(0, _reactIntl.addLocaleData)(_en2.default);
	(0, _reactIntl.addLocaleData)(_zh2.default);
	(0, _reactIntl.addLocaleData)(_ja2.default);
	(0, _reactIntl.addLocaleData)(_fr2.default);
	(0, _reactIntl.addLocaleData)(_es2.default);
	(0, _reactIntl.addLocaleData)(_id2.default);
	
	var getSettings = function getSettings(year) {
	  return _settings2.default.find(function (pageSettings) {
	    return pageSettings.year === year;
	  });
	};
	
	var PageContainer = function (_React$Component) {
	  _inherits(PageContainer, _React$Component);
	
	  function PageContainer() {
	    _classCallCheck(this, PageContainer);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PageContainer.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        pathContext = _props.pathContext;
	    var language = pathContext.language,
	        year = pathContext.year;
	
	    var messages = (0, _getMessages2.default)({ language: language, year: year });
	    var translations = getAllTranslations({ edges: data.allFile.edges })['year' + year];
	    var _appData$ = _data2.default['year' + year],
	        projects = _appData$.projects,
	        categories = _appData$.categories;
	
	    var allYears = Object.keys(_data2.default).map(function (key) {
	      return parseInt(key.slice('year'.length));
	    });
	    var settings = getSettings(year);
	    var availableLanguageCodes = settings.languages || ['en'];
	    var isAvailable = function isAvailable(lang) {
	      return availableLanguageCodes.includes(lang.code);
	    };
	    var languages = _allLanguages2.default.filter(isAvailable);
	
	    var _processProjectData = (0, _processProjectData3.default)(projects, categories),
	        entities = _processProjectData.entities,
	        projectsByTag = _processProjectData.projectsByTag;
	
	    var url = siteMetadata.url,
	        currentYear = siteMetadata.currentYear;
	
	    var fullUrl = siteMetadata.url + '/' + year + '/' + language;
	    return _react2.default.createElement(
	      _reactIntl.IntlProvider,
	      { locale: language, messages: messages },
	      _react2.default.createElement(_Page2.default, {
	        projects: projectsByTag,
	        entities: entities,
	        url: fullUrl,
	        translations: translations,
	        year: year,
	        allYears: allYears,
	        currentYear: currentYear,
	        categories: categories,
	        languages: languages
	      })
	    );
	  };
	
	  return PageContainer;
	}(_react2.default.Component);
	
	exports.default = PageContainer;
	
	
	function getAllTranslations(_ref) {
	  var edges = _ref.edges;
	
	  var translations = {};
	  var isTranslation = function isTranslation(edge) {
	    return edge.node.ext === '.md';
	  };
	  edges.filter(isTranslation).forEach(function (element) {
	    var node = element.node;
	    var fields = node.fields;
	    var key = fields.key,
	        language = fields.language,
	        markdown = fields.markdown,
	        year = fields.year;
	
	    var path = 'year' + year + '.' + language + '.' + key;
	    (0, _lodash2.default)(translations, path, markdown);
	  });
	  return translations;
	}
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProjectAvatar = __webpack_require__(56);
	
	var _ProjectAvatar2 = _interopRequireDefault(_ProjectAvatar);
	
	__webpack_require__(336);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var excluded = ['axios', 'create-react-app', 'animatecss', 'react-boilerplate', 'airbnb-style-guide', 'front-end-checklist', 'awesome', 'json-server', 'threejs', 'express', 'reveal', 'immutable', 'material-design-icons', '30-seconds-of-code'];
	
	var Wall = function Wall(_ref) {
	  var projects = _ref.projects;
	
	  var niceProjects = projects.filter(function (project) {
	    return !excluded.includes(project.slug);
	  });
	  // .slice(0, 50)
	  return _react2.default.createElement(
	    'div',
	    { id: 'bgpicture' },
	    _react2.default.createElement(
	      'div',
	      { className: 'bgpicture-grid' },
	      niceProjects.map(function (project, i) {
	        var rowNumber = Math.floor(i / 7);
	        var evenRow = rowNumber % 2 === 0;
	        if (evenRow) {
	          return [_react2.default.createElement(Cell, { project: project }), _react2.default.createElement(Cell, null)];
	        } else {
	          return [_react2.default.createElement(Cell, null), _react2.default.createElement(Cell, { project: project })];
	        }
	      })
	    )
	  );
	};
	
	var Cell = function Cell(_ref2) {
	  var project = _ref2.project;
	
	  if (!project) return _react2.default.createElement('div', { className: 'empty-cell' });
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_ProjectAvatar2.default, { project: project, size: 75 })
	  );
	};
	
	exports.default = Wall;
	module.exports = exports['default'];

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _TranslatedBlock = __webpack_require__(57);
	
	var _TranslatedBlock2 = _interopRequireDefault(_TranslatedBlock);
	
	var _ProjectTable = __webpack_require__(240);
	
	var _ProjectTable2 = _interopRequireDefault(_ProjectTable);
	
	var _Guest = __webpack_require__(228);
	
	var _Guest2 = _interopRequireDefault(_Guest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Category = function Category(_ref) {
	  var projects = _ref.projects,
	      entities = _ref.entities,
	      locale = _ref.locale,
	      translations = _ref.translations,
	      tag = _ref.tag,
	      number = _ref.number,
	      _ref$excluded = _ref.excluded,
	      excluded = _ref$excluded === undefined ? [] : _ref$excluded,
	      guest = _ref.guest,
	      year = _ref.year,
	      currentYear = _ref.currentYear,
	      intl = _ref.intl,
	      hasComment = _ref.hasComment,
	      props = _objectWithoutProperties(_ref, ['projects', 'entities', 'locale', 'translations', 'tag', 'number', 'excluded', 'guest', 'year', 'currentYear', 'intl', 'hasComment']);
	
	  var count = props.count;
	
	  if (!projects[tag]) throw new Error('No projects with the tag "' + tag + '"');
	  var graphProjects = projects[tag].slice(0, count);
	  var key = tag.replace(/-/gi, '');
	
	  return _react2.default.createElement(
	    'section',
	    { className: 'section' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' + (hasComment ? '' : ' small-container') },
	      _react2.default.createElement('a', { name: 'section-' + tag }),
	      _react2.default.createElement(
	        'h2',
	        { className: 'project-category-header' },
	        _react2.default.createElement(
	          'span',
	          { className: 'project-category-header-inner' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'categories.' + key })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: '' + (hasComment ? 'project-category-grid' : '') },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: '' + (hasComment ? 'column1' : '') },
	            _react2.default.createElement(_ProjectTable2.default, _extends({}, props, {
	              tagKey: key,
	              projects: graphProjects,
	              year: year,
	              showBlurb: tag !== 'misc',
	              currentYear: currentYear,
	              intl: intl
	            }))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          hasComment && _react2.default.createElement(
	            'div',
	            { className: 'column2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'tag-card-comments markdown-body' },
	              guest && _react2.default.createElement(_Guest2.default, {
	                guestId: guest,
	                translations: translations,
	                language: locale,
	                entities: entities
	              }),
	              _react2.default.createElement(_TranslatedBlock2.default, {
	                translations: translations,
	                language: locale,
	                path: 'categories.' + tag,
	                entities: entities
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Category;
	module.exports = exports['default'];

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _Social = __webpack_require__(124);
	
	var _Social2 = _interopRequireDefault(_Social);
	
	var _TranslatedBlock = __webpack_require__(57);
	
	var _TranslatedBlock2 = _interopRequireDefault(_TranslatedBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Markdown from './Markdown'
	var Conclusion = function Conclusion(_ref) {
	  var entities = _ref.entities,
	      url = _ref.url,
	      intl = _ref.intl,
	      translations = _ref.translations;
	  return _react2.default.createElement(
	    'div',
	    { className: 'container small-container', id: 'conclusion' },
	    _react2.default.createElement(
	      'div',
	      { className: 'small-card conclusion' },
	      _react2.default.createElement(
	        'div',
	        { className: 'small-card-header' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'tag-card-header-text' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'conclusion' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'markdown-body' },
	        false && _react2.default.createElement(Markdown, { source: md[intl.locale].body, entities: entities }),
	        _react2.default.createElement(_TranslatedBlock2.default, {
	          translations: translations,
	          language: intl.locale,
	          path: 'conclusion',
	          entities: entities
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'conclusion-share-buttons' },
	          _react2.default.createElement(_Social2.default, { url: url, text: intl.formatMessage({ id: 'social.text' }) })
	        )
	      )
	    )
	  );
	};
	
	exports.default = Conclusion;
	module.exports = exports['default'];

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(_ref) {
	  var language = _ref.language;
	  return _react2.default.createElement(
	    "div",
	    { id: "footer" },
	    _react2.default.createElement(
	      "div",
	      { className: "container small-container" },
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          "a",
	          { href: "https://bestofjs.org" },
	          "Best of JavaScript"
	        ),
	        " is a project created by",
	        ' ',
	        _react2.default.createElement(
	          "a",
	          { href: "https://michaelrambeau.com/" },
	          "Michael Rambeau"
	        ),
	        ", from Osaka, Japan."
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _TranslatedBlock = __webpack_require__(57);
	
	var _TranslatedBlock2 = _interopRequireDefault(_TranslatedBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Guest = function Guest(_ref) {
	  var guestId = _ref.guestId,
	      translations = _ref.translations,
	      language = _ref.language,
	      entities = _ref.entities;
	  return _react2.default.createElement(
	    'div',
	    { className: 'guest' },
	    _react2.default.createElement(
	      'div',
	      { className: 'guest-blurb' },
	      _react2.default.createElement(_TranslatedBlock2.default, {
	        translations: translations,
	        language: language,
	        path: 'guests.' + guestId,
	        entities: entities
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'guest-portrait' },
	      _react2.default.createElement('img', { src: '/img/guests/' + guestId + '.jpg' })
	    )
	  );
	};
	
	exports.default = Guest;
	module.exports = exports['default'];

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(49);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _globe = __webpack_require__(641);
	
	var _globe2 = _interopRequireDefault(_globe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Dropdown language menu used on small screens
	*/
	
	var DropDownMenu = function DropDownMenu(_ref) {
	  var year = _ref.year,
	      languages = _ref.languages,
	      currentLanguage = _ref.currentLanguage,
	      onChange = _ref.onChange;
	  return _react2.default.createElement(
	    'div',
	    { className: 'language-menu-mobile' },
	    _react2.default.createElement(
	      'div',
	      { className: 'control has-icons-left' },
	      _react2.default.createElement(
	        'div',
	        { className: 'select' },
	        _react2.default.createElement(
	          'select',
	          {
	            className: 'language-dropdown',
	            onChange: onChange,
	            style: { width: 64 }
	          },
	          _react2.default.createElement('option', null),
	          languages.map(function (item) {
	            return _react2.default.createElement(LanguageLink, {
	              item: item,
	              key: item.code,
	              active: currentLanguage === item.code,
	              year: year
	            });
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'icon is-left' },
	        _react2.default.createElement('img', { src: _globe2.default, width: '24', height: '24' })
	      )
	    )
	  );
	};
	
	var LanguageLink = function LanguageLink(_ref2) {
	  var item = _ref2.item,
	      active = _ref2.active,
	      year = _ref2.year;
	
	  if (active) return _react2.default.createElement(
	    'option',
	    { disabled: true },
	    item.text
	  );
	  return _react2.default.createElement(
	    'option',
	    { value: '/' + year + '/' + item.code },
	    item.text
	  );
	};
	
	exports.default = DropDownMenu;
	module.exports = exports['default'];

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(49);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FullSizeMenu = function FullSizeMenu(_ref) {
	  var year = _ref.year,
	      languages = _ref.languages,
	      currentLanguage = _ref.currentLanguage;
	  return _react2.default.createElement(
	    'div',
	    { className: 'language-menu' },
	    languages.map(function (item) {
	      return _react2.default.createElement(LanguageLink, {
	        item: item,
	        key: item.code,
	        active: currentLanguage === item.code,
	        year: year
	      });
	    })
	  );
	};
	
	var LanguageLink = function LanguageLink(_ref2) {
	  var item = _ref2.item,
	      active = _ref2.active,
	      year = _ref2.year;
	
	  if (active) return _react2.default.createElement(
	    'span',
	    { className: 'language-menu-item is-active' },
	    item.text
	  );
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: '/' + year + '/' + item.code, className: 'language-menu-item' },
	    item.text
	  );
	};
	
	exports.default = FullSizeMenu;
	module.exports = exports['default'];

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(49);
	
	var _octocat = __webpack_require__(642);
	
	var _octocat2 = _interopRequireDefault(_octocat);
	
	var _FullSizeMenu = __webpack_require__(230);
	
	var _FullSizeMenu2 = _interopRequireDefault(_FullSizeMenu);
	
	var _DropDownMenu = __webpack_require__(229);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var language = _ref.language,
	      year = _ref.year,
	      availableLanguages = _ref.availableLanguages;
	
	  var onChange = function onChange(e) {
	    var path = e.target.value;
	    (0, _gatsbyLink.navigateTo)(path);
	  };
	  return _react2.default.createElement(
	    'div',
	    { id: 'header' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'header-layout' },
	        _react2.default.createElement(
	          'a',
	          { id: 'logo', href: 'https://bestofjs.org' },
	          _react2.default.createElement('img', { src: '/bestofjs.svg', width: '160', alt: 'bestofjs.org logo' })
	        ),
	        _react2.default.createElement(_FullSizeMenu2.default, {
	          currentLanguage: language,
	          languages: availableLanguages,
	          year: year
	        }),
	        availableLanguages.length > 3 && _react2.default.createElement(_DropDownMenu2.default, {
	          currentLanguage: language,
	          languages: availableLanguages,
	          year: year,
	          onChange: onChange
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'a',
	      {
	        href: 'https://github.com/bestofjs/javascript-risingstars',
	        id: 'github-corner'
	      },
	      _react2.default.createElement('img', { src: _octocat2.default, width: 60, height: 60 })
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Header = __webpack_require__(231);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Header2.default;
	module.exports = exports['default'];

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Newsletter = function Newsletter(_ref) {
	  var _React$createElement;
	
	  var intl = _ref.intl;
	  return _react2.default.createElement(
	    'div',
	    { className: 'newsletter container container-section small-container markdown-body' },
	    _react2.default.createElement(
	      'h3',
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'common.newsletter.title',
	        defaultMessage: 'Get the latest JS rankings in your inbox every week'
	      })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'common.newsletter.text',
	        defaultMessage: 'Sign up for {link}\'s newsletter, and...',
	        values: {
	          link: _react2.default.createElement(
	            'a',
	            { href: 'https://bestofjs.org/' },
	            'Best of JavaScript'
	          )
	        }
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { id: 'mc_embed_signup' },
	      _react2.default.createElement(
	        'form',
	        {
	          action: 'https://api.elasticemail.com/contact/add?version=2',
	          method: 'post',
	          id: 'mc-embedded-subscribe-form',
	          name: 'mc-embedded-subscribe-form',
	          className: 'validate',
	          target: '_blank',
	          noValidate: true
	        },
	        _react2.default.createElement('input', {
	          type: 'email',
	          placeholder: intl.formatMessage({
	            id: 'common.newsletter.placeholder',
	            defaultMessage: 'Your Email'
	          }),
	          name: 'EMAIL',
	          className: 'required email',
	          id: 'mce-EMAIL'
	        }),
	        _react2.default.createElement(
	          'button',
	          (_React$createElement = {
	            className: 'button',
	            type: 'submit',
	            value: 'Sign Up',
	            name: 'subscribe',
	            id: 'mc-embedded-subscribe'
	          }, _React$createElement['className'] = 'button', _React$createElement),
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'common.newsletter.button',
	            defaultMessage: 'Sign Up'
	          })
	        ),
	        _react2.default.createElement('input', {
	          name: 'publiclistid',
	          id: 'CwyOqTgB',
	          value: '72c3249d-ed56-484d-b586-71c80b84d469',
	          type: 'hidden'
	        }),
	        _react2.default.createElement('input', {
	          name: 'publicaccountid',
	          value: '0941e3f0-7b53-413c-a17f-06bff65f0a13',
	          type: 'hidden'
	        }),
	        _react2.default.createElement('input', {
	          name: 'publicformid',
	          value: 'e362aac5-777d-4d8b-a537-c807041f37cb',
	          type: 'hidden'
	        }),
	        _react2.default.createElement('input', {
	          name: 'returnUrl',
	          value: 'https://weekly.bestofjs.org/check-email/',
	          type: 'hidden'
	        }),
	        _react2.default.createElement('input', {
	          name: 'activationReturnUrl',
	          value: 'https://weekly.bestofjs.org/email-confirmed/',
	          type: 'hidden'
	        }),
	        _react2.default.createElement('input', { name: 'alreadyactiveurl', value: '', type: 'hidden' }),
	        _react2.default.createElement('input', {
	          name: 'activationTemplate',
	          value: 'subscriber-activation',
	          type: 'hidden'
	        }),
	        _react2.default.createElement('input', { name: 'source', value: 'WebForm', type: 'hidden' }),
	        _react2.default.createElement('input', { id: 'ewf_captcha', name: 'captcha', value: 'false', type: 'hidden' }),
	        _react2.default.createElement('input', { name: 'notifyEmail', value: '', type: 'hidden' })
	      )
	    )
	  );
	};
	
	exports.default = Newsletter;
	module.exports = exports['default'];

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProjectAvatar = __webpack_require__(56);
	
	var _ProjectAvatar2 = _interopRequireDefault(_ProjectAvatar);
	
	__webpack_require__(337);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var excluded = ['axios', 'animatecss', 'react-boilerplate', 'angularjs', 'airbnb-style-guide', 'awesome', 'create-react-app', 'standard', 'skeleton', 'webtorrent', 'handlebarsjs'];
	
	var Wall = function Wall(_ref) {
	  var projects = _ref.projects,
	      _ref$lang = _ref.lang,
	      lang = _ref$lang === undefined ? 'ja' : _ref$lang,
	      year = _ref.year;
	
	  var titles = {
	    en: year + ' JavaScript Rising Stars',
	    ja: _react2.default.createElement(
	      'span',
	      null,
	      'JavaScript',
	      _react2.default.createElement('br', null),
	      ' \u30D9\u30B9\u30C8\u30FB\u30AA\u30D6\u30FB\u30B6\u30FB\u30A4\u30E4\u30FC',
	      year
	    ),
	    fr: 'Le Meilleur du JavaScript en ' + year,
	    zh: _react2.default.createElement(
	      'span',
	      null,
	      year,
	      '\u5E74',
	      _react2.default.createElement('br', null),
	      'JavaScript',
	      _react2.default.createElement('br', null),
	      '\u660E\u661F\u9879\u76EE'
	    ),
	    es: _react2.default.createElement(
	      'span',
	      null,
	      'Lo mejor',
	      _react2.default.createElement('br', null),
	      'de JavaScript',
	      _react2.default.createElement('br', null),
	      'en ',
	      year
	    )
	  };
	  var title = titles[lang] || titles['en'];
	  var niceProjects = projects.filter(function (project) {
	    return !excluded.includes(project.slug);
	  }).slice(0, 25);
	  return _react2.default.createElement(
	    'div',
	    { id: 'wall' },
	    _react2.default.createElement(
	      'div',
	      { className: 'text' },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'icon-wall-grid' },
	      niceProjects.map(function (project) {
	        return _react2.default.createElement(
	          'div',
	          { key: project.slug },
	          _react2.default.createElement(_ProjectAvatar2.default, { project: project, size: 75 })
	        );
	      })
	    )
	  );
	};
	
	exports.default = Wall;
	module.exports = exports['default'];

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Component used to display repository `description`,
	// removing emojis except if `showEmojis` option is set to true
	// See node.js repository: `Node.js JavaScript runtime :sparkles::turtle::rocket::sparkles:`
	
	var emoji = function emoji() {
	  var size = 20;
	  return '<img align="absmiddle" width="' + size + '" height=' + size + ' src="https://assets-cdn.github.com/images/icons/emoji/$2.png">';
	};
	
	var Description = function Description(_ref) {
	  var text = _ref.text,
	      showEmojis = _ref.showEmojis;
	
	  var replacedBy = showEmojis ? emoji() : '';
	  var result = text.replace(/(:([a-z_\d]+):)/g, replacedBy).trim();
	  if (showEmojis) return _react2.default.createElement(HtmlDescription, { html: result });
	  return _react2.default.createElement(
	    'span',
	    null,
	    result
	  );
	};
	
	var HtmlDescription = function HtmlDescription(_ref2) {
	  var html = _ref2.html;
	  return _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: html } });
	};
	
	exports.default = Description;
	module.exports = exports['default'];

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _formatDelta = __webpack_require__(79);
	
	var _formatDelta2 = _interopRequireDefault(_formatDelta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectBlurb = function ProjectBlurb(_ref) {
	  var project = _ref.project,
	      index = _ref.index,
	      tagKey = _ref.tagKey,
	      year = _ref.year,
	      intl = _ref.intl;
	  var slug = project.slug,
	      twitter = project.twitter,
	      delta = project.delta,
	      name = project.name;
	
	  var category = intl.formatMessage({ id: 'categories-share.' + tagKey });
	  var values = {
	    year: year,
	    name: '@' + (twitter || slug),
	    ranking: index,
	    delta: (0, _formatDelta2.default)(project.delta, 1),
	    category: category
	  };
	  var tweetText = intl.formatMessage({
	    id: 'common.view_project.twitter.text'
	  }, values).concat(' #RisingStarsJS https://risingstars.js.org');
	  var tweetURL = 'https://twitter.com/home?status=' + encodeURIComponent(tweetText);
	  // const addSuffix = n =>
	  //   n === 1 ? '#1' : n === 2 ? 'second' : n === 3 ? 'third' : `${n}th`
	  return _react2.default.createElement(
	    'div',
	    { className: 'project-blurb' },
	    _react2.default.createElement(_reactIntl.FormattedMessage, {
	      id: 'common.view_project.twitter.text',
	      defaultMessage: 'In {year}, {name} was the project #{ranking}...',
	      values: _extends({}, values, { name: name })
	    }),
	    ' ',
	    '\u2013',
	    ' ',
	    _react2.default.createElement(
	      'a',
	      { href: tweetURL, target: '_blank' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'common.view_project.twitter.action',
	        defaultMessage: 'Tweet'
	      })
	    )
	  );
	};
	
	exports.default = ProjectBlurb;
	module.exports = exports['default'];

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formatDelta = __webpack_require__(79);
	
	var _formatDelta2 = _interopRequireDefault(_formatDelta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectChart = function ProjectChart(_ref) {
	  var project = _ref.project,
	      intl = _ref.intl;
	
	  if (!project.monthly || project.monthly.length === 0) return _react2.default.createElement(
	    'div',
	    { style: { fontStyle: 'italic', marginBottom: '.5rem' } },
	    'No data available'
	  );
	  var months = intl.formatMessage({
	    id: 'common.view_project.months',
	    defaultMessage: 'Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec'
	  }).split(' ');
	  var monthlyDeltas = (project.monthly || []).concat([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]) // fill with 0 for missing data
	  .slice(0, 12).reverse(); // sort by date ascending (from January to December)
	  var monthlyDeltaMax = monthlyDeltas.reduce(function (a, b) {
	    return Math.max(a, b);
	  }, 0);
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'project-chart' },
	      _react2.default.createElement(
	        'div',
	        { className: 'project-chart-columns' },
	        monthlyDeltas.map(function (d, i) {
	          return _react2.default.createElement(
	            'div',
	            { key: i, className: 'project-chart-column' },
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'project-chart-bar',
	                style: {
	                  height: Math.round(d * 100 / monthlyDeltaMax) + '%'
	                }
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'project-chart-stars' },
	                d > 0 && _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _formatDelta2.default)(d, 1)
	                )
	              )
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'project-chart-months' },
	        months.map(function (m, i) {
	          return _react2.default.createElement(
	            'div',
	            { key: i, className: 'project-chart-month' },
	            m
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = ProjectChart;
	module.exports = exports['default'];

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withState = __webpack_require__(580);
	
	var _withState2 = _interopRequireDefault(_withState);
	
	var _ProjectTableRow = __webpack_require__(241);
	
	var _ProjectTableRow2 = _interopRequireDefault(_ProjectTableRow);
	
	var _ProjectDetails = __webpack_require__(239);
	
	var _ProjectDetails2 = _interopRequireDefault(_ProjectDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// only first project of "all" category should start expanded
	var withToggle = (0, _withState2.default)('showDetails', 'toggleDetails', function (props) {
	  return props.tagKey === 'all' && props.index === 1;
	});
	
	var ProjectContainer = function ProjectContainer(_ref) {
	  var maxDelta = _ref.maxDelta,
	      showDetails = _ref.showDetails,
	      props = _objectWithoutProperties(_ref, ['maxDelta', 'showDetails']);
	
	  var project = props.project,
	      index = props.index;
	
	  var widthPercent = project.delta * 100 / maxDelta; // use relative scale
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_ProjectTableRow2.default, _extends({ widthPercent: widthPercent }, props)),
	    _react2.default.createElement(_ProjectDetails2.default, _extends({
	      key: 'details-' + index,
	      isOpen: showDetails
	    }, props))
	  );
	};
	
	exports.default = withToggle(ProjectContainer);
	module.exports = exports['default'];

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tinytime = __webpack_require__(631);
	
	var _tinytime2 = _interopRequireDefault(_tinytime);
	
	var _ProjectChart = __webpack_require__(237);
	
	var _ProjectChart2 = _interopRequireDefault(_ProjectChart);
	
	var _ProjectBlurb = __webpack_require__(236);
	
	var _ProjectBlurb2 = _interopRequireDefault(_ProjectBlurb);
	
	var _reactIntl = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var templateMonthYear = (0, _tinytime2.default)('{Mo}/{YYYY}');
	
	
	var ProjectDetails = function ProjectDetails(_ref) {
	  var project = _ref.project,
	      index = _ref.index,
	      tagKey = _ref.tagKey,
	      isOpen = _ref.isOpen,
	      year = _ref.year,
	      currentYear = _ref.currentYear,
	      intl = _ref.intl,
	      _ref$showBlurb = _ref.showBlurb,
	      showBlurb = _ref$showBlurb === undefined ? true : _ref$showBlurb;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'project-details ' + (isOpen ? 'is-open' : 'is-closed') },
	    _react2.default.createElement(
	      'div',
	      { className: 'project-details-inner' },
	      year === currentYear && showBlurb && _react2.default.createElement(_ProjectBlurb2.default, {
	        project: project,
	        index: index,
	        tagKey: tagKey,
	        year: year,
	        intl: intl
	      }),
	      _react2.default.createElement(_ProjectChart2.default, { project: project, intl: intl }),
	      _react2.default.createElement(
	        'ul',
	        { className: 'project-links' },
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'project-created-at' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'common.view_project.created',
	              defaultMessage: 'Created'
	            }),
	            ' ',
	            templateMonthYear.render(new Date(project.created_at))
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: project.repository },
	            'GitHub'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'https://bestofjs.org/projects/' + project.slug },
	            'BestOfJS'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: project.url },
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'common.view_project.homepage',
	              defaultMessage: 'Homepage'
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ProjectDetails;
	module.exports = exports['default'];

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(576);
	
	var _ProjectContainer = __webpack_require__(238);
	
	var _ProjectContainer2 = _interopRequireDefault(_ProjectContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var withToggle = (0, _recompose.withState)('showFullList', 'toggleFullList', false);
	
	var ProjectTable = function ProjectTable(_ref) {
	  var projects = _ref.projects,
	      showFullList = _ref.showFullList,
	      toggleFullList = _ref.toggleFullList,
	      _ref$limit = _ref.limit,
	      limit = _ref$limit === undefined ? 5 : _ref$limit,
	      count = _ref.count,
	      props = _objectWithoutProperties(_ref, ['projects', 'showFullList', 'toggleFullList', 'limit', 'count']);
	
	  var maxDelta = projects.map(function (p) {
	    return p.delta;
	  }).reduce(function (a, b) {
	    return Math.max(a, b);
	  }, []);
	  var visibleProjects = showFullList ? projects : projects.slice(0, limit);
	  var hasMoreItems = count > limit;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'project-table' },
	      visibleProjects.map(function (project, i) {
	        return _react2.default.createElement(_ProjectContainer2.default, _extends({
	          key: project.slug,
	          maxDelta: maxDelta,
	          project: project,
	          index: i + 1
	        }, props));
	      })
	    ),
	    !showFullList && hasMoreItems && _react2.default.createElement(
	      'button',
	      {
	        className: 'button',
	        type: 'button',
	        onClick: function onClick() {
	          return toggleFullList(true);
	        },
	        style: { display: 'block', width: '100%', marginTop: '1rem' }
	      },
	      'SHOW MORE'
	    )
	  );
	};
	
	exports.default = withToggle(ProjectTable);
	module.exports = exports['default'];

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Description = __webpack_require__(235);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	var _ProjectAvatar = __webpack_require__(56);
	
	var _ProjectAvatar2 = _interopRequireDefault(_ProjectAvatar);
	
	var _Stars = __webpack_require__(242);
	
	var _Stars2 = _interopRequireDefault(_Stars);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectTableRow = function ProjectTableRow(_ref) {
	  var project = _ref.project,
	      _ref$showDescription = _ref.showDescription,
	      showDescription = _ref$showDescription === undefined ? true : _ref$showDescription,
	      index = _ref.index,
	      showDetails = _ref.showDetails,
	      toggleDetails = _ref.toggleDetails,
	      widthPercent = _ref.widthPercent;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: 'project-table-row ' + (showDetails ? 'is-open' : 'is-closed'),
	      id: project.slug,
	      onClick: function onClick() {
	        toggleDetails(!showDetails);
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'ranking' },
	      _react2.default.createElement(
	        'span',
	        null,
	        index
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'inner' },
	      _react2.default.createElement(
	        'div',
	        { className: 'icon' },
	        _react2.default.createElement(_ProjectAvatar2.default, { project: project, size: 50 })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'main-column' },
	        _react2.default.createElement('div', {
	          className: 'project-table-bar',
	          style: { width: widthPercent + '%' }
	        }),
	        _react2.default.createElement(
	          'h4',
	          { className: 'project-name' },
	          project.name
	        ),
	        showDescription && _react2.default.createElement(
	          'div',
	          { className: 'description' },
	          _react2.default.createElement(_Description2.default, { text: project.description, showEmojis: false })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'stars' },
	        _react2.default.createElement(_Stars2.default, { value: project.delta, decimals: 1 })
	      )
	    )
	  );
	};
	
	exports.default = ProjectTableRow;
	module.exports = exports['default'];

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _star = __webpack_require__(643);
	
	var _star2 = _interopRequireDefault(_star);
	
	var _formatDelta = __webpack_require__(79);
	
	var _formatDelta2 = _interopRequireDefault(_formatDelta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Stars = function Stars(_ref) {
	  var value = _ref.value,
	      decimals = _ref.decimals;
	
	  return _react2.default.createElement(
	    'span',
	    { className: 'stars' },
	    '+',
	    (0, _formatDelta2.default)(value, decimals),
	    _react2.default.createElement('img', { className: 'star', src: _star2.default, alt: '\u2606', width: '14', height: '16' })
	  );
	};
	exports.default = Stars;
	module.exports = exports['default'];

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _ProjectAvatar = __webpack_require__(56);
	
	var _ProjectAvatar2 = _interopRequireDefault(_ProjectAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getMinCount = function getMinCount(count, index) {
	  return index === 0 ? Math.min(count, 10) : Math.min(count, 5);
	};
	
	var TOC = function TOC(_ref) {
	  var categories = _ref.categories,
	      projects = _ref.projects;
	  return _react2.default.createElement(
	    'div',
	    { className: 'toc nav container container-section small-container' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'toc-header' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'introduction.table_of_contents' })
	    ),
	    _react2.default.createElement(
	      'ol',
	      null,
	      categories.filter(function (item) {
	        return !item.disabled;
	      }).map(function (item, i) {
	        var key = item.key.replace(/-/gi, '');
	        return _react2.default.createElement(
	          'li',
	          { key: key },
	          _react2.default.createElement(
	            'a',
	            { className: 'toc-link', href: '#section-' + item.key },
	            _react2.default.createElement(
	              'span',
	              { className: 'toc-link-label' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'categories.' + key })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'toc-projects' },
	              projects[item.key].slice(0, getMinCount(item.count, i)).map(function (project) {
	                return _react2.default.createElement(_ProjectAvatar2.default, {
	                  key: project.slug,
	                  project: project,
	                  size: 30,
	                  link: false
	                });
	              })
	            )
	          )
	        );
	      }),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { className: 'toc-link toc-link-conclusion', href: '#conclusion' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'conclusion' })
	        )
	      )
	    )
	  );
	};
	
	exports.default = TOC;
	module.exports = exports['default'];

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Banner = function Banner() {
	  return _react2.default.createElement(
	    'div',
	    { id: 'picture-block' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'h1',
	        { style: { textShadow: '0 3px 3px rgba(143,50,0,.99)' } },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'header.title' })
	      )
	    )
	  );
	};
	
	exports.default = Banner;
	module.exports = exports['default'];

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TopWithBanner = __webpack_require__(246);
	
	var _TopWithBanner2 = _interopRequireDefault(_TopWithBanner);
	
	var _TopWithPicture = __webpack_require__(247);
	
	var _TopWithPicture2 = _interopRequireDefault(_TopWithPicture);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Top = function Top(props) {
	  var year = props.year;
	
	  var Component = false ? _TopWithPicture2.default : _TopWithBanner2.default;
	  return _react2.default.createElement(Component, props);
	};
	
	exports.default = Top;
	module.exports = exports['default'];

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Banner = __webpack_require__(244);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _Introduction = __webpack_require__(125);
	
	var _Introduction2 = _interopRequireDefault(_Introduction);
	
	var _YearNavigator = __webpack_require__(248);
	
	var _YearNavigator2 = _interopRequireDefault(_YearNavigator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// const Container = styled.div`
	//   margin: 2rem 0;
	//   padding: 2rem;
	//   border: 1px solid #788080;
	// `
	
	/*
	Layout used in 2016 and 2018, showing a banner made of projects logos
	*/
	var TopWithBanner = function TopWithBanner(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_YearNavigator2.default, props),
	    _react2.default.createElement(_Banner2.default, null),
	    _react2.default.createElement(
	      'div',
	      { className: 'container small-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'top-with-banner-introduction' },
	        _react2.default.createElement(_Introduction2.default, props)
	      )
	    )
	  );
	};
	// import styled from 'styled-components'
	
	exports.default = TopWithBanner;
	module.exports = exports['default'];

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _Introduction = __webpack_require__(125);
	
	var _Introduction2 = _interopRequireDefault(_Introduction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	2 columns layout used in 2017, showing a picture on the left (the Death Star!)
	*/
	var TopWithPicture = function TopWithPicture(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'introduction-container container container-section' },
	    _react2.default.createElement(
	      'div',
	      { className: 'main-image' },
	      _react2.default.createElement('img', { src: '/img/risingstars.png' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'introduction small-card markdown-body card-introduction' },
	      _react2.default.createElement(
	        'div',
	        { className: 'introduction-inner' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'header.title' })
	        ),
	        _react2.default.createElement(_Introduction2.default, props)
	      )
	    )
	  );
	};
	
	exports.default = TopWithPicture;
	module.exports = exports['default'];

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(49);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var YearNavigator = function YearNavigator(_ref) {
	  var allYears = _ref.allYears,
	      activeYear = _ref.year;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'year-menu-container' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container small-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'year-menu' },
	        allYears.map(function (year) {
	          return _react2.default.createElement(YearNavigator.Item, {
	            key: year,
	            year: year,
	            isActive: activeYear === year
	          });
	        })
	      )
	    )
	  );
	};
	
	YearNavigator.Item = function (_ref2) {
	  var year = _ref2.year,
	      isActive = _ref2.isActive;
	
	  var url = '/' + year;
	  return isActive ? _react2.default.createElement(
	    'div',
	    { className: 'active' },
	    year
	  ) : _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: url },
	    year
	  );
	};
	
	exports.default = YearNavigator;
	module.exports = exports['default'];

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Top = __webpack_require__(245);
	
	var _Top2 = _interopRequireDefault(_Top);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Top2.default;
	module.exports = exports['default'];

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(49);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _teamMembers = __webpack_require__(214);
	
	var _teamMembers2 = _interopRequireDefault(_teamMembers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Section = function Section(_ref) {
	  var language = _ref.language,
	      year = _ref.year,
	      availableLanguages = _ref.availableLanguages;
	
	  return _react2.default.createElement(
	    'section',
	    { className: 'TranslatorSection' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container small-container' },
	      _react2.default.createElement(TeamMemberList, { language: language, year: year }),
	      availableLanguages.length > 1 && _react2.default.createElement(OtherLanguages, {
	        year: year,
	        language: language,
	        availableLanguages: availableLanguages
	      })
	    )
	  );
	};
	
	var OtherLanguages = function OtherLanguages(_ref2) {
	  var year = _ref2.year,
	      language = _ref2.language,
	      availableLanguages = _ref2.availableLanguages;
	  return _react2.default.createElement(
	    'div',
	    { style: { marginTop: '2rem' } },
	    _react2.default.createElement(
	      'p',
	      { className: 'member-list-header' },
	      'Available Translations'
	    ),
	    availableLanguages.filter(function (lang) {
	      return lang.code !== language;
	    }).map(function (lang) {
	      return _react2.default.createElement(
	        'p',
	        { key: lang.code },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' + year + '/' + lang.code },
	          lang.text
	        )
	      );
	    })
	  );
	};
	
	var TeamMemberList = function TeamMemberList(_ref3) {
	  var language = _ref3.language,
	      year = _ref3.year;
	
	  var transWorks = _teamMembers2.default.translationWorks[year];
	  var translators = (transWorks && transWorks[language] || []).map(function (name) {
	    return _teamMembers2.default.translators[name];
	  });
	
	  var authors = Object.keys(_teamMembers2.default.authorWorks).map(function (name) {
	    return _teamMembers2.default.authors[name];
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    translators.length > 0 && _react2.default.createElement(TranslatorBlock, { translators: translators, language: language }),
	    _react2.default.createElement(AuthorBlock, { authors: authors })
	  );
	};
	
	var AuthorBlock = function AuthorBlock(_ref4) {
	  var authors = _ref4.authors;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      { className: 'member-list-header' },
	      'Authors'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'translator-list' },
	      authors.map(function (author, i) {
	        var _React$createElement;
	
	        return _react2.default.createElement(TeamMember, (_React$createElement = { key: i, member: author }, _React$createElement['key'] = author.name, _React$createElement));
	      })
	    )
	  );
	};
	
	var translations = {
	  ja: 'Japanese version',
	  zh: 'Chinese (simplified) version',
	  es: 'Spanish version',
	  id: 'Bahasa Indonesia'
	};
	
	var TranslatorBlock = function TranslatorBlock(_ref5) {
	  var translators = _ref5.translators,
	      language = _ref5.language;
	  return _react2.default.createElement(
	    'div',
	    { style: { marginBottom: '2rem' } },
	    _react2.default.createElement(
	      'p',
	      { className: 'member-list-header' },
	      translations[language]
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'translator-list' },
	      translators.map(function (translator) {
	        return _react2.default.createElement(TeamMember, { member: translator, key: translator.name });
	      })
	    )
	  );
	};
	
	var TeamMember = function TeamMember(_ref6) {
	  var member = _ref6.member;
	  return _react2.default.createElement(
	    'div',
	    { className: 'translator-list-item' },
	    _react2.default.createElement(
	      'a',
	      { href: member.url },
	      _react2.default.createElement('img', { className: 'avatar', src: member.avatar, width: '75', height: '75' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'translator-item-body' },
	      _react2.default.createElement(
	        'a',
	        { href: member.url, className: 'translator-name' },
	        member.name
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'translator-bio' },
	        member.bio1,
	        member.bio2 && _react2.default.createElement(
	          'div',
	          null,
	          member.bio2
	        )
	      )
	    )
	  );
	};
	
	exports.default = Section;
	module.exports = exports['default'];

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(460);

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMarkdown = __webpack_require__(542);
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function processMarkdown(entities, md) {
	  var processed = md.replace(/{(.+?)}/gi, function (match, slug) {
	    var project = entities[slug];
	    if (!project) {
	      console.log(slug);
	      return 'NO slug ' + slug;
	    }
	    // throw new Error(`Unable to find project whose slug is ${slug}`)
	    var url = project.url || project.repository;
	    return '[' + project.name + '](' + url + ')';
	  });
	  return processed;
	}
	
	var MD = function MD(_ref) {
	  var source = _ref.source,
	      entities = _ref.entities;
	  return _react2.default.createElement(_reactMarkdown2.default, { source: processMarkdown(entities, source) });
	};
	
	exports.default = MD;
	module.exports = exports['default'];

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = getMessages;
	
	var _flat = __webpack_require__(350);
	
	var _flat2 = _interopRequireDefault(_flat);
	
	var _messages = __webpack_require__(221);
	
	var _messages2 = _interopRequireDefault(_messages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Gather all messages for a given year and a given language
	function getMessages(_ref) {
	  var language = _ref.language,
	      year = _ref.year;
	
	  var yearMessages = _messages2.default['year' + year][language];
	  var commonMessages = _messages2.default.common[language];
	  var messages = _extends({}, yearMessages, { common: commonMessages });
	  if (Object.keys(messages).length === 0) return {};
	  return (0, _flat2.default)(messages);
	}
	module.exports = exports['default'];

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var slugify = __webpack_require__(255);
	
	var processProject = function processProject(item) {
	  return _extends({}, item, {
	    repository: 'https://github.com/' + item.full_name,
	    slug: slugify(item.name)
	  });
	};
	
	var sortBy = function sortBy(fn) {
	  return function (a, b) {
	    return fn(b) - fn(a);
	  };
	};
	var sortByYearlyDelta = sortBy(function (project) {
	  return project.delta;
	});
	
	function getSortedProjects(entities) {
	  return Object.values(entities).slice().sort(sortByYearlyDelta);
	}
	
	function isMatchingTag(category, project) {
	  var tags = category.tags || [category.key];
	  return tags.some(function (tag) {
	    return project.tags.includes(tag);
	  });
	}
	
	function filterByTag(sortedProjects, entities, category) {
	  var key = category.key,
	      excluded = category.excluded,
	      count = category.count;
	
	  var isMatching = function isMatching(project) {
	    return key === 'all' || isMatchingTag(category, project);
	  };
	  var isExcluded = function isExcluded(project) {
	    return excluded && excluded.includes(project.slug);
	  };
	  return sortedProjects.filter(function (project) {
	    return isMatching(project) && !isExcluded(project);
	  });
	}
	
	function getProjectsByTag(sortedProjects, entities, categories) {
	  return categories.reduce(function (result, category) {
	    var _extends2;
	
	    return _extends({}, result, (_extends2 = {}, _extends2[category.key] = filterByTag(sortedProjects, entities, category), _extends2));
	  }, {});
	}
	
	function getProjectsBySlug(payload) {
	  var projectsBySlug = payload.projects.map(processProject).reduce(function (acc, project) {
	    var _extends3;
	
	    return _extends({}, acc, (_extends3 = {}, _extends3[project.slug] = project, _extends3));
	  }, {});
	  return projectsBySlug;
	}
	
	function getTopProjects(projectsByTag, categories) {
	  return categories.reduce(function (acc, category) {
	    var categoryTopProjects = projectsByTag[category.key].slice(0, category.count + 1);
	    return [].concat(acc, categoryTopProjects);
	  }, []);
	}
	
	function getMiscProjects(projectsByTag, categories) {
	  var topProjects = getTopProjects(projectsByTag, categories);
	  return projectsByTag.all.filter(function (p) {
	    return !topProjects.includes(p);
	  });
	}
	
	function processProjectData(projectData, categories) {
	  var entities = getProjectsBySlug(projectData);
	  var sorted = getSortedProjects(entities);
	  var projectsByTag = getProjectsByTag(sorted, entities, categories);
	  projectsByTag.misc = getMiscProjects(projectsByTag, categories);
	  return {
	    projectsByTag: projectsByTag,
	    entities: entities
	  };
	}
	
	module.exports = processProjectData;

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	'use strict';
	
	var removeSpaces = function removeSpaces(value) {
	  var replaced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  return replace(value, '\\s+', replaced);
	};
	
	var replace = function replace(value) {
	  var search = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
	  var newvalue = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
	  var caseSensitive = arguments.length <= 3 || arguments[3] === undefined ? true : arguments[3];
	  var flags = caseSensitive ? 'g' : 'gi';
	  return value.replace(new RegExp(search, flags), newvalue);
	};
	
	var slugify = function slugify(value) {
	  var result = value;
	  result = result.trim().toLowerCase();
	  result = removeSpaces(result, '-');
	  result = replace(result, '&', '-and-');
	  result = replace(result, '[^\\w\\-]+', '');
	  result = replace(result, '--+', '-');
	  return result;
	};
	
	module.exports = slugify;

/***/ }),
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = bail
	
	function bail(err) {
	  if (err) {
	    throw err
	  }
	}


/***/ }),
/* 267 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  function listen(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function () {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  function emit() {
	    currentListeners = nextListeners;
	    var listeners = currentListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i].apply(listeners, arguments);
	    }
	  }
	
	  return {
	    listen: listen,
	    emit: emit
	  };
	};

/***/ }),
/* 268 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = collapse
	
	// `collapse(' \t\nbar \nbaz\t') // ' bar baz '`
	function collapse(value) {
	  return String(value).replace(/\s+/g, ' ')
	}


/***/ }),
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */
/***/ (function(module, exports) {

	'use strict';
	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var defineProperty = Object.defineProperty;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}
	
		return toStr.call(arr) === '[object Array]';
	};
	
	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}
	
		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}
	
		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) { /**/ }
	
		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};
	
	// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
	var setProperty = function setProperty(target, options) {
		if (defineProperty && options.name === '__proto__') {
			defineProperty(target, options.name, {
				enumerable: true,
				configurable: true,
				value: options.newValue,
				writable: true
			});
		} else {
			target[options.name] = options.newValue;
		}
	};
	
	// Return undefined instead of __proto__ if '__proto__' is not an own property
	var getProperty = function getProperty(obj, name) {
		if (name === '__proto__') {
			if (!hasOwn.call(obj, name)) {
				return void 0;
			} else if (gOPD) {
				// In early versions of node, obj['__proto__'] is buggy when obj has
				// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
				return gOPD(obj, name).value;
			}
		}
	
		return obj[name];
	};
	
	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone;
		var target = arguments[0];
		var i = 1;
		var length = arguments.length;
		var deep = false;
	
		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		}
		if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
			target = {};
		}
	
		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = getProperty(target, name);
					copy = getProperty(options, name);
	
					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							setProperty(target, { name: name, newValue: extend(deep, clone, copy) });
	
						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							setProperty(target, { name: name, newValue: copy });
						}
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};


/***/ }),
/* 336 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var isBuffer = __webpack_require__(392)
	
	module.exports = flatten
	flatten.flatten = flatten
	flatten.unflatten = unflatten
	
	function flatten (target, opts) {
	  opts = opts || {}
	
	  var delimiter = opts.delimiter || '.'
	  var maxDepth = opts.maxDepth
	  var output = {}
	
	  function step (object, prev, currentDepth) {
	    currentDepth = currentDepth || 1
	    Object.keys(object).forEach(function (key) {
	      var value = object[key]
	      var isarray = opts.safe && Array.isArray(value)
	      var type = Object.prototype.toString.call(value)
	      var isbuffer = isBuffer(value)
	      var isobject = (
	        type === '[object Object]' ||
	        type === '[object Array]'
	      )
	
	      var newKey = prev
	        ? prev + delimiter + key
	        : key
	
	      if (!isarray && !isbuffer && isobject && Object.keys(value).length &&
	        (!opts.maxDepth || currentDepth < maxDepth)) {
	        return step(value, newKey, currentDepth + 1)
	      }
	
	      output[newKey] = value
	    })
	  }
	
	  step(target)
	
	  return output
	}
	
	function unflatten (target, opts) {
	  opts = opts || {}
	
	  var delimiter = opts.delimiter || '.'
	  var overwrite = opts.overwrite || false
	  var result = {}
	
	  var isbuffer = isBuffer(target)
	  if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
	    return target
	  }
	
	  // safely ensure that the key is
	  // an integer.
	  function getkey (key) {
	    var parsedKey = Number(key)
	
	    return (
	      isNaN(parsedKey) ||
	      key.indexOf('.') !== -1 ||
	      opts.object
	    ) ? key
	      : parsedKey
	  }
	
	  var sortedKeys = Object.keys(target).sort(function (keyA, keyB) {
	    return keyA.length - keyB.length
	  })
	
	  sortedKeys.forEach(function (key) {
	    var split = key.split(delimiter)
	    var key1 = getkey(split.shift())
	    var key2 = getkey(split[0])
	    var recipient = result
	
	    while (key2 !== undefined) {
	      var type = Object.prototype.toString.call(recipient[key1])
	      var isobject = (
	        type === '[object Object]' ||
	        type === '[object Array]'
	      )
	
	      // do not write over falsey, non-undefined values if overwrite is false
	      if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
	        return
	      }
	
	      if ((overwrite && !isobject) || (!overwrite && recipient[key1] == null)) {
	        recipient[key1] = (
	          typeof key2 === 'number' &&
	          !opts.object ? [] : {}
	        )
	      }
	
	      recipient = recipient[key1]
	      if (split.length > 0) {
	        key1 = getkey(split.shift())
	        key2 = getkey(split[0])
	      }
	    }
	
	    // unflatten again for 'messy objects'
	    recipient[key1] = unflatten(target[key], opts)
	  })
	
	  return result
	}


/***/ }),
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ }),
/* 376 */
/***/ (function(module, exports) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	var RelativeTimeFormat;
	// -- Utilities ----------------------------------------------------------------
	function getCacheId(inputs) {
	    return JSON.stringify(inputs.map(function (input) {
	        return input && typeof input === 'object' ? orderedProps(input) : input;
	    }));
	}
	function orderedProps(obj) {
	    return Object.keys(obj)
	        .sort()
	        .map(function (k) {
	        var _a;
	        return (_a = {}, _a[k] = obj[k], _a);
	    });
	}
	var memoizeFormatConstructor = function (FormatConstructor, cache) {
	    if (cache === void 0) { cache = {}; }
	    return function () {
	        var _a;
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var cacheId = getCacheId(args);
	        var format = cacheId && cache[cacheId];
	        if (!format) {
	            format = new ((_a = FormatConstructor).bind.apply(_a, [void 0].concat(args)))();
	            if (cacheId) {
	                cache[cacheId] = format;
	            }
	        }
	        return format;
	    };
	};
	exports.default = memoizeFormatConstructor;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(376)['default'];
	exports['default'] = exports;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(379)['default'];
	exports['default'] = exports;


/***/ }),
/* 379 */
/***/ (function(module, exports) {

	"use strict";
	
	exports["default"] = (function() {
	  "use strict";
	
	  /*
	   * Generated by PEG.js 0.9.0.
	   *
	   * http://pegjs.org/
	   */
	
	  function peg$subclass(child, parent) {
	    function ctor() { this.constructor = child; }
	    ctor.prototype = parent.prototype;
	    child.prototype = new ctor();
	  }
	
	  function peg$SyntaxError(message, expected, found, location) {
	    this.message  = message;
	    this.expected = expected;
	    this.found    = found;
	    this.location = location;
	    this.name     = "SyntaxError";
	
	    if (typeof Error.captureStackTrace === "function") {
	      Error.captureStackTrace(this, peg$SyntaxError);
	    }
	  }
	
	  peg$subclass(peg$SyntaxError, Error);
	
	  function peg$parse(input) {
	    var options = arguments.length > 1 ? arguments[1] : {},
	        parser  = this,
	
	        peg$FAILED = {},
	
	        peg$startRuleFunctions = { start: peg$parsestart },
	        peg$startRuleFunction  = peg$parsestart,
	
	        peg$c0 = function(elements) {
	                return {
	                    type    : 'messageFormatPattern',
	                    elements: elements,
	                    location: location()
	                };
	            },
	        peg$c1 = function(text) {
	                var string = '',
	                    i, j, outerLen, inner, innerLen;
	
	                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
	                    inner = text[i];
	
	                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
	                        string += inner[j];
	                    }
	                }
	
	                return string;
	            },
	        peg$c2 = function(messageText) {
	                return {
	                    type : 'messageTextElement',
	                    value: messageText,
	                    location: location()
	                };
	            },
	        peg$c3 = /^[^ \t\n\r,.+={}#]/,
	        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
	        peg$c5 = "{",
	        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
	        peg$c7 = ",",
	        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
	        peg$c9 = "}",
	        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
	        peg$c11 = function(id, format) {
	                return {
	                    type  : 'argumentElement',
	                    id    : id,
	                    format: format && format[2],
	                    location: location()
	                };
	            },
	        peg$c12 = "number",
	        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
	        peg$c14 = "date",
	        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
	        peg$c16 = "time",
	        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
	        peg$c18 = function(type, style) {
	                return {
	                    type : type + 'Format',
	                    style: style && style[2],
	                    location: location()
	                };
	            },
	        peg$c19 = "plural",
	        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
	        peg$c21 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: false,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options,
	                    location: location()
	                };
	            },
	        peg$c22 = "selectordinal",
	        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
	        peg$c24 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: true,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options,
	                    location: location()
	                }
	            },
	        peg$c25 = "select",
	        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
	        peg$c27 = function(options) {
	                return {
	                    type   : 'selectFormat',
	                    options: options,
	                    location: location()
	                };
	            },
	        peg$c28 = "=",
	        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
	        peg$c30 = function(selector, pattern) {
	                return {
	                    type    : 'optionalFormatPattern',
	                    selector: selector,
	                    value   : pattern,
	                    location: location()
	                };
	            },
	        peg$c31 = "offset:",
	        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
	        peg$c33 = function(number) {
	                return number;
	            },
	        peg$c34 = function(offset, options) {
	                return {
	                    type   : 'pluralFormat',
	                    offset : offset,
	                    options: options,
	                    location: location()
	                };
	            },
	        peg$c35 = { type: "other", description: "whitespace" },
	        peg$c36 = /^[ \t\n\r]/,
	        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
	        peg$c38 = { type: "other", description: "optionalWhitespace" },
	        peg$c39 = /^[0-9]/,
	        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
	        peg$c41 = /^[0-9a-f]/i,
	        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
	        peg$c43 = "0",
	        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
	        peg$c45 = /^[1-9]/,
	        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
	        peg$c47 = function(digits) {
	            return parseInt(digits, 10);
	        },
	        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
	        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
	        peg$c50 = "\\\\",
	        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
	        peg$c52 = function() { return '\\'; },
	        peg$c53 = "\\#",
	        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
	        peg$c55 = function() { return '\\#'; },
	        peg$c56 = "\\{",
	        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
	        peg$c58 = function() { return '\u007B'; },
	        peg$c59 = "\\}",
	        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
	        peg$c61 = function() { return '\u007D'; },
	        peg$c62 = "\\u",
	        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
	        peg$c64 = function(digits) {
	                return String.fromCharCode(parseInt(digits, 16));
	            },
	        peg$c65 = function(chars) { return chars.join(''); },
	
	        peg$currPos          = 0,
	        peg$savedPos         = 0,
	        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
	        peg$maxFailPos       = 0,
	        peg$maxFailExpected  = [],
	        peg$silentFails      = 0,
	
	        peg$result;
	
	    if ("startRule" in options) {
	      if (!(options.startRule in peg$startRuleFunctions)) {
	        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
	      }
	
	      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
	    }
	
	    function text() {
	      return input.substring(peg$savedPos, peg$currPos);
	    }
	
	    function location() {
	      return peg$computeLocation(peg$savedPos, peg$currPos);
	    }
	
	    function expected(description) {
	      throw peg$buildException(
	        null,
	        [{ type: "other", description: description }],
	        input.substring(peg$savedPos, peg$currPos),
	        peg$computeLocation(peg$savedPos, peg$currPos)
	      );
	    }
	
	    function error(message) {
	      throw peg$buildException(
	        message,
	        null,
	        input.substring(peg$savedPos, peg$currPos),
	        peg$computeLocation(peg$savedPos, peg$currPos)
	      );
	    }
	
	    function peg$computePosDetails(pos) {
	      var details = peg$posDetailsCache[pos],
	          p, ch;
	
	      if (details) {
	        return details;
	      } else {
	        p = pos - 1;
	        while (!peg$posDetailsCache[p]) {
	          p--;
	        }
	
	        details = peg$posDetailsCache[p];
	        details = {
	          line:   details.line,
	          column: details.column,
	          seenCR: details.seenCR
	        };
	
	        while (p < pos) {
	          ch = input.charAt(p);
	          if (ch === "\n") {
	            if (!details.seenCR) { details.line++; }
	            details.column = 1;
	            details.seenCR = false;
	          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
	            details.line++;
	            details.column = 1;
	            details.seenCR = true;
	          } else {
	            details.column++;
	            details.seenCR = false;
	          }
	
	          p++;
	        }
	
	        peg$posDetailsCache[pos] = details;
	        return details;
	      }
	    }
	
	    function peg$computeLocation(startPos, endPos) {
	      var startPosDetails = peg$computePosDetails(startPos),
	          endPosDetails   = peg$computePosDetails(endPos);
	
	      return {
	        start: {
	          offset: startPos,
	          line:   startPosDetails.line,
	          column: startPosDetails.column
	        },
	        end: {
	          offset: endPos,
	          line:   endPosDetails.line,
	          column: endPosDetails.column
	        }
	      };
	    }
	
	    function peg$fail(expected) {
	      if (peg$currPos < peg$maxFailPos) { return; }
	
	      if (peg$currPos > peg$maxFailPos) {
	        peg$maxFailPos = peg$currPos;
	        peg$maxFailExpected = [];
	      }
	
	      peg$maxFailExpected.push(expected);
	    }
	
	    function peg$buildException(message, expected, found, location) {
	      function cleanupExpected(expected) {
	        var i = 1;
	
	        expected.sort(function(a, b) {
	          if (a.description < b.description) {
	            return -1;
	          } else if (a.description > b.description) {
	            return 1;
	          } else {
	            return 0;
	          }
	        });
	
	        while (i < expected.length) {
	          if (expected[i - 1] === expected[i]) {
	            expected.splice(i, 1);
	          } else {
	            i++;
	          }
	        }
	      }
	
	      function buildMessage(expected, found) {
	        function stringEscape(s) {
	          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }
	
	          return s
	            .replace(/\\/g,   '\\\\')
	            .replace(/"/g,    '\\"')
	            .replace(/\x08/g, '\\b')
	            .replace(/\t/g,   '\\t')
	            .replace(/\n/g,   '\\n')
	            .replace(/\f/g,   '\\f')
	            .replace(/\r/g,   '\\r')
	            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
	            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
	            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
	            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
	        }
	
	        var expectedDescs = new Array(expected.length),
	            expectedDesc, foundDesc, i;
	
	        for (i = 0; i < expected.length; i++) {
	          expectedDescs[i] = expected[i].description;
	        }
	
	        expectedDesc = expected.length > 1
	          ? expectedDescs.slice(0, -1).join(", ")
	              + " or "
	              + expectedDescs[expected.length - 1]
	          : expectedDescs[0];
	
	        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";
	
	        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
	      }
	
	      if (expected !== null) {
	        cleanupExpected(expected);
	      }
	
	      return new peg$SyntaxError(
	        message !== null ? message : buildMessage(expected, found),
	        expected,
	        found,
	        location
	      );
	    }
	
	    function peg$parsestart() {
	      var s0;
	
	      s0 = peg$parsemessageFormatPattern();
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatPattern() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsemessageFormatElement();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsemessageFormatElement();
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c0(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatElement() {
	      var s0;
	
	      s0 = peg$parsemessageTextElement();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parseargumentElement();
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageText() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$parse_();
	      if (s3 !== peg$FAILED) {
	        s4 = peg$parsechars();
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parse_();
	          if (s5 !== peg$FAILED) {
	            s3 = [s3, s4, s5];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$FAILED;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsechars();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s3 = [s3, s4, s5];
	                s2 = s3;
	              } else {
	                peg$currPos = s2;
	                s2 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s2;
	              s2 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c1(s1);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = peg$parsews();
	        if (s1 !== peg$FAILED) {
	          s0 = input.substring(s0, peg$currPos);
	        } else {
	          s0 = s1;
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageTextElement() {
	      var s0, s1;
	
	      s0 = peg$currPos;
	      s1 = peg$parsemessageText();
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c2(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseargument() {
	      var s0, s1, s2;
	
	      s0 = peg$parsenumber();
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = [];
	        if (peg$c3.test(input.charAt(peg$currPos))) {
	          s2 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c4); }
	        }
	        if (s2 !== peg$FAILED) {
	          while (s2 !== peg$FAILED) {
	            s1.push(s2);
	            if (peg$c3.test(input.charAt(peg$currPos))) {
	              s2 = input.charAt(peg$currPos);
	              peg$currPos++;
	            } else {
	              s2 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c4); }
	            }
	          }
	        } else {
	          s1 = peg$FAILED;
	        }
	        if (s1 !== peg$FAILED) {
	          s0 = input.substring(s0, peg$currPos);
	        } else {
	          s0 = s1;
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parseargumentElement() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 123) {
	        s1 = peg$c5;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c6); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parseargument();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$currPos;
	              if (input.charCodeAt(peg$currPos) === 44) {
	                s6 = peg$c7;
	                peg$currPos++;
	              } else {
	                s6 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c8); }
	              }
	              if (s6 !== peg$FAILED) {
	                s7 = peg$parse_();
	                if (s7 !== peg$FAILED) {
	                  s8 = peg$parseelementFormat();
	                  if (s8 !== peg$FAILED) {
	                    s6 = [s6, s7, s8];
	                    s5 = s6;
	                  } else {
	                    peg$currPos = s5;
	                    s5 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s5;
	                  s5 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s5;
	                s5 = peg$FAILED;
	              }
	              if (s5 === peg$FAILED) {
	                s5 = null;
	              }
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parse_();
	                if (s6 !== peg$FAILED) {
	                  if (input.charCodeAt(peg$currPos) === 125) {
	                    s7 = peg$c9;
	                    peg$currPos++;
	                  } else {
	                    s7 = peg$FAILED;
	                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
	                  }
	                  if (s7 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c11(s3, s5);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseelementFormat() {
	      var s0;
	
	      s0 = peg$parsesimpleFormat();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsepluralFormat();
	        if (s0 === peg$FAILED) {
	          s0 = peg$parseselectOrdinalFormat();
	          if (s0 === peg$FAILED) {
	            s0 = peg$parseselectFormat();
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsesimpleFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c12) {
	        s1 = peg$c12;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c13); }
	      }
	      if (s1 === peg$FAILED) {
	        if (input.substr(peg$currPos, 4) === peg$c14) {
	          s1 = peg$c14;
	          peg$currPos += 4;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c15); }
	        }
	        if (s1 === peg$FAILED) {
	          if (input.substr(peg$currPos, 4) === peg$c16) {
	            s1 = peg$c16;
	            peg$currPos += 4;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c17); }
	          }
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$currPos;
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s4 = peg$c7;
	            peg$currPos++;
	          } else {
	            s4 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s4 !== peg$FAILED) {
	            s5 = peg$parse_();
	            if (s5 !== peg$FAILED) {
	              s6 = peg$parsechars();
	              if (s6 !== peg$FAILED) {
	                s4 = [s4, s5, s6];
	                s3 = s4;
	              } else {
	                peg$currPos = s3;
	                s3 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s3;
	              s3 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s3;
	            s3 = peg$FAILED;
	          }
	          if (s3 === peg$FAILED) {
	            s3 = null;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c18(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c19) {
	        s1 = peg$c19;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c20); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c21(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectOrdinalFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 13) === peg$c22) {
	        s1 = peg$c22;
	        peg$currPos += 13;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c23); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c24(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c25) {
	        s1 = peg$c25;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c26); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = [];
	              s6 = peg$parseoptionalFormatPattern();
	              if (s6 !== peg$FAILED) {
	                while (s6 !== peg$FAILED) {
	                  s5.push(s6);
	                  s6 = peg$parseoptionalFormatPattern();
	                }
	              } else {
	                s5 = peg$FAILED;
	              }
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c27(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselector() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      s1 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 61) {
	        s2 = peg$c28;
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c29); }
	      }
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parsenumber();
	        if (s3 !== peg$FAILED) {
	          s2 = [s2, s3];
	          s1 = s2;
	        } else {
	          peg$currPos = s1;
	          s1 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s1;
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        s0 = input.substring(s0, peg$currPos);
	      } else {
	        s0 = s1;
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsechars();
	      }
	
	      return s0;
	    }
	
	    function peg$parseoptionalFormatPattern() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      s1 = peg$parse_();
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parseselector();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 123) {
	              s4 = peg$c5;
	              peg$currPos++;
	            } else {
	              s4 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c6); }
	            }
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parsemessageFormatPattern();
	                if (s6 !== peg$FAILED) {
	                  s7 = peg$parse_();
	                  if (s7 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 125) {
	                      s8 = peg$c9;
	                      peg$currPos++;
	                    } else {
	                      s8 = peg$FAILED;
	                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
	                    }
	                    if (s8 !== peg$FAILED) {
	                      peg$savedPos = s0;
	                      s1 = peg$c30(s2, s6);
	                      s0 = s1;
	                    } else {
	                      peg$currPos = s0;
	                      s0 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseoffset() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 7) === peg$c31) {
	        s1 = peg$c31;
	        peg$currPos += 7;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c32); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parsenumber();
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c33(s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralStyle() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = peg$parseoffset();
	      if (s1 === peg$FAILED) {
	        s1 = null;
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = [];
	          s4 = peg$parseoptionalFormatPattern();
	          if (s4 !== peg$FAILED) {
	            while (s4 !== peg$FAILED) {
	              s3.push(s4);
	              s4 = peg$parseoptionalFormatPattern();
	            }
	          } else {
	            s3 = peg$FAILED;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c34(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsews() {
	      var s0, s1;
	
	      peg$silentFails++;
	      s0 = [];
	      if (peg$c36.test(input.charAt(peg$currPos))) {
	        s1 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c37); }
	      }
	      if (s1 !== peg$FAILED) {
	        while (s1 !== peg$FAILED) {
	          s0.push(s1);
	          if (peg$c36.test(input.charAt(peg$currPos))) {
	            s1 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c37); }
	          }
	        }
	      } else {
	        s0 = peg$FAILED;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c35); }
	      }
	
	      return s0;
	    }
	
	    function peg$parse_() {
	      var s0, s1, s2;
	
	      peg$silentFails++;
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsews();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsews();
	      }
	      if (s1 !== peg$FAILED) {
	        s0 = input.substring(s0, peg$currPos);
	      } else {
	        s0 = s1;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c38); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsedigit() {
	      var s0;
	
	      if (peg$c39.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c40); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsehexDigit() {
	      var s0;
	
	      if (peg$c41.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c42); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsenumber() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 48) {
	        s1 = peg$c43;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c44); }
	      }
	      if (s1 === peg$FAILED) {
	        s1 = peg$currPos;
	        s2 = peg$currPos;
	        if (peg$c45.test(input.charAt(peg$currPos))) {
	          s3 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s3 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c46); }
	        }
	        if (s3 !== peg$FAILED) {
	          s4 = [];
	          s5 = peg$parsedigit();
	          while (s5 !== peg$FAILED) {
	            s4.push(s5);
	            s5 = peg$parsedigit();
	          }
	          if (s4 !== peg$FAILED) {
	            s3 = [s3, s4];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	          s1 = input.substring(s1, peg$currPos);
	        } else {
	          s1 = s2;
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c47(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsechar() {
	      var s0, s1, s2, s3, s4, s5, s6, s7;
	
	      if (peg$c48.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c49); }
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c50) {
	          s1 = peg$c50;
	          peg$currPos += 2;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c51); }
	        }
	        if (s1 !== peg$FAILED) {
	          peg$savedPos = s0;
	          s1 = peg$c52();
	        }
	        s0 = s1;
	        if (s0 === peg$FAILED) {
	          s0 = peg$currPos;
	          if (input.substr(peg$currPos, 2) === peg$c53) {
	            s1 = peg$c53;
	            peg$currPos += 2;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c54); }
	          }
	          if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c55();
	          }
	          s0 = s1;
	          if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            if (input.substr(peg$currPos, 2) === peg$c56) {
	              s1 = peg$c56;
	              peg$currPos += 2;
	            } else {
	              s1 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c57); }
	            }
	            if (s1 !== peg$FAILED) {
	              peg$savedPos = s0;
	              s1 = peg$c58();
	            }
	            s0 = s1;
	            if (s0 === peg$FAILED) {
	              s0 = peg$currPos;
	              if (input.substr(peg$currPos, 2) === peg$c59) {
	                s1 = peg$c59;
	                peg$currPos += 2;
	              } else {
	                s1 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c60); }
	              }
	              if (s1 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c61();
	              }
	              s0 = s1;
	              if (s0 === peg$FAILED) {
	                s0 = peg$currPos;
	                if (input.substr(peg$currPos, 2) === peg$c62) {
	                  s1 = peg$c62;
	                  peg$currPos += 2;
	                } else {
	                  s1 = peg$FAILED;
	                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
	                }
	                if (s1 !== peg$FAILED) {
	                  s2 = peg$currPos;
	                  s3 = peg$currPos;
	                  s4 = peg$parsehexDigit();
	                  if (s4 !== peg$FAILED) {
	                    s5 = peg$parsehexDigit();
	                    if (s5 !== peg$FAILED) {
	                      s6 = peg$parsehexDigit();
	                      if (s6 !== peg$FAILED) {
	                        s7 = peg$parsehexDigit();
	                        if (s7 !== peg$FAILED) {
	                          s4 = [s4, s5, s6, s7];
	                          s3 = s4;
	                        } else {
	                          peg$currPos = s3;
	                          s3 = peg$FAILED;
	                        }
	                      } else {
	                        peg$currPos = s3;
	                        s3 = peg$FAILED;
	                      }
	                    } else {
	                      peg$currPos = s3;
	                      s3 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s3;
	                    s3 = peg$FAILED;
	                  }
	                  if (s3 !== peg$FAILED) {
	                    s2 = input.substring(s2, peg$currPos);
	                  } else {
	                    s2 = s3;
	                  }
	                  if (s2 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c64(s2);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              }
	            }
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsechars() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsechar();
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$parsechar();
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c65(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    peg$result = peg$startRuleFunction();
	
	    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
	      return peg$result;
	    } else {
	      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
	        peg$fail({ type: "end", description: "end of input" });
	      }
	
	      throw peg$buildException(
	        null,
	        peg$maxFailExpected,
	        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
	        peg$maxFailPos < input.length
	          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
	          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
	      );
	    }
	  }
	
	  return {
	    SyntaxError: peg$SyntaxError,
	    parse:       peg$parse
	  };
	})();
	
	//# sourceMappingURL=parser.js.map

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports["default"] = Compiler;
	
	function Compiler(locales, formats, pluralFn) {
	    this.locales  = locales;
	    this.formats  = formats;
	    this.pluralFn = pluralFn;
	}
	
	Compiler.prototype.compile = function (ast) {
	    this.pluralStack        = [];
	    this.currentPlural      = null;
	    this.pluralNumberFormat = null;
	
	    return this.compileMessage(ast);
	};
	
	Compiler.prototype.compileMessage = function (ast) {
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new Error('Message AST is not of type: "messageFormatPattern"');
	    }
	
	    var elements = ast.elements,
	        pattern  = [];
	
	    var i, len, element;
	
	    for (i = 0, len = elements.length; i < len; i += 1) {
	        element = elements[i];
	
	        switch (element.type) {
	            case 'messageTextElement':
	                pattern.push(this.compileMessageText(element));
	                break;
	
	            case 'argumentElement':
	                pattern.push(this.compileArgument(element));
	                break;
	
	            default:
	                throw new Error('Message element does not have a valid type');
	        }
	    }
	
	    return pattern;
	};
	
	Compiler.prototype.compileMessageText = function (element) {
	    // When this `element` is part of plural sub-pattern and its value contains
	    // an unescaped '#', use a `PluralOffsetString` helper to properly output
	    // the number with the correct offset in the string.
	    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
	        // Create a cache a NumberFormat instance that can be reused for any
	        // PluralOffsetString instance in this message.
	        if (!this.pluralNumberFormat) {
	            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
	        }
	
	        return new PluralOffsetString(
	                this.currentPlural.id,
	                this.currentPlural.format.offset,
	                this.pluralNumberFormat,
	                element.value);
	    }
	
	    // Unescape the escaped '#'s in the message text.
	    return element.value.replace(/\\#/g, '#');
	};
	
	Compiler.prototype.compileArgument = function (element) {
	    var format = element.format;
	
	    if (!format) {
	        return new StringFormat(element.id);
	    }
	
	    var formats  = this.formats,
	        locales  = this.locales,
	        pluralFn = this.pluralFn,
	        options;
	
	    switch (format.type) {
	        case 'numberFormat':
	            options = formats.number[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.NumberFormat(locales, options).format
	            };
	
	        case 'dateFormat':
	            options = formats.date[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'timeFormat':
	            options = formats.time[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'pluralFormat':
	            options = this.compileOptions(element);
	            return new PluralFormat(
	                element.id, format.ordinal, format.offset, options, pluralFn
	            );
	
	        case 'selectFormat':
	            options = this.compileOptions(element);
	            return new SelectFormat(element.id, options);
	
	        default:
	            throw new Error('Message element does not have a valid format type');
	    }
	};
	
	Compiler.prototype.compileOptions = function (element) {
	    var format      = element.format,
	        options     = format.options,
	        optionsHash = {};
	
	    // Save the current plural element, if any, then set it to a new value when
	    // compiling the options sub-patterns. This conforms the spec's algorithm
	    // for handling `"#"` syntax in message text.
	    this.pluralStack.push(this.currentPlural);
	    this.currentPlural = format.type === 'pluralFormat' ? element : null;
	
	    var i, len, option;
	
	    for (i = 0, len = options.length; i < len; i += 1) {
	        option = options[i];
	
	        // Compile the sub-pattern and save it under the options's selector.
	        optionsHash[option.selector] = this.compileMessage(option.value);
	    }
	
	    // Pop the plural stack to put back the original current plural value.
	    this.currentPlural = this.pluralStack.pop();
	
	    return optionsHash;
	};
	
	// -- Compiler Helper Classes --------------------------------------------------
	
	function StringFormat(id) {
	    this.id = id;
	}
	
	StringFormat.prototype.format = function (value) {
	    if (!value && typeof value !== 'number') {
	        return '';
	    }
	
	    return typeof value === 'string' ? value : String(value);
	};
	
	function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
	    this.id         = id;
	    this.useOrdinal = useOrdinal;
	    this.offset     = offset;
	    this.options    = options;
	    this.pluralFn   = pluralFn;
	}
	
	PluralFormat.prototype.getOption = function (value) {
	    var options = this.options;
	
	    var option = options['=' + value] ||
	            options[this.pluralFn(value - this.offset, this.useOrdinal)];
	
	    return option || options.other;
	};
	
	function PluralOffsetString(id, offset, numberFormat, string) {
	    this.id           = id;
	    this.offset       = offset;
	    this.numberFormat = numberFormat;
	    this.string       = string;
	}
	
	PluralOffsetString.prototype.format = function (value) {
	    var number = this.numberFormat.format(value - this.offset);
	
	    return this.string
	            .replace(/(^|[^\\])#/g, '$1' + number)
	            .replace(/\\#/g, '#');
	};
	
	function SelectFormat(id, options) {
	    this.id      = id;
	    this.options = options;
	}
	
	SelectFormat.prototype.getOption = function (value) {
	    var options = this.options;
	    return options[value] || options.other;
	};
	
	//# sourceMappingURL=compiler.js.map

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(155), src$es5$$ = __webpack_require__(383), src$compiler$$ = __webpack_require__(380), intl$messageformat$parser$$ = __webpack_require__(378);
	exports["default"] = MessageFormat;
	
	// -- MessageFormat --------------------------------------------------------
	
	function MessageFormat(message, locales, formats) {
	    // Parse string messages into an AST.
	    var ast = typeof message === 'string' ?
	            MessageFormat.__parse(message) : message;
	
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new TypeError('A message must be provided as a String or AST.');
	    }
	
	    // Creates a new object with the specified `formats` merged with the default
	    // formats.
	    formats = this._mergeFormats(MessageFormat.formats, formats);
	
	    // Defined first because it's used to build the format pattern.
	    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});
	
	    // Compile the `ast` to a pattern that is highly optimized for repeated
	    // `format()` invocations. **Note:** This passes the `locales` set provided
	    // to the constructor instead of just the resolved locale.
	    var pluralFn = this._findPluralRuleFunction(this._locale);
	    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var messageFormat = this;
	    this.format = function (values) {
	      try {
	        return messageFormat._format(pattern, values);
	      } catch (e) {
	        if (e.variableId) {
	          throw new Error(
	            'The intl string context variable \'' + e.variableId + '\'' +
	            ' was not provided to the string \'' + message + '\''
	          );
	        } else {
	          throw e;
	        }
	      }
	    };
	}
	
	// Default format options used as the prototype of the `formats` provided to the
	// constructor. These are used when constructing the internal Intl.NumberFormat
	// and Intl.DateTimeFormat instances.
	src$es5$$.defineProperty(MessageFormat, 'formats', {
	    enumerable: true,
	
	    value: {
	        number: {
	            'currency': {
	                style: 'currency'
	            },
	
	            'percent': {
	                style: 'percent'
	            }
	        },
	
	        date: {
	            'short': {
	                month: 'numeric',
	                day  : 'numeric',
	                year : '2-digit'
	            },
	
	            'medium': {
	                month: 'short',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'long': {
	                month: 'long',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'full': {
	                weekday: 'long',
	                month  : 'long',
	                day    : 'numeric',
	                year   : 'numeric'
	            }
	        },
	
	        time: {
	            'short': {
	                hour  : 'numeric',
	                minute: 'numeric'
	            },
	
	            'medium':  {
	                hour  : 'numeric',
	                minute: 'numeric',
	                second: 'numeric'
	            },
	
	            'long': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            },
	
	            'full': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            }
	        }
	    }
	});
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlMessageFormat is missing a ' +
	            '`locale` property'
	        );
	    }
	
	    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
	}});
	
	// Defines `__parse()` static method as an exposed private.
	src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});
	
	// Define public `defaultLocale` property which defaults to English, but can be
	// set by the developer.
	src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	MessageFormat.prototype.resolvedOptions = function () {
	    // TODO: Provide anything else?
	    return {
	        locale: this._locale
	    };
	};
	
	MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
	    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
	    return compiler.compile(ast);
	};
	
	MessageFormat.prototype._findPluralRuleFunction = function (locale) {
	    var localeData = MessageFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find a `pluralRuleFunction` to return.
	    while (data) {
	        if (data.pluralRuleFunction) {
	            return data.pluralRuleFunction;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlMessageFormat is missing a ' +
	        '`pluralRuleFunction` for :' + locale
	    );
	};
	
	MessageFormat.prototype._format = function (pattern, values) {
	    var result = '',
	        i, len, part, id, value, err;
	
	    for (i = 0, len = pattern.length; i < len; i += 1) {
	        part = pattern[i];
	
	        // Exist early for string parts.
	        if (typeof part === 'string') {
	            result += part;
	            continue;
	        }
	
	        id = part.id;
	
	        // Enforce that all required values are provided by the caller.
	        if (!(values && src$utils$$.hop.call(values, id))) {
	          err = new Error('A value must be provided for: ' + id);
	          err.variableId = id;
	          throw err;
	        }
	
	        value = values[id];
	
	        // Recursively format plural and select parts' option — which can be a
	        // nested pattern structure. The choosing of the option to use is
	        // abstracted-by and delegated-to the part helper object.
	        if (part.options) {
	            result += this._format(part.getOption(value), values);
	        } else {
	            result += part.format(value);
	        }
	    }
	
	    return result;
	};
	
	MessageFormat.prototype._mergeFormats = function (defaults, formats) {
	    var mergedFormats = {},
	        type, mergedType;
	
	    for (type in defaults) {
	        if (!src$utils$$.hop.call(defaults, type)) { continue; }
	
	        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);
	
	        if (formats && src$utils$$.hop.call(formats, type)) {
	            src$utils$$.extend(mergedType, formats[type]);
	        }
	    }
	
	    return mergedFormats;
	};
	
	MessageFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(MessageFormat.defaultLocale);
	
	    var localeData = MessageFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlMessageFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	//# sourceMappingURL=core.js.map

/***/ }),
/* 382 */
/***/ (function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};
	
	//# sourceMappingURL=en.js.map

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(155);
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (src$utils$$.hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	/* jslint esnext: true */
	
	"use strict";
	var src$core$$ = __webpack_require__(381), src$en$$ = __webpack_require__(382);
	
	src$core$$["default"].__addLocaleData(src$en$$["default"]);
	src$core$$["default"].defaultLocale = 'en';
	
	exports["default"] = src$core$$["default"];
	
	//# sourceMappingURL=main.js.map

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlRelativeFormat = __webpack_require__(390)['default'];
	
	// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(655);
	
	// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlRelativeFormat;
	exports['default'] = exports;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	/* jslint esnext: true */
	var intl_messageformat_1 = __webpack_require__(154);
	var diff_1 = __webpack_require__(387);
	var es5_1 = __webpack_require__(389);
	exports.default = RelativeFormat;
	// -----------------------------------------------------------------------------
	var FIELDS = [
	    'second', 'second-short',
	    'minute', 'minute-short',
	    'hour', 'hour-short',
	    'day', 'day-short',
	    'month', 'month-short',
	    'year', 'year-short'
	];
	var STYLES = ['best fit', 'numeric'];
	// -- RelativeFormat -----------------------------------------------------------
	function RelativeFormat(locales, options) {
	    options = options || {};
	    // Make a copy of `locales` if it's an array, so that it doesn't change
	    // since it's used lazily.
	    if (es5_1.isArray(locales)) {
	        locales = locales.concat();
	    }
	    es5_1.defineProperty(this, '_locale', { value: this._resolveLocale(locales) });
	    es5_1.defineProperty(this, '_options', { value: {
	            style: this._resolveStyle(options.style),
	            units: this._isValidUnits(options.units) && options.units
	        } });
	    es5_1.defineProperty(this, '_locales', { value: locales });
	    es5_1.defineProperty(this, '_fields', { value: this._findFields(this._locale) });
	    es5_1.defineProperty(this, '_messages', { value: es5_1.objCreate(null) });
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var relativeFormat = this;
	    this.format = function format(date, options) {
	        return relativeFormat._format(date, options);
	    };
	}
	// Define internal private properties for dealing with locale data.
	es5_1.defineProperty(RelativeFormat, '__localeData__', { value: es5_1.objCreate(null) });
	es5_1.defineProperty(RelativeFormat, '__addLocaleData', { value: function () {
	        for (var i = 0; i < arguments.length; i++) {
	            var datum = arguments[i];
	            if (!(datum && datum.locale)) {
	                throw new Error('Locale data provided to IntlRelativeFormat is missing a ' +
	                    '`locale` property value');
	            }
	            RelativeFormat.__localeData__[datum.locale.toLowerCase()] = datum;
	            // Add data to IntlMessageFormat.
	            intl_messageformat_1.default.__addLocaleData(datum);
	        }
	    } });
	// Define public `defaultLocale` property which can be set by the developer, or
	// it will be set when the first RelativeFormat instance is created by
	// leveraging the resolved locale from `Intl`.
	es5_1.defineProperty(RelativeFormat, 'defaultLocale', {
	    enumerable: true,
	    writable: true,
	    value: undefined
	});
	// Define public `thresholds` property which can be set by the developer, and
	// defaults to relative time thresholds from moment.js.
	es5_1.defineProperty(RelativeFormat, 'thresholds', {
	    enumerable: true,
	    value: {
	        second: 45, 'second-short': 45,
	        minute: 45, 'minute-short': 45,
	        hour: 22, 'hour-short': 22,
	        day: 26, 'day-short': 26,
	        month: 11, 'month-short': 11 // months to year
	    }
	});
	RelativeFormat.prototype.resolvedOptions = function () {
	    return {
	        locale: this._locale,
	        style: this._options.style,
	        units: this._options.units
	    };
	};
	RelativeFormat.prototype._compileMessage = function (units) {
	    // `this._locales` is the original set of locales the user specified to the
	    // constructor, while `this._locale` is the resolved root locale.
	    var locales = this._locales;
	    var resolvedLocale = this._locale;
	    var field = this._fields[units];
	    var relativeTime = field.relativeTime;
	    var future = '';
	    var past = '';
	    var i;
	    for (i in relativeTime.future) {
	        if (relativeTime.future.hasOwnProperty(i)) {
	            future += ' ' + i + ' {' +
	                relativeTime.future[i].replace('{0}', '#') + '}';
	        }
	    }
	    for (i in relativeTime.past) {
	        if (relativeTime.past.hasOwnProperty(i)) {
	            past += ' ' + i + ' {' +
	                relativeTime.past[i].replace('{0}', '#') + '}';
	        }
	    }
	    var message = '{when, select, future {{0, plural, ' + future + '}}' +
	        'past {{0, plural, ' + past + '}}}';
	    // Create the synthetic IntlMessageFormat instance using the original
	    // locales value specified by the user when constructing the the parent
	    // IntlRelativeFormat instance.
	    return new intl_messageformat_1.default(message, locales);
	};
	RelativeFormat.prototype._getMessage = function (units) {
	    var messages = this._messages;
	    // Create a new synthetic message based on the locale data from CLDR.
	    if (!messages[units]) {
	        messages[units] = this._compileMessage(units);
	    }
	    return messages[units];
	};
	RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
	    var field = this._fields[units];
	    if (field.relative) {
	        return field.relative[diff];
	    }
	};
	RelativeFormat.prototype._findFields = function (locale) {
	    var localeData = RelativeFormat.__localeData__;
	    var data = localeData[locale.toLowerCase()];
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find `fields` to return.
	    while (data) {
	        if (data.fields) {
	            return data.fields;
	        }
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	    throw new Error('Locale data added to IntlRelativeFormat is missing `fields` for :' +
	        locale);
	};
	RelativeFormat.prototype._format = function (date, options) {
	    var now = options && options.now !== undefined ? options.now : es5_1.dateNow();
	    if (date === undefined) {
	        date = now;
	    }
	    // Determine if the `date` and optional `now` values are valid, and throw a
	    // similar error to what `Intl.DateTimeFormat#format()` would throw.
	    if (!isFinite(now)) {
	        throw new RangeError('The `now` option provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.');
	    }
	    if (!isFinite(date)) {
	        throw new RangeError('The date value provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.');
	    }
	    var diffReport = diff_1.default(now, date);
	    var units = this._options.units || this._selectUnits(diffReport);
	    var diffInUnits = diffReport[units];
	    if (this._options.style !== 'numeric') {
	        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
	        if (relativeUnits) {
	            return relativeUnits;
	        }
	    }
	    return this._getMessage(units).format({
	        '0': Math.abs(diffInUnits),
	        when: diffInUnits < 0 ? 'past' : 'future'
	    });
	};
	RelativeFormat.prototype._isValidUnits = function (units) {
	    if (!units || es5_1.arrIndexOf.call(FIELDS, units) >= 0) {
	        return true;
	    }
	    if (typeof units === 'string') {
	        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
	        if (suggestion && es5_1.arrIndexOf.call(FIELDS, suggestion) >= 0) {
	            throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` ' +
	                'value, did you mean: ' + suggestion);
	        }
	    }
	    throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
	        'must be one of: "' + FIELDS.join('", "') + '"');
	};
	RelativeFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(RelativeFormat.defaultLocale);
	    var localeData = RelativeFormat.__localeData__;
	    var i, len, localeParts, data;
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	            localeParts.pop();
	        }
	    }
	    var defaultLocale = locales.pop();
	    throw new Error('No locale data has been added to IntlRelativeFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale);
	};
	RelativeFormat.prototype._resolveStyle = function (style) {
	    // Default to "best fit" style.
	    if (!style) {
	        return STYLES[0];
	    }
	    if (es5_1.arrIndexOf.call(STYLES, style) >= 0) {
	        return style;
	    }
	    throw new Error('"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
	        'must be one of: "' + STYLES.join('", "') + '"');
	};
	RelativeFormat.prototype._selectUnits = function (diffReport) {
	    var i, l, units;
	    var fields = FIELDS.filter(function (field) {
	        return field.indexOf('-short') < 1;
	    });
	    for (i = 0, l = fields.length; i < l; i += 1) {
	        units = fields[i];
	        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
	            break;
	        }
	    }
	    return units;
	};
	//# sourceMappingURL=core.js.map

/***/ }),
/* 387 */
/***/ (function(module, exports) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	/* jslint esnext: true */
	var round = Math.round;
	function daysToYears(days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    return days * 400 / 146097;
	}
	// Thanks to date-fns
	// https://github.com/date-fns/date-fns
	// MIT © Sasha Koss
	var MILLISECONDS_IN_MINUTE = 60000;
	var MILLISECONDS_IN_DAY = 86400000;
	function startOfDay(dirtyDate) {
	    var date = new Date(dirtyDate);
	    date.setHours(0, 0, 0, 0);
	    return date;
	}
	function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
	    var startOfDayLeft = startOfDay(dirtyDateLeft);
	    var startOfDayRight = startOfDay(dirtyDateRight);
	    var timestampLeft = startOfDayLeft.getTime() -
	        startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
	    var timestampRight = startOfDayRight.getTime() -
	        startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
	    // Round the number of days to the nearest integer
	    // because the number of milliseconds in a day is not constant
	    // (e.g. it's different in the day of the daylight saving time clock shift)
	    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
	}
	function default_1(from, to) {
	    // Convert to ms timestamps.
	    from = +from;
	    to = +to;
	    var millisecond = round(to - from), second = round(millisecond / 1000), minute = round(second / 60), hour = round(minute / 60);
	    // We expect a more precision in rounding when dealing with
	    // days as it feels wrong when something happended 13 hours ago and
	    // is regarded as "yesterday" even if the time was this morning.
	    var day = differenceInCalendarDays(to, from);
	    var week = round(day / 7);
	    var rawYears = daysToYears(day), month = round(rawYears * 12), year = round(rawYears);
	    return {
	        millisecond: millisecond,
	        second: second,
	        'second-short': second,
	        minute: minute,
	        'minute-short': minute,
	        hour: hour,
	        'hour-short': hour,
	        day: day,
	        'day-short': day,
	        week: week,
	        'week-short': week,
	        month: month,
	        'month-short': month,
	        year: year,
	        'year-short': year
	    };
	}
	exports.default = default_1;
	//# sourceMappingURL=diff.js.map

/***/ }),
/* 388 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* @generated */
	exports.default = { "locale": "en", "pluralRuleFunction": function (n, ord) {
	        var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
	        if (ord)
	            return (n10 == 1 && n100 != 11) ? 'one'
	                : (n10 == 2 && n100 != 12) ? 'two'
	                    : (n10 == 3 && n100 != 13) ? 'few'
	                        : 'other';
	        return (n == 1 && v0) ? 'one' : 'other';
	    }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "week": { "displayName": "week", "relativePeriod": "the week of {0}", "relative": { "0": "this week", "1": "next week", "-1": "last week" }, "relativeTime": { "future": { "one": "in {0} week", "other": "in {0} weeks" }, "past": { "one": "{0} week ago", "other": "{0} weeks ago" } } }, "week-short": { "displayName": "wk.", "relativePeriod": "the week of {0}", "relative": { "0": "this wk.", "1": "next wk.", "-1": "last wk." }, "relativeTime": { "future": { "one": "in {0} wk.", "other": "in {0} wk." }, "past": { "one": "{0} wk. ago", "other": "{0} wk. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
	//# sourceMappingURL=en.js.map

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	/* jslint esnext: true */
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	var hop = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	var realDefineProp = (function () {
	    try {
	        return !!Object.defineProperty({}, 'a', {});
	    }
	    catch (e) {
	        return false;
	    }
	})();
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	var defineProperty = realDefineProp ? Object.defineProperty :
	    function (obj, name, desc) {
	        if ('get' in desc && obj.__defineGetter__) {
	            obj.__defineGetter__(name, desc.get);
	        }
	        else if (!hop.call(obj, name) || 'value' in desc) {
	            obj[name] = desc.value;
	        }
	    };
	exports.defineProperty = defineProperty;
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	    function F() { }
	    F.prototype = proto;
	    obj = new F();
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	    return obj;
	};
	exports.objCreate = objCreate;
	var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
	    /*jshint validthis:true */
	    var arr = this;
	    if (!arr.length) {
	        return -1;
	    }
	    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
	        if (arr[i] === search) {
	            return i;
	        }
	    }
	    return -1;
	};
	exports.arrIndexOf = arrIndexOf;
	var isArray = Array.isArray || function (obj) {
	    return toString.call(obj) === '[object Array]';
	};
	exports.isArray = isArray;
	var dateNow = Date.now || function () {
	    return new Date().getTime();
	};
	exports.dateNow = dateNow;
	//# sourceMappingURL=es5.js.map

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/* jslint esnext: true */
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(386);
	var en_1 = __webpack_require__(388);
	core_1.default.__addLocaleData(en_1.default);
	core_1.default.defaultLocale = 'en';
	exports.default = core_1.default;
	//# sourceMappingURL=main.js.map

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var alphabetical = __webpack_require__(156)
	var decimal = __webpack_require__(69)
	
	module.exports = alphanumerical
	
	// Check if the given character code, or the character code at the first
	// character, is alphanumerical.
	function alphanumerical(character) {
	  return alphabetical(character) || decimal(character)
	}


/***/ }),
/* 392 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	module.exports = function isBuffer (obj) {
	  return obj != null && obj.constructor != null &&
	    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}


/***/ }),
/* 393 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = hexadecimal
	
	// Check if the given character code, or the character code at the first
	// character, is hexadecimal.
	function hexadecimal(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return (
	    (code >= 97 /* a */ && code <= 102) /* z */ ||
	    (code >= 65 /* A */ && code <= 70) /* Z */ ||
	    (code >= 48 /* A */ && code <= 57) /* Z */
	  )
	}


/***/ }),
/* 394 */
/***/ (function(module, exports) {

	'use strict';
	var toString = Object.prototype.toString;
	
	module.exports = function (x) {
		var prototype;
		return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
	};


/***/ }),
/* 395 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = wordCharacter
	
	var fromCode = String.fromCharCode
	var re = /\w/
	
	// Check if the given character code, or the character code at the first
	// character, is a word character.
	function wordCharacter(character) {
	  return re.test(
	    typeof character === 'number' ? fromCode(character) : character.charAt(0)
	  )
	}


/***/ }),
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */
/***/ (function(module, exports) {

	module.exports = [{"key":"all","excluded":["awesome","you-dont-know-js","airbnb-style-guide","front-end-job-interview-questions"],"count":10},{"key":"framework","count":15},{"key":"nodejs-framework","count":10},{"key":"react","count":10,"excluded":["react"]},{"key":"mobile","count":3},{"key":"compiler","count":10},{"key":"build"},{"key":"test-framework","count":5},{"key":"ide","count":5},{"key":"ssg","count":5}]

/***/ }),
/* 416 */
/***/ (function(module, exports) {

	module.exports = {"date":"2018-01-11T12:14:43.085Z","count":331,"projects":[{"name":"RiotJS","url":"http://riotjs.com","full_name":"riot/riot","description":"Simple and elegant component-based UI library","owner_id":12729373,"tags":["framework","vdom"],"delta":3005,"stars":12675,"created_at":"2013-09-27T05:21:01.000Z","monthly":[163,304,217,283,308,232,208,329,250,208,219,284]},{"name":"Aurelia","url":"http://aurelia.io/","full_name":"aurelia/framework","description":"The aurelia framework brings together all the required core aurelia libraries into a ready-to-go app","owner_id":9808864,"tags":["framework"],"delta":3749,"stars":10346,"created_at":"2014-12-10T19:22:29.000Z","monthly":[270,266,310,340,535,440,339,228,218,265,301,237]},{"name":"Angular 1","url":"https://angularjs.org","full_name":"angular/angular.js","description":"AngularJS - HTML enhanced for web apps!","owner_id":139426,"tags":["framework","angular"],"delta":8530,"stars":57787,"created_at":"2010-01-06T00:34:37.000Z","twitter":"","monthly":[532,575,533,746,717,707,708,714,653,843,829,973],"icon":"angular.svg"},{"name":"Flux","url":"http://facebook.github.io/flux/","full_name":"facebook/flux","description":"Application Architecture for Building User Interfaces","owner_id":69631,"tags":["flux"],"delta":3067,"stars":14712,"created_at":"2014-07-20T23:33:08.000Z","monthly":[166,168,189,181,245,210,247,260,290,353,320,438],"icon":"https://s3-us-west-2.amazonaws.com/svgporn.com/logos/flux.svg"},{"name":"React","url":"https://reactjs.org","full_name":"facebook/react","description":"A declarative, efficient, and flexible JavaScript library for building user interfaces.","owner_id":69631,"tags":["framework","vdom","react"],"delta":22894,"stars":85350,"created_at":"2013-05-24T16:15:54.000Z","twitter":"reactjs","monthly":[1819,2079,2166,2412,1840,1954,1593,1577,1955,2189,1514,1796],"icon":"react.svg"},{"name":"Foundation","url":"http://foundation.zurb.com","full_name":"zurb/foundation-sites","description":"The most advanced responsive front-end framework in the world. Quickly create prototypes and product","owner_id":156122,"tags":["css-lib"],"delta":2536,"stars":26871,"created_at":"2011-10-13T23:05:42.000Z","monthly":[174,159,173,178,205,176,186,215,205,286,280,299]},{"name":"Bootstrap","url":"http://getbootstrap.com","full_name":"twbs/bootstrap","description":"The most popular HTML, CSS, and JavaScript framework for developing responsive, mobile first project","owner_id":2918581,"tags":["css-lib"],"delta":14499,"stars":120175,"created_at":"2011-07-29T21:19:00.000Z","twitter":"getbootstrap","monthly":[1183,1071,1174,1797,1075,1210,1066,1157,1168,1266,966,1366]},{"name":"Ionic","url":"https://ionicframework.com/","full_name":"ionic-team/ionic","description":"Build amazing native and progressive web apps with open web technologies. One app running on everyth","owner_id":3171503,"tags":["mobile"],"delta":6024,"stars":32895,"created_at":"2013-08-20T23:06:02.000Z","twitter":"Ionicframework","monthly":[438,471,444,480,438,459,504,468,488,581,548,705]},{"name":"Sails","url":"https://sailsjs.com","full_name":"balderdashy/sails","description":"Realtime MVC Framework for Node.js","owner_id":1445252,"tags":["nodejs-framework"],"delta":3176,"stars":18239,"created_at":"2012-03-18T19:46:15.000Z","twitter":"sailsjs","monthly":[223,249,214,201,241,234,246,295,290,354,334,295]},{"name":"Keystone","url":"http://www.keystonejs.com","full_name":"keystonejs/keystone","description":"node.js cms and web app framework","owner_id":6118534,"tags":["nodejs-framework","cms"],"delta":3579,"stars":11742,"created_at":"2013-07-02T05:01:55.000Z","twitter":"keystonejs","monthly":[282,321,267,315,318,278,290,293,336,300,290,289]},{"name":"PureCSS","url":"http://purecss.io/","full_name":"yahoo/pure","description":"A set of small, responsive CSS modules that you can use in every web project.","owner_id":16574,"tags":["css-lib"],"delta":2503,"stars":18038,"created_at":"2013-04-22T16:16:39.000Z","monthly":[241,228,144,199,179,243,182,227,161,234,214,251]},{"name":"Phaser","url":"http://phaser.io","full_name":"photonstorm/phaser","description":"Phaser is a fun, free and fast 2D game framework for making HTML5 games for desktop and mobile web b","owner_id":164476,"tags":["game"],"delta":3016,"stars":17110,"created_at":"2013-04-12T12:27:51.000Z","monthly":[224,222,278,204,285,275,220,222,282,299,220,285]},{"name":"Greensock","url":"https://greensock.com","full_name":"greensock/GreenSock-JS","description":"GreenSock's GSAP JavaScript animation library (including Draggable).","owner_id":2386673,"tags":["animation"],"delta":1562,"stars":7042,"created_at":"2012-09-21T18:03:25.000Z","monthly":[84,117,94,125,181,115,137,144,143,135,139,148]},{"name":"SemanticUI","url":"http://www.semantic-ui.com","full_name":"Semantic-Org/Semantic-UI","description":"Semantic is a UI component framework based around useful principles from natural language.","owner_id":5796209,"tags":["css-lib"],"delta":8233,"stars":38935,"created_at":"2013-04-08T23:32:04.000Z","monthly":[709,669,688,740,660,683,618,666,690,835,601,674]},{"name":"Ember","url":"http://www.emberjs.com","full_name":"emberjs/ember.js","description":"Ember.js - A JavaScript framework for creating ambitious web applications","owner_id":1253363,"tags":["framework"],"delta":1932,"stars":18601,"created_at":"2011-05-25T23:39:40.000Z","monthly":[150,146,172,122,177,145,135,153,149,197,182,204]},{"name":"ChartJS","url":"http://www.chartjs.org/","full_name":"chartjs/Chart.js","description":"Simple HTML5 Charts using the <canvas> tag","owner_id":10342521,"tags":["chart","canvas"],"delta":9531,"stars":34450,"created_at":"2013-03-17T23:56:36.000Z","monthly":[588,607,542,616,594,594,753,1350,2668,438,343,438]},{"name":"D3","url":"https://d3js.org","full_name":"d3/d3","description":"Bring data to life with SVG, Canvas and HTML. :bar_chart::chart_with_upwards_trend::tada:","owner_id":1562726,"tags":["chart","d3","svg","canvas"],"delta":13623,"stars":71527,"created_at":"2010-09-27T17:22:42.000Z","twitter":"d3js_org","monthly":[1159,1123,976,1077,1111,1176,1539,1099,1162,1209,1001,991]},{"name":"Backbone","url":"http://backbonejs.org","full_name":"jashkenas/backbone","description":"Give your JS App some Backbone with Models, Views, Collections, and Events","owner_id":4732,"tags":["framework"],"delta":2116,"stars":26927,"created_at":"2010-09-30T19:41:28.000Z","monthly":[118,101,133,138,189,179,177,187,209,240,210,235],"icon":"https://s3-us-west-2.amazonaws.com/svgporn.com/logos/backbone-icon.svg"},{"name":"AngularUI Router","url":"http://ui-router.github.io/","full_name":"angular-ui/ui-router","description":"The de-facto solution to flexible routing with nested views in AngularJS","owner_id":1530011,"tags":["angular","routing"],"delta":3209,"stars":13723,"created_at":"2013-01-18T20:26:29.000Z","monthly":[180,219,229,255,253,219,289,272,308,356,291,338]},{"name":"Material UI","url":"http://www.material-ui.com","full_name":"mui-org/material-ui","description":"React components that implement Google's Material Design.","owner_id":33663932,"tags":["material","react","component"],"delta":9363,"stars":32115,"created_at":"2014-08-18T19:11:54.000Z","twitter":"materialui","monthly":[722,750,761,794,821,796,753,854,879,860,668,705]},{"name":"Polymer","url":"https://www.polymer-project.org/","full_name":"Polymer/polymer","description":"Build modern apps using web components","owner_id":2159051,"tags":["framework"],"delta":2930,"stars":18984,"created_at":"2012-08-23T20:56:30.000Z","monthly":[187,243,249,224,209,218,208,198,235,300,309,350]},{"name":"Restify","url":"http://restify.com","full_name":"restify/node-restify","description":"The future of Node.js REST development","owner_id":6948699,"tags":["api","nodejs-framework"],"delta":1709,"stars":7662,"created_at":"2011-04-25T21:19:26.000Z","monthly":[123,119,143,113,158,121,202,146,128,167,133,156]},{"name":"Express","url":"https://expressjs.com","full_name":"expressjs/express","description":"Fast, unopinionated, minimalist web framework for node.","owner_id":5658226,"tags":["nodejs-framework","express"],"delta":6876,"stars":36006,"created_at":"2009-06-26T18:56:01.000Z","twitter":"expressjs","monthly":[483,582,458,490,559,566,551,618,643,736,655,535]},{"name":"Materialize CSS","url":"http://materializecss.com","full_name":"Dogfalo/materialize","description":"Materialize, a CSS Framework based on Material Design","owner_id":2775751,"tags":["css-lib","material"],"delta":8545,"stars":30871,"created_at":"2014-09-12T19:35:38.000Z","monthly":[626,682,721,664,742,682,660,784,747,725,752,760]},{"name":"Material Angular","url":"https://material.angularjs.org/","full_name":"angular/material","description":"Material design for AngularJS","owner_id":139426,"tags":["angular","material"],"delta":3022,"stars":15971,"created_at":"2014-07-01T19:20:06.000Z","monthly":[120,143,172,237,215,197,255,275,308,373,352,375]},{"name":"Impress","url":"http://impress.github.io/impress.js","full_name":"impress/impress.js","description":"It's a presentation framework based on the power of CSS3 transforms and transitions in modern browse","owner_id":5477410,"tags":["presentation"],"delta":4400,"stars":32927,"created_at":"2011-12-28T22:23:19.000Z","monthly":[235,239,240,249,238,1662,238,236,269,289,259,246]},{"name":"jQuery","url":"https://jquery.com/","full_name":"jquery/jquery","description":"jQuery JavaScript Library","owner_id":70142,"tags":["util","dom"],"delta":5483,"stars":47662,"created_at":"2009-04-03T15:20:14.000Z","monthly":[401,361,453,440,463,539,543,430,435,494,407,517]},{"name":"React Router","url":"https://reacttraining.com/react-router/","full_name":"ReactTraining/react-router","description":"Declarative routing for React","owner_id":11823761,"tags":["react","routing"],"delta":9073,"stars":27448,"created_at":"2014-05-16T22:22:51.000Z","monthly":[647,661,756,1018,753,673,716,709,744,750,685,961]},{"name":"Webpack","url":"https://webpack.js.org","full_name":"webpack/webpack","description":"A bundler for javascript and friends. Packs many modules into a few bundled assets. Code Splitting a","owner_id":2105791,"tags":["build","module"],"delta":11237,"stars":35713,"created_at":"2012-03-10T10:08:14.000Z","monthly":[1020,1095,1208,885,1008,918,856,755,883,892,805,912],"icon":"webpack.svg"},{"name":"Gulp","url":"http://gulpjs.com","full_name":"gulpjs/gulp","description":"The streaming build system","owner_id":6200624,"tags":["build"],"delta":6284,"stars":28419,"created_at":"2013-07-04T05:26:06.000Z","twitter":"gulpjs","monthly":[357,481,489,470,510,547,497,532,573,657,549,622]},{"name":"Grunt","url":"http://gruntjs.com/","full_name":"gruntjs/grunt","description":"Grunt: The JavaScript Task Runner","owner_id":1630826,"tags":["build"],"delta":889,"stars":11702,"created_at":"2011-09-21T15:16:20.000Z","monthly":[70,63,54,39,62,76,64,66,89,100,107,99]},{"name":"Fontawesome","url":"http://fontawesome.io","full_name":"FortAwesome/Font-Awesome","description":"The iconic font and CSS toolkit","owner_id":1505683,"tags":["icon"],"delta":8931,"stars":54182,"created_at":"2012-02-17T14:19:43.000Z","monthly":[715,706,776,859,667,581,584,790,777,898,798,780]},{"name":"Ionicons","url":"http://ionicons.com/","full_name":"ionic-team/ionicons","description":"The premium icon font for Ionic","owner_id":3171503,"tags":["icon"],"delta":2132,"stars":12213,"created_at":"2013-10-10T14:34:18.000Z","monthly":[142,158,195,183,181,190,153,169,168,204,178,211]},{"name":"Reveal","url":"https://revealjs.com","full_name":"hakimel/reveal.js","description":"The HTML Presentation Framework","owner_id":629429,"tags":["presentation"],"delta":6510,"stars":38348,"created_at":"2011-06-07T18:54:22.000Z","monthly":[426,530,536,543,463,564,555,616,638,593,506,540]},{"name":"Select2","url":"https://select2.org/","full_name":"select2/select2","description":"Select2 is a jQuery based replacement for select boxes. It supports searching, remote data sets, and","owner_id":8077542,"tags":["plugin","autocomplete"],"delta":3228,"stars":21730,"created_at":"2012-03-04T18:43:12.000Z","monthly":[238,253,241,259,274,244,272,321,306,298,251,271]},{"name":"RxJS","url":"http://reactivex.io","full_name":"Reactive-Extensions/RxJS","description":"The Reactive Extensions for JavaScript","owner_id":984368,"tags":["fp","stream"],"delta":6556,"stars":18323,"created_at":"2012-01-07T00:31:41.000Z","monthly":[697,681,516,652,456,443,490,531,484,550,521,535]},{"name":"Jasmine","url":"http://jasmine.github.io/","full_name":"jasmine/jasmine","description":"Simple JavaScript testing framework for browsers and node.js","owner_id":4624349,"tags":["test-framework","test"],"delta":1833,"stars":13183,"created_at":"2008-12-02T23:46:37.000Z","monthly":[99,127,113,167,144,162,140,150,183,184,172,192]},{"name":"Mocha","url":"https://mochajs.org","full_name":"mochajs/mocha","description":"☕️ simple, flexible, fun javascript test framework for node.js & the browser","owner_id":8770005,"tags":["test-framework","test"],"delta":2942,"stars":14345,"created_at":"2011-03-07T18:44:25.000Z","monthly":[242,260,215,202,281,279,256,238,203,280,219,267]},{"name":"Jest","url":"http://facebook.github.io/jest/","full_name":"facebook/jest","description":"🃏 Delightful JavaScript Testing.","owner_id":69631,"tags":["test-framework","test"],"delta":3918,"stars":14703,"created_at":"2013-12-10T00:18:04.000Z","twitter":"fbjest","monthly":[792,475,502,929,222,139,153,139,189,166,96,116],"icon":"jest.svg"},{"name":"Sinon.JS","url":"http://sinonjs.org/","full_name":"sinonjs/sinon","description":"Test spies, stubs and mocks for JavaScript.","owner_id":6570253,"tags":["test"],"delta":993,"stars":5266,"created_at":"2010-06-29T21:15:32.000Z"},{"name":"Karma","url":"http://karma-runner.github.io","full_name":"karma-runner/karma","description":"Spectacular Test Runner for JavaScript","owner_id":3284117,"tags":["test"],"delta":1731,"stars":9346,"created_at":"2011-10-12T07:55:46.000Z","monthly":[131,107,104,144,140,151,164,155,142,147,150,196]},{"name":"Zepto","url":"http://zeptojs.com","full_name":"madrobby/zepto","description":"Zepto.js is a minimalist JavaScript library for modern browsers, with a jQuery-compatible API","owner_id":3390,"tags":["dom"],"delta":2039,"stars":13411,"created_at":"2010-09-20T07:57:57.000Z","monthly":[160,153,139,145,209,189,152,186,174,223,126,183]},{"name":"Underscore","url":"http://underscorejs.org","full_name":"jashkenas/underscore","description":"JavaScript's utility _ belt","owner_id":4732,"tags":["util"],"delta":2977,"stars":22152,"created_at":"2009-10-25T18:31:06.000Z","monthly":[201,224,257,221,234,210,230,250,241,302,237,370]},{"name":"Lodash","url":"https://lodash.com/","full_name":"lodash/lodash","description":"A modern JavaScript utility library delivering modularity, performance, & extras.","owner_id":2565403,"tags":["util"],"delta":7987,"stars":28880,"created_at":"2012-04-07T04:11:46.000Z","monthly":[535,610,505,519,588,559,512,568,627,705,627,1632]},{"name":"Koa","url":"http://koajs.com","full_name":"koajs/koa","description":"Expressive middleware for node.js using ES2017 async functions","owner_id":5055057,"tags":["nodejs-framework"],"delta":5012,"stars":19116,"created_at":"2013-07-20T18:53:45.000Z","monthly":[402,380,374,425,466,367,342,436,414,428,387,591]},{"name":"Moment","url":"momentjs.com","full_name":"moment/moment","description":"Parse, validate, manipulate, and display dates in javascript.","owner_id":4129662,"tags":["format","date"],"delta":5264,"stars":35042,"created_at":"2011-03-01T02:46:06.000Z","monthly":[405,416,435,406,483,467,384,471,422,504,373,498]},{"name":"Format.JS","url":"http://formatjs.io/","full_name":"yahoo/react-intl","description":"Internationalize React apps. This library provides React components and an API to format dates, numb","owner_id":16574,"tags":["format","i18n"],"delta":2168,"stars":6451,"created_at":"2014-04-24T17:28:36.000Z","monthly":[154,180,193,181,339,190,181,180,199,132,120,119]},{"name":"Math.JS","url":"mathjs.org","full_name":"josdejong/mathjs","description":"An extensive math library for JavaScript and Node.js","owner_id":568626,"tags":["math"],"delta":1045,"stars":5279,"created_at":"2013-02-15T19:46:01.000Z","monthly":[83,86,100,80,77,66,83,80,81,89,82,138]},{"name":"Metalsmith","url":"http://metalsmith.io","full_name":"segmentio/metalsmith","description":"An extremely simple, pluggable static site generator.","owner_id":819518,"tags":["ssg"],"delta":1218,"stars":6487,"created_at":"2014-02-04T03:46:22.000Z","monthly":[75,52,89,101,120,89,98,97,112,108,151,126]},{"name":"Radium","url":"http://formidable.com/open-source/radium/","full_name":"FormidableLabs/radium","description":"A toolchain for React component styling.","owner_id":5078602,"tags":["css-in-js"],"delta":2243,"stars":5943,"created_at":"2015-01-09T19:35:59.000Z","monthly":[136,127,131,182,239,196,183,171,210,285,191,192]},{"name":"Typeahead","url":"http://twitter.github.com/typeahead.js/","full_name":"twitter/typeahead.js","description":"typeahead.js is a fast and fully-featured autocomplete library","owner_id":50278,"tags":["plugin","autocomplete"],"delta":1940,"stars":14865,"created_at":"2013-02-19T19:45:01.000Z","monthly":[85,107,104,136,163,211,163,170,191,213,188,209]},{"name":"Atom","url":"https://atom.io","full_name":"atom/atom","description":":atom: The hackable text editor","owner_id":1089146,"tags":["ide"],"delta":10102,"stars":42749,"created_at":"2012-01-20T18:18:21.000Z","twitter":"atomeditor","monthly":[733,780,847,797,885,669,787,841,969,1000,817,977]},{"name":"Brackets","url":"http://brackets.io","full_name":"adobe/brackets","description":"An open source code editor for the web, written in JavaScript, HTML and CSS.","owner_id":476009,"tags":["ide"],"delta":2369,"stars":28559,"created_at":"2011-12-07T21:14:40.000Z","twitter":"brackets","monthly":[161,226,173,168,144,176,225,199,174,209,251,263]},{"name":"Chosen","url":"http://harvesthq.github.io/chosen/","full_name":"harvesthq/chosen","description":"Chosen is a library for making long, unwieldy select boxes more friendly.","owner_id":43635,"tags":["plugin"],"delta":1551,"stars":21329,"created_at":"2011-04-18T15:07:41.000Z","monthly":[80,120,120,105,139,117,127,132,137,174,139,161]},{"name":"Hapi","url":"hapijs.com","full_name":"hapijs/hapi","description":"Server Framework  for Node.js","owner_id":3774533,"tags":["nodejs-framework"],"delta":1937,"stars":8924,"created_at":"2011-08-06T00:35:39.000Z","monthly":[146,138,174,164,139,140,149,173,176,172,171,195]},{"name":"Meteor","url":"https://www.meteor.com","full_name":"meteor/meteor","description":"Meteor, the JavaScript App Platform","owner_id":789528,"tags":["fullstack","meteor"],"delta":5352,"stars":38994,"created_at":"2012-01-19T01:58:17.000Z","monthly":[271,327,258,257,394,377,370,405,608,653,705,727]},{"name":"Browserify","url":"http://browserify.org/","full_name":"browserify/browserify","description":"browser-side require() the node.js way","owner_id":6320506,"tags":["build","module"],"delta":1661,"stars":11675,"created_at":"2010-09-22T16:11:32.000Z","monthly":[80,120,127,129,133,141,129,124,143,163,188,184]},{"name":"Loopback","url":"http://loopback.io","full_name":"strongloop/loopback","description":"LoopBack makes it easy to build modern applications that require complex integrations.","owner_id":3020012,"tags":["api","nodejs-framework"],"delta":2480,"stars":10385,"created_at":"2013-04-09T16:02:18.000Z","monthly":[173,191,168,157,197,173,210,209,201,238,306,257]},{"name":"Istanbul","url":"https://gotwarlost.github.io/istanbul/","full_name":"gotwarlost/istanbul","description":"Yet another JS code coverage tool that computes statement, line, function and branch coverage with m","owner_id":1056819,"tags":["test"],"delta":1850,"stars":6903,"created_at":"2012-09-12T06:36:32.000Z","monthly":[101,129,152,140,179,153,172,177,159,160,159,169]},{"name":"Highcharts","url":"www.highcharts.com","full_name":"highcharts/highcharts","description":"Highcharts JS, the JavaScript charting framework","owner_id":15981345,"tags":["chart"],"delta":1274,"stars":7154,"created_at":"2010-06-11T12:23:53.000Z","monthly":[101,92,100,105,106,103,117,126,81,112,113,118]},{"name":"ChartistJS","url":"http://gionkunz.github.io/chartist-js/","full_name":"gionkunz/chartist-js","description":"Simple responsive charts","owner_id":2203704,"tags":["chart"],"delta":1595,"stars":10331,"created_at":"2014-03-09T22:40:07.000Z","monthly":[120,126,116,106,122,121,132,134,130,142,174,172]},{"name":"Immutable","url":"http://facebook.github.io/immutable-js/","full_name":"facebook/immutable-js","description":"Immutable persistent data collections for Javascript which increase efficiency and simplicity.","owner_id":69631,"tags":["data-structure"],"delta":5911,"stars":22041,"created_at":"2014-07-02T06:02:29.000Z","monthly":[493,441,421,447,476,492,477,470,538,575,513,568],"icon":"https://s3-us-west-2.amazonaws.com/svgporn.com/logos/immutable.svg"},{"name":"Bootstrap material","url":"http://fezvrasta.github.io/bootstrap-material-design/","full_name":"FezVrasta/bootstrap-material-design","description":"Material design theme for Bootstrap 3 and 4","owner_id":5382443,"tags":["css-lib","material"],"delta":3515,"stars":18925,"created_at":"2014-08-18T11:54:00.000Z","monthly":[235,203,237,243,271,302,248,315,408,401,317,335]},{"name":"Sheperd","url":"http://github.hubspot.com/shepherd/docs/welcome","full_name":"HubSpot/shepherd","description":"Guide your users through a tour of your app #hubspot-open-source","owner_id":326419,"tags":["presentation"],"delta":1303,"stars":5424,"created_at":"2013-12-17T06:30:27.000Z","monthly":[95,77,106,173,133,130,105,86,86,128,100,84]},{"name":"IntroJS","url":"http://introjs.com","full_name":"usablica/intro.js","description":"A better way for new feature introduction and step-by-step users guide for your website and project.","owner_id":2010360,"tags":["presentation"],"delta":3115,"stars":16186,"created_at":"2013-03-10T15:12:45.000Z","monthly":[91,63,86,190,93,102,99,130,503,1412,166,180]},{"name":"PACE","url":"http://github.hubspot.com/pace/docs/welcome","full_name":"HubSpot/pace","description":"Automatically add a progress bar to your site. #hubspot-open-source","owner_id":326419,"tags":["progress-bar"],"delta":2225,"stars":13083,"created_at":"2013-09-12T04:24:29.000Z","monthly":[189,149,145,159,159,219,174,239,211,227,186,168]},{"name":"Vue.js","url":"http://vuejs.org","full_name":"vuejs/vue","description":"🖖 A progressive, incrementally-adoptable JavaScript framework for building UI on the web.","owner_id":6128107,"tags":["framework","vdom","vue"],"delta":26402,"stars":79318,"created_at":"2013-07-29T03:24:51.000Z","twitter":"vuejs","monthly":[2959,3158,3671,2725,2208,2055,1700,2033,2026,1302,948,1617],"icon":"vue.svg"},{"name":"Web Starter Kit","url":"http://developers.google.com/web/starter-kit","full_name":"google/web-starter-kit","description":"Web Starter Kit - a workflow for multi-device websites","owner_id":1342004,"tags":["html"],"delta":3205,"stars":17924,"created_at":"2014-04-07T08:45:18.000Z","monthly":[238,176,184,227,249,215,387,345,218,318,327,321]},{"name":"HTML5 boilerplate","url":"https://html5boilerplate.com/","full_name":"h5bp/html5-boilerplate","description":"A professional front-end template for building fast, robust, and adaptable web apps or sites.","owner_id":1136800,"tags":["html"],"delta":3913,"stars":39486,"created_at":"2010-01-24T18:03:24.000Z","monthly":[251,278,284,319,331,317,293,338,318,418,323,443]},{"name":"Vex","url":"http://github.hubspot.com/vex/docs/welcome","full_name":"HubSpot/vex","description":"A modern dialog library which is highly configurable and easy to style. #hubspot-open-source","owner_id":326419,"tags":["modal"],"delta":1003,"stars":6429,"created_at":"2013-09-05T23:09:57.000Z","monthly":[56,62,71,79,102,92,89,150,72,116,59,55]},{"name":"Async","url":"http://caolan.github.io/async/","full_name":"caolan/async","description":"Async utilities for node and the browser","owner_id":5274,"tags":["flow"],"delta":4177,"stars":23087,"created_at":"2010-06-01T21:01:30.000Z","monthly":[253,274,288,274,323,341,413,460,384,418,334,415],"icon":"https://caolan.github.io/async/img/async-logo.svg"},{"name":"Skrollr","url":"http://prinzhorn.github.io/skrollr/","full_name":"Prinzhorn/skrollr","description":"Stand-alone parallax scrolling library for mobile (Android + iOS) and desktop. No jQuery. Just plain","owner_id":679144,"tags":["scrolling"],"delta":1740,"stars":17709,"created_at":"2012-03-18T15:41:35.000Z","monthly":[131,122,107,137,139,163,133,182,150,157,173,146]},{"name":"Animate.css","url":"http://daneden.github.io/animate.css","full_name":"daneden/animate.css","description":"🍿 A cross-browser library of CSS animations. As easy to use as an easy thing.","owner_id":439365,"tags":["animation"],"delta":9886,"stars":48199,"created_at":"2011-10-12T10:07:38.000Z","monthly":[651,826,809,815,814,789,740,849,819,1062,801,911]},{"name":"NativeScript","url":"http://www.nativescript.org","full_name":"NativeScript/NativeScript","description":"NativeScript is an open source framework for building truly native mobile apps with JavaScript. Use ","owner_id":7392261,"tags":["mobile"],"delta":3749,"stars":12115,"created_at":"2015-03-01T09:47:08.000Z","twitter":"NativeScript","monthly":[294,313,281,312,281,365,270,416,262,273,342,340]},{"name":"Validator","url":"","full_name":"chriso/validator.js","description":"String validation","owner_id":364903,"tags":["string","validation"],"delta":2183,"stars":9345,"created_at":"2010-10-06T06:58:48.000Z","monthly":[163,183,153,177,225,158,229,147,199,226,169,154]},{"name":"React hot loader","url":"http://gaearon.github.io/react-hot-loader/","full_name":"gaearon/react-hot-loader","description":"Tweak React components in real time.","owner_id":810438,"tags":["react"],"delta":2651,"stars":8022,"created_at":"2014-07-12T23:49:43.000Z","monthly":[197,192,188,218,214,219,239,349,296,198,138,203]},{"name":"Mithril","url":"http://mithril.js.org","full_name":"MithrilJS/mithril.js","description":"A Javascript Framework for Building Brilliant Applications","owner_id":19475707,"tags":["framework","vdom"],"delta":1580,"stars":8287,"created_at":"2014-03-17T01:59:39.000Z","monthly":[67,99,109,84,163,120,90,149,154,164,183,198],"icon":"https://s3-us-west-2.amazonaws.com/svgporn.com/logos/mithril.svg"},{"name":"Fixed datatable","url":"http://facebook.github.io/fixed-data-table/","full_name":"facebookarchive/fixed-data-table","description":"A React table component designed to allow presenting thousands of rows of data.","owner_id":7560860,"tags":["table","react"],"delta":1496,"stars":4294,"created_at":"2015-01-28T04:19:02.000Z","monthly":[110,109,155,107,145,126,121,121,122,136,127,117]},{"name":"Ratchet","url":"http://goratchet.com","full_name":"twbs/ratchet","description":"Build mobile apps with simple HTML, CSS, and JavaScript components. ","owner_id":2918581,"tags":["css-lib","mobile"],"delta":1183,"stars":14261,"created_at":"2012-08-17T05:41:57.000Z","monthly":[52,64,56,111,88,102,80,142,121,142,103,122]},{"name":"Snap.svg","url":"http://snapsvg.io","full_name":"adobe-webplatform/Snap.svg","description":"The JavaScript library for modern SVG graphics.","owner_id":2976699,"tags":["drawing","svg"],"delta":1617,"stars":10814,"created_at":"2013-08-15T20:51:34.000Z","monthly":[134,133,113,147,157,121,135,110,126,175,142,124]},{"name":"Three.js","url":"https://threejs.org/","full_name":"mrdoob/three.js","description":"JavaScript 3D library.","owner_id":97088,"tags":["3d"],"delta":7128,"stars":38334,"created_at":"2010-03-23T18:58:01.000Z","monthly":[639,633,750,609,569,633,597,633,644,570,430,421]},{"name":"Hammer.js","url":"http://hammerjs.github.io","full_name":"hammerjs/hammer.js","description":"A javascript library for multi-touch gestures :// You can touch this","owner_id":7997161,"tags":["touch"],"delta":2458,"stars":17530,"created_at":"2012-03-02T12:58:28.000Z","monthly":[159,187,204,218,237,196,186,212,217,219,209,214]},{"name":"Slick","url":"kenwheeler.github.io/slick","full_name":"kenwheeler/slick","description":"the last carousel you'll ever need","owner_id":286616,"tags":["nav"],"delta":3829,"stars":20422,"created_at":"2014-03-24T02:10:05.000Z","monthly":[223,302,321,273,328,301,303,362,322,388,390,316]},{"name":"Hexo","url":"https://hexo.io","full_name":"hexojs/hexo","description":"A fast, simple & powerful blog framework, powered by Node.js.","owner_id":6375567,"tags":["ssg","blog"],"delta":5879,"stars":20089,"created_at":"2012-09-23T15:17:08.000Z","twitter":"hexojs","monthly":[516,464,446,510,526,449,428,562,559,516,406,497]},{"name":"socket.io","url":"http://socket.io","full_name":"socketio/socket.io","description":"Realtime application framework (Node.JS server)","owner_id":10566080,"tags":["realtime","websocket"],"delta":7675,"stars":38437,"created_at":"2010-03-11T18:24:48.000Z","monthly":[689,617,598,569,602,588,644,601,689,762,622,694]},{"name":"deepstream.io","url":"http://deepstream.io/","full_name":"deepstreamIO/deepstream.io","description":"deepstream.io server","owner_id":9024218,"tags":["realtime"],"delta":3875,"stars":5796,"created_at":"2014-11-09T08:30:01.000Z","monthly":[190,239,214,1480,111,139,34,50,49,102,1184,83]},{"name":"Stylus","url":"http://stylus-lang.com/","full_name":"stylus/stylus","description":"Expressive, robust, feature-rich CSS language built for nodejs","owner_id":10009463,"tags":["css-tool"],"delta":1186,"stars":8772,"created_at":"2010-12-28T22:11:43.000Z","monthly":[113,92,101,77,88,86,90,115,76,101,120,127]},{"name":"autoprefixer","url":"https://twitter.com/autoprefixer","full_name":"postcss/autoprefixer","description":" Parse CSS and add vendor prefixes to rules by Can I Use","owner_id":8296347,"tags":["css-tool"],"delta":3103,"stars":14388,"created_at":"2013-03-14T05:04:51.000Z","monthly":[273,203,243,225,249,261,252,272,285,298,248,294]},{"name":"PurifyCSS","url":"","full_name":"purifycss/purifycss","description":"Remove unused CSS. Also works with single-page apps.","owner_id":12516362,"tags":["css-tool"],"delta":1022,"stars":8009,"created_at":"2015-05-26T02:42:17.000Z","monthly":[90,93,66,159,70,81,111,64,40,40,68,140]},{"name":"Elemental UI","url":"elemental-ui.com","full_name":"elementalui/elemental","description":"A flexible and beautiful UI framework for React.js","owner_id":11880721,"tags":["react","component"],"delta":1232,"stars":3911,"created_at":"2015-04-10T03:02:59.000Z","monthly":[89,82,66,112,102,110,113,99,120,101,114,124]},{"name":"Flexbox","url":"http://flexboxgrid.com","full_name":"kristoferjoseph/flexboxgrid","description":"Grid based on CSS3 flexbox","owner_id":76308,"tags":["css-lib"],"delta":2700,"stars":6888,"created_at":"2013-12-21T23:48:16.000Z","monthly":[192,201,234,192,297,176,227,397,168,230,194,192]},{"name":"Awesome","url":"","full_name":"sindresorhus/awesome","description":":sunglasses: Curated list of awesome lists","owner_id":170270,"tags":["meta"],"delta":23085,"stars":75347,"created_at":"2014-07-11T13:42:37.000Z","monthly":[1863,1599,1865,2173,2187,1899,1502,1534,1501,2140,2384,2438],"icon":"https://s3-us-west-2.amazonaws.com/svgporn.com/logos/awesome.svg"},{"name":"Material Design icons","url":"http://google.github.io/material-design-icons/","full_name":"google/material-design-icons","description":"Material Design icons by Google","owner_id":1342004,"tags":["icon","material"],"delta":6350,"stars":33071,"created_at":"2014-10-08T18:01:28.000Z","monthly":[420,453,491,465,569,431,459,615,508,723,606,610]},{"name":"Redux","url":"http://redux.js.org","full_name":"reactjs/redux","description":"Predictable state container for JavaScript apps","owner_id":6412038,"tags":["flux","redux","state"],"delta":15245,"stars":37158,"created_at":"2015-05-29T23:53:15.000Z","monthly":[932,1099,1115,1171,1186,1120,1244,1295,1280,1525,1540,1738],"icon":"redux.svg"},{"name":"cssnext","url":"http://cssnext.io/","full_name":"MoOx/postcss-cssnext","description":" :cyclone: PostCSS plugin to use tomorrow's CSS syntax, today.","owner_id":157534,"tags":["css-tool"],"delta":1367,"stars":4892,"created_at":"2014-08-01T06:49:41.000Z","monthly":[73,115,85,138,106,139,139,98,108,107,121,138]},{"name":"Amaze UI","url":"http://amazeui.org/","full_name":"amazeui/amazeui","description":"Amaze UI, a mobile-first and modular front-end framework.","owner_id":8945728,"tags":["mobile"],"delta":2191,"stars":11169,"created_at":"2014-08-04T14:23:37.000Z","monthly":[329,285,203,182,128,118,137,134,177,191,109,198]},{"name":"Airbnb Style Guide","url":"","full_name":"airbnb/javascript","description":"JavaScript Style Guide","owner_id":698437,"tags":["learning"],"delta":17052,"stars":64107,"created_at":"2012-11-01T23:13:50.000Z","monthly":[1223,1252,1183,1407,1565,1499,1259,1319,1692,2249,1121,1283]},{"name":"UIkit","url":"http://getuikit.com","full_name":"uikit/uikit","description":"A lightweight and modular front-end framework for developing fast and powerful web interfaces","owner_id":4173184,"tags":["css-lib"],"delta":2068,"stars":11406,"created_at":"2013-07-18T16:00:26.000Z","monthly":[146,265,203,162,156,154,141,170,153,205,133,180]},{"name":"Bootswatch","url":"https://bootswatch.com","full_name":"thomaspark/bootswatch","description":"Themes for Bootstrap","owner_id":900407,"tags":["css-lib"],"delta":1524,"stars":9771,"created_at":"2012-02-07T04:31:56.000Z","monthly":[92,127,105,93,117,144,134,126,197,155,117,117]},{"name":"Dynamic.JS","url":"http://dynamicsjs.com","full_name":"michaelvillar/dynamics.js","description":"Javascript library to create physics-based animations","owner_id":173322,"tags":["animation"],"delta":1152,"stars":6723,"created_at":"2014-02-03T00:17:07.000Z","monthly":[65,73,73,61,93,95,91,86,77,116,185,137]},{"name":"React bootstrap","url":"https://react-bootstrap.github.io/","full_name":"react-bootstrap/react-bootstrap","description":"Bootstrap 3 components built with React","owner_id":6853419,"tags":["react","component"],"delta":3973,"stars":11941,"created_at":"2013-12-27T19:06:07.000Z","monthly":[293,370,323,314,340,351,317,321,382,373,282,307]},{"name":"selectize.js","url":"http://selectize.github.io/selectize.js/","full_name":"selectize/selectize.js","description":"Selectize is the hybrid of a textbox and <select> box. It's jQuery based and it has autocomplete and","owner_id":14022691,"tags":["plugin","autocomplete"],"delta":1803,"stars":10573,"created_at":"2012-08-29T18:31:57.000Z","monthly":[127,107,114,146,168,156,194,127,136,148,187,193]},{"name":"Pixi.js","url":"http://pixijs.com","full_name":"pixijs/pixi.js","description":"The HTML5 Creation Engine: Create beautiful digital content with the fastest, most flexible 2D WebGL","owner_id":5406849,"tags":["game"],"delta":3260,"stars":17177,"created_at":"2013-01-21T22:40:50.000Z","monthly":[389,282,288,288,385,223,268,238,205,260,182,252]},{"name":"JSHint","url":"http://jshint.com","full_name":"jshint/jshint","description":"JSHint is a tool that helps to detect errors and potential problems in your JavaScript code","owner_id":1335450,"tags":["lint"],"delta":1043,"stars":7699,"created_at":"2011-01-19T22:28:53.000Z","monthly":[73,88,74,59,106,89,82,93,88,94,100,97]},{"name":"You Don't Know JS","url":"http://www.kickstarter.com/projects/getify/you-dont-know-js-book-series","full_name":"getify/You-Dont-Know-JS","description":"A book series on JavaScript. @YDKJS on twitter.","owner_id":150330,"tags":["learning","book"],"delta":23253,"stars":73360,"created_at":"2013-11-16T02:37:24.000Z","monthly":[1933,1929,1642,2190,2089,2467,4204,1466,1397,1351,1256,1329],"icon":"js.svg"},{"name":"ESLint","url":"https://eslint.org","full_name":"eslint/eslint","description":"A fully pluggable tool for identifying and reporting on patterns in JavaScript.","owner_id":6019716,"tags":["lint"],"delta":2907,"stars":10031,"created_at":"2013-06-29T23:59:48.000Z","monthly":[211,194,215,232,245,237,203,286,273,273,329,209]},{"name":"Babylon.js","url":"http://www.babylonjs.com","full_name":"BabylonJS/Babylon.js","description":"Babylon.js: a complete JavaScript framework for building 3D games with HTML 5 and WebGL","owner_id":4855800,"tags":["game","3d","webgl"],"delta":1281,"stars":6003,"created_at":"2013-06-27T20:40:42.000Z","monthly":[120,132,101,85,101,126,101,72,85,116,125,117]},{"name":"Spectacle","url":"http://formidable.com/open-source/spectacle/","full_name":"FormidableLabs/spectacle","description":"ReactJS based Presentation Library","owner_id":5078602,"tags":["presentation"],"delta":1848,"stars":5841,"created_at":"2015-06-30T20:36:07.000Z","monthly":[82,103,191,133,140,118,117,168,179,365,93,159]},{"name":"jQueryUI","url":"https://jqueryui.com/","full_name":"jquery/jquery-ui","description":"The official jQuery user interface library.","owner_id":70142,"tags":["plugin","modal","tree"],"delta":548,"stars":10285,"created_at":"2010-01-19T14:40:34.000Z","monthly":[22,30,58,37,44,59,42,61,45,68,34,48]},{"name":"Ramda","url":"http://ramdajs.com","full_name":"ramda/ramda","description":":ram: Practical functional Javascript","owner_id":5298359,"tags":["fp"],"delta":3033,"stars":10602,"created_at":"2013-06-21T20:32:35.000Z","monthly":[257,270,353,227,246,209,215,179,233,417,207,220]},{"name":"Standard","url":"https://standardjs.com","full_name":"standard/standard","description":"🌟 JavaScript Style Guide, with linter & automatic code fixer","owner_id":29208316,"tags":["lint"],"delta":5215,"stars":15698,"created_at":"2015-01-27T01:23:31.000Z","monthly":[442,391,355,407,410,301,699,408,579,302,402,519],"icon":"https://standardjs.com/favicons/apple-touch-icon-180x180.png"},{"name":"request","url":"","full_name":"request/request","description":"🏊🏾 Simplified HTTP request client.","owner_id":730467,"tags":["http"],"delta":4396,"stars":18134,"created_at":"2011-01-23T01:25:14.000Z","monthly":[379,411,374,359,389,363,355,363,367,366,320,350]},{"name":"Axios","url":"","full_name":"axios/axios","description":"Promise based HTTP client for the browser and node.js","owner_id":32372333,"tags":["http"],"delta":9349,"stars":33697,"created_at":"2014-08-18T22:30:27.000Z","monthly":[1656,2471,819,600,608,479,484,536,496,528,329,343]},{"name":"superagent","url":"http://visionmedia.github.com/superagent/","full_name":"visionmedia/superagent","description":"Ajax with less suck - (and node.js HTTP client to match)","owner_id":9285252,"tags":["http"],"delta":3345,"stars":12031,"created_at":"2011-04-13T02:29:45.000Z","monthly":[213,266,233,226,340,261,295,303,255,356,272,325]},{"name":"Bluebird","url":"http://bluebirdjs.com","full_name":"petkaantonov/bluebird","description":":bird: :zap: Bluebird is a full featured promise library with unmatched performance.","owner_id":829734,"tags":["flow"],"delta":3936,"stars":16066,"created_at":"2013-09-07T19:39:57.000Z","monthly":[253,269,300,341,352,297,322,358,362,364,394,324]},{"name":"q","url":"http://documentup.com/kriskowal/q/","full_name":"kriskowal/q","description":"A promise library for JavaScript","owner_id":60294,"tags":["flow"],"delta":2170,"stars":13931,"created_at":"2010-09-04T01:21:12.000Z","monthly":[127,121,140,131,149,177,174,196,208,326,203,218]},{"name":"Material Design Lite","url":"http://getmdl.io","full_name":"google/material-design-lite","description":"Material Design Components in HTML/CSS/JS","owner_id":1342004,"tags":["css-lib","material"],"delta":8146,"stars":29367,"created_at":"2015-01-14T22:01:33.000Z","monthly":[479,549,783,589,607,591,641,656,604,737,770,1140]},{"name":"React Motion","url":"","full_name":"chenglou/react-motion","description":"A spring that solves your animation problems.","owner_id":1909539,"tags":["react","animation"],"delta":4063,"stars":11442,"created_at":"2015-06-11T07:38:23.000Z","monthly":[337,300,312,303,372,285,328,345,373,375,346,387]},{"name":"Dropzone","url":"http://www.dropzonejs.com","full_name":"enyo/dropzone","description":"Dropzone is an easy to use drag'n'drop library. It supports image previews and shows nice progress b","owner_id":133277,"tags":["dnd"],"delta":2270,"stars":13304,"created_at":"2012-02-12T16:19:18.000Z","monthly":[169,165,154,220,250,201,203,197,191,193,157,170]},{"name":"Masonry","url":"http://masonry.desandro.com","full_name":"desandro/masonry","description":":love_hotel: Cascading grid layout library","owner_id":85566,"tags":["layout"],"delta":1927,"stars":12673,"created_at":"2009-11-21T21:04:56.000Z","monthly":[145,136,125,165,162,169,155,174,176,174,174,172]},{"name":"Pug","url":"https://pugjs.org","full_name":"pugjs/pug","description":"Pug – robust, elegant, feature rich template engine for Node.js","owner_id":9338635,"tags":["template"],"delta":3354,"stars":15857,"created_at":"2010-06-23T01:05:42.000Z","monthly":[275,281,282,307,284,288,304,412,323,212,148,238]},{"name":"PostCSS","url":"http://postcss.org/","full_name":"postcss/postcss","description":"Transforming styles with JS plugins","owner_id":8296347,"tags":["css-tool"],"delta":4816,"stars":17165,"created_at":"2013-09-24T23:06:48.000Z","monthly":[353,350,316,417,360,362,386,369,497,458,434,514]},{"name":"Pikaday","url":"http://dbushell.github.io/Pikaday/","full_name":"dbushell/Pikaday","description":"A refreshing JavaScript Datepicker — lightweight, no dependencies, modular CSS","owner_id":998922,"tags":["plugin","date"],"delta":1323,"stars":5812,"created_at":"2012-10-08T07:51:03.000Z","monthly":[77,92,81,98,127,124,121,129,109,126,114,125]},{"name":"NodeBB","url":"https://nodebb.org","full_name":"NodeBB/NodeBB","description":"Node.js based forum software built for the modern web","owner_id":4449608,"tags":["blog"],"delta":1519,"stars":8162,"created_at":"2013-04-22T16:49:40.000Z","monthly":[90,133,86,93,117,89,118,144,132,269,122,126]},{"name":"Ghost","url":"https://ghost.org","full_name":"TryGhost/Ghost","description":"The platform for professional publishers","owner_id":2178663,"tags":["blog"],"delta":3504,"stars":24710,"created_at":"2013-05-04T11:09:13.000Z","monthly":[202,281,255,264,314,290,292,321,313,313,306,353]},{"name":"React-select","url":"http://jedwatson.github.io/react-select/","full_name":"JedWatson/react-select","description":"A Select control built with and for React JS","owner_id":872310,"tags":["autocomplete","react"],"delta":3453,"stars":10009,"created_at":"2014-08-26T04:27:45.000Z","monthly":[251,287,283,319,291,306,308,258,277,268,321,284]},{"name":"Tape","url":"","full_name":"substack/tape","description":"tap-producing test harness for node and browsers","owner_id":12631,"tags":["test-framework","test"],"delta":1659,"stars":4339,"created_at":"2012-11-25T17:08:02.000Z","monthly":[123,108,166,122,119,114,147,128,144,172,142,174]},{"name":"Guide to FP","url":"","full_name":"MostlyAdequate/mostly-adequate-guide","description":"Mostly adequate guide to FP (in javascript)","owner_id":14079115,"tags":["fp","learning","book"],"delta":2868,"stars":12838,"created_at":"2015-05-06T01:44:15.000Z","monthly":[338,244,241,252,229,262,257,196,180,207,185,277]},{"name":"Angular seed","url":"http://angularjs.org/","full_name":"angular/angular-seed","description":"Seed project for angular apps. ","owner_id":139426,"tags":["angular"],"delta":2061,"stars":13198,"created_at":"2010-12-24T06:07:50.000Z","monthly":[90,130,103,146,162,195,195,156,213,259,201,211]},{"name":"Dragula","url":"https://bevacqua.github.io/dragula/","full_name":"bevacqua/dragula","description":":ok_hand: Drag and drop so simple it hurts","owner_id":934293,"tags":["dnd"],"delta":4259,"stars":17066,"created_at":"2015-04-13T21:35:38.000Z","monthly":[727,139,168,149,133,185,181,145,156,271,1603,402]},{"name":"React DnD","url":"http://react-dnd.github.io/react-dnd","full_name":"react-dnd/react-dnd","description":"Drag and Drop for React","owner_id":25307599,"tags":["dnd","react"],"delta":2288,"stars":7465,"created_at":"2014-10-19T13:29:28.000Z","monthly":[193,204,194,191,267,175,178,157,166,232,179,152]},{"name":"Paper.js","url":"http://paperjs.org","full_name":"paperjs/paper.js","description":"The Swiss Army Knife of Vector Graphics Scripting – Scriptographer ported to JavaScript and the brow","owner_id":846856,"tags":["drawing"],"delta":1368,"stars":8679,"created_at":"2011-02-07T18:21:30.000Z","monthly":[111,131,156,98,102,117,99,110,128,106,116,94]},{"name":"Devdocs.io","url":"https://devdocs.io","full_name":"Thibaut/devdocs","description":"API Documentation Browser","owner_id":17579,"tags":["learning"],"delta":3639,"stars":16614,"created_at":"2013-10-24T18:16:07.000Z","monthly":[310,332,411,258,298,246,307,342,261,282,284,308]},{"name":"Video.js","url":"www.videojs.com","full_name":"videojs/video.js","description":"Video.js - open source HTML5 & Flash video player","owner_id":3287189,"tags":["video"],"delta":3440,"stars":18826,"created_at":"2010-05-14T18:45:10.000Z","monthly":[369,309,318,268,345,287,252,268,277,282,226,239]},{"name":"howler.js","url":"https://howlerjs.com","full_name":"goldfire/howler.js","description":"Javascript audio library for the modern web.","owner_id":882005,"tags":["audio"],"delta":3347,"stars":9183,"created_at":"2013-01-28T16:47:12.000Z","monthly":[137,119,139,132,453,1634,146,180,81,101,131,94]},{"name":"FabricJS","url":"http://fabricjs.com","full_name":"kangax/fabric.js","description":"Javascript Canvas Library, SVG-to-Canvas (& canvas-to-SVG) Parser","owner_id":383,"tags":["drawing","svg","canvas"],"delta":1814,"stars":9372,"created_at":"2010-06-09T22:24:38.000Z","monthly":[185,136,159,156,147,154,190,137,139,151,111,149]},{"name":"MUI","url":"https://www.muicss.com","full_name":"muicss/mui","description":"Lightweight CSS framework","owner_id":7343632,"tags":["css-lib","material"],"delta":1340,"stars":3763,"created_at":"2015-02-15T17:30:26.000Z","monthly":[90,200,82,83,90,93,81,101,78,107,101,234]},{"name":"Less","url":"http://lesscss.org","full_name":"less/less.js","description":"Less. The dynamic stylesheet language.","owner_id":3538330,"tags":["css-tool"],"delta":1210,"stars":15322,"created_at":"2010-02-20T17:25:38.000Z","monthly":[111,96,120,79,95,100,77,126,94,84,103,125]},{"name":"nunjucks","url":"https://mozilla.github.io/nunjucks/","full_name":"mozilla/nunjucks","description":"A powerful templating engine with inheritance, asynchronous control, and more (jinja2 inspired)","owner_id":131524,"tags":["template"],"delta":1281,"stars":4859,"created_at":"2012-08-09T05:40:44.000Z","monthly":[107,128,92,102,103,89,132,104,101,99,94,130]},{"name":"Chai","url":"http://chaijs.com","full_name":"chaijs/chai","description":"BDD / TDD assertion framework for node.js and the browser that can be paired with any testing framew","owner_id":1515293,"tags":["test"],"delta":1205,"stars":4934,"created_at":"2011-12-07T08:06:35.000Z","monthly":[91,112,100,87,85,101,124,91,81,115,102,116]},{"name":"Blessed","url":"","full_name":"yaronn/blessed-contrib","description":"Build terminal dashboards using ascii/ansi art and javascript","owner_id":1359037,"tags":["cli","dashboard"],"delta":1663,"stars":10682,"created_at":"2015-01-14T14:18:07.000Z","monthly":[473,74,134,67,202,136,73,157,67,80,97,103]},{"name":"Velocity","url":"VelocityJS.org","full_name":"julianshapiro/velocity","description":"Accelerated JavaScript animation.","owner_id":655026,"tags":["animation"],"delta":2497,"stars":14039,"created_at":"2014-04-09T20:02:38.000Z","monthly":[211,198,195,166,175,188,186,275,220,266,178,239]},{"name":"Johnny-Five","url":"http://johnny-five.io","full_name":"rwaldron/johnny-five","description":"JavaScript Robotics and IoT programming framework, developed at Bocoup.","owner_id":27985,"tags":["iot"],"delta":1999,"stars":8524,"created_at":"2012-03-30T20:09:52.000Z","monthly":[95,117,118,201,144,124,158,162,204,169,296,211]},{"name":"Serverless","url":"http://www.serverless.com","full_name":"serverless/serverless","description":"Serverless Framework – Build web, mobile and IoT applications with serverless architectures using AW","owner_id":13742415,"tags":["microservice"],"delta":7708,"stars":21126,"created_at":"2015-04-21T03:48:40.000Z","monthly":[585,634,1364,701,704,512,536,569,343,537,509,714]},{"name":"Cycle.js","url":"http://cycle.js.org","full_name":"cyclejs/cyclejs","description":"A functional and reactive JavaScript framework for predictable code","owner_id":12686838,"tags":["fp","vdom","framework"],"delta":2896,"stars":7884,"created_at":"2014-11-07T11:28:45.000Z","monthly":[197,215,205,211,240,183,177,192,198,274,280,524]},{"name":"System.js","url":"","full_name":"systemjs/systemjs","description":"Dynamic ES module loader","owner_id":6577368,"tags":["module"],"delta":3133,"stars":8798,"created_at":"2013-05-14T20:45:48.000Z","monthly":[134,187,491,216,188,248,261,308,236,264,254,346]},{"name":"Relay","url":"https://facebook.github.io/relay/","full_name":"facebook/relay","description":"Relay is a JavaScript framework for building data-driven React applications.","owner_id":69631,"tags":["framework","graphql"],"delta":2341,"stars":10268,"created_at":"2015-08-10T22:09:16.000Z","twitter":"","monthly":[160,155,208,208,213,119,158,176,200,263,258,223],"icon":"relay.svg"},{"name":"react-color","url":"http://casesandberg.github.io/react-color/","full_name":"casesandberg/react-color","description":":art: Color Pickers from Sketch, Photoshop, Chrome, Github, Twitter & more","owner_id":4633636,"tags":["react"],"delta":1472,"stars":4580,"created_at":"2015-08-09T18:45:30.000Z","monthly":[93,105,141,584,81,81,105,55,60,58,54,55]},{"name":"Falcor","url":"http://netflix.github.io/falcor","full_name":"Netflix/falcor","description":"A JavaScript library for efficient data fetching","owner_id":913567,"tags":["data"],"delta":1967,"stars":8398,"created_at":"2015-02-13T00:17:50.000Z","monthly":[92,109,144,118,120,84,169,170,232,270,193,266]},{"name":"echarts","url":"http://echarts.baidu.com/","full_name":"ecomfe/echarts","description":"A powerful, interactive charting and visualization library for browser","owner_id":2268460,"tags":["chart"],"delta":6074,"stars":23230,"created_at":"2013-04-03T03:18:59.000Z","monthly":[552,536,388,467,536,466,446,484,446,511,296,946]},{"name":"Leaflet","url":"http://leafletjs.com","full_name":"Leaflet/Leaflet","description":" :leaves: JavaScript library for mobile-friendly interactive maps","owner_id":2854298,"tags":["map"],"delta":4719,"stars":20395,"created_at":"2010-09-22T16:57:44.000Z","monthly":[450,285,630,1137,325,267,235,287,326,303,211,263]},{"name":"sigma.js","url":"http://sigmajs.org","full_name":"jacomyal/sigma.js","description":"A JavaScript library dedicated to graph drawing","owner_id":144846,"tags":["chart"],"delta":1214,"stars":7717,"created_at":"2012-03-11T15:17:40.000Z","monthly":[124,91,65,70,76,74,95,125,106,96,220,72]},{"name":"json-server","url":"","full_name":"typicode/json-server","description":"Get a full fake REST API with zero coding in less than 30 seconds (seriously)","owner_id":5502029,"tags":["api"],"delta":7782,"stars":27996,"created_at":"2013-11-27T13:21:13.000Z","monthly":[537,700,482,390,527,516,428,2820,408,363,254,357]},{"name":"Critical","url":"","full_name":"addyosmani/critical","description":"Extract & Inline Critical-path CSS in HTML pages","owner_id":110953,"tags":["performance"],"delta":1105,"stars":6373,"created_at":"2014-06-28T09:31:42.000Z","monthly":[108,109,98,82,179,84,79,77,63,89,40,97]},{"name":"Cheerio","url":"https://cheerio.js.org/","full_name":"cheeriojs/cheerio","description":"Fast, flexible, and lean implementation of core jQuery designed specifically for the server.","owner_id":7230330,"tags":["parsing"],"delta":3568,"stars":14609,"created_at":"2011-10-09T04:23:20.000Z","monthly":[258,319,279,308,321,290,327,322,294,289,278,283]},{"name":"nock","url":"","full_name":"node-nock/nock","description":"HTTP mocking and expectations library","owner_id":17545810,"tags":["test"],"delta":1482,"stars":5786,"created_at":"2011-09-22T10:08:03.000Z","monthly":[115,118,104,105,129,155,135,141,110,145,97,128]},{"name":"Electron","url":"https://electronjs.org","full_name":"electron/electron","description":"Build cross platform desktop apps with JavaScript, HTML, and CSS","owner_id":13409222,"tags":["desktop"],"delta":18177,"stars":55064,"created_at":"2013-04-12T01:47:36.000Z","twitter":"electronjs","monthly":[1152,1214,1178,1364,1290,1304,1517,3401,1294,1840,1131,1492]},{"name":"x-ray","url":"http://lapwinglabs.com/","full_name":"matthewmueller/x-ray","description":"The next web scraper. See through the <html> noise.","owner_id":170299,"tags":["parsing"],"delta":1687,"stars":4134,"created_at":"2015-02-05T00:34:16.000Z","monthly":[58,69,77,71,103,77,88,90,86,95,113,760]},{"name":"PM2","url":"http://pm2.io/","full_name":"Unitech/pm2","description":"PM2 RE: Production Runtime and Process Manager for Node.js apps with a built-in Load Balancer.","owner_id":757747,"tags":["process"],"delta":5466,"stars":22895,"created_at":"2013-05-21T03:25:25.000Z","monthly":[478,500,476,532,477,437,397,452,396,442,403,476]},{"name":"ACE","url":"https://ace.c9.io","full_name":"ajaxorg/ace","description":"Ace (Ajax.org Cloud9 Editor)","owner_id":168515,"tags":["highlight"],"delta":2153,"stars":16586,"created_at":"2010-10-27T10:43:36.000Z","monthly":[189,155,162,206,220,193,140,189,168,197,157,177]},{"name":"co","url":"","full_name":"tj/co","description":"The ultimate generator based flow-control goodness for nodejs (supports thunks, promises, etc)","owner_id":25254,"tags":["flow"],"delta":2825,"stars":9186,"created_at":"2013-06-06T04:06:16.000Z","monthly":[228,223,230,248,260,254,252,272,216,210,200,232]},{"name":"CodeMirror","url":"http://codemirror.net/","full_name":"codemirror/CodeMirror","description":"In-browser code editor","owner_id":8876537,"tags":["highlight"],"delta":2511,"stars":13616,"created_at":"2011-01-14T13:44:03.000Z","monthly":[253,200,238,198,222,189,183,192,196,214,197,229]},{"name":"TypeScript","url":"http://www.typescriptlang.org","full_name":"Microsoft/TypeScript","description":"TypeScript is a superset of JavaScript that compiles to clean JavaScript output.","owner_id":6154722,"tags":["compiler"],"delta":9423,"stars":29771,"created_at":"2014-06-17T15:28:39.000Z","twitter":"typescriptlang","monthly":[732,846,877,966,805,971,794,685,741,754,601,651],"icon":"typescript.svg"},{"name":"Fullpage.js","url":"http://alvarotrigo.com/fullPage/","full_name":"alvarotrigo/fullPage.js","description":"fullPage plugin by Alvaro Trigo. Create full screen pages fast and simple","owner_id":1706326,"tags":["scrolling"],"delta":4966,"stars":21909,"created_at":"2013-09-20T11:58:29.000Z","monthly":[363,372,306,356,446,407,396,497,505,504,363,451]},{"name":"Babel","url":"https://babeljs.io/","full_name":"babel/babel","description":":tropical_fish: Babel is a compiler for writing next generation JavaScript.","owner_id":9637642,"tags":["compiler"],"delta":6570,"stars":25206,"created_at":"2014-09-28T13:38:23.000Z","twitter":"babeljs","monthly":[483,437,497,484,529,482,484,548,570,660,624,772]},{"name":"CoffeeScript","url":"http://coffeescript.org/","full_name":"jashkenas/coffeescript","description":"Unfancy JavaScript","owner_id":4732,"tags":["compiler"],"delta":1224,"stars":14502,"created_at":"2009-12-18T01:39:53.000Z","twitter":"","monthly":[98,69,74,84,91,83,103,114,124,127,121,136],"icon":"coffeescript.svg"},{"name":"ws","url":"http://einaros.github.io/ws/","full_name":"websockets/ws","description":"Simple to use, blazing fast and thoroughly tested WebSocket client and server for Node.js","owner_id":10721323,"tags":["realtime","websocket"],"delta":1437,"stars":7221,"created_at":"2011-11-09T22:32:45.000Z","monthly":[125,145,117,119,112,130,126,103,108,116,126,110]},{"name":"Tracking.js","url":"http://trackingjs.com","full_name":"eduardolundgren/tracking.js","description":"A modern approach for Computer Vision on the web","owner_id":113087,"tags":["image"],"delta":1008,"stars":5995,"created_at":"2012-06-18T04:39:34.000Z","monthly":[74,94,65,84,75,77,112,87,94,86,72,88]},{"name":"Feathers","url":"https://feathersjs.com","full_name":"feathersjs/feathers","description":"A REST and realtime API layer for modern applications.","owner_id":5321853,"tags":["api","nodejs-framework","realtime"],"delta":4082,"stars":8180,"created_at":"2011-10-19T22:45:16.000Z","twitter":"FeatherJS","monthly":[201,267,180,140,217,131,158,212,428,2032,59,57]},{"name":"Winston","url":"http://github.com/winstonjs/winston","full_name":"winstonjs/winston","description":"A logger for just about everything.","owner_id":9682013,"tags":["log"],"delta":2046,"stars":9171,"created_at":"2010-12-29T18:49:51.000Z","monthly":[156,191,163,165,196,156,214,153,165,164,162,161]},{"name":"StackEdit","url":"https://stackedit.io/","full_name":"benweet/stackedit","description":"In-browser Markdown editor","owner_id":1005257,"tags":["md"],"delta":1816,"stars":10625,"created_at":"2013-03-24T13:46:06.000Z","monthly":[119,156,114,147,176,138,149,133,132,215,162,175]},{"name":"CSS Modules","url":"","full_name":"css-modules/css-modules","description":"Documentation about css-modules","owner_id":12612655,"tags":["css-in-js"],"delta":3407,"stars":8768,"created_at":"2015-05-25T21:54:47.000Z","monthly":[259,302,344,284,286,238,284,302,331,301,216,260]},{"name":"node-inspector","url":"","full_name":"node-inspector/node-inspector","description":"Node.js debugger based on Blink Developer Tools","owner_id":4449877,"tags":["debug"],"delta":2305,"stars":11940,"created_at":"2010-07-17T23:20:19.000Z","monthly":[113,135,143,163,189,224,244,221,192,257,190,234]},{"name":"Modernizr","url":"https://modernizr.com","full_name":"Modernizr/Modernizr","description":"Modernizr is a JavaScript library that detects HTML5 and CSS3 features in the user’s browser.","owner_id":131060,"tags":["compatibility"],"delta":2497,"stars":21868,"created_at":"2009-09-25T20:13:23.000Z","monthly":[169,205,216,236,182,196,174,214,208,251,194,252]},{"name":"React Native","url":"http://facebook.github.io/react-native/","full_name":"facebook/react-native","description":"A framework for building native apps with React.","owner_id":69631,"tags":["mobile","react-native"],"delta":17471,"stars":58274,"created_at":"2015-01-09T18:10:16.000Z","twitter":"reactnative","monthly":[1199,1331,1370,1368,1332,1378,1353,1417,1814,1788,1321,1800]},{"name":"MEAN","url":"http://mean.io","full_name":"linnovate/mean","description":"The MEAN stack uses Mongo, Express, Angular(4) and Node for simple and scalable fullstack js applica","owner_id":307487,"tags":["fullstack"],"delta":1649,"stars":10710,"created_at":"2013-05-22T12:15:47.000Z","monthly":[80,94,65,90,122,130,166,150,169,169,221,193]},{"name":"You might not need jQuery","url":"http://YouMightNotNeedjQuery.com","full_name":"HubSpot/youmightnotneedjquery","description":"A resource for doing things au naturel.","owner_id":326419,"tags":["learning"],"delta":2211,"stars":9752,"created_at":"2014-01-16T00:21:17.000Z","monthly":[160,111,281,158,171,218,158,143,233,192,169,217]},{"name":"FlowChart","url":"http://flowchart.js.org/","full_name":"adrai/flowchart.js","description":"Draws simple SVG flow chart diagrams from textual representation of the diagram","owner_id":1086194,"tags":["chart"],"delta":1149,"stars":4528,"created_at":"2013-07-17T11:25:29.000Z","monthly":[75,78,75,78,74,57,78,82,60,88,108,296]},{"name":"Pomelo","url":"http://pomelo.netease.com","full_name":"NetEase/pomelo","description":"A fast,scalable,distributed game server framework for Node.js.","owner_id":1460597,"tags":["game"],"delta":1420,"stars":8700,"created_at":"2012-09-20T02:37:07.000Z","monthly":[108,100,111,115,126,102,129,124,152,115,104,134]},{"name":"NW.js","url":"https://nwjs.io","full_name":"nwjs/nw.js","description":"Call all Node.js modules directly from DOM/WebWorker and enable a new way of writing applications wi","owner_id":10180421,"tags":["desktop"],"delta":3767,"stars":33070,"created_at":"2012-01-04T06:21:10.000Z","monthly":[296,231,234,289,256,294,183,351,346,377,360,550]},{"name":"clipboard.js","url":"https://clipboardjs.com","full_name":"zenorocha/clipboard.js","description":":scissors: Modern copy to clipboard. No Flash. Just 3kb gzipped :clipboard:","owner_id":398893,"tags":["util"],"delta":5184,"stars":20502,"created_at":"2015-09-18T23:04:55.000Z","monthly":[396,629,784,519,395,341,344,390,355,394,329,308]},{"name":"jimp","url":"","full_name":"oliver-moran/jimp","description":"An image processing library written entirely in JavaScript for Node, with zero external or native de","owner_id":414918,"tags":["image"],"delta":1045,"stars":5115,"created_at":"2014-09-13T22:53:45.000Z","monthly":[106,87,92,94,84,121,80,69,97,70,89,56]},{"name":"Gatsby","url":"https://www.gatsbyjs.org","full_name":"gatsbyjs/gatsby","description":"⚛️📄🚀 Blazing fast static site generator for React","owner_id":12551863,"tags":["ssg","react","graphql"],"delta":4908,"stars":17146,"created_at":"2015-05-21T22:43:05.000Z","twitter":"gatsbyjs","monthly":[382,1042,469,279,385,1310,175,126,182,211,235,112],"icon":"gatsby.svg"},{"name":"React Starter Kit","url":"https://reactstarter.com","full_name":"kriasoft/react-starter-kit","description":"React Starter Kit — isomorphic web app boilerplate (Node.js, Express, GraphQL, React.js, Babel, Post","owner_id":773036,"tags":["react","isomorphic","boilerplate","graphql"],"delta":6306,"stars":16551,"created_at":"2014-04-16T13:08:18.000Z","monthly":[368,489,474,517,613,525,551,571,540,569,516,573]},{"name":"Sharp","url":"http://sharp.dimens.io/","full_name":"lovell/sharp","description":"High performance Node.js image processing, the fastest module to resize JPEG, PNG, WebP and TIFF ima","owner_id":210965,"tags":["image"],"delta":1180,"stars":7102,"created_at":"2013-08-19T20:24:24.000Z","monthly":[113,122,128,110,106,71,71,142,73,87,83,74]},{"name":"Node.js","url":"https://nodejs.org","full_name":"nodejs/node","description":"Node.js JavaScript runtime :sparkles::turtle::rocket::sparkles:","owner_id":9950313,"tags":["node.js"],"delta":11518,"stars":44280,"created_at":"2014-11-26T19:57:11.000Z","twitter":"nodejs","monthly":[881,953,1197,984,950,827,799,949,1087,1034,780,1077]},{"name":"Relax","url":"","full_name":"relax/relax","description":"New generation CMS on top of React, Redux and GraphQL","owner_id":13644940,"tags":["cms"],"delta":3667,"stars":7754,"created_at":"2015-08-31T12:16:25.000Z","monthly":[141,129,177,147,142,131,188,1981,183,126,144,178]},{"name":"Sequelize","url":"http://docs.sequelizejs.com","full_name":"sequelize/sequelize","description":"An easy-to-use multi SQL dialect ORM for Node.js","owner_id":3591786,"tags":["db"],"delta":3046,"stars":12667,"created_at":"2010-07-22T07:11:11.000Z","monthly":[289,246,238,223,269,250,236,271,259,244,235,286]},{"name":"Recompose","url":"","full_name":"acdlite/recompose","description":"A React utility belt for function components and higher-order components.","owner_id":3624098,"tags":["react"],"delta":2539,"stars":8538,"created_at":"2015-10-07T05:54:51.000Z","monthly":[244,212,224,294,267,216,307,166,146,217,135,111]},{"name":"AMP HTML","url":"https://www.ampproject.org","full_name":"ampproject/amphtml","description":"AMP HTML source code, samples, and documentation.  See below for more info.","owner_id":14114390,"tags":["performance"],"delta":4132,"stars":10862,"created_at":"2015-09-01T22:10:53.000Z","monthly":[171,189,260,353,339,222,236,209,253,588,950,362]},{"name":"photon","url":"photonkit.com","full_name":"connors/photon","description":"The fastest way to build beautiful Electron apps using simple HTML and CSS","owner_id":874145,"tags":["desktop"],"delta":2190,"stars":7958,"created_at":"2015-09-28T04:03:26.000Z","monthly":[157,129,145,201,205,169,194,229,136,206,163,256]},{"name":"Synaptic","url":"http://caza.la/synaptic","full_name":"cazala/synaptic","description":"architecture-free neural network library for node.js and the browser","owner_id":2781777,"tags":["neural","ml"],"delta":1536,"stars":5671,"created_at":"2014-09-30T18:07:03.000Z","monthly":[214,129,149,100,135,128,143,202,106,103,63,64]},{"name":"smartcrop.js","url":"http://29a.ch/2014/04/03/smartcrop-content-aware-image-cropping","full_name":"jwagner/smartcrop.js","description":"Content aware image cropping","owner_id":293536,"tags":["image"],"delta":1181,"stars":10148,"created_at":"2014-04-03T14:21:19.000Z","monthly":[39,45,55,53,55,66,78,63,106,104,165,352]},{"name":"Inquirer.js","url":"","full_name":"SBoudrias/Inquirer.js","description":"A collection of common interactive command line user interfaces.","owner_id":923865,"tags":["cli"],"delta":1537,"stars":6010,"created_at":"2013-05-17T01:41:36.000Z","monthly":[115,113,128,128,121,99,100,111,268,110,119,125]},{"name":"Trix","url":"https://trix-editor.org/","full_name":"basecamp/trix","description":"A rich text editor for everyday writing","owner_id":13131,"tags":["rich-text-editor"],"delta":1188,"stars":8297,"created_at":"2013-08-01T22:21:30.000Z","monthly":[39,61,66,70,99,111,93,116,78,80,181,194]},{"name":"Structor","url":"http://helmetrex.com/","full_name":"ipselon/structor","description":"Structor - React UI Builder","owner_id":11865795,"tags":["react"],"delta":1134,"stars":4940,"created_at":"2015-10-17T15:49:40.000Z","monthly":[84,70,46,68,85,85,63,107,97,131,120,178]},{"name":"Nightmare","url":"https://open.segment.com","full_name":"segmentio/nightmare","description":"A high-level browser automation library.","owner_id":819518,"tags":["auto"],"delta":3573,"stars":14543,"created_at":"2014-04-05T22:19:51.000Z","monthly":[371,516,296,217,328,306,277,409,225,214,226,188]},{"name":"Rollup","url":"http://rollupjs.org","full_name":"rollup/rollup","description":"Next-generation ES6 module bundler","owner_id":12554859,"tags":["module","build"],"delta":5159,"stars":11463,"created_at":"2015-05-14T22:26:28.000Z","twitter":"rollupjs","monthly":[324,341,481,610,721,321,340,387,322,452,458,402]},{"name":"Quill","url":"https://quilljs.com","full_name":"quilljs/quill","description":"Quill is a modern WYSIWYG editor built for compatibility and extensibility.","owner_id":7089101,"tags":["rich-text-editor"],"delta":4714,"stars":16176,"created_at":"2012-07-30T23:23:18.000Z","monthly":[224,294,408,2817,179,114,124,122,112,104,111,105]},{"name":"isomorphic-fetch","url":"","full_name":"matthew-andrews/isomorphic-fetch","description":"Isomorphic WHATWG Fetch API, for Node & Browserify","owner_id":825088,"tags":["http","isomorphic"],"delta":2599,"stars":5213,"created_at":"2014-11-07T08:46:13.000Z","monthly":[164,178,153,192,205,186,206,211,255,475,164,210]},{"name":"Mongoose","url":"http://mongoosejs.com","full_name":"Automattic/mongoose","description":"MongoDB object modeling designed to work in an asynchronous environment.","owner_id":887802,"tags":["db"],"delta":2757,"stars":14457,"created_at":"2010-04-06T21:39:05.000Z","monthly":[245,238,228,215,270,214,229,208,223,250,220,217]},{"name":"React toolbox","url":"http://www.react-toolbox.io","full_name":"react-toolbox/react-toolbox","description":"A set of React components implementing Google's Material Design specification with the power of CSS ","owner_id":13482715,"tags":["material","react","component"],"delta":2507,"stars":7520,"created_at":"2015-05-27T15:23:33.000Z","monthly":[236,248,227,286,310,235,185,165,169,175,155,116]},{"name":"Sortable","url":"http://rubaxa.github.io/Sortable/","full_name":"RubaXa/Sortable","description":"Sortable — is a JavaScript library for reorderable drag-and-drop lists on modern browsers and touch ","owner_id":1109562,"tags":["dnd"],"delta":3193,"stars":12303,"created_at":"2013-12-19T10:10:13.000Z","monthly":[251,287,391,272,274,244,264,263,258,254,201,234]},{"name":"AVA","url":"","full_name":"avajs/ava","description":":rocket: Futuristic JavaScript test runner","owner_id":8527916,"tags":["test-framework","test"],"delta":5466,"stars":12419,"created_at":"2014-11-18T17:20:26.000Z","twitter":"ava__js","monthly":[333,321,363,381,450,428,421,408,447,989,604,321]},{"name":"slideout","url":"https://slideout.js.org","full_name":"Mango/slideout","description":"A touch slideout navigation menu for your mobile web apps.","owner_id":5920385,"tags":["nav"],"delta":1116,"stars":7087,"created_at":"2015-02-02T01:05:43.000Z","monthly":[102,89,75,86,76,88,74,79,105,128,141,73]},{"name":"MathJax","url":"http://www.mathjax.org/","full_name":"mathjax/MathJax","description":"Beautiful math in all browsers","owner_id":252187,"tags":["math"],"delta":1057,"stars":4808,"created_at":"2010-08-19T03:28:53.000Z","monthly":[81,85,71,82,89,91,73,107,86,110,107,75]},{"name":"plotly.js","url":"https://plot.ly/javascript/","full_name":"plotly/plotly.js","description":"The open source JavaScript graphing library that powers plotly","owner_id":5997976,"tags":["chart"],"delta":1866,"stars":7433,"created_at":"2015-11-05T23:27:17.000Z","monthly":[99,111,118,171,165,146,176,141,174,183,186,196]},{"name":"mo · js","url":"http://mojs.io/","full_name":"legomushroom/mojs","description":"motion graphics toolbelt for the web","owner_id":1478800,"tags":["animation"],"delta":3826,"stars":12745,"created_at":"2014-06-26T08:49:14.000Z","monthly":[220,437,364,100,274,220,152,168,203,480,938,270]},{"name":"GraphQL","url":"http://facebook.github.io/graphql/","full_name":"facebook/graphql","description":"GraphQL is a query language and execution engine tied to any backend service.","owner_id":69631,"tags":["data","graphql"],"delta":1913,"stars":6977,"created_at":"2015-07-01T01:26:56.000Z","twitter":"graphql","monthly":[175,207,245,183,123,107,148,111,158,184,105,167],"icon":"graphql.svg"},{"name":"Passport","url":"http://passportjs.org","full_name":"jaredhanson/passport","description":"Simple, unobtrusive authentication for Node.js.","owner_id":10355,"tags":["auth"],"delta":2628,"stars":12384,"created_at":"2011-10-08T22:38:32.000Z","monthly":[243,196,187,215,303,198,195,209,222,242,200,218],"icon":"https://s3-us-west-2.amazonaws.com/svgporn.com/logos/passport.svg"},{"name":"VS Code","url":"https://code.visualstudio.com","full_name":"Microsoft/vscode","description":"Visual Studio Code","owner_id":6154722,"tags":["ide"],"delta":11774,"stars":41758,"created_at":"2015-09-03T20:23:38.000Z","twitter":"code","monthly":[1014,1073,984,938,763,775,813,989,1796,983,739,907],"icon":"vscode.svg"},{"name":"headroom.js","url":"http://wicky.nillia.ms/headroom.js/","full_name":"WickyNilliams/headroom.js","description":"Give your pages some headroom. Hide your header until you need it","owner_id":1091390,"tags":["scrolling"],"delta":1116,"stars":9640,"created_at":"2013-08-07T20:42:58.000Z","monthly":[93,99,127,107,127,56,60,84,103,131,53,76]},{"name":"vivus","url":"","full_name":"maxwellito/vivus","description":"JavaScript library to make drawing animation on SVG","owner_id":1097232,"tags":["animation","svg"],"delta":3019,"stars":9683,"created_at":"2014-05-13T22:22:18.000Z","monthly":[179,219,796,132,173,153,164,192,178,192,219,422]},{"name":"virtual-dom","url":"","full_name":"Matt-Esch/virtual-dom","description":"A Virtual DOM and diffing algorithm","owner_id":1058839,"tags":["vdom"],"delta":1949,"stars":8673,"created_at":"2014-01-23T17:12:21.000Z","monthly":[146,142,110,132,120,177,136,171,180,178,268,189]},{"name":"page.js","url":"http://visionmedia.github.com/page.js","full_name":"visionmedia/page.js","description":"Micro client-side router inspired by the Express router","owner_id":9285252,"tags":["routing"],"delta":1256,"stars":5274,"created_at":"2012-04-12T23:33:30.000Z","monthly":[84,88,111,80,122,92,101,108,116,140,96,118]},{"name":"supertest","url":"","full_name":"visionmedia/supertest","description":"Super-agent driven library for testing node.js HTTP servers using a fluent API","owner_id":9285252,"tags":["test"],"delta":1558,"stars":6180,"created_at":"2012-06-27T20:56:12.000Z","monthly":[114,118,115,115,136,169,113,134,145,151,116,132]},{"name":"Solved by Flexbox","url":"https://philipwalton.github.io/solved-by-flexbox/","full_name":"philipwalton/solved-by-flexbox","description":"A showcase of problems once hard or impossible to solve with CSS alone, now made trivially easy with","owner_id":326742,"tags":["learning"],"delta":1995,"stars":10686,"created_at":"2013-08-31T23:04:51.000Z","monthly":[146,150,148,128,173,159,146,130,161,290,202,162]},{"name":"Enzyme","url":"http://airbnb.io/enzyme/","full_name":"airbnb/enzyme","description":"JavaScript Testing utilities for React","owner_id":698437,"tags":["test","react"],"delta":5389,"stars":12262,"created_at":"2015-11-10T21:45:38.000Z","monthly":[331,349,332,367,414,428,394,459,434,1009,470,402]},{"name":"marked","url":"","full_name":"chjj/marked","description":"A markdown parser and compiler. Built for speed.","owner_id":470564,"tags":["md"],"delta":3274,"stars":15037,"created_at":"2011-07-24T13:15:51.000Z","monthly":[283,240,263,237,343,258,207,312,271,295,253,312]},{"name":"Swiper","url":"http://idangero.us/swiper/","full_name":"nolimits4web/Swiper","description":"Most modern mobile touch slider with hardware accelerated transitions","owner_id":999588,"tags":["nav"],"delta":3659,"stars":14887,"created_at":"2012-03-14T19:11:45.000Z","monthly":[334,337,293,270,342,280,277,338,288,347,260,293]},{"name":"Framework7","url":"http://framework7.io","full_name":"framework7io/framework7","description":"Full featured HTML framework for building iOS & Android apps","owner_id":31954178,"tags":["mobile"],"delta":2691,"stars":11527,"created_at":"2014-02-23T12:15:53.000Z","monthly":[190,215,229,247,209,219,218,237,186,252,197,292]},{"name":"react virtualized","url":"http://www.reactvirtualized.com","full_name":"bvaughn/react-virtualized","description":"React components for efficiently rendering large lists and tabular data","owner_id":29597,"tags":["react","scrolling"],"delta":3669,"stars":8413,"created_at":"2015-11-03T00:48:07.000Z","monthly":[279,277,329,260,279,219,316,501,622,113,309,165]},{"name":"ScrollReveal","url":"https://scrollrevealjs.org/","full_name":"jlmakes/scrollreveal","description":"Easy scroll animations for web and mobile browsers.","owner_id":2044842,"tags":["scrolling"],"delta":2741,"stars":14186,"created_at":"2014-01-16T17:37:20.000Z","monthly":[202,208,244,293,222,200,222,183,160,229,218,360]},{"name":"aframe","url":"https://aframe.io/","full_name":"aframevr/aframe","description":":a: web framework for building virtual reality experiences.","owner_id":16024092,"tags":["virtual"],"delta":3358,"stars":7306,"created_at":"2015-09-15T02:04:40.000Z","monthly":[284,240,266,549,366,346,227,201,277,251,150,201]},{"name":"Victory","url":"http://formidable.com/open-source/victory/","full_name":"FormidableLabs/victory","description":"A collection of composable React components for building interactive data visualizations","owner_id":5078602,"tags":["chart","react","d3"],"delta":2875,"stars":5432,"created_at":"2015-07-02T22:36:50.000Z","monthly":[1218,352,117,103,198,63,354,63,75,63,120,149]},{"name":"BrowserSync","url":"http://browsersync.io/","full_name":"BrowserSync/browser-sync","description":"Keep multiple browsers & devices in sync when building websites. http://browsersync.io","owner_id":10654171,"tags":["test"],"delta":2064,"stars":9536,"created_at":"2013-10-12T19:35:45.000Z","monthly":[142,150,133,156,170,135,150,165,197,223,204,239]},{"name":"LocalForage","url":"https://localforage.github.io/localForage","full_name":"localForage/localForage","description":"💾 Offline storage, improved. Wraps IndexedDB, WebSQL, or localStorage using a simple but powerful A","owner_id":18673496,"tags":["offline"],"delta":1915,"stars":10806,"created_at":"2013-10-31T00:10:06.000Z","monthly":[195,177,139,155,197,148,221,162,111,142,142,126]},{"name":"joi","url":"","full_name":"hapijs/joi","description":"Object schema validation","owner_id":3774533,"tags":["json","validation"],"delta":2053,"stars":6798,"created_at":"2012-09-16T16:38:06.000Z","monthly":[198,150,168,158,159,162,133,169,155,170,223,208]},{"name":"SocketCluster","url":"http://socketcluster.io/","full_name":"SocketCluster/socketcluster","description":"Highly scalable realtime framework","owner_id":12481324,"tags":["realtime","websocket"],"delta":1300,"stars":4401,"created_at":"2013-09-23T12:11:47.000Z","monthly":[111,60,56,65,70,64,42,45,69,53,583,82]},{"name":"redux-form","url":"http://redux-form.com","full_name":"erikras/redux-form","description":"A Higher Order Component using react-redux to keep form state in a Redux store","owner_id":4396759,"tags":["form","redux"],"delta":3683,"stars":8577,"created_at":"2015-07-31T16:07:03.000Z","monthly":[303,302,310,349,407,331,311,312,296,283,254,225]},{"name":"React Redux Universal Hot Example","url":"","full_name":"erikras/react-redux-universal-hot-example","description":"A starter boilerplate for a universal webapp using express, react, redux, webpack, and react-transfo","owner_id":4396759,"tags":["boilerplate","react","redux"],"delta":5396,"stars":10783,"created_at":"2015-06-23T16:39:21.000Z","monthly":[322,342,294,312,418,398,448,574,555,617,553,563]},{"name":"Este","url":"","full_name":"este/este","description":"Explore the source code","owner_id":3302034,"tags":["boilerplate","react","redux"],"delta":1974,"stars":5306,"created_at":"2013-02-16T03:30:38.000Z","monthly":[249,152,136,157,179,148,118,212,140,144,178,161]},{"name":"React boilerplate","url":"https://www.reactboilerplate.com","full_name":"react-boilerplate/react-boilerplate","description":":fire: A highly scalable, offline-first foundation with the best developer experience and a focus on","owner_id":25323389,"tags":["boilerplate","react","redux","offline"],"delta":8949,"stars":16657,"created_at":"2015-02-18T14:36:32.000Z","monthly":[532,536,478,675,473,523,843,3562,170,276,178,703]},{"name":"Milligram","url":"https://milligram.io","full_name":"milligram/milligram","description":"A minimalist CSS framework.","owner_id":16243913,"tags":["css-lib"],"delta":4471,"stars":6784,"created_at":"2015-12-10T17:03:36.000Z","monthly":[147,248,91,78,129,138,114,98,141,167,359,2761]},{"name":"Skeleton","url":"http://www.getskeleton.com","full_name":"dhg/Skeleton","description":"Skeleton: A Dead Simple, Responsive Boilerplate for Mobile-Friendly Development","owner_id":693790,"tags":["css-lib"],"delta":2686,"stars":15122,"created_at":"2011-04-30T20:04:24.000Z","monthly":[224,175,202,203,182,193,224,269,217,230,269,298]},{"name":"Highlight.js","url":"https://highlightjs.org/","full_name":"isagalaev/highlight.js","description":"Javascript syntax highlighter","owner_id":99931,"tags":["highlight"],"delta":2256,"stars":11418,"created_at":"2011-01-01T23:47:21.000Z","monthly":[175,209,170,187,207,150,171,227,171,238,149,202]},{"name":"jsonwebtoken","url":"","full_name":"auth0/node-jsonwebtoken","description":"JsonWebToken implementation for node.js http://self-issued.info/docs/draft-ietf-oauth-json-web-token","owner_id":2824157,"tags":["auth"],"delta":1966,"stars":6584,"created_at":"2013-07-01T01:28:43.000Z","monthly":[158,178,163,155,158,203,192,155,193,146,151,114]},{"name":"Nodal","url":"http://www.nodaljs.com/","full_name":"keithwhor/nodal","description":"API Services Made Easy With Node.js","owner_id":3936867,"tags":["nodejs-framework"],"delta":2670,"stars":4523,"created_at":"2015-04-19T06:34:05.000Z","monthly":[84,47,30,56,101,256,192,338,230,268,275,793],"icon":"https://s3-us-west-2.amazonaws.com/svgporn.com/logos/nodal.svg"},{"name":"VerbalExpressions","url":"","full_name":"VerbalExpressions/JSVerbalExpressions","description":"JavaScript Regular expressions made easy","owner_id":5083777,"tags":["regexp"],"delta":1893,"stars":10333,"created_at":"2013-07-19T14:59:46.000Z","monthly":[1,27,32,40,95,77,42,78,52,78,171,1200]},{"name":"es6-promise","url":"","full_name":"stefanpenner/es6-promise","description":"A polyfill for ES6-style Promises","owner_id":1377,"tags":["flow"],"delta":1417,"stars":5308,"created_at":"2013-12-09T12:04:03.000Z","monthly":[137,131,124,99,118,108,105,107,140,141,120,87]},{"name":"Feature.js","url":"http://featurejs.com/","full_name":"viljamis/feature.js","description":"Feature.js is a fast, simple and lightweight browser feature detection library in 1kb.","owner_id":671836,"tags":["compatibility"],"delta":1451,"stars":3014,"created_at":"2016-01-09T16:38:47.000Z","monthly":[28,45,4,10,16,14,50,34,18,65,310,857]},{"name":"React Slingshot","url":"","full_name":"coryhouse/react-slingshot","description":"React + Redux starter kit / boilerplate with Babel, hot reloading, testing, linting and a working ex","owner_id":1688997,"tags":["boilerplate","react","redux"],"delta":3655,"stars":7983,"created_at":"2015-12-31T22:04:53.000Z","monthly":[317,244,275,279,309,289,361,316,227,338,423,277]},{"name":"Inferno","url":"http://infernojs.org","full_name":"infernojs/inferno","description":"An extremely fast, React-like JavaScript library for building modern user interfaces","owner_id":14214240,"tags":["vdom","framework"],"delta":6873,"stars":12025,"created_at":"2015-02-01T22:07:38.000Z","twitter":"inferno_js","monthly":[2445,652,217,1122,127,453,1468,48,114,52,95,80]},{"name":"Preact","url":"https://preactjs.com","full_name":"developit/preact","description":"⚛️ Fast 3kB React alternative with the same modern API. Components & Virtual DOM.","owner_id":105127,"tags":["vdom","framework"],"delta":5185,"stars":17096,"created_at":"2015-09-11T02:40:18.000Z","twitter":"preactjs","monthly":[1029,924,630,251,351,264,352,286,172,173,521,232],"icon":"preact.svg"},{"name":"Medium editor","url":"https://yabwe.github.io/medium-editor/","full_name":"yabwe/medium-editor","description":"Medium.com WYSIWYG editor clone. Uses contenteditable API to implement a rich text solution.","owner_id":12655868,"tags":["rich-text-editor"],"delta":2930,"stars":11605,"created_at":"2013-05-29T17:40:11.000Z","monthly":[208,174,164,165,202,146,171,290,179,199,872,160]},{"name":"Hint.css","url":"https://kushagragour.in/lab/hint/","full_name":"chinchang/hint.css","description":"A CSS only tooltip library for your lovely websites.","owner_id":379918,"tags":["tooltip"],"delta":2392,"stars":7528,"created_at":"2012-12-30T20:17:34.000Z","monthly":[53,32,51,148,155,64,104,139,59,168,1385,34]},{"name":"Bulma","url":"https://bulma.io","full_name":"jgthms/bulma","description":"Modern CSS framework based on Flexbox","owner_id":1254808,"tags":["css-lib"],"delta":10411,"stars":23365,"created_at":"2016-01-23T23:48:34.000Z","monthly":[757,588,564,437,1099,796,288,317,340,465,3900,860]},{"name":"micro","url":"https://zeit.co/blog/micro-8","full_name":"zeit/micro","description":"Asynchronous HTTP microservices","owner_id":14985020,"tags":["microservice"],"delta":1942,"stars":5729,"created_at":"2016-01-23T05:17:00.000Z","monthly":[176,80,116,83,198,115,344,54,205,187,384]},{"name":"mjml","url":"https://mjml.io","full_name":"mjmlio/mjml","description":"MJML: the only framework that makes responsive-email easy","owner_id":16115896,"tags":["email"],"delta":3515,"stars":6116,"created_at":"2016-01-28T14:04:05.000Z","monthly":[269,109,59,86,128,136,117,128,124,320,2039]},{"name":"Vorpal","url":"http://vorpal.js.org","full_name":"dthree/vorpal","description":"Node's framework for interactive CLIs","owner_id":10319897,"tags":["cli"],"delta":2143,"stars":4369,"created_at":"2015-08-23T17:08:20.000Z","monthly":[43,74,50,46,67,63,72,62,82,470,1114]},{"name":"Nodemailer","url":"http://nodemailer.com/","full_name":"nodemailer/nodemailer","description":"✉️ Send e-mails with Node.JS – easy as cake!","owner_id":16486629,"tags":["email"],"delta":1673,"stars":8854,"created_at":"2011-01-19T21:17:36.000Z","monthly":[164,144,138,135,163,185,142,152,173,160,117]},{"name":"Recharts","url":"http://recharts.org","full_name":"recharts/recharts","description":"Redefined chart library built with React and D3","owner_id":13690587,"tags":["chart","react","d3","svg"],"delta":4222,"stars":7656,"created_at":"2015-08-07T06:50:27.000Z","monthly":[300,292,239,349,2528,42,61,76,225,35,75]},{"name":"GrapeJS","url":"http://grapesjs.com","full_name":"artf/grapesjs","description":"Free and Open source Web Builder Framework. Next generation tool for building templates without codi","owner_id":11614725,"tags":["rich-text-editor"],"delta":1101,"stars":3091,"created_at":"2016-01-22T00:23:19.000Z","monthly":[141,9,22,27,17,13,22,19,31,86,714]},{"name":"Mermaid","url":"http://knsv.github.io/mermaid/","full_name":"knsv/mermaid","description":"Generation of diagram and flowchart from text in a similar manner as markdown","owner_id":5837277,"tags":["chart","d3"],"delta":1877,"stars":15007,"created_at":"2014-11-01T23:52:32.000Z","monthly":[201,207,181,161,184,207,165,228,123,149,71]},{"name":"bricks.js","url":"http://callmecavs.com/bricks.js/","full_name":"callmecavs/bricks.js","description":"A blazing fast masonry layout generator for fixed width elements.","owner_id":2293641,"tags":["layout"],"delta":2865,"stars":3985,"created_at":"2015-12-09T22:16:21.000Z","monthly":[40,13,38,47,49,78,41,42,64,596,1857]},{"name":"MERN Starter","url":"http://mern.io","full_name":"Hashnode/mern-starter","description":"Boilerplate for getting started with MERN stack","owner_id":16342708,"tags":["boilerplate","redux","fullstack","react"],"delta":2225,"stars":4314,"created_at":"2016-01-29T14:40:26.000Z","monthly":[206,123,141,98,130,170,206,152,112,245,642]},{"name":"okayNav","url":"","full_name":"VPenkov/okayNav","description":"The world's okayest responsive navigation. This is (sort of) a legacy implementation. Please stay tu","owner_id":1693651,"tags":["nav"],"delta":2269,"stars":4127,"created_at":"2016-02-15T17:12:47.000Z","monthly":[11,41,17,16,11,30,30,97,178,730,1108]},{"name":"Draft.js","url":"https://draftjs.org/","full_name":"facebook/draft-js","description":"A React framework for building text editors.","owner_id":69631,"tags":["rich-text-editor"],"delta":5057,"stars":11834,"created_at":"2016-02-19T20:18:26.000Z","monthly":[432,285,240,304,254,351,239,293,369,1030,1260]},{"name":"Substance","url":"http://substance.io","full_name":"substance/substance","description":"A JavaScript library for web-based content editing.","owner_id":1441591,"tags":["rich-text-editor"],"delta":1351,"stars":2351,"created_at":"2015-08-20T16:03:09.000Z","monthly":[67,37,52,51,39,28,41,25,47,843,121]},{"name":"Adonis","url":"http://adonisjs.com","full_name":"adonisjs/adonis-framework","description":"NodeJs Web Application Framework. Makes it easy for you to write webapps with less code :smiley:","owner_id":13810373,"tags":["nodejs-framework"],"delta":1036,"stars":3394,"created_at":"2015-08-15T17:03:54.000Z","twitter":"adonisframework","monthly":[75,135,115,227,123,54,70,51,76,110]},{"name":"rebass","url":"http://jxnblk.com/rebass","full_name":"jxnblk/rebass","description":"Functional React UI component library, built with styled-components","owner_id":3451712,"tags":["react","component"],"delta":1100,"stars":3351,"created_at":"2015-02-11T14:48:09.000Z","monthly":[89,74,130,106,77,108,72,67,169,208]},{"name":"Tachyons","url":"http://tachyons.io","full_name":"tachyons-css/tachyons","description":"Functional css for humans","owner_id":15205635,"tags":["css-lib"],"delta":2296,"stars":6141,"created_at":"2013-11-04T10:41:59.000Z","monthly":[228,345,288,329,233,159,148,323,226,17]},{"name":"Handlebars.js","url":"http://handlebarsjs.com","full_name":"wycats/handlebars.js","description":"Handlebars provides the power necessary to let you build semantic templates effectively with no frus","owner_id":4,"tags":["template"],"delta":1251,"stars":12826,"created_at":"2010-07-31T18:54:46.000Z","monthly":[116,135,114,128,165,129,141,136,187,0]},{"name":"Popper.js","url":"https://popper.js.org","full_name":"FezVrasta/popper.js","description":"A kickass library to manage your poppers","owner_id":5382443,"tags":["tooltip"],"delta":2112,"stars":7251,"created_at":"2016-03-29T17:00:47.000Z","monthly":[179,35,34,57,48,30,73,146,1510]},{"name":"mobx","url":"http://mobx.js.org","full_name":"mobxjs/mobx","description":"Simple, scalable state management.","owner_id":17475736,"tags":["state"],"delta":5203,"stars":12768,"created_at":"2015-03-14T14:31:38.000Z","monthly":[616,565,597,569,741,481,690,551,393]},{"name":"bricklayer","url":"http://bricklayer.js.org","full_name":"ademilter/bricklayer","description":"Lightweight and independent Pinterest-like cascading grid layout library","owner_id":187922,"tags":["layout"],"delta":1600,"stars":2273,"created_at":"2016-04-08T21:59:15.000Z","monthly":[46,16,21,11,35,26,54,258,1133]},{"name":"uWebSockets","url":"https://gitter.im/uWebSockets-chat/","full_name":"uNetworking/uWebSockets","description":"Tiny WebSockets","owner_id":28876608,"tags":["realtime","websocket"],"delta":3984,"stars":8358,"created_at":"2016-03-21T04:39:40.000Z","monthly":[424,603,974,752,163,39,120,814,95]},{"name":"mustache.js","url":"http://mustache.github.com/","full_name":"janl/mustache.js","description":"Minimal templating with {{mustaches}} in JavaScript","owner_id":11321,"tags":["template"],"delta":993,"stars":11566,"created_at":"2009-10-04T23:41:19.000Z","monthly":[106,139,126,115,156,108,127,116]},{"name":"Nightwatch","url":"http://nightwatchjs.org","full_name":"nightwatchjs/nightwatch","description":"Automated testing and continous integration framework based on node.js and selenium webdriver","owner_id":12559275,"tags":["auto"],"delta":1372,"stars":7641,"created_at":"2012-03-17T21:28:18.000Z","monthly":[157,140,217,151,218,171,157,161]},{"name":"jsdom","url":"","full_name":"tmpvar/jsdom","description":"A JavaScript implementation of the WHATWG DOM and HTML standards, for use with node.js","owner_id":46673,"tags":["test"],"delta":1149,"stars":9004,"created_at":"2010-01-19T06:55:19.000Z","monthly":[155,139,146,138,118,149,189,115]},{"name":"Web Fundamentals","url":"https://developers.google.com/web/fundamentals","full_name":"google/WebFundamentals","description":"Best practices for modern web development","owner_id":1342004,"tags":["learning"],"delta":1164,"stars":8259,"created_at":"2014-04-28T18:45:45.000Z","monthly":[90,86,127,165,144,224,184,144]},{"name":"nodemon","url":"http://nodemon.io/","full_name":"remy/nodemon","description":"Monitor for any changes in your node.js application and automatically restart the server - perfect f","owner_id":13700,"tags":["process"],"delta":1948,"stars":13191,"created_at":"2010-10-03T12:50:52.000Z","monthly":[224,236,263,240,273,264,249,199]},{"name":"Plyr","url":"http://plyr.io","full_name":"sampotts/plyr","description":"A simple HTML5, YouTube and Vimeo player","owner_id":719092,"tags":["video"],"delta":2957,"stars":10427,"created_at":"2015-02-14T11:33:07.000Z","monthly":[184,109,94,100,125,217,546,1582]},{"name":"Horizon","url":"https://horizon.io","full_name":"rethinkdb/horizon","description":"Horizon is a realtime, open-source backend for JavaScript apps.","owner_id":1229647,"tags":["realtime"],"delta":3911,"stars":6720,"created_at":"2015-10-28T05:33:14.000Z","monthly":[88,99,239,248,392,351,597,1897]},{"name":"PouchDB","url":"https://pouchdb.com/","full_name":"pouchdb/pouchdb","description":":koala: - PouchDB is a pocket-sized database.","owner_id":3406112,"tags":["realtime","db"],"delta":1761,"stars":9945,"created_at":"2010-06-10T18:34:24.000Z","monthly":[677,140,172,245,177,129,164,57]},{"name":"date-fns","url":"https://date-fns.org","full_name":"date-fns/date-fns","description":"⏳ Modern JavaScript date utility library ⌛️","owner_id":14921202,"tags":["date"],"delta":3261,"stars":8639,"created_at":"2014-10-06T10:24:22.000Z","monthly":[2749,43,38,23,51,68,59,230]},{"name":"Picnic CSS","url":"http://picnicss.com/","full_name":"franciscop/picnic","description":":handbag: A beautiful CSS library to kickstart your projects","owner_id":2801252,"tags":["css-lib"],"delta":1014,"stars":2502,"created_at":"2014-09-03T17:49:15.000Z","monthly":[55,28,11,49,27,97,731,16]},{"name":"Push","url":"https://pushjs.org","full_name":"Nickersoft/push.js","description":"The world's most versatile desktop notifications framework :earth_americas:","owner_id":2104129,"tags":["notify"],"delta":2774,"stars":7066,"created_at":"2015-07-20T01:46:04.000Z","monthly":[122,84,75,166,355,111,436,1425]},{"name":"bideo","url":"https://rishabhp.github.io/bideo.js/","full_name":"rishabhp/bideo.js","description":"Fullscreen HTML5 Background Video for the Web.","owner_id":933948,"tags":["video"],"delta":1808,"stars":3538,"created_at":"2016-05-16T05:05:42.000Z","monthly":[235,25,33,65,52,74,454,870]},{"name":"Spectre.css","url":"https://picturepan2.github.io/spectre/","full_name":"picturepan2/spectre","description":"Spectre.css - a Lightweight, Responsive and Modern CSS Framework","owner_id":126385,"tags":["css-lib"],"delta":1093,"stars":5518,"created_at":"2016-03-07T11:53:15.000Z","monthly":[49,59,96,128,82,72,166,441]},{"name":"forever","url":"http://github.com/foreverjs/forever","full_name":"foreverjs/forever","description":"A simple CLI tool for ensuring that a given script runs continuously (i.e. forever)","owner_id":10152066,"tags":["process"],"delta":1072,"stars":10645,"created_at":"2010-09-27T15:47:23.000Z","monthly":[145,144,146,150,147,144,170,26]},{"name":"redux-actions","url":"","full_name":"reduxactions/redux-actions","description":"Flux Standard Action utilities for Redux.","owner_id":30840905,"tags":["redux"],"delta":1127,"stars":4396,"created_at":"2015-07-01T21:08:45.000Z","monthly":[159,152,152,154,165,184,147,14]},{"name":"redux-saga","url":"https://redux-saga.js.org/","full_name":"redux-saga/redux-saga","description":"An alternative side effect model for Redux apps","owner_id":24776643,"tags":["redux"],"delta":3097,"stars":11413,"created_at":"2015-11-29T16:58:12.000Z","monthly":[422,439,415,462,409,484,436,30]},{"name":"Deco IDE","url":"https://www.decosoftware.com/","full_name":"decosoftware/deco-ide","description":"The React Native IDE","owner_id":14793641,"tags":["ide"],"delta":1141,"stars":5463,"created_at":"2016-05-19T21:29:00.000Z","monthly":[76,112,84,124,161,176,408]},{"name":"barba.js","url":"http://barbajs.org","full_name":"luruke/barba.js","description":"Create badass, fluid and smooth transition between your website's pages.","owner_id":61326,"tags":["nav"],"delta":2490,"stars":5835,"created_at":"2015-11-12T20:08:53.000Z","monthly":[46,69,49,58,118,574,1576]},{"name":"PhantomJS","url":"http://phantomjs.org","full_name":"ariya/phantomjs","description":"Scriptable Headless WebKit","owner_id":7288,"tags":["auto"],"delta":2184,"stars":24262,"created_at":"2010-12-27T08:18:58.000Z","monthly":[271,361,329,289,331,353,250]},{"name":"Choo","url":"https://choo.io/","full_name":"choojs/choo","description":":steam_locomotive::train: - sturdy 4kb frontend framework","owner_id":29929674,"tags":["framework"],"delta":1908,"stars":4940,"created_at":"2016-05-10T17:50:35.000Z","monthly":[123,256,148,166,271,688,256]},{"name":"Algolia Places","url":"https://community.algolia.com/places/","full_name":"algolia/places","description":":globe_with_meridians: Turn any <input> into an address autocomplete","owner_id":2034458,"tags":["map","autocomplete"],"delta":1176,"stars":4213,"created_at":"2016-03-22T09:01:46.000Z","monthly":[176,48,36,82,106,436,292]},{"name":"flatpickr","url":"https://chmln.github.io/flatpickr","full_name":"chmln/flatpickr","description":"lightweight and powerful datetimepicker with no dependencies","owner_id":11352152,"tags":["plugin","date"],"delta":2613,"stars":9285,"created_at":"2015-08-10T23:52:45.000Z","monthly":[324,117,125,179,331,604,933]},{"name":"anime.js","url":"http://animejs.com","full_name":"juliangarnier/anime","description":"JavaScript Animation Engine","owner_id":1268691,"tags":["animation"],"delta":7069,"stars":18014,"created_at":"2016-03-13T21:37:45.000Z","monthly":[471,402,687,385,355,3003,1766]},{"name":"NativeBase","url":"https://nativebase.io/","full_name":"GeekyAnts/NativeBase","description":"Essential cross-platform UI components for React Native","owner_id":18482943,"tags":["react-native","mobile"],"delta":1646,"stars":7270,"created_at":"2016-04-15T11:37:23.000Z","monthly":[279,309,247,291,236,284]},{"name":"ZingTouch","url":"https://zingchart.github.io/zingtouch/","full_name":"zingchart/zingtouch","description":"A JavaScript touch gesture detection library for the modern web","owner_id":1650175,"tags":["touch"],"delta":1170,"stars":1567,"created_at":"2016-03-15T20:49:25.000Z","monthly":[15,39,-61,20,85,1072]},{"name":"Node-tap","url":"http://www.node-tap.org/","full_name":"tapjs/node-tap","description":"Test Anything Protocol tools for node","owner_id":16528145,"tags":["test-framework","test"],"delta":63,"stars":1152,"created_at":"2011-03-21T18:02:54.000Z"},{"name":"You Don't Need JavaScript","url":"","full_name":"you-dont-need/You-Dont-Need-JavaScript","description":"CSS is powerful, you can do a lot of things without JS.","owner_id":21141794,"tags":["learning"],"delta":2738,"stars":9623,"created_at":"2016-07-05T07:30:42.000Z","monthly":[146,487,180,193,625,1107]},{"name":"Slate","url":"http://slatejs.org","full_name":"ianstormtaylor/slate","description":"A completely customizable framework for building rich text editors.","owner_id":311752,"tags":["rich-text-editor"],"delta":1644,"stars":6347,"created_at":"2016-06-18T01:52:42.000Z","monthly":[56,83,60,124,240,1081]},{"name":"Hyper","url":"https://hyper.is","full_name":"zeit/hyper","description":"A terminal built on web technologies","owner_id":14985020,"tags":["cli"],"delta":9311,"stars":20633,"created_at":"2016-07-01T06:01:21.000Z","monthly":[3234,665,905,581,1293,2633]},{"name":"cleave.js","url":"http://nosir.github.io/cleave.js","full_name":"nosir/cleave.js","description":"Format input text content when you are typing...","owner_id":352617,"tags":["plugin"],"delta":3046,"stars":7782,"created_at":"2016-05-18T12:45:03.000Z","monthly":[441,96,122,268,638,1481]},{"name":"lightgallery.js","url":"https://sachinchoolur.github.io/lightgallery.js/","full_name":"sachinchoolur/lightgallery.js","description":"Full featured JavaScript image & video gallery. No dependencies","owner_id":6586706,"tags":["viewer"],"delta":2366,"stars":3741,"created_at":"2016-08-01T04:19:56.000Z","monthly":[166,32,45,186,1937]},{"name":"Create React App","url":"","full_name":"facebookincubator/create-react-app","description":"Create React apps with no build configuration.","owner_id":19538647,"tags":["boilerplate","react"],"delta":9536,"stars":40707,"created_at":"2016-07-17T14:55:11.000Z","monthly":[1786,1682,2102,2395,1571]},{"name":"React Server","url":"https://react-server.io/","full_name":"redfin/react-server","description":":rocket: Blazing fast page load and seamless navigation.","owner_id":6288468,"tags":["boilerplate","isomorphic","react"],"delta":2745,"stars":3508,"created_at":"2016-02-09T19:20:35.000Z","monthly":[38,56,113,101,155,2282]},{"name":"Bytesize Icons","url":"http://danklammer.com/bytesize-icons/","full_name":"danklammer/bytesize-icons","description":"Tiny style-controlled SVG iconset (94 icons, 10kb)","owner_id":1743221,"tags":["icon"],"delta":1250,"stars":2510,"created_at":"2015-07-15T08:51:51.000Z","monthly":[46,42,66,261,835]},{"name":"in-view","url":"https://camwiegert.github.io/in-view","full_name":"camwiegert/in-view","description":"Get notified when a DOM element enters or exits the viewport. :eyes:","owner_id":2547860,"tags":["scrolling"],"delta":1090,"stars":3953,"created_at":"2016-08-02T14:06:34.000Z","monthly":[51,54,35,950]},{"name":"Fuse.js","url":"http://fusejs.io/","full_name":"krisk/Fuse","description":"Lightweight fuzzy-search, in JavaScript","owner_id":565580,"tags":["search"],"delta":1886,"stars":5440,"created_at":"2012-05-28T04:31:06.000Z","monthly":[162,549,810,365]},{"name":"Choreographer-js","url":"https://christinecha.github.io/choreographer-js/","full_name":"christinecha/choreographer-js","description":"A simple library to take care of complicated animations.","owner_id":13008259,"tags":["animation","scrolling"],"delta":1224,"stars":1618,"created_at":"2016-09-10T19:51:15.000Z","monthly":[87,79,656,402]},{"name":"Vuex","url":"https://vuex.vuejs.org","full_name":"vuejs/vuex","description":"🗃️ Centralized State Management for Vue.js.","owner_id":6128107,"tags":["flux","vue","state"],"delta":1752,"stars":12089,"created_at":"2015-07-16T04:21:26.000Z","monthly":[566,561,603,22]},{"name":"Angular","url":"https://angular.io","full_name":"angular/angular","description":"One framework. Mobile & desktop.","owner_id":139426,"tags":["framework","angular"],"delta":10362,"stars":31827,"created_at":"2014-09-18T16:12:01.000Z","twitter":"angular","monthly":[901,688,675,8098]},{"name":"Front-end Job Interview Questions","url":"http://h5bp.github.io/Front-end-Developer-Interview-Questions/","full_name":"h5bp/Front-end-Developer-Interview-Questions","description":"A list of helpful front-end related questions you can use to interview potential candidates, test yo","owner_id":1136800,"tags":["learning"],"delta":1708,"stars":31564,"created_at":"2012-02-09T23:34:10.000Z","monthly":[645,778,285]},{"name":"PDF.js","url":"","full_name":"mozilla/pdf.js","description":"PDF Reader in JavaScript","owner_id":131524,"tags":["pdf"],"delta":757,"stars":20571,"created_at":"2011-04-26T06:32:03.000Z","monthly":[263,301,193]},{"name":"Yarn","url":"https://yarnpkg.com","full_name":"yarnpkg/yarn","description":"📦🐈 Fast, reliable, and secure dependency management.","owner_id":22247014,"tags":["package"],"delta":10792,"stars":29614,"created_at":"2016-01-19T17:39:16.000Z","monthly":[1223,1821,7748]},{"name":"Tesseract.js","url":"http://tesseract.projectnaptha.com/","full_name":"naptha/tesseract.js","description":"Pure Javascript OCR for 62 Languages 📖🎉🖥","owner_id":7720173,"tags":["image"],"delta":6119,"stars":12789,"created_at":"2015-06-24T02:49:52.000Z","monthly":[202,509,5408]},{"name":"Styled Components","url":"http://styled-components.com","full_name":"styled-components/styled-components","description":"Visual primitives for the component age. Use the best bits of ES6 and CSS to style your apps without","owner_id":20658825,"tags":["css-in-js"],"delta":2205,"stars":12503,"created_at":"2016-08-16T06:41:32.000Z","monthly":[710,795,700]},{"name":"gun","url":"http://gun.js.org/","full_name":"amark/gun","description":"A realtime, decentralized, offline-first, graph database engine.","owner_id":433412,"tags":["db"],"delta":1257,"stars":7083,"created_at":"2014-07-31T15:52:10.000Z","monthly":[817,206,234]},{"name":"TestCafe","url":"https://devexpress.github.io/testcafe/","full_name":"DevExpress/testcafe","description":"A Node.js tool to automate end-to-end web testing.","owner_id":4243232,"tags":["auto"],"delta":1261,"stars":3832,"created_at":"2015-04-20T13:43:28.000Z","monthly":[446,156,659]},{"name":"WebTorrent","url":"https://webtorrent.io","full_name":"webtorrent/webtorrent","description":"⚡️ Streaming torrent client for the web","owner_id":5800008,"tags":["webrtc"],"delta":473,"stars":15495,"created_at":"2013-10-15T08:16:40.000Z","monthly":[171,206,96]},{"name":"vux","url":"https://vux.li/","full_name":"airyland/vux","description":"Mobile UI Components based on Vue & WeUI","owner_id":559179,"tags":["vue"],"delta":955,"stars":10833,"created_at":"2016-02-15T03:23:27.000Z","monthly":[397,431,127]},{"name":"Next.js","url":"https://zeit.co/blog/next4","full_name":"zeit/next.js","description":"Framework for server-rendered or statically-exported React apps","owner_id":14985020,"tags":["boilerplate","isomorphic","react"],"delta":4567,"stars":20992,"created_at":"2016-10-05T23:32:51.000Z","monthly":[975,2012,1580]},{"name":"flv.js","url":"","full_name":"Bilibili/flv.js","description":"HTML5 FLV Player","owner_id":12002442,"tags":["video"],"delta":5114,"stars":10953,"created_at":"2016-05-12T08:34:31.000Z","monthly":[3447,1667]},{"name":"Flow","url":"https://flow.org/","full_name":"facebook/flow","description":"Adds static typing to JavaScript to improve developer productivity and code quality.","owner_id":69631,"tags":["compiler"],"delta":624,"stars":14950,"created_at":"2014-10-28T17:17:45.000Z","twitter":"flowtype","monthly":[343,281],"icon":"flow.svg"},{"name":"Storybook","url":"https://storybook.js.org","full_name":"storybooks/storybook","description":"Interactive UI component dev & test: React, React Native, Vue, Angular","owner_id":22632046,"tags":["react","vue","angular"],"delta":785,"stars":18500,"created_at":"2016-03-18T04:23:44.000Z","twitter":"storybookjs","monthly":[426,359]},{"name":"vue-router","url":"http://router.vuejs.org/","full_name":"vuejs/vue-router","description":"🚦 The official router for Vue.js.","owner_id":6128107,"tags":["vue","routing"],"delta":677,"stars":8326,"created_at":"2013-12-11T19:37:46.000Z"},{"name":"JavaScript Stack from Scratch","url":"","full_name":"verekia/js-stack-from-scratch","description":"🛠️⚡ Step-by-step tutorial to build a modern JavaScript stack.","owner_id":522007,"tags":["learning"],"delta":1073,"stars":16637,"created_at":"2016-10-02T13:31:23.000Z","monthly":[521,552]},{"name":"Whitestorm.js","url":"https://whs.io","full_name":"WhitestormJS/whs.js","description":":rocket: 🌪 Super-fast 3D framework for Web Applications 🥇 & Games 🎮. Based on Three.js","owner_id":16437392,"tags":["3d"],"delta":1746,"stars":4620,"created_at":"2015-08-30T10:29:14.000Z","monthly":[86,1660]},{"name":"Blueprint","url":"http://blueprintjs.com/","full_name":"palantir/blueprint","description":"A React-based UI toolkit for the web","owner_id":303157,"tags":["react","component"],"delta":3228,"stars":8034,"created_at":"2016-10-25T21:17:50.000Z","monthly":[437,2791]},{"name":"Element","url":"http://element.eleme.io/","full_name":"ElemeFE/element","description":"A Vue.js 2.0 UI Toolkit for Web","owner_id":12810740,"tags":["vue","component"],"delta":1902,"stars":21836,"created_at":"2016-09-03T06:19:26.000Z","monthly":[1041,861]},{"name":"Svelte","url":"https://svelte.technology","full_name":"sveltejs/svelte","description":"The magical disappearing UI framework","owner_id":23617963,"tags":["framework"],"delta":1666,"stars":6146,"created_at":"2016-11-20T18:13:05.000Z","monthly":[1666]},{"name":"faker.js","url":"","full_name":"Marak/faker.js","description":"generate massive amounts of fake data in Node.js and the browser","owner_id":70011,"tags":["random"],"delta":102,"stars":12637,"created_at":"2010-05-15T00:53:07.000Z","monthly":[102]},{"name":"Lighthouse","url":"https://developers.google.com/web/tools/lighthouse/","full_name":"GoogleChrome/lighthouse","description":"Auditing, performance metrics, and best practices for Progressive Web Apps","owner_id":1778935,"tags":["performance"],"delta":745,"stars":11921,"created_at":"2016-03-08T01:03:11.000Z","monthly":[745]},{"name":"regexgen","url":"https://runkit.com/npm/regexgen","full_name":"devongovett/regexgen","description":"Generate regular expressions that match a set of strings","owner_id":19409,"tags":["regexp"],"delta":1198,"stars":2317,"created_at":"2016-12-20T02:50:53.000Z","monthly":[1198]},{"name":"Reason","url":"http://reasonml.github.io","full_name":"facebook/reason","description":"Simple, fast & type safe code that leverages the JavaScript & OCaml ecosystems","owner_id":69631,"tags":["compiler"],"delta":1857,"stars":4556,"created_at":"2015-11-16T08:22:32.000Z","twitter":"reasonml","monthly":[99,94,152,133,63,112,98,1106]},{"name":"ClojureScript","url":"http://clojurescript.org/","full_name":"clojure/clojurescript","description":"Clojure to JS compiler","owner_id":317875,"tags":["compiler"],"delta":1156,"stars":7464,"created_at":"2011-07-20T23:29:13.000Z","monthly":[108,100,61,85,82,82,91,112,103,106,100,126]},{"name":"Purescript","url":"http://purescript.org","full_name":"purescript/purescript","description":"A strongly-typed language that compiles to Javascript","owner_id":6556677,"tags":["compiler"],"delta":1081,"stars":4371,"created_at":"2013-09-30T05:29:23.000Z","monthly":[77,108,74,121,78,69,67,87,115,79,85,121]}]}

/***/ }),
/* 417 */
/***/ (function(module, exports) {

	module.exports = [{"key":"all","excluded":["awesome","you-dont-know-js","airbnb-style-guide","front-end-job-interview-questions","front-end-checklist","30-seconds-of-code"],"count":35,"limit":10},{"key":"framework","count":10},{"key":"nodejs-framework","tags":["nodejs-framework"],"count":10},{"key":"react","tags":["react","react-native"],"count":15,"excluded":["react","react-native"]},{"key":"vue","limit":10,"count":10,"excluded":["vuejs","storybook"],"guest":"evan"},{"key":"mobile","excluded":["mint-ui","nativebase"],"count":5},{"key":"compiler","count":8},{"key":"build","count":7},{"key":"test-framework","count":5},{"key":"ide","count":5},{"key":"css-in-js","count":10},{"key":"ssg","count":5},{"key":"graphql","count":10}]

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	module.exports = {"date":"2018-01-20T22:41:19.468Z","count":514,"projects":[{"name":"RiotJS","url":"http://riotjs.com","full_name":"riot/riot","description":"Simple and elegant component-based UI library","owner_id":12729373,"tags":["framework","vdom"],"delta":1392,"stars":12695,"created_at":"2013-09-27T05:21:01.000Z","monthly":[89,62,83,125,117,91,112,138,153,138,149,135]},{"name":"Aurelia","url":"http://aurelia.io/","full_name":"aurelia/framework","description":"The aurelia framework brings together all the required core aurelia libraries into a ready-to-go app","owner_id":9808864,"tags":["framework"],"delta":1592,"stars":10368,"created_at":"2014-12-10T19:22:29.000Z","monthly":[56,43,97,131,139,130,152,147,145,169,169,214]},{"name":"Angular 1","url":"https://angularjs.org","full_name":"angular/angular.js","description":"AngularJS - HTML enhanced for web apps!","owner_id":139426,"tags":["framework","angular"],"delta":3610,"stars":57856,"created_at":"2010-01-06T00:34:37.000Z","twitter":"","monthly":[130,203,217,270,317,323,347,365,277,392,388,381],"icon":"angular.svg"},{"name":"Flux","url":"http://facebook.github.io/flux/","full_name":"facebook/flux","description":"Application Architecture for Building User Interfaces","owner_id":69631,"tags":["flux"],"delta":1687,"stars":14755,"created_at":"2014-07-20T23:33:08.000Z","monthly":[73,115,102,122,124,132,141,144,202,187,182,163],"icon":"https://s3-us-west-2.amazonaws.com/svgporn.com/logos/flux.svg"},{"name":"React","url":"https://reactjs.org","full_name":"facebook/react","description":"A declarative, efficient, and flexible JavaScript library for building user interfaces.","owner_id":69631,"tags":["framework","vdom","react"],"delta":27774,"stars":86238,"created_at":"2013-05-24T16:15:54.000Z","twitter":"reactjs","monthly":[2201,2463,2795,2506,2181,2552,1969,2328,2269,2555,1999,1956],"icon":"react.svg"},{"name":"Foundation","url":"http://foundation.zurb.com","full_name":"zurb/foundation-sites","description":"The most advanced responsive front-end framework in the world. Quickly create prototypes and product","owner_id":156122,"tags":["css-lib"],"delta":2164,"stars":26915,"created_at":"2011-10-13T23:05:42.000Z","monthly":[132,150,228,165,203,211,219,189,177,158,149,183]},{"name":"Bootstrap","url":"http://getbootstrap.com","full_name":"twbs/bootstrap","description":"The most popular HTML, CSS, and JavaScript framework for developing responsive, mobile first project","owner_id":2918581,"tags":["css-lib"],"delta":14537,"stars":120751,"created_at":"2011-07-29T21:19:00.000Z","twitter":"getbootstrap","monthly":[1134,1251,1476,1218,1406,1141,1012,1130,1331,1415,1027,996]},{"name":"Ionic","url":"https://ionicframework.com/","full_name":"ionic-team/ionic","description":"Build amazing native and progressive web apps with open web technologies. One app running on everyth","owner_id":3171503,"tags":["mobile"],"delta":5499,"stars":32994,"created_at":"2013-08-20T23:06:02.000Z","twitter":"Ionicframework","monthly":[311,510,465,421,419,439,437,509,530,515,443,500]},{"name":"Sails","url":"https://sailsjs.com","full_name":"balderdashy/sails","description":"Realtime MVC Framework for Node.js","owner_id":1445252,"tags":["nodejs-framework"],"delta":2005,"stars":18285,"created_at":"2012-03-18T19:46:15.000Z","twitter":"sailsjs","monthly":[108,135,128,148,152,164,182,211,172,219,176,210]},{"name":"Keystone","url":"http://www.keystonejs.com","full_name":"keystonejs/keystone","description":"node.js cms and web app framework","owner_id":6118534,"tags":["nodejs-framework","cms"],"delta":3039,"stars":11821,"created_at":"2013-07-02T05:01:55.000Z","twitter":"keystonejs","monthly":[235,197,225,193,264,314,252,250,252,289,279,289]},{"name":"PureCSS","url":"http://purecss.io/","full_name":"pure-css/pure","description":"A set of small, responsive CSS modules that you can use in every web project.","owner_id":23743443,"tags":["css-lib"],"delta":2376,"stars":18094,"created_at":"2013-04-22T16:16:39.000Z","monthly":[164,146,130,135,189,211,251,276,214,220,204,236]},{"name":"Phaser","url":"http://phaser.io","full_name":"photonstorm/phaser","description":"Phaser is a fun, free and fast 2D game framework for making HTML5 games for desktop and mobile web b","owner_id":164476,"tags":["game"],"delta":3017,"stars":17212,"created_at":"2013-04-12T12:27:51.000Z","monthly":[196,189,282,207,298,224,251,275,318,285,236,256]},{"name":"Greensock","url":"https://greensock.com","full_name":"greensock/GreenSock-JS","description":"GreenSock's GSAP JavaScript animation library (including Draggable).","owner_id":2386673,"tags":["animation"],"delta":1498,"stars":7094,"created_at":"2012-09-21T18:03:25.000Z","monthly":[99,149,135,119,125,105,118,115,128,124,125,156]},{"name":"SemanticUI","url":"http://www.semantic-ui.com","full_name":"Semantic-Org/Semantic-UI","description":"Semantic is a UI component framework based around useful principles from natural language.","owner_id":5796209,"tags":["css-lib"],"delta":8342,"stars":39136,"created_at":"2013-04-08T23:32:04.000Z","monthly":[451,492,492,444,594,570,621,683,1921,781,675,618]},{"name":"Ember","url":"http://www.emberjs.com","full_name":"emberjs/ember.js","description":"Ember.js - A JavaScript framework for creating ambitious web applications","owner_id":1253363,"tags":["framework"],"delta":1224,"stars":18648,"created_at":"2011-05-25T23:39:40.000Z","monthly":[95,66,109,93,87,106,101,98,84,132,117,136]},{"name":"ChartJS","url":"http://www.chartjs.org/","full_name":"chartjs/Chart.js","description":"Simple HTML5 Charts using the <canvas> tag","owner_id":10342521,"tags":["chart","canvas"],"delta":7140,"stars":34647,"created_at":"2013-03-17T23:56:36.000Z","monthly":[562,568,569,584,567,599,581,603,564,770,617,556]},{"name":"D3","url":"https://d3js.org","full_name":"d3/d3","description":"Bring data to life with SVG, Canvas and HTML. :bar_chart::chart_with_upwards_trend::tada:","owner_id":1562726,"tags":["chart","d3","svg","canvas"],"delta":12650,"stars":71804,"created_at":"2010-09-27T17:22:42.000Z","twitter":"d3js_org","monthly":[797,879,879,985,1044,1015,768,1149,1268,1647,1132,1087]},{"name":"Backbone","url":"http://backbonejs.org","full_name":"jashkenas/backbone","description":"Give your JS App some Backbone with Models, Views, Collections, and Events","owner_id":4732,"tags":["framework"],"delta":1004,"stars":26936,"created_at":"2010-09-30T19:41:28.000Z","monthly":[49,59,73,79,130,80,95,86,85,111,87,70],"icon":"https://s3-us-west-2.amazonaws.com/svgporn.com/logos/backbone-icon.svg"},{"name":"AngularUI Router","url":"http://ui-router.github.io/","full_name":"angular-ui/ui-router","description":"The de-facto solution to flexible routing with nested views in AngularJS","owner_id":1530011,"tags":["angular","routing"],"delta":1079,"stars":13731,"created_at":"2013-01-18T20:26:29.000Z","monthly":[34,51,67,60,56,95,81,88,108,158,161,120]},{"name":"Material UI","url":"http://www.material-ui.com","full_name":"mui-org/material-ui","description":"React components that implement Google's Material Design.","owner_id":33663932,"tags":["material","react","component"],"delta":9648,"stars":32422,"created_at":"2014-08-18T19:11:54.000Z","twitter":"materialui","monthly":[918,864,848,701,796,883,757,816,842,833,749,641]},{"name":"Polymer","url":"https://www.polymer-project.org/","full_name":"Polymer/polymer","description":"Build modern apps using web components","owner_id":2159051,"tags":["framework"],"delta":2268,"stars":19031,"created_at":"2012-08-23T20:56:30.000Z","monthly":[160,133,159,206,273,151,178,305,131,219,176,177]},{"name":"Restify","url":"http://restify.com","full_name":"restify/node-restify","description":"The future of Node.js REST development","owner_id":6948699,"tags":["nodejs-framework"],"delta":1539,"stars":7702,"created_at":"2011-04-25T21:19:26.000Z","twitter":"","monthly":[102,129,124,125,133,122,127,117,131,184,144,101]},{"name":"Express","url":"https://expressjs.com","full_name":"expressjs/express","description":"Fast, unopinionated, minimalist web framework for node.","owner_id":5658226,"tags":["nodejs-framework","express"],"delta":6679,"stars":36186,"created_at":"2009-06-26T18:56:01.000Z","twitter":"expressjs","monthly":[524,560,610,485,525,512,552,583,587,613,586,542]},{"name":"Materialize CSS","url":"http://materializecss.com","full_name":"Dogfalo/materialize","description":"Materialize, a CSS Framework based on Material Design","owner_id":2775751,"tags":["css-lib","material"],"delta":7013,"stars":31017,"created_at":"2014-09-12T19:35:38.000Z","monthly":[480,527,571,573,625,550,612,632,610,621,615,597]},{"name":"Material Angular","url":"https://material.angularjs.org/","full_name":"angular/material","description":"Material design for AngularJS","owner_id":139426,"tags":["angular","material"],"delta":956,"stars":15996,"created_at":"2014-07-01T19:20:06.000Z","monthly":[53,47,61,46,80,65,59,101,108,117,102,117]},{"name":"Impress","url":"http://impress.js.org","full_name":"impress/impress.js","description":"It's a presentation framework based on the power of CSS3 transforms and transitions in modern browse","owner_id":5477410,"tags":["presentation"],"delta":2313,"stars":32966,"created_at":"2011-12-28T22:23:19.000Z","monthly":[154,154,224,172,191,161,193,211,227,221,197,208]},{"name":"jQuery","url":"https://jquery.com/","full_name":"jquery/jquery","description":"jQuery JavaScript Library","owner_id":70142,"tags":["util","dom"],"delta":4719,"stars":47800,"created_at":"2009-04-03T15:20:14.000Z","monthly":[326,326,302,356,424,412,405,449,416,528,459,316]},{"name":"React Router","url":"https://reacttraining.com/react-router/","full_name":"ReactTraining/react-router","description":"Declarative routing for React","owner_id":11823761,"tags":["react","routing"],"delta":8676,"stars":27694,"created_at":"2014-05-16T22:22:51.000Z","monthly":[666,673,662,572,725,710,647,762,747,1074,748,690]},{"name":"Webpack","url":"https://webpack.js.org","full_name":"webpack/webpack","description":"A bundler for javascript and friends. Packs many modules into a few bundled assets. Code Splitting a","owner_id":2105791,"tags":["build","module"],"delta":13063,"stars":36136,"created_at":"2012-03-10T10:08:14.000Z","monthly":[1019,1043,1044,714,995,1067,1242,1113,1079,1239,1150,1358],"icon":"webpack.svg"},{"name":"Gulp","url":"http://gulpjs.com","full_name":"gulpjs/gulp","description":"The streaming build system","owner_id":6200624,"tags":["build"],"delta":3595,"stars":28525,"created_at":"2013-07-04T05:26:06.000Z","twitter":"gulpjs","monthly":[228,270,286,237,302,291,254,303,391,376,313,344]},{"name":"Grunt","url":"http://gruntjs.com/","full_name":"gruntjs/grunt","description":"Grunt: The JavaScript Task Runner","owner_id":1630826,"tags":["build"],"delta":446,"stars":11714,"created_at":"2011-09-21T15:16:20.000Z","monthly":[45,37,35,32,36,34,47,50,44,32,27,27]},{"name":"Fontawesome","url":"http://fontawesome.io","full_name":"FortAwesome/Font-Awesome","description":"The iconic font and CSS toolkit","owner_id":1505683,"tags":["icon"],"delta":6621,"stars":54329,"created_at":"2012-02-17T14:19:43.000Z","monthly":[573,426,430,461,543,604,568,566,597,664,617,572]},{"name":"Ionicons","url":"http://ionicons.com/","full_name":"ionic-team/ionicons","description":"The premium icon font for Ionic","owner_id":3171503,"tags":["icon"],"delta":1865,"stars":12263,"created_at":"2013-10-10T14:34:18.000Z","monthly":[138,210,245,149,119,135,105,104,151,190,141,178]},{"name":"Reveal","url":"https://revealjs.com","full_name":"hakimel/reveal.js","description":"The HTML Presentation Framework","owner_id":629429,"tags":["presentation"],"delta":6212,"stars":38509,"created_at":"2011-06-07T18:54:22.000Z","monthly":[397,537,555,524,456,505,463,550,554,571,525,575]},{"name":"Select2","url":"https://select2.org/","full_name":"select2/select2","description":"Select2 is a jQuery based replacement for select boxes. It supports searching, remote data sets, and","owner_id":8077542,"tags":["plugin","autocomplete"],"delta":2553,"stars":21791,"created_at":"2012-03-04T18:43:12.000Z","monthly":[174,187,146,176,226,204,209,247,266,262,251,205]},{"name":"RxJS","url":"http://reactivex.io","full_name":"Reactive-Extensions/RxJS","description":"The Reactive Extensions for JavaScript","owner_id":984368,"tags":["fp","stream"],"delta":4481,"stars":18387,"created_at":"2012-01-07T00:31:41.000Z","monthly":[220,328,299,242,302,328,336,395,480,556,461,534]},{"name":"Jasmine","url":"http://jasmine.github.io/","full_name":"jasmine/jasmine","description":"Simple JavaScript testing framework for browsers and node.js","owner_id":4624349,"tags":["test-framework","test"],"delta":1185,"stars":13209,"created_at":"2008-12-02T23:46:37.000Z","monthly":[83,109,76,88,120,96,94,106,97,128,95,93]},{"name":"Mocha","url":"https://mochajs.org","full_name":"mochajs/mocha","description":"☕️ simple, flexible, fun javascript test framework for node.js & the browser","owner_id":8770005,"tags":["test-framework","test"],"delta":3065,"stars":14426,"created_at":"2011-03-07T18:44:25.000Z","monthly":[287,295,269,238,259,231,230,251,244,266,253,242]},{"name":"Jest","url":"http://facebook.github.io/jest/","full_name":"facebook/jest","description":"🃏 Delightful JavaScript Testing.","owner_id":69631,"tags":["test-framework","test"],"delta":7138,"stars":15014,"created_at":"2013-12-10T00:18:04.000Z","twitter":"fbjest","monthly":[675,664,705,473,476,549,499,884,549,647,519,498],"icon":"jest.svg"},{"name":"Sinon.JS","url":"http://sinonjs.org/","full_name":"sinonjs/sinon","description":"Test spies, stubs and mocks for JavaScript.","owner_id":6570253,"tags":["test"],"delta":1694,"stars":5296,"created_at":"2010-06-29T21:15:32.000Z","monthly":[119,156,162,155,147,154,140,133,187,158,83,100]},{"name":"Karma","url":"http://karma-runner.github.io","full_name":"karma-runner/karma","description":"Spectacular Test Runner for JavaScript","owner_id":3284117,"tags":["test"],"delta":1357,"stars":9375,"created_at":"2011-10-12T07:55:46.000Z","monthly":[84,117,98,86,112,110,108,130,128,155,110,119]},{"name":"Zepto","url":"http://zeptojs.com","full_name":"madrobby/zepto","description":"Zepto.js is a minimalist JavaScript library for modern browsers, with a jQuery-compatible API","owner_id":3390,"tags":["dom"],"delta":1519,"stars":13446,"created_at":"2010-09-20T07:57:57.000Z","monthly":[100,107,119,147,142,115,121,127,119,143,169,110]},{"name":"Underscore","url":"http://underscorejs.org","full_name":"jashkenas/underscore","description":"JavaScript's utility _ belt","owner_id":4732,"tags":["util"],"delta":2247,"stars":22203,"created_at":"2009-10-25T18:31:06.000Z","monthly":[158,200,178,200,245,161,214,192,158,196,162,183]},{"name":"Lodash","url":"https://lodash.com/","full_name":"lodash/lodash","description":"A modern JavaScript utility library delivering modularity, performance, & extras.","owner_id":2565403,"tags":["util"],"delta":7977,"stars":29116,"created_at":"2012-04-07T04:11:46.000Z","monthly":[665,797,632,622,770,711,699,644,613,695,555,574]},{"name":"Koa","url":"http://koajs.com","full_name":"koajs/koa","description":"Expressive middleware for node.js using ES2017 async functions","owner_id":5055057,"tags":["nodejs-framework"],"delta":5780,"stars":19283,"created_at":"2013-07-20T18:53:45.000Z","monthly":[460,481,441,465,517,421,489,479,486,609,510,422]},{"name":"Moment","url":"momentjs.com","full_name":"moment/moment","description":"Parse, validate, manipulate, and display dates in javascript.","owner_id":4129662,"tags":["format","date"],"delta":5631,"stars":35175,"created_at":"2011-03-01T02:46:06.000Z","monthly":[473,492,540,381,488,508,433,487,498,482,438,411]},{"name":"Format.JS","url":"http://formatjs.io/","full_name":"yahoo/react-intl","description":"Internationalize React apps. This library provides React components and an API to format dates, numb","owner_id":16574,"tags":["format","i18n"],"delta":2608,"stars":6526,"created_at":"2014-04-24T17:28:36.000Z","monthly":[161,221,224,182,226,281,203,240,220,218,228,204]},{"name":"Math.JS","url":"mathjs.org","full_name":"josdejong/mathjs","description":"An extensive math library for JavaScript and Node.js","owner_id":568626,"tags":["math"],"delta":1278,"stars":5312,"created_at":"2013-02-15T19:46:01.000Z","monthly":[141,100,101,109,90,100,83,159,99,91,107,98]},{"name":"Numeral.JS","url":"http://numeraljs.com","full_name":"adamwdraper/Numeral-js","description":"A javascript library for formatting and manipulating numbers.","owner_id":678099,"tags":["format"],"delta":1168,"stars":5839,"created_at":"2012-10-01T20:50:23.000Z","monthly":[100,112,99,73,88,112,99,137,95,108,65,80]},{"name":"Metalsmith","url":"http://metalsmith.io","full_name":"segmentio/metalsmith","description":"An extremely simple, pluggable static site generator.","owner_id":819518,"tags":["ssg"],"delta":1011,"stars":6510,"created_at":"2014-02-04T03:46:22.000Z","monthly":[61,80,72,81,73,136,72,82,85,72,90,107]},{"name":"Radium","url":"http://formidable.com/open-source/radium/","full_name":"FormidableLabs/radium","description":"A toolchain for React component styling.","owner_id":5078602,"tags":["css-in-js"],"delta":1193,"stars":5974,"created_at":"2015-01-09T19:35:59.000Z","monthly":[68,106,81,68,88,89,92,99,126,112,120,144]},{"name":"Typeahead","url":"http://twitter.github.com/typeahead.js/","full_name":"twitter/typeahead.js","description":"typeahead.js is a fast and fully-featured autocomplete library","owner_id":50278,"tags":["plugin","autocomplete"],"delta":1206,"stars":14891,"created_at":"2013-02-19T19:45:01.000Z","monthly":[78,67,83,114,78,98,110,105,128,127,104,114]},{"name":"Atom","url":"https://atom.io","full_name":"atom/atom","description":":atom: The hackable text editor","owner_id":1089146,"tags":["ide"],"delta":9075,"stars":42940,"created_at":"2012-01-20T18:18:21.000Z","twitter":"atomeditor","monthly":[557,724,763,921,871,774,695,798,604,764,766,838]},{"name":"Brackets","url":"http://brackets.io","full_name":"adobe/brackets","description":"An open source code editor for the web, written in JavaScript, HTML and CSS.","owner_id":476009,"tags":["ide"],"delta":1877,"stars":28597,"created_at":"2011-12-07T21:14:40.000Z","twitter":"brackets","monthly":[106,112,142,192,161,189,126,172,142,233,164,138]},{"name":"Chosen","url":"http://harvesthq.github.io/chosen/","full_name":"harvesthq/chosen","description":"Chosen is a library for making long, unwieldy select boxes more friendly.","owner_id":43635,"tags":["plugin"],"delta":1009,"stars":21340,"created_at":"2011-04-18T15:07:41.000Z","monthly":[59,65,76,80,90,79,72,108,92,118,102,68]},{"name":"Hapi","url":"hapijs.com","full_name":"hapijs/hapi","description":"Server Framework  for Node.js","owner_id":3774533,"tags":["nodejs-framework"],"delta":1730,"stars":8981,"created_at":"2011-08-06T00:35:39.000Z","monthly":[179,182,142,137,121,133,116,141,130,127,152,170]},{"name":"Meteor","url":"https://www.meteor.com","full_name":"meteor/meteor","description":"Meteor, the JavaScript App Platform","owner_id":789528,"tags":["fullstack","meteor","nodejs-framework"],"delta":2615,"stars":39046,"created_at":"2012-01-19T01:58:17.000Z","twitter":"","monthly":[199,195,246,172,189,190,216,289,275,234,197,213]},{"name":"Browserify","url":"http://browserify.org/","full_name":"browserify/browserify","description":"browser-side require() the node.js way","owner_id":6320506,"tags":["build","module"],"delta":1051,"stars":11699,"created_at":"2010-09-22T16:11:32.000Z","monthly":[92,94,89,76,82,72,77,94,103,81,90,101]},{"name":"Loopback","url":"http://loopback.io","full_name":"strongloop/loopback","description":"LoopBack makes it easy to build modern applications that require complex integrations.","owner_id":3020012,"tags":["api","nodejs-framework"],"delta":2330,"stars":10435,"created_at":"2013-04-09T16:02:18.000Z","monthly":[139,158,192,167,168,208,283,224,194,224,180,193]},{"name":"Istanbul","url":"https://gotwarlost.github.io/istanbul/","full_name":"gotwarlost/istanbul","description":"Yet another JS code coverage tool that computes statement, line, function and branch coverage with m","owner_id":1056819,"tags":["test"],"delta":1405,"stars":6917,"created_at":"2012-09-12T06:36:32.000Z","monthly":[70,120,67,85,95,116,111,141,152,159,137,152]},{"name":"Highcharts","url":"www.highcharts.com","full_name":"highcharts/highcharts","description":"Highcharts JS, the JavaScript charting framework","owner_id":15981345,"tags":["chart"],"delta":1313,"stars":7199,"created_at":"2010-06-11T12:23:53.000Z","monthly":[140,151,132,93,104,106,81,123,116,104,88,75]},{"name":"ChartistJS","url":"http://gionkunz.github.io/chartist-js/","full_name":"gionkunz/chartist-js","description":"Simple responsive charts","owner_id":2203704,"tags":["chart"],"delta":1319,"stars":10372,"created_at":"2014-03-09T22:40:07.000Z","monthly":[92,128,98,149,110,102,81,107,112,110,108,122]},{"name":"Immutable","url":"http://facebook.github.io/immutable-js/","full_name":"facebook/immutable-js","description":"Immutable persistent data collections for Javascript which increase efficiency and simplicity.","owner_id":69631,"tags":["data-structure"],"delta":5488,"stars":22158,"created_at":"2014-07-02T06:02:29.000Z","monthly":[356,385,445,435,440,435,448,504,494,566,461,519],"icon":"https://s3-us-west-2.amazonaws.com/svgporn.com/logos/immutable.svg"},{"name":"Bootstrap material","url":"http://fezvrasta.github.io/bootstrap-material-design/","full_name":"FezVrasta/bootstrap-material-design","description":"Material design theme for Bootstrap 3 and 4","owner_id":5382443,"tags":["css-lib","material"],"delta":1616,"stars":18942,"created_at":"2014-08-18T11:54:00.000Z","monthly":[64,94,74,82,112,152,139,159,148,204,193,195]},{"name":"Sheperd","url":"http://github.hubspot.com/shepherd/docs/welcome","full_name":"HubSpot/shepherd","description":"Guide your users through a tour of your app #hubspot-open-source","owner_id":326419,"tags":["presentation"],"delta":1002,"stars":5440,"created_at":"2013-12-17T06:30:27.000Z","monthly":[60,44,49,123,79,65,75,96,131,84,67,129]},{"name":"IntroJS","url":"http://introjs.com","full_name":"usablica/intro.js","description":"A better way for new feature introduction and step-by-step users guide for your website and project.","owner_id":2010360,"tags":["presentation"],"delta":1455,"stars":16218,"created_at":"2013-03-10T15:12:45.000Z","monthly":[114,111,121,96,163,145,114,109,164,126,108,84]},{"name":"PACE","url":"http://github.hubspot.com/pace/docs/welcome","full_name":"HubSpot/pace","description":"Automatically add a progress bar to your site. #hubspot-open-source","owner_id":326419,"tags":["progress-bar"],"delta":1962,"stars":13144,"created_at":"2013-09-12T04:24:29.000Z","monthly":[133,138,120,140,178,174,185,217,135,199,169,174]},{"name":"Vue.js","url":"http://vuejs.org","full_name":"vuejs/vue","description":"🖖 A progressive, incrementally-adoptable JavaScript framework for building UI on the web.","owner_id":6128107,"tags":["framework","vdom","vue"],"delta":39994,"stars":80749,"created_at":"2013-07-29T03:24:51.000Z","twitter":"vuejs","monthly":[2970,3069,3407,3649,3324,3597,3122,3246,3125,3928,3524,3033],"icon":"vue.svg"},{"name":"Web Starter Kit","url":"http://developers.google.com/web/starter-kit","full_name":"google/web-starter-kit","description":"Web Starter Kit - a workflow for multi-device websites","owner_id":1342004,"tags":["html"],"delta":2532,"stars":17948,"created_at":"2014-04-07T08:45:18.000Z","monthly":[77,88,98,114,134,197,689,227,248,251,192,217]},{"name":"HTML5 boilerplate","url":"https://html5boilerplate.com/","full_name":"h5bp/html5-boilerplate","description":"A professional front-end template for building fast, robust, and adaptable web apps or sites.","owner_id":1136800,"tags":["html"],"delta":3238,"stars":39561,"created_at":"2010-01-24T18:03:24.000Z","monthly":[260,315,363,309,282,230,212,239,260,287,240,241]},{"name":"Async","url":"http://caolan.github.io/async/","full_name":"caolan/async","description":"Async utilities for node and the browser","owner_id":5274,"tags":["flow"],"delta":2957,"stars":23173,"created_at":"2010-06-01T21:01:30.000Z","monthly":[231,214,229,191,265,244,278,253,277,262,255,258],"icon":"https://caolan.github.io/async/img/async-logo.svg"},{"name":"Skrollr","url":"http://prinzhorn.github.io/skrollr/","full_name":"Prinzhorn/skrollr","description":"Stand-alone parallax scrolling library for mobile (Android + iOS) and desktop. No jQuery. Just plain","owner_id":679144,"tags":["scrolling"],"delta":1108,"stars":17729,"created_at":"2012-03-18T15:41:35.000Z","monthly":[60,95,91,74,94,98,86,111,91,111,118,79]},{"name":"Animate.css","url":"http://daneden.github.io/animate.css","full_name":"daneden/animate.css","description":"🍿 A cross-browser library of CSS animations. As easy to use as an easy thing.","owner_id":439365,"tags":["animation"],"delta":9959,"stars":48456,"created_at":"2011-10-12T10:07:38.000Z","monthly":[743,961,894,777,822,776,764,817,922,942,757,784]},{"name":"NativeScript","url":"http://www.nativescript.org","full_name":"NativeScript/NativeScript","description":"NativeScript is an open source framework for building truly native mobile apps with JavaScript. Use ","owner_id":7392261,"tags":["mobile"],"delta":2938,"stars":12203,"created_at":"2015-03-01T09:47:08.000Z","twitter":"NativeScript","monthly":[233,271,280,299,211,217,224,255,238,245,224,241]},{"name":"Validator","url":"","full_name":"chriso/validator.js","description":"String validation","owner_id":364903,"tags":["string","validation"],"delta":2479,"stars":9424,"created_at":"2010-10-06T06:58:48.000Z","monthly":[211,200,210,205,225,207,214,212,178,248,178,191]},{"name":"React hot loader","url":"http://gaearon.github.io/react-hot-loader/","full_name":"gaearon/react-hot-loader","description":"Tweak React components in real time.","owner_id":810438,"tags":["react"],"delta":1924,"stars":8081,"created_at":"2014-07-12T23:49:43.000Z","monthly":[171,127,210,115,163,161,154,140,171,204,161,147]},{"name":"Mithril","url":"http://mithril.js.org","full_name":"MithrilJS/mithril.js","description":"A Javascript Framework for Building Brilliant Applications","owner_id":19475707,"tags":["framework","vdom"],"delta":1467,"stars":8318,"created_at":"2014-03-17T01:59:39.000Z","monthly":[92,111,71,101,109,93,73,90,149,108,317,153],"icon":"https://s3-us-west-2.amazonaws.com/svgporn.com/logos/mithril.svg"},{"name":"TotalJS","url":"http://www.totaljs.com","full_name":"totaljs/framework","description":"Node.js framework","owner_id":6499216,"tags":["nodejs-framework"],"delta":1435,"stars":3573,"created_at":"2012-12-16T13:12:02.000Z","monthly":[46,63,66,51,54,63,69,793,73,42,66,49]},{"name":"Ratchet","url":"http://goratchet.com","full_name":"twbs/ratchet","description":"Build mobile apps with simple HTML, CSS, and JavaScript components. ","owner_id":2918581,"tags":["css-lib","mobile"],"delta":687,"stars":14279,"created_at":"2012-08-17T05:41:57.000Z","monthly":[22,76,98,67,42,52,20,53,49,57,55,96]},{"name":"Snap.svg","url":"http://snapsvg.io","full_name":"adobe-webplatform/Snap.svg","description":"The JavaScript library for modern SVG graphics.","owner_id":2976699,"tags":["drawing","svg"],"delta":1640,"stars":10860,"created_at":"2013-08-15T20:51:34.000Z","monthly":[119,161,109,101,155,115,134,130,167,165,144,140]},{"name":"Three.js","url":"https://threejs.org/","full_name":"mrdoob/three.js","description":"JavaScript 3D library.","owner_id":97088,"tags":["3d"],"delta":8266,"stars":38639,"created_at":"2010-03-23T18:58:01.000Z","monthly":[953,821,739,594,629,580,621,652,640,737,685,615]},{"name":"Hammer.js","url":"http://hammerjs.github.io","full_name":"hammerjs/hammer.js","description":"A javascript library for multi-touch gestures :// You can touch this","owner_id":7997161,"tags":["touch"],"delta":2187,"stars":17598,"created_at":"2012-03-02T12:58:28.000Z","monthly":[187,137,138,187,163,184,151,235,221,217,184,183]},{"name":"Slick","url":"kenwheeler.github.io/slick","full_name":"kenwheeler/slick","description":"the last carousel you'll ever need","owner_id":286616,"tags":["nav"],"delta":3495,"stars":20509,"created_at":"2014-03-24T02:10:05.000Z","monthly":[232,252,270,277,341,278,306,277,348,336,288,290]},{"name":"Hexo","url":"https://hexo.io","full_name":"hexojs/hexo","description":"A fast, simple & powerful blog framework, powered by Node.js.","owner_id":6375567,"tags":["ssg","blog"],"delta":6152,"stars":20265,"created_at":"2012-09-23T15:17:08.000Z","twitter":"hexojs","monthly":[486,476,509,471,537,494,431,469,487,609,519,664]},{"name":"socket.io","url":"http://socket.io","full_name":"socketio/socket.io","description":"Realtime application framework (Node.JS server)","owner_id":10566080,"tags":["realtime","websocket"],"delta":8617,"stars":38667,"created_at":"2010-03-11T18:24:48.000Z","monthly":[663,749,688,683,736,768,730,812,745,821,576,646]},{"name":"deepstream.io","url":"http://deepstream.io/","full_name":"deepstreamIO/deepstream.io","description":"deepstream.io server","owner_id":9024218,"tags":["realtime"],"delta":1115,"stars":5809,"created_at":"2014-11-09T08:30:01.000Z","monthly":[31,30,20,31,45,117,106,127,204,150,166,88]},{"name":"Stylus","url":"http://stylus-lang.com/","full_name":"stylus/stylus","description":"Expressive, robust, feature-rich CSS language built for nodejs","owner_id":10009463,"tags":["css-tool"],"delta":1050,"stars":8796,"created_at":"2010-12-28T22:11:43.000Z","monthly":[86,78,67,83,101,86,89,113,63,103,103,78]},{"name":"autoprefixer","url":"https://twitter.com/autoprefixer","full_name":"postcss/autoprefixer","description":" Parse CSS and add vendor prefixes to rules by Can I Use","owner_id":8296347,"tags":["css-tool"],"delta":2808,"stars":14437,"created_at":"2013-03-14T05:04:51.000Z","monthly":[194,258,200,204,247,190,211,280,252,273,234,265]},{"name":"PurifyCSS","url":"","full_name":"purifycss/purifycss","description":"Remove unused CSS. Also works with single-page apps.","owner_id":12516362,"tags":["css-tool"],"delta":1228,"stars":8037,"created_at":"2015-05-26T02:42:17.000Z","monthly":[95,118,79,47,113,137,137,94,80,114,129,85]},{"name":"Flexbox","url":"http://flexboxgrid.com","full_name":"kristoferjoseph/flexboxgrid","description":"Grid based on CSS3 flexbox","owner_id":76308,"tags":["css-lib"],"delta":1847,"stars":6916,"created_at":"2013-12-21T23:48:16.000Z","monthly":[86,96,113,109,148,134,172,155,160,260,204,210]},{"name":"Awesome","url":"","full_name":"sindresorhus/awesome","description":":sunglasses: Curated list of awesome lists","owner_id":170270,"tags":["meta"],"delta":25461,"stars":76170,"created_at":"2014-07-11T13:42:37.000Z","monthly":[2059,3968,2015,1804,1951,1677,1822,1682,1783,2206,2311,2183],"icon":"https://s3-us-west-2.amazonaws.com/svgporn.com/logos/awesome.svg"},{"name":"Material Design icons","url":"http://google.github.io/material-design-icons/","full_name":"google/material-design-icons","description":"Material Design icons by Google","owner_id":1342004,"tags":["icon","material"],"delta":5573,"stars":33204,"created_at":"2014-10-08T18:01:28.000Z","monthly":[386,454,560,382,428,477,406,512,493,650,433,392]},{"name":"Redux","url":"http://redux.js.org","full_name":"reactjs/redux","description":"Predictable state container for JavaScript apps","owner_id":6412038,"tags":["flux","redux","state"],"delta":10054,"stars":37471,"created_at":"2015-05-29T23:53:15.000Z","monthly":[797,876,812,738,809,767,780,820,913,1051,821,870],"icon":"redux.svg"},{"name":"cssnext","url":"http://cssnext.io/","full_name":"MoOx/postcss-cssnext","description":" :cyclone: PostCSS plugin to use tomorrow's CSS syntax, today.","owner_id":157534,"tags":["css-tool"],"delta":1227,"stars":4924,"created_at":"2014-08-01T06:49:41.000Z","monthly":[99,72,76,63,111,102,96,115,103,109,123,158]},{"name":"Amaze UI","url":"http://amazeui.org/","full_name":"amazeui/amazeui","description":"Amaze UI, a mobile-first and modular front-end framework.","owner_id":8945728,"tags":["mobile"],"delta":2505,"stars":11230,"created_at":"2014-08-04T14:23:37.000Z","monthly":[203,213,174,181,216,234,227,231,213,237,183,193]},{"name":"Airbnb Style Guide","url":"","full_name":"airbnb/javascript","description":"JavaScript Style Guide","owner_id":698437,"tags":["learning"],"delta":18524,"stars":64908,"created_at":"2012-11-01T23:13:50.000Z","monthly":[1183,2158,1421,1146,1456,1900,1503,1513,1488,1641,1759,1356]},{"name":"UIkit","url":"http://getuikit.com","full_name":"uikit/uikit","description":"A lightweight and modular front-end framework for developing fast and powerful web interfaces","owner_id":4173184,"tags":["css-lib"],"delta":3256,"stars":11495,"created_at":"2013-07-18T16:00:26.000Z","monthly":[243,216,236,245,262,249,301,361,371,293,205,274]},{"name":"Bootswatch","url":"https://bootswatch.com","full_name":"thomaspark/bootswatch","description":"Themes for Bootstrap","owner_id":900407,"tags":["css-lib"],"delta":1320,"stars":9815,"created_at":"2012-02-07T04:31:56.000Z","monthly":[100,120,112,90,116,134,98,121,113,102,98,116]},{"name":"React bootstrap","url":"https://react-bootstrap.github.io/","full_name":"react-bootstrap/react-bootstrap","description":"Bootstrap 3 components built with React","owner_id":6853419,"tags":["react","component"],"delta":3475,"stars":12017,"created_at":"2013-12-27T19:06:07.000Z","monthly":[215,269,265,259,302,288,292,306,345,331,313,290]},{"name":"selectize.js","url":"http://selectize.github.io/selectize.js/","full_name":"selectize/selectize.js","description":"Selectize is the hybrid of a textbox and <select> box. It's jQuery based and it has autocomplete and","owner_id":14022691,"tags":["plugin","autocomplete"],"delta":1445,"stars":10615,"created_at":"2012-08-29T18:31:57.000Z","monthly":[69,102,130,120,112,129,135,125,124,147,139,113]},{"name":"Pixi.js","url":"http://pixijs.com","full_name":"pixijs/pixi.js","description":"The HTML5 Creation Engine: Create beautiful digital content with the fastest, most flexible 2D WebGL","owner_id":5406849,"tags":["game"],"delta":4378,"stars":17309,"created_at":"2013-01-21T22:40:50.000Z","monthly":[412,347,336,303,337,323,551,309,382,343,383,352]},{"name":"You Don't Know JS","url":"http://www.kickstarter.com/projects/getify/you-dont-know-js-book-series","full_name":"getify/You-Dont-Know-JS","description":"A book series on JavaScript. @YDKJS on twitter.","owner_id":150330,"tags":["learning","book"],"delta":24911,"stars":73963,"created_at":"2013-11-16T02:37:24.000Z","monthly":[1618,1630,1454,1609,1967,2181,2304,2422,2573,2897,1782,2474],"icon":"js.svg"},{"name":"ESLint","url":"https://eslint.org","full_name":"eslint/eslint","description":"A fully pluggable tool for identifying and reporting on patterns in JavaScript.","owner_id":6019716,"tags":["lint"],"delta":3268,"stars":10163,"created_at":"2013-06-29T23:59:48.000Z","monthly":[440,330,395,217,276,243,260,203,214,283,205,202]},{"name":"Babylon.js","url":"http://www.babylonjs.com","full_name":"BabylonJS/Babylon.js","description":"Babylon.js: a complete JavaScript framework for building 3D games with HTML 5 and WebGL","owner_id":4855800,"tags":["game","3d","webgl"],"delta":1943,"stars":6042,"created_at":"2013-06-27T20:40:42.000Z","monthly":[194,131,112,121,120,634,117,103,115,115,86,95]},{"name":"Spectacle","url":"http://formidable.com/open-source/spectacle/","full_name":"FormidableLabs/spectacle","description":"ReactJS based Presentation Library","owner_id":5078602,"tags":["presentation"],"delta":1892,"stars":5890,"created_at":"2015-06-30T20:36:07.000Z","monthly":[143,251,162,109,107,127,106,173,163,176,185,190]},{"name":"jQueryUI","url":"https://jqueryui.com/","full_name":"jquery/jquery-ui","description":"The official jQuery user interface library.","owner_id":70142,"tags":["plugin","modal","tree"],"delta":474,"stars":10302,"created_at":"2010-01-19T14:40:34.000Z","monthly":[38,48,36,43,51,32,41,59,47,41,25,13]},{"name":"Ramda","url":"http://ramdajs.com","full_name":"ramda/ramda","description":":ram: Practical functional Javascript","owner_id":5298359,"tags":["fp"],"delta":4036,"stars":10695,"created_at":"2013-06-21T20:32:35.000Z","monthly":[306,324,302,335,347,344,319,285,292,501,254,427]},{"name":"Standard","url":"https://standardjs.com","full_name":"standard/standard","description":"🌟 JavaScript Style Guide, with linter & automatic code fixer","owner_id":29208316,"tags":["lint"],"delta":6763,"stars":15922,"created_at":"2015-01-27T01:23:31.000Z","monthly":[680,763,427,393,393,482,486,448,658,861,589,583],"icon":"https://standardjs.com/favicons/apple-touch-icon-180x180.png"},{"name":"request","url":"","full_name":"request/request","description":"🏊🏾 Simplified HTTP request client.","owner_id":730467,"tags":["http"],"delta":4280,"stars":18244,"created_at":"2011-01-23T01:25:14.000Z","monthly":[366,304,323,341,378,351,375,386,330,426,380,320]},{"name":"Axios","url":"","full_name":"axios/axios","description":"Promise based HTTP client for the browser and node.js","owner_id":32372333,"tags":["http"],"delta":21944,"stars":34477,"created_at":"2014-08-18T22:30:27.000Z","monthly":[1688,1929,1715,1743,1859,1943,1837,1883,1964,2173,1666,1544]},{"name":"superagent","url":"http://visionmedia.github.com/superagent/","full_name":"visionmedia/superagent","description":"Ajax with less suck - (and node.js HTTP client to match)","owner_id":9285252,"tags":["http"],"delta":2514,"stars":12088,"created_at":"2011-04-13T02:29:45.000Z","monthly":[170,177,178,198,232,196,200,238,206,244,221,254]},{"name":"Bluebird","url":"http://bluebirdjs.com","full_name":"petkaantonov/bluebird","description":":bird: :zap: Bluebird is a full featured promise library with unmatched performance.","owner_id":829734,"tags":["flow"],"delta":2702,"stars":16123,"created_at":"2013-09-07T19:39:57.000Z","monthly":[173,172,168,174,196,237,214,206,216,322,247,377]},{"name":"q","url":"http://documentup.com/kriskowal/q/","full_name":"kriskowal/q","description":"A promise library for JavaScript","owner_id":60294,"tags":["flow"],"delta":1137,"stars":13950,"created_at":"2010-09-04T01:21:12.000Z","monthly":[80,79,93,63,94,85,95,104,109,120,117,98]},{"name":"Material Design Lite","url":"http://getmdl.io","full_name":"google/material-design-lite","description":"Material Design Components in HTML/CSS/JS","owner_id":1342004,"tags":["css-lib","material"],"delta":3968,"stars":29423,"created_at":"2015-01-14T22:01:33.000Z","monthly":[163,239,220,244,293,279,334,445,364,492,437,458]},{"name":"React Motion","url":"","full_name":"chenglou/react-motion","description":"A spring that solves your animation problems.","owner_id":1909539,"tags":["react","animation"],"delta":4131,"stars":11654,"created_at":"2015-06-11T07:38:23.000Z","monthly":[340,316,365,303,466,288,288,285,360,366,377,377]},{"name":"Dropzone","url":"http://www.dropzonejs.com","full_name":"enyo/dropzone","description":"Dropzone is an easy to use drag'n'drop library. It supports image previews and shows nice progress b","owner_id":133277,"tags":["dnd"],"delta":1628,"stars":13338,"created_at":"2012-02-12T16:19:18.000Z","monthly":[115,112,106,105,137,135,147,114,169,156,193,139]},{"name":"Masonry","url":"http://masonry.desandro.com","full_name":"desandro/masonry","description":":love_hotel: Cascading grid layout library","owner_id":85566,"tags":["layout"],"delta":1428,"stars":12704,"created_at":"2009-11-21T21:04:56.000Z","monthly":[114,109,97,104,140,112,119,147,135,132,121,98]},{"name":"Pug","url":"https://pugjs.org","full_name":"pugjs/pug","description":"Pug – robust, elegant, feature rich template engine for Node.js","owner_id":9338635,"tags":["template"],"delta":2654,"stars":15912,"created_at":"2010-06-23T01:05:42.000Z","monthly":[182,168,181,187,202,215,222,270,247,272,240,268]},{"name":"PostCSS","url":"http://postcss.org/","full_name":"postcss/postcss","description":"Transforming styles with JS plugins","owner_id":8296347,"tags":["css-tool"],"delta":4060,"stars":17263,"created_at":"2013-09-24T23:06:48.000Z","monthly":[415,227,244,268,342,328,330,361,355,421,367,402]},{"name":"Pikaday","url":"http://dbushell.github.io/Pikaday/","full_name":"dbushell/Pikaday","description":"A refreshing JavaScript Datepicker — lightweight, no dependencies, modular CSS","owner_id":998922,"tags":["plugin","date"],"delta":1076,"stars":5834,"created_at":"2012-10-08T07:51:03.000Z","monthly":[56,66,88,68,73,84,99,80,87,206,77,92]},{"name":"NodeBB","url":"https://nodebb.org","full_name":"NodeBB/NodeBB","description":"Node.js based forum software built for the modern web","owner_id":4449608,"tags":["blog"],"delta":1383,"stars":8235,"created_at":"2013-04-22T16:49:40.000Z","monthly":[140,111,120,109,101,136,120,105,112,109,110,110]},{"name":"Ghost","url":"https://ghost.org","full_name":"TryGhost/Ghost","description":"The platform for professional publishers","owner_id":2178663,"tags":["blog"],"delta":3144,"stars":24772,"created_at":"2013-05-04T11:09:13.000Z","monthly":[192,253,222,242,386,371,208,176,241,312,267,274]},{"name":"React-select","url":"http://jedwatson.github.io/react-select/","full_name":"JedWatson/react-select","description":"A Select control built with and for React JS","owner_id":872310,"tags":["autocomplete","react"],"delta":4282,"stars":10131,"created_at":"2014-08-26T04:27:45.000Z","monthly":[333,708,356,278,305,314,293,336,310,355,385,309]},{"name":"Tape","url":"","full_name":"substack/tape","description":"tap-producing test harness for node and browsers","owner_id":12631,"tags":["test-framework","test"],"delta":1009,"stars":4367,"created_at":"2012-11-25T17:08:02.000Z","monthly":[51,57,54,79,70,65,63,91,105,135,90,149]},{"name":"Guide to FP","url":"","full_name":"MostlyAdequate/mostly-adequate-guide","description":"Mostly adequate guide to FP (in javascript)","owner_id":14079115,"tags":["fp","learning","book"],"delta":2748,"stars":12889,"created_at":"2015-05-06T01:44:15.000Z","monthly":[180,183,212,189,222,170,215,224,256,253,257,387]},{"name":"Angular seed","url":"http://angularjs.org/","full_name":"angular/angular-seed","description":"Seed project for angular apps. ","owner_id":139426,"tags":["angular"],"delta":779,"stars":13203,"created_at":"2010-12-24T06:07:50.000Z","monthly":[29,24,37,22,45,61,58,109,89,77,115,113]},{"name":"Dragula","url":"https://bevacqua.github.io/dragula/","full_name":"bevacqua/dragula","description":":ok_hand: Drag and drop so simple it hurts","owner_id":934293,"tags":["dnd"],"delta":2041,"stars":17134,"created_at":"2015-04-13T21:35:38.000Z","monthly":[116,127,185,145,154,176,150,189,185,202,164,248]},{"name":"React DnD","url":"http://react-dnd.github.io/react-dnd","full_name":"react-dnd/react-dnd","description":"Drag and Drop for React","owner_id":25307599,"tags":["dnd","react"],"delta":2914,"stars":7540,"created_at":"2014-10-19T13:29:28.000Z","monthly":[238,215,253,263,278,202,218,271,290,253,212,221]},{"name":"Paper.js","url":"http://paperjs.org","full_name":"paperjs/paper.js","description":"The Swiss Army Knife of Vector Graphics Scripting – Scriptographer ported to JavaScript and the brow","owner_id":846856,"tags":["drawing"],"delta":1381,"stars":8742,"created_at":"2011-02-07T18:21:30.000Z","monthly":[99,130,132,99,115,110,108,133,98,121,126,110]},{"name":"Devdocs.io","url":"https://devdocs.io","full_name":"Thibaut/devdocs","description":"API Documentation Browser","owner_id":17579,"tags":["learning"],"delta":5204,"stars":16723,"created_at":"2013-10-24T18:16:07.000Z","monthly":[335,412,1416,334,408,288,299,298,351,455,316,292]},{"name":"Video.js","url":"www.videojs.com","full_name":"videojs/video.js","description":"Video.js - open source HTML5 & Flash video player","owner_id":3287189,"tags":["video"],"delta":3989,"stars":18947,"created_at":"2010-05-14T18:45:10.000Z","monthly":[341,326,281,318,401,303,290,409,363,323,314,320]},{"name":"Media Element","url":"http://mediaelementjs.com/","full_name":"mediaelement/mediaelement","description":"HTML5 <audio> or <video> player with support for MP4, WebM, and MP3 as well as HLS, Dash, YouTube, F","owner_id":1226323,"tags":["video"],"delta":1312,"stars":5754,"created_at":"2010-07-28T02:32:56.000Z","monthly":[101,110,94,124,121,110,114,174,117,97,91,59]},{"name":"howler.js","url":"https://howlerjs.com","full_name":"goldfire/howler.js","description":"Javascript audio library for the modern web.","owner_id":882005,"tags":["audio"],"delta":1888,"stars":9236,"created_at":"2013-01-28T16:47:12.000Z","monthly":[161,170,169,170,153,153,183,153,154,142,146,134]},{"name":"FabricJS","url":"http://fabricjs.com","full_name":"kangax/fabric.js","description":"Javascript Canvas Library, SVG-to-Canvas (& canvas-to-SVG) Parser","owner_id":383,"tags":["drawing","svg","canvas"],"delta":2252,"stars":9435,"created_at":"2010-06-09T22:24:38.000Z","monthly":[192,210,173,178,195,172,162,183,193,220,194,180]},{"name":"Less","url":"http://lesscss.org","full_name":"less/less.js","description":"Less. The dynamic stylesheet language.","owner_id":3538330,"tags":["css-tool"],"delta":969,"stars":15344,"created_at":"2010-02-20T17:25:38.000Z","monthly":[70,57,60,77,116,77,101,79,90,90,93,59]},{"name":"nunjucks","url":"https://mozilla.github.io/nunjucks/","full_name":"mozilla/nunjucks","description":"A powerful templating engine with inheritance, asynchronous control, and more (jinja2 inspired)","owner_id":131524,"tags":["template"],"delta":1070,"stars":4900,"created_at":"2012-08-09T05:40:44.000Z","monthly":[69,92,79,93,90,83,89,115,99,99,89,73]},{"name":"cytoscape.js","url":"http://js.cytoscape.org","full_name":"cytoscape/cytoscape.js","description":"Graph theory / network library for analysis and visualisation (supports CommonJS/Node.js/Browserify/","owner_id":956141,"tags":["chart"],"delta":1062,"stars":3843,"created_at":"2011-08-23T15:28:32.000Z","monthly":[75,95,90,76,120,79,115,81,88,75,76,92]},{"name":"Chai","url":"http://chaijs.com","full_name":"chaijs/chai","description":"BDD / TDD assertion framework for node.js and the browser that can be paired with any testing framew","owner_id":1515293,"tags":["test"],"delta":1229,"stars":4961,"created_at":"2011-12-07T08:06:35.000Z","monthly":[113,112,108,99,101,87,83,103,134,112,89,88]},{"name":"Blessed","url":"","full_name":"yaronn/blessed-contrib","description":"Build terminal dashboards using ascii/ansi art and javascript","owner_id":1359037,"tags":["cli","dashboard"],"delta":1796,"stars":10715,"created_at":"2015-01-14T14:18:07.000Z","monthly":[103,93,165,109,147,296,350,86,111,71,104,161]},{"name":"Velocity","url":"VelocityJS.org","full_name":"julianshapiro/velocity","description":"Accelerated JavaScript animation.","owner_id":655026,"tags":["animation"],"delta":2053,"stars":14078,"created_at":"2014-04-09T20:02:38.000Z","monthly":[191,117,133,169,153,147,162,191,214,206,185,185]},{"name":"Johnny-Five","url":"http://johnny-five.io","full_name":"rwaldron/johnny-five","description":"JavaScript Robotics and IoT programming framework, developed at Bocoup.","owner_id":27985,"tags":["iot"],"delta":1308,"stars":8556,"created_at":"2012-03-30T20:09:52.000Z","monthly":[121,114,128,106,126,110,83,109,124,92,89,106]},{"name":"Serverless","url":"http://www.serverless.com","full_name":"serverless/serverless","description":"Serverless Framework – Build web, mobile and IoT applications with serverless architectures using AW","owner_id":13742415,"tags":["microservice","serverless"],"delta":7335,"stars":21318,"created_at":"2015-04-21T03:48:40.000Z","twitter":"","monthly":[497,521,586,553,720,625,586,709,569,713,626,630]},{"name":"Cycle.js","url":"http://cycle.js.org","full_name":"cyclejs/cyclejs","description":"A functional and reactive JavaScript framework for predictable code","owner_id":12686838,"tags":["fp","vdom","framework"],"delta":1999,"stars":7935,"created_at":"2014-11-07T11:28:45.000Z","monthly":[97,102,137,194,238,402,132,108,118,149,161,161]},{"name":"System.js","url":"","full_name":"systemjs/systemjs","description":"Dynamic ES module loader","owner_id":6577368,"tags":["module"],"delta":1154,"stars":8816,"created_at":"2013-05-14T20:45:48.000Z","monthly":[70,58,73,64,94,79,83,96,106,140,132,159]},{"name":"Relay","url":"https://facebook.github.io/relay/","full_name":"facebook/relay","description":"Relay is a JavaScript framework for building data-driven React applications.","owner_id":69631,"tags":["framework","graphql"],"delta":2490,"stars":10348,"created_at":"2015-08-10T22:09:16.000Z","twitter":"","monthly":[206,148,171,161,181,212,191,201,541,193,128,157],"icon":"relay.svg"},{"name":"react-color","url":"http://casesandberg.github.io/react-color/","full_name":"casesandberg/react-color","description":":art: Color Pickers from Sketch, Photoshop, Chrome, Github, Twitter & more","owner_id":4633636,"tags":["react"],"delta":1388,"stars":4618,"created_at":"2015-08-09T18:45:30.000Z","monthly":[102,92,115,130,133,121,110,118,142,112,103,110]},{"name":"Falcor","url":"http://netflix.github.io/falcor","full_name":"Netflix/falcor","description":"A JavaScript library for efficient data fetching","owner_id":913567,"tags":["data"],"delta":1274,"stars":8433,"created_at":"2015-02-13T00:17:50.000Z","monthly":[93,69,159,113,99,104,57,69,72,88,264,87]},{"name":"echarts","url":"http://echarts.baidu.com/","full_name":"ecomfe/echarts","description":"A powerful, interactive charting and visualization library for browser","owner_id":2268460,"tags":["chart"],"delta":7637,"stars":24493,"created_at":"2013-04-03T03:18:59.000Z","monthly":[699,892,557,614,697,737,648,634,611,676,488,384]},{"name":"Leaflet","url":"http://leafletjs.com","full_name":"Leaflet/Leaflet","description":" :leaves: JavaScript library for mobile-friendly interactive maps","owner_id":2854298,"tags":["map"],"delta":3174,"stars":20581,"created_at":"2010-09-22T16:57:44.000Z","monthly":[257,252,246,258,282,235,272,257,271,290,261,293]},{"name":"chroma.js","url":"http://gka.github.io/chroma.js","full_name":"gka/chroma.js","description":"JavaScript library for all kinds of color manipulations","owner_id":617518,"tags":["color"],"delta":1304,"stars":4785,"created_at":"2011-12-12T00:33:02.000Z","monthly":[60,62,66,87,86,84,90,314,308,77,51,19]},{"name":"json-server","url":"","full_name":"typicode/json-server","description":"Get a full fake REST API with zero coding in less than 30 seconds (seriously)","owner_id":5502029,"tags":["test"],"delta":9545,"stars":28243,"created_at":"2013-11-27T13:21:13.000Z","twitter":"","monthly":[671,782,655,628,809,898,1469,850,701,755,720,607]},{"name":"Critical","url":"","full_name":"addyosmani/critical","description":"Extract & Inline Critical-path CSS in HTML pages","owner_id":110953,"tags":["performance"],"delta":2408,"stars":6411,"created_at":"2014-06-28T09:31:42.000Z","monthly":[169,1149,190,88,139,117,82,96,76,123,81,98]},{"name":"Cheerio","url":"https://cheerio.js.org/","full_name":"cheeriojs/cheerio","description":"Fast, flexible, and lean implementation of core jQuery designed specifically for the server.","owner_id":7230330,"tags":["parsing"],"delta":3743,"stars":14711,"created_at":"2011-10-09T04:23:20.000Z","monthly":[340,319,290,301,335,280,282,335,265,383,336,277]},{"name":"nock","url":"","full_name":"node-nock/nock","description":"HTTP mocking and expectations library","owner_id":17545810,"tags":["test"],"delta":1451,"stars":5808,"created_at":"2011-09-22T10:08:03.000Z","monthly":[96,100,140,114,138,133,123,104,137,138,117,111]},{"name":"Electron","url":"https://electronjs.org","full_name":"electron/electron","description":"Build cross platform desktop apps with JavaScript, HTML, and CSS","owner_id":13409222,"tags":["desktop"],"delta":14813,"stars":55513,"created_at":"2013-04-12T01:47:36.000Z","twitter":"electronjs","monthly":[1179,1224,1337,1101,1159,1155,1125,1313,1322,1383,1246,1269]},{"name":"PM2","url":"http://pm2.io/","full_name":"Unitech/pm2","description":"PM2 RE: Production Runtime and Process Manager for Node.js apps with a built-in Load Balancer.","owner_id":757747,"tags":["process"],"delta":6234,"stars":23040,"created_at":"2013-05-21T03:25:25.000Z","monthly":[465,479,511,505,538,606,518,525,480,609,579,419]},{"name":"ACE","url":"https://ace.c9.io","full_name":"ajaxorg/ace","description":"Ace (Ajax.org Cloud9 Editor)","owner_id":168515,"tags":["highlight"],"delta":2456,"stars":16647,"created_at":"2010-10-27T10:43:36.000Z","monthly":[269,209,206,198,224,205,184,261,195,190,164,151]},{"name":"co","url":"","full_name":"tj/co","description":"The ultimate generator based flow-control goodness for nodejs (supports thunks, promises, etc)","owner_id":25254,"tags":["flow"],"delta":1933,"stars":9222,"created_at":"2013-06-06T04:06:16.000Z","monthly":[103,132,86,128,170,153,158,192,167,270,211,163]},{"name":"CodeMirror","url":"http://codemirror.net/","full_name":"codemirror/CodeMirror","description":"In-browser code editor","owner_id":8876537,"tags":["highlight"],"delta":2856,"stars":13733,"created_at":"2011-01-14T13:44:03.000Z","monthly":[249,226,233,251,271,231,223,249,212,273,231,207]},{"name":"TypeScript","url":"http://www.typescriptlang.org","full_name":"Microsoft/TypeScript","description":"TypeScript is a superset of JavaScript that compiles to clean JavaScript output.","owner_id":6154722,"tags":["compiler"],"delta":11564,"stars":30154,"created_at":"2014-06-17T15:28:39.000Z","twitter":"typescriptlang","monthly":[992,1075,1159,818,1041,976,936,928,1074,972,855,738],"icon":"typescript.svg"},{"name":"Fullpage.js","url":"http://alvarotrigo.com/fullPage/","full_name":"alvarotrigo/fullPage.js","description":"fullPage plugin by Alvaro Trigo. Create full screen pages fast and simple","owner_id":1706326,"tags":["scrolling"],"delta":4674,"stars":22023,"created_at":"2013-09-20T11:58:29.000Z","monthly":[322,269,380,460,390,399,387,462,377,443,389,396]},{"name":"Babel","url":"https://babeljs.io/","full_name":"babel/babel","description":":tropical_fish: Babel is a compiler for writing next generation JavaScript.","owner_id":9637642,"tags":["compiler"],"delta":5718,"stars":25398,"created_at":"2014-09-28T13:38:23.000Z","twitter":"babeljs","monthly":[587,1076,564,397,412,371,336,361,395,447,382,390]},{"name":"CoffeeScript","url":"http://coffeescript.org/","full_name":"jashkenas/coffeescript","description":"Unfancy JavaScript","owner_id":4732,"tags":["compiler"],"delta":896,"stars":14520,"created_at":"2009-12-18T01:39:53.000Z","twitter":"","monthly":[37,56,96,118,70,70,62,71,98,63,78,77],"icon":"coffeescript.svg"},{"name":"ws","url":"http://einaros.github.io/ws/","full_name":"websockets/ws","description":"Simple to use, blazing fast and thoroughly tested WebSocket client and server for Node.js","owner_id":10721323,"tags":["realtime","websocket"],"delta":2716,"stars":7348,"created_at":"2011-11-09T22:32:45.000Z","monthly":[284,282,280,217,261,242,197,220,210,208,146,169]},{"name":"Tracking.js","url":"http://trackingjs.com","full_name":"eduardolundgren/tracking.js","description":"A modern approach for Computer Vision on the web","owner_id":113087,"tags":["image"],"delta":1496,"stars":6051,"created_at":"2012-06-18T04:39:34.000Z","monthly":[125,121,151,229,114,176,74,119,92,100,108,87]},{"name":"Feathers","url":"https://feathersjs.com","full_name":"feathersjs/feathers","description":"A REST and realtime API layer for modern applications.","owner_id":5321853,"tags":["nodejs-framework","realtime","express"],"delta":2963,"stars":8270,"created_at":"2011-10-19T22:45:16.000Z","twitter":"FeatherJS","monthly":[165,226,232,190,234,250,258,293,257,280,273,305]},{"name":"Morgan","url":"","full_name":"expressjs/morgan","description":"HTTP request logger middleware for node.js","owner_id":5658226,"tags":["log"],"delta":1103,"stars":3111,"created_at":"2014-02-08T19:19:14.000Z","monthly":[94,98,98,83,115,75,91,101,93,74,93,88]},{"name":"Winston","url":"http://github.com/winstonjs/winston","full_name":"winstonjs/winston","description":"A logger for just about everything.","owner_id":9682013,"tags":["log"],"delta":2440,"stars":9236,"created_at":"2010-12-29T18:49:51.000Z","monthly":[211,245,223,169,212,277,164,158,157,209,241,174]},{"name":"Animate Plus","url":"","full_name":"bendc/animateplus","description":"A+ animation module for the modern web","owner_id":51664,"tags":["animation","svg"],"delta":2071,"stars":4443,"created_at":"2015-05-12T18:54:16.000Z","monthly":[1018,843,22,15,21,15,27,32,10,26,22,20]},{"name":"StackEdit","url":"https://stackedit.io/","full_name":"benweet/stackedit","description":"In-browser Markdown editor","owner_id":1005257,"tags":["md"],"delta":1588,"stars":10746,"created_at":"2013-03-24T13:46:06.000Z","monthly":[151,149,142,153,113,127,78,116,137,179,143,100]},{"name":"CSS Modules","url":"","full_name":"css-modules/css-modules","description":"Documentation about css-modules","owner_id":12612655,"tags":["css-in-js"],"delta":2942,"stars":8860,"created_at":"2015-05-25T21:54:47.000Z","monthly":[217,234,210,194,254,246,307,313,234,272,227,234]},{"name":"node-inspector","url":"","full_name":"node-inspector/node-inspector","description":"Node.js debugger based on Blink Developer Tools","owner_id":4449877,"tags":["debug"],"delta":1073,"stars":11956,"created_at":"2010-07-17T23:20:19.000Z","monthly":[53,58,62,64,102,83,89,96,120,118,105,123]},{"name":"Modernizr","url":"https://modernizr.com","full_name":"Modernizr/Modernizr","description":"Modernizr is a JavaScript library that detects HTML5 and CSS3 features in the user’s browser.","owner_id":131060,"tags":["compatibility"],"delta":2334,"stars":21932,"created_at":"2009-09-25T20:13:23.000Z","monthly":[176,239,228,189,181,179,181,180,224,218,195,144]},{"name":"React Native","url":"http://facebook.github.io/react-native/","full_name":"facebook/react-native","description":"A framework for building native apps with React.","owner_id":69631,"tags":["mobile","react-native"],"delta":15588,"stars":58711,"created_at":"2015-01-09T18:10:16.000Z","twitter":"reactnative","monthly":[1243,1340,1242,1147,1245,1332,1303,1287,1317,1644,1319,1169]},{"name":"MEAN","url":"http://mean.io","full_name":"linnovate/mean","description":"The MEAN stack uses Mongo, Express, Angular(4) and Node for simple and scalable fullstack js applica","owner_id":307487,"tags":["fullstack","nodejs-framework"],"delta":958,"stars":10745,"created_at":"2013-05-22T12:15:47.000Z","twitter":"","monthly":[104,100,109,76,71,73,76,69,85,55,63,77]},{"name":"You might not need jQuery","url":"http://YouMightNotNeedjQuery.com","full_name":"HubSpot/youmightnotneedjquery","description":"A resource for doing things au naturel.","owner_id":326419,"tags":["learning"],"delta":1604,"stars":9793,"created_at":"2014-01-16T00:21:17.000Z","monthly":[110,109,122,105,168,141,113,164,138,154,130,150]},{"name":"Pomelo","url":"http://pomelo.netease.com","full_name":"NetEase/pomelo","description":"A fast,scalable,distributed game server framework for Node.js.","owner_id":1460597,"tags":["game"],"delta":1742,"stars":8739,"created_at":"2012-09-20T02:37:07.000Z","monthly":[141,140,168,153,178,129,126,141,115,206,137,108]},{"name":"NW.js","url":"https://nwjs.io","full_name":"nwjs/nw.js","description":"Call all Node.js modules directly from DOM/WebWorker and enable a new way of writing applications wi","owner_id":10180421,"tags":["desktop"],"delta":2728,"stars":33125,"created_at":"2012-01-04T06:21:10.000Z","monthly":[194,207,208,189,235,178,210,234,267,274,268,264]},{"name":"clipboard.js","url":"https://clipboardjs.com","full_name":"zenorocha/clipboard.js","description":":scissors: Modern copy to clipboard. No Flash. Just 3kb gzipped :clipboard:","owner_id":398893,"tags":["util"],"delta":4917,"stars":20643,"created_at":"2015-09-18T23:04:55.000Z","monthly":[444,417,370,374,458,388,423,441,368,450,388,396]},{"name":"jimp","url":"","full_name":"oliver-moran/jimp","description":"An image processing library written entirely in JavaScript for Node, with zero external or native de","owner_id":414918,"tags":["image"],"delta":3294,"stars":5385,"created_at":"2014-09-13T22:53:45.000Z","monthly":[268,137,148,148,148,114,122,138,134,173,898,866]},{"name":"Gatsby","url":"https://www.gatsbyjs.org","full_name":"gatsbyjs/gatsby","description":"⚛️📄🚀 Blazing fast static site generator for React","owner_id":12551863,"tags":["ssg","react","graphql"],"delta":9665,"stars":17715,"created_at":"2015-05-21T22:43:05.000Z","twitter":"gatsbyjs","monthly":[1172,796,1055,698,664,2058,505,573,438,508,481,717],"icon":"gatsby.svg"},{"name":"Popmotion","url":"https://popmotion.io","full_name":"Popmotion/popmotion","description":"The JavaScript motion engine. Create unique animations and interactions with tweens, physics and inp","owner_id":14272617,"tags":["animation"],"delta":3657,"stars":9226,"created_at":"2014-08-17T16:23:07.000Z","monthly":[3011,13,35,22,41,389,23,14,38,3,29,39]},{"name":"React Starter Kit","url":"https://reactstarter.com","full_name":"kriasoft/react-starter-kit","description":"React Starter Kit — isomorphic web app boilerplate (Node.js, Express, GraphQL, React.js, Babel, Post","owner_id":773036,"tags":["react","isomorphic","boilerplate","graphql"],"delta":4315,"stars":16663,"created_at":"2014-04-16T13:08:18.000Z","monthly":[258,313,347,308,367,350,358,449,417,363,371,414]},{"name":"Sharp","url":"http://sharp.pixelplumbing.com/","full_name":"lovell/sharp","description":"High performance Node.js image processing, the fastest module to resize JPEG, PNG, WebP and TIFF ima","owner_id":210965,"tags":["image"],"delta":2940,"stars":7204,"created_at":"2013-08-19T20:24:24.000Z","monthly":[228,223,259,208,247,210,231,568,196,218,196,156]},{"name":"Node.js","url":"https://nodejs.org","full_name":"nodejs/node","description":"Node.js JavaScript runtime :sparkles::turtle::rocket::sparkles:","owner_id":9950313,"tags":["node.js"],"delta":13713,"stars":44626,"created_at":"2014-11-26T19:57:11.000Z","twitter":"nodejs","monthly":[1008,1464,1792,946,1167,1018,1084,1109,1013,1185,1058,869]},{"name":"Relax","url":"","full_name":"relax/relax","description":"New generation CMS on top of React, Redux and GraphQL","owner_id":13644940,"tags":["cms"],"delta":1080,"stars":7788,"created_at":"2015-08-31T12:16:25.000Z","monthly":[78,53,70,64,96,78,67,79,101,133,133,128]},{"name":"Sequelize","url":"http://docs.sequelizejs.com","full_name":"sequelize/sequelize","description":"An easy-to-use multi SQL dialect ORM for Node.js","owner_id":3591786,"tags":["db"],"delta":4159,"stars":12773,"created_at":"2010-07-22T07:11:11.000Z","monthly":[380,419,382,380,361,373,364,328,300,353,263,256]},{"name":"Recompose","url":"","full_name":"acdlite/recompose","description":"A React utility belt for function components and higher-order components.","owner_id":3624098,"tags":["react"],"delta":5035,"stars":8705,"created_at":"2015-10-07T05:54:51.000Z","monthly":[379,393,396,437,481,437,467,597,426,439,282,301]},{"name":"AMP HTML","url":"https://www.ampproject.org","full_name":"ampproject/amphtml","description":"AMP HTML source code, samples, and documentation.  See below for more info.","owner_id":14114390,"tags":["performance"],"delta":1515,"stars":10885,"created_at":"2015-09-01T22:10:53.000Z","monthly":[70,152,108,86,81,86,113,199,98,170,165,187]},{"name":"photon","url":"photonkit.com","full_name":"connors/photon","description":"The fastest way to build beautiful Electron apps using simple HTML and CSS","owner_id":874145,"tags":["desktop"],"delta":1619,"stars":7993,"created_at":"2015-09-28T04:03:26.000Z","monthly":[110,161,173,115,131,103,114,133,128,142,154,155]},{"name":"Synaptic","url":"http://caza.la/synaptic","full_name":"cazala/synaptic","description":"architecture-free neural network library for node.js and the browser","owner_id":2781777,"tags":["neural","ml"],"delta":2272,"stars":5704,"created_at":"2014-09-30T18:07:03.000Z","monthly":[156,147,197,288,388,130,177,244,141,129,139,136]},{"name":"smartcrop.js","url":"http://29a.ch/2014/04/03/smartcrop-content-aware-image-cropping","full_name":"jwagner/smartcrop.js","description":"Content aware image cropping","owner_id":293536,"tags":["image"],"delta":667,"stars":10166,"created_at":"2014-04-03T14:21:19.000Z","monthly":[38,64,58,46,123,44,44,52,67,54,32,45]},{"name":"Inquirer.js","url":"","full_name":"SBoudrias/Inquirer.js","description":"A collection of common interactive command line user interfaces.","owner_id":923865,"tags":["cli"],"delta":2198,"stars":6085,"created_at":"2013-05-17T01:41:36.000Z","monthly":[331,258,190,163,187,156,156,142,168,186,136,125]},{"name":"Structor","url":"http://helmetrex.com/","full_name":"ipselon/structor","description":"Structor - React UI Builder","owner_id":11865795,"tags":["react"],"delta":1370,"stars":4959,"created_at":"2015-10-17T15:49:40.000Z","monthly":[53,63,586,76,77,69,48,118,80,56,49,95]},{"name":"Nightmare","url":"https://open.segment.com","full_name":"segmentio/nightmare","description":"A high-level browser automation library.","owner_id":819518,"tags":["auto"],"delta":4587,"stars":14630,"created_at":"2014-04-05T22:19:51.000Z","monthly":[227,311,318,324,366,426,333,424,486,539,428,405]},{"name":"Rollup","url":"http://rollupjs.org","full_name":"rollup/rollup","description":"Next-generation ES6 module bundler","owner_id":12554859,"tags":["module","build"],"delta":3526,"stars":11573,"created_at":"2015-05-14T22:26:28.000Z","twitter":"rollupjs","monthly":[362,297,203,200,260,254,289,288,498,270,267,338]},{"name":"Quill","url":"https://quilljs.com","full_name":"quilljs/quill","description":"Quill is a modern WYSIWYG editor built for compatibility and extensibility.","owner_id":7089101,"tags":["rich-text-editor"],"delta":4212,"stars":16330,"created_at":"2012-07-30T23:23:18.000Z","monthly":[348,382,349,335,361,337,403,334,393,357,322,291]},{"name":"isomorphic-fetch","url":"","full_name":"matthew-andrews/isomorphic-fetch","description":"Isomorphic WHATWG Fetch API, for Node & Browserify","owner_id":825088,"tags":["http","isomorphic"],"delta":1707,"stars":5243,"created_at":"2014-11-07T08:46:13.000Z","monthly":[95,99,117,116,139,155,145,149,168,184,171,169]},{"name":"Mongoose","url":"http://mongoosejs.com","full_name":"Automattic/mongoose","description":"MongoDB object modeling designed to work in an asynchronous environment.","owner_id":887802,"tags":["db"],"delta":3253,"stars":14566,"created_at":"2010-04-06T21:39:05.000Z","monthly":[280,324,282,233,267,281,276,292,246,272,261,239]},{"name":"React toolbox","url":"http://www.react-toolbox.io","full_name":"react-toolbox/react-toolbox","description":"A set of React components implementing Google's Material Design specification with the power of CSS ","owner_id":13482715,"tags":["material","react","component"],"delta":2462,"stars":7547,"created_at":"2015-05-27T15:23:33.000Z","monthly":[111,87,185,170,217,171,197,285,233,238,267,301]},{"name":"Sortable","url":"http://rubaxa.github.io/Sortable/","full_name":"RubaXa/Sortable","description":"Sortable — is a JavaScript library for reorderable drag-and-drop lists on modern browsers and touch ","owner_id":1109562,"tags":["dnd"],"delta":3284,"stars":12383,"created_at":"2013-12-19T10:10:13.000Z","monthly":[279,282,261,312,307,282,287,245,286,260,261,222]},{"name":"AVA","url":"","full_name":"avajs/ava","description":":rocket: Futuristic JavaScript test runner","owner_id":8527916,"tags":["test-framework","test"],"delta":4763,"stars":12523,"created_at":"2014-11-18T17:20:26.000Z","twitter":"ava__js","monthly":[245,294,321,260,303,315,304,358,377,452,522,1012]},{"name":"MathJax","url":"http://www.mathjax.org/","full_name":"mathjax/MathJax","description":"Beautiful math in all browsers","owner_id":252187,"tags":["math"],"delta":1107,"stars":4841,"created_at":"2010-08-19T03:28:53.000Z","monthly":[117,106,93,77,80,76,91,103,114,119,66,65]},{"name":"plotly.js","url":"https://plot.ly/javascript/","full_name":"plotly/plotly.js","description":"The open source JavaScript graphing library that powers plotly","owner_id":5997976,"tags":["chart"],"delta":1652,"stars":7505,"created_at":"2015-11-05T23:27:17.000Z","monthly":[166,183,143,103,148,147,147,106,133,160,137,79]},{"name":"mo · js","url":"http://mojs.io/","full_name":"legomushroom/mojs","description":"motion graphics toolbelt for the web","owner_id":1478800,"tags":["animation"],"delta":3851,"stars":12781,"created_at":"2014-06-26T08:49:14.000Z","monthly":[276,151,144,144,122,126,105,163,124,170,235,2091]},{"name":"GraphQL","url":"http://facebook.github.io/graphql/","full_name":"facebook/graphql","description":"GraphQL is a query language and execution engine tied to any backend service.","owner_id":69631,"tags":["data","graphql"],"delta":2793,"stars":7095,"created_at":"2015-07-01T01:26:56.000Z","twitter":"graphql","monthly":[276,212,244,250,210,220,250,323,250,266,165,127],"icon":"graphql.svg"},{"name":"Passport","url":"http://passportjs.org","full_name":"jaredhanson/passport","description":"Simple, unobtrusive authentication for Node.js.","owner_id":10355,"tags":["auth"],"delta":2843,"stars":12453,"created_at":"2011-10-08T22:38:32.000Z","monthly":[210,243,250,235,219,258,226,266,241,246,213,236],"icon":"https://s3-us-west-2.amazonaws.com/svgporn.com/logos/passport.svg"},{"name":"VS Code","url":"https://code.visualstudio.com","full_name":"Microsoft/vscode","description":"Visual Studio Code","owner_id":6154722,"tags":["ide"],"delta":20169,"stars":42501,"created_at":"2015-09-03T20:23:38.000Z","twitter":"code","monthly":[1792,2642,2473,1599,1600,1413,1324,1538,1677,1839,1375,897],"icon":"vscode.svg"},{"name":"vivus","url":"","full_name":"maxwellito/vivus","description":"JavaScript library to make drawing animation on SVG","owner_id":1097232,"tags":["animation","svg"],"delta":1882,"stars":9714,"created_at":"2014-05-13T22:22:18.000Z","monthly":[134,184,134,200,186,111,133,195,151,176,160,118]},{"name":"virtual-dom","url":"","full_name":"Matt-Esch/virtual-dom","description":"A Virtual DOM and diffing algorithm","owner_id":1058839,"tags":["vdom"],"delta":1466,"stars":8705,"created_at":"2014-01-23T17:12:21.000Z","monthly":[105,103,111,142,102,122,107,122,123,200,137,92]},{"name":"supertest","url":"","full_name":"visionmedia/supertest","description":"Super-agent driven library for testing node.js HTTP servers using a fluent API","owner_id":9285252,"tags":["test"],"delta":1660,"stars":6226,"created_at":"2012-06-27T20:56:12.000Z","monthly":[143,114,126,131,140,112,163,147,160,143,141,140]},{"name":"Solved by Flexbox","url":"https://philipwalton.github.io/solved-by-flexbox/","full_name":"philipwalton/solved-by-flexbox","description":"A showcase of problems once hard or impossible to solve with CSS alone, now made trivially easy with","owner_id":326742,"tags":["learning"],"delta":1493,"stars":10714,"created_at":"2013-08-31T23:04:51.000Z","monthly":[95,108,110,82,112,121,116,189,104,135,174,147]},{"name":"Enzyme","url":"http://airbnb.io/enzyme/","full_name":"airbnb/enzyme","description":"JavaScript Testing utilities for React","owner_id":698437,"tags":["test","react"],"delta":4385,"stars":12408,"created_at":"2015-11-10T21:45:38.000Z","monthly":[382,408,411,380,344,341,325,342,399,369,362,322]},{"name":"marked","url":"","full_name":"chjj/marked","description":"A markdown parser and compiler. Built for speed.","owner_id":470564,"tags":["md"],"delta":3590,"stars":15137,"created_at":"2011-07-24T13:15:51.000Z","monthly":[277,272,272,314,287,272,285,309,320,343,318,321]},{"name":"Swiper","url":"http://idangero.us/swiper/","full_name":"nolimits4web/swiper","description":"Most modern mobile touch slider with hardware accelerated transitions","owner_id":999588,"tags":["nav"],"delta":4290,"stars":15010,"created_at":"2012-03-14T19:11:45.000Z","monthly":[309,364,334,333,359,344,325,328,358,618,320,298]},{"name":"Framework7","url":"http://framework7.io","full_name":"framework7io/framework7","description":"Full featured HTML framework for building iOS & Android apps","owner_id":31954178,"tags":["mobile"],"delta":2883,"stars":11584,"created_at":"2014-02-23T12:15:53.000Z","monthly":[232,208,247,230,246,235,255,254,248,274,222,232]},{"name":"react virtualized","url":"http://www.reactvirtualized.com","full_name":"bvaughn/react-virtualized","description":"React components for efficiently rendering large lists and tabular data","owner_id":29597,"tags":["react","scrolling"],"delta":4068,"stars":8572,"created_at":"2015-11-03T00:48:07.000Z","monthly":[373,372,337,264,310,344,336,395,390,389,299,259]},{"name":"ScrollReveal","url":"https://scrollrevealjs.org/","full_name":"jlmakes/scrollreveal","description":"Easy scroll animations for web and mobile browsers.","owner_id":2044842,"tags":["scrolling"],"delta":2896,"stars":14275,"created_at":"2014-01-16T17:37:20.000Z","monthly":[231,273,255,230,260,258,212,269,280,236,188,204]},{"name":"aframe","url":"https://aframe.io/","full_name":"aframevr/aframe","description":":a: web framework for building virtual reality experiences.","owner_id":16024092,"tags":["virtual"],"delta":2927,"stars":7363,"created_at":"2015-09-15T02:04:40.000Z","monthly":[208,188,256,296,247,231,248,177,296,291,224,265]},{"name":"Strapi","url":"https://strapi.io","full_name":"strapi/strapi","description":":rocket: Node.js Content Management Framework (headless-CMS) to build powerful API with no effort.","owner_id":19872173,"tags":["api"],"delta":1527,"stars":2724,"created_at":"2015-09-30T15:34:48.000Z","monthly":[301,299,360,69,78,79,59,62,51,49,52,68]},{"name":"Victory","url":"http://formidable.com/open-source/victory/","full_name":"FormidableLabs/victory","description":"A collection of composable React components for building interactive data visualizations","owner_id":5078602,"tags":["chart","react","d3"],"delta":1876,"stars":5466,"created_at":"2015-07-02T22:36:50.000Z","monthly":[76,114,149,172,231,162,143,150,148,280,118,133]},{"name":"BrowserSync","url":"http://browsersync.io/","full_name":"BrowserSync/browser-sync","description":"Keep multiple browsers & devices in sync when building websites. http://browsersync.io","owner_id":10654171,"tags":["test"],"delta":1404,"stars":9558,"created_at":"2013-10-12T19:35:45.000Z","monthly":[79,78,133,106,127,118,115,143,132,135,118,120]},{"name":"LocalForage","url":"https://localforage.github.io/localForage","full_name":"localForage/localForage","description":"💾 Offline storage, improved. Wraps IndexedDB, WebSQL, or localStorage using a simple but powerful A","owner_id":18673496,"tags":["offline"],"delta":3646,"stars":10885,"created_at":"2013-10-31T00:10:06.000Z","monthly":[268,187,218,201,225,202,217,197,175,281,306,1169]},{"name":"joi","url":"","full_name":"hapijs/joi","description":"Object schema validation","owner_id":3774533,"tags":["json","validation"],"delta":2627,"stars":6875,"created_at":"2012-09-16T16:38:06.000Z","monthly":[195,312,274,263,234,247,205,193,183,192,159,170]},{"name":"redux-form","url":"http://redux-form.com","full_name":"erikras/redux-form","description":"A Higher Order Component using react-redux to keep form state in a Redux store","owner_id":4396759,"tags":["form","redux"],"delta":3710,"stars":8667,"created_at":"2015-07-31T16:07:03.000Z","monthly":[274,313,284,259,313,308,310,269,333,377,358,312]},{"name":"React Redux Universal Hot Example","url":"","full_name":"erikras/react-redux-universal-hot-example","description":"A starter boilerplate for a universal webapp using express, react, redux, webpack, and react-transfo","owner_id":4396759,"tags":["boilerplate","react","redux"],"delta":2281,"stars":10825,"created_at":"2015-06-23T16:39:21.000Z","monthly":[103,105,128,135,162,210,164,219,238,261,274,282]},{"name":"Este","url":"","full_name":"este/este","description":"Explore the source code.","owner_id":3302034,"tags":["boilerplate","react","redux"],"delta":1045,"stars":5317,"created_at":"2013-02-16T03:30:38.000Z","monthly":[30,25,41,29,59,80,82,98,149,161,172,119]},{"name":"React boilerplate","url":"https://www.reactboilerplate.com","full_name":"react-boilerplate/react-boilerplate","description":":fire: A highly scalable, offline-first foundation with the best developer experience and a focus on","owner_id":25323389,"tags":["boilerplate","react","redux","offline"],"delta":5335,"stars":16781,"created_at":"2015-02-18T14:36:32.000Z","monthly":[338,343,391,330,351,401,380,413,503,557,607,721]},{"name":"Milligram","url":"https://milligram.io","full_name":"milligram/milligram","description":"A minimalist CSS framework.","owner_id":16243913,"tags":["css-lib"],"delta":2054,"stars":6817,"created_at":"2015-12-10T17:03:36.000Z","monthly":[95,112,82,90,126,140,109,459,137,113,140,451]},{"name":"Skeleton","url":"http://www.getskeleton.com","full_name":"dhg/Skeleton","description":"Skeleton: A Dead Simple, Responsive Boilerplate for Mobile-Friendly Development","owner_id":693790,"tags":["css-lib"],"delta":1817,"stars":15166,"created_at":"2011-04-30T20:04:24.000Z","monthly":[127,118,122,124,192,152,135,175,173,173,163,163]},{"name":"Highlight.js","url":"https://highlightjs.org/","full_name":"isagalaev/highlight.js","description":"Javascript syntax highlighter","owner_id":99931,"tags":["highlight"],"delta":2465,"stars":11476,"created_at":"2011-01-01T23:47:21.000Z","monthly":[203,220,156,209,211,210,201,237,186,215,206,211]},{"name":"jsonwebtoken","url":"","full_name":"auth0/node-jsonwebtoken","description":"JsonWebToken implementation for node.js http://self-issued.info/docs/draft-ietf-oauth-json-web-token","owner_id":2824157,"tags":["auth"],"delta":2579,"stars":6665,"created_at":"2013-07-01T01:28:43.000Z","monthly":[231,241,211,225,212,233,204,228,200,224,181,189]},{"name":"VerbalExpressions","url":"","full_name":"VerbalExpressions/JSVerbalExpressions","description":"JavaScript Regular expressions made easy","owner_id":5083777,"tags":["regexp"],"delta":492,"stars":10336,"created_at":"2013-07-19T14:59:46.000Z","monthly":[36,110,73,28,54,55,19,27,1,38,22,29]},{"name":"es6-promise","url":"","full_name":"stefanpenner/es6-promise","description":"A polyfill for ES6-style Promises","owner_id":1377,"tags":["flow"],"delta":1355,"stars":5350,"created_at":"2013-12-09T12:04:03.000Z","monthly":[103,100,88,103,122,116,113,98,124,140,126,122]},{"name":"React Slingshot","url":"","full_name":"coryhouse/react-slingshot","description":"React + Redux starter kit / boilerplate with Babel, hot reloading, testing, linting and a working ex","owner_id":1688997,"tags":["boilerplate","react","redux"],"delta":2421,"stars":8026,"created_at":"2015-12-31T22:04:53.000Z","monthly":[119,159,280,170,128,199,180,204,219,249,283,231]},{"name":"Inferno","url":"http://infernojs.org","full_name":"infernojs/inferno","description":"An extremely fast, React-like JavaScript library for building modern user interfaces","owner_id":14214240,"tags":["vdom","framework"],"delta":4595,"stars":12071,"created_at":"2015-02-01T22:07:38.000Z","twitter":"inferno_js","monthly":[116,149,151,500,364,239,193,276,237,375,396,1599]},{"name":"Preact","url":"https://preactjs.com","full_name":"developit/preact","description":"⚛️ Fast 3kB React alternative with the same modern API. Components & Virtual DOM.","owner_id":105127,"tags":["vdom","framework"],"delta":10431,"stars":17281,"created_at":"2015-09-11T02:40:18.000Z","twitter":"preactjs","monthly":[532,401,545,1942,2047,729,920,829,634,575,498,779],"icon":"preact.svg"},{"name":"Medium editor","url":"https://yabwe.github.io/medium-editor/","full_name":"yabwe/medium-editor","description":"Medium.com WYSIWYG editor clone. Uses contenteditable API to implement a rich text solution.","owner_id":12655868,"tags":["rich-text-editor"],"delta":1815,"stars":11664,"created_at":"2013-05-29T17:40:11.000Z","monthly":[128,161,132,134,142,184,113,142,151,177,177,174]},{"name":"Bulma","url":"https://bulma.io","full_name":"jgthms/bulma","description":"Modern CSS framework based on Flexbox","owner_id":1254808,"tags":["css-lib"],"delta":11989,"stars":23746,"created_at":"2016-01-23T23:48:34.000Z","monthly":[778,1005,1664,888,1089,1075,873,907,840,927,867,1076]},{"name":"micro","url":"https://zeit.co/blog/micro-8","full_name":"zeit/micro","description":"Asynchronous HTTP microservices","owner_id":14985020,"tags":["microservice","nodejs-framework"],"delta":3156,"stars":5900,"created_at":"2016-01-23T05:17:00.000Z","twitter":"","monthly":[157,223,198,230,419,244,177,273,252,272,277,434]},{"name":"mjml","url":"https://mjml.io","full_name":"mjmlio/mjml","description":"MJML: the only framework that makes responsive-email easy","owner_id":16115896,"tags":["email"],"delta":1942,"stars":6144,"created_at":"2016-01-28T14:04:05.000Z","monthly":[118,102,165,89,111,101,106,99,106,144,208,593]},{"name":"Nodemailer","url":"http://nodemailer.com/","full_name":"nodemailer/nodemailer","description":"✉️ Send e-mails with Node.JS – easy as cake!","owner_id":16486629,"tags":["email"],"delta":1781,"stars":8887,"created_at":"2011-01-19T21:17:36.000Z","monthly":[132,143,135,153,170,169,126,171,135,157,137,153]},{"name":"Recharts","url":"http://recharts.org","full_name":"recharts/recharts","description":"Redefined chart library built with React and D3","owner_id":13690587,"tags":["chart","react","d3","svg"],"delta":3212,"stars":7760,"created_at":"2015-08-07T06:50:27.000Z","monthly":[239,321,250,276,268,265,254,275,288,260,250,266]},{"name":"GrapeJS","url":"http://grapesjs.com","full_name":"artf/grapesjs","description":"Free and Open source Web Builder Framework. Next generation tool for building templates without codi","owner_id":11614725,"tags":["rich-text-editor"],"delta":1475,"stars":3152,"created_at":"2016-01-22T00:23:19.000Z","monthly":[194,193,227,148,133,99,129,98,78,52,39,85]},{"name":"Mermaid","url":"http://knsv.github.io/mermaid/","full_name":"knsv/mermaid","description":"Generation of diagram and flowchart from text in a similar manner as markdown","owner_id":5837277,"tags":["chart","d3"],"delta":5783,"stars":15142,"created_at":"2014-11-01T23:52:32.000Z","monthly":[256,274,272,266,399,209,266,171,257,290,315,2808]},{"name":"MERN Starter","url":"http://mern.io","full_name":"Hashnode/mern-starter","description":"Boilerplate for getting started with MERN stack","owner_id":16342708,"tags":["boilerplate","redux","fullstack","react","nodejs-framework"],"delta":1021,"stars":4343,"created_at":"2016-01-29T14:40:26.000Z","twitter":"","monthly":[72,80,63,77,65,98,90,84,96,102,90,104]},{"name":"Draft.js","url":"https://draftjs.org/","full_name":"facebook/draft-js","description":"A React framework for building text editors.","owner_id":69631,"tags":["rich-text-editor"],"delta":3209,"stars":11905,"created_at":"2016-02-19T20:18:26.000Z","monthly":[234,283,218,210,213,267,234,328,269,323,267,363]},{"name":"Razzle","url":"","full_name":"jaredpalmer/razzle","description":"✨ Create server-rendered universal JavaScript applications with no configuration","owner_id":4060187,"tags":["boilerplate","isomorphic","scaffolding","react"],"delta":1684,"stars":3023,"created_at":"2016-02-10T18:34:27.000Z","monthly":[180,233,182,146,331,98,84,196,44,54,62,74]},{"name":"Adonis","url":"http://adonisjs.com","full_name":"adonisjs/adonis-framework","description":"NodeJs Web Application Framework. Makes it easy for you to write webapps with less code :smiley:","owner_id":13810373,"tags":["nodejs-framework"],"delta":1913,"stars":3446,"created_at":"2015-08-15T17:03:54.000Z","twitter":"adonisframework","monthly":[199,252,141,196,113,121,104,133,183,154,144,173]},{"name":"react-vis","url":"https://uber.github.io/react-vis","full_name":"uber/react-vis","description":"Data-Visualization oriented components","owner_id":538264,"tags":["chart","react"],"delta":1212,"stars":2798,"created_at":"2016-02-22T20:45:50.000Z","monthly":[90,133,131,108,156,97,74,104,116,68,71,64]},{"name":"rebass","url":"http://jxnblk.com/rebass","full_name":"jxnblk/rebass","description":"Functional React UI component library, built with styled-components","owner_id":3451712,"tags":["react","component"],"delta":1382,"stars":3369,"created_at":"2015-02-11T14:48:09.000Z","monthly":[50,59,68,115,144,688,31,35,46,48,47,51]},{"name":"Tachyons","url":"http://tachyons.io","full_name":"tachyons-css/tachyons","description":"Functional css for humans","owner_id":15205635,"tags":["css-lib"],"delta":2668,"stars":6193,"created_at":"2013-11-04T10:41:59.000Z","monthly":[173,262,238,205,295,192,223,219,308,209,144,200]},{"name":"Handlebars.js","url":"http://handlebarsjs.com","full_name":"wycats/handlebars.js","description":"Handlebars provides the power necessary to let you build semantic templates effectively with no frus","owner_id":4,"tags":["template"],"delta":1513,"stars":12864,"created_at":"2010-07-31T18:54:46.000Z","monthly":[100,113,113,97,147,138,127,126,141,176,126,109]},{"name":"Popper.js","url":"https://popper.js.org","full_name":"FezVrasta/popper.js","description":"A kickass library to manage your poppers","owner_id":5382443,"tags":["tooltip"],"delta":3815,"stars":7374,"created_at":"2016-03-29T17:00:47.000Z","monthly":[345,369,414,400,683,242,207,198,563,211,60,123]},{"name":"mobx","url":"http://mobx.js.org","full_name":"mobxjs/mobx","description":"Simple, scalable state management.","owner_id":17475736,"tags":["state"],"delta":6156,"stars":12903,"created_at":"2015-03-14T14:31:38.000Z","monthly":[480,439,429,422,579,517,437,558,484,710,541,560]},{"name":"uWebSockets","url":"https://gitter.im/uWebSockets-chat/","full_name":"uNetworking/uWebSockets","description":"Tiny WebSockets","owner_id":28876608,"tags":["realtime","websocket"],"delta":3613,"stars":8420,"created_at":"2016-03-21T04:39:40.000Z","monthly":[132,151,168,141,148,149,208,278,173,201,1563,301]},{"name":"Phenomic","url":"https://phenomic.io/","full_name":"phenomic/phenomic","description":"Modular website compiler ⚡️","owner_id":28756976,"tags":["ssg","react"],"delta":1397,"stars":2793,"created_at":"2015-09-01T09:40:57.000Z","twitter":"phenomic_app","monthly":[67,42,77,50,59,92,125,127,103,123,392,140]},{"name":"mustache.js","url":"http://mustache.github.com/","full_name":"janl/mustache.js","description":"Minimal templating with {{mustaches}} in JavaScript","owner_id":11321,"tags":["template"],"delta":1330,"stars":11612,"created_at":"2009-10-04T23:41:19.000Z","monthly":[112,108,111,104,109,119,100,116,122,117,104,108]},{"name":"Nightwatch","url":"http://nightwatchjs.org","full_name":"nightwatchjs/nightwatch","description":"Automated testing and continous integration framework based on node.js and selenium webdriver","owner_id":12559275,"tags":["auto"],"delta":2003,"stars":7681,"created_at":"2012-03-17T21:28:18.000Z","monthly":[131,133,132,157,239,173,147,184,163,234,160,150]},{"name":"WebdriverIO","url":"http://webdriver.io","full_name":"webdriverio/webdriverio","description":"A Node.js bindings implementation for the W3C WebDriver protocol","owner_id":6512473,"tags":["auto"],"delta":1111,"stars":3688,"created_at":"2011-08-30T19:02:35.000Z","monthly":[80,94,90,67,93,90,79,99,158,113,72,76]},{"name":"jsdom","url":"","full_name":"tmpvar/jsdom","description":"A JavaScript implementation of the WHATWG DOM and HTML standards, for use with node.js","owner_id":46673,"tags":["test"],"delta":2054,"stars":9065,"created_at":"2010-01-19T06:55:19.000Z","monthly":[163,220,206,139,180,183,167,177,181,174,123,141]},{"name":"Web Fundamentals","url":"https://developers.google.com/web/fundamentals","full_name":"google/WebFundamentals","description":"Best practices for modern web development","owner_id":1342004,"tags":["learning"],"delta":1400,"stars":8296,"created_at":"2014-04-28T18:45:45.000Z","monthly":[165,140,136,86,71,103,108,119,111,148,117,96]},{"name":"nodemon","url":"http://nodemon.io/","full_name":"remy/nodemon","description":"Monitor for any changes in your node.js application and automatically restart the server - perfect f","owner_id":13700,"tags":["process"],"delta":3608,"stars":13301,"created_at":"2010-10-03T12:50:52.000Z","monthly":[328,318,296,268,316,308,296,293,306,298,291,290]},{"name":"brain","url":"http://brain.js.org","full_name":"BrainJS/brain.js","description":"🤖 Neural networks in JavaScript","owner_id":23732838,"tags":["neural","ml"],"delta":1087,"stars":1644,"created_at":"2016-02-13T18:09:44.000Z","monthly":[110,132,111,98,97,115,124,118,72,38,44,28]},{"name":"Plyr","url":"http://plyr.io","full_name":"sampotts/plyr","description":"A simple HTML5, YouTube and Vimeo player","owner_id":719092,"tags":["video"],"delta":1575,"stars":10465,"created_at":"2015-02-14T11:33:07.000Z","monthly":[144,162,157,130,139,110,117,126,126,144,108,112]},{"name":"PouchDB","url":"https://pouchdb.com/","full_name":"pouchdb/pouchdb","description":":koala: - PouchDB is a pocket-sized database.","owner_id":3406112,"tags":["realtime","db"],"delta":1902,"stars":9993,"created_at":"2010-06-10T18:34:24.000Z","monthly":[130,139,173,128,146,124,141,152,148,205,198,218]},{"name":"date-fns","url":"https://date-fns.org","full_name":"date-fns/date-fns","description":"⏳ Modern JavaScript date utility library ⌛️","owner_id":14921202,"tags":["date"],"delta":4744,"stars":8774,"created_at":"2014-10-06T10:24:22.000Z","monthly":[568,1334,418,304,405,396,180,153,190,203,190,403]},{"name":"Push","url":"https://pushjs.org","full_name":"Nickersoft/push.js","description":"The world's most versatile desktop notifications framework :earth_americas:","owner_id":2104129,"tags":["notify"],"delta":1508,"stars":7093,"created_at":"2015-07-20T01:46:04.000Z","monthly":[114,88,170,403,160,70,90,60,80,98,75,100]},{"name":"Spectre.css","url":"https://picturepan2.github.io/spectre/","full_name":"picturepan2/spectre","description":"Spectre.css - a Lightweight, Responsive and Modern CSS Framework","owner_id":126385,"tags":["css-lib"],"delta":2249,"stars":5700,"created_at":"2016-03-07T11:53:15.000Z","monthly":[188,155,147,177,199,245,135,308,185,351,91,68]},{"name":"forever","url":"http://github.com/foreverjs/forever","full_name":"foreverjs/forever","description":"A simple CLI tool for ensuring that a given script runs continuously (i.e. forever)","owner_id":10152066,"tags":["process"],"delta":1616,"stars":10686,"created_at":"2010-09-27T15:47:23.000Z","monthly":[132,129,142,133,135,123,106,152,142,140,135,147]},{"name":"redux-actions","url":"","full_name":"reduxactions/redux-actions","description":"Flux Standard Action utilities for Redux.","owner_id":30840905,"tags":["redux"],"delta":1919,"stars":4447,"created_at":"2015-07-01T21:08:45.000Z","monthly":[120,148,129,142,158,152,168,173,174,200,194,161]},{"name":"redux-saga","url":"https://redux-saga.js.org/","full_name":"redux-saga/redux-saga","description":"An alternative side effect model for Redux apps","owner_id":24776643,"tags":["redux"],"delta":5620,"stars":11567,"created_at":"2015-11-29T16:58:12.000Z","monthly":[409,481,458,410,503,413,492,443,483,581,427,520]},{"name":"barba.js","url":"http://barbajs.org","full_name":"luruke/barba.js","description":"Create badass, fluid and smooth transition between your website's pages.","owner_id":61326,"tags":["nav"],"delta":1998,"stars":5856,"created_at":"2015-11-12T20:08:53.000Z","monthly":[95,100,103,168,113,109,213,233,671,72,67,54]},{"name":"PhantomJS","url":"http://phantomjs.org","full_name":"ariya/phantomjs","description":"Scriptable Headless WebKit","owner_id":7288,"tags":["auto"],"delta":3633,"stars":24354,"created_at":"2010-12-27T08:18:58.000Z","monthly":[249,279,236,272,304,253,309,330,344,415,332,310]},{"name":"Waypoints","url":"http://imakewebthings.com/waypoints/","full_name":"imakewebthings/waypoints","description":"Waypoints is a library that makes it easy to execute a function whenever you scroll to an element.","owner_id":406639,"tags":["scrolling"],"delta":1071,"stars":9061,"created_at":"2011-01-25T07:46:22.000Z","monthly":[67,109,92,118,96,73,76,86,96,93,83,82]},{"name":"Choo","url":"https://choo.io/","full_name":"choojs/choo","description":":steam_locomotive::train: - sturdy 4kb frontend framework","owner_id":29929674,"tags":["framework"],"delta":1746,"stars":4990,"created_at":"2016-05-10T17:50:35.000Z","monthly":[92,125,121,113,118,103,163,355,111,168,106,171]},{"name":"flatpickr","url":"https://chmln.github.io/flatpickr","full_name":"chmln/flatpickr","description":"lightweight and powerful datetimepicker with no dependencies","owner_id":11352152,"tags":["plugin","date"],"delta":4342,"stars":9342,"created_at":"2015-08-10T23:52:45.000Z","monthly":[176,196,244,192,384,242,219,198,198,397,215,1681]},{"name":"anime.js","url":"http://animejs.com","full_name":"juliangarnier/anime","description":"JavaScript Animation Engine","owner_id":1268691,"tags":["animation"],"delta":7578,"stars":18190,"created_at":"2016-03-13T21:37:45.000Z","monthly":[1262,522,875,888,574,483,613,541,601,442,351,426]},{"name":"Grommet","url":"https://grommet.github.io","full_name":"grommet/grommet","description":"Focus on the essential experience","owner_id":14203820,"tags":["react","component"],"delta":1515,"stars":2811,"created_at":"2015-03-24T08:54:10.000Z","monthly":[122,110,101,104,135,113,150,145,140,129,107,159]},{"name":"NativeBase","url":"https://nativebase.io/","full_name":"GeekyAnts/NativeBase","description":"Essential cross-platform UI components for React Native","owner_id":18482943,"tags":["react-native","mobile"],"delta":4402,"stars":7384,"created_at":"2016-04-15T11:37:23.000Z","monthly":[326,311,272,322,335,344,381,403,414,433,546,315]},{"name":"debug","url":"","full_name":"visionmedia/debug","description":"A tiny JavaScript debugging utility modelled after Node.js core's debugging technique. Works in Node","owner_id":9285252,"tags":["debug","log"],"delta":1557,"stars":5463,"created_at":"2011-11-29T02:23:54.000Z","monthly":[128,145,177,198,147,116,96,114,104,117,103,112]},{"name":"Node-tap","url":"http://www.node-tap.org/","full_name":"tapjs/node-tap","description":"Test Anything Protocol tools for node","owner_id":16528145,"tags":["test-framework","test"],"delta":245,"stars":1158,"created_at":"2011-03-21T18:02:54.000Z"},{"name":"Helmet","url":"https://helmetjs.github.io/","full_name":"helmetjs/helmet","description":"Help secure Express apps with various HTTP headers","owner_id":8338613,"tags":["express"],"delta":1386,"stars":4161,"created_at":"2012-02-01T22:54:45.000Z","monthly":[112,170,101,107,111,134,179,96,79,94,101,102]},{"name":"You Don't Need JavaScript","url":"","full_name":"you-dont-need/You-Dont-Need-JavaScript","description":"CSS is powerful, you can do a lot of things without JS.","owner_id":21141794,"tags":["learning"],"delta":1227,"stars":9641,"created_at":"2016-07-05T07:30:42.000Z","monthly":[93,105,128,135,61,91,110,89,91,67,77,180]},{"name":"Slate","url":"http://slatejs.org","full_name":"ianstormtaylor/slate","description":"A completely customizable framework for building rich text editors.","owner_id":311752,"tags":["rich-text-editor"],"delta":3560,"stars":6441,"created_at":"2016-06-18T01:52:42.000Z","monthly":[167,240,381,87,86,128,116,395,1685,123,77,75]},{"name":"Hyper","url":"https://hyper.is","full_name":"zeit/hyper","description":"A terminal built on web technologies","owner_id":14985020,"tags":["cli"],"delta":6894,"stars":20827,"created_at":"2016-07-01T06:01:21.000Z","monthly":[439,488,504,491,492,527,529,540,490,831,627,936]},{"name":"cleave.js","url":"http://nosir.github.io/cleave.js","full_name":"nosir/cleave.js","description":"Format input text content when you are typing...","owner_id":352617,"tags":["plugin"],"delta":1381,"stars":7844,"created_at":"2016-05-18T12:45:03.000Z","monthly":[101,112,99,130,131,101,111,92,140,155,103,106]},{"name":"Create React App","url":"","full_name":"facebookincubator/create-react-app","description":"Create React apps with no build configuration.","owner_id":19538647,"tags":["boilerplate","react"],"delta":22546,"stars":41439,"created_at":"2016-07-17T14:55:11.000Z","monthly":[1521,1701,1740,1474,2251,1864,1791,2239,1776,2284,1831,2074]},{"name":"Text Mask","url":"https://text-mask.github.io/text-mask/","full_name":"text-mask/text-mask","description":"Input mask for React, Angular, Ember, Vue, & plain JavaScript","owner_id":21117230,"tags":["plugin"],"delta":1140,"stars":2519,"created_at":"2016-01-22T23:19:59.000Z","monthly":[81,73,76,125,180,72,84,91,92,121,67,78]},{"name":"Fuse.js","url":"http://fusejs.io/","full_name":"krisk/Fuse","description":"Lightweight fuzzy-search, in JavaScript","owner_id":565580,"tags":["search"],"delta":1536,"stars":5473,"created_at":"2012-05-28T04:31:06.000Z","monthly":[107,144,129,138,136,116,140,132,135,130,102,127]},{"name":"react-game-kit","url":"http://reactnext.surge.sh","full_name":"FormidableLabs/react-game-kit","description":"Component library for making games with React  & React Native","owner_id":5078602,"tags":["game","react"],"delta":1046,"stars":3354,"created_at":"2016-09-15T07:46:01.000Z","monthly":[71,75,79,88,96,104,71,84,84,125,92,77]},{"name":"Matter.js","url":"","full_name":"liabru/matter-js","description":"a 2D rigid body physics engine for the web ▲● ■","owner_id":654420,"tags":["game"],"delta":1631,"stars":6548,"created_at":"2014-02-19T14:16:17.000Z","monthly":[131,199,105,122,142,228,84,99,143,190,95,93]},{"name":"StdLib","url":"https://stdlib.com","full_name":"stdlib/lib","description":"StdLib Service Creation, Deployment, and Management Tools","owner_id":25233216,"tags":["microservice","serverless"],"delta":2370,"stars":3045,"created_at":"2016-08-08T11:27:43.000Z","twitter":"","monthly":[90,115,111,116,122,169,188,108,145,164,567,475]},{"name":"Vuex","url":"https://vuex.vuejs.org","full_name":"vuejs/vuex","description":"🗃️ Centralized State Management for Vue.js.","owner_id":6128107,"tags":["flux","vue","state"],"delta":7153,"stars":12294,"created_at":"2015-07-16T04:21:26.000Z","monthly":[555,638,569,600,582,553,579,588,632,713,597,547]},{"name":"Aphrodite","url":"","full_name":"Khan/aphrodite","description":"Framework-agnostic CSS-in-JS with support for server-side rendering, browser prefixing, and minimum ","owner_id":15455,"tags":["css-in-js"],"delta":1475,"stars":3825,"created_at":"2015-10-07T02:31:35.000Z","monthly":[91,62,85,91,99,101,135,172,194,161,117,167]},{"name":"Marko","url":"https://markojs.com/","full_name":"marko-js/marko","description":"A friendly (and fast!) UI library from eBay that makes building web apps fun","owner_id":11873696,"tags":["template"],"delta":4592,"stars":5853,"created_at":"2014-01-07T23:58:21.000Z","monthly":[175,121,189,343,1831,107,134,166,157,771,100,498]},{"name":"snabbdom","url":"","full_name":"snabbdom/snabbdom","description":"A virtual DOM library with focus on simplicity, modularity, powerful features and performance.","owner_id":22341607,"tags":["vdom"],"delta":1140,"stars":3135,"created_at":"2015-05-09T20:25:10.000Z","monthly":[94,81,59,77,80,85,75,114,105,152,96,122]},{"name":"React Styleguidist","url":"https://react-styleguidist.js.org/","full_name":"styleguidist/react-styleguidist","description":"Isolated React component development environment with a living style guide","owner_id":23550189,"tags":["react","styleguide"],"delta":2458,"stars":3653,"created_at":"2015-09-07T05:30:30.000Z","monthly":[196,336,290,150,231,170,216,185,295,135,105,149]},{"name":"lowdb","url":"","full_name":"typicode/lowdb","description":":zap: lowdb is a small local JSON database powered by Lodash (supports Node, Electron and the browse","owner_id":5502029,"tags":["db"],"delta":2797,"stars":6988,"created_at":"2014-04-02T02:16:06.000Z","monthly":[974,185,209,171,161,153,191,186,151,151,147,118]},{"name":"electron-builder","url":"https://electron.build","full_name":"electron-userland/electron-builder","description":"A complete solution to package and build a ready for distribution Electron app with “auto update” su","owner_id":17519142,"tags":["desktop"],"delta":2085,"stars":4178,"created_at":"2015-05-21T07:45:02.000Z","monthly":[188,180,215,132,179,182,185,179,154,160,172,159]},{"name":"Netlify CMS","url":"https://www.netlifycms.org","full_name":"netlify/netlify-cms","description":"A CMS for Static Site Generators","owner_id":7892489,"tags":["cms"],"delta":3188,"stars":4004,"created_at":"2015-01-20T05:47:47.000Z","monthly":[279,359,179,152,143,127,135,132,207,1345,66,64]},{"name":"hotel","url":"","full_name":"typicode/hotel","description":":love_hotel: A simple process manager for developers. Start apps from your browser and access them u","owner_id":5502029,"tags":["cli"],"delta":2140,"stars":7111,"created_at":"2015-05-27T08:24:07.000Z","monthly":[138,166,168,120,140,124,179,139,165,145,174,482]},{"name":"core-js","url":"","full_name":"zloirock/core-js","description":"Standard Library","owner_id":2213682,"tags":["compatibility"],"delta":2507,"stars":5426,"created_at":"2013-07-17T16:32:27.000Z","monthly":[209,216,588,217,177,209,162,130,156,184,128,131]},{"name":"Angular","url":"https://angular.io","full_name":"angular/angular","description":"One framework. Mobile & desktop.","owner_id":139426,"tags":["framework","angular"],"delta":12153,"stars":32207,"created_at":"2014-09-18T16:12:01.000Z","twitter":"angular","monthly":[930,1212,1058,925,989,983,911,884,1039,1446,949,827],"icon":"angular.svg"},{"name":"Front-end Job Interview Questions","url":"http://h5bp.github.io/Front-end-Developer-Interview-Questions/","full_name":"h5bp/Front-end-Developer-Interview-Questions","description":"A list of helpful front-end related questions you can use to interview potential candidates, test yo","owner_id":1136800,"tags":["learning"],"delta":6367,"stars":31773,"created_at":"2012-02-09T23:34:10.000Z","monthly":[429,524,513,458,547,587,529,497,498,614,696,475]},{"name":"knex.js","url":"knexjs.org","full_name":"tgriesser/knex","description":"A query builder for PostgreSQL, MySQL and SQLite3, designed to be flexible, portable, and fun to use","owner_id":154748,"tags":["db"],"delta":2056,"stars":6022,"created_at":"2012-12-29T05:18:25.000Z","monthly":[190,189,185,175,155,157,184,190,177,159,146,149]},{"name":"PDF.js","url":"","full_name":"mozilla/pdf.js","description":"PDF Reader in JavaScript","owner_id":131524,"tags":["pdf"],"delta":3883,"stars":20698,"created_at":"2011-04-26T06:32:03.000Z","monthly":[368,359,368,313,330,316,326,324,305,365,268,241]},{"name":"jsPDF","url":"https://parall.ax/products/jspdf","full_name":"MrRio/jsPDF","description":"Client-side JavaScript PDF generation for everyone.","owner_id":47539,"tags":["pdf"],"delta":2704,"stars":9976,"created_at":"2009-12-06T14:56:32.000Z","monthly":[212,214,255,294,264,178,183,213,217,267,212,195]},{"name":"p5","url":"http://p5js.org/","full_name":"processing/p5.js","description":"p5.js is a JS client-side library for creating graphic and interactive experiences, based on the cor","owner_id":1617169,"tags":["drawing","canvas","3d"],"delta":2169,"stars":7149,"created_at":"2013-02-26T03:14:47.000Z","monthly":[197,230,206,149,157,278,140,138,131,233,154,156]},{"name":"Yarn","url":"https://yarnpkg.com","full_name":"yarnpkg/yarn","description":"📦🐈 Fast, reliable, and secure dependency management.","owner_id":22247014,"tags":["package"],"delta":8383,"stars":29795,"created_at":"2016-01-19T17:39:16.000Z","monthly":[577,549,664,593,519,511,553,755,726,941,965,1030]},{"name":"Lerna","url":"https://lernajs.io","full_name":"lerna/lerna","description":":dragon: A tool for managing JavaScript projects with multiple packages.","owner_id":19333396,"tags":["package"],"delta":4419,"stars":7618,"created_at":"2015-12-04T09:36:55.000Z","monthly":[362,440,402,428,360,429,345,341,358,426,263,265]},{"name":"Tesseract.js","url":"http://tesseract.projectnaptha.com/","full_name":"naptha/tesseract.js","description":"Pure Javascript OCR for 62 Languages 📖🎉🖥","owner_id":7720173,"tags":["image"],"delta":1926,"stars":12835,"created_at":"2015-06-24T02:49:52.000Z","monthly":[153,149,143,129,176,152,110,202,135,149,189,239]},{"name":"Styled Components","url":"http://styled-components.com","full_name":"styled-components/styled-components","description":"Visual primitives for the component age. Use the best bits of ES6 and CSS to style your apps without","owner_id":20658825,"tags":["css-in-js"],"delta":8735,"stars":12782,"created_at":"2016-08-16T06:41:32.000Z","monthly":[703,555,677,625,697,703,744,874,861,899,545,852]},{"name":"Ajv: Another JSON Schema Validator","url":"http://epoberezkin.github.io/ajv/","full_name":"epoberezkin/ajv","description":"The fastest JSON Schema Validator. Supports draft-04/06/07","owner_id":2769109,"tags":["json","validation"],"delta":1670,"stars":2884,"created_at":"2015-05-19T23:23:32.000Z","monthly":[139,151,193,155,133,132,147,128,117,147,118,110]},{"name":"Gun","url":"http://gun.js.org/","full_name":"amark/gun","description":"A realtime, decentralized, offline-first, graph database engine.","owner_id":433412,"tags":["db","realtime","nodejs-framework"],"delta":3160,"stars":7155,"created_at":"2014-07-31T15:52:10.000Z","twitter":"","monthly":[184,198,128,87,183,162,1346,223,106,128,234,181],"icon":"gun.svg"},{"name":"TestCafe","url":"https://devexpress.github.io/testcafe/","full_name":"DevExpress/testcafe","description":"A Node.js tool to automate end-to-end web testing.","owner_id":4243232,"tags":["auto"],"delta":2078,"stars":3873,"created_at":"2015-04-20T13:43:28.000Z","monthly":[140,145,175,117,196,227,192,103,195,223,134,231]},{"name":"Node-RED","url":"http://nodered.org","full_name":"node-red/node-red","description":"A visual tool for wiring the Internet of Things","owner_id":5375661,"tags":["iot"],"delta":1648,"stars":5407,"created_at":"2013-09-05T13:30:47.000Z","monthly":[108,150,133,108,144,134,96,124,129,169,165,188]},{"name":"WebTorrent","url":"https://webtorrent.io","full_name":"webtorrent/webtorrent","description":"⚡️ Streaming torrent client for the web","owner_id":5800008,"tags":["webrtc"],"delta":3096,"stars":15597,"created_at":"2013-10-15T08:16:40.000Z","monthly":[350,233,280,213,290,254,214,203,395,249,213,202]},{"name":"vux","url":"https://vux.li/","full_name":"airyland/vux","description":"Mobile UI Components based on Vue & WeUI","owner_id":559179,"tags":["vue"],"delta":4646,"stars":10954,"created_at":"2016-02-15T03:23:27.000Z","monthly":[426,409,311,373,399,394,383,361,392,510,382,306]},{"name":"React Redux Starter Kit","url":"","full_name":"davezuko/react-redux-starter-kit","description":"Get started with React, Redux, and React-Router.","owner_id":6439050,"tags":["boilerplate","redux","react"],"delta":2651,"stars":9939,"created_at":"2015-06-24T18:38:28.000Z","monthly":[72,77,75,97,126,242,263,307,337,345,317,393]},{"name":"Next.js","url":"https://zeit.co/blog/next4","full_name":"zeit/next.js","description":"Framework for server-rendered or statically-exported React apps","owner_id":14985020,"tags":["boilerplate","isomorphic","react"],"delta":12687,"stars":21447,"created_at":"2016-10-05T23:32:51.000Z","monthly":[960,864,1182,697,856,1219,745,1170,1309,2128,664,893]},{"name":"Glamor","url":"","full_name":"threepointone/glamor","description":"inline css for react et al","owner_id":18808,"tags":["css-in-js"],"delta":1313,"stars":2859,"created_at":"2016-07-18T11:25:39.000Z","monthly":[69,69,75,56,98,122,92,192,140,100,92,208]},{"name":"flv.js","url":"","full_name":"Bilibili/flv.js","description":"HTML5 FLV Player","owner_id":12002442,"tags":["video"],"delta":3023,"stars":11051,"created_at":"2016-05-12T08:34:31.000Z","monthly":[246,226,204,232,274,262,275,189,186,258,296,375]},{"name":"Flow","url":"https://flow.org/","full_name":"facebook/flow","description":"Adds static typing to JavaScript to improve developer productivity and code quality.","owner_id":69631,"tags":["compiler"],"delta":5066,"stars":15097,"created_at":"2014-10-28T17:17:45.000Z","twitter":"flowtype","monthly":[417,392,433,372,420,381,447,484,577,505,303,335],"icon":"flow.svg"},{"name":"Storybook","url":"https://storybook.js.org","full_name":"storybooks/storybook","description":"Interactive UI component dev & test: React, React Native, Vue, Angular","owner_id":22632046,"tags":["react","vue","angular"],"delta":9675,"stars":19089,"created_at":"2016-03-18T04:23:44.000Z","twitter":"storybookjs","monthly":[1192,1290,837,671,1045,704,940,807,627,666,429,467]},{"name":"JavaScript Cookie","url":"","full_name":"js-cookie/js-cookie","description":"A simple, lightweight JavaScript API for handling browser cookies","owner_id":11557446,"tags":["util"],"delta":3219,"stars":8271,"created_at":"2015-03-19T15:57:47.000Z","monthly":[283,296,273,228,297,235,248,259,291,332,252,225]},{"name":"vue-router","url":"http://router.vuejs.org/","full_name":"vuejs/vue-router","description":"🚦 The official router for Vue.js.","owner_id":6128107,"tags":["vue","routing"],"delta":4645,"stars":8495,"created_at":"2013-12-11T19:37:46.000Z","monthly":[313,351,403,374,352,370,407,396,411,460,400,408]},{"name":"JavaScript Stack from Scratch","url":"","full_name":"verekia/js-stack-from-scratch","description":"🛠️⚡ Step-by-step tutorial to build a modern JavaScript stack.","owner_id":522007,"tags":["learning"],"delta":7117,"stars":16698,"created_at":"2016-10-02T13:31:23.000Z","monthly":[178,164,179,170,222,249,316,390,655,3929,292,373]},{"name":"Whitestorm.js","url":"https://whs.io","full_name":"WhitestormJS/whs.js","description":":rocket: 🌪 Super-fast 3D framework for Web Applications 🥇 & Games 🎮. Based on Three.js","owner_id":16437392,"tags":["3d"],"delta":2037,"stars":4637,"created_at":"2015-08-30T10:29:14.000Z","monthly":[63,49,114,88,92,154,70,103,174,440,620,70]},{"name":"Botkit","url":"http://botkit.ai","full_name":"howdyai/botkit","description":"Botkit is the leading developer tool for building chat bots, apps and custom integrations for major ","owner_id":16260958,"tags":["bot"],"delta":2394,"stars":7639,"created_at":"2015-12-11T21:21:12.000Z","monthly":[130,144,174,183,166,134,141,209,229,302,266,316]},{"name":"Blueprint","url":"http://blueprintjs.com/","full_name":"palantir/blueprint","description":"A React-based UI toolkit for the web","owner_id":303157,"tags":["react","component"],"delta":2801,"stars":8110,"created_at":"2016-10-25T21:17:50.000Z","monthly":[235,284,414,169,171,265,159,222,200,194,209,279]},{"name":"Element","url":"http://element.eleme.io/","full_name":"ElemeFE/element","description":"A Vue.js 2.0 UI Toolkit for Web","owner_id":12810740,"tags":["vue","component"],"delta":14932,"stars":22385,"created_at":"2016-09-03T06:19:26.000Z","monthly":[1073,1346,1433,1265,1106,1078,1045,1051,1203,1776,1152,1404]},{"name":"pino","url":"http://getpino.io","full_name":"pinojs/pino","description":"🌲 super fast, all natural json logger 🌲","owner_id":23048140,"tags":["log"],"delta":1529,"stars":2238,"created_at":"2016-02-16T14:14:29.000Z","monthly":[126,156,219,268,148,114,73,91,132,90,46,66]},{"name":"realm","url":"https://realm.io","full_name":"realm/realm-js","description":" Realm is a mobile database: an alternative to SQLite & key-value stores","owner_id":7575099,"tags":["db"],"delta":1013,"stars":2584,"created_at":"2015-08-13T15:51:36.000Z","monthly":[50,84,69,69,94,98,101,71,76,70,145,86]},{"name":"Clarity Design System","url":"http://clarity.design","full_name":"vmware/clarity","description":"UX guidelines, HTML/CSS framework, and Angular components working together to craft exceptional expe","owner_id":473334,"tags":["angular"],"delta":1948,"stars":2902,"created_at":"2016-09-29T17:24:17.000Z","monthly":[118,134,166,409,280,109,133,140,91,110,103,155]},{"name":"deck.gl","url":"http://uber.github.io/deck.gl","full_name":"uber/deck.gl","description":"WebGL based visualization layers","owner_id":538264,"tags":["webgl"],"delta":2339,"stars":4026,"created_at":"2015-12-15T08:38:29.000Z","monthly":[128,110,153,108,151,147,113,155,1034,81,66,93]},{"name":"markdown-it","url":"https://markdown-it.github.io","full_name":"markdown-it/markdown-it","description":"Markdown parser, done right. 100% CommonMark support, extensions, syntax plugins & high speed","owner_id":10248321,"tags":["md"],"delta":1702,"stars":4674,"created_at":"2014-12-19T22:54:53.000Z","monthly":[169,153,133,147,154,132,109,153,130,153,164,105]},{"name":"React Sortable","url":"http://clauderic.github.io/react-sortable-hoc/","full_name":"clauderic/react-sortable-hoc","description":"A set of higher-order components to turn any list into an animated, touch-friendly, sortable list ✌️","owner_id":1416436,"tags":["dnd","react"],"delta":2099,"stars":3968,"created_at":"2016-06-08T03:11:35.000Z","monthly":[150,191,183,164,223,185,187,199,151,216,129,121]},{"name":"dva","url":"","full_name":"dvajs/dva","description":"🌱 React and redux based, lightweight and elm-style framework. (Inspired by elm and choo)","owner_id":20552239,"tags":["framework","redux"],"delta":5255,"stars":7621,"created_at":"2016-06-24T09:06:16.000Z","monthly":[510,551,405,463,525,447,384,387,402,463,403,315]},{"name":"Svelte","url":"https://svelte.technology","full_name":"sveltejs/svelte","description":"The magical disappearing UI framework","owner_id":23617963,"tags":["framework"],"delta":2178,"stars":6209,"created_at":"2016-11-20T18:13:05.000Z","monthly":[219,123,103,163,98,102,115,192,166,227,200,470]},{"name":"vuelidate","url":"https://monterail.github.io/vuelidate/","full_name":"monterail/vuelidate","description":"Simple, lightweight model-based validation for Vue.js","owner_id":234138,"tags":["vue","form"],"delta":1213,"stars":1749,"created_at":"2016-11-05T14:30:37.000Z","monthly":[70,107,111,74,99,103,96,81,72,157,90,153]},{"name":"rxdb","url":"https://pubkey.github.io/rxdb/","full_name":"pubkey/rxdb","description":":computer: :iphone: A reactive Database for Progressive Web Apps and more","owner_id":8926560,"tags":["db","realtime"],"delta":4479,"stars":6227,"created_at":"2016-12-02T19:34:42.000Z","monthly":[117,216,99,103,122,100,174,1013,117,638,789,991]},{"name":"Styled JSX","url":"","full_name":"zeit/styled-jsx","description":"Full CSS support for JSX without compromises","owner_id":14985020,"tags":["css-in-js"],"delta":1666,"stars":2653,"created_at":"2016-12-05T13:58:02.000Z","monthly":[129,135,231,92,76,123,105,163,138,216,133,125]},{"name":"JSS","url":"http://cssinjs.org","full_name":"cssinjs/jss","description":"JSS is an authoring tool for CSS which uses JavaScript as a host language.","owner_id":9503099,"tags":["css-in-js"],"delta":1296,"stars":3020,"created_at":"2014-10-12T20:33:53.000Z","monthly":[126,142,120,89,94,115,107,101,94,107,107,94]},{"name":"styletron","url":"http://styletron.js.org","full_name":"rtsao/styletron","description":":zap: Universal, high-performance JavaScript styles","owner_id":780408,"tags":["css-in-js"],"delta":1039,"stars":2335,"created_at":"2016-04-01T00:00:06.000Z","monthly":[47,52,51,44,57,151,217,145,42,53,54,126]},{"name":"faker.js","url":"","full_name":"Marak/faker.js","description":"generate massive amounts of fake data in Node.js and the browser","owner_id":70011,"tags":["random"],"delta":3601,"stars":12762,"created_at":"2010-05-15T00:53:07.000Z","monthly":[284,331,318,314,346,287,270,266,410,329,237,209]},{"name":"Vuetify","url":"https://vuetifyjs.com","full_name":"vuetifyjs/vuetify","description":"Material Component Framework for Vue.js 2","owner_id":22138497,"tags":["vue","material"],"delta":6259,"stars":7832,"created_at":"2016-09-12T00:39:35.000Z","twitter":"vuetifyjs","monthly":[585,615,777,1136,554,569,360,402,385,363,191,322]},{"name":"Material Components","url":"https://material.io/components/","full_name":"material-components/material-components-web","description":"Modular and customizable Material Design UI components for the web","owner_id":19478152,"tags":["material","css-lib"],"delta":5578,"stars":7311,"created_at":"2016-12-05T16:04:09.000Z","monthly":[338,336,379,282,343,381,457,1234,436,457,418,517]},{"name":"react-dates","url":"http://airbnb.io/react-dates","full_name":"airbnb/react-dates","description":"An easily internationalizable, mobile-friendly datepicker library for the web","owner_id":698437,"tags":["date","react"],"delta":2784,"stars":6109,"created_at":"2016-05-04T00:49:45.000Z","monthly":[169,259,235,271,197,201,301,237,235,214,262,203]},{"name":"Lighthouse","url":"https://developers.google.com/web/tools/lighthouse/","full_name":"GoogleChrome/lighthouse","description":"Auditing, performance metrics, and best practices for Progressive Web Apps","owner_id":1778935,"tags":["performance"],"delta":5647,"stars":12074,"created_at":"2016-03-08T01:03:11.000Z","monthly":[407,323,420,307,537,413,535,573,335,347,692,758]},{"name":"Nuclide","url":"https://nuclide.io","full_name":"facebook/nuclide","description":"An open IDE for web and native mobile development, built on top of Atom ","owner_id":69631,"tags":["ide"],"delta":1422,"stars":7383,"created_at":"2015-03-02T05:25:27.000Z","twitter":"","monthly":[76,82,68,123,75,127,101,145,152,154,167,152],"icon":"nuclide.svg"},{"name":"FuseBox","url":"http://fuse-box.org","full_name":"fuse-box/fuse-box","description":"A blazing fast js bundler/loader with a comprehensive API :fire:","owner_id":23119087,"tags":["module","build"],"delta":2547,"stars":3123,"created_at":"2016-10-28T10:37:16.000Z","monthly":[75,60,100,94,92,81,276,107,76,185,1292,109]},{"name":"React Native for Web","url":"https://necolas.github.io/react-native-web/storybook","full_name":"necolas/react-native-web","description":"React Native for Web","owner_id":239676,"tags":["react-native","component"],"delta":3469,"stars":7357,"created_at":"2015-06-09T19:25:38.000Z","monthly":[321,236,293,266,227,318,269,278,374,271,327,289]},{"name":"Vulcan","url":"http://vulcanjs.org","full_name":"VulcanJS/Vulcan","description":"🌋 A toolkit to quickly build apps with React, GraphQL & Meteor","owner_id":6634779,"tags":["realtime","meteor","graphql","nodejs-framework"],"delta":1358,"stars":6497,"created_at":"2012-09-07T01:13:24.000Z","twitter":"vulcanjs","monthly":[79,88,79,91,140,149,153,138,140,109,65,127]},{"name":"Vue material","url":"http://vuematerial.io","full_name":"vuematerial/vue-material","description":"Material design for Vue.js","owner_id":23659108,"tags":["vue","material"],"delta":3712,"stars":5282,"created_at":"2016-06-17T22:41:53.000Z","monthly":[234,245,273,251,293,303,304,307,320,449,405,328]},{"name":"vue-resource","url":"","full_name":"pagekit/vue-resource","description":"The HTTP client for Vue.js","owner_id":510472,"tags":["vue","http"],"delta":3596,"stars":7398,"created_at":"2014-02-07T23:07:56.000Z","monthly":[189,234,211,272,274,314,278,323,369,454,409,269]},{"name":"vue-i18n","url":"https://kazupon.github.io/vue-i18n/","full_name":"kazupon/vue-i18n","description":":globe_with_meridians: Internationalization plugin for Vue.js","owner_id":72989,"tags":["vue","i18n"],"delta":1371,"stars":1980,"created_at":"2014-05-02T17:32:14.000Z","monthly":[121,126,126,123,140,117,133,109,130,117,67,62]},{"name":"Prism","url":"http://prismjs.com","full_name":"PrismJS/prism","description":"Lightweight, robust, elegant syntax highlighting.","owner_id":11140484,"tags":["highlight"],"delta":1063,"stars":4891,"created_at":"2012-07-10T19:47:14.000Z","monthly":[109,86,89,102,99,66,86,110,69,90,105,52]},{"name":"Botpress","url":"https://botpress.io","full_name":"botpress/botpress","description":"🤖 Modular chatbot framework that ⚡ thousands of bots all around the world","owner_id":23510677,"tags":["bot"],"delta":3615,"stars":3995,"created_at":"2016-11-16T21:57:59.000Z","monthly":[122,90,96,75,58,61,81,87,93,290,1672,890]},{"name":"Rax","url":"https://alibaba.github.io/rax","full_name":"alibaba/rax","description":":tophat: A universal React-compatible render engine.","owner_id":1961952,"tags":["vdom","framework"],"delta":2622,"stars":3897,"created_at":"2016-10-14T07:53:50.000Z","monthly":[80,77,87,328,104,122,98,100,124,119,268,1115]},{"name":"nwb","url":"","full_name":"insin/nwb","description":"A toolkit for React, Preact, Inferno & vanilla JS apps, React libraries and other npm modules for th","owner_id":226692,"tags":["scaffolding","boilerplate"],"delta":1077,"stars":2888,"created_at":"2015-11-10T23:32:58.000Z","monthly":[67,53,84,109,93,111,109,99,88,75,80,109]},{"name":"vue-multiselect","url":"https://vue-multiselect.js.org/","full_name":"shentao/vue-multiselect","description":"Universal select/multiselect/tagging component for Vue.js","owner_id":3737591,"tags":["vue","autocomplete"],"delta":1537,"stars":2588,"created_at":"2016-04-23T13:02:33.000Z","monthly":[107,182,121,126,129,226,137,101,115,138,99,56]},{"name":"Nuxt","url":"https://nuxtjs.org","full_name":"nuxt/nuxt.js","description":"Versatile Vue.js Framework","owner_id":23360933,"tags":["vue","isomorphic"],"delta":6271,"stars":9186,"created_at":"2016-10-26T11:18:47.000Z","monthly":[498,635,606,532,732,592,481,537,515,625,354,164]},{"name":"WebSlides","url":"https://webslides.tv/","full_name":"webslides/WebSlides","description":"Create HTML presentations in seconds —","owner_id":13846397,"tags":["presentation"],"delta":1930,"stars":4008,"created_at":"2017-01-08T20:35:48.000Z","monthly":[22,54,54,89,81,36,45,106,64,135,370,874]},{"name":"docute","url":"https://docute.js.org","full_name":"egoist/docute","description":":scroll: Effortlessly documentation done right.","owner_id":8784712,"tags":["doc"],"delta":1092,"stars":1529,"created_at":"2016-12-08T18:04:40.000Z","monthly":[103,61,71,75,64,68,65,132,86,269,89,9]},{"name":"React Table","url":"http://react-table.js.org","full_name":"react-tools/react-table","description":"React Table - A lightweight, fast and extendable datagrid for React","owner_id":30272234,"tags":["table","react"],"delta":1796,"stars":2425,"created_at":"2016-10-20T17:25:08.000Z","monthly":[208,205,191,170,165,113,129,206,141,107,111,50]},{"name":"Prettier","url":"https://prettier.io/","full_name":"prettier/prettier","description":"Prettier is an opinionated code formatter.","owner_id":25822731,"tags":["lint"],"delta":17690,"stars":20371,"created_at":"2016-11-29T17:13:37.000Z","twitter":"PrettierCode","monthly":[1463,956,1362,721,1276,1009,1813,1031,2588,1290,1096,114],"icon":"prettier.svg"},{"name":"reactstrap","url":"https://reactstrap.github.io","full_name":"reactstrap/reactstrap","description":"Simple React Bootstrap 4 components","owner_id":17580417,"tags":["react","component"],"delta":2235,"stars":3333,"created_at":"2016-02-19T08:01:36.000Z","monthly":[266,250,305,213,222,154,151,182,142,197,137,16]},{"name":"Quasar","url":"http://quasar-framework.org","full_name":"quasarframework/quasar","description":"Quasar Framework","owner_id":23064371,"tags":["mobile","vue"],"delta":3706,"stars":4788,"created_at":"2015-10-05T15:45:36.000Z","twitter":"quasarframework","monthly":[331,301,343,360,397,298,266,314,244,341,297,17]},{"name":"React Navigation","url":"https://reactnavigation.org","full_name":"react-navigation/react-navigation","description":"Learn once, navigate anywhere","owner_id":29647600,"tags":["routing","react-native"],"delta":8760,"stars":9125,"created_at":"2017-01-26T19:51:40.000Z","monthly":[486,632,609,535,494,586,612,822,646,846,910,1582]},{"name":"Calypso","url":"https://developer.wordpress.com/calypso/","full_name":"Automattic/wp-calypso","description":"The new JavaScript- and API-powered WordPress.com","owner_id":887802,"tags":["cms","redux","react"],"delta":1169,"stars":9625,"created_at":"2015-11-10T20:00:16.000Z","monthly":[95,100,111,197,89,91,103,82,93,98,110]},{"name":"Hyperapp","url":"https://hyperapp.js.org","full_name":"hyperapp/hyperapp","description":"1 KB JavaScript library for building web applications.","owner_id":25238911,"tags":["framework"],"delta":8068,"stars":10266,"created_at":"2017-01-20T05:20:21.000Z","monthly":[1476,189,333,746,321,671,2092,113,148,779,1200]},{"name":"Keen-UI","url":"https://josephuspaye.github.io/Keen-UI/","full_name":"JosephusPaye/Keen-UI","description":"A lightweight collection of essential UI components written with Vue and inspired by Material Design","owner_id":5924865,"tags":["material","vue"],"delta":1346,"stars":3193,"created_at":"2016-03-22T01:23:20.000Z","monthly":[60,51,48,69,67,73,78,94,105,193,508]},{"name":"Ant Design","url":"http://ant.design","full_name":"ant-design/ant-design","description":"🐜 A UI Design Language","owner_id":12101536,"tags":["react","component"],"delta":13276,"stars":23119,"created_at":"2015-04-24T15:37:24.000Z","monthly":[1598,1267,1199,887,1075,941,928,910,971,1117,936]},{"name":"lazysizes","url":"","full_name":"aFarkas/lazysizes","description":"High performance and SEO friendly lazy loader for images (responsive and normal), iframes and more, ","owner_id":188254,"tags":["load"],"delta":1779,"stars":7706,"created_at":"2014-10-11T21:03:26.000Z","monthly":[149,188,209,136,151,220,169,147,160,169,81]},{"name":"Poi","url":"https://poi.js.org","full_name":"egoist/poi","description":":zap: Delightful web development.","owner_id":8784712,"tags":["vue","build"],"delta":2674,"stars":3129,"created_at":"2016-04-21T16:21:09.000Z","monthly":[1272,200,178,165,54,78,82,129,94,132,127]},{"name":"Apollo client","url":"https://www.apollographql.com/client/","full_name":"apollographql/apollo-client","description":":rocket: A fully-featured, production ready caching GraphQL client for every UI framework and GraphQ","owner_id":17189275,"tags":["graphql"],"delta":4128,"stars":5662,"created_at":"2016-02-26T20:25:00.000Z","twitter":"apollographql","monthly":[393,438,414,331,295,327,295,285,348,338,64]},{"name":"TA.Gui","url":"http://tebel.org","full_name":"tebelorg/TagUI","description":"General purpose tool for automating web interactions","owner_id":10379612,"tags":["auto","test"],"delta":1326,"stars":2607,"created_at":"2016-12-06T04:30:34.000Z","monthly":[32,125,27,34,57,676,9,14,21,85,246]},{"name":"docsify","url":"https://docsify.js.org","full_name":"QingWei-Li/docsify","description":"🃏 A magical documentation site generator.","owner_id":7565692,"tags":["doc"],"delta":3391,"stars":4843,"created_at":"2016-11-20T07:55:43.000Z","monthly":[294,205,251,210,267,206,731,479,226,467,55]},{"name":"Neutrino","url":"https://neutrino.js.org","full_name":"mozilla-neutrino/neutrino-dev","description":"Create and build modern JavaScript applications with zero initial configuration.","owner_id":21367267,"tags":["scaffolding"],"delta":1609,"stars":2346,"created_at":"2017-02-03T03:27:20.000Z","monthly":[295,83,95,46,59,55,74,196,98,442,166]},{"name":"neurojs","url":"http://janhuenermann.com/projects/learning-to-drive","full_name":"janhuenermann/neurojs","description":"A javascript deep learning and reinforcement learning library.","owner_id":10101036,"tags":["neural","ml"],"delta":3167,"stars":4002,"created_at":"2016-09-18T23:33:53.000Z","monthly":[40,27,41,38,43,37,59,91,218,2573]},{"name":"Caporal.js","url":"","full_name":"mattallty/Caporal.js","description":"A full-featured framework for building command line applications (cli) with node.js","owner_id":178616,"tags":["cli"],"delta":1318,"stars":2556,"created_at":"2017-02-08T22:06:55.000Z","monthly":[71,36,30,18,27,17,17,53,282,767]},{"name":"store.js","url":"","full_name":"marcuswestin/store.js","description":"Cross-browser storage for all use cases, used across the web.","owner_id":131967,"tags":["db"],"delta":2579,"stars":10779,"created_at":"2010-06-27T20:29:33.000Z","monthly":[123,146,139,170,177,155,178,141,227,1123]},{"name":"React Trend","url":"https://unsplash.github.io/react-trend/","full_name":"unsplash/react-trend","description":"📈 Simple, elegant spark lines","owner_id":9951955,"tags":["chart","svg","react"],"delta":1517,"stars":1848,"created_at":"2017-02-02T18:04:20.000Z","monthly":[32,39,37,24,18,9,65,42,118,1133]},{"name":"Planck.js","url":"http://piqnt.com/planck.js/","full_name":"shakiba/planck.js","description":"2D JavaScript Physics Engine","owner_id":1061095,"tags":["game"],"delta":2581,"stars":2808,"created_at":"2016-03-22T04:46:05.000Z","monthly":[29,23,16,36,34,28,39,59,1935,382]},{"name":"Create React Native App","url":"","full_name":"react-community/create-react-native-app","description":"Create a React Native app on any OS with no build config.","owner_id":24483500,"tags":["react-native"],"delta":7656,"stars":7925,"created_at":"2017-01-11T17:54:30.000Z","monthly":[363,403,438,393,478,476,493,498,637,3387,34,56]},{"name":"react-loadable","url":"","full_name":"thejameskyle/react-loadable","description":":hourglass_flowing_sand: A higher order component for loading components with promises.","owner_id":952783,"tags":["isomorphic","react"],"delta":4946,"stars":5556,"created_at":"2017-03-09T18:41:17.000Z","monthly":[471,511,553,178,285,307,377,212,262,499]},{"name":"iView","url":"https://iviewui.com/","full_name":"iview/iview","description":"A high quality UI Toolkit built on Vue.js 2.0","owner_id":20693613,"tags":["vue","component"],"delta":9542,"stars":12359,"created_at":"2016-07-28T01:52:59.000Z","monthly":[585,788,1274,576,626,929,566,485,613,351]},{"name":"Ant Design Mobile","url":"https://mobile.ant.design","full_name":"ant-design/ant-design-mobile","description":"A configurable Mobile UI","owner_id":12101536,"tags":["mobile","react-native"],"delta":2295,"stars":3975,"created_at":"2015-11-30T03:33:06.000Z","monthly":[278,294,258,306,247,198,221,191,191,111]},{"name":"Eagle.js","url":"https://zulko.github.io/eaglejs-demo/","full_name":"Zulko/eagle.js","description":"A hackable slideshow framework built with Vue.js","owner_id":1646122,"tags":["presentation","vue"],"delta":1106,"stars":1371,"created_at":"2017-03-12T17:07:55.000Z","monthly":[27,22,29,29,63,37,32,69,139,659]},{"name":"react-overdrive","url":"https://react-overdrive.now.sh","full_name":"berzniz/react-overdrive","description":"Super easy magic-move transitions for React apps","owner_id":170214,"tags":["animation","react"],"delta":1187,"stars":2383,"created_at":"2017-03-06T13:47:55.000Z","monthly":[128,23,38,29,50,49,32,59,235,544]},{"name":"ngx-datatable","url":"http://swimlane.github.io/ngx-datatable/","full_name":"swimlane/ngx-datatable","description":"✨  A feature-rich yet lightweight data-table crafted for Angular4 and beyond!","owner_id":10552812,"tags":["angular","table"],"delta":1323,"stars":2260,"created_at":"2016-05-31T19:25:47.000Z","monthly":[117,153,155,121,159,121,146,158,164,29]},{"name":"Redux Offline","url":"","full_name":"redux-offline/redux-offline","description":"Build Offline-First Apps for Web and React Native","owner_id":31570694,"tags":["redux","offline"],"delta":2146,"stars":4293,"created_at":"2017-03-11T18:37:50.000Z","monthly":[159,125,109,85,115,102,105,220,1126]},{"name":"AOS","url":"","full_name":"michalsnik/aos","description":"Animate on scroll library","owner_id":4093559,"tags":["scrolling"],"delta":1664,"stars":5336,"created_at":"2015-07-09T17:49:00.000Z","monthly":[261,227,170,184,141,141,159,171,210]},{"name":"Polished","url":"https://polished.js.org/","full_name":"styled-components/polished","description":"A lightweight toolset for writing styles in JavaScript ✨","owner_id":20658825,"tags":["css-in-js"],"delta":2919,"stars":2994,"created_at":"2016-11-03T14:39:21.000Z","monthly":[103,96,129,94,96,139,210,262,518]},{"name":"You Don't Need jQuery","url":"","full_name":"nefe/You-Dont-Need-jQuery","description":"Examples of how to do query, style, dom, ajax, event etc like jQuery with plain javascript.","owner_id":33238961,"tags":["learning"],"delta":2996,"stars":12719,"created_at":"2015-11-21T16:02:26.000Z","monthly":[127,128,138,199,233,278,186,339,1368]},{"name":"Reactide","url":"http://reactide.io","full_name":"reactide/reactide","description":"Reactide is the first dedicated IDE for React web application development. http://reactide.io","owner_id":26257999,"tags":["ide"],"delta":7371,"stars":7584,"created_at":"2017-03-07T18:30:34.000Z","monthly":[73,38,71,34,76,66,109,181,2223]},{"name":"Tippy.js","url":"https://atomiks.github.io/tippyjs/","full_name":"atomiks/tippyjs","description":"A lightweight, vanilla JS tooltip library","owner_id":22450188,"tags":["tooltip"],"delta":2958,"stars":3271,"created_at":"2017-04-01T06:51:35.000Z","monthly":[103,136,130,81,67,112,92,273,1964]},{"name":"SweetAlert2","url":"https://sweetalert2.github.io/","full_name":"sweetalert2/sweetalert2","description":"A beautiful, responsive, customizable and accessible (WAI-ARIA) replacement for JavaScript's popup b","owner_id":35137722,"tags":["notify"],"delta":1822,"stars":4161,"created_at":"2015-01-03T16:15:52.000Z","monthly":[212,196,213,158,251,165,138,203,286]},{"name":"normalizr","url":"","full_name":"paularmstrong/normalizr","description":"Normalizes nested JSON according to a schema","owner_id":33297,"tags":["json"],"delta":3838,"stars":11590,"created_at":"2014-08-20T08:41:38.000Z","monthly":[385,445,367,378,437,489,371,504,462]},{"name":"Glamorous","url":"https://glamorous.rocks","full_name":"paypal/glamorous","description":"💄 Maintainable CSS with React","owner_id":476675,"tags":["css-in-js"],"delta":2899,"stars":3036,"created_at":"2017-04-03T21:35:49.000Z","twitter":"glamorouscss","monthly":[165,120,151,139,292,196,206,273,531]},{"name":"AR.js","url":"","full_name":"jeromeetienne/AR.js","description":"Efficient Augmented Reality for the Web - 60fps on mobile!","owner_id":252962,"tags":["virtual"],"delta":6495,"stars":9461,"created_at":"2017-02-17T10:27:59.000Z","monthly":[329,332,605,3598,434,263,395,237,302]},{"name":"Turbolinks","url":"","full_name":"turbolinks/turbolinks","description":"Turbolinks makes navigating your web application faster","owner_id":16996872,"tags":["http"],"delta":1372,"stars":5177,"created_at":"2016-02-01T02:14:01.000Z","monthly":[238,141,97,165,239,112,109,157,114]},{"name":"React VR","url":"https://facebook.github.io/react-vr","full_name":"facebook/react-vr","description":"Create amazing 360 and VR content using React","owner_id":69631,"tags":["react-native","virtual"],"delta":3190,"stars":5461,"created_at":"2016-12-12T19:45:37.000Z","monthly":[100,124,172,187,196,183,260,413,1555]},{"name":"React Move","url":"https://react-move.js.org","full_name":"react-tools/react-move","description":"React Move 🌀 Beautiful, data-driven animations for React","owner_id":30272234,"tags":["animation","react"],"delta":2315,"stars":3187,"created_at":"2017-03-20T15:38:13.000Z","monthly":[84,61,82,98,67,40,57,226,1600]},{"name":"Vee-Validate","url":"http://vee-validate.logaretm.com/","full_name":"baianat/vee-validate","description":"Simple Vue.js input validation plugin","owner_id":5085038,"tags":["form","vue"],"delta":2982,"stars":3546,"created_at":"2016-07-30T01:10:44.000Z","monthly":[254,261,296,225,247,220,236,222,123]},{"name":"mini.css","url":"https://minicss.org/","full_name":"Chalarangelo/mini.css","description":"A minimal, responsive, style-agnostic CSS framework!","owner_id":8281875,"tags":["css-lib"],"delta":1563,"stars":2147,"created_at":"2016-08-22T06:31:31.000Z","monthly":[107,57,40,39,45,128,250,864,33]},{"name":"yargs","url":"http://yargs.js.org/","full_name":"yargs/yargs","description":" yargs the modern, pirate-themed successor to optimist.","owner_id":16504989,"tags":["cli"],"delta":1015,"stars":3966,"created_at":"2013-11-07T17:25:51.000Z","monthly":[117,145,128,125,120,129,119,126,6]},{"name":"ShellJS","url":"http://shelljs.org","full_name":"shelljs/shelljs","description":":shell: Portable Unix shell commands for Node.js","owner_id":14236201,"tags":["cli"],"delta":1223,"stars":7150,"created_at":"2012-03-02T17:04:47.000Z","monthly":[182,141,159,126,151,138,155,161,10]},{"name":"Moon","url":"http://moonjs.ga/","full_name":"kbrsh/moon","description":"🌙 ⚡️ A minimal, blazing fast UI library.","owner_id":15644571,"tags":["framework"],"delta":3695,"stars":4175,"created_at":"2016-07-14T04:53:09.000Z","monthly":[73,96,98,566,1857,403,226,356,20]},{"name":"Prepack","url":"https://prepack.io","full_name":"facebook/prepack","description":"Prepack is a partial evaluator for JavaScript. Prepack rewrites a JavaScript bundle, resulting in Ja","owner_id":69631,"tags":["performance"],"delta":4031,"stars":10821,"created_at":"2015-10-28T23:25:08.000Z","monthly":[141,113,218,103,119,227,320,2790]},{"name":"Nest","url":"https://nestjs.com/","full_name":"nestjs/nest","description":"A progressive Node.js framework for building efficient and scalable server-side applications on top ","owner_id":28507035,"tags":["nodejs-framework","microservice"],"delta":2975,"stars":3373,"created_at":"2017-02-04T20:12:52.000Z","twitter":"nestframework","monthly":[385,429,667,391,165,61,120,296]},{"name":"Reaction","url":"https://reactioncommerce.com/","full_name":"reactioncommerce/reaction","description":"Reaction is a customizable, real-time reactive, JavaScript commerce platform.","owner_id":5605462,"tags":["meteor"],"delta":1872,"stars":6369,"created_at":"2013-09-18T15:30:36.000Z","monthly":[184,237,226,145,237,231,233,379]},{"name":"Britecharts","url":"http://eventbrite.github.io/britecharts/","full_name":"eventbrite/britecharts","description":"Client-side reusable Charting Library based on D3.js v4 that allows easy and intuitive use of charts","owner_id":369874,"tags":["chart","d3"],"delta":1739,"stars":2958,"created_at":"2015-05-19T22:42:39.000Z","monthly":[31,42,90,120,87,88,125,1156]},{"name":"vx","url":"https://vx-demo.now.sh/","full_name":"hshoff/vx","description":"react + d3 = vx | visualization components","owner_id":339208,"tags":["chart","react","d3","svg"],"delta":2272,"stars":3303,"created_at":"2017-03-15T16:25:41.000Z","monthly":[117,132,159,112,443,173,441,695]},{"name":"Mavo","url":"https://mavo.io","full_name":"mavoweb/mavo","description":"Create web applications entirely by writing HTML and CSS!","owner_id":27614671,"tags":["cms"],"delta":1259,"stars":1798,"created_at":"2015-09-14T05:21:12.000Z","monthly":[28,63,62,39,48,50,127,842]},{"name":"Workbox","url":"https://developers.google.com/web/tools/workbox/","full_name":"GoogleChrome/workbox","description":"📦 Workbox: JavaScript libraries for Progressive Web Apps","owner_id":1778935,"tags":["webworker"],"delta":2496,"stars":4005,"created_at":"2016-04-04T15:55:19.000Z","monthly":[227,251,370,318,278,297,272,483]},{"name":"diegomura/react-pdf","url":"","full_name":"diegomura/react-pdf","description":"📄 Create PDF files using React","owner_id":5600341,"tags":["react","pdf"],"delta":2690,"stars":3756,"created_at":"2016-10-18T21:33:58.000Z","monthly":[62,61,116,104,154,243,513,1437]},{"name":"Handsontable","url":"https://handsontable.com","full_name":"handsontable/handsontable","description":"Handsontable Community Edition - JavaScript/HTML5 Spreadsheet Component for Web Apps","owner_id":8068250,"tags":["table"],"delta":1060,"stars":9186,"created_at":"2011-05-23T22:38:58.000Z","monthly":[142,181,142,122,136,149,161,27]},{"name":"Spectre.css","url":"https://picturepan2.github.io/spectre/","full_name":"picturepan2/spectre","description":"Spectre.css - a Lightweight, Responsive and Modern CSS Framework","owner_id":126385,"tags":["css-lib"],"delta":1294,"stars":5700,"created_at":"2016-03-07T11:53:15.000Z","monthly":[188,155,147,177,199,245,135,48]},{"name":"Ory Editor","url":"https://editor.ory.am/?utm_source=github&utm_medium=header&utm_campaign=editor","full_name":"ory/editor","description":"Next-gen, highly customizable content editor for the browser - based on React and Redux. WYSIWYG on ","owner_id":25334553,"tags":["rich-text-editor","react","redux"],"delta":4131,"stars":6397,"created_at":"2015-05-29T12:19:44.000Z","monthly":[89,89,175,139,92,199,1122,2226]},{"name":"Muuri","url":"http://haltu.github.io/muuri/","full_name":"haltu/muuri","description":"Responsive, sortable, filterable and draggable grid layouts","owner_id":884254,"tags":["layout","dnd"],"delta":6220,"stars":6451,"created_at":"2015-12-21T07:00:44.000Z","monthly":[4961,84,104,41,43,43,305,82]},{"name":"Chromatism","url":"","full_name":"toish/chromatism","description":":rainbow: A simple set of utility functions for colours.","owner_id":8439945,"tags":["color"],"delta":1624,"stars":1694,"created_at":"2015-08-30T00:00:33.000Z","monthly":[-2,0,10,8,8,19,479,1102]},{"name":"Feather","url":"https://feathericons.com","full_name":"feathericons/feather","description":"Simply beautiful open source icons","owner_id":29268069,"tags":["icon","svg"],"delta":9409,"stars":11923,"created_at":"2014-05-28T19:49:55.000Z","monthly":[281,510,197,633,2655,504,4629]},{"name":"billboard.js","url":"https://naver.github.io/billboard.js/","full_name":"naver/billboard.js","description":":bar_chart: Re-usable, easy interface JavaScript chart library based on D3 v4+:chart_with_upwards_tr","owner_id":6589568,"tags":["chart","d3","svg"],"delta":2083,"stars":2288,"created_at":"2017-06-08T02:54:44.000Z","monthly":[331,106,208,334,73,130,901]},{"name":"Cell","url":"https://www.celljs.org","full_name":"intercellular/cell","description":"A self-driving web app framework","owner_id":29186916,"tags":["framework"],"delta":1294,"stars":1468,"created_at":"2017-06-06T06:31:44.000Z","monthly":[21,16,11,11,46,164,1025]},{"name":"flubber","url":"","full_name":"veltman/flubber","description":"Tools for smoother shape animations.","owner_id":2120446,"tags":["animation","svg"],"delta":2295,"stars":4426,"created_at":"2017-06-09T08:16:56.000Z","monthly":[34,30,31,43,77,712,1368]},{"name":"Amplitude.js","url":"https://521dimensions.com/open-source/amplitudejs","full_name":"521dimensions/amplitudejs","description":"Amplitude.js is the HTML5 Audio Player for the modern era. No dependencies required.","owner_id":4382659,"tags":["audio"],"delta":1314,"stars":2310,"created_at":"2013-10-07T20:38:20.000Z","monthly":[135,127,25,35,17,82,893]},{"name":"Spellbook of Modern Web Dev","url":"","full_name":"dexteryy/spellbook-of-modern-webdev","description":"A Big Picture, Thesaurus, and Taxonomy of Modern JavaScript Web Development","owner_id":43011,"tags":["learning"],"delta":4639,"stars":9226,"created_at":"2017-06-10T18:03:21.000Z","monthly":[76,99,117,132,265,1070,2880]},{"name":"Collect.js","url":"","full_name":"ecrmnn/collect.js","description":"💎 Convenient and dependency free wrapper for working with arrays and objects","owner_id":1481696,"tags":["util"],"delta":2803,"stars":2987,"created_at":"2016-09-11T14:53:13.000Z","monthly":[11,27,20,36,56,166,2487]},{"name":"Golden Layout","url":"","full_name":"WolframHempel/golden-layout","description":"The ultimate Javascript layout manager","owner_id":1503717,"tags":["layout"],"delta":1580,"stars":3515,"created_at":"2014-10-05T07:29:06.000Z","monthly":[49,56,61,58,59,110,1187]},{"name":"Flight","url":"http://www.react-flight.io","full_name":"jondot/react-flight","description":"The best way to build animation compositions for React.","owner_id":83390,"tags":["react","animation"],"delta":1704,"stars":2547,"created_at":"2017-06-15T05:52:50.000Z","monthly":[25,14,11,20,63,265,1306]},{"name":"Sonar","url":"https://sonarwhal.com/","full_name":"sonarwhal/sonarwhal","description":"A linting tool for the web","owner_id":25042266,"tags":["lint","access"],"delta":1042,"stars":1208,"created_at":"2017-02-16T18:15:31.000Z","monthly":[110,172,646,53,10,51]},{"name":"react-native-ui-kitten","url":"https://akveo.github.io/react-native-ui-kitten/","full_name":"akveo/react-native-ui-kitten","description":"🐱  Customizable and reusable react-native component kit","owner_id":11921694,"tags":["react-native"],"delta":1108,"stars":2073,"created_at":"2016-12-20T08:22:38.000Z","monthly":[118,113,98,123,144,512]},{"name":"Chalk","url":"","full_name":"chalk/chalk","description":"🖍 Terminal string styling done right","owner_id":13122722,"tags":["cli"],"delta":1576,"stars":7830,"created_at":"2013-08-03T00:20:12.000Z","monthly":[265,285,279,219,244,284]},{"name":"Commander.js","url":"","full_name":"tj/commander.js","description":"node.js command-line interfaces made easy","owner_id":25254,"tags":["cli"],"delta":1424,"stars":9847,"created_at":"2011-08-14T21:33:58.000Z","monthly":[292,268,246,177,253,188]},{"name":"npm","url":"http://www.npmjs.com/","full_name":"npm/npm","description":"a package manager for javascript","owner_id":6078720,"tags":["package","node.js"],"delta":1893,"stars":15161,"created_at":"2009-09-29T17:21:24.000Z","monthly":[329,380,371,266,278,269]},{"name":"Ink","url":"","full_name":"vadimdemedes/ink","description":"🌈 React for interactive command-line apps","owner_id":697676,"tags":["react","cli"],"delta":3640,"stars":4310,"created_at":"2017-06-12T06:12:28.000Z","monthly":[140,52,51,62,230,3105]},{"name":"Front End Guide","url":"","full_name":"grab/front-end-guide","description":"📚 Study guide and introduction to the modern front end stack.","owner_id":17284363,"tags":["learning"],"delta":2054,"stars":9926,"created_at":"2017-04-24T02:06:06.000Z","monthly":[140,197,226,299,298,894]},{"name":"Bundle Buddy","url":"","full_name":"samccone/bundle-buddy","description":"A tool to identify bundle duplication across splits.","owner_id":883126,"tags":["performance"],"delta":1137,"stars":2044,"created_at":"2017-06-25T01:15:25.000Z","monthly":[44,128,35,69,86,775]},{"name":"Pell","url":"https://jaredreich.com/pell","full_name":"jaredreich/pell","description":"📝 the simplest and smallest (1kB) WYSIWYG text editor for web, with no dependencies","owner_id":8563847,"tags":["rich-text-editor"],"delta":6152,"stars":7039,"created_at":"2017-07-09T14:30:51.000Z","monthly":[74,60,77,155,383,5403]},{"name":"Emotion","url":"https://emotion.sh/","full_name":"emotion-js/emotion","description":"⚡️ The Next Generation of CSS-in-JS","owner_id":31557565,"tags":["css-in-js"],"delta":2544,"stars":2704,"created_at":"2017-05-27T04:23:45.000Z","monthly":[298,186,352,190,257,488]},{"name":"Scribbletune","url":"http://scribbletune.com/","full_name":"walmik/scribbletune","description":"Create music with JavaScript and Node.js!","owner_id":467030,"tags":["audio"],"delta":1863,"stars":2323,"created_at":"2013-11-25T21:44:43.000Z","monthly":[25,34,47,122,300,1335]},{"name":"Reselect","url":"","full_name":"reactjs/reselect","description":"Selector library for Redux","owner_id":6412038,"tags":["redux"],"delta":2066,"stars":9973,"created_at":"2015-07-01T11:06:45.000Z","monthly":[311,363,333,365,406,288]},{"name":"Redux Persist","url":"","full_name":"rt2zz/redux-persist","description":"persist and rehydrate a redux store","owner_id":2302315,"tags":["redux"],"delta":1480,"stars":4671,"created_at":"2015-07-23T04:43:58.000Z","monthly":[218,287,276,257,266,176]},{"name":"BotUI","url":"https://botui.org","full_name":"botui/botui","description":"🤖 A JavaScript framework to create conversational UIs","owner_id":29958442,"tags":["bot"],"delta":1008,"stars":1534,"created_at":"2017-06-29T15:54:57.000Z","monthly":[46,28,47,137,183,567]},{"name":"Apollo Server","url":"https://www.apollographql.com/docs/apollo-server/","full_name":"apollographql/apollo-server","description":":earth_africa: GraphQL server for Express, Connect, Hapi, Koa and more","owner_id":17189275,"tags":["graphql"],"delta":2301,"stars":3021,"created_at":"2016-04-21T09:26:01.000Z","monthly":[211,187,208,179,199,301]},{"name":"Wade","url":"","full_name":"kbrsh/wade","description":":ocean: Blazing fast, 1kb search for Javascript","owner_id":15644571,"tags":["search"],"delta":2163,"stars":2652,"created_at":"2017-05-21T01:53:54.000Z","monthly":[35,703,94,102,100,1129]},{"name":"Project Guidelines","url":"","full_name":"wearehive/project-guidelines","description":"A set of best practices for JavaScript projects","owner_id":7815827,"tags":["learning"],"delta":3029,"stars":11690,"created_at":"2017-06-30T10:17:55.000Z","monthly":[349,161,179,200,1193,947]},{"name":"Spacetime","url":"https://smallwins.github.io/spacetime/","full_name":"smallwins/spacetime","description":"A lightweight javascript timezone library","owner_id":15916329,"tags":["date"],"delta":1268,"stars":1520,"created_at":"2017-02-22T15:31:34.000Z","monthly":[31,25,26,74,637,475]},{"name":"Fitty","url":"https://rikschennink.github.io/fitty/","full_name":"rikschennink/fitty","description":"✨ Makes Text Fit Perfectly","owner_id":1132575,"tags":["typo"],"delta":1185,"stars":1928,"created_at":"2017-07-24T09:39:26.000Z","monthly":[14,19,41,355,597,159]},{"name":"Chromeless","url":"https://chromeless.netlify.com","full_name":"graphcool/chromeless","description":"🖥  Chrome automation made simple. Runs locally or headless on AWS Lambda.","owner_id":17219288,"tags":["auto"],"delta":4535,"stars":11687,"created_at":"2017-06-01T16:11:11.000Z","monthly":[251,319,351,431,3183]},{"name":"SheetJS js-xlsx","url":"http://sheetjs.com/","full_name":"SheetJS/js-xlsx","description":":green_book: SheetJS Community Edition -- Spreadsheet Parser and Writer","owner_id":5826089,"tags":["table"],"delta":1639,"stars":8776,"created_at":"2012-12-03T19:25:52.000Z","monthly":[385,327,321,301,305]},{"name":"React Helmet","url":"","full_name":"nfl/react-helmet","description":"A document head manager for React","owner_id":1261928,"tags":["react"],"delta":1168,"stars":6181,"created_at":"2015-06-18T00:07:34.000Z","monthly":[269,229,277,224,169]},{"name":"react-beautiful-dnd","url":"","full_name":"atlassian/react-beautiful-dnd","description":"Beautiful, accessible drag and drop for lists with React.js","owner_id":168166,"tags":["react","dnd"],"delta":3263,"stars":4894,"created_at":"2017-08-09T03:37:15.000Z","monthly":[315,455,621,603,1269]},{"name":"NG-ZORRO","url":"https://ng.ant.design","full_name":"NG-ZORRO/ng-zorro-antd","description":"An enterprise-class UI components based on Ant Design and Angular. 🐜 ","owner_id":30223759,"tags":["angular","component"],"delta":1104,"stars":2211,"created_at":"2017-08-08T14:59:33.000Z","monthly":[176,226,143,266,293]},{"name":"Nivo","url":"http://nivo.rocks","full_name":"plouc/nivo","description":"nivo provides a rich set of dataviz components, built on top of the awesome d3 and Reactjs libraries","owner_id":501642,"tags":["react","chart","svg","d3"],"delta":1904,"stars":2115,"created_at":"2016-04-16T03:27:56.000Z","monthly":[209,39,101,157,1398]},{"name":"Puppeteer","url":"","full_name":"GoogleChrome/puppeteer","description":"Headless Chrome Node API","owner_id":1778935,"tags":["auto"],"delta":21965,"stars":23986,"created_at":"2017-05-09T22:16:13.000Z","monthly":[1931,2168,2956,2913,3884]},{"name":"Wekan","url":"https://wekan.github.io","full_name":"wekan/wekan","description":"The open-source Trello-like kanban (built with Meteor)","owner_id":11725037,"tags":["meteor"],"delta":1124,"stars":12184,"created_at":"2014-01-21T01:26:28.000Z","monthly":[133,200,289,177,325]},{"name":"Rocket.Chat","url":"https://rocket.chat/","full_name":"RocketChat/Rocket.Chat","description":"Have your own Slack like online chat, built with Meteor.","owner_id":12508788,"tags":["meteor"],"delta":2535,"stars":15763,"created_at":"2015-05-19T07:36:09.000Z","monthly":[326,447,601,394,767]},{"name":"Vuestic Admin Dashboard","url":"http://vuestic.epicmax.co","full_name":"epicmaxco/vuestic-admin","description":"Vue.js admin dashboard","owner_id":30595047,"tags":["vue","dashboard"],"delta":2951,"stars":3118,"created_at":"2017-07-31T11:52:40.000Z","monthly":[278,187,206,223,116]},{"name":"Buefy","url":"https://buefy.github.io","full_name":"rafaelpimpa/buefy","description":"Lightweight UI components for Vue.js based on Bulma","owner_id":18370605,"tags":["vue","component"],"delta":1879,"stars":2027,"created_at":"2017-03-31T16:44:48.000Z","monthly":[206,181,161,163,65]},{"name":"fuzzysort","url":"https://rawgit.com/farzher/fuzzysort/master/test.html","full_name":"farzher/fuzzysort","description":"Fast SublimeText-like fuzzy search for JavaScript.","owner_id":1005136,"tags":["search"],"delta":1203,"stars":1363,"created_at":"2017-08-18T06:43:55.000Z","monthly":[18,19,70,229,867]},{"name":"BootstrapVue","url":"https://bootstrap-vue.js.org","full_name":"bootstrap-vue/bootstrap-vue","description":"Quickly integrate Bootstrap 4 Components with Vue.js.","owner_id":22965283,"tags":["vue","component"],"delta":3235,"stars":3620,"created_at":"2016-10-08T15:59:35.000Z","monthly":[477,303,360,347,99]},{"name":"downshift","url":"http://downshift.netlify.com/","full_name":"paypal/downshift","description":"🏎 Primitives to build simple, flexible, WAI-ARIA compliant enhanced input React components","owner_id":476675,"tags":["react","autocomplete"],"delta":2773,"stars":3108,"created_at":"2017-07-25T14:31:42.000Z","monthly":[241,337,394,354,1173,274]},{"name":"Stencil","url":"https://stenciljs.com/","full_name":"ionic-team/stencil","description":"A simple, reusable web component compiler","owner_id":3171503,"tags":["framework"],"delta":1189,"stars":1986,"created_at":"2017-02-15T18:57:07.000Z","monthly":[178,251,290,456,14]},{"name":"r2","url":"","full_name":"mikeal/r2","description":"HTTP client. Spiritual successor to request.","owner_id":579,"tags":["http"],"delta":3495,"stars":4312,"created_at":"2017-08-30T23:50:18.000Z","monthly":[78,44,148,3225]},{"name":"react-imgpro","url":"","full_name":"nitin42/react-imgpro","description":"📷  Image Processing Component for React","owner_id":16336071,"tags":["react","image"],"delta":1123,"stars":1804,"created_at":"2017-09-02T10:01:40.000Z","monthly":[20,13,97,993]},{"name":"Rythm.js","url":"https://okazari.github.io/Rythm.js/","full_name":"Okazari/Rythm.js","description":"A javascript library that makes your page dance.","owner_id":5747538,"tags":["audio"],"delta":2101,"stars":2899,"created_at":"2016-03-12T20:29:07.000Z","monthly":[12,26,110,1953]},{"name":"Lozad","url":"https://apoorv.pro/lozad.js/demo/","full_name":"ApoorvSaxena/lozad.js","description":"🔥  Highly performant, light ~0.7kb and configurable lazy loader in pure JS with no dependencies for","owner_id":307583,"tags":["load"],"delta":3023,"stars":3567,"created_at":"2017-08-28T20:28:52.000Z","monthly":[76,119,610,2218]},{"name":"Fastify","url":"https://www.fastify.io","full_name":"fastify/fastify","description":"Fast and low overhead web framework, for Node.js","owner_id":24939410,"tags":["nodejs-framework"],"delta":5777,"stars":6041,"created_at":"2016-09-28T19:10:14.000Z","monthly":[342,611,2175,2105,60,99,91,17,56,87,15,109]},{"name":"Elm","url":"http://elm-lang.org/","full_name":"elm-lang/elm-compiler","description":"Compiler for Elm, a functional language for reliable webapps.","owner_id":4359353,"tags":["compiler","fp"],"delta":880,"stars":4305,"created_at":"2012-04-19T06:24:43.000Z","monthly":[61,55,63,55,50,51,56,62,53,82,51,71]},{"name":"Formik","url":"","full_name":"jaredpalmer/formik","description":"Build forms in React, without the tears 😭 ","owner_id":4060187,"tags":["react","form"],"delta":1265,"stars":4431,"created_at":"2017-06-14T19:50:59.000Z","monthly":[300,427,337,201]},{"name":"Modern JavaScript Cheatsheet","url":"https://mbeaudru.github.io/modern-js-cheatsheet/","full_name":"mbeaudru/modern-js-cheatsheet","description":"Cheatsheet for the JavaScript knowledge you will frequently encounter in modern projects.","owner_id":8942633,"tags":["learning"],"delta":7572,"stars":15609,"created_at":"2017-09-18T14:56:00.000Z","monthly":[543,603,5910,516]},{"name":"freeCodeCamp","url":"","full_name":"freeCodeCamp/freeCodeCamp","description":"The https://freeCodeCamp.org open source codebase and curriculum. Learn to code and help nonprofits.","owner_id":9892522,"tags":["learning"],"delta":378,"stars":291583,"created_at":"2014-12-24T17:49:19.000Z","monthly":[74,137,190,-23]},{"name":"Every Programmer Should Know","url":"","full_name":"mtdvio/every-programmer-should-know","description":"A collection of (mostly) technical things every software developer should know","owner_id":33053074,"tags":["meta"],"delta":6672,"stars":31460,"created_at":"2017-08-24T13:18:26.000Z","monthly":[946,1116,4610]},{"name":"Draggable","url":"https://shopify.github.io/draggable/","full_name":"Shopify/draggable","description":"The JavaScript Drag & Drop library your grandparents warned you about.","owner_id":8085,"tags":["dnd"],"delta":5312,"stars":9789,"created_at":"2017-09-27T15:31:23.000Z","monthly":[229,465,4618]},{"name":"deeplearn.js","url":"https://deeplearnjs.org","full_name":"PAIR-code/deeplearnjs","description":"Hardware-accelerated deep learning // machine learning // NumPy library for the web.","owner_id":29804435,"tags":["ml"],"delta":1911,"stars":5858,"created_at":"2017-08-02T14:45:47.000Z","monthly":[588,343,980]},{"name":"GraphiQL","url":"","full_name":"graphql/graphiql","description":"An in-browser IDE for exploring GraphQL.","owner_id":12972006,"tags":["graphql"],"delta":2562,"stars":4826,"created_at":"2015-08-11T02:56:22.000Z","monthly":[242,222,213]},{"name":"GraphQL Playground","url":"","full_name":"graphcool/graphql-playground","description":"🎮  GraphQL IDE for better development workflows (GraphQL Subscriptions, interactive docs & collabor","owner_id":17219288,"tags":["graphql"],"delta":1293,"stars":1381,"created_at":"2017-01-25T13:19:29.000Z","monthly":[109,134,172]},{"name":"Material Design for Angular","url":"https://material.angular.io","full_name":"angular/material2","description":"Material Design components for Angular","owner_id":139426,"tags":["material","angular"],"delta":1427,"stars":12784,"created_at":"2016-01-04T18:50:02.000Z","monthly":[447,507,473]},{"name":"React Static","url":"","full_name":"nozzle/react-static","description":"⚛️ 🚀 A progressive static-site generator for React.","owner_id":5400727,"tags":["react","ssg"],"delta":2998,"stars":3176,"created_at":"2017-09-09T22:10:32.000Z","monthly":[338,341,2188]},{"name":"vuera","url":"","full_name":"akxcv/vuera","description":":eyes: Vue in React, React in Vue. Seamless integration of the two. :dancers:","owner_id":17192674,"tags":["react","vue"],"delta":1153,"stars":1489,"created_at":"2017-09-27T21:26:27.000Z","monthly":[35,100,1018]},{"name":"accessibilityjs","url":"","full_name":"github/accessibilityjs","description":"Client side accessibility error scanner.","owner_id":9919,"tags":["access"],"delta":1079,"stars":1981,"created_at":"2017-06-22T12:41:18.000Z","monthly":[55,351,673]},{"name":"napajs","url":"","full_name":"Microsoft/napajs","description":"Napa.js: a multi-threaded JavaScript runtime","owner_id":6154722,"tags":["node.js"],"delta":3016,"stars":7509,"created_at":"2017-07-18T21:41:10.000Z","monthly":[217,569,2230]},{"name":"Froala Design Blocks ","url":"https://www.froala.com/design-blocks","full_name":"froala/design-blocks","description":"A set of 170+ Bootstrap based design blocks ready to be used to create clean modern websites.","owner_id":7966884,"tags":["html"],"delta":3725,"stars":9648,"created_at":"2017-08-03T13:22:43.000Z","monthly":[1105,1404,1216]},{"name":"Front-End Checklist","url":"https://frontendchecklist.io","full_name":"thedaviddias/Front-End-Checklist","description":"🗂 The perfect Front-End Checklist for modern websites and meticulous developers","owner_id":237229,"tags":["learning"],"delta":15502,"stars":24908,"created_at":"2017-10-16T10:12:36.000Z","monthly":[4536,7152,3814]},{"name":"HEML","url":"https://heml.io","full_name":"SparkPost/heml","description":"HEML is an open source markup language for building responsive email.","owner_id":9406778,"tags":["email"],"delta":1822,"stars":3617,"created_at":"2017-10-09T23:16:05.000Z","monthly":[152,1183,487]},{"name":"Graphcool","url":"https://www.prismagraphql.com","full_name":"graphcool/prisma","description":"⚡️ Prisma turns your database into a realtime GraphQL API","owner_id":17219288,"tags":["graphql"],"delta":1657,"stars":4999,"created_at":"2016-09-25T12:54:40.000Z","twitter":"graphcool","monthly":[477,939,241]},{"name":"Frappé Charts","url":"https://frappe.github.io/charts","full_name":"frappe/charts","description":"📊🍩📈 Simple, responsive, modern SVG Charts with zero dependencies","owner_id":836974,"tags":["chart","svg"],"delta":9001,"stars":10186,"created_at":"2017-10-26T10:13:21.000Z","monthly":[604,8397]},{"name":"Ant Design Pro","url":"http://pro.ant.design/","full_name":"ant-design/ant-design-pro","description":"👨🏻‍💻👩🏻‍💻 An out-of-box UI solution for enterprise applications","owner_id":12101536,"tags":["dashboard","react"],"delta":5670,"stars":6779,"created_at":"2017-08-25T10:40:44.000Z","monthly":[1102,2871]},{"name":"Bottender","url":"https://bottender.js.org","full_name":"Yoctol/bottender","description":"⚡️ Make Bots in Your Way, Fast and Flexibly ","owner_id":10671553,"tags":["bot"],"delta":1497,"stars":1955,"created_at":"2017-10-16T09:40:49.000Z","monthly":[119,1378]},{"name":"Tailwind CSS","url":"https://tailwindcss.com/","full_name":"tailwindcss/tailwindcss","description":"A utility-first CSS framework for rapid UI development.","owner_id":30317862,"tags":["css-lib"],"delta":2156,"stars":3550,"created_at":"2017-10-06T14:59:14.000Z","monthly":[436,1720]},{"name":"Server.js","url":"https://serverjs.io/","full_name":"franciscop/server","description":":desktop_computer: Simple and powerful server for Node.js","owner_id":2801252,"tags":["nodejs-framework","express"],"delta":2922,"stars":3004,"created_at":"2016-12-20T20:51:08.000Z","twitter":"","monthly":[131,2679,34,1,8,10,17,3,8,4,10,17],"icon":"server.svg"},{"name":"cube-ui","url":"https://didi.github.io/cube-ui/","full_name":"didi/cube-ui","description":":large_orange_diamond: A fantastic mobile ui lib implement by Vue","owner_id":27521938,"tags":["vue","mobile"],"delta":1452,"stars":2288,"created_at":"2017-11-03T06:17:27.000Z","monthly":[350,1102]},{"name":"Reason","url":"http://reasonml.github.io","full_name":"facebook/reason","description":"Simple, fast & type safe code that leverages the JavaScript & OCaml ecosystems","owner_id":69631,"tags":["compiler"],"delta":2066,"stars":4742,"created_at":"2015-11-16T08:22:32.000Z","twitter":"reasonml","monthly":[395,201,266,284,151,72,85,115,143,186,79,186]},{"name":"ClojureScript","url":"http://clojurescript.org/","full_name":"clojure/clojurescript","description":"Clojure to JS compiler","owner_id":317875,"tags":["compiler"],"delta":1049,"stars":7483,"created_at":"2011-07-20T23:29:13.000Z","monthly":[46,54,56,59,70,81,72,54,75,83,59,73]},{"name":"Papers we love","url":"http://paperswelove.org/","full_name":"papers-we-love/papers-we-love","description":"Papers from the computer science community to read and discuss.","owner_id":6187757,"tags":["learning"],"delta":846,"stars":28259,"created_at":"2013-12-15T14:31:41.000Z","monthly":[426,420]},{"name":"Tech Interview Handbook","url":"","full_name":"yangshun/tech-interview-handbook","description":"💯 Algorithms study materials, behavioral content and tips for rocking your coding interview","owner_id":1315101,"tags":["meta"],"delta":715,"stars":16507,"created_at":"2016-07-05T05:00:48.000Z","monthly":[355,360]},{"name":"Node.js Best Practices","url":"https://twitter.com/nodepractices/","full_name":"i0natan/nodebestpractices","description":"The largest Node.JS best practices list. Curated from the top ranked articles and always updated","owner_id":8571500,"tags":["learning"],"delta":2974,"stars":11792,"created_at":"2017-09-15T08:33:19.000Z","monthly":[985,1989]},{"name":"Functional Programming Jargon","url":"http://git.io/fp-jargons","full_name":"hemanth/functional-programming-jargon","description":"Jargon from the functional programming world in simple terms!","owner_id":18315,"tags":["learning","fp"],"delta":300,"stars":11463,"created_at":"2015-02-22T16:04:42.000Z","monthly":[140,160]},{"name":"Luxon","url":"https://moment.github.io/luxon","full_name":"moment/luxon","description":"⏱ A library for working with dates and times in JS","owner_id":4129662,"tags":["date"],"delta":4721,"stars":5325,"created_at":"2015-11-30T12:48:48.000Z","monthly":[672,4049]},{"name":"react-fns","url":"https://react-fns.netlify.com","full_name":"jaredpalmer/react-fns","description":"Browser API's turned into declarative React components and HoC's","owner_id":4060187,"tags":["react"],"delta":1204,"stars":2313,"created_at":"2017-10-14T20:19:51.000Z","monthly":[201,1003]},{"name":"Scrollama","url":"https://russellgoldenberg.github.io/scrollama/basic","full_name":"russellgoldenberg/scrollama","description":"Scrollytelling with IntersectionObserver.","owner_id":324631,"tags":["scrolling"],"delta":1616,"stars":3023,"created_at":"2017-10-20T13:05:29.000Z","monthly":[485,1131]},{"name":"Functional-Light JavaScript","url":"http://FLJSBook.com","full_name":"getify/Functional-Light-JS","description":"Pragmatic, balanced FP in JavaScript. @FLJSBook on twitter.","owner_id":150330,"tags":["fp","book"],"delta":1027,"stars":7130,"created_at":"2016-08-17T01:40:50.000Z","monthly":[642,385]},{"name":"Superstruct","url":"","full_name":"ianstormtaylor/superstruct","description":"A simple and composable way  to validate data in Javascript.","owner_id":311752,"tags":["validation","json"],"delta":2483,"stars":2997,"created_at":"2017-11-23T03:03:25.000Z","monthly":[2483]},{"name":"Parcel","url":"https://parceljs.org","full_name":"parcel-bundler/parcel","description":"📦🚀 Blazing fast, zero configuration web application bundler","owner_id":32607881,"tags":["module","build"],"delta":13950,"stars":16940,"created_at":"2017-08-07T16:36:47.000Z","twitter":"parceljs","monthly":[13934,1,1]},{"name":"30 seconds of code","url":"https://30secondsofcode.org/","full_name":"Chalarangelo/30-seconds-of-code","description":"Curated collection of useful Javascript snippets that you can understand in 30 seconds or less.","owner_id":8281875,"tags":["learning"],"delta":11107,"stars":16135,"created_at":"2017-11-29T17:35:03.000Z","monthly":[11107]},{"name":"Docusaurus","url":"https://docusaurus.io","full_name":"facebook/Docusaurus","description":"Easy to maintain open source documentation websites.","owner_id":69631,"tags":["doc","react"],"delta":2204,"stars":5739,"created_at":"2017-06-20T16:13:53.000Z","monthly":[2204]},{"name":"Boardgame","url":"http://boardgame.io/","full_name":"google/boardgame.io","description":"State management and more for turn based games.","owner_id":1342004,"tags":["state"],"delta":4104,"stars":5356,"created_at":"2017-11-21T23:47:35.000Z","monthly":[4104]},{"name":"React Content Loader","url":"https://danilowoz.github.io/react-content-loader/","full_name":"danilowoz/react-content-loader","description":"React component that uses SVG to create a collection of loaders which simulates the structure of the","owner_id":4838076,"tags":["react","svg"],"delta":1259,"stars":3384,"created_at":"2017-01-20T00:30:11.000Z","monthly":[1259]},{"name":"Mint UI","url":"http://mint-ui.github.io/#!/en","full_name":"ElemeFE/mint-ui","description":"Mobile UI elements for Vue.js","owner_id":12810740,"tags":["vue","component","mobile"],"delta":5546,"stars":9352,"created_at":"2016-05-17T09:54:10.000Z","monthly":[116]},{"name":"Purescript","url":"http://purescript.org","full_name":"purescript/purescript","description":"A strongly-typed language that compiles to Javascript","owner_id":6556677,"tags":["compiler"],"delta":1225,"stars":4402,"created_at":"2013-09-30T05:29:23.000Z","monthly":[108,123,121,99,106,92,96,63,101,96,77,123]},{"name":"Weex","url":"https://weex.apache.org/","full_name":"apache/incubator-weex","description":"A framework for building Mobile cross-platform UI.","owner_id":47359,"tags":["vue","mobile"],"delta":6515,"stars":7473,"created_at":"2017-01-06T08:00:06.000Z","twitter":"","monthly":[456,538,608,563,550,668,764,839,1387,116,26],"icon":"weex.svg"}]}

/***/ }),
/* 419 */
/***/ (function(module, exports) {

	module.exports = [{"key":"all","excluded":["js-algorithms-and-data-structures","awesome","you-dont-know-js","airbnb-style-guide","front-end-job-interview-questions","front-end-checklist","30-seconds-of-code","nodejs-best-practices","tech-interview-handbook","30-seconds-of-css","33-js-concepts","project-guidelines"],"limit":10,"count":50},{"key":"framework","count":20},{"key":"nodejs-framework","tags":["nodejs-framework"],"count":20},{"key":"react","tags":["react","react-native"],"count":20,"excluded":["react","react-native","storybook"]},{"key":"vue","count":10,"excluded":["vuejs","storybook"]},{"key":"angular","count":10,"excluded":["angular","angular-1","storybook"]},{"key":"mobile","excluded":["mint-ui","nativebase"],"count":5},{"key":"compiler","count":5},{"key":"build","count":5},{"key":"test-framework","count":5},{"key":"ide","count":5},{"key":"css-in-js","count":10,"excluded":["typographyjs"]},{"key":"ssg","count":10},{"key":"graphql","count":15,"disabled":false},{"key":"learning","count":10,"availableComments":["en","es","zh"],"guest":"angelos"}]

/***/ }),
/* 420 */
/***/ (function(module, exports) {

	module.exports = {"date":"2019-01-07T22:18:12.406Z","count":950,"projects":[{"name":"RiotJS","url":"https://riot.js.org","full_name":"riot/riot","description":"Simple and elegant component-based UI library","owner_id":12729373,"tags":["framework","vdom"],"delta":739,"stars":13395,"created_at":"2013-09-27T05:21:01.000Z","monthly":[44,48,58,47,49,70,54,63,79,75,80,72]},{"name":"Aurelia","url":"http://aurelia.io/","full_name":"aurelia/framework","description":"The aurelia framework brings together all the required core aurelia libraries into a ready-to-go app","owner_id":9808864,"tags":["framework"],"delta":418,"stars":10751,"created_at":"2014-12-10T19:22:29.000Z","monthly":[30,53,16,29,26,42,29,19,26,33,42,73]},{"name":"Angular 1","url":"https://angularjs.org","full_name":"angular/angular.js","description":"AngularJS - HTML enhanced for web apps!","owner_id":139426,"tags":["framework","angular"],"delta":1581,"stars":59339,"created_at":"2010-01-06T00:34:37.000Z","twitter":"","monthly":[28,75,93,139,131,125,187,146,212,106,158,181],"icon":"angular.svg"},{"name":"Flux","url":"http://facebook.github.io/flux/","full_name":"facebook/flux","description":"Application Architecture for Building User Interfaces","owner_id":69631,"tags":["flux"],"delta":1133,"stars":15835,"created_at":"2014-07-20T23:33:08.000Z","twitter":"","monthly":[65,73,69,83,90,98,119,116,109,108,97,106],"icon":"flux.svg"},{"name":"React","url":"https://reactjs.org","full_name":"facebook/react","description":"A declarative, efficient, and flexible JavaScript library for building user interfaces.","owner_id":69631,"tags":["framework","vdom","react"],"delta":34157,"stars":119154,"created_at":"2013-05-24T16:15:54.000Z","twitter":"reactjs","monthly":[2001,2284,2179,2218,2390,2550,7922,2419,2538,2869,2063,2724],"icon":"react.svg"},{"name":"Foundation","url":"http://foundation.zurb.com","full_name":"zurb/foundation-sites","description":"The most advanced responsive front-end framework in the world. Quickly create prototypes and product","owner_id":156122,"tags":["css-lib"],"delta":1039,"stars":27889,"created_at":"2011-10-13T23:05:42.000Z","monthly":[53,97,74,79,63,89,69,97,96,133,80,109]},{"name":"Bootstrap","url":"https://getbootstrap.com","full_name":"twbs/bootstrap","description":"The most popular HTML, CSS, and JavaScript framework for developing responsive, mobile first project","owner_id":2918581,"tags":["css-lib"],"delta":9960,"stars":129834,"created_at":"2011-07-29T21:19:00.000Z","twitter":"getbootstrap","monthly":[678,641,694,700,587,706,694,887,930,900,1015,1528]},{"name":"Alt","url":"http://alt.js.org/","full_name":"goatslacker/alt","description":"Isomorphic flux implementation","owner_id":10632,"tags":["flux"],"delta":51,"stars":3499,"created_at":"2014-12-19T09:44:04.000Z"},{"name":"Reflux","url":null,"full_name":"reflux/refluxjs","description":"A simple library for uni-directional dataflow application architecture with React extensions inspire","owner_id":13524454,"tags":["flux"],"delta":104,"stars":5402,"created_at":"2014-07-01T18:05:30.000Z"},{"name":"Ionic","url":"https://ionicframework.com/","full_name":"ionic-team/ionic","description":"Build amazing native and progressive web apps with open web technologies. One app running on everyth","owner_id":3171503,"tags":["mobile"],"delta":3482,"stars":36326,"created_at":"2013-08-20T23:06:02.000Z","twitter":"Ionicframework","monthly":[266,299,271,246,353,265,206,340,282,325,294,335]},{"name":"Sails","url":"https://sailsjs.com","full_name":"balderdashy/sails","description":"Realtime MVC Framework for Node.js","owner_id":1445252,"tags":["nodejs-framework"],"delta":1853,"stars":20082,"created_at":"2012-03-18T19:46:15.000Z","twitter":"sailsjs","monthly":[118,114,135,154,141,158,156,164,274,177,117,145],"icon":"sails.jpg"},{"name":"Keystone","url":"http://www.keystonejs.com","full_name":"keystonejs/keystone","description":"Node.js CMS and web app framework","owner_id":6118534,"tags":["nodejs-framework","cms"],"delta":2139,"stars":13843,"created_at":"2013-07-02T05:01:55.000Z","twitter":"keystonejs","monthly":[123,144,165,153,167,178,165,172,178,220,240,234]},{"name":"PureCSS","url":"http://purecss.io/","full_name":"pure-css/pure","description":"A set of small, responsive CSS modules that you can use in every web project.","owner_id":23743443,"tags":["css-lib"],"delta":1473,"stars":19488,"created_at":"2013-04-22T16:16:39.000Z","monthly":[128,106,139,113,120,119,74,122,112,143,129,168]},{"name":"Topcoat","url":"topcoat.io","full_name":"topcoat/topcoat","description":"CSS for clean and fast web apps","owner_id":2718604,"tags":["css-lib"],"delta":22,"stars":4305,"created_at":"2012-11-01T15:12:16.000Z"},{"name":"Phaser","url":"http://phaser.io","full_name":"photonstorm/phaser","description":"Phaser is a fun, free and fast 2D game framework for making HTML5 games for desktop and mobile web b","owner_id":164476,"tags":["game"],"delta":6522,"stars":23601,"created_at":"2013-04-12T12:27:51.000Z","monthly":[229,341,297,225,253,239,294,324,773,1280,1960,307]},{"name":"Greensock","url":"https://greensock.com","full_name":"greensock/GreenSock-JS","description":"GreenSock's GSAP JavaScript animation library (including Draggable).","owner_id":2386673,"tags":["animation"],"delta":1688,"stars":8716,"created_at":"2012-09-21T18:03:25.000Z","monthly":[139,121,136,156,142,158,172,151,121,158,116,118]},{"name":"SemanticUI","url":"http://www.semantic-ui.com","full_name":"Semantic-Org/Semantic-UI","description":"Semantic is a UI component framework based around useful principles from natural language.","owner_id":5796209,"tags":["css-lib"],"delta":5228,"stars":44077,"created_at":"2013-04-08T23:32:04.000Z","monthly":[366,308,336,332,377,435,429,480,537,599,485,544]},{"name":"Ember","url":"http://www.emberjs.com","full_name":"emberjs/ember.js","description":"Ember.js - A JavaScript framework for creating ambitious web applications","owner_id":1253363,"tags":["framework"],"delta":1773,"stars":20359,"created_at":"2011-05-25T23:39:40.000Z","monthly":[94,97,94,92,703,112,128,79,76,84,84,130]},{"name":"Chart.js","url":"https://www.chartjs.org/","full_name":"chartjs/Chart.js","description":"Simple HTML5 Charts using the <canvas> tag","owner_id":10342521,"tags":["chart","canvas"],"delta":6794,"stars":41176,"created_at":"2013-03-17T23:56:36.000Z","twitter":"","monthly":[513,475,486,525,540,650,856,481,575,552,555,586]},{"name":"Raphael","url":"http://www.raphaeljs.com/","full_name":"DmitryBaranovskiy/raphael","description":"JavaScript Vector Library","owner_id":22726,"tags":["drawing"],"delta":587,"stars":10043,"created_at":"2008-09-02T05:34:33.000Z","monthly":[40,50,36,48,47,48,41,61,56,60,45,55]},{"name":"D3","url":"https://d3js.org","full_name":"d3/d3","description":"Bring data to life with SVG, Canvas and HTML. :bar_chart::chart_with_upwards_trend::tada:","owner_id":1562726,"tags":["chart","d3","svg","canvas"],"delta":10054,"stars":81489,"created_at":"2010-09-27T17:22:42.000Z","twitter":"d3js_org","monthly":[707,779,690,749,743,738,751,857,973,1438,739,890]},{"name":"Backbone","url":"http://backbonejs.org","full_name":"jashkenas/backbone","description":"Give your JS App some Backbone with Models, Views, Collections, and Events","owner_id":4732,"tags":["framework"],"delta":448,"stars":27365,"created_at":"2010-09-30T19:41:28.000Z","twitter":"","monthly":[18,22,19,28,35,34,10,59,56,62,47,58],"icon":"backbone.svg"},{"name":"AngularUI Router","url":"http://ui-router.github.io/","full_name":"angular-ui/ui-router","description":"The de-facto solution to flexible routing with nested views in AngularJS","owner_id":1530011,"tags":["angular","routing"],"delta":218,"stars":13923,"created_at":"2013-01-18T20:26:29.000Z","twitter":"","monthly":[10,-1,0,8,7,29,3,36,37,26,24,39]},{"name":"Material UI","url":"https://material-ui.com/","full_name":"mui-org/material-ui","description":"React components that implement Google's Material Design.","owner_id":33663932,"tags":["material","react","component"],"delta":11386,"stars":43318,"created_at":"2014-08-18T19:11:54.000Z","twitter":"materialui","monthly":[783,757,879,864,869,846,931,1861,860,974,769,993]},{"name":"Broccoli","url":"","full_name":"broccolijs/broccoli","description":"Browser compilation library – an asset pipeline for applications that run in the browser","owner_id":6686448,"tags":["build"],"delta":84,"stars":3162,"created_at":"2013-05-14T02:48:01.000Z"},{"name":"BaconJS","url":"https://baconjs.github.io","full_name":"baconjs/bacon.js","description":"FRP (functional reactive programming) library for Javascript","owner_id":5165264,"tags":["stream","reactive"],"delta":203,"stars":6031,"created_at":"2012-03-02T19:21:42.000Z","twitter":""},{"name":"Polymer","url":"https://polymer-library.polymer-project.org/","full_name":"Polymer/polymer","description":"Our original Web Component library.","owner_id":2159051,"tags":["framework"],"delta":1591,"stars":20563,"created_at":"2012-08-23T20:56:30.000Z","monthly":[65,142,97,122,143,136,160,218,116,139,146,107]},{"name":"Restify","url":"http://restify.com","full_name":"restify/node-restify","description":"The future of Node.js REST development","owner_id":6948699,"tags":["nodejs-framework"],"delta":1282,"stars":8926,"created_at":"2011-04-25T21:19:26.000Z","twitter":"","monthly":[77,97,82,75,92,106,96,118,174,134,113,118]},{"name":"Brunch","url":"http://brunch.io","full_name":"brunch/brunch","description":":fork_and_knife: Fast front-end web app build tool with simple declarative config, seamless incremen","owner_id":575509,"tags":["build"],"delta":225,"stars":6549,"created_at":"2011-01-21T00:59:55.000Z"},{"name":"Express","url":"https://expressjs.com","full_name":"expressjs/express","description":"Fast, unopinionated, minimalist web framework for node.","owner_id":5658226,"tags":["nodejs-framework","express"],"delta":5849,"stars":41788,"created_at":"2009-06-26T18:56:01.000Z","twitter":"expressjs","monthly":[398,493,425,434,483,446,463,510,602,564,483,548]},{"name":"Materialize CSS","url":"https://materializecss.com","full_name":"Dogfalo/materialize","description":"Materialize, a CSS Framework based on Material Design","owner_id":2775751,"tags":["css-lib","material"],"delta":4039,"stars":34783,"created_at":"2014-09-12T19:35:38.000Z","monthly":[219,241,243,254,257,316,386,387,404,470,388,474]},{"name":"Material Angular","url":"https://material.angularjs.org/","full_name":"angular/material","description":"Material design for AngularJS","owner_id":139426,"tags":["angular","material"],"delta":399,"stars":16363,"created_at":"2014-07-01T19:20:06.000Z","monthly":[15,18,20,-6,25,48,29,68,48,28,42,64]},{"name":"Impress","url":"http://impress.js.org","full_name":"impress/impress.js","description":"It's a presentation framework based on the power of CSS3 transforms and transitions in modern browse","owner_id":5477410,"tags":["presentation"],"delta":1454,"stars":34365,"created_at":"2011-12-28T22:23:19.000Z","monthly":[102,117,115,112,111,85,84,133,175,153,129,138]},{"name":"jQuery","url":"https://jquery.com/","full_name":"jquery/jquery","description":"jQuery JavaScript Library","owner_id":70142,"tags":["util","dom"],"delta":3122,"stars":50721,"created_at":"2009-04-03T15:20:14.000Z","monthly":[229,207,206,196,266,272,216,270,297,362,216,385]},{"name":"React Router","url":"https://reacttraining.com/react-router/","full_name":"ReactTraining/react-router","description":"Declarative routing for React","owner_id":11823761,"tags":["react","routing"],"delta":6979,"stars":34234,"created_at":"2014-05-16T22:22:51.000Z","monthly":[429,495,510,491,515,551,638,647,648,721,562,772]},{"name":"Webpack","url":"https://webpack.js.org","full_name":"webpack/webpack","description":"A bundler for javascript and friends. Packs many modules into a few bundled assets. Code Splitting a","owner_id":2105791,"tags":["build","module"],"delta":10721,"stars":46253,"created_at":"2012-03-10T10:08:14.000Z","monthly":[618,605,593,670,803,738,799,910,1050,1326,1385,1224],"icon":"webpack.svg"},{"name":"Gulp","url":"http://gulpjs.com","full_name":"gulpjs/gulp","description":"The streaming build system","owner_id":6200624,"tags":["build"],"delta":2469,"stars":30774,"created_at":"2013-07-04T05:26:06.000Z","twitter":"gulpjs","monthly":[139,103,141,168,214,216,192,251,248,231,216,350]},{"name":"Grunt","url":"http://gruntjs.com/","full_name":"gruntjs/grunt","description":"Grunt: The JavaScript Task Runner","owner_id":1630826,"tags":["build"],"delta":215,"stars":11912,"created_at":"2011-09-21T15:16:20.000Z","monthly":[25,8,18,6,20,13,7,29,31,28,12,18]},{"name":"Fontawesome","url":"https://fontawesome.com","full_name":"FortAwesome/Font-Awesome","description":"The iconic SVG, font, and CSS toolkit","owner_id":1505683,"tags":["icon"],"delta":4250,"stars":58363,"created_at":"2012-02-17T14:19:43.000Z","monthly":[275,246,200,234,311,248,300,457,435,490,626,428]},{"name":"Ionicons","url":"http://ionicons.com/","full_name":"ionic-team/ionicons","description":"The premium icon font for Ionic Framework and web apps everywhere","owner_id":3171503,"tags":["icon"],"delta":1119,"stars":13312,"created_at":"2013-10-10T14:34:18.000Z","monthly":[65,82,82,71,67,85,90,137,111,89,105,135]},{"name":"Reveal","url":"https://revealjs.com","full_name":"hakimel/reveal.js","description":"The HTML Presentation Framework","owner_id":629429,"tags":["presentation"],"delta":5712,"stars":44008,"created_at":"2011-06-07T18:54:22.000Z","monthly":[372,481,431,531,500,393,466,577,552,512,425,472]},{"name":"Select2","url":"https://select2.org/","full_name":"select2/select2","description":"Select2 is a jQuery based replacement for select boxes. It supports searching, remote data sets, and","owner_id":8077542,"tags":["plugin","autocomplete"],"delta":1461,"stars":23158,"created_at":"2012-03-04T18:43:12.000Z","monthly":[87,90,123,99,122,127,112,127,136,144,135,159]},{"name":"RxJS","url":"http://reactivex.io","full_name":"Reactive-Extensions/RxJS","description":"The Reactive Extensions for JavaScript","owner_id":984368,"tags":["stream","reactive"],"delta":1261,"stars":19522,"created_at":"2012-01-07T00:31:41.000Z","twitter":"","monthly":[45,52,43,55,59,92,93,96,128,213,191,194]},{"name":"Jasmine","url":"http://jasmine.github.io/","full_name":"jasmine/jasmine","description":"Simple JavaScript testing framework for browsers and node.js","owner_id":4624349,"tags":["test-framework","test"],"delta":911,"stars":14081,"created_at":"2008-12-02T23:46:37.000Z","monthly":[44,79,71,76,80,76,74,90,84,88,72,77]},{"name":"Mocha","url":"https://mochajs.org","full_name":"mochajs/mocha","description":"☕️ simple, flexible, fun javascript test framework for node.js & the browser","owner_id":8770005,"tags":["test-framework","test"],"delta":2619,"stars":16928,"created_at":"2011-03-07T18:44:25.000Z","monthly":[171,181,218,172,187,231,204,240,252,263,225,275]},{"name":"Jest","url":"https://jestjs.io","full_name":"facebook/jest","description":"Delightful JavaScript Testing.","owner_id":69631,"tags":["test-framework","test"],"delta":8058,"stars":22616,"created_at":"2013-12-10T00:18:04.000Z","twitter":"fbjest","monthly":[542,663,603,626,689,764,711,674,584,672,642,888],"icon":"jest.svg"},{"name":"Sinon.JS","url":"https://sinonjs.org/","full_name":"sinonjs/sinon","description":"Test spies, stubs and mocks for JavaScript.","owner_id":6570253,"tags":["test"],"delta":1503,"stars":6758,"created_at":"2010-06-29T21:15:32.000Z","monthly":[96,109,118,92,144,125,112,143,143,169,130,122]},{"name":"Karma","url":"http://karma-runner.github.io","full_name":"karma-runner/karma","description":"Spectacular Test Runner for JavaScript","owner_id":3284117,"tags":["test"],"delta":1092,"stars":10425,"created_at":"2011-10-12T07:55:46.000Z","monthly":[70,70,69,76,158,140,86,87,96,81,66,93]},{"name":"Zepto","url":"http://zeptojs.com","full_name":"madrobby/zepto","description":"Zepto.js is a minimalist JavaScript library for modern browsers, with a jQuery-compatible API","owner_id":3390,"tags":["dom"],"delta":835,"stars":14231,"created_at":"2010-09-20T07:57:57.000Z","monthly":[59,49,64,61,66,59,77,67,83,101,65,84]},{"name":"Underscore","url":"http://underscorejs.org","full_name":"jashkenas/underscore","description":"JavaScript's utility _ belt","owner_id":4732,"tags":["util"],"delta":1948,"stars":24060,"created_at":"2009-10-25T18:31:06.000Z","monthly":[86,125,114,127,142,207,237,209,171,207,144,179]},{"name":"Lodash","url":"https://lodash.com/","full_name":"lodash/lodash","description":"A modern JavaScript utility library delivering modularity, performance, & extras.","owner_id":2565403,"tags":["util"],"delta":7892,"stars":36648,"created_at":"2012-04-07T04:11:46.000Z","monthly":[532,568,535,605,622,781,807,699,680,707,622,734]},{"name":"Koa","url":"https://koajs.com","full_name":"koajs/koa","description":"Expressive middleware for node.js using ES2017 async functions","owner_id":5055057,"tags":["nodejs-framework"],"delta":5478,"stars":24521,"created_at":"2013-07-20T18:53:45.000Z","monthly":[373,371,385,476,448,468,438,506,527,578,382,526]},{"name":"Moment","url":"momentjs.com","full_name":"moment/moment","description":"Parse, validate, manipulate, and display dates in javascript.","owner_id":4129662,"tags":["format","date"],"delta":4777,"stars":39758,"created_at":"2011-03-01T02:46:06.000Z","monthly":[309,329,289,331,353,407,491,473,490,490,379,436]},{"name":"React Intl","url":"http://formatjs.io/","full_name":"yahoo/react-intl","description":"Internationalize React apps. This library provides React components and an API to format dates, numb","owner_id":16574,"tags":["format","i18n"],"delta":2586,"stars":8989,"created_at":"2014-04-24T17:28:36.000Z","twitter":"","monthly":[175,196,224,185,214,228,178,215,272,251,220,228]},{"name":"Math.JS","url":"mathjs.org","full_name":"josdejong/mathjs","description":"An extensive math library for JavaScript and Node.js","owner_id":568626,"tags":["math"],"delta":2619,"stars":7910,"created_at":"2013-02-15T19:46:01.000Z","monthly":[156,135,117,250,202,313,827,148,126,123,95,127]},{"name":"Numeral.JS","url":"http://numeraljs.com","full_name":"adamwdraper/Numeral-js","description":"A javascript library for formatting and manipulating numbers.","owner_id":678099,"tags":["format"],"delta":1207,"stars":7006,"created_at":"2012-10-01T20:50:23.000Z","monthly":[97,96,101,86,101,124,87,133,91,101,76,114]},{"name":"Metalsmith","url":"https://metalsmith.io","full_name":"segmentio/metalsmith","description":"An extremely simple, pluggable static site generator.","owner_id":819518,"tags":["ssg"],"delta":626,"stars":7092,"created_at":"2014-02-04T03:46:22.000Z","monthly":[34,39,51,43,50,51,52,75,72,58,38,63]},{"name":"Harp","url":"http://harpjs.com","full_name":"sintaxi/harp","description":"Static Site Server/Generator with built-in preprocessing","owner_id":867,"tags":["ssg"],"delta":166,"stars":4740,"created_at":"2012-12-03T02:49:07.000Z"},{"name":"Radium","url":"http://formidable.com/open-source/radium/","full_name":"FormidableLabs/radium","description":"A toolchain for React component styling.","owner_id":5078602,"tags":["css-in-js"],"delta":822,"stars":6759,"created_at":"2015-01-09T19:35:59.000Z","monthly":[61,68,50,50,71,71,59,71,83,94,65,79]},{"name":"Typeahead","url":"http://twitter.github.com/typeahead.js/","full_name":"twitter/typeahead.js","description":"typeahead.js is a fast and fully-featured autocomplete library","owner_id":50278,"tags":["plugin","autocomplete"],"delta":672,"stars":15522,"created_at":"2013-02-19T19:45:01.000Z","monthly":[35,25,51,56,44,49,54,47,70,99,71,71]},{"name":"Atom","url":"https://atom.io","full_name":"atom/atom","description":":atom: The hackable text editor","owner_id":1089146,"tags":["ide"],"delta":4852,"stars":47478,"created_at":"2012-01-20T18:18:21.000Z","twitter":"atomeditor","monthly":[271,331,333,313,370,340,366,416,495,560,510,547]},{"name":"Brackets","url":"http://brackets.io","full_name":"adobe/brackets","description":"An open source code editor for the web, written in JavaScript, HTML and CSS.","owner_id":476009,"tags":["ide"],"delta":951,"stars":29485,"created_at":"2011-12-07T21:14:40.000Z","twitter":"brackets","monthly":[49,61,186,20,52,66,56,76,104,72,103,106]},{"name":"Chosen","url":"http://harvesthq.github.io/chosen/","full_name":"harvesthq/chosen","description":"Chosen is a library for making long, unwieldy select boxes more friendly.","owner_id":43635,"tags":["plugin"],"delta":624,"stars":21953,"created_at":"2011-04-18T15:07:41.000Z","monthly":[48,40,34,42,30,52,44,62,75,90,59,48]},{"name":"Hapi","url":"hapijs.com","full_name":"hapijs/hapi","description":"Server Framework  for Node.js","owner_id":3774533,"tags":["nodejs-framework"],"delta":1710,"stars":10619,"created_at":"2011-08-06T00:35:39.000Z","monthly":[150,130,154,248,103,119,123,140,144,147,99,153]},{"name":"Meteor","url":"https://www.meteor.com","full_name":"meteor/meteor","description":"Meteor, the JavaScript App Platform","owner_id":789528,"tags":["fullstack","meteor","nodejs-framework"],"delta":1708,"stars":40682,"created_at":"2012-01-19T01:58:17.000Z","twitter":"","monthly":[113,86,146,100,118,113,127,175,174,198,194,164]},{"name":"Derby","url":"http://derbyjs.com","full_name":"derbyjs/derby","description":"MVC framework making it easy to write realtime, collaborative applications that run in both Node.js ","owner_id":2942220,"tags":["fullstack","nodejs-framework"],"delta":60,"stars":4369,"created_at":"2011-04-09T04:29:16.000Z","twitter":""},{"name":"Browserify","url":"http://browserify.org/","full_name":"browserify/browserify","description":"browser-side require() the node.js way","owner_id":6320506,"tags":["build","module"],"delta":749,"stars":12420,"created_at":"2010-09-22T16:11:32.000Z","monthly":[54,46,61,55,62,56,78,42,71,82,64,78]},{"name":"Loopback","url":"http://loopback.io","full_name":"strongloop/loopback","description":"LoopBack makes it easy to build modern applications that require complex integrations.","owner_id":3020012,"tags":["api","nodejs-framework"],"delta":1843,"stars":12189,"created_at":"2013-04-09T16:02:18.000Z","twitter":"","monthly":[130,159,170,156,136,140,154,167,172,141,145,173],"icon":"loopback.svg"},{"name":"Istanbul","url":"https://gotwarlost.github.io/istanbul/","full_name":"gotwarlost/istanbul","description":"Yet another JS code coverage tool that computes statement, line, function and branch coverage with m","owner_id":1056819,"tags":["test"],"delta":801,"stars":7696,"created_at":"2012-09-12T06:36:32.000Z","monthly":[44,55,60,76,84,58,69,69,81,77,63,65]},{"name":"ng-admin","url":"http://ng-admin-book.marmelab.com/","full_name":"marmelab/ng-admin","description":"Add an AngularJS admin GUI to any RESTful API","owner_id":3116319,"tags":["angular","dashboard"],"delta":137,"stars":3930,"created_at":"2014-05-22T12:00:10.000Z"},{"name":"Highcharts","url":"https://www.highcharts.com","full_name":"highcharts/highcharts","description":"Highcharts JS, the JavaScript charting framework","owner_id":15981345,"tags":["chart"],"delta":1172,"stars":8320,"created_at":"2010-06-11T12:23:53.000Z","monthly":[83,112,83,109,78,91,84,101,75,112,111,133]},{"name":"ChartistJS","url":"http://gionkunz.github.io/chartist-js/","full_name":"gionkunz/chartist-js","description":"Simple responsive charts","owner_id":2203704,"tags":["chart"],"delta":1011,"stars":11328,"created_at":"2014-03-09T22:40:07.000Z","twitter":"","monthly":[47,74,87,65,88,84,111,87,91,92,81,104],"icon":"chartist.svg"},{"name":"Immutable","url":"http://facebook.github.io/immutable-js/","full_name":"facebook/immutable-js","description":"Immutable persistent data collections for Javascript which increase efficiency and simplicity.","owner_id":69631,"tags":["data-structure"],"delta":4165,"stars":26125,"created_at":"2014-07-02T06:02:29.000Z","twitter":"","monthly":[281,301,305,310,304,379,330,393,380,412,339,431],"icon":"immutable.svg"},{"name":"Flight","url":"http://flightjs.github.io/","full_name":"flightjs/flight","description":"A component-based, event-driven JavaScript framework from Twitter","owner_id":4271779,"tags":["framework"],"delta":17,"stars":6646,"created_at":"2013-01-30T19:59:30.000Z"},{"name":"Bootstrap material","url":"http://fezvrasta.github.io/bootstrap-material-design/","full_name":"FezVrasta/bootstrap-material-design","description":"Material design theme for Bootstrap 3 and 4","owner_id":5382443,"tags":["css-lib","material"],"delta":794,"stars":19712,"created_at":"2014-08-18T11:54:00.000Z","monthly":[48,60,49,54,62,57,86,85,55,71,77,90]},{"name":"Sheperd","url":"https://shipshapecode.github.io/shepherd/docs/welcome","full_name":"shipshapecode/shepherd","description":"Guide your users through a tour of your app","owner_id":17297725,"tags":["presentation"],"delta":561,"stars":5970,"created_at":"2013-12-17T06:30:27.000Z","monthly":[21,35,41,35,39,170,16,38,31,37,43,55]},{"name":"IntroJS","url":"http://introjs.com","full_name":"usablica/intro.js","description":"A better way for new feature introduction and step-by-step users guide for your website and project.","owner_id":2010360,"tags":["presentation"],"delta":1395,"stars":17556,"created_at":"2013-03-10T15:12:45.000Z","monthly":[102,131,113,126,106,133,109,124,120,119,86,126]},{"name":"PACE","url":"http://github.hubspot.com/pace/docs/welcome","full_name":"HubSpot/pace","description":"Automatically add a progress bar to your site. #hubspot-open-source","owner_id":326419,"tags":["progress-bar"],"delta":1134,"stars":14192,"created_at":"2013-09-12T04:24:29.000Z","monthly":[47,64,67,84,72,92,73,98,121,153,101,162]},{"name":"Lightable","url":"www.lighttable.com","full_name":"LightTable/LightTable","description":"The Light Table IDE ⛺","owner_id":5877010,"tags":["ide"],"delta":420,"stars":10399,"created_at":"2012-06-27T22:32:43.000Z","monthly":[37,28,49,47,27,29,22,24,29,38,48,42]},{"name":"Vue.js","url":"http://vuejs.org","full_name":"vuejs/vue","description":"🖖 Vue.js is a progressive, incrementally-adoptable JavaScript framework for building UI on the web.","owner_id":6128107,"tags":["framework","vdom","vue"],"delta":45282,"stars":124137,"created_at":"2013-07-29T03:24:51.000Z","twitter":"vuejs","monthly":[2833,2952,2495,2681,3318,3603,9669,3313,3707,3937,2888,3886],"icon":"vue.svg"},{"name":"Web Starter Kit","url":"http://developers.google.com/web/starter-kit","full_name":"google/web-starter-kit","description":"Web Starter Kit - a workflow for multi-device websites","owner_id":1342004,"tags":["html"],"delta":569,"stars":18478,"created_at":"2014-04-07T08:45:18.000Z","monthly":[20,25,20,27,48,64,29,62,65,77,68,64]},{"name":"HTML5 boilerplate","url":"https://html5boilerplate.com/","full_name":"h5bp/html5-boilerplate","description":"A professional front-end template for building fast, robust, and adaptable web apps or sites.","owner_id":1136800,"tags":["html"],"delta":2488,"stars":41938,"created_at":"2010-01-24T18:03:24.000Z","monthly":[179,135,195,164,192,185,223,285,267,189,235,239]},{"name":"Vex","url":"http://github.hubspot.com/vex/docs/welcome","full_name":"HubSpot/vex","description":"A modern dialog library which is highly configurable and easy to style. #hubspot-open-source","owner_id":326419,"tags":["modal"],"delta":278,"stars":6703,"created_at":"2013-09-05T23:09:57.000Z"},{"name":"Async","url":"http://caolan.github.io/async/","full_name":"caolan/async","description":"Async utilities for node and the browser","owner_id":5274,"tags":["flow"],"delta":2064,"stars":25103,"created_at":"2010-06-01T21:01:30.000Z","monthly":[126,147,130,134,150,182,152,195,208,212,184,244],"icon":"https://caolan.github.io/async/img/async-logo.svg"},{"name":"Skrollr","url":"http://prinzhorn.github.io/skrollr/","full_name":"Prinzhorn/skrollr","description":"Stand-alone parallax scrolling library for mobile (Android + iOS) and desktop. No jQuery. Just plain","owner_id":679144,"tags":["scrolling"],"delta":475,"stars":18168,"created_at":"2012-03-18T15:41:35.000Z","monthly":[31,20,21,37,21,41,31,40,60,71,36,66]},{"name":"Animate.css","url":"http://daneden.github.io/animate.css","full_name":"daneden/animate.css","description":"🍿 A cross-browser library of CSS animations. As easy to use as an easy thing.","owner_id":439365,"tags":["animation"],"delta":8522,"stars":56598,"created_at":"2011-10-12T10:07:38.000Z","monthly":[655,663,675,584,767,694,620,782,755,793,708,826]},{"name":"NativeScript","url":"https://www.nativescript.org","full_name":"NativeScript/NativeScript","description":"NativeScript is an open source framework for building truly native mobile apps with JavaScript. Use ","owner_id":7392261,"tags":["mobile"],"delta":3766,"stars":15856,"created_at":"2015-03-01T09:47:08.000Z","twitter":"NativeScript","monthly":[249,304,352,302,308,288,299,320,386,363,333,262]},{"name":"Validator","url":"","full_name":"chriso/validator.js","description":"String validation","owner_id":364903,"tags":["string","validation"],"delta":2882,"stars":12243,"created_at":"2010-10-06T06:58:48.000Z","monthly":[216,210,247,234,252,265,232,263,281,249,219,214]},{"name":"React hot loader","url":"http://gaearon.github.io/react-hot-loader/","full_name":"gaearon/react-hot-loader","description":"Tweak React components in real time.","owner_id":810438,"tags":["react"],"delta":1961,"stars":9947,"created_at":"2014-07-12T23:49:43.000Z","monthly":[156,123,134,136,143,126,153,143,215,252,214,166]},{"name":"Marionette","url":"http://marionettejs.com","full_name":"marionettejs/backbone.marionette","description":"The Backbone Framework","owner_id":2273169,"tags":["framework"],"delta":-17,"stars":7153,"created_at":"2011-12-12T16:36:09.000Z"},{"name":"Mithril","url":"http://mithril.js.org","full_name":"MithrilJS/mithril.js","description":"A Javascript Framework for Building Brilliant Applications","owner_id":19475707,"tags":["framework","vdom"],"delta":2102,"stars":10407,"created_at":"2014-03-17T01:59:39.000Z","twitter":"","monthly":[170,212,430,210,494,170,59,72,71,66,54,94],"icon":"mithril.svg"},{"name":"TotalJS","url":"http://www.totaljs.com","full_name":"totaljs/framework","description":"Node.js framework","owner_id":6499216,"tags":["nodejs-framework"],"delta":323,"stars":3879,"created_at":"2012-12-16T13:12:02.000Z"},{"name":"Knockout","url":"http://knockoutjs.com/","full_name":"knockout/knockout","description":"Knockout makes it easier to create rich, responsive UIs with JavaScript","owner_id":3863375,"tags":["framework","reactive"],"delta":608,"stars":9265,"created_at":"2010-07-05T08:08:34.000Z","twitter":"","monthly":[26,47,35,49,61,74,62,50,31,45,49,79]},{"name":"Ratchet","url":"http://goratchet.com","full_name":"twbs/ratchet","description":"Build mobile apps with simple HTML, CSS, and JavaScript components. ","owner_id":2918581,"tags":["css-lib","mobile"],"delta":118,"stars":14367,"created_at":"2012-08-17T05:41:57.000Z","monthly":[7,5,6,14,3,16,2,5,5,12,9,34]},{"name":"Snap.svg","url":"http://snapsvg.io","full_name":"adobe-webplatform/Snap.svg","description":"The JavaScript library for modern SVG graphics.","owner_id":2976699,"tags":["drawing","svg"],"delta":1029,"stars":11825,"created_at":"2013-08-15T20:51:34.000Z","monthly":[62,96,54,71,61,97,77,90,101,107,91,122]},{"name":"Three.js","url":"https://threejs.org/","full_name":"mrdoob/three.js","description":"JavaScript 3D library.","owner_id":97088,"tags":["3d"],"delta":9574,"stars":47811,"created_at":"2010-03-23T18:58:01.000Z","monthly":[983,728,742,701,807,795,689,784,843,930,673,899]},{"name":"Hammer.js","url":"http://hammerjs.github.io","full_name":"hammerjs/hammer.js","description":"A javascript library for multi-touch gestures :// You can touch this","owner_id":7997161,"tags":["touch"],"delta":2013,"stars":19517,"created_at":"2012-03-02T12:58:28.000Z","monthly":[148,163,144,146,158,181,128,181,203,220,157,184]},{"name":"Slick","url":"kenwheeler.github.io/slick","full_name":"kenwheeler/slick","description":"the last carousel you'll ever need","owner_id":286616,"tags":["nav"],"delta":2697,"stars":23089,"created_at":"2014-03-24T02:10:05.000Z","monthly":[173,164,176,185,202,209,239,274,309,285,222,259]},{"name":"Hexo","url":"https://hexo.io","full_name":"hexojs/hexo","description":"A fast, simple & powerful blog framework, powered by Node.js.","owner_id":6375567,"tags":["ssg","blog"],"delta":4838,"stars":24814,"created_at":"2012-09-23T15:17:08.000Z","twitter":"hexojs","monthly":[366,327,314,338,383,364,340,435,494,514,377,586]},{"name":"Faye","url":"http://faye.jcoglan.com","full_name":"faye/faye","description":"Simple pub/sub messaging for the web","owner_id":1277447,"tags":["realtime","websocket"],"delta":167,"stars":4163,"created_at":"2009-06-06T10:37:03.000Z"},{"name":"Primus","url":"","full_name":"primus/primus","description":":zap: Primus, the creator god of the transformers & an abstraction layer for real-time to prevent mo","owner_id":5393950,"tags":["realtime","websocket"],"delta":385,"stars":3799,"created_at":"2013-06-25T08:17:42.000Z"},{"name":"socket.io","url":"http://socket.io","full_name":"socketio/socket.io","description":"Realtime application framework (Node.JS server)","owner_id":10566080,"tags":["realtime","websocket"],"delta":6561,"stars":44810,"created_at":"2010-03-11T18:24:48.000Z","monthly":[317,346,380,326,388,576,590,716,789,772,591,770]},{"name":"Ractive","url":"http://ractive.js.org","full_name":"ractivejs/ractive","description":"Next-generation DOM manipulation","owner_id":4751469,"tags":["framework","reactive"],"delta":201,"stars":5614,"created_at":"2012-07-31T13:08:09.000Z","twitter":""},{"name":"deepstream.io","url":"http://deepstream.io/","full_name":"deepstreamIO/deepstream.io","description":"deepstream.io server","owner_id":9024218,"tags":["realtime"],"delta":280,"stars":6059,"created_at":"2014-11-09T08:30:01.000Z"},{"name":"Stylus","url":"http://stylus-lang.com/","full_name":"stylus/stylus","description":"Expressive, robust, feature-rich CSS language built for nodejs","owner_id":10009463,"tags":["css-tool"],"delta":923,"stars":9671,"created_at":"2010-12-28T22:11:43.000Z","monthly":[74,58,59,55,91,103,64,75,84,85,74,101]},{"name":"vibrant.js","url":"http://jariz.github.io/vibrant.js/","full_name":"jariz/vibrant.js","description":"Extract prominent colors from an image. JS port of Android's Palette.","owner_id":1415847,"tags":["image","color"],"delta":144,"stars":4360,"created_at":"2015-05-24T18:44:22.000Z"},{"name":"engine.io","url":"http://socket.io","full_name":"socketio/engine.io","description":"Engine.IO is the implementation of transport-based cross-browser/cross-device bi-directional communi","owner_id":10566080,"tags":["realtime"],"delta":341,"stars":3635,"created_at":"2011-11-18T18:03:54.000Z"},{"name":"autoprefixer","url":"https://twitter.com/autoprefixer","full_name":"postcss/autoprefixer","description":" Parse CSS and add vendor prefixes to rules by Can I Use","owner_id":8296347,"tags":["css-tool"],"delta":2110,"stars":16452,"created_at":"2013-03-14T05:04:51.000Z","monthly":[131,147,139,163,177,170,133,183,197,245,210,215]},{"name":"PurifyCSS","url":"","full_name":"purifycss/purifycss","description":"Remove unused CSS. Also works with single-page apps.","owner_id":12516362,"tags":["css-tool"],"delta":890,"stars":8880,"created_at":"2015-05-26T02:42:17.000Z","monthly":[49,39,43,33,101,71,36,62,74,135,76,171]},{"name":"Elemental UI","url":"elemental-ui.com","full_name":"elementalui/elemental","description":"A flexible and beautiful UI framework for React.js","owner_id":11880721,"tags":["react","component"],"delta":296,"stars":4183,"created_at":"2015-04-10T03:02:59.000Z"},{"name":"Flexbox","url":"http://flexboxgrid.com","full_name":"kristoferjoseph/flexboxgrid","description":"Grid based on CSS3 flexbox","owner_id":76308,"tags":["css-lib"],"delta":982,"stars":7858,"created_at":"2013-12-21T23:48:16.000Z","monthly":[61,66,86,67,68,86,103,67,102,94,90,92]},{"name":"Awesome","url":"","full_name":"sindresorhus/awesome","description":":sunglasses: Curated list of awesome lists","owner_id":170270,"tags":["meta"],"delta":24300,"stars":99272,"created_at":"2014-07-11T13:42:37.000Z","twitter":"","monthly":[1621,1914,2037,1667,1818,1670,2167,1988,2118,2786,1854,2660],"icon":"awesome.svg"},{"name":"Material Design icons","url":"http://google.github.io/material-design-icons/","full_name":"google/material-design-icons","description":"Material Design icons by Google","owner_id":1342004,"tags":["icon","material"],"delta":3869,"stars":36851,"created_at":"2014-10-08T18:01:28.000Z","monthly":[220,205,248,289,323,281,315,457,407,446,300,378]},{"name":"Redux","url":"http://redux.js.org","full_name":"reduxjs/redux","description":"Predictable state container for JavaScript apps","owner_id":13142323,"tags":["flux","redux","state"],"delta":9088,"stars":46117,"created_at":"2015-05-29T23:53:15.000Z","monthly":[563,532,615,651,660,785,722,895,1066,955,767,877],"icon":"redux.svg"},{"name":"Amaze UI","url":"http://amazeui.org/","full_name":"amazeui/amazeui","description":"Amaze UI, a mobile-first and modular front-end framework.","owner_id":8945728,"tags":["mobile"],"delta":1477,"stars":12602,"created_at":"2014-08-04T14:23:37.000Z","monthly":[87,87,107,89,139,84,136,155,180,155,86,172]},{"name":"Airbnb Style Guide","url":"","full_name":"airbnb/javascript","description":"JavaScript Style Guide","owner_id":698437,"tags":["learning"],"delta":16400,"stars":80277,"created_at":"2012-11-01T23:13:50.000Z","twitter":"","monthly":[955,1169,1379,1135,1278,1408,1198,1344,1546,1614,1480,1894]},{"name":"Suit CSS","url":"http://suitcss.github.io/","full_name":"suitcss/suit","description":"Style tools for UI components","owner_id":4564613,"tags":["css-tool"],"delta":186,"stars":3515,"created_at":"2011-10-19T21:38:00.000Z"},{"name":"UIkit","url":"http://getuikit.com","full_name":"uikit/uikit","description":"A lightweight and modular front-end framework for developing fast and powerful web interfaces","owner_id":4173184,"tags":["css-lib"],"delta":2327,"stars":13705,"created_at":"2013-07-18T16:00:26.000Z","monthly":[158,149,165,163,175,170,174,218,226,267,218,244]},{"name":"Bootswatch","url":"https://bootswatch.com","full_name":"thomaspark/bootswatch","description":"Themes for Bootstrap","owner_id":900407,"tags":["css-lib"],"delta":1153,"stars":10919,"created_at":"2012-02-07T04:31:56.000Z","monthly":[125,88,66,71,83,85,85,88,107,132,119,104]},{"name":"Dynamic.JS","url":"http://dynamicsjs.com","full_name":"michaelvillar/dynamics.js","description":"Javascript library to create physics-based animations","owner_id":173322,"tags":["animation"],"delta":326,"stars":7034,"created_at":"2014-02-03T00:17:07.000Z"},{"name":"React bootstrap","url":"https://react-bootstrap.netlify.com","full_name":"react-bootstrap/react-bootstrap","description":"Bootstrap components built with React","owner_id":6853419,"tags":["react","component"],"delta":2585,"stars":14452,"created_at":"2013-12-27T19:06:07.000Z","monthly":[197,175,232,160,179,180,193,233,227,279,235,295]},{"name":"selectize.js","url":"http://selectize.github.io/selectize.js/","full_name":"selectize/selectize.js","description":"Selectize is the hybrid of a textbox and <select> box. It's jQuery based and it has autocomplete and","owner_id":14022691,"tags":["plugin","autocomplete"],"delta":1000,"stars":11571,"created_at":"2012-08-29T18:31:57.000Z","monthly":[75,66,104,78,66,88,58,98,91,78,101,97]},{"name":"Pixi.js","url":"http://pixijs.com","full_name":"pixijs/pixi.js","description":"The HTML5 Creation Engine: Create beautiful digital content with the fastest, most flexible 2D WebGL","owner_id":5406849,"tags":["game"],"delta":4227,"stars":21339,"created_at":"2013-01-21T22:40:50.000Z","monthly":[317,335,327,314,350,316,358,329,480,341,304,456]},{"name":"JSHint","url":"http://jshint.com","full_name":"jshint/jshint","description":"JSHint is a tool that helps to detect errors and potential problems in your JavaScript code","owner_id":1335450,"tags":["lint"],"delta":426,"stars":8077,"created_at":"2011-01-19T22:28:53.000Z"},{"name":"You Don't Know JS","url":"http://www.kickstarter.com/projects/getify/you-dont-know-js-book-series","full_name":"getify/You-Dont-Know-JS","description":"A book series on JavaScript. @YDKJS on twitter.","owner_id":150330,"tags":["learning","book"],"delta":21031,"stars":94170,"created_at":"2013-11-16T02:37:24.000Z","monthly":[1450,1570,1601,1671,1837,1478,1538,1717,2390,1965,1733,2081],"icon":"js.svg"},{"name":"ESLint","url":"https://eslint.org","full_name":"eslint/eslint","description":"A fully pluggable tool for identifying and reporting on patterns in JavaScript","owner_id":6019716,"tags":["lint"],"delta":3172,"stars":13076,"created_at":"2013-06-29T23:59:48.000Z","monthly":[175,223,230,178,226,262,261,239,266,271,363,478]},{"name":"Babylon.js","url":"http://www.babylonjs.com","full_name":"BabylonJS/Babylon.js","description":"Babylon.js: a complete JavaScript framework for building 3D games with HTML 5 and WebGL","owner_id":4855800,"tags":["game","3d","webgl"],"delta":2140,"stars":8117,"created_at":"2013-06-27T20:40:42.000Z","monthly":[190,225,163,153,173,142,190,329,158,135,134,148]},{"name":"Spectacle","url":"http://formidable.com/open-source/spectacle/","full_name":"FormidableLabs/spectacle","description":"ReactJS based Presentation Library","owner_id":5078602,"tags":["presentation"],"delta":1441,"stars":7242,"created_at":"2015-06-30T20:36:07.000Z","monthly":[71,98,75,83,131,92,113,178,145,175,133,147]},{"name":"PhysicsJS","url":"http://wellcaffeinated.net/PhysicsJS/","full_name":"wellcaffeinated/PhysicsJS","description":"A modular, extendable, and easy-to-use physics engine for javascript","owner_id":1128935,"tags":["game"],"delta":114,"stars":3222,"created_at":"2013-03-26T05:12:54.000Z"},{"name":"PlayCanvas","url":"https://playcanvas.com/","full_name":"playcanvas/engine","description":"Fast and lightweight WebGL game engine","owner_id":1030579,"tags":["game"],"delta":944,"stars":4065,"created_at":"2014-05-12T11:24:30.000Z","monthly":[66,76,58,62,60,69,86,114,101,102,62,88]},{"name":"jQueryUI","url":"https://jqueryui.com/","full_name":"jquery/jquery-ui","description":"The official jQuery user interface library.","owner_id":70142,"tags":["plugin","modal","tree"],"delta":327,"stars":10595,"created_at":"2010-01-19T14:40:34.000Z","monthly":[26,13,23,8,31,19,21,41,29,30,38,48]},{"name":"Ramda","url":"https://ramdajs.com","full_name":"ramda/ramda","description":":ram: Practical functional Javascript","owner_id":5298359,"tags":["fp","util"],"delta":4470,"stars":15029,"created_at":"2013-06-21T20:32:35.000Z","twitter":"","monthly":[328,335,338,314,354,466,608,333,363,383,329,319]},{"name":"Standard","url":"https://standardjs.com","full_name":"standard/standard","description":"🌟 JavaScript Style Guide, with linter & automatic code fixer","owner_id":29208316,"tags":["lint"],"delta":4576,"stars":20079,"created_at":"2015-01-27T01:23:31.000Z","monthly":[254,237,281,279,280,350,347,399,327,430,625,767],"icon":"https://standardjs.com/favicons/apple-touch-icon-180x180.png"},{"name":"request","url":"","full_name":"request/request","description":"🏊🏾 Simplified HTTP request client.","owner_id":730467,"tags":["http"],"delta":3441,"stars":21536,"created_at":"2011-01-23T01:25:14.000Z","monthly":[259,246,249,236,255,283,284,332,314,348,305,330]},{"name":"Highland","url":"http://highlandjs.org","full_name":"caolan/highland","description":"High-level streams library for Node.js and the browser","owner_id":5274,"tags":["flow","stream"],"delta":184,"stars":3078,"created_at":"2012-08-25T05:18:11.000Z"},{"name":"Axios","url":"","full_name":"axios/axios","description":"Promise based HTTP client for the browser and node.js","owner_id":32372333,"tags":["http"],"delta":19939,"stars":53288,"created_at":"2014-08-18T22:30:27.000Z","monthly":[1274,1416,1377,1545,1660,1700,1641,1756,1766,2024,1646,2134]},{"name":"SuperAgent","url":"http://visionmedia.github.com/superagent/","full_name":"visionmedia/superagent","description":"Ajax with less suck - (and node.js HTTP client to match)","owner_id":9285252,"tags":["http"],"delta":1730,"stars":13723,"created_at":"2011-04-13T02:29:45.000Z","twitter":"","monthly":[106,112,117,120,150,125,142,149,182,163,159,205]},{"name":"Bluebird","url":"http://bluebirdjs.com","full_name":"petkaantonov/bluebird","description":":bird: :zap: Bluebird is a full featured promise library with unmatched performance.","owner_id":829734,"tags":["flow"],"delta":1731,"stars":17764,"created_at":"2013-09-07T19:39:57.000Z","monthly":[124,142,112,96,114,143,125,178,153,185,153,206]},{"name":"q","url":"http://documentup.com/kriskowal/q/","full_name":"kriskowal/q","description":"A promise library for JavaScript","owner_id":60294,"tags":["flow"],"delta":606,"stars":14513,"created_at":"2010-09-04T01:21:12.000Z","monthly":[43,50,30,24,58,60,33,38,63,88,36,83]},{"name":"Assemble","url":"http://assemble.io/","full_name":"assemble/assemble","description":"Get the rocks out of your socks! Assemble makes you fast at web development! Used by thousands of pr","owner_id":2645080,"tags":["ssg"],"delta":163,"stars":3639,"created_at":"2012-09-22T20:50:23.000Z"},{"name":"Material Design Lite","url":"https://getmdl.io","full_name":"google/material-design-lite","description":"Material Design Components in HTML/CSS/JS","owner_id":1342004,"tags":["css-lib","material"],"delta":1651,"stars":30933,"created_at":"2015-01-14T22:01:33.000Z","monthly":[106,77,85,116,91,162,128,192,183,187,122,202]},{"name":"Layzr.js","url":"http://callmecavs.com/layzr.js/","full_name":"callmecavs/layzr.js","description":"A modern lazy loading library for images.","owner_id":2293641,"tags":["load"],"delta":178,"stars":5556,"created_at":"2015-04-08T03:03:08.000Z"},{"name":"React Motion","url":"","full_name":"chenglou/react-motion","description":"A spring that solves your animation problems.","owner_id":1909539,"tags":["react","animation"],"delta":4407,"stars":15813,"created_at":"2015-06-11T07:38:23.000Z","monthly":[204,245,263,253,537,655,309,326,356,423,376,460]},{"name":"Headjs","url":"http://headjs.com","full_name":"headjs/headjs","description":"The only script in your HEAD.","owner_id":501658,"tags":["load"],"delta":42,"stars":4204,"created_at":"2010-11-29T11:15:57.000Z"},{"name":"Dropzone","url":"http://www.dropzonejs.com","full_name":"enyo/dropzone","description":"Dropzone is an easy to use drag'n'drop library. It supports image previews and shows nice progress b","owner_id":133277,"tags":["dnd"],"delta":874,"stars":14148,"created_at":"2012-02-12T16:19:18.000Z","monthly":[45,34,47,49,52,67,80,92,91,92,97,128]},{"name":"Masonry","url":"https://masonry.desandro.com","full_name":"desandro/masonry","description":":love_hotel: Cascading grid layout plugin","owner_id":85566,"tags":["layout"],"delta":1086,"stars":13742,"created_at":"2009-11-21T21:04:56.000Z","monthly":[87,83,62,79,85,92,90,84,98,101,106,119]},{"name":"Pug","url":"https://pugjs.org","full_name":"pugjs/pug","description":"Pug – robust, elegant, feature rich template engine for Node.js","owner_id":9338635,"tags":["template"],"delta":1875,"stars":17723,"created_at":"2010-06-23T01:05:42.000Z","monthly":[135,133,120,145,154,157,129,225,145,200,141,191]},{"name":"PostCSS","url":"https://postcss.org/","full_name":"postcss/postcss","description":"Transforming styles with JS plugins","owner_id":8296347,"tags":["css-tool"],"delta":2902,"stars":19996,"created_at":"2013-09-24T23:06:48.000Z","monthly":[185,186,170,180,206,229,224,242,327,343,257,353]},{"name":"Pikaday","url":"http://dbushell.github.io/Pikaday/","full_name":"Pikaday/Pikaday","description":"A refreshing JavaScript Datepicker — lightweight, no dependencies, modular CSS","owner_id":44224148,"tags":["plugin","date"],"delta":682,"stars":6484,"created_at":"2012-10-08T07:51:03.000Z","monthly":[111,48,37,34,34,44,38,57,89,65,54,71]},{"name":"NodeBB","url":"https://nodebb.org","full_name":"NodeBB/NodeBB","description":"Node.js based forum software built for the modern web","owner_id":4449608,"tags":["blog"],"delta":1421,"stars":9554,"created_at":"2013-04-22T16:49:40.000Z","monthly":[149,89,102,74,107,149,85,120,120,146,103,177]},{"name":"Ghost","url":"https://ghost.org","full_name":"TryGhost/Ghost","description":"The platform for professional publishers","owner_id":2178663,"tags":["blog"],"delta":3680,"stars":28388,"created_at":"2013-05-04T11:09:13.000Z","monthly":[273,270,299,235,811,439,172,395,178,225,179,204]},{"name":"React-select","url":"https://react-select.com/","full_name":"JedWatson/react-select","description":"The Select Component for React.js","owner_id":872310,"tags":["autocomplete","react"],"delta":5072,"stars":15055,"created_at":"2014-08-26T04:27:45.000Z","monthly":[321,426,420,374,464,765,407,382,391,438,333,351]},{"name":"Tape","url":"","full_name":"substack/tape","description":"tap-producing test harness for node and browsers","owner_id":12631,"tags":["test-framework","test"],"delta":533,"stars":4862,"created_at":"2012-11-25T17:08:02.000Z","monthly":[28,38,31,30,40,36,36,36,64,58,52,84]},{"name":"two.js","url":"https://two.js.org","full_name":"jonobr1/two.js","description":"A renderer agnostic two-dimensional drawing api for the web.","owner_id":220033,"tags":["drawing"],"delta":640,"stars":5946,"created_at":"2012-09-05T23:19:40.000Z","monthly":[48,65,44,51,65,55,43,56,66,53,50,44]},{"name":"Guide to FP","url":"","full_name":"MostlyAdequate/mostly-adequate-guide","description":"Mostly adequate guide to FP (in javascript)","owner_id":14079115,"tags":["fp","learning","book"],"delta":2395,"stars":15201,"created_at":"2015-05-06T01:44:15.000Z","monthly":[152,214,203,171,147,175,246,278,238,206,188,177]},{"name":"Angular seed","url":"http://angularjs.org/","full_name":"angular/angular-seed","description":"Seed project for angular apps. ","owner_id":139426,"tags":["angular"],"delta":130,"stars":13319,"created_at":"2010-12-24T06:07:50.000Z","monthly":[9,13,10,10,2,7,-1,8,18,27,5,22]},{"name":"Dragula","url":"https://bevacqua.github.io/dragula/","full_name":"bevacqua/dragula","description":":ok_hand: Drag and drop so simple it hurts","owner_id":934293,"tags":["dnd"],"delta":1443,"stars":18503,"created_at":"2015-04-13T21:35:38.000Z","monthly":[98,113,105,86,127,113,126,125,114,138,115,183]},{"name":"React DnD","url":"http://react-dnd.github.io/react-dnd","full_name":"react-dnd/react-dnd","description":"Drag and Drop for React","owner_id":25307599,"tags":["dnd","react"],"delta":2731,"stars":10161,"created_at":"2014-10-19T13:29:28.000Z","monthly":[203,214,232,245,227,241,204,260,253,244,190,218]},{"name":"Myth","url":"myth.io","full_name":"segmentio/myth","description":"A CSS preprocessor that acts like a polyfill for future versions of the spec.","owner_id":819518,"tags":["css-tool"],"delta":34,"stars":4425,"created_at":"2013-12-16T09:22:19.000Z"},{"name":"Paper.js","url":"http://paperjs.org","full_name":"paperjs/paper.js","description":"The Swiss Army Knife of Vector Graphics Scripting – Scriptographer ported to JavaScript and the brow","owner_id":846856,"tags":["drawing"],"delta":1428,"stars":10097,"created_at":"2011-02-07T18:21:30.000Z","monthly":[118,102,104,102,86,86,195,117,96,123,169,130]},{"name":"RSVP","url":"","full_name":"tildeio/rsvp.js","description":"A lightweight library that provides tools for organizing asynchronous code","owner_id":1355851,"tags":["flow"],"delta":131,"stars":3533,"created_at":"2012-10-16T18:15:00.000Z"},{"name":"Devdocs.io","url":"https://devdocs.io","full_name":"freeCodeCamp/devdocs","description":"API Documentation Browser","owner_id":9892522,"tags":["learning"],"delta":3022,"stars":19583,"created_at":"2013-10-24T18:16:07.000Z","monthly":[213,223,252,197,189,217,172,220,327,456,224,332]},{"name":"Video.js","url":"www.videojs.com","full_name":"videojs/video.js","description":"Video.js - open source HTML5 & Flash video player","owner_id":3287189,"tags":["video"],"delta":4903,"stars":23663,"created_at":"2010-05-14T18:45:10.000Z","monthly":[339,328,295,286,316,264,389,365,309,1387,274,351]},{"name":"Fuel UX","url":"http://getFuelUX.com","full_name":"ExactTarget/fuelux","description":"Extends Twitter Bootstrap with additional lightweight JavaScript controls. Easy to install, customiz","owner_id":1648421,"tags":["css-lib"],"delta":21,"stars":5409,"created_at":"2012-07-06T12:12:47.000Z"},{"name":"Media Element","url":"http://mediaelementjs.com/","full_name":"mediaelement/mediaelement","description":"HTML5 <audio> or <video> player with support for MP4, WebM, and MP3 as well as HLS, Dash, YouTube, F","owner_id":1226323,"tags":["video"],"delta":804,"stars":6527,"created_at":"2010-07-28T02:32:56.000Z","monthly":[53,57,60,53,75,62,41,80,57,115,65,86]},{"name":"howler.js","url":"https://howlerjs.com","full_name":"goldfire/howler.js","description":"Javascript audio library for the modern web.","owner_id":882005,"tags":["audio"],"delta":3959,"stars":13116,"created_at":"2013-01-28T16:47:12.000Z","monthly":[184,1878,169,199,251,155,157,187,193,186,172,228]},{"name":"FabricJS","url":"http://fabricjs.com","full_name":"fabricjs/fabric.js","description":"Javascript Canvas Library, SVG-to-Canvas (& canvas-to-SVG) Parser","owner_id":24580162,"tags":["drawing","svg","canvas"],"delta":2314,"stars":11681,"created_at":"2010-06-09T22:24:38.000Z","monthly":[229,204,169,212,203,185,186,242,188,188,140,168]},{"name":"MUI","url":"https://www.muicss.com","full_name":"muicss/mui","description":"Lightweight CSS framework","owner_id":7343632,"tags":["css-lib","material"],"delta":376,"stars":4125,"created_at":"2015-02-15T17:30:26.000Z"},{"name":"Less","url":"http://lesscss.org","full_name":"less/less.js","description":"Less. The dynamic stylesheet language.","owner_id":3538330,"tags":["css-tool"],"delta":551,"stars":15872,"created_at":"2010-02-20T17:25:38.000Z","monthly":[25,22,70,46,52,49,48,50,47,57,48,37]},{"name":"Knwl.js","url":"http://loadfive.com/os/knwl","full_name":"benhmoore/Knwl.js","description":"Find Dates, Places, Times, and More. A .js library for parsing text for specific information.","owner_id":5818776,"tags":["parsing"],"delta":47,"stars":5306,"created_at":"2013-12-01T01:53:53.000Z"},{"name":"Wintersmith","url":"http://wintersmith.io/","full_name":"jnordberg/wintersmith","description":"A flexible static site generator","owner_id":95886,"tags":["ssg"],"delta":120,"stars":3409,"created_at":"2012-02-02T18:54:12.000Z"},{"name":"Nunjucks","url":"https://mozilla.github.io/nunjucks/","full_name":"mozilla/nunjucks","description":"A powerful templating engine with inheritance, asynchronous control, and more (jinja2 inspired)","owner_id":131524,"tags":["template"],"delta":905,"stars":5750,"created_at":"2012-08-09T05:40:44.000Z","twitter":"","monthly":[65,78,58,54,74,69,59,59,74,132,83,100]},{"name":"Peity","url":"http://benpickles.github.io/peity","full_name":"benpickles/peity","description":"Progressive <svg> pie, donut, bar and line charts","owner_id":3637,"tags":["chart"],"delta":157,"stars":4099,"created_at":"2009-11-20T13:49:20.000Z"},{"name":"cytoscape.js","url":"http://js.cytoscape.org","full_name":"cytoscape/cytoscape.js","description":"Graph theory (network) library for visualisation and analysis","owner_id":956141,"tags":["chart"],"delta":1525,"stars":5329,"created_at":"2011-08-23T15:28:32.000Z","monthly":[130,355,98,92,120,102,88,105,156,90,92,97]},{"name":"Intern","url":"https://theintern.io/","full_name":"theintern/intern","description":"A next-generation code testing stack for JavaScript.","owner_id":3977877,"tags":["test-framework","test"],"delta":184,"stars":4082,"created_at":"2013-03-26T18:45:29.000Z"},{"name":"Vantage","url":"","full_name":"dthree/vantage","description":"Distributed, realtime CLI for live Node apps.","owner_id":10319897,"tags":["cli"],"delta":76,"stars":3450,"created_at":"2015-05-30T01:34:31.000Z"},{"name":"Epoch","url":"http://epochjs.github.io/epoch","full_name":"epochjs/epoch","description":"A general purpose, real-time visualization library.","owner_id":14932104,"tags":["chart","d3"],"delta":49,"stars":4949,"created_at":"2013-06-27T23:04:32.000Z"},{"name":"Morris.js","url":"http://morrisjs.github.com/morris.js/","full_name":"morrisjs/morris.js","description":"Pretty time-series line graphs","owner_id":6538127,"tags":["chart"],"delta":187,"stars":6887,"created_at":"2012-02-21T22:51:27.000Z"},{"name":"Flot","url":"http://www.flotcharts.org/","full_name":"flot/flot","description":"Attractive JavaScript charts for jQuery","owner_id":584619,"tags":["chart"],"delta":129,"stars":5631,"created_at":"2011-01-26T15:48:51.000Z"},{"name":"Chai","url":"http://chaijs.com","full_name":"chaijs/chai","description":"BDD / TDD assertion framework for node.js and the browser that can be paired with any testing framew","owner_id":1515293,"tags":["test"],"delta":1046,"stars":5968,"created_at":"2011-12-07T08:06:35.000Z","monthly":[63,85,64,66,89,102,76,83,97,126,94,101]},{"name":"Blessed","url":"","full_name":"yaronn/blessed-contrib","description":"Build terminal dashboards using ascii/ansi art and javascript","owner_id":1359037,"tags":["cli","dashboard"],"delta":1467,"stars":12184,"created_at":"2015-01-14T14:18:07.000Z","monthly":[95,152,71,84,79,103,84,374,121,90,110,104]},{"name":"Velocity","url":"VelocityJS.org","full_name":"julianshapiro/velocity","description":"Accelerated JavaScript animation.","owner_id":655026,"tags":["animation"],"delta":1558,"stars":15592,"created_at":"2014-04-09T20:02:38.000Z","monthly":[138,142,90,126,140,169,142,127,120,131,117,116]},{"name":"Johnny-Five","url":"http://johnny-five.io","full_name":"rwaldron/johnny-five","description":"JavaScript Robotics and IoT programming framework, developed at Bocoup.","owner_id":27985,"tags":["iot"],"delta":1555,"stars":10053,"created_at":"2012-03-30T20:09:52.000Z","monthly":[92,93,103,162,297,94,127,114,143,100,102,128]},{"name":"AngularUI Grid","url":"http://ui-grid.info","full_name":"angular-ui/ui-grid","description":"UI Grid: an Angular Data Grid","owner_id":1530011,"tags":["angular"],"delta":210,"stars":5240,"created_at":"2012-10-13T01:39:25.000Z"},{"name":"Seneca","url":"http://senecajs.org","full_name":"senecajs/seneca","description":"A microservices toolkit for Node.js.","owner_id":10085488,"tags":["microservice"],"delta":545,"stars":3261,"created_at":"2010-10-21T17:09:05.000Z","monthly":[40,47,42,48,49,36,47,55,46,41,46,48]},{"name":"Serverless","url":"https://serverless.com","full_name":"serverless/serverless","description":"Serverless Framework – Build web, mobile and IoT applications with serverless architectures using AW","owner_id":13742415,"tags":["microservice","serverless"],"delta":6282,"stars":27343,"created_at":"2015-04-21T03:48:40.000Z","twitter":"","monthly":[504,556,473,376,456,543,523,660,508,543,542,598]},{"name":"Cycle.js","url":"http://cycle.js.org","full_name":"cyclejs/cyclejs","description":"A functional and reactive JavaScript framework for predictable code","owner_id":12686838,"tags":["fp","vdom","framework"],"delta":1137,"stars":9008,"created_at":"2014-11-07T11:28:45.000Z","monthly":[66,141,60,72,86,96,49,96,80,128,121,142]},{"name":"System.js","url":"","full_name":"systemjs/systemjs","description":"Dynamic ES module loader","owner_id":6577368,"tags":["module"],"delta":614,"stars":9404,"created_at":"2013-05-14T20:45:48.000Z","monthly":[34,54,67,35,46,41,57,45,69,60,58,48]},{"name":"Relay","url":"https://facebook.github.io/relay/","full_name":"facebook/relay","description":"Relay is a JavaScript framework for building data-driven React applications.","owner_id":69631,"tags":["framework","graphql"],"delta":1696,"stars":11882,"created_at":"2015-08-10T22:09:16.000Z","twitter":"","monthly":[117,129,120,74,131,139,131,135,128,166,159,267],"icon":"relay.svg"},{"name":"react-color","url":"http://casesandberg.github.io/react-color/","full_name":"casesandberg/react-color","description":":art: Color Pickers from Sketch, Photoshop, Chrome, Github, Twitter & more","owner_id":4633636,"tags":["react"],"delta":1656,"stars":6243,"created_at":"2015-08-09T18:45:30.000Z","monthly":[130,105,131,163,289,116,117,123,140,115,116,111]},{"name":"Falcor","url":"http://netflix.github.io/falcor","full_name":"Netflix/falcor","description":"A JavaScript library for efficient data fetching","owner_id":913567,"tags":["data"],"delta":734,"stars":9120,"created_at":"2015-02-13T00:17:50.000Z","monthly":[31,55,39,29,40,66,61,73,70,82,83,105]},{"name":"Echarts","url":"http://echarts.baidu.com/","full_name":"apache/incubator-echarts","description":"A powerful, interactive charting and visualization library for browser","owner_id":47359,"tags":["chart"],"delta":8861,"stars":31975,"created_at":"2013-04-03T03:18:59.000Z","twitter":"","monthly":[513,544,503,571,603,588,613,599,805,999,595,1928]},{"name":"MetricsGraphics.js","url":"http://metricsgraphicsjs.org","full_name":"metricsgraphics/metrics-graphics","description":"A library optimized for concise and principled data graphics and layouts.","owner_id":37669658,"tags":["chart"],"delta":228,"stars":7010,"created_at":"2014-05-01T18:25:52.000Z"},{"name":"Leaflet","url":"https://leafletjs.com","full_name":"Leaflet/Leaflet","description":" :leaves: JavaScript library for mobile-friendly interactive maps","owner_id":2854298,"tags":["map"],"delta":3311,"stars":23675,"created_at":"2010-09-22T16:57:44.000Z","monthly":[256,271,272,258,268,352,236,269,287,287,195,360]},{"name":"chroma.js","url":"https://vis4.net/chromajs/","full_name":"gka/chroma.js","description":"JavaScript library for all kinds of color manipulations","owner_id":617518,"tags":["color"],"delta":1102,"stars":5866,"created_at":"2011-12-12T00:33:02.000Z","monthly":[93,85,74,71,163,87,86,105,70,117,92,59]},{"name":"sigma.js","url":"http://sigmajs.org","full_name":"jacomyal/sigma.js","description":"A JavaScript library dedicated to graph drawing","owner_id":144846,"tags":["chart"],"delta":611,"stars":8319,"created_at":"2012-03-11T15:17:40.000Z","monthly":[46,57,55,43,38,65,42,64,45,49,53,54]},{"name":"json-server","url":"","full_name":"typicode/json-server","description":"Get a full fake REST API with zero coding in less than 30 seconds (seriously)","owner_id":5502029,"tags":["test","filesystem"],"delta":9250,"stars":37265,"created_at":"2013-11-27T13:21:13.000Z","twitter":"","monthly":[590,649,685,588,890,745,734,1242,863,848,619,797]},{"name":"Critical","url":"","full_name":"addyosmani/critical","description":"Extract & Inline Critical-path CSS in HTML pages","owner_id":110953,"tags":["performance"],"delta":1031,"stars":7387,"created_at":"2014-06-28T09:31:42.000Z","monthly":[67,73,99,50,87,86,116,100,71,102,73,107]},{"name":"Cheerio","url":"https://cheerio.js.org/","full_name":"cheeriojs/cheerio","description":"Fast, flexible, and lean implementation of core jQuery designed specifically for the server.","owner_id":7230330,"tags":["parsing","scraping"],"delta":3766,"stars":18302,"created_at":"2011-10-09T04:23:20.000Z","twitter":"","monthly":[243,267,269,291,361,336,307,340,357,392,264,339]},{"name":"nock","url":"","full_name":"nock/nock","description":"HTTP server mocking and expectations library for Node.js","owner_id":17545810,"tags":["test"],"delta":1616,"stars":7412,"created_at":"2011-09-22T10:08:03.000Z","monthly":[156,154,154,104,141,179,131,98,146,171,83,99]},{"name":"Electron","url":"https://electronjs.org","full_name":"electron/electron","description":":electron: Build cross-platform desktop apps with JavaScript, HTML, and CSS","owner_id":13409222,"tags":["desktop"],"delta":13593,"stars":68435,"created_at":"2013-04-12T01:47:36.000Z","twitter":"electronjs","monthly":[1076,1078,982,1054,1078,1059,1188,1207,1088,1248,1124,1411]},{"name":"X-ray","url":"http://lapwinglabs.com/","full_name":"matthewmueller/x-ray","description":"The next web scraper. See through the <html> noise.","owner_id":170299,"tags":["scraping"],"delta":691,"stars":4816,"created_at":"2015-02-05T00:34:16.000Z","twitter":"","monthly":[40,112,123,50,34,49,50,46,53,49,29,56]},{"name":"PM2","url":"http://pm2.io/","full_name":"Unitech/pm2","description":"Node.js Production Process Manager with a built-in Load Balancer.","owner_id":757747,"tags":["process"],"delta":4808,"stars":27626,"created_at":"2013-05-21T03:25:25.000Z","monthly":[318,431,370,381,387,386,350,438,447,444,358,498]},{"name":"Clusterize.js","url":"https://clusterize.js.org","full_name":"NeXTs/Clusterize.js","description":"Tiny vanilla JS plugin to display large data sets easily","owner_id":1753208,"tags":["table"],"delta":552,"stars":6061,"created_at":"2015-04-26T20:12:51.000Z","monthly":[42,43,49,39,46,32,41,45,42,75,52,46]},{"name":"Octicons","url":"https://octicons.github.com/","full_name":"primer/octicons","description":"A scalable set of icons handcrafted with <3 by GitHub","owner_id":7143434,"tags":["icon"],"delta":733,"stars":4957,"created_at":"2014-06-16T17:10:25.000Z","monthly":[37,54,46,47,57,88,67,73,89,61,63,51]},{"name":"ACE","url":"https://ace.c9.io","full_name":"ajaxorg/ace","description":"Ace (Ajax.org Cloud9 Editor)","owner_id":168515,"tags":["highlight"],"delta":2426,"stars":18979,"created_at":"2010-10-27T10:43:36.000Z","monthly":[192,296,194,175,171,211,172,166,223,232,189,205]},{"name":"Random color","url":"http://llllll.li/randomColor/","full_name":"davidmerfield/randomColor","description":"A tiny script for generating attractive colors","owner_id":747928,"tags":["color"],"delta":491,"stars":4840,"created_at":"2014-04-08T20:25:02.000Z"},{"name":"co","url":"","full_name":"tj/co","description":"The ultimate generator based flow-control goodness for nodejs (supports thunks, promises, etc)","owner_id":25254,"tags":["flow"],"delta":1227,"stars":10397,"created_at":"2013-06-06T04:06:16.000Z","monthly":[72,77,79,77,96,97,176,110,112,137,85,109]},{"name":"CodeMirror","url":"http://codemirror.net/","full_name":"codemirror/CodeMirror","description":"In-browser code editor","owner_id":8876537,"tags":["highlight"],"delta":2972,"stars":16571,"created_at":"2011-01-14T13:44:03.000Z","monthly":[256,291,237,256,243,297,200,217,244,232,229,270]},{"name":"TypeScript","url":"http://www.typescriptlang.org","full_name":"Microsoft/TypeScript","description":"TypeScript is a superset of JavaScript that compiles to clean JavaScript output.","owner_id":6154722,"tags":["compiler","types"],"delta":13586,"stars":43248,"created_at":"2014-06-17T15:28:39.000Z","twitter":"typescriptlang","monthly":[1178,997,1349,1063,1134,1169,1537,1031,1015,1058,940,1115],"icon":"typescript.svg"},{"name":"Fullpage.js","url":"http://alvarotrigo.com/fullPage/","full_name":"alvarotrigo/fullPage.js","description":"fullPage plugin by Alvaro Trigo. Create full screen pages fast and simple","owner_id":1706326,"tags":["scrolling"],"delta":3761,"stars":25621,"created_at":"2013-09-20T11:58:29.000Z","monthly":[225,242,410,215,259,272,271,377,373,414,359,344]},{"name":"Babel","url":"https://babeljs.io/","full_name":"babel/babel","description":"🐠 Babel is a compiler for writing next generation JavaScript.","owner_id":9637642,"tags":["compiler"],"delta":6271,"stars":31322,"created_at":"2014-09-28T13:38:23.000Z","twitter":"babeljs","monthly":[487,445,438,502,635,414,474,483,561,660,526,646]},{"name":"CoffeeScript","url":"http://coffeescript.org/","full_name":"jashkenas/coffeescript","description":"Unfancy JavaScript","owner_id":4732,"tags":["compiler"],"delta":546,"stars":15051,"created_at":"2009-12-18T01:39:53.000Z","twitter":"","monthly":[58,27,64,46,47,33,23,40,58,38,61,51],"icon":"coffeescript.svg"},{"name":"ws","url":"http://einaros.github.io/ws/","full_name":"websockets/ws","description":"Simple to use, blazing fast and thoroughly tested WebSocket client and server for Node.js","owner_id":10721323,"tags":["realtime","websocket"],"delta":3147,"stars":10313,"created_at":"2011-11-09T22:32:45.000Z","monthly":[176,250,201,202,198,279,264,299,281,334,310,353]},{"name":"ProseMirror","url":"http://prosemirror.net/","full_name":"ProseMirror/prosemirror","description":"The ProseMirror WYSIWYM editor","owner_id":13659461,"tags":["rich-text-editor"],"delta":568,"stars":3661,"created_at":"2015-08-06T08:55:00.000Z","monthly":[15,38,56,25,35,52,25,33,178,36,26,49]},{"name":"Tracking.js","url":"http://trackingjs.com","full_name":"eduardolundgren/tracking.js","description":"A modern approach for Computer Vision on the web","owner_id":113087,"tags":["image"],"delta":1444,"stars":7423,"created_at":"2012-06-18T04:39:34.000Z","monthly":[82,98,105,82,149,92,209,125,112,146,109,135]},{"name":"Feathers","url":"https://feathersjs.com","full_name":"feathersjs/feathers","description":"A REST and realtime API layer for modern applications.","owner_id":5321853,"tags":["nodejs-framework","realtime","express"],"delta":2156,"stars":10294,"created_at":"2011-10-19T22:45:16.000Z","twitter":"FeatherJS","monthly":[152,188,159,171,159,152,157,189,187,191,187,264]},{"name":"Vega","url":"http://vega.github.io/vega","full_name":"vega/vega","description":"A visualization grammar.","owner_id":11796929,"tags":["chart"],"delta":1025,"stars":6521,"created_at":"2013-02-03T18:36:30.000Z","monthly":[60,91,80,49,66,71,152,100,88,96,113,59]},{"name":"Morgan","url":"","full_name":"expressjs/morgan","description":"HTTP request logger middleware for node.js","owner_id":5658226,"tags":["log","middleware"],"delta":1187,"stars":4276,"created_at":"2014-02-08T19:19:14.000Z","twitter":"","monthly":[81,125,89,81,92,94,102,116,93,115,107,92]},{"name":"Winston","url":"http://github.com/winstonjs/winston","full_name":"winstonjs/winston","description":"A logger for just about everything.","owner_id":9682013,"tags":["log"],"delta":3132,"stars":12294,"created_at":"2010-12-29T18:49:51.000Z","twitter":"","monthly":[217,244,245,221,280,288,347,265,260,279,233,253]},{"name":"gm","url":"http://aheckmann.github.com/gm/","full_name":"aheckmann/gm","description":"GraphicsMagick for node","owner_id":166834,"tags":["image"],"delta":802,"stars":5437,"created_at":"2010-06-11T12:11:37.000Z","monthly":[60,53,36,75,70,76,70,66,90,81,51,74]},{"name":"UpUp","url":"https://www.talater.com/upup/","full_name":"TalAter/UpUp","description":"✈️ Easily create sites that work offline as well as online","owner_id":926653,"tags":["offline"],"delta":207,"stars":4514,"created_at":"2015-03-11T13:20:08.000Z"},{"name":"Animate Plus","url":"","full_name":"bendc/animateplus","description":"A+ animation module for the modern web","owner_id":51664,"tags":["animation","svg"],"delta":744,"stars":5137,"created_at":"2015-05-12T18:54:16.000Z","monthly":[29,41,32,33,77,39,68,86,86,60,92,101]},{"name":"StackEdit","url":"https://stackedit.io/","full_name":"benweet/stackedit","description":"In-browser Markdown editor","owner_id":1005257,"tags":["md"],"delta":2767,"stars":13384,"created_at":"2013-03-24T13:46:06.000Z","monthly":[183,199,202,195,232,228,207,243,270,256,275,277]},{"name":"Cyclon","url":"https://cylonjs.com","full_name":"hybridgroup/cylon","description":"JavaScript framework for robotics, drones, and the Internet of Things (IoT)","owner_id":212109,"tags":["iot"],"delta":293,"stars":3470,"created_at":"2013-10-18T06:57:08.000Z"},{"name":"Lovefield","url":"https://google.github.io/lovefield/","full_name":"google/lovefield","description":"Lovefield is a relational database for web apps. Written in JavaScript, works cross-browser. Provide","owner_id":1342004,"tags":["db"],"delta":280,"stars":5995,"created_at":"2014-09-30T18:29:14.000Z"},{"name":"basket.js","url":"http://addyosmani.github.com/basket.js","full_name":"addyosmani/basket.js","description":"A script and resource loader for caching & loading files with localStorage","owner_id":110953,"tags":["load"],"delta":109,"stars":3200,"created_at":"2012-02-29T22:16:56.000Z"},{"name":"CSS Modules","url":"","full_name":"css-modules/css-modules","description":"Documentation about css-modules","owner_id":12612655,"tags":["css-in-js"],"delta":2454,"stars":11195,"created_at":"2015-05-25T21:54:47.000Z","monthly":[152,182,196,189,226,193,160,210,259,223,209,255]},{"name":"node-inspector","url":"","full_name":"node-inspector/node-inspector","description":"Node.js debugger based on Blink Developer Tools","owner_id":4449877,"tags":["debug"],"delta":432,"stars":12354,"created_at":"2010-07-17T23:20:19.000Z","monthly":[34,26,28,28,7,36,44,35,41,57,40,56]},{"name":"offline","url":"http://github.hubspot.com/offline/docs/welcome","full_name":"HubSpot/offline","description":"Automatically display online/offline indication to your users","owner_id":326419,"tags":["offline"],"delta":348,"stars":8346,"created_at":"2013-10-21T20:14:57.000Z"},{"name":"minimist","url":"","full_name":"substack/minimist","description":"parse argument options","owner_id":12631,"tags":["cli"],"delta":734,"stars":3393,"created_at":"2013-06-25T08:14:48.000Z","monthly":[62,53,49,62,59,74,81,55,48,65,61,65]},{"name":"Modernizr","url":"https://modernizr.com","full_name":"Modernizr/Modernizr","description":"Modernizr is a JavaScript library that detects HTML5 and CSS3 features in the user’s browser.","owner_id":131060,"tags":["compatibility"],"delta":1454,"stars":23294,"created_at":"2009-09-25T20:13:23.000Z","monthly":[78,74,117,89,123,93,90,150,142,157,166,175]},{"name":"MEAN","url":"http://mean.io","full_name":"linnovate/mean","description":"The MEAN stack uses Mongo, Express, Angular(6) and Node for simple and scalable fullstack js applica","owner_id":307487,"tags":["fullstack","nodejs-framework"],"delta":809,"stars":11496,"created_at":"2013-05-22T12:15:47.000Z","twitter":"","monthly":[73,36,46,47,32,52,64,65,76,89,104,125]},{"name":"You might not need jQuery","url":"http://YouMightNotNeedjQuery.com","full_name":"HubSpot/youmightnotneedjquery","description":"A resource for doing things au naturel.","owner_id":326419,"tags":["learning"],"delta":1226,"stars":10960,"created_at":"2014-01-16T00:21:17.000Z","monthly":[78,66,99,105,119,114,87,70,122,130,111,125]},{"name":"React Native","url":"https://facebook.github.io/react-native/","full_name":"facebook/react-native","description":"A framework for building native apps with React.","owner_id":69631,"tags":["mobile","react-native"],"delta":14550,"stars":72595,"created_at":"2015-01-09T18:10:16.000Z","twitter":"reactnative","monthly":[921,1090,1126,1128,1144,1160,1384,1210,1264,1523,1264,1336],"icon":"react-native.svg"},{"name":"flowchart.js","url":"http://flowchart.js.org/","full_name":"adrai/flowchart.js","description":"Draws simple SVG flow chart diagrams from textual representation of the diagram","owner_id":1086194,"tags":["chart"],"delta":978,"stars":5497,"created_at":"2013-07-17T11:25:29.000Z","twitter":"","monthly":[82,71,80,81,135,69,72,74,81,71,83,79]},{"name":"Sequence Diagrams","url":"https://bramp.github.io/js-sequence-diagrams/","full_name":"bramp/js-sequence-diagrams","description":"Draws simple SVG sequence diagrams from textual representation of the diagram","owner_id":160627,"tags":["chart"],"delta":745,"stars":6045,"created_at":"2012-11-17T15:33:46.000Z","monthly":[59,64,63,46,51,68,57,60,103,68,46,60]},{"name":"ContentTools","url":"http://getcontenttools.com","full_name":"GetmeUK/ContentTools","description":"A JS library for building WYSIWYG editors for HTML content.","owner_id":13717900,"tags":["rich-text-editor"],"delta":379,"stars":3455,"created_at":"2015-08-09T12:44:12.000Z"},{"name":"Pomelo","url":"http://pomelo.netease.com","full_name":"NetEase/pomelo","description":"A fast,scalable,distributed game server framework for Node.js.","owner_id":1460597,"tags":["game"],"delta":1172,"stars":9855,"created_at":"2012-09-20T02:37:07.000Z","monthly":[88,54,69,68,91,124,88,136,140,127,81,106]},{"name":"NW.js","url":"https://nwjs.io","full_name":"nwjs/nw.js","description":"Call all Node.js modules directly from DOM/WebWorker and enable a new way of writing applications wi","owner_id":10180421,"tags":["desktop"],"delta":1784,"stars":34845,"created_at":"2012-01-04T06:21:10.000Z","monthly":[165,158,131,132,128,135,154,179,172,142,119,169]},{"name":"Sequence.js","url":"http://sequencejs.com","full_name":"IanLunn/Sequence","description":"The responsive CSS animation framework for creating unique sliders, presentations, banners, and othe","owner_id":694641,"tags":["animation"],"delta":41,"stars":3373,"created_at":"2012-01-13T14:16:29.000Z"},{"name":"bookshelf","url":"http://bookshelfjs.org","full_name":"bookshelf/bookshelf","description":"A simple Node.js ORM for PostgreSQL, MySQL and SQLite3 built on top of Knex.js","owner_id":4448260,"tags":["db"],"delta":703,"stars":5310,"created_at":"2013-03-06T03:07:32.000Z","monthly":[43,41,42,56,53,74,58,65,69,67,65,70]},{"name":"clipboard.js","url":"https://clipboardjs.com","full_name":"zenorocha/clipboard.js","description":":scissors: Modern copy to clipboard. No Flash. Just 3kb gzipped :clipboard:","owner_id":398893,"tags":["util"],"delta":4257,"stars":24687,"created_at":"2015-09-18T23:04:55.000Z","monthly":[314,287,306,309,313,374,337,421,376,402,340,478]},{"name":"jimp","url":"","full_name":"oliver-moran/jimp","description":"An image processing library written entirely in JavaScript for Node, with zero external or native de","owner_id":414918,"tags":["image"],"delta":2299,"stars":7380,"created_at":"2014-09-13T22:53:45.000Z","monthly":[114,162,173,137,194,121,148,335,166,137,159,453]},{"name":"Gatsby","url":"https://www.gatsbyjs.org","full_name":"gatsbyjs/gatsby","description":"Build blazing fast, modern apps and websites with React","owner_id":12551863,"tags":["ssg","react","graphql"],"delta":12981,"stars":29790,"created_at":"2015-05-21T22:43:05.000Z","twitter":"gatsbyjs","monthly":[1259,946,1131,1062,1097,1046,875,831,928,1108,960,1738],"icon":"gatsby.svg"},{"name":"Popmotion","url":"https://popmotion.io","full_name":"Popmotion/popmotion","description":"Simple animation libraries for delightful user interfaces","owner_id":14272617,"tags":["animation"],"delta":8806,"stars":15856,"created_at":"2014-08-17T16:23:07.000Z","monthly":[277,300,382,415,398,175,251,442,1410,1885,417,2454]},{"name":"React Starter Kit","url":"https://reactstarter.com","full_name":"kriasoft/react-starter-kit","description":"React Starter Kit — isomorphic web app boilerplate (Node.js, Express, GraphQL, React.js, Babel, Post","owner_id":773036,"tags":["react","isomorphic","boilerplate","graphql"],"delta":2212,"stars":18677,"created_at":"2014-04-16T13:08:18.000Z","monthly":[116,122,94,140,140,174,189,187,224,219,250,357]},{"name":"Sharp","url":"https://sharp.pixelplumbing.com/","full_name":"lovell/sharp","description":"High performance Node.js image processing, the fastest module to resize JPEG, PNG, WebP and TIFF ima","owner_id":210965,"tags":["image"],"delta":4295,"stars":11352,"created_at":"2013-08-19T20:24:24.000Z","monthly":[1302,281,274,231,218,246,281,282,273,320,232,355]},{"name":"Node.js","url":"https://nodejs.org","full_name":"nodejs/node","description":"Node.js JavaScript runtime :sparkles::turtle::rocket::sparkles:","owner_id":9950313,"tags":["node.js","runtime"],"delta":12867,"stars":57007,"created_at":"2014-11-26T19:57:11.000Z","twitter":"nodejs","monthly":[892,1041,1017,1040,1009,966,1326,1310,1160,1172,858,1076]},{"name":"Relax","url":"","full_name":"relax/relax","description":"New generation CMS on top of React, Redux and GraphQL","owner_id":13644940,"tags":["cms"],"delta":492,"stars":8224,"created_at":"2015-08-31T12:16:25.000Z"},{"name":"Kraken","url":"http://krakenjs.com","full_name":"krakenjs/kraken-js","description":"An express-based Node.js web application bootstrapping module.","owner_id":7001600,"tags":["nodejs-framework"],"delta":200,"stars":4704,"created_at":"2013-09-30T18:54:00.000Z"},{"name":"Sequelize","url":"http://docs.sequelizejs.com","full_name":"sequelize/sequelize","description":"An easy-to-use multi SQL dialect ORM for Node.js","owner_id":3591786,"tags":["db"],"delta":4424,"stars":17062,"created_at":"2010-07-22T07:11:11.000Z","monthly":[316,317,336,365,349,389,367,420,398,394,390,383]},{"name":"Recompose","url":"","full_name":"acdlite/recompose","description":"A React utility belt for function components and higher-order components.","owner_id":3624098,"tags":["react","fp"],"delta":4675,"stars":13128,"created_at":"2015-10-07T05:54:51.000Z","twitter":"","monthly":[178,238,452,358,461,433,416,404,406,455,398,476]},{"name":"AMP HTML","url":"https://www.ampproject.org","full_name":"ampproject/amphtml","description":"AMP HTML source code, samples, and documentation.  See below for more info.","owner_id":14114390,"tags":["performance"],"delta":1430,"stars":12273,"created_at":"2015-09-01T22:10:53.000Z","monthly":[42,98,95,96,115,91,73,145,114,228,251,82]},{"name":"photon","url":"photonkit.com","full_name":"connors/photon","description":"The fastest way to build beautiful Electron apps using simple HTML and CSS","owner_id":874145,"tags":["desktop"],"delta":798,"stars":8748,"created_at":"2015-09-28T04:03:26.000Z","monthly":[53,57,49,52,53,55,59,62,81,99,71,107]},{"name":"Synaptic","url":"http://caza.la/synaptic","full_name":"cazala/synaptic","description":"architecture-free neural network library for node.js and the browser","owner_id":2781777,"tags":["neural","ml"],"delta":745,"stars":6375,"created_at":"2014-09-30T18:07:03.000Z","monthly":[34,22,33,39,39,30,54,72,95,126,80,121]},{"name":"smartcrop.js","url":"http://29a.ch/2014/04/03/smartcrop-content-aware-image-cropping","full_name":"jwagner/smartcrop.js","description":"Content aware image cropping","owner_id":293536,"tags":["image"],"delta":655,"stars":10797,"created_at":"2014-04-03T14:21:19.000Z","monthly":[46,23,62,45,38,35,52,61,78,49,101,65]},{"name":"Inquirer.js","url":"","full_name":"SBoudrias/Inquirer.js","description":"A collection of common interactive command line user interfaces.","owner_id":923865,"tags":["cli"],"delta":3103,"stars":9058,"created_at":"2013-05-17T01:41:36.000Z","monthly":[282,296,242,270,257,258,239,279,202,277,220,281]},{"name":"Trix","url":"https://trix-editor.org/","full_name":"basecamp/trix","description":"A rich text editor for everyday writing","owner_id":13131,"tags":["rich-text-editor"],"delta":4513,"stars":12843,"created_at":"2013-08-01T22:21:30.000Z","monthly":[131,202,1629,1883,88,107,50,46,50,92,130,105]},{"name":"Structor","url":"","full_name":"ipselon/structor","description":"Structor - React UI Builder","owner_id":11865795,"tags":["react"],"delta":553,"stars":5485,"created_at":"2015-10-17T15:49:40.000Z","twitter":"","monthly":[23,35,37,33,55,45,55,57,48,56,62,47]},{"name":"accounting.js","url":"http://openexchangerates.github.io/accounting.js","full_name":"openexchangerates/accounting.js","description":"A lightweight JavaScript library for number, money and currency formatting - fully localisable, zero","owner_id":8118621,"tags":["format","money"],"delta":440,"stars":4112,"created_at":"2011-08-21T04:18:02.000Z","twitter":""},{"name":"Nightmare","url":"https://open.segment.com","full_name":"segmentio/nightmare","description":"A high-level browser automation library.","owner_id":819518,"tags":["auto"],"delta":2168,"stars":16682,"created_at":"2014-04-05T22:19:51.000Z","monthly":[139,145,174,126,131,184,144,198,215,253,231,228]},{"name":"Rollup","url":"https://rollupjs.org","full_name":"rollup/rollup","description":"Next-generation ES module bundler","owner_id":12554859,"tags":["module","build"],"delta":3156,"stars":14576,"created_at":"2015-05-14T22:26:28.000Z","twitter":"rollupjs","monthly":[270,248,231,162,257,241,271,303,279,292,228,374]},{"name":"Quill","url":"https://quilljs.com","full_name":"quilljs/quill","description":"Quill is a modern WYSIWYG editor built for compatibility and extensibility.","owner_id":7089101,"tags":["rich-text-editor"],"delta":4945,"stars":21056,"created_at":"2012-07-30T23:23:18.000Z","monthly":[340,397,417,364,406,417,376,480,445,487,359,457]},{"name":"isomorphic-fetch","url":"","full_name":"matthew-andrews/isomorphic-fetch","description":"Isomorphic WHATWG Fetch API, for Node & Browserify","owner_id":825088,"tags":["http","isomorphic"],"delta":874,"stars":6070,"created_at":"2014-11-07T08:46:13.000Z","monthly":[55,53,61,54,73,73,89,77,73,90,82,94]},{"name":"when.js","url":"","full_name":"cujojs/when","description":"A solid, fast Promises/A+ and when() implementation, plus other async goodies.","owner_id":1211266,"tags":["flow"],"delta":91,"stars":3385,"created_at":"2011-03-30T11:52:09.000Z"},{"name":"CSSgram","url":"http://una.im/CSSgram/","full_name":"una/CSSgram","description":"CSS library for Instagram filters","owner_id":1693164,"tags":["css-tool"],"delta":308,"stars":4633,"created_at":"2015-09-26T14:50:01.000Z"},{"name":"imagemin","url":"","full_name":"imagemin/imagemin","description":"Tense, nervous, minifying images?","owner_id":7868808,"tags":["image"],"delta":904,"stars":2740,"created_at":"2013-11-04T09:26:16.000Z","monthly":[69,129,47,75,93,81,59,73,53,77,75,73]},{"name":"Mongoose","url":"http://mongoosejs.com","full_name":"Automattic/mongoose","description":"MongoDB object modeling designed to work in an asynchronous environment.","owner_id":887802,"tags":["db"],"delta":3293,"stars":17677,"created_at":"2010-04-06T21:39:05.000Z","monthly":[211,204,227,289,289,298,272,307,283,317,274,322]},{"name":"React toolbox","url":"http://www.react-toolbox.io","full_name":"react-toolbox/react-toolbox","description":"A set of React components implementing Google's Material Design specification with the power of CSS ","owner_id":13482715,"tags":["material","react","component"],"delta":794,"stars":8291,"created_at":"2015-05-27T15:23:33.000Z","monthly":[33,45,55,40,39,79,72,78,80,97,91,85]},{"name":"Sortable","url":"http://sortablejs.github.io/Sortable/","full_name":"SortableJS/Sortable","description":"Sortable — is a JavaScript library for reorderable drag-and-drop lists on modern browsers and touch ","owner_id":17040762,"tags":["dnd"],"delta":2919,"stars":15204,"created_at":"2013-12-19T10:10:13.000Z","monthly":[327,252,178,198,229,235,263,242,271,264,207,253]},{"name":"AVA","url":"","full_name":"avajs/ava","description":"🚀 Testing can be a drag. AVA helps you get it done.","owner_id":8527916,"tags":["test-framework","test"],"delta":3075,"stars":15468,"created_at":"2014-11-18T17:20:26.000Z","twitter":"ava__js","monthly":[250,212,173,205,231,201,252,230,247,338,282,454]},{"name":"Got","url":"","full_name":"sindresorhus/got","description":"Simplified HTTP requests","owner_id":170270,"tags":["http"],"delta":2309,"stars":4599,"created_at":"2014-03-27T22:40:49.000Z","twitter":"","monthly":[100,118,169,367,994,96,67,73,85,90,67,83]},{"name":"slideout","url":"https://slideout.js.org","full_name":"Mango/slideout","description":"A touch slideout navigation menu for your mobile web apps.","owner_id":5920385,"tags":["nav"],"delta":501,"stars":7578,"created_at":"2015-02-02T01:05:43.000Z","monthly":[36,36,24,32,44,35,32,41,54,63,52,52]},{"name":"MathJax","url":"http://www.mathjax.org/","full_name":"mathjax/MathJax","description":"Beautiful math in all browsers","owner_id":252187,"tags":["math"],"delta":1391,"stars":6193,"created_at":"2010-08-19T03:28:53.000Z","monthly":[101,105,111,116,120,94,95,134,129,164,116,106]},{"name":"notie","url":"https://jaredreich.com/notie","full_name":"jaredreich/notie","description":"🔔 a clean and simple notification, input, and selection suite for javascript, with no dependencies","owner_id":8563847,"tags":["notify"],"delta":249,"stars":6013,"created_at":"2015-11-06T03:08:02.000Z"},{"name":"plotly.js","url":"https://plot.ly/javascript/","full_name":"plotly/plotly.js","description":"Open-source JavaScript charting library behind plot.ly and Dash","owner_id":5997976,"tags":["chart"],"delta":2066,"stars":9453,"created_at":"2015-11-05T23:27:17.000Z","monthly":[107,159,187,162,153,176,165,178,160,191,217,211]},{"name":"mo · js","url":"http://mojs.io/","full_name":"legomushroom/mojs","description":"motion graphics toolbelt for the web","owner_id":1478800,"tags":["animation"],"delta":1573,"stars":14293,"created_at":"2014-06-26T08:49:14.000Z","monthly":[84,60,151,156,150,170,152,103,125,162,116,144]},{"name":"GraphQL","url":"https://graphql.org/","full_name":"facebook/graphql","description":"GraphQL is a query language and execution engine tied to any backend service.","owner_id":69631,"tags":["data","graphql"],"delta":3668,"stars":10611,"created_at":"2015-07-01T01:26:56.000Z","twitter":"graphql","monthly":[249,354,300,258,272,309,374,322,286,307,289,348],"icon":"graphql.svg"},{"name":"Passport","url":"http://www.passportjs.org","full_name":"jaredhanson/passport","description":"Simple, unobtrusive authentication for Node.js.","owner_id":10355,"tags":["auth"],"delta":2444,"stars":14817,"created_at":"2011-10-08T22:38:32.000Z","twitter":"","monthly":[213,164,165,188,173,219,194,238,236,249,178,227],"icon":"passport.svg"},{"name":"VS Code","url":"https://code.visualstudio.com","full_name":"Microsoft/vscode","description":"Visual Studio Code","owner_id":6154722,"tags":["ide"],"delta":25187,"stars":66818,"created_at":"2015-09-03T20:23:38.000Z","twitter":"code","monthly":[1636,1752,2490,2266,2211,1938,3061,2269,1831,1993,1782,1958],"icon":"vscode.svg"},{"name":"headroom.js","url":"http://wicky.nillia.ms/headroom.js/","full_name":"WickyNilliams/headroom.js","description":"Give your pages some headroom. Hide your header until you need it","owner_id":1091390,"tags":["scrolling"],"delta":364,"stars":9999,"created_at":"2013-08-07T20:42:58.000Z"},{"name":"lunr","url":"http://lunrjs.com","full_name":"olivernn/lunr.js","description":"A bit like Solr, but much smaller and not as bright","owner_id":35913,"tags":["search"],"delta":943,"stars":5750,"created_at":"2011-06-23T20:53:57.000Z","monthly":[63,58,67,62,153,79,74,80,61,84,99,63]},{"name":"vivus","url":"","full_name":"maxwellito/vivus","description":"JavaScript library to make drawing animation on SVG","owner_id":1097232,"tags":["animation","svg"],"delta":1544,"stars":11227,"created_at":"2014-05-13T22:22:18.000Z","monthly":[168,126,133,85,127,137,152,89,114,123,165,125]},{"name":"jump.js","url":"http://callmecavs.com/jump.js/","full_name":"callmecavs/jump.js","description":"A modern smooth scrolling library.","owner_id":2293641,"tags":["scrolling"],"delta":282,"stars":3210,"created_at":"2015-07-12T23:18:24.000Z"},{"name":"virtual-dom","url":"","full_name":"Matt-Esch/virtual-dom","description":"A Virtual DOM and diffing algorithm","owner_id":1058839,"tags":["vdom"],"delta":1165,"stars":9822,"created_at":"2014-01-23T17:12:21.000Z","monthly":[52,81,82,65,85,114,114,129,132,125,89,97]},{"name":"page.js","url":"http://visionmedia.github.com/page.js","full_name":"visionmedia/page.js","description":"Micro client-side router inspired by the Express router","owner_id":9285252,"tags":["routing"],"delta":927,"stars":6191,"created_at":"2012-04-12T23:33:30.000Z","monthly":[34,36,70,61,43,60,60,64,78,106,257,58]},{"name":"director","url":"http://github.com/flatiron/director","full_name":"flatiron/director","description":"a tiny and isomorphic URL router for JavaScript","owner_id":624259,"tags":["routing"],"delta":346,"stars":5396,"created_at":"2010-04-24T00:22:38.000Z"},{"name":"SuperTest","url":"","full_name":"visionmedia/supertest","description":"Super-agent driven library for testing node.js HTTP servers using a fluent API","owner_id":9285252,"tags":["test"],"delta":1654,"stars":7821,"created_at":"2012-06-27T20:56:12.000Z","twitter":"","monthly":[117,135,133,121,155,145,138,125,164,144,133,144]},{"name":"EpicEditor","url":"http://epiceditor.com","full_name":"OscarGodson/EpicEditor","description":"EpicEditor is an embeddable JavaScript Markdown editor with split fullscreen editing, live previewin","owner_id":20615,"tags":["md"],"delta":-25,"stars":4346,"created_at":"2012-01-26T20:11:47.000Z"},{"name":"Solved by Flexbox","url":"https://philipwalton.github.io/solved-by-flexbox/","full_name":"philipwalton/solved-by-flexbox","description":"A showcase of problems once hard or impossible to solve with CSS alone, now made trivially easy with","owner_id":326742,"tags":["learning"],"delta":850,"stars":11511,"created_at":"2013-08-31T23:04:51.000Z","monthly":[33,39,57,52,71,74,58,92,88,89,96,101]},{"name":"Enzyme","url":"https://airbnb.io/enzyme/","full_name":"airbnb/enzyme","description":"JavaScript Testing utilities for React","owner_id":698437,"tags":["test","react"],"delta":3997,"stars":16146,"created_at":"2015-11-10T21:45:38.000Z","monthly":[207,258,351,291,314,397,348,356,334,385,325,431]},{"name":"marked","url":"https://marked.js.org/","full_name":"markedjs/marked","description":"A markdown parser and compiler. Built for speed.","owner_id":19886934,"tags":["md"],"delta":3198,"stars":18193,"created_at":"2011-07-24T13:15:51.000Z","monthly":[243,237,209,222,267,278,265,299,299,302,247,330]},{"name":"Split.js","url":"https://split.js.org/","full_name":"nathancahill/split","description":"Unopinionated utilities for resizeable split views","owner_id":1383872,"tags":["layout"],"delta":417,"stars":3334,"created_at":"2015-08-29T02:50:58.000Z"},{"name":"Swiper","url":"http://idangero.us/swiper/","full_name":"nolimits4web/swiper","description":"Most modern mobile touch slider with hardware accelerated transitions","owner_id":999588,"tags":["nav"],"delta":3805,"stars":18629,"created_at":"2012-03-14T19:11:45.000Z","monthly":[282,276,303,302,326,291,310,329,329,364,293,400]},{"name":"Framework7","url":"http://framework7.io","full_name":"framework7io/framework7","description":"Full featured HTML framework for building iOS & Android apps","owner_id":31954178,"tags":["mobile"],"delta":2131,"stars":13620,"created_at":"2014-02-23T12:15:53.000Z","monthly":[168,148,153,197,183,187,154,180,180,220,153,208]},{"name":"ramjet","url":"http://www.rich-harris.co.uk/ramjet/","full_name":"Rich-Harris/ramjet","description":"Morph DOM elements from one state to another with smooth animations and transitions","owner_id":1162160,"tags":["animation"],"delta":170,"stars":5251,"created_at":"2014-09-25T23:17:22.000Z"},{"name":"react virtualized","url":"http://www.reactvirtualized.com","full_name":"bvaughn/react-virtualized","description":"React components for efficiently rendering large lists and tabular data","owner_id":29597,"tags":["react","scrolling"],"delta":5525,"stars":13880,"created_at":"2015-11-03T00:48:07.000Z","monthly":[504,442,360,366,398,495,472,486,453,598,477,474]},{"name":"ScrollReveal","url":"https://scrollrevealjs.org/","full_name":"scrollreveal/scrollreveal","description":"Animate elements as they scroll into view.","owner_id":42127942,"tags":["scrolling"],"delta":2726,"stars":16882,"created_at":"2014-01-16T17:37:20.000Z","monthly":[177,165,177,156,231,299,355,244,211,256,212,243]},{"name":"aframe","url":"https://aframe.io/","full_name":"aframevr/aframe","description":":a: web framework for building virtual reality experiences.","owner_id":16024092,"tags":["virtual"],"delta":1960,"stars":9244,"created_at":"2015-09-15T02:04:40.000Z","monthly":[125,123,117,123,179,235,165,152,155,211,201,174]},{"name":"React Refetch","url":"https://blog.heroku.com/react-refetch","full_name":"heroku/react-refetch","description":"A simple, declarative, and composable way to fetch data for React components","owner_id":23211,"tags":["react","data"],"delta":365,"stars":3138,"created_at":"2015-11-11T21:02:02.000Z","twitter":""},{"name":"Strapi","url":"https://strapi.io","full_name":"strapi/strapi","description":"🚀 Open source Node.js Headless CMS to easily build customisable APIs","owner_id":19872173,"tags":["api"],"delta":7892,"stars":10536,"created_at":"2015-09-30T15:34:48.000Z","monthly":[916,830,800,668,634,622,583,557,595,636,542,509]},{"name":"Victory","url":"http://formidable.com/open-source/victory/","full_name":"FormidableLabs/victory","description":"A collection of composable React components for building interactive data visualizations","owner_id":5078602,"tags":["chart","react","d3"],"delta":1312,"stars":6712,"created_at":"2015-07-02T22:36:50.000Z","monthly":[103,103,84,87,83,88,112,116,109,147,149,131]},{"name":"BrowserSync","url":"http://browsersync.io/","full_name":"BrowserSync/browser-sync","description":"Keep multiple browsers & devices in sync when building websites. http://browsersync.io","owner_id":10654171,"tags":["test"],"delta":904,"stars":10446,"created_at":"2013-10-12T19:35:45.000Z","monthly":[60,79,69,51,69,75,74,83,72,121,72,79]},{"name":"gmaps.js","url":"http://hpneo.github.com/gmaps/","full_name":"hpneo/gmaps","description":"the easiest way to use Google Maps","owner_id":611699,"tags":["map"],"delta":176,"stars":7044,"created_at":"2011-10-08T03:55:37.000Z"},{"name":"LocalForage","url":"https://localforage.github.io/localForage","full_name":"localForage/localForage","description":"💾 Offline storage, improved. Wraps IndexedDB, WebSQL, or localStorage using a simple but powerful A","owner_id":18673496,"tags":["offline"],"delta":3467,"stars":14248,"created_at":"2013-10-31T00:10:06.000Z","monthly":[192,176,227,182,379,499,494,251,246,268,321,232]},{"name":"joi","url":"","full_name":"hapijs/joi","description":"Object schema validation","owner_id":3774533,"tags":["json","validation"],"delta":3551,"stars":10326,"created_at":"2012-09-16T16:38:06.000Z","monthly":[333,278,296,289,342,327,291,311,249,279,246,310]},{"name":"SocketCluster","url":"http://socketcluster.io/","full_name":"SocketCluster/socketcluster","description":"Highly scalable realtime framework","owner_id":12481324,"tags":["realtime","websocket","nodejs-framework"],"delta":668,"stars":5069,"created_at":"2013-09-23T12:11:47.000Z","twitter":"","monthly":[44,42,51,48,40,56,49,60,56,84,69,69]},{"name":"redux-form","url":"http://redux-form.com","full_name":"erikras/redux-form","description":"A Higher Order Component using react-redux to keep form state in a Redux store","owner_id":4396759,"tags":["form","redux"],"delta":2504,"stars":11014,"created_at":"2015-07-31T16:07:03.000Z","monthly":[146,135,158,157,175,229,210,237,256,278,260,263]},{"name":"Deku","url":"https://github.com/anthonyshort/deku/tree/master/docs","full_name":"anthonyshort/deku","description":"Render interfaces using pure functions and virtual DOM","owner_id":36125,"tags":["vdom"],"delta":139,"stars":3361,"created_at":"2014-08-08T04:32:23.000Z"},{"name":"remarkable","url":"https://jonschlinkert.github.io/remarkable/demo/","full_name":"jonschlinkert/remarkable","description":"Markdown parser, done right. Commonmark support, extensions, syntax plugins, high speed - all in one","owner_id":383994,"tags":["md"],"delta":498,"stars":4132,"created_at":"2014-09-01T17:57:42.000Z"},{"name":"React Redux Universal Hot Example","url":"","full_name":"erikras/react-redux-universal-hot-example","description":"A starter boilerplate for a universal webapp using express, react, redux, webpack, and react-transfo","owner_id":4396759,"tags":["boilerplate","react","redux"],"delta":809,"stars":11570,"created_at":"2015-06-23T16:39:21.000Z","monthly":[24,32,59,42,72,72,44,67,74,93,117,113]},{"name":"Este","url":"https://javascript-skoleni.com/","full_name":"este/este","description":"Is What It Is","owner_id":3302034,"tags":["boilerplate","react","redux"],"delta":233,"stars":5530,"created_at":"2013-02-16T03:30:38.000Z"},{"name":"React boilerplate","url":"https://www.reactboilerplate.com","full_name":"react-boilerplate/react-boilerplate","description":":fire: A highly scalable, offline-first foundation with the best developer experience and a focus on","owner_id":25323389,"tags":["boilerplate","react","redux","offline","serviceworker"],"delta":4411,"stars":20977,"created_at":"2015-02-18T14:36:32.000Z","twitter":"","monthly":[324,319,354,337,347,515,380,386,347,352,320,430]},{"name":"Milligram","url":"https://milligram.io","full_name":"milligram/milligram","description":"A minimalist CSS framework.","owner_id":16243913,"tags":["css-lib"],"delta":1048,"stars":7823,"created_at":"2015-12-10T17:03:36.000Z","monthly":[90,99,113,74,80,68,61,100,104,106,48,105]},{"name":"Skeleton","url":"http://www.getskeleton.com","full_name":"dhg/Skeleton","description":"Skeleton: A Dead Simple, Responsive Boilerplate for Mobile-Friendly Development","owner_id":693790,"tags":["css-lib"],"delta":1214,"stars":16315,"created_at":"2011-04-30T20:04:24.000Z","monthly":[52,104,94,95,102,95,94,113,109,100,126,130]},{"name":"Labella.js","url":"http://twitter.github.io/labella.js/","full_name":"twitter/labella.js","description":"Placing labels on a timeline without overlap.","owner_id":50278,"tags":["plugin"],"delta":77,"stars":3603,"created_at":"2015-06-04T19:02:35.000Z"},{"name":"Highlight.js","url":"https://highlightjs.org/","full_name":"highlightjs/highlight.js","description":"Javascript syntax highlighter","owner_id":9039821,"tags":["highlight"],"delta":2122,"stars":13529,"created_at":"2011-01-01T23:47:21.000Z","monthly":[159,148,190,200,171,140,187,170,191,190,178,198]},{"name":"stats.js","url":"http://mrdoob.github.io/stats.js/","full_name":"mrdoob/stats.js","description":"JavaScript Performance Monitor","owner_id":97088,"tags":["performance"],"delta":877,"stars":5522,"created_at":"2010-04-08T11:54:17.000Z","monthly":[84,66,62,53,79,76,77,91,67,74,70,78]},{"name":"jsonwebtoken","url":"","full_name":"auth0/node-jsonwebtoken","description":"JsonWebToken implementation for node.js http://self-issued.info/docs/draft-ietf-oauth-json-web-token","owner_id":2824157,"tags":["auth"],"delta":2750,"stars":9303,"created_at":"2013-07-01T01:28:43.000Z","monthly":[220,194,245,188,210,245,227,249,283,231,191,267]},{"name":"Nodal","url":"http://www.nodaljs.com/","full_name":"keithwhor/nodal","description":"API Services Made Easy With Node.js","owner_id":3936867,"tags":["nodejs-framework"],"delta":60,"stars":4578,"created_at":"2015-04-19T06:34:05.000Z","twitter":"","icon":"nodal.svg"},{"name":"VerbalExpressions","url":"","full_name":"VerbalExpressions/JSVerbalExpressions","description":"JavaScript Regular expressions made easy","owner_id":5083777,"tags":["regexp"],"delta":388,"stars":10711,"created_at":"2013-07-19T14:59:46.000Z","monthly":[16,11,25,39,85,72,37,16,23,22,23,19]},{"name":"es6-promise","url":"","full_name":"stefanpenner/es6-promise","description":"A polyfill for ES6-style Promises","owner_id":1377,"tags":["flow"],"delta":1071,"stars":6360,"created_at":"2013-12-09T12:04:03.000Z","monthly":[85,68,68,61,90,103,90,98,110,115,64,119]},{"name":"Feature.js","url":"http://featurejs.com/","full_name":"viljamis/feature.js","description":"Feature.js is a fast, simple and lightweight browser feature detection library in 1kb.","owner_id":671836,"tags":["compatibility"],"delta":50,"stars":3067,"created_at":"2016-01-09T16:38:47.000Z"},{"name":"React Slingshot","url":"","full_name":"coryhouse/react-slingshot","description":"React + Redux starter kit / boilerplate with Babel, hot reloading, testing, linting and a working ex","owner_id":1688997,"tags":["boilerplate","react","redux"],"delta":1156,"stars":9092,"created_at":"2015-12-31T22:04:53.000Z","monthly":[74,70,72,44,88,77,99,137,68,138,136,153]},{"name":"Inferno","url":"http://infernojs.org","full_name":"infernojs/inferno","description":":fire: An extremely fast, React-like JavaScript library for building modern user interfaces","owner_id":14214240,"tags":["vdom","framework"],"delta":1371,"stars":13354,"created_at":"2015-02-01T22:07:38.000Z","twitter":"inferno_js","monthly":[71,98,218,100,98,79,74,75,104,119,181,154]},{"name":"Preact","url":"https://preactjs.com","full_name":"developit/preact","description":"⚛️ Fast 3kB React alternative with the same modern API. Components & Virtual DOM.","owner_id":105127,"tags":["vdom","framework"],"delta":4214,"stars":21219,"created_at":"2015-09-11T02:40:18.000Z","twitter":"preactjs","monthly":[291,369,290,300,373,285,340,354,345,351,388,528],"icon":"preact.svg"},{"name":"Viewer.js","url":"https://fengyuanchen.github.io/viewerjs","full_name":"fengyuanchen/viewerjs","description":"JavaScript image viewer.","owner_id":3456749,"tags":["viewer"],"delta":928,"stars":3420,"created_at":"2015-12-24T07:27:47.000Z","monthly":[107,89,75,94,88,86,66,82,69,77,34,61]},{"name":"Medium editor","url":"https://yabwe.github.io/medium-editor/","full_name":"yabwe/medium-editor","description":"Medium.com WYSIWYG editor clone. Uses contenteditable API to implement a rich text solution.","owner_id":12655868,"tags":["rich-text-editor"],"delta":1522,"stars":13105,"created_at":"2013-05-29T17:40:11.000Z","monthly":[110,106,107,115,111,104,119,155,115,184,140,156]},{"name":"Hint.css","url":"https://kushagragour.in/lab/hint/","full_name":"chinchang/hint.css","description":"A CSS only tooltip library for your lovely websites.","owner_id":379918,"tags":["tooltip"],"delta":189,"stars":7715,"created_at":"2012-12-30T20:17:34.000Z","twitter":""},{"name":"Bulma","url":"https://bulma.io","full_name":"jgthms/bulma","description":"Modern CSS framework based on Flexbox","owner_id":1254808,"tags":["css-lib"],"delta":8878,"stars":32162,"created_at":"2016-01-23T23:48:34.000Z","twitter":"","monthly":[520,694,678,579,883,684,682,904,848,721,732,953],"icon":"bulma.svg"},{"name":"Micro","url":"https://zeit.co/blog/micro-8","full_name":"zeit/micro","description":"Asynchronous HTTP microservices","owner_id":14985020,"tags":["microservice","nodejs-framework"],"delta":2176,"stars":7856,"created_at":"2016-01-23T05:17:00.000Z","twitter":"","monthly":[125,163,194,160,153,240,126,163,187,173,147,345]},{"name":"deployd","url":"http://www.deployd.com","full_name":"deployd/deployd","description":"a toolkit for building realtime APIs","owner_id":1043054,"tags":["api","realtime"],"delta":222,"stars":4908,"created_at":"2011-09-11T21:58:04.000Z","twitter":""},{"name":"mjml","url":"https://mjml.io","full_name":"mjmlio/mjml","description":"MJML: the only framework that makes responsive-email easy","owner_id":16115896,"tags":["email"],"delta":1765,"stars":7878,"created_at":"2016-01-28T14:04:05.000Z","monthly":[100,133,131,151,150,121,124,172,243,168,164,108]},{"name":"Vorpal","url":"http://vorpal.js.org","full_name":"dthree/vorpal","description":"Node's framework for interactive CLIs","owner_id":10319897,"tags":["cli"],"delta":561,"stars":4928,"created_at":"2015-08-23T17:08:20.000Z","monthly":[29,46,35,28,57,33,42,54,46,54,85,52]},{"name":"Nodemailer","url":"http://nodemailer.com/","full_name":"nodemailer/nodemailer","description":"✉️ Send e-mails with Node.JS – easy as cake!","owner_id":16486629,"tags":["email"],"delta":1667,"stars":10500,"created_at":"2011-01-19T21:17:36.000Z","monthly":[153,137,115,128,133,143,134,140,136,172,136,140]},{"name":"Recharts","url":"http://recharts.org","full_name":"recharts/recharts","description":"Redefined chart library built with React and D3","owner_id":13690587,"tags":["chart","react","d3","svg"],"delta":2997,"stars":10603,"created_at":"2015-08-07T06:50:27.000Z","monthly":[186,183,279,207,259,216,221,219,403,283,249,292]},{"name":"GrapeJS","url":"https://grapesjs.com","full_name":"artf/grapesjs","description":"Free and Open source Web Builder Framework. Next generation tool for building templates without codi","owner_id":11614725,"tags":["rich-text-editor","cms"],"delta":3984,"stars":7061,"created_at":"2016-01-22T00:23:19.000Z","twitter":"","monthly":[171,166,371,1696,151,192,167,189,201,225,225,230],"icon":"grapejs.svg"},{"name":"Mousetrap","url":"https://craig.is/killing/mice","full_name":"ccampbell/mousetrap","description":"Simple library for handling keyboard shortcuts in Javascript","owner_id":259316,"tags":["keyboard"],"delta":838,"stars":9255,"created_at":"2012-07-05T03:13:55.000Z","twitter":"","monthly":[46,66,55,44,80,69,52,75,79,100,83,89]},{"name":"Mermaid","url":"http://knsv.github.io/mermaid/","full_name":"knsv/mermaid","description":"Generation of diagram and flowchart from text in a similar manner as markdown","owner_id":5837277,"tags":["chart","d3"],"delta":6574,"stars":21590,"created_at":"2014-11-01T23:52:32.000Z","monthly":[441,813,271,278,449,568,473,515,1883,304,240,339]},{"name":"bricks.js","url":"http://callmecavs.com/bricks.js/","full_name":"callmecavs/bricks.js","description":"A blazing fast masonry layout generator for fixed width elements.","owner_id":2293641,"tags":["layout"],"delta":289,"stars":4264,"created_at":"2015-12-09T22:16:21.000Z"},{"name":"MERN Starter","url":"http://mern.io","full_name":"Hashnode/mern-starter","description":"Boilerplate for getting started with MERN stack","owner_id":16342708,"tags":["boilerplate","redux","fullstack","react","nodejs-framework"],"delta":810,"stars":5112,"created_at":"2016-01-29T14:40:26.000Z","twitter":"","monthly":[34,63,55,48,58,64,73,88,84,77,85,81]},{"name":"okayNav","url":"","full_name":"VPenkov/okayNav","description":"The world's okayest responsive navigation. This is (sort of) a legacy implementation. Please stay tu","owner_id":1693651,"tags":["nav"],"delta":35,"stars":4157,"created_at":"2016-02-15T17:12:47.000Z"},{"name":"Draft.js","url":"https://draftjs.org/","full_name":"facebook/draft-js","description":"A React framework for building text editors.","owner_id":69631,"tags":["rich-text-editor"],"delta":2864,"stars":14663,"created_at":"2016-02-19T20:18:26.000Z","monthly":[203,206,226,250,250,229,218,288,270,278,203,243]},{"name":"Razzle","url":"","full_name":"jaredpalmer/razzle","description":"✨ Create server-rendered universal JavaScript applications with no configuration","owner_id":4060187,"tags":["boilerplate","isomorphic","scaffolding","react"],"delta":3168,"stars":5894,"created_at":"2016-02-10T18:34:27.000Z","monthly":[147,199,251,161,215,231,610,158,224,261,303,408]},{"name":"Claudia.js","url":"https://claudiajs.com","full_name":"claudiajs/claudia","description":"Deploy Node.js projects to AWS Lambda and API Gateway easily","owner_id":17075165,"tags":["microservice","serverless"],"delta":568,"stars":3033,"created_at":"2016-02-05T00:10:57.000Z","twitter":"","monthly":[29,35,31,37,52,41,39,33,65,66,78,62]},{"name":"Adonis","url":"https://adonisjs.com","full_name":"adonisjs/adonis-framework","description":"NodeJs Web Application Framework. Makes it easy for you to write webapps with less code :smiley:","owner_id":13810373,"tags":["nodejs-framework"],"delta":2015,"stars":5392,"created_at":"2015-08-15T17:03:54.000Z","twitter":"adonisframework","monthly":[211,180,142,149,155,170,157,177,172,193,136,173]},{"name":"react-vis","url":"https://uber.github.io/react-vis","full_name":"uber/react-vis","description":"Data Visualization Components","owner_id":538264,"tags":["chart","react"],"delta":2119,"stars":4876,"created_at":"2016-02-22T20:45:50.000Z","monthly":[102,152,194,187,230,136,172,199,163,347,126,111]},{"name":"rebass","url":"https://rebassjs.org","full_name":"rebassjs/rebass","description":":atom_symbol: React primitive UI components built with styled-system.","owner_id":41265750,"tags":["react","component"],"delta":1450,"stars":4807,"created_at":"2015-02-11T14:48:09.000Z","monthly":[83,103,127,225,163,127,139,88,100,102,137,56]},{"name":"Tachyons","url":"https://tachyons.io","full_name":"tachyons-css/tachyons","description":"Functional css for humans","owner_id":15205635,"tags":["css-lib"],"delta":2191,"stars":8311,"created_at":"2013-11-04T10:41:59.000Z","monthly":[157,201,137,146,146,241,141,174,195,233,261,159]},{"name":"Balloon.css","url":"https://kazzkiq.github.io/balloon.css/","full_name":"kazzkiq/balloon.css","description":"Simple tooltips made of pure CSS","owner_id":1953194,"tags":["tooltip"],"delta":305,"stars":4146,"created_at":"2016-03-01T17:52:58.000Z"},{"name":"Hamburgers","url":"https://jonsuh.com/hamburgers","full_name":"jonsuh/hamburgers","description":"Tasty CSS-animated Hamburgers","owner_id":359871,"tags":["icon"],"delta":828,"stars":4832,"created_at":"2016-02-27T02:16:24.000Z","monthly":[63,79,73,60,83,56,58,77,64,68,64,83]},{"name":"interact.js","url":"http://interactjs.io/","full_name":"taye/interact.js","description":"JavaScript drag and drop, resizing and multi-touch gestures with inertia and snapping for modern bro","owner_id":1679746,"tags":["touch","dnd"],"delta":1018,"stars":7781,"created_at":"2012-10-21T10:05:19.000Z","monthly":[88,123,136,60,68,70,62,106,87,79,58,81]},{"name":"Handlebars.js","url":"http://handlebarsjs.com","full_name":"wycats/handlebars.js","description":"Handlebars provides the power necessary to let you build semantic templates effectively with no frus","owner_id":4,"tags":["template"],"delta":1244,"stars":14060,"created_at":"2010-07-31T18:54:46.000Z","monthly":[122,80,84,84,106,96,104,114,132,106,116,100]},{"name":"Cash","url":"","full_name":"kenwheeler/cash","description":"An absurdly small jQuery alternative for modern browsers","owner_id":286616,"tags":["dom"],"delta":561,"stars":3318,"created_at":"2014-09-19T12:47:40.000Z","monthly":[47,42,43,34,41,58,104,77,47,24,23,21]},{"name":"doT","url":"","full_name":"olado/doT","description":"The fastest + concise javascript template engine for nodejs and browsers. Partials, custom delimiter","owner_id":544390,"tags":["template"],"delta":363,"stars":4098,"created_at":"2011-01-10T20:47:04.000Z"},{"name":"Swipe","url":"","full_name":"thebird/Swipe","description":"Swipe is the most accurate touch slider.","owner_id":361414,"tags":["touch"],"delta":226,"stars":6775,"created_at":"2011-04-28T17:57:25.000Z"},{"name":"Popper.js","url":"https://popper.js.org","full_name":"FezVrasta/popper.js","description":"A kickass library to manage your poppers","owner_id":5382443,"tags":["tooltip"],"delta":3609,"stars":10804,"created_at":"2016-03-29T17:00:47.000Z","monthly":[223,250,273,267,245,298,292,298,355,403,355,350]},{"name":"MobX","url":"http://mobx.js.org","full_name":"mobxjs/mobx","description":"Simple, scalable state management.","owner_id":17475736,"tags":["state"],"delta":5271,"stars":17986,"created_at":"2015-03-14T14:31:38.000Z","twitter":"","monthly":[286,316,376,350,438,495,436,481,529,704,413,447]},{"name":"uWebSockets","url":"","full_name":"uNetworking/uWebSockets","description":"Tiny WebSockets","owner_id":28876608,"tags":["realtime","websocket"],"delta":1637,"stars":9964,"created_at":"2016-03-21T04:39:40.000Z","monthly":[96,137,120,87,132,163,124,132,150,144,165,187]},{"name":"Phenomic","url":"https://phenomic.io/","full_name":"phenomic/phenomic","description":"Modular website compiler (React, Webpack, Reason and whatever you want) ⚡️","owner_id":28756976,"tags":["ssg","react"],"delta":365,"stars":3131,"created_at":"2015-09-01T09:40:57.000Z","twitter":"phenomic_app"},{"name":"MassiveJS","url":"","full_name":"dmfay/massive-js","description":"A data mapper for Node.js and PostgreSQL.","owner_id":3075455,"tags":["db"],"delta":531,"stars":2511,"created_at":"2012-04-27T03:25:03.000Z","monthly":[28,26,33,14,34,100,52,40,64,47,32,61]},{"name":"tota11y","url":"http://khan.github.io/tota11y/","full_name":"Khan/tota11y","description":"an accessibility (a11y) visualization toolkit","owner_id":15455,"tags":["access"],"delta":498,"stars":4098,"created_at":"2015-05-11T21:32:32.000Z"},{"name":"mustache.js","url":"http://mustache.github.com/","full_name":"janl/mustache.js","description":"Minimal templating with {{mustaches}} in JavaScript","owner_id":11321,"tags":["template"],"delta":1157,"stars":12722,"created_at":"2009-10-04T23:41:19.000Z","monthly":[76,85,85,89,101,92,98,131,119,101,84,96]},{"name":"Nightwatch","url":"http://nightwatchjs.org","full_name":"nightwatchjs/nightwatch","description":"Automated testing and continuous integration framework based on Node.js and using the Webdriver prot","owner_id":12559275,"tags":["auto"],"delta":1202,"stars":8848,"created_at":"2012-03-17T21:28:18.000Z","monthly":[63,66,88,97,103,116,85,121,102,137,110,114]},{"name":"WebdriverIO","url":"http://webdriver.io","full_name":"webdriverio/webdriverio","description":"Next-gen WebDriver test automation framework for Node.js","owner_id":6512473,"tags":["auto"],"delta":853,"stars":4502,"created_at":"2011-08-30T19:02:35.000Z","monthly":[72,63,51,78,76,65,79,58,88,69,72,82]},{"name":"jsdom","url":"","full_name":"jsdom/jsdom","description":"A JavaScript implementation of the WHATWG DOM and HTML standards, for use with node.js","owner_id":9271229,"tags":["test"],"delta":2401,"stars":11384,"created_at":"2010-01-19T06:55:19.000Z","monthly":[190,188,230,195,202,199,183,219,202,208,176,209]},{"name":"Web Fundamentals","url":"https://developers.google.com/web/fundamentals","full_name":"google/WebFundamentals","description":"Best practices for modern web development","owner_id":1342004,"tags":["learning"],"delta":1530,"stars":9784,"created_at":"2014-04-28T18:45:45.000Z","monthly":[65,67,115,114,206,97,105,195,138,199,137,92]},{"name":"nodemon","url":"http://nodemon.io/","full_name":"remy/nodemon","description":"Monitor for any changes in your node.js application and automatically restart the server - perfect f","owner_id":13700,"tags":["process"],"delta":3878,"stars":16985,"created_at":"2010-10-03T12:50:52.000Z","monthly":[266,337,289,344,314,326,300,328,336,339,302,397]},{"name":"scrape-it","url":"http://ionicabizau.net/blog/30-how-to-write-a-web-scraper-in-node-js","full_name":"IonicaBizau/scrape-it","description":"🔮 A Node.js scraper for humans.","owner_id":2864371,"tags":["scraping"],"delta":370,"stars":3223,"created_at":"2016-04-28T08:41:40.000Z","twitter":""},{"name":"Brain.js","url":"http://brain.js.org","full_name":"BrainJS/brain.js","description":"🤖 Neural networks in JavaScript","owner_id":23732838,"tags":["neural","ml"],"delta":6514,"stars":8561,"created_at":"2016-02-13T18:09:44.000Z","twitter":"","monthly":[1547,156,183,218,314,211,195,248,544,2630,107,161]},{"name":"jspm","url":"https://jspm.org","full_name":"jspm/jspm-cli","description":"Package management CLI","owner_id":3802108,"tags":["module","package"],"delta":36,"stars":3668,"created_at":"2013-03-22T23:20:12.000Z"},{"name":"Plyr","url":"https://plyr.io","full_name":"sampotts/plyr","description":"A simple HTML5, YouTube and Vimeo player","owner_id":719092,"tags":["video"],"delta":2350,"stars":12773,"created_at":"2015-02-14T11:33:07.000Z","monthly":[194,197,217,153,225,184,211,239,266,181,146,137]},{"name":"Horizon","url":"https://horizon.io","full_name":"rethinkdb/horizon","description":"Horizon is a realtime, open-source backend for JavaScript apps.","owner_id":1229647,"tags":["realtime"],"delta":45,"stars":6763,"created_at":"2015-10-28T05:33:14.000Z"},{"name":"PouchDB","url":"https://pouchdb.com/","full_name":"pouchdb/pouchdb","description":":koala: - PouchDB is a pocket-sized database.","owner_id":3406112,"tags":["realtime","db"],"delta":1531,"stars":11456,"created_at":"2010-06-10T18:34:24.000Z","monthly":[107,105,130,107,125,146,125,110,157,146,137,136]},{"name":"date-fns","url":"https://date-fns.org","full_name":"date-fns/date-fns","description":"⏳ Modern JavaScript date utility library ⌛️","owner_id":14921202,"tags":["date"],"delta":7090,"stars":15728,"created_at":"2014-10-06T10:24:22.000Z","monthly":[399,500,678,2035,508,488,569,445,401,337,315,415]},{"name":"Umbrella JS","url":"http://umbrellajs.com/","full_name":"franciscop/umbrella","description":":umbrella: Lightweight javascript library for DOM manipulation and events","owner_id":2801252,"tags":["dom","util"],"delta":651,"stars":1574,"created_at":"2014-10-21T19:19:27.000Z","twitter":"","monthly":[18,13,14,33,463,12,10,19,11,14,13,31],"icon":"umbrella.svg"},{"name":"Push","url":"https://pushjs.org","full_name":"Nickersoft/push.js","description":"The world's most versatile desktop notifications framework :earth_americas:","owner_id":2104129,"tags":["notify"],"delta":680,"stars":7731,"created_at":"2015-07-20T01:46:04.000Z","monthly":[29,46,54,32,57,36,46,42,59,70,138,71]},{"name":"bideo","url":"https://rishabhp.github.io/bideo.js/","full_name":"rishabhp/bideo.js","description":"Fullscreen HTML5 Background Video for the Web.","owner_id":933948,"tags":["video"],"delta":232,"stars":3764,"created_at":"2016-05-16T05:05:42.000Z"},{"name":"Spectre.css","url":"https://picturepan2.github.io/spectre/","full_name":"picturepan2/spectre","description":"Spectre.css - A Lightweight, Responsive and Modern CSS Framework","owner_id":126385,"tags":["css-lib"],"delta":3346,"stars":8799,"created_at":"2016-03-07T11:53:15.000Z","monthly":[209,1575,105,120,89,112,112,150,190,162,138,384]},{"name":"forever","url":"http://github.com/foreverjs/forever","full_name":"foreverjs/forever","description":"A simple CLI tool for ensuring that a given script runs continuously (i.e. forever)","owner_id":10152066,"tags":["process"],"delta":1137,"stars":11749,"created_at":"2010-09-27T15:47:23.000Z","monthly":[67,92,58,84,93,86,85,101,122,121,102,126]},{"name":"redux-actions","url":"https://redux-actions.js.org","full_name":"redux-utilities/redux-actions","description":"Flux Standard Action utilities for Redux.","owner_id":30840905,"tags":["redux"],"delta":1429,"stars":5808,"created_at":"2015-07-01T21:08:45.000Z","monthly":[63,96,89,112,119,208,113,142,109,124,114,140]},{"name":"Redux-Saga","url":"https://redux-saga.js.org/","full_name":"redux-saga/redux-saga","description":"An alternative side effect model for Redux apps","owner_id":24776643,"tags":["redux"],"delta":5010,"stars":16343,"created_at":"2015-11-29T16:58:12.000Z","twitter":"","monthly":[298,370,371,369,447,443,444,472,445,483,387,481]},{"name":"loadtest","url":"","full_name":"alexfernandez/loadtest","description":"Runs a load test on the selected URL. Easy to extend minimally for your own ends.","owner_id":876570,"tags":["test"],"delta":510,"stars":1474,"created_at":"2013-06-21T23:50:01.000Z","monthly":[30,22,30,35,32,44,37,37,52,49,39,103]},{"name":"barba.js","url":"http://barbajs.org","full_name":"luruke/barba.js","description":"Create badass, fluid and smooth transition between your website's pages.","owner_id":61326,"tags":["nav"],"delta":991,"stars":6818,"created_at":"2015-11-12T20:08:53.000Z","monthly":[64,82,74,60,56,86,75,90,129,116,84,75]},{"name":"PhantomJS","url":"http://phantomjs.org","full_name":"ariya/phantomjs","description":"Scriptable Headless Browser","owner_id":7288,"tags":["auto"],"delta":2227,"stars":26414,"created_at":"2010-12-27T08:18:58.000Z","monthly":[112,143,104,111,99,137,165,193,230,376,256,301]},{"name":"SimpleWebRTC","url":"","full_name":"andyet/SimpleWebRTC","description":"Simplest WebRTC ever","owner_id":325865,"tags":["realtime"],"delta":455,"stars":3919,"created_at":"2013-01-23T07:28:01.000Z"},{"name":"Waypoints","url":"http://imakewebthings.com/waypoints/","full_name":"imakewebthings/waypoints","description":"Waypoints is a library that makes it easy to execute a function whenever you scroll to an element.","owner_id":406639,"tags":["scrolling"],"delta":582,"stars":9611,"created_at":"2011-01-25T07:46:22.000Z","monthly":[31,36,36,52,47,45,34,67,59,69,40,66]},{"name":"lazy.js","url":"http://danieltao.com/lazy.js/","full_name":"dtao/lazy.js","description":"Like Underscore, but lazier","owner_id":409328,"tags":["util"],"delta":967,"stars":5490,"created_at":"2013-05-10T14:33:46.000Z","monthly":[50,34,44,97,54,193,279,66,40,38,32,40]},{"name":"Choo","url":"https://choo.io/","full_name":"choojs/choo","description":":steam_locomotive::train: - sturdy 4kb frontend framework","owner_id":29929674,"tags":["framework"],"delta":947,"stars":5857,"created_at":"2016-05-10T17:50:35.000Z","monthly":[48,54,63,43,55,100,65,98,85,83,114,139]},{"name":"Algolia Places","url":"https://community.algolia.com/places/","full_name":"algolia/places","description":":globe_with_meridians: Turn any <input> into an address autocomplete","owner_id":2034458,"tags":["map","autocomplete"],"delta":385,"stars":4603,"created_at":"2016-03-22T09:01:46.000Z"},{"name":"flatpickr","url":"https://flatpickr.js.org","full_name":"flatpickr/flatpickr","description":"lightweight, powerful javascript datetimepicker with no dependencies","owner_id":36319609,"tags":["plugin","date"],"delta":1773,"stars":11040,"created_at":"2015-08-10T23:52:45.000Z","monthly":[106,159,152,188,156,134,142,132,134,146,152,172]},{"name":"anime.js","url":"http://animejs.com","full_name":"juliangarnier/anime","description":"JavaScript Animation Engine","owner_id":1268691,"tags":["animation"],"delta":7228,"stars":25187,"created_at":"2016-03-13T21:37:45.000Z","monthly":[484,531,507,449,796,686,824,532,668,585,504,662]},{"name":"Grommet","url":"https://grommet.io","full_name":"grommet/grommet","description":"a react-based framework that provides accessibility, modularity, responsiveness, and theming in a ti","owner_id":14203820,"tags":["react","component"],"delta":1353,"stars":4124,"created_at":"2015-03-24T08:54:10.000Z","monthly":[128,152,171,55,86,105,99,102,109,136,86,124]},{"name":"NativeBase","url":"https://nativebase.io/","full_name":"GeekyAnts/NativeBase","description":"Essential cross-platform UI components for React Native","owner_id":18482943,"tags":["react-native","mobile"],"delta":3781,"stars":11008,"created_at":"2016-04-15T11:37:23.000Z","monthly":[213,241,243,337,345,265,367,325,371,401,295,378]},{"name":"LokiJS","url":"http://lokijs.org","full_name":"techfort/LokiJS","description":"javascript embeddable / in-memory database","owner_id":4130173,"tags":["db"],"delta":728,"stars":4547,"created_at":"2013-07-25T07:39:20.000Z","monthly":[51,53,64,71,53,69,46,67,54,56,71,73]},{"name":"debug","url":"","full_name":"visionmedia/debug","description":"A tiny JavaScript debugging utility modelled after Node.js core's debugging technique. Works in Node","owner_id":9285252,"tags":["debug","log"],"delta":1764,"stars":7160,"created_at":"2011-11-29T02:23:54.000Z","monthly":[117,147,161,120,128,131,127,164,166,213,136,154]},{"name":"Node-tap","url":"https://www.node-tap.org/","full_name":"tapjs/node-tap","description":"Test Anything Protocol tools for node","owner_id":16528145,"tags":["test-framework","test"],"delta":140,"stars":1290,"created_at":"2011-03-21T18:02:54.000Z"},{"name":"Helmet","url":"https://helmetjs.github.io/","full_name":"helmetjs/helmet","description":"Help secure Express apps with various HTTP headers","owner_id":8338613,"tags":["express","middleware"],"delta":1377,"stars":5485,"created_at":"2012-02-01T22:54:45.000Z","twitter":"","monthly":[97,109,123,101,141,128,92,129,93,135,99,130]},{"name":"You Don't Need JavaScript","url":"","full_name":"you-dont-need/You-Dont-Need-JavaScript","description":"CSS is powerful, you can do a lot of things without JS.","owner_id":21141794,"tags":["learning"],"delta":1742,"stars":11356,"created_at":"2016-07-05T07:30:42.000Z","monthly":[121,78,179,652,77,82,70,107,100,108,94,74]},{"name":"Slate","url":"http://slatejs.org","full_name":"ianstormtaylor/slate","description":"A completely customizable framework for building rich text editors.","owner_id":311752,"tags":["rich-text-editor"],"delta":6505,"stars":12807,"created_at":"2016-06-18T01:52:42.000Z","twitter":"","monthly":[576,2668,449,600,359,340,189,280,291,287,192,274],"icon":"slate.png"},{"name":"Hyper","url":"https://hyper.is","full_name":"zeit/hyper","description":"A terminal built on web technologies","owner_id":14985020,"tags":["cli"],"delta":6273,"stars":26900,"created_at":"2016-07-01T06:01:21.000Z","monthly":[454,385,351,346,433,485,595,841,924,492,413,554]},{"name":"cleave.js","url":"http://nosir.github.io/cleave.js","full_name":"nosir/cleave.js","description":"Format input text content when you are typing...","owner_id":352617,"tags":["plugin"],"delta":1516,"stars":9281,"created_at":"2016-05-18T12:45:03.000Z","monthly":[176,104,106,89,123,117,99,142,130,142,119,169]},{"name":"lightgallery.js","url":"https://sachinchoolur.github.io/lightgallery.js/","full_name":"sachinchoolur/lightgallery.js","description":"Full featured JavaScript image & video gallery. No dependencies","owner_id":6586706,"tags":["viewer"],"delta":417,"stars":4164,"created_at":"2016-08-01T04:19:56.000Z"},{"name":"Create React App","url":"https://facebook.github.io/create-react-app/","full_name":"facebook/create-react-app","description":"Set up a modern web app by running one command.","owner_id":69631,"tags":["boilerplate","react","serviceworker"],"delta":21235,"stars":61640,"created_at":"2016-07-17T14:55:11.000Z","twitter":"","monthly":[1383,1449,2107,1769,1538,1702,1648,1833,1790,1979,1714,2323]},{"name":"React Server","url":"https://react-server.io/","full_name":"redfin/react-server","description":":rocket: Blazing fast page load and seamless navigation.","owner_id":6288468,"tags":["boilerplate","isomorphic","react"],"delta":305,"stars":3790,"created_at":"2016-02-09T19:20:35.000Z"},{"name":"in-view","url":"https://camwiegert.github.io/in-view","full_name":"camwiegert/in-view","description":"Get notified when a DOM element enters or exits the viewport. :eyes:","owner_id":2547860,"tags":["scrolling"],"delta":382,"stars":4336,"created_at":"2016-08-02T14:06:34.000Z"},{"name":"Text Mask","url":"https://text-mask.github.io/text-mask/","full_name":"text-mask/text-mask","description":"Input mask for React, Angular, Ember, Vue, & plain JavaScript","owner_id":21117230,"tags":["plugin"],"delta":4110,"stars":6585,"created_at":"2016-01-22T23:19:59.000Z","monthly":[71,156,102,164,103,128,130,473,2501,96,99,87]},{"name":"Fuse.js","url":"http://fusejs.io/","full_name":"krisk/Fuse","description":"Lightweight fuzzy-search, in JavaScript","owner_id":565580,"tags":["search"],"delta":1858,"stars":7279,"created_at":"2012-05-28T04:31:06.000Z","monthly":[212,168,150,131,183,169,142,151,146,154,131,121]},{"name":"react-game-kit","url":"http://reactnext.surge.sh","full_name":"FormidableLabs/react-game-kit","description":"Component library for making games with React  & React Native","owner_id":5078602,"tags":["game","react"],"delta":688,"stars":3997,"created_at":"2016-09-15T07:46:01.000Z","monthly":[19,21,41,39,47,58,42,56,84,98,103,80]},{"name":"Matter.js","url":"","full_name":"liabru/matter-js","description":"a 2D rigid body physics engine for the web ▲● ■","owner_id":654420,"tags":["game"],"delta":1536,"stars":8036,"created_at":"2014-02-19T14:16:17.000Z","monthly":[116,105,143,127,162,201,122,138,107,116,78,121]},{"name":"StdLib","url":"https://stdlib.com","full_name":"stdlib/lib","description":"StdLib API Development, Deployment, and Management Tools","owner_id":25233216,"tags":["microservice","serverless"],"delta":511,"stars":3506,"created_at":"2016-08-08T11:27:43.000Z","twitter":"","monthly":[21,24,31,13,31,34,60,36,30,64,87,80]},{"name":"JsBarcode","url":"http://lindell.me/JsBarcode","full_name":"lindell/JsBarcode","description":"Barcode generation library written in JavaScript that works in both the browser and on Node.js","owner_id":284868,"tags":["canvas"],"delta":791,"stars":2382,"created_at":"2011-12-29T15:38:35.000Z","monthly":[61,79,65,43,73,81,74,90,61,59,37,68]},{"name":"Vuex","url":"https://vuex.vuejs.org","full_name":"vuejs/vuex","description":"🗃️ Centralized State Management for Vue.js.","owner_id":6128107,"tags":["flux","vue","state"],"delta":6471,"stars":18456,"created_at":"2015-07-16T04:21:26.000Z","monthly":[422,442,440,457,486,640,642,574,687,587,464,630]},{"name":"Aphrodite","url":"","full_name":"Khan/aphrodite","description":"Framework-agnostic CSS-in-JS with support for server-side rendering, browser prefixing, and minimum ","owner_id":15455,"tags":["css-in-js"],"delta":706,"stars":4486,"created_at":"2015-10-07T02:31:35.000Z","monthly":[46,35,46,30,62,77,55,79,77,65,55,79]},{"name":"Marko","url":"https://markojs.com/","full_name":"marko-js/marko","description":"A friendly (and fast!) UI library from eBay that makes building web apps fun","owner_id":11873696,"tags":["template"],"delta":2148,"stars":7954,"created_at":"2014-01-07T23:58:21.000Z","monthly":[209,251,219,256,281,309,122,98,131,81,74,117]},{"name":"snabbdom","url":"","full_name":"snabbdom/snabbdom","description":"A virtual DOM library with focus on simplicity, modularity, powerful features and performance.","owner_id":22341607,"tags":["vdom"],"delta":1763,"stars":4903,"created_at":"2015-05-09T20:25:10.000Z","monthly":[133,139,152,213,195,146,179,167,164,157,61,57]},{"name":"React Styleguidist","url":"https://react-styleguidist.js.org/","full_name":"styleguidist/react-styleguidist","description":"Isolated React component development environment with a living style guide","owner_id":23550189,"tags":["react","styleguide"],"delta":2718,"stars":6284,"created_at":"2015-09-07T05:30:30.000Z","monthly":[152,199,234,190,202,234,228,249,272,356,203,199]},{"name":"Lowdb","url":"","full_name":"typicode/lowdb","description":"⚡️ lowdb is a small local JSON database powered by Lodash (supports Node, Electron and the browser)","owner_id":5502029,"tags":["db","filesystem"],"delta":2653,"stars":9401,"created_at":"2014-04-02T02:16:06.000Z","twitter":"","monthly":[198,166,222,186,217,180,194,235,180,200,199,476]},{"name":"electron-builder","url":"https://www.electron.build","full_name":"electron-userland/electron-builder","description":"A complete solution to package and build a ready for distribution Electron app with “auto update” su","owner_id":17519142,"tags":["desktop"],"delta":2131,"stars":6211,"created_at":"2015-05-21T07:45:02.000Z","monthly":[174,192,135,162,174,206,159,184,199,175,178,193]},{"name":"Netlify CMS","url":"https://www.netlifycms.org","full_name":"netlify/netlify-cms","description":"A CMS for Static Site Generators","owner_id":7892489,"tags":["cms"],"delta":3278,"stars":7211,"created_at":"2015-01-20T05:47:47.000Z","monthly":[293,235,265,193,287,250,254,271,402,347,238,243]},{"name":"Apostrophe","url":"http://apostrophecms.org/","full_name":"apostrophecms/apostrophe","description":"A CMS framework for Node.js that supports in-context editing, schema-driven content types, flexible ","owner_id":12648958,"tags":["cms"],"delta":624,"stars":2482,"created_at":"2013-02-08T20:04:02.000Z","monthly":[32,46,62,41,41,56,52,52,50,49,54,89]},{"name":"Prose","url":"http://prose.io","full_name":"prose/prose","description":"A Content Editor for GitHub.","owner_id":1801942,"tags":["cms"],"delta":226,"stars":4126,"created_at":"2012-03-08T23:32:29.000Z"},{"name":"hotel","url":"","full_name":"typicode/hotel","description":"🏩 A simple process manager for developers. Start apps from your browser and access them using local","owner_id":5502029,"tags":["cli"],"delta":1050,"stars":8098,"created_at":"2015-05-27T08:24:07.000Z","monthly":[81,72,112,84,75,94,63,96,75,100,68,130]},{"name":"core-js","url":"","full_name":"zloirock/core-js","description":"Standard Library","owner_id":2213682,"tags":["compatibility"],"delta":1961,"stars":7289,"created_at":"2013-07-17T16:32:27.000Z","monthly":[131,157,147,137,157,163,158,196,188,168,123,236]},{"name":"Angular","url":"https://angular.io","full_name":"angular/angular","description":"One framework. Mobile & desktop.","owner_id":139426,"tags":["framework","angular"],"delta":12398,"stars":44062,"created_at":"2014-09-18T16:12:01.000Z","twitter":"angular","monthly":[766,964,1057,1004,1079,1186,1121,1049,1119,1012,968,1073],"icon":"angular.svg"},{"name":"Front-end Job Interview Questions","url":"http://h5bp.github.io/Front-end-Developer-Interview-Questions/","full_name":"h5bp/Front-end-Developer-Interview-Questions","description":"A list of helpful front-end related questions you can use to interview potential candidates, test yo","owner_id":1136800,"tags":["learning"],"delta":7142,"stars":38666,"created_at":"2012-02-09T23:34:10.000Z","monthly":[396,383,465,583,564,469,470,594,637,878,1112,591]},{"name":"JS assessment","url":"","full_name":"rmurphey/js-assessment","description":"A test-driven approach to assessing JS skills","owner_id":58987,"tags":["learning"],"delta":269,"stars":4843,"created_at":"2012-04-11T16:32:36.000Z"},{"name":"react-markdown","url":"https://rexxars.github.io/react-markdown/","full_name":"rexxars/react-markdown","description":"Render Markdown as React components","owner_id":48200,"tags":["md","react"],"delta":1447,"stars":3042,"created_at":"2015-05-18T23:59:17.000Z","monthly":[111,134,126,117,131,142,126,141,98,120,96,105]},{"name":"knex.js","url":"knexjs.org","full_name":"tgriesser/knex","description":"A query builder for PostgreSQL, MySQL and SQLite3, designed to be flexible, portable, and fun to use","owner_id":154748,"tags":["db"],"delta":2626,"stars":8569,"created_at":"2012-12-29T05:18:25.000Z","monthly":[215,231,215,170,210,244,230,200,275,221,213,202]},{"name":"PDF.js","url":"","full_name":"mozilla/pdf.js","description":"PDF Reader in JavaScript","owner_id":131524,"tags":["pdf"],"delta":4372,"stars":24916,"created_at":"2011-04-26T06:32:03.000Z","monthly":[446,423,358,373,335,327,323,393,363,373,294,364]},{"name":"jsPDF","url":"https://parall.ax/products/jspdf","full_name":"MrRio/jsPDF","description":"Client-side JavaScript PDF generation for everyone.","owner_id":47539,"tags":["pdf"],"delta":5509,"stars":15426,"created_at":"2009-12-06T14:56:32.000Z","monthly":[2768,216,256,248,253,304,256,295,227,233,185,268]},{"name":"p5","url":"http://p5js.org/","full_name":"processing/p5.js","description":"p5.js is a client-side JS platform that empowers artists, designers, students, and anyone to learn t","owner_id":1617169,"tags":["drawing","canvas","3d"],"delta":2345,"stars":9376,"created_at":"2013-02-26T03:14:47.000Z","monthly":[223,153,177,157,146,141,168,213,223,242,221,281]},{"name":"Yarn","url":"https://yarnpkg.com","full_name":"yarnpkg/yarn","description":"📦🐈 Fast, reliable, and secure dependency management.","owner_id":22247014,"tags":["package"],"delta":4775,"stars":34278,"created_at":"2016-01-19T17:39:16.000Z","monthly":[299,336,305,346,369,364,363,429,463,492,493,516]},{"name":"Lerna","url":"https://lernajs.io","full_name":"lerna/lerna","description":":dragon: A tool for managing JavaScript projects with multiple packages.","owner_id":19333396,"tags":["package"],"delta":6669,"stars":14089,"created_at":"2015-12-04T09:36:55.000Z","monthly":[518,586,556,659,880,491,504,486,520,504,458,507]},{"name":"Tesseract.js","url":"http://tesseract.projectnaptha.com/","full_name":"naptha/tesseract.js","description":"Pure Javascript OCR for 62 Languages 📖🎉🖥","owner_id":7720173,"tags":["image"],"delta":1946,"stars":14749,"created_at":"2015-06-24T02:49:52.000Z","monthly":[155,144,157,159,157,143,170,192,179,189,150,151]},{"name":"Styled Components","url":"https://styled-components.com","full_name":"styled-components/styled-components","description":"Visual primitives for the component age. Use the best bits of ES6 and CSS to style your apps without","owner_id":20658825,"tags":["css-in-js"],"delta":8942,"stars":21306,"created_at":"2016-08-16T06:41:32.000Z","monthly":[586,616,674,636,696,673,729,774,811,813,738,1196]},{"name":"Ajv: Another JSON Schema Validator","url":"https://ajv.js.org","full_name":"epoberezkin/ajv","description":"The fastest JSON Schema Validator. Supports draft-04/06/07","owner_id":2769109,"tags":["json","validation"],"delta":2023,"stars":4826,"created_at":"2015-05-19T23:23:32.000Z","monthly":[182,195,182,168,153,199,140,141,158,164,160,181]},{"name":"Gun","url":"https://gun.eco/docs","full_name":"amark/gun","description":"A realtime, decentralized, offline-first, mutable graph database engine.","owner_id":433412,"tags":["db","realtime","nodejs-framework"],"delta":2415,"stars":9443,"created_at":"2014-07-31T15:52:10.000Z","twitter":"","monthly":[258,141,107,133,216,248,159,182,145,357,218,251],"icon":"gun.svg"},{"name":"TestCafe","url":"https://devexpress.github.io/testcafe/","full_name":"DevExpress/testcafe","description":"A Node.js tool to automate end-to-end web testing.","owner_id":4243232,"tags":["auto"],"delta":2128,"stars":5949,"created_at":"2015-04-20T13:43:28.000Z","monthly":[138,171,150,162,162,188,207,180,157,195,272,146]},{"name":"Node-RED","url":"http://nodered.org","full_name":"node-red/node-red","description":"A visual tool for wiring the Internet of Things","owner_id":5375661,"tags":["iot"],"delta":1654,"stars":6990,"created_at":"2013-09-05T13:30:47.000Z","monthly":[140,160,146,120,120,110,115,151,128,161,149,154]},{"name":"WebTorrent","url":"https://webtorrent.io","full_name":"webtorrent/webtorrent","description":"⚡️ Streaming torrent client for the web","owner_id":5800008,"tags":["webrtc"],"delta":3066,"stars":18490,"created_at":"2013-10-15T08:16:40.000Z","monthly":[278,176,211,175,302,227,282,265,276,289,244,341]},{"name":"vux","url":"https://vux.li/","full_name":"airyland/vux","description":"Mobile UI Components based on Vue & WeUI","owner_id":559179,"tags":["vue"],"delta":4167,"stars":14896,"created_at":"2016-02-15T03:23:27.000Z","monthly":[249,246,225,282,297,366,450,486,532,396,235,403]},{"name":"React Redux Starter Kit","url":"","full_name":"davezuko/react-redux-starter-kit","description":"Get started with React, Redux, and React-Router.","owner_id":6439050,"tags":["boilerplate","redux","react"],"delta":487,"stars":10397,"created_at":"2015-06-24T18:38:28.000Z","monthly":[-2,11,19,17,30,51,57,42,75,47,68,72]},{"name":"Next.js","url":"https://nextjs.org","full_name":"zeit/next.js","description":"The React Framework","owner_id":14985020,"tags":["isomorphic","react","nodejs-framework","ssg"],"delta":12615,"stars":33219,"created_at":"2016-10-05T23:32:51.000Z","twitter":"","monthly":[1037,961,1173,1258,908,939,914,1049,918,992,964,1502],"icon":"nextjs.svg"},{"name":"Glamor","url":"","full_name":"threepointone/glamor","description":"inline css for react et al","owner_id":18808,"tags":["css-in-js"],"delta":584,"stars":3395,"created_at":"2016-07-18T11:25:39.000Z","monthly":[41,35,23,14,33,46,30,64,71,71,73,83]},{"name":"flv.js","url":"","full_name":"Bilibili/flv.js","description":"HTML5 FLV Player","owner_id":12002442,"tags":["video"],"delta":2876,"stars":13783,"created_at":"2016-05-12T08:34:31.000Z","monthly":[182,196,175,258,313,335,220,213,184,386,161,253]},{"name":"Flow","url":"https://flow.org/","full_name":"facebook/flow","description":"Adds static typing to JavaScript to improve developer productivity and code quality.","owner_id":69631,"tags":["compiler","types"],"delta":3810,"stars":18671,"created_at":"2014-10-28T17:17:45.000Z","twitter":"flowtype","monthly":[210,253,254,318,313,318,350,333,333,393,344,391],"icon":"flow.svg"},{"name":"Storybook","url":"https://storybook.js.org","full_name":"storybooks/storybook","description":"Interactive UI component dev & test: React, React Native, Vue, Angular, Ember","owner_id":22632046,"tags":["react","vue","angular","test"],"delta":15061,"stars":32616,"created_at":"2016-03-18T04:23:44.000Z","twitter":"storybookjs","monthly":[909,1235,1311,1151,1265,1162,982,1182,1240,1295,1138,2191]},{"name":"JavaScript Cookie","url":"","full_name":"js-cookie/js-cookie","description":"A simple, lightweight JavaScript API for handling browser cookies","owner_id":11557446,"tags":["util"],"delta":3507,"stars":11615,"created_at":"2015-03-19T15:57:47.000Z","monthly":[274,294,279,255,303,308,250,347,329,330,249,289]},{"name":"vue-router","url":"http://router.vuejs.org/","full_name":"vuejs/vue-router","description":"🚦 The official router for Vue.js.","owner_id":6128107,"tags":["vue","routing"],"delta":4113,"stars":12391,"created_at":"2013-12-11T19:37:46.000Z","monthly":[291,310,334,327,306,382,393,322,375,368,276,429]},{"name":"JavaScript Stack from Scratch","url":"","full_name":"verekia/js-stack-from-scratch","description":"🛠️⚡ Step-by-step tutorial to build a modern JavaScript stack.","owner_id":522007,"tags":["learning"],"delta":1104,"stars":17719,"created_at":"2016-10-02T13:31:23.000Z","monthly":[53,46,83,63,74,107,95,101,121,110,118,133]},{"name":"Whitestorm.js","url":"https://whs.io","full_name":"WhitestormJS/whs.js","description":":rocket: 🌪 Super-fast 3D framework for Web Applications 🥇 & Games 🎮. Based on Three.js","owner_id":16437392,"tags":["3d"],"delta":452,"stars":5063,"created_at":"2015-08-30T10:29:14.000Z"},{"name":"Botkit","url":"http://botkit.ai","full_name":"howdyai/botkit","description":"Botkit is the leading developer tool for building chat bots, apps and custom integrations for major ","owner_id":16260958,"tags":["bot"],"delta":1257,"stars":8810,"created_at":"2015-12-11T21:21:12.000Z","monthly":[52,107,86,69,75,107,93,123,116,131,148,150]},{"name":"Blueprint","url":"https://blueprintjs.com/","full_name":"palantir/blueprint","description":"A React-based UI toolkit for the web","owner_id":303157,"tags":["react","component"],"delta":4938,"stars":12911,"created_at":"2016-10-25T21:17:50.000Z","monthly":[255,321,1162,338,753,349,261,315,334,367,217,266]},{"name":"Element","url":"https://element.eleme.io/","full_name":"ElemeFE/element","description":"A Vue.js 2.0 UI Toolkit for Web","owner_id":12810740,"tags":["vue","component"],"delta":12395,"stars":34031,"created_at":"2016-09-03T06:19:26.000Z","monthly":[872,882,795,993,996,1067,1066,1197,1101,1238,838,1350]},{"name":"AlloyFinger","url":"http://alloyteam.github.io/AlloyFinger/","full_name":"AlloyTeam/AlloyFinger","description":"super tiny size multi-touch gestures library for the web. 　　　You can touch this →","owner_id":1503033,"tags":["touch"],"delta":541,"stars":2679,"created_at":"2016-05-25T23:17:03.000Z","monthly":[38,51,35,32,36,31,57,41,50,56,55,59]},{"name":"pino","url":"http://getpino.io","full_name":"pinojs/pino","description":"🌲 super fast, all natural json logger 🌲","owner_id":23048140,"tags":["log"],"delta":1267,"stars":3459,"created_at":"2016-02-16T14:14:29.000Z","monthly":[138,81,92,128,120,84,97,109,113,121,80,104]},{"name":"realm","url":"https://realm.io","full_name":"realm/realm-js","description":" Realm is a mobile database: an alternative to SQLite & key-value stores","owner_id":7575099,"tags":["db"],"delta":777,"stars":3309,"created_at":"2015-08-13T15:51:36.000Z","monthly":[70,57,45,55,71,71,57,69,66,67,59,90]},{"name":"Clarity Design System","url":"http://clarity.design","full_name":"vmware/clarity","description":"UX guidelines, HTML/CSS framework, and Angular components working together to craft exceptional expe","owner_id":473334,"tags":["angular"],"delta":1576,"stars":4410,"created_at":"2016-09-29T17:24:17.000Z","monthly":[135,90,81,94,121,121,170,188,185,132,106,153]},{"name":"deck.gl","url":"http://uber.github.io/deck.gl","full_name":"uber/deck.gl","description":"WebGL2 powered geospatial visualization layers","owner_id":538264,"tags":["webgl"],"delta":1531,"stars":5487,"created_at":"2015-12-15T08:38:29.000Z","monthly":[106,121,102,120,132,136,184,203,103,99,93,132]},{"name":"markdown-it","url":"https://markdown-it.github.io","full_name":"markdown-it/markdown-it","description":"Markdown parser, done right. 100% CommonMark support, extensions, syntax plugins & high speed","owner_id":10248321,"tags":["md"],"delta":1963,"stars":6579,"created_at":"2014-12-19T22:54:53.000Z","monthly":[156,147,142,146,166,188,157,211,227,141,142,140]},{"name":"remark","url":"https://remark.js.org","full_name":"remarkjs/remark","description":"markdown processor powered by plugins part of the @unifiedjs collective","owner_id":16309564,"tags":["md"],"delta":709,"stars":1943,"created_at":"2014-07-28T19:35:14.000Z","monthly":[61,101,60,40,58,50,65,73,63,45,36,57]},{"name":"React Sortable","url":"http://clauderic.github.io/react-sortable-hoc/","full_name":"clauderic/react-sortable-hoc","description":"A set of higher-order components to turn any list into an animated, touch-friendly, sortable list ✌️","owner_id":1416436,"tags":["dnd","react"],"delta":2293,"stars":5894,"created_at":"2016-06-08T03:11:35.000Z","monthly":[146,168,171,120,184,152,195,156,168,189,170,474]},{"name":"dva","url":"https://dvajs.com/","full_name":"dvajs/dva","description":"🌱 React and redux based, lightweight and elm-style framework. (Inspired by elm and choo)","owner_id":20552239,"tags":["framework","redux"],"delta":4799,"stars":12067,"created_at":"2016-06-24T09:06:16.000Z","monthly":[284,256,267,280,365,378,417,576,512,539,324,601]},{"name":"Svelte","url":"https://svelte.technology","full_name":"sveltejs/svelte","description":"The magical disappearing UI framework","owner_id":23617963,"tags":["framework"],"delta":2963,"stars":8752,"created_at":"2016-11-20T18:13:05.000Z","monthly":[141,334,150,172,286,308,262,142,238,261,116,553]},{"name":"vuelidate","url":"https://monterail.github.io/vuelidate/","full_name":"monterail/vuelidate","description":"Simple, lightweight model-based validation for Vue.js","owner_id":234138,"tags":["vue","form"],"delta":1513,"stars":3246,"created_at":"2016-11-05T14:30:37.000Z","monthly":[143,88,130,129,163,127,114,164,124,120,127,84]},{"name":"RxDB","url":"https://rxdb.info/","full_name":"pubkey/rxdb","description":":computer: :iphone: A realtime Database for the Web","owner_id":8926560,"tags":["db","realtime"],"delta":2335,"stars":8494,"created_at":"2016-12-02T19:34:42.000Z","twitter":"","monthly":[69,99,226,1183,87,93,77,97,121,86,79,118],"icon":"rxdb.svg"},{"name":"Styled JSX","url":"","full_name":"zeit/styled-jsx","description":"Full CSS support for JSX without compromises","owner_id":14985020,"tags":["css-in-js"],"delta":1395,"stars":3962,"created_at":"2016-12-05T13:58:02.000Z","monthly":[106,108,107,91,113,133,85,197,85,89,114,167]},{"name":"JSS","url":"https://cssinjs.org","full_name":"cssinjs/jss","description":"JSS is an authoring tool for CSS which uses JavaScript as a host language.","owner_id":9503099,"tags":["css-in-js"],"delta":1503,"stars":4452,"created_at":"2014-10-12T20:33:53.000Z","monthly":[128,112,111,96,116,151,122,169,131,117,104,146]},{"name":"PullToRefresh.js","url":"http://boxfactura.com/pulltorefresh.js/","full_name":"BoxFactura/pulltorefresh.js","description":"A quick and powerful plugin for your pull-to-refresh needs in your webapp.","owner_id":17629776,"tags":["touch"],"delta":1789,"stars":3346,"created_at":"2016-11-04T00:21:40.000Z","monthly":[22,17,27,21,34,75,1486,28,27,22,7,23]},{"name":"scrollMonitor","url":"","full_name":"stutrek/scrollMonitor","description":"A simple and fast API to monitor elements as you scroll","owner_id":339327,"tags":["scrolling"],"delta":426,"stars":3010,"created_at":"2013-01-08T16:26:16.000Z"},{"name":"json-schema-faker","url":"http://json-schema-faker.js.org/","full_name":"json-schema-faker/json-schema-faker","description":"JSON-Schema + fake data generators","owner_id":13982985,"tags":["random","json","test"],"delta":520,"stars":1635,"created_at":"2014-10-07T22:23:13.000Z","monthly":[39,43,34,26,43,51,44,41,48,44,60,47]},{"name":"Chance","url":"http://chancejs.com","full_name":"chancejs/chancejs","description":"Chance - Random generator helper for JavaScript","owner_id":17460423,"tags":["random"],"delta":1383,"stars":4239,"created_at":"2013-06-20T20:26:22.000Z","monthly":[62,53,52,120,97,258,489,73,43,55,37,44]},{"name":"faker.js","url":"","full_name":"Marak/faker.js","description":"generate massive amounts of realistic fake data in Node.js and the browser","owner_id":70011,"tags":["random"],"delta":4355,"stars":16924,"created_at":"2010-05-15T00:53:07.000Z","monthly":[466,420,360,280,289,335,331,351,400,383,314,426]},{"name":"Voca","url":"https://vocajs.com","full_name":"panzerdp/voca","description":"The ultimate JavaScript string library","owner_id":1078719,"tags":["string"],"delta":601,"stars":2473,"created_at":"2016-03-23T15:10:11.000Z","monthly":[35,26,27,41,54,140,187,28,9,15,15,24]},{"name":"Vuetify","url":"https://vuetifyjs.com","full_name":"vuetifyjs/vuetify","description":"🐉 Material Component Framework for Vue.js 2","owner_id":22138497,"tags":["vue","material"],"delta":8245,"stars":15774,"created_at":"2016-09-12T00:39:35.000Z","twitter":"vuetifyjs","monthly":[674,648,634,765,585,698,762,688,647,689,700,755]},{"name":"Material Components","url":"https://material.io/develop/","full_name":"material-components/material-components-web","description":"Modular and customizable Material Design UI components for the web","owner_id":19478152,"tags":["material","css-lib"],"delta":4115,"stars":11279,"created_at":"2016-12-05T16:04:09.000Z","monthly":[270,212,279,295,314,335,366,858,293,253,344,296]},{"name":"Pigeon Maps","url":"https://pigeon-maps.js.org/","full_name":"mariusandra/pigeon-maps","description":"ReactJS Maps without external dependencies","owner_id":53387,"tags":["map","react"],"delta":2316,"stars":2770,"created_at":"2016-12-16T13:55:49.000Z","monthly":[13,15,102,2166,6,1,1,1,4,0,3,4]},{"name":"react-dates","url":"http://airbnb.io/react-dates","full_name":"airbnb/react-dates","description":"An easily internationalizable, mobile-friendly datepicker library for the web","owner_id":698437,"tags":["date","react"],"delta":2763,"stars":8754,"created_at":"2016-05-04T00:49:45.000Z","monthly":[129,117,143,217,176,224,189,267,687,208,180,226]},{"name":"Lighthouse","url":"https://developers.google.com/web/tools/lighthouse/","full_name":"GoogleChrome/lighthouse","description":"Auditing, performance metrics, and best practices for Progressive Web Apps","owner_id":1778935,"tags":["performance"],"delta":3842,"stars":15644,"created_at":"2016-03-08T01:03:11.000Z","monthly":[231,378,229,305,258,302,246,401,319,344,351,478]},{"name":"Nuclide","url":"https://nuclide.io","full_name":"facebookarchive/nuclide","description":"An open IDE for web and native mobile development, built on top of Atom ","owner_id":7560860,"tags":["ide"],"delta":647,"stars":7987,"created_at":"2015-03-02T05:25:27.000Z","twitter":"","monthly":[12,24,44,44,50,60,56,70,78,81,69,59],"icon":"nuclide.svg"},{"name":"FuseBox","url":"http://fuse-box.org","full_name":"fuse-box/fuse-box","description":"A blazing fast js bundler/loader with a comprehensive API :fire:","owner_id":23119087,"tags":["module","build"],"delta":579,"stars":3600,"created_at":"2016-10-28T10:37:16.000Z","monthly":[29,55,26,47,25,35,20,39,44,53,73,133]},{"name":"React Native for Web","url":"https://necolas.github.io/react-native-web/examples","full_name":"necolas/react-native-web","description":"React Native for Web","owner_id":239676,"tags":["react-native","component"],"delta":4374,"stars":11553,"created_at":"2015-06-09T19:25:38.000Z","monthly":[316,304,317,314,287,305,406,526,395,461,370,373]},{"name":"nyc","url":"https://istanbul.js.org/","full_name":"istanbuljs/nyc","description":"the Istanbul command line interface","owner_id":13523395,"tags":["test"],"delta":953,"stars":3104,"created_at":"2015-05-09T02:55:45.000Z","monthly":[46,60,82,52,86,80,86,95,85,104,92,85]},{"name":"Vulcan","url":"http://vulcanjs.org","full_name":"VulcanJS/Vulcan","description":"🌋 A toolkit to quickly build apps with React, GraphQL & Meteor","owner_id":6634779,"tags":["realtime","meteor","graphql","nodejs-framework"],"delta":823,"stars":7274,"created_at":"2012-09-07T01:13:24.000Z","twitter":"vulcanjs","monthly":[92,95,57,55,51,55,46,64,52,64,96,96]},{"name":"Vue material","url":"http://vuematerial.io","full_name":"vuematerial/vue-material","description":"Material design for Vue.js","owner_id":23659108,"tags":["vue","material"],"delta":2307,"stars":7449,"created_at":"2016-06-17T22:41:53.000Z","monthly":[132,140,157,170,196,193,236,227,209,231,150,266]},{"name":"vue-resource","url":"","full_name":"pagekit/vue-resource","description":"The HTTP client for Vue.js","owner_id":510472,"tags":["vue","http"],"delta":1563,"stars":8893,"created_at":"2014-02-07T23:07:56.000Z","monthly":[94,101,136,88,104,150,120,141,170,176,113,170]},{"name":"vue-i18n","url":"https://kazupon.github.io/vue-i18n/","full_name":"kazupon/vue-i18n","description":":globe_with_meridians: Internationalization plugin for Vue.js","owner_id":72989,"tags":["vue","i18n"],"delta":1810,"stars":3743,"created_at":"2014-05-02T17:32:14.000Z","monthly":[126,141,140,147,207,202,132,150,153,143,132,137]},{"name":"Prism","url":"http://prismjs.com","full_name":"PrismJS/prism","description":"Lightweight, robust, elegant syntax highlighting.","owner_id":11140484,"tags":["highlight"],"delta":1286,"stars":6133,"created_at":"2012-07-10T19:47:14.000Z","monthly":[105,98,75,108,154,102,84,127,120,119,74,120]},{"name":"Botpress","url":"https://botpress.io","full_name":"botpress/botpress","description":"The ultimate open-source bot platform with built-in NLU","owner_id":23510677,"tags":["bot"],"delta":2689,"stars":6634,"created_at":"2016-11-16T21:57:59.000Z","monthly":[125,144,185,142,175,155,660,657,83,92,165,106]},{"name":"Rax","url":"https://developers.taobao.com/","full_name":"alibaba/rax","description":"[ 🚧Work In Progress v1.0] The fastest way to build cross-container application.","owner_id":1961952,"tags":["vdom","framework"],"delta":1043,"stars":4874,"created_at":"2016-10-14T07:53:50.000Z","monthly":[65,85,76,49,79,75,81,90,103,112,100,128]},{"name":"nwb","url":"","full_name":"insin/nwb","description":"A toolkit for React, Preact, Inferno & vanilla JS apps, React libraries and other npm modules for th","owner_id":226692,"tags":["scaffolding","boilerplate"],"delta":1288,"stars":4112,"created_at":"2015-11-10T23:32:58.000Z","monthly":[84,79,108,77,90,116,92,129,129,114,140,130]},{"name":"vue-multiselect","url":"https://vue-multiselect.js.org/","full_name":"shentao/vue-multiselect","description":"Universal select/multiselect/tagging component for Vue.js","owner_id":3737591,"tags":["vue","autocomplete"],"delta":1269,"stars":3812,"created_at":"2016-04-23T13:02:33.000Z","monthly":[66,114,94,82,82,108,104,127,129,184,89,90]},{"name":"vue-form-generator","url":"","full_name":"vue-generators/vue-form-generator","description":":clipboard: A schema-based form generator component for Vue.js","owner_id":33808724,"tags":["vue","form"],"delta":811,"stars":1632,"created_at":"2016-04-27T19:54:13.000Z","monthly":[68,67,62,51,65,62,75,54,82,86,58,81]},{"name":"Nuxt","url":"https://nuxtjs.org","full_name":"nuxt/nuxt.js","description":"The Vue.js Developers Framework","owner_id":23360933,"tags":["vue","isomorphic","nodejs-framework","ssg"],"delta":8711,"stars":17288,"created_at":"2016-10-26T11:18:47.000Z","twitter":"","monthly":[602,603,787,716,629,578,605,708,858,860,688,1077],"icon":"nuxt.svg"},{"name":"i18next","url":"http://i18next.com/","full_name":"i18next/i18next","description":" i18next: learn once - translate everywhere","owner_id":8546082,"tags":["i18n"],"delta":925,"stars":3812,"created_at":"2011-12-16T12:37:42.000Z","monthly":[85,68,67,79,81,84,66,83,82,90,58,82]},{"name":"WebSlides","url":"https://webslides.tv/","full_name":"webslides/WebSlides","description":"Create HTML presentations in seconds —","owner_id":13846397,"tags":["presentation"],"delta":401,"stars":4395,"created_at":"2017-01-08T20:35:48.000Z"},{"name":"Intercooler","url":"http://intercoolerjs.org","full_name":"intercoolerjs/intercooler-js","description":"Making AJAX as easy as anchor tags","owner_id":44975234,"tags":["routing"],"delta":290,"stars":4310,"created_at":"2013-12-17T22:11:03.000Z","twitter":""},{"name":"docute","url":"https://docute.org","full_name":"leptosia/docute","description":"📚 Effortless documentation, done right.","owner_id":43379271,"tags":["doc"],"delta":876,"stars":2381,"created_at":"2016-12-08T18:04:40.000Z","monthly":[66,86,141,82,23,42,58,42,96,80,86,74]},{"name":"Yeoman","url":"http://yeoman.io","full_name":"yeoman/yeoman","description":"Yeoman - a set of tools for automating development workflow","owner_id":1714870,"tags":["scaffolding"],"delta":306,"stars":9141,"created_at":"2012-04-13T05:12:21.000Z"},{"name":"iFrame Resizer","url":"http://davidjbradshaw.github.io/iframe-resizer/","full_name":"davidjbradshaw/iframe-resizer","description":"Keep same and cross domain iFrames sized to their content with support for window/content resizing, ","owner_id":591634,"tags":["util"],"delta":691,"stars":3751,"created_at":"2013-06-14T19:18:32.000Z","monthly":[51,57,57,60,61,60,46,65,61,57,49,67]},{"name":"React Table","url":"http://react-table.js.org","full_name":"react-tools/react-table","description":"React Table - A lightweight, fast and extendable datagrid for React","owner_id":30272234,"tags":["table","react"],"delta":2625,"stars":4935,"created_at":"2016-10-20T17:25:08.000Z","monthly":[160,141,179,146,200,174,197,225,589,215,188,211]},{"name":"Prettier","url":"https://prettier.io","full_name":"prettier/prettier","description":"Prettier is an opinionated code formatter.","owner_id":25822731,"tags":["lint"],"delta":10520,"stars":29500,"created_at":"2016-11-29T17:13:37.000Z","twitter":"PrettierCode","monthly":[502,641,591,574,683,650,860,853,919,1264,974,2009],"icon":"prettier.svg"},{"name":"reactstrap","url":"https://reactstrap.github.io","full_name":"reactstrap/reactstrap","description":"Simple React Bootstrap 4 components","owner_id":17580417,"tags":["react","component"],"delta":3600,"stars":6792,"created_at":"2016-02-19T08:01:36.000Z","monthly":[244,236,252,270,263,347,304,316,364,373,317,314]},{"name":"Quasar","url":"https://quasar-framework.org","full_name":"quasarframework/quasar","description":"Quasar Framework","owner_id":23064371,"tags":["mobile","vue"],"delta":3604,"stars":8204,"created_at":"2015-10-05T15:45:36.000Z","twitter":"quasarframework","monthly":[257,183,244,268,306,337,386,340,248,342,295,398]},{"name":"React Navigation","url":"https://reactnavigation.org","full_name":"react-navigation/react-navigation","description":"Routing and navigation for your React Native apps","owner_id":29647600,"tags":["routing","react-native"],"delta":5543,"stars":14359,"created_at":"2017-01-26T19:51:40.000Z","monthly":[234,308,312,275,398,390,498,626,495,636,698,673]},{"name":"node-html-pdf","url":"","full_name":"marcbachmann/node-html-pdf","description":":page_facing_up: Html to pdf converter in nodejs. It spawns a phantomjs process and passes the pdf a","owner_id":431376,"tags":["pdf"],"delta":586,"stars":2465,"created_at":"2014-04-18T15:51:48.000Z","monthly":[38,38,36,36,36,38,43,52,72,68,62,67]},{"name":"Dexie.js","url":"https://dexie.org","full_name":"dfahlander/Dexie.js","description":"A Minimalistic Wrapper for IndexedDB","owner_id":6791329,"tags":["db"],"delta":1081,"stars":3649,"created_at":"2014-02-26T08:16:16.000Z","monthly":[86,83,89,74,78,90,95,92,100,111,87,96]},{"name":"Calypso","url":"https://developer.wordpress.com/calypso/","full_name":"Automattic/wp-calypso","description":"The JavaScript and API powered WordPress.com","owner_id":887802,"tags":["cms","redux","react"],"delta":1144,"stars":10727,"created_at":"2015-11-10T20:00:16.000Z","monthly":[70,103,69,71,236,103,54,91,70,93,86,98]},{"name":"Hyperapp","url":"","full_name":"jorgebucaran/hyperapp","description":"1 kB JavaScript micro-framework for building declarative web applications","owner_id":56996,"tags":["framework"],"delta":7612,"stars":15964,"created_at":"2017-01-20T05:20:21.000Z","twitter":"","monthly":[134,209,185,192,309,621,491,1595,243,488,877,2268],"icon":"hyperapp.svg"},{"name":"Keen-UI","url":"https://josephuspaye.github.io/Keen-UI/","full_name":"JosephusPaye/Keen-UI","description":"A lightweight Vue.js UI library with a simple API, inspired by Google's Material Design.","owner_id":5924865,"tags":["material","vue"],"delta":431,"stars":3598,"created_at":"2016-03-22T01:23:20.000Z"},{"name":"OpenLayers","url":"https://openlayers.org","full_name":"openlayers/openlayers","description":"OpenLayers","owner_id":240579,"tags":["map"],"delta":1220,"stars":4410,"created_at":"2012-06-20T06:53:59.000Z","monthly":[109,106,91,93,137,119,100,119,93,101,61,91]},{"name":"Mapbox GL JS","url":"https://www.mapbox.com/mapbox-gl-js/","full_name":"mapbox/mapbox-gl-js","description":"Interactive, thoroughly customizable maps in the browser, powered by vector tiles and WebGL","owner_id":600935,"tags":["map"],"delta":1318,"stars":3797,"created_at":"2013-03-07T14:45:24.000Z","monthly":[107,105,98,90,121,146,105,136,116,96,83,115]},{"name":"Ant Design","url":"https://ant.design","full_name":"ant-design/ant-design","description":"🐜 A UI Design Language","owner_id":12101536,"tags":["react","component"],"delta":18511,"stars":40706,"created_at":"2015-04-24T15:37:24.000Z","monthly":[4034,1168,1026,1255,1312,1319,1204,1388,1323,1578,1043,1861]},{"name":"lazysizes","url":"","full_name":"aFarkas/lazysizes","description":"High performance and SEO friendly lazy loader for images (responsive and normal), iframes and more, ","owner_id":188254,"tags":["load"],"delta":2214,"stars":9857,"created_at":"2014-10-11T21:03:26.000Z","monthly":[184,338,157,152,170,145,151,210,196,182,128,201]},{"name":"Poi","url":"https://poi.js.org","full_name":"egoist/poi","description":":zap: A zero-config bundler for JavaScript applications.","owner_id":8784712,"tags":["vue","build"],"delta":1317,"stars":4297,"created_at":"2016-04-21T16:21:09.000Z","twitter":"","monthly":[123,60,56,32,66,104,117,100,114,149,156,240],"icon":"poi.png"},{"name":"video-react","url":"https://video-react.js.org/","full_name":"video-react/video-react","description":"A web video player built for the HTML5 world using React library.","owner_id":22510068,"tags":["video","react"],"delta":528,"stars":1021,"created_at":"2016-09-29T00:10:58.000Z","monthly":[38,43,46,46,43,38,38,58,43,59,32,44]},{"name":"Apollo client","url":"http://dev.apollodata.com/","full_name":"apollographql/apollo-client","description":":rocket: A fully-featured, production ready caching GraphQL client for every UI framework and GraphQ","owner_id":17189275,"tags":["graphql","caching"],"delta":4179,"stars":9635,"created_at":"2016-02-26T20:25:00.000Z","twitter":"apollographql","monthly":[282,300,289,265,311,369,384,384,353,406,398,438]},{"name":"docsify","url":"https://docsify.js.org","full_name":"docsifyjs/docsify","description":"🃏 A magical documentation site generator.","owner_id":40133106,"tags":["doc"],"delta":3761,"stars":8407,"created_at":"2016-11-20T07:55:43.000Z","monthly":[267,385,267,310,317,247,244,358,370,435,217,344]},{"name":"Neutrino","url":"https://neutrinojs.org","full_name":"neutrinojs/neutrino","description":"Create and build modern JavaScript projects with zero initial configuration.","owner_id":21367267,"tags":["scaffolding"],"delta":697,"stars":2946,"created_at":"2017-02-03T03:27:20.000Z","monthly":[30,48,49,46,40,52,46,51,57,75,65,138]},{"name":"neurojs","url":"http://janhuenermann.com/projects/learning-to-drive","full_name":"janhuenermann/neurojs","description":"A javascript deep learning and reinforcement learning library.","owner_id":10101036,"tags":["neural","ml"],"delta":192,"stars":4185,"created_at":"2016-09-18T23:33:53.000Z"},{"name":"store.js","url":"","full_name":"marcuswestin/store.js","description":"Cross-browser storage for all use cases, used across the web.","owner_id":131967,"tags":["db"],"delta":1340,"stars":12028,"created_at":"2010-06-27T20:29:33.000Z","monthly":[77,109,74,97,114,106,98,117,162,145,91,150]},{"name":"Gutenberg","url":"http://bafs.github.io/Gutenberg","full_name":"BafS/Gutenberg","description":"Modern framework to print the web correctly. ","owner_id":588205,"tags":["css-lib","typo"],"delta":189,"stars":3986,"created_at":"2015-10-20T15:16:35.000Z"},{"name":"Planck.js","url":"http://piqnt.com/planck.js/","full_name":"shakiba/planck.js","description":"2D JavaScript Physics Engine","owner_id":1061095,"tags":["game"],"delta":441,"stars":3235,"created_at":"2016-03-22T04:46:05.000Z"},{"name":"hyperHTML","url":"","full_name":"WebReflection/hyperHTML","description":"A Fast & Light Virtual DOM Alternative","owner_id":85749,"tags":["vdom"],"delta":824,"stars":2160,"created_at":"2017-03-04T11:12:27.000Z","monthly":[53,88,73,54,61,64,80,64,57,66,81,83]},{"name":"Create React Native App","url":"","full_name":"react-community/create-react-native-app","description":"Create a React Native app on any OS with no build config.","owner_id":24483500,"tags":["react-native"],"delta":3733,"stars":11411,"created_at":"2017-01-11T17:54:30.000Z","monthly":[58,79,132,237,287,301,404,460,446,486,397,446]},{"name":"react-loadable","url":"","full_name":"jamiebuilds/react-loadable","description":":hourglass_flowing_sand: A higher order component for loading components with promises.","owner_id":952783,"tags":["isomorphic","react"],"delta":6985,"stars":11996,"created_at":"2017-03-09T18:41:17.000Z","monthly":[296,401,628,642,830,609,526,535,586,594,479,859]},{"name":"iView","url":"https://iviewui.com/","full_name":"iview/iview","description":"A high quality UI Toolkit built on Vue.js 2.0","owner_id":20693613,"tags":["vue","component"],"delta":7285,"stars":19209,"created_at":"2016-07-28T01:52:59.000Z","monthly":[513,491,400,644,628,691,656,642,647,774,357,842]},{"name":"Ant Design Mobile","url":"https://mobile.ant.design","full_name":"ant-design/ant-design-mobile","description":"A configurable Mobile UI","owner_id":12101536,"tags":["mobile","react-native"],"delta":2668,"stars":6455,"created_at":"2015-11-30T03:33:06.000Z","monthly":[168,165,139,153,169,242,235,355,240,276,200,326]},{"name":"Eagle.js","url":"https://zulko.github.io/eaglejs-demo/","full_name":"Zulko/eagle.js","description":"A hackable slideshow framework built with Vue.js","owner_id":1646122,"tags":["presentation","vue"],"delta":1935,"stars":3299,"created_at":"2017-03-12T17:07:55.000Z","monthly":[169,55,222,1065,56,90,81,97,25,22,22,31]},{"name":"react-overdrive","url":"https://react-overdrive.now.sh","full_name":"berzniz/react-overdrive","description":"Super easy magic-move transitions for React apps","owner_id":170214,"tags":["animation","react"],"delta":539,"stars":2832,"created_at":"2017-03-06T13:47:55.000Z","monthly":[9,21,9,7,63,37,30,49,107,33,60,114]},{"name":"ngx-datatable","url":"http://swimlane.github.io/ngx-datatable/","full_name":"swimlane/ngx-datatable","description":"✨  A feature-rich yet lightweight data-table crafted for Angular","owner_id":10552812,"tags":["angular","table"],"delta":1069,"stars":3251,"created_at":"2016-05-31T19:25:47.000Z","monthly":[54,62,65,56,70,91,84,99,85,164,109,130]},{"name":"Sanctuary","url":"https://sanctuary.js.org","full_name":"sanctuary-js/sanctuary","description":":see_no_evil: Refuge from unsafe JavaScript","owner_id":18357498,"tags":["fp"],"delta":637,"stars":1828,"created_at":"2015-01-19T05:52:10.000Z","monthly":[45,56,85,37,57,45,48,43,58,48,76,39]},{"name":"Redux Offline","url":"","full_name":"redux-offline/redux-offline","description":"Build Offline-First Apps for Web and React Native","owner_id":31570694,"tags":["redux","offline"],"delta":1028,"stars":5203,"created_at":"2017-03-11T18:37:50.000Z","monthly":[57,47,60,40,63,72,82,138,95,102,90,182]},{"name":"Choices.js","url":"https://joshuajohnson.co.uk/Choices/","full_name":"jshjohnson/Choices","description":"A vanilla JS customisable select box/text input plugin ⚡️","owner_id":3064889,"tags":["autocomplete"],"delta":640,"stars":2282,"created_at":"2016-03-15T14:02:08.000Z","monthly":[37,63,53,43,47,51,112,54,50,49,35,46]},{"name":"AOS","url":"","full_name":"michalsnik/aos","description":"Animate on scroll library","owner_id":4093559,"tags":["scrolling"],"delta":2966,"stars":8196,"created_at":"2015-07-09T17:49:00.000Z","monthly":[219,240,213,240,266,272,217,250,208,264,337,240]},{"name":"Polished","url":"https://polished.js.org/","full_name":"styled-components/polished","description":"A lightweight toolset for writing styles in JavaScript ✨","owner_id":20658825,"tags":["css-in-js"],"delta":1539,"stars":4481,"created_at":"2016-11-03T14:39:21.000Z","monthly":[118,108,106,129,121,175,250,126,93,93,102,118]},{"name":"You Don't Need jQuery","url":"","full_name":"nefe/You-Dont-Need-jQuery","description":"Examples of how to do query, style, dom, ajax, event etc like jQuery with plain javascript.","owner_id":33238961,"tags":["learning"],"delta":1787,"stars":14434,"created_at":"2015-11-21T16:02:26.000Z","monthly":[102,116,151,180,157,137,124,182,201,171,91,175]},{"name":"Reactide","url":"http://reactide.io","full_name":"reactide/reactide","description":"Reactide is the first dedicated IDE for React web application development. http://reactide.io","owner_id":26257999,"tags":["ide"],"delta":1121,"stars":8532,"created_at":"2017-03-07T18:30:34.000Z","monthly":[133,78,50,35,47,85,50,67,108,115,92,261]},{"name":"Tippy.js","url":"https://atomiks.github.io/tippyjs/","full_name":"atomiks/tippyjs","description":"Highly customizable vanilla JS tooltip/popover library","owner_id":22450188,"tags":["tooltip"],"delta":2127,"stars":5364,"created_at":"2017-04-01T06:51:35.000Z","monthly":[110,131,149,132,97,113,102,130,178,621,274,90]},{"name":"react-datasheet","url":"https://nadbm.github.io/react-datasheet/","full_name":"nadbm/react-datasheet","description":"Excel-like data grid component for react","owner_id":5846191,"tags":["table","react"],"delta":724,"stars":3289,"created_at":"2016-09-25T19:18:17.000Z","monthly":[45,61,56,47,57,71,55,50,44,65,77,96]},{"name":"SweetAlert2","url":"https://sweetalert2.github.io/","full_name":"sweetalert2/sweetalert2","description":"A beautiful, responsive, highly customizable and accessible (WAI-ARIA) replacement for JavaScript's ","owner_id":35137722,"tags":["notify"],"delta":3910,"stars":7973,"created_at":"2015-01-03T16:15:52.000Z","monthly":[164,170,137,135,183,193,155,180,213,442,1744,194]},{"name":"normalizr","url":"","full_name":"paularmstrong/normalizr","description":"Normalizes nested JSON according to a schema","owner_id":33297,"tags":["json"],"delta":4014,"stars":15401,"created_at":"2014-08-20T08:41:38.000Z","monthly":[246,263,286,304,349,330,305,339,402,419,364,407]},{"name":"Glamorous","url":"https://glamorous.rocks","full_name":"paypal/glamorous","description":"DEPRECATED: 💄 Maintainable CSS with React","owner_id":476675,"tags":["css-in-js"],"delta":865,"stars":3764,"created_at":"2017-04-03T21:35:49.000Z","twitter":"glamorouscss","monthly":[-5,26,29,27,25,52,55,94,122,129,112,199]},{"name":"AR.js","url":"","full_name":"jeromeetienne/AR.js","description":"Efficient Augmented Reality for the Web - 60fps on mobile!","owner_id":252962,"tags":["virtual"],"delta":2959,"stars":12243,"created_at":"2017-02-17T10:27:59.000Z","monthly":[163,229,327,253,206,205,261,209,249,282,253,322]},{"name":"Turbolinks","url":"","full_name":"turbolinks/turbolinks","description":"Turbolinks makes navigating your web application faster","owner_id":16996872,"tags":["routing"],"delta":2921,"stars":7679,"created_at":"2016-02-01T02:14:01.000Z","twitter":"","monthly":[107,169,281,185,163,183,119,217,168,215,529,585]},{"name":"Reactive Search","url":"https://opensource.appbase.io/reactivesearch","full_name":"appbaseio/reactivesearch","description":"React, React Native and Vue UI components for building data-driven apps with Elasticsearch","owner_id":8524145,"tags":["search","react"],"delta":1983,"stars":2666,"created_at":"2017-02-15T15:21:24.000Z","monthly":[136,101,87,77,74,104,185,193,147,240,174,465]},{"name":"AlaSQL","url":"http://alasql.org","full_name":"agershun/alasql","description":"AlaSQL.js - JavaScript SQL database for browser and Node.js. Handles both traditional relational tab","owner_id":643040,"tags":["db"],"delta":631,"stars":2839,"created_at":"2014-10-26T16:30:37.000Z","monthly":[62,41,45,44,64,44,46,59,54,68,48,56]},{"name":"C3.js","url":"http://c3js.org","full_name":"c3js/c3","description":":bar_chart: A D3-based reusable chart library","owner_id":9966497,"tags":["chart","d3"],"delta":745,"stars":8152,"created_at":"2013-07-18T06:51:40.000Z","monthly":[43,54,56,68,62,58,72,71,72,70,62,57]},{"name":"SVG.js","url":"http://svgjs.com/","full_name":"svgdotjs/svg.js","description":"The lightweight library for manipulating and animating SVG","owner_id":22855482,"tags":["svg"],"delta":1519,"stars":6624,"created_at":"2012-12-15T10:26:54.000Z","monthly":[82,97,82,121,200,166,115,137,99,134,126,160]},{"name":"React 360","url":"https://facebook.github.io/react-360","full_name":"facebook/react-360","description":"Create amazing 360 and VR content using React","owner_id":69631,"tags":["react-native","virtual"],"delta":1366,"stars":6772,"created_at":"2016-12-12T19:45:37.000Z","twitter":"","monthly":[96,118,92,73,83,125,135,246,106,96,84,112]},{"name":"React Move","url":"https://react-move.js.org","full_name":"react-tools/react-move","description":"React Move 🌀 Beautiful, data-driven animations for React","owner_id":30272234,"tags":["animation","react"],"delta":2577,"stars":5656,"created_at":"2017-03-20T15:38:13.000Z","monthly":[34,45,90,117,1670,35,108,56,89,83,78,172]},{"name":"Vee-Validate","url":"https://baianat.github.io/vee-validate/","full_name":"baianat/vee-validate","description":"✔ Template Based Validation Framework for Vue.js","owner_id":5085038,"tags":["form","vue"],"delta":2379,"stars":5786,"created_at":"2016-07-30T01:10:44.000Z","monthly":[118,173,189,184,201,178,176,197,239,252,197,275]},{"name":"discord.js","url":"https://discord.js.org","full_name":"discordjs/discord.js","description":"A powerful JavaScript library for interacting with the Discord API","owner_id":26492485,"tags":["realtime"],"delta":1389,"stars":3311,"created_at":"2015-08-10T13:36:26.000Z","monthly":[100,112,169,83,137,83,84,116,94,167,116,128]},{"name":"yargs","url":"http://yargs.js.org/","full_name":"yargs/yargs","description":" yargs the modern, pirate-themed successor to optimist.","owner_id":16504989,"tags":["cli"],"delta":1713,"stars":5618,"created_at":"2013-11-07T17:25:51.000Z","monthly":[116,142,124,151,139,157,166,152,135,135,144,152]},{"name":"ShellJS","url":"http://shelljs.org","full_name":"shelljs/shelljs","description":":shell: Portable Unix shell commands for Node.js","owner_id":14236201,"tags":["cli"],"delta":1961,"stars":9027,"created_at":"2012-03-02T17:04:47.000Z","monthly":[193,175,124,147,155,163,144,166,144,226,156,168]},{"name":"Moon","url":"https://kbrsh.github.io/moon","full_name":"kbrsh/moon","description":"🌙 The minimal & fast UI library","owner_id":15644571,"tags":["framework"],"delta":522,"stars":4617,"created_at":"2016-07-14T04:53:09.000Z","monthly":[11,13,10,3,44,140,24,44,42,30,53,108]},{"name":"React Desktop","url":"http://reactdesktop.js.org","full_name":"gabrielbull/react-desktop","description":"React UI Components for macOS High Sierra and Windows 10","owner_id":671923,"tags":["react","desktop","component"],"delta":984,"stars":7971,"created_at":"2015-10-14T02:22:59.000Z","monthly":[62,56,67,38,79,84,82,97,115,133,79,92]},{"name":"vue-infinite-loading","url":"https://peachscript.github.io/vue-infinite-loading/","full_name":"PeachScript/vue-infinite-loading","description":"An infinite scroll plugin for Vue.js.","owner_id":5035925,"tags":["vue","scrolling"],"delta":609,"stars":1487,"created_at":"2016-05-10T08:17:39.000Z","monthly":[47,51,43,39,65,39,48,56,48,72,41,60]},{"name":"React Native Tab View","url":"","full_name":"react-native-community/react-native-tab-view","description":"A cross-platform Tab View component for React Native","owner_id":20269980,"tags":["react-native"],"delta":1030,"stars":2542,"created_at":"2016-06-15T21:38:19.000Z","monthly":[55,103,76,59,74,90,100,85,89,89,107,103]},{"name":"Prepack","url":"prepack.io","full_name":"facebook/prepack","description":"A JavaScript bundle optimizer.","owner_id":69631,"tags":["performance"],"delta":2636,"stars":13284,"created_at":"2015-10-28T23:25:08.000Z","monthly":[79,103,198,122,231,213,196,422,176,276,233,387]},{"name":"Nest","url":"https://nestjs.com/","full_name":"nestjs/nest","description":"A progressive Node.js framework for building efficient and scalable server-side applications on top ","owner_id":28507035,"tags":["nodejs-framework","microservice"],"delta":8363,"stars":11473,"created_at":"2017-02-04T20:12:52.000Z","twitter":"nestframework","monthly":[882,742,668,862,708,651,579,785,462,615,826,583]},{"name":"node-qrcode","url":"","full_name":"soldair/node-qrcode","description":"qr code generator","owner_id":119903,"tags":["canvas"],"delta":944,"stars":2510,"created_at":"2010-12-21T01:45:11.000Z","monthly":[83,72,74,54,104,110,73,71,97,70,44,92]},{"name":"Moleculer","url":"https://moleculer.services/","full_name":"moleculerjs/moleculer","description":":rocket: Progressive microservices framework for Node.js","owner_id":25477106,"tags":["microservice"],"delta":1436,"stars":1964,"created_at":"2017-02-17T11:11:35.000Z","monthly":[58,76,90,66,88,130,96,151,140,426,56,59]},{"name":"Reaction","url":"https://reactioncommerce.com/","full_name":"reactioncommerce/reaction","description":"Reaction is a customizable, real-time reactive, JavaScript commerce platform.","owner_id":5605462,"tags":["meteor"],"delta":2011,"stars":8248,"created_at":"2013-09-18T15:30:36.000Z","monthly":[119,173,167,153,140,111,145,173,205,182,184,259]},{"name":"Britecharts","url":"http://eventbrite.github.io/britecharts/","full_name":"eventbrite/britecharts","description":"Client-side reusable Charting Library based on D3.js v5 that allows easy and intuitive use of charts","owner_id":369874,"tags":["chart","d3"],"delta":525,"stars":3451,"created_at":"2015-05-19T22:42:39.000Z","monthly":[16,17,15,16,24,24,21,40,46,66,124,116]},{"name":"vx","url":"https://vx-demo.now.sh/","full_name":"hshoff/vx","description":"🐯react + d3 = vx | visualization components","owner_id":339208,"tags":["chart","react","d3","svg"],"delta":2255,"stars":5503,"created_at":"2017-03-15T16:25:41.000Z","monthly":[110,128,116,123,266,669,185,147,156,142,87,126]},{"name":"Element React","url":"https://elemefe.github.io/element-react/","full_name":"ElemeFE/element-react","description":"Element UI","owner_id":12810740,"tags":["react","component"],"delta":659,"stars":1964,"created_at":"2016-10-18T06:56:20.000Z","monthly":[54,49,46,39,55,50,55,74,58,57,61,61]},{"name":"pdfkit","url":"http://pdfkit.org/","full_name":"foliojs/pdfkit","description":"A JavaScript PDF generation library for Node and the browser","owner_id":41874169,"tags":["pdf"],"delta":870,"stars":4456,"created_at":"2011-07-11T15:12:29.000Z","monthly":[67,77,54,56,60,87,64,87,98,87,73,60]},{"name":"Workbox","url":"https://developers.google.com/web/tools/workbox/","full_name":"GoogleChrome/workbox","description":"📦 Workbox: JavaScript libraries for Progressive Web Apps","owner_id":1778935,"tags":["serviceworker"],"delta":2912,"stars":6719,"created_at":"2016-04-04T15:55:19.000Z","twitter":"","monthly":[144,285,215,282,255,226,217,242,239,225,237,345]},{"name":"diegomura/react-pdf","url":"https://react-pdf.org","full_name":"diegomura/react-pdf","description":"📄 Create PDF files using React","owner_id":5600341,"tags":["react","pdf"],"delta":1792,"stars":5533,"created_at":"2016-10-18T21:33:58.000Z","monthly":[101,115,99,93,248,508,77,107,90,107,122,125]},{"name":"Handsontable","url":"https://handsontable.com","full_name":"handsontable/handsontable","description":"Handsontable Community Edition - JavaScript/HTML5 Data Grid Component with Spreadsheet Look & Feel. ","owner_id":8068250,"tags":["table"],"delta":1980,"stars":11104,"created_at":"2011-05-23T22:38:58.000Z","monthly":[174,153,143,148,141,179,164,227,161,188,149,153]},{"name":"Ory Editor","url":"https://ory-editor.aeneas.io","full_name":"aeneasr/ory-editor","description":"Next-gen, highly customizable content editor for the browser - based on React and Redux and written ","owner_id":3372410,"tags":["rich-text-editor","react","redux"],"delta":1007,"stars":7334,"created_at":"2015-05-29T12:19:44.000Z","monthly":[55,90,101,86,104,115,71,74,69,73,69,100]},{"name":"Muuri","url":"http://haltu.github.io/muuri/","full_name":"haltu/muuri","description":"Responsive, sortable, filterable and draggable grid layouts","owner_id":884254,"tags":["layout","dnd"],"delta":1382,"stars":7614,"created_at":"2015-12-21T07:00:44.000Z","monthly":[149,103,86,72,79,68,57,82,98,170,120,298]},{"name":"React Live","url":"https://react-live.kitten.sh/","full_name":"FormidableLabs/react-live","description":"A production-focused playground for live editing React components","owner_id":5078602,"tags":["react"],"delta":584,"stars":1397,"created_at":"2017-04-01T05:07:34.000Z","monthly":[38,31,70,55,162,25,38,54,31,44,17,19]},{"name":"Superfine","url":"","full_name":"jorgebucaran/superfine","description":"Minimal view layer for creating declarative web user interfaces","owner_id":56996,"tags":["vdom"],"delta":532,"stars":1256,"created_at":"2017-05-19T12:53:23.000Z","twitter":"","monthly":[16,14,12,10,35,82,60,165,32,16,22,68]},{"name":"Typography.js","url":"http://kyleamathews.github.io/typography.js/","full_name":"KyleAMathews/typography.js","description":"A powerful toolkit for building websites with beautiful design","owner_id":71047,"tags":["css-in-js","typo"],"delta":1079,"stars":2323,"created_at":"2015-03-05T23:25:48.000Z","monthly":[130,65,102,79,112,83,70,65,89,66,99,119]},{"name":"ReactXP","url":"https://microsoft.github.io/reactxp/","full_name":"Microsoft/reactxp","description":"Library for cross-platform app development.","owner_id":6154722,"tags":["react-native"],"delta":1757,"stars":7403,"created_at":"2017-03-22T19:15:24.000Z","monthly":[60,83,236,474,69,100,204,93,93,90,117,138]},{"name":"Feather","url":"https://feathericons.com","full_name":"feathericons/feather","description":"Simply beautiful open source icons","owner_id":29268069,"tags":["icon","svg"],"delta":3421,"stars":14953,"created_at":"2014-05-28T19:49:55.000Z","monthly":[187,166,193,140,156,204,365,542,324,254,286,604]},{"name":"DPlayer","url":"http://dplayer.js.org","full_name":"MoePlayer/DPlayer","description":":lollipop: Wow, such a lovely HTML5 danmaku video player","owner_id":30426040,"tags":["video"],"delta":2847,"stars":4594,"created_at":"2016-05-03T14:11:22.000Z","monthly":[266,254,232,180,232,236,221,274,284,274,175,219]},{"name":"APlayer","url":"http://aplayer.js.org","full_name":"MoePlayer/APlayer","description":":lollipop: Wow, such a beautiful HTML5 music player","owner_id":30426040,"tags":["audio"],"delta":1164,"stars":3348,"created_at":"2015-11-14T13:13:46.000Z","monthly":[120,91,97,58,92,72,82,125,110,135,69,113]},{"name":"billboard.js","url":"https://naver.github.io/billboard.js/","full_name":"naver/billboard.js","description":":bar_chart: Re-usable, easy interface JavaScript chart library based on D3 v4+:chart_with_upwards_tr","owner_id":6589568,"tags":["chart","d3","svg"],"delta":1077,"stars":3303,"created_at":"2017-06-08T02:54:44.000Z","monthly":[94,34,276,22,59,55,168,28,58,106,86,91]},{"name":"flubber","url":"","full_name":"veltman/flubber","description":"Tools for smoother shape animations.","owner_id":2120446,"tags":["animation","svg"],"delta":427,"stars":4837,"created_at":"2017-06-09T08:16:56.000Z"},{"name":"Amplitude.js","url":"https://521dimensions.com/open-source/amplitudejs","full_name":"521dimensions/amplitudejs","description":"Amplitude.js is the HTML5 Audio Player for the modern era. No dependencies required.","owner_id":4382659,"tags":["audio"],"delta":800,"stars":2945,"created_at":"2013-10-07T20:38:20.000Z","monthly":[41,46,80,83,51,35,86,38,43,36,51,210]},{"name":"Spellbook of Modern Web Dev","url":"","full_name":"dexteryy/spellbook-of-modern-webdev","description":"A Big Picture, Thesaurus, and Taxonomy of Modern JavaScript Web Development","owner_id":43011,"tags":["learning"],"delta":863,"stars":10008,"created_at":"2017-06-10T18:03:21.000Z","monthly":[63,44,28,45,59,49,56,72,72,105,144,126]},{"name":"Collect.js","url":"","full_name":"ecrmnn/collect.js","description":"💎 Convenient and dependency free wrapper for working with arrays and objects","owner_id":1481696,"tags":["util"],"delta":1340,"stars":4328,"created_at":"2016-09-11T14:53:13.000Z","monthly":[56,34,44,81,74,201,656,64,14,70,10,36]},{"name":"Golden Layout","url":"https://golden-layout.com/","full_name":"golden-layout/golden-layout","description":"A multi window layout manager for webapps","owner_id":38538777,"tags":["layout"],"delta":582,"stars":4062,"created_at":"2014-10-05T07:29:06.000Z","monthly":[32,36,42,36,62,46,47,59,75,57,34,56]},{"name":"JerryScript","url":"http://jerryscript.net","full_name":"pando-project/jerryscript","description":"Ultra-lightweight JavaScript engine for the Internet of Things.","owner_id":40356977,"tags":["iot"],"delta":751,"stars":3402,"created_at":"2015-04-03T01:10:31.000Z","monthly":[52,44,42,39,49,51,42,66,76,103,123,64]},{"name":"react-day-picker","url":"http://react-day-picker.js.org","full_name":"gpbl/react-day-picker","description":"Flexible date picker for React","owner_id":120693,"tags":["react","date"],"delta":1072,"stars":2854,"created_at":"2014-12-28T17:07:20.000Z","monthly":[40,58,74,72,248,108,89,78,63,84,66,92]},{"name":"Grid Styled","url":"https://grid.rebassjs.org","full_name":"rebassjs/grid","description":"Responsive React grid system built with styled-system","owner_id":41265750,"tags":["react","layout"],"delta":772,"stars":1747,"created_at":"2016-10-14T02:43:02.000Z","monthly":[34,55,61,55,83,64,48,73,71,95,87,46]},{"name":"Infinite Scroll","url":"https://infinite-scroll.com","full_name":"metafizzy/infinite-scroll","description":"📜 Automatically add next page","owner_id":573910,"tags":["scrolling"],"delta":655,"stars":5976,"created_at":"2010-05-04T17:28:57.000Z","monthly":[52,49,42,34,61,43,48,73,62,58,49,84]},{"name":"Sonarwhal","url":"https://webhint.io/","full_name":"webhintio/hint","description":"💡 A hinting engine for the web","owner_id":25042266,"tags":["lint","access"],"delta":819,"stars":2027,"created_at":"2017-02-16T18:15:31.000Z","twitter":"","monthly":[16,52,44,105,139,10,41,108,204,35,21,44]},{"name":"react-native-ui-kitten","url":"https://akveo.github.io/react-native-ui-kitten/","full_name":"akveo/react-native-ui-kitten","description":"🐱  Customizable and reusable react-native component kit","owner_id":11921694,"tags":["react-native"],"delta":1368,"stars":3356,"created_at":"2016-12-20T08:22:38.000Z","monthly":[90,118,98,118,108,100,111,101,118,130,118,158]},{"name":"Yup","url":"","full_name":"jquense/yup","description":"Dead simple Object schema validation","owner_id":339286,"tags":["json","validation"],"delta":2513,"stars":3714,"created_at":"2014-09-22T23:54:22.000Z","monthly":[251,321,291,208,246,228,169,191,154,187,147,120]},{"name":"Chalk","url":"","full_name":"chalk/chalk","description":"🖍 Terminal string styling done right","owner_id":13122722,"tags":["cli"],"delta":3320,"stars":11055,"created_at":"2013-08-03T00:20:12.000Z","monthly":[269,271,237,294,349,258,265,272,293,323,232,257]},{"name":"Commander.js","url":"","full_name":"tj/commander.js","description":"node.js command-line interfaces made easy","owner_id":25254,"tags":["cli"],"delta":4049,"stars":13786,"created_at":"2011-08-14T21:33:58.000Z","monthly":[308,320,320,410,311,348,403,318,357,363,307,284]},{"name":"Rekit","url":"http://rekit.js.org","full_name":"supnate/rekit","description":"IDE and toolkit for building scalable web applications with React, Redux and React-router","owner_id":481738,"tags":["boilerplate","redux","react"],"delta":2575,"stars":3619,"created_at":"2016-08-02T17:53:21.000Z","monthly":[59,52,69,57,91,83,80,69,127,276,1591,21]},{"name":"Ink","url":"","full_name":"vadimdemedes/ink","description":"🌈 React for interactive command-line apps","owner_id":697676,"tags":["react","cli"],"delta":2296,"stars":6571,"created_at":"2017-06-12T06:12:28.000Z","monthly":[54,107,95,47,74,98,77,334,429,752,75,154]},{"name":"Front End Guide","url":"","full_name":"grab/front-end-guide","description":"📚 Study guide and introduction to the modern front end stack.","owner_id":17284363,"tags":["learning"],"delta":1880,"stars":11718,"created_at":"2017-04-24T02:06:06.000Z","monthly":[96,101,100,95,121,159,376,195,161,173,150,153]},{"name":"Pell","url":"https://jaredreich.com/pell","full_name":"jaredreich/pell","description":"📝 the simplest and smallest WYSIWYG text editor for web, with no dependencies","owner_id":8563847,"tags":["rich-text-editor"],"delta":3764,"stars":10541,"created_at":"2017-07-09T14:30:51.000Z","monthly":[36,52,48,58,69,65,58,136,271,2611,61,299]},{"name":"Emotion","url":"https://emotion.sh/","full_name":"emotion-js/emotion","description":"CSS-in-JS library designed for high performance style composition","owner_id":31557565,"tags":["css-in-js"],"delta":3911,"stars":6539,"created_at":"2017-05-27T04:23:45.000Z","monthly":[507,336,294,368,417,419,291,404,248,190,159,278]},{"name":"Scribbletune","url":"https://scribbletune.com/","full_name":"scribbletune/scribbletune","description":"Create music with JavaScript","owner_id":42105280,"tags":["audio"],"delta":559,"stars":2874,"created_at":"2013-11-25T21:44:43.000Z","monthly":[15,21,48,45,85,60,51,51,45,87,30,21]},{"name":"Reselect","url":"","full_name":"reduxjs/reselect","description":"Selector library for Redux","owner_id":13142323,"tags":["redux"],"delta":3864,"stars":13612,"created_at":"2015-07-01T11:06:45.000Z","monthly":[218,258,310,289,374,295,283,286,367,429,349,406]},{"name":"Redux Persist","url":"","full_name":"rt2zz/redux-persist","description":"persist and rehydrate a redux store","owner_id":2302315,"tags":["redux"],"delta":2842,"stars":7373,"created_at":"2015-07-23T04:43:58.000Z","monthly":[233,198,168,212,244,236,234,252,248,277,270,270]},{"name":"Apollo Server","url":"https://www.apollographql.com/docs/apollo-server/","full_name":"apollographql/apollo-server","description":"🌍 GraphQL server for Express, Connect, Hapi, Koa and more","owner_id":17189275,"tags":["graphql"],"delta":3184,"stars":6052,"created_at":"2016-04-21T09:26:01.000Z","monthly":[236,228,285,239,276,371,331,278,231,255,181,273]},{"name":"Project Guidelines","url":"","full_name":"elsewhencode/project-guidelines","description":"A set of best practices for JavaScript projects","owner_id":7815827,"tags":["learning"],"delta":7757,"stars":19153,"created_at":"2017-06-30T10:17:55.000Z","monthly":[556,323,212,94,99,126,145,162,178,244,1449,4169]},{"name":"pnpm","url":"https://pnpm.js.org","full_name":"pnpm/pnpm","description":"📦🚀 Fast, disk space efficient package manager","owner_id":21320719,"tags":["package"],"delta":2022,"stars":5094,"created_at":"2016-01-28T07:40:43.000Z","monthly":[101,187,125,156,196,324,348,168,128,142,68,79]},{"name":"Spacetime","url":"https://spencermounta.in/spacetime/","full_name":"spencermountain/spacetime","description":"A lightweight javascript timezone library","owner_id":399657,"tags":["date"],"delta":977,"stars":2466,"created_at":"2017-02-22T15:31:34.000Z","monthly":[57,348,55,56,277,11,32,13,27,40,18,43]},{"name":"React Autosuggest","url":"http://react-autosuggest.js.org","full_name":"moroshko/react-autosuggest","description":"WAI-ARIA compliant React autosuggest component","owner_id":259753,"tags":["react","autocomplete"],"delta":1101,"stars":4017,"created_at":"2015-03-07T12:09:12.000Z","monthly":[49,81,79,82,93,87,94,97,107,115,94,123]},{"name":"Chromeless","url":"https://chromeless.netlify.com","full_name":"prisma-archive/chromeless","description":"🖥  Chrome automation made simple. Runs locally or headless on AWS Lambda.","owner_id":45311580,"tags":["auto"],"delta":1698,"stars":13216,"created_at":"2017-06-01T16:11:11.000Z","monthly":[28,47,72,78,70,113,139,149,181,220,337,264]},{"name":"Express Gateway","url":"https://www.express-gateway.io","full_name":"ExpressGateway/express-gateway","description":"A microservices API Gateway built on top of ExpressJS","owner_id":27776345,"tags":["microservice","express"],"delta":673,"stars":1330,"created_at":"2016-07-06T00:21:45.000Z","monthly":[46,46,58,43,41,83,57,80,68,49,27,75]},{"name":"SheetJS js-xlsx","url":"https://sheetjs.com/","full_name":"SheetJS/js-xlsx","description":":green_book: SheetJS Community Edition -- Spreadsheet Parser and Writer","owner_id":5826089,"tags":["table"],"delta":5372,"stars":13975,"created_at":"2012-12-03T19:25:52.000Z","monthly":[465,548,452,450,459,452,461,492,447,443,293,410]},{"name":"Turf","url":"http://turfjs.org/","full_name":"Turfjs/turf","description":"A modular geospatial engine written in JavaScript","owner_id":7736769,"tags":["map"],"delta":871,"stars":4100,"created_at":"2013-10-03T14:50:25.000Z","monthly":[60,69,66,70,61,62,68,86,75,100,75,79]},{"name":"Ring UI","url":"https://jetbrains.github.io/ring-ui","full_name":"JetBrains/ring-ui","description":"A collection of JetBrains Web UI components","owner_id":878437,"tags":["react","component"],"delta":874,"stars":2104,"created_at":"2017-07-19T09:25:26.000Z","monthly":[14,84,126,522,19,10,12,15,13,18,9,32]},{"name":"React Helmet","url":"","full_name":"nfl/react-helmet","description":"A document head manager for React","owner_id":1261928,"tags":["react"],"delta":3237,"stars":9277,"created_at":"2015-06-18T00:07:34.000Z","monthly":[219,243,267,257,318,288,278,262,269,282,275,279]},{"name":"Bot Builder","url":"http://botframework.com","full_name":"Microsoft/BotBuilder","description":"Bot Builder provides the most comprehensive experience for building conversation applications","owner_id":6154722,"tags":["bot"],"delta":805,"stars":5497,"created_at":"2016-03-03T23:47:03.000Z","monthly":[34,36,45,48,55,63,69,73,87,85,112,98]},{"name":"DataTables","url":"http://www.datatables.net/","full_name":"DataTables/DataTables","description":"Tables plug-in for jQuery","owner_id":278219,"tags":["table"],"delta":706,"stars":5824,"created_at":"2010-05-16T07:02:32.000Z","monthly":[43,71,61,33,58,78,82,58,61,62,49,50]},{"name":"seamless-immutable","url":"","full_name":"rtfeldman/seamless-immutable","description":"Immutable data structures for JavaScript which are backwards-compatible with normal JS Arrays and Ob","owner_id":1094080,"tags":["data-structure"],"delta":695,"stars":4885,"created_at":"2014-10-24T03:53:10.000Z","monthly":[33,25,57,51,69,68,49,59,61,77,62,84]},{"name":"react-beautiful-dnd","url":"","full_name":"atlassian/react-beautiful-dnd","description":"Beautiful and accessible drag and drop for lists with React","owner_id":168166,"tags":["react","dnd"],"delta":7433,"stars":12088,"created_at":"2017-08-09T03:37:15.000Z","monthly":[427,1875,386,398,539,981,475,318,661,458,356,559]},{"name":"NG-ZORRO","url":"https://ng.ant.design/docs/introduce/en","full_name":"NG-ZORRO/ng-zorro-antd","description":"An enterprise-class UI components based on Ant Design and Angular 7. 🐜 ","owner_id":30223759,"tags":["angular","component"],"delta":2171,"stars":4251,"created_at":"2017-08-08T14:59:33.000Z","monthly":[190,161,150,146,168,210,236,201,204,197,94,214]},{"name":"Nivo","url":"https://nivo.rocks","full_name":"plouc/nivo","description":"nivo provides a rich set of dataviz components, built on top of the awesome d3 and Reactjs libraries","owner_id":501642,"tags":["react","chart","svg","d3"],"delta":2634,"stars":4701,"created_at":"2016-04-16T03:27:56.000Z","monthly":[342,1381,133,116,73,57,70,102,125,80,49,106]},{"name":"Mozaïk","url":"http://mozaik.rocks","full_name":"plouc/mozaik","description":"Mozaïk is a tool based on nodejs / react / redux / nivo / d3 to easily craft beautiful dashboards","owner_id":501642,"tags":["dashboard","react","d3"],"delta":536,"stars":2992,"created_at":"2014-12-26T03:18:38.000Z","monthly":[38,44,25,26,42,26,28,37,49,83,51,87]},{"name":"Puppeteer","url":"https://pptr.dev","full_name":"GoogleChrome/puppeteer","description":"Headless Chrome Node API","owner_id":1778935,"tags":["auto"],"delta":21365,"stars":43549,"created_at":"2017-05-09T22:16:13.000Z","monthly":[1622,1359,1459,1446,1726,1478,1455,1673,1649,2128,1966,3404]},{"name":"Wekan","url":"https://wekan.github.io","full_name":"wekan/wekan","description":"The open-source kanban (built with Meteor)","owner_id":11725037,"tags":["meteor"],"delta":1622,"stars":13684,"created_at":"2014-01-21T01:26:28.000Z","monthly":[81,114,99,127,128,160,113,129,153,166,148,204]},{"name":"Rocket.Chat","url":"https://rocket.chat/","full_name":"RocketChat/Rocket.Chat","description":"Have your own Slack like online chat, built with Meteor.","owner_id":12508788,"tags":["meteor"],"delta":5533,"stars":21074,"created_at":"2015-05-19T07:36:09.000Z","monthly":[339,294,299,402,492,455,365,699,528,769,455,436]},{"name":"Vuestic Admin Dashboard","url":"http://vuestic.epicmax.co","full_name":"epicmaxco/vuestic-admin","description":"Vue.js admin dashboard","owner_id":30595047,"tags":["vue","dashboard"],"delta":2078,"stars":5051,"created_at":"2017-07-31T11:52:40.000Z","monthly":[90,71,117,94,197,208,263,158,228,187,211,254]},{"name":"Buefy","url":"https://buefy.github.io","full_name":"buefy/buefy","description":"Lightweight UI components for Vue.js based on Bulma","owner_id":26799900,"tags":["vue","component"],"delta":2453,"stars":4371,"created_at":"2017-03-31T16:44:48.000Z","monthly":[173,206,199,224,219,202,208,203,204,209,177,229]},{"name":"redux-observable","url":"https://redux-observable.js.org","full_name":"redux-observable/redux-observable","description":"RxJS middleware for action side effects in Redux using \"Epics\"","owner_id":19417071,"tags":["redux","stream","fp"],"delta":1670,"stars":6074,"created_at":"2016-04-20T21:58:23.000Z","monthly":[79,93,95,97,141,156,170,154,160,165,167,193]},{"name":"BootstrapVue","url":"https://bootstrap-vue.js.org","full_name":"bootstrap-vue/bootstrap-vue","description":"BootstrapVue provides one of the most comprehensive implementations of Bootstrap 4 components and gr","owner_id":22965283,"tags":["vue","component"],"delta":4050,"stars":7517,"created_at":"2016-10-08T15:59:35.000Z","monthly":[335,445,278,281,279,330,299,326,385,360,321,411]},{"name":"Pts","url":"https://ptsjs.org","full_name":"williamngan/pts","description":"A library for visualization and creative-coding","owner_id":4358746,"tags":["canvas","drawing"],"delta":3050,"stars":3401,"created_at":"2017-03-24T14:09:43.000Z","twitter":"","monthly":[31,31,54,161,2670,9,47,21,3,16,4,3]},{"name":"downshift","url":"http://downshift.netlify.com/","full_name":"paypal/downshift","description":"🏎 Primitive to build simple, flexible, WAI-ARIA compliant enhanced input React components","owner_id":476675,"tags":["react","autocomplete","access"],"delta":3173,"stars":6147,"created_at":"2017-07-25T14:31:42.000Z","twitter":"","monthly":[172,190,244,221,281,230,407,258,325,278,298,269]},{"name":"Kue","url":"http://automattic.github.io/kue","full_name":"Automattic/kue","description":"Kue is a priority job queue backed by redis, built for node.js.","owner_id":887802,"tags":["queue"],"delta":1318,"stars":8212,"created_at":"2011-06-27T22:37:37.000Z","monthly":[88,103,110,89,113,129,100,106,98,149,119,114]},{"name":"Bee-Queue","url":"","full_name":"bee-queue/bee-queue","description":"A simple, fast, robust job/task queue for Node.js, backed by Redis.","owner_id":30018338,"tags":["queue"],"delta":555,"stars":1217,"created_at":"2015-01-19T04:22:11.000Z","monthly":[35,36,39,34,57,56,46,60,50,50,43,49]},{"name":"Bull","url":"","full_name":"OptimalBits/bull","description":"Premium Queue package for handling jobs and messages in NodeJS.","owner_id":945399,"tags":["queue"],"delta":2016,"stars":4242,"created_at":"2013-06-27T14:35:35.000Z","monthly":[157,171,217,154,177,200,150,148,369,95,81,97]},{"name":"Agenda","url":"http://agendajs.com","full_name":"agenda/agenda","description":"Lightweight job scheduling for Node.js","owner_id":29439479,"tags":["queue"],"delta":1253,"stars":4812,"created_at":"2013-10-29T02:58:41.000Z","monthly":[73,76,81,85,117,140,130,91,105,109,80,166]},{"name":"react-map-gl","url":"https://uber.github.io/react-map-gl","full_name":"uber/react-map-gl","description":"React friendly API wrapper around MapboxGL JS","owner_id":538264,"tags":["react","map","webgl"],"delta":810,"stars":4138,"created_at":"2015-10-08T16:56:26.000Z","monthly":[60,66,73,67,84,63,74,86,69,63,46,59]},{"name":"Stencil","url":"https://stenciljs.com/","full_name":"ionic-team/stencil","description":"A Web Component compiler for building fast, reusable UI components and Progressive Web Apps 💎 Built","owner_id":3171503,"tags":["framework","webcomponent"],"delta":2774,"stars":4623,"created_at":"2017-02-15T18:57:07.000Z","twitter":"","monthly":[234,159,221,215,312,228,160,180,232,247,257,329]},{"name":"r2","url":"","full_name":"mikeal/r2","description":"HTTP client. Spiritual successor to request.","owner_id":579,"tags":["http"],"delta":242,"stars":4527,"created_at":"2017-08-30T23:50:18.000Z"},{"name":"Semiotic","url":"https://emeeks.github.io/semiotic/","full_name":"emeeks/semiotic","description":"A data visualization framework combining React & D3","owner_id":495634,"tags":["react","d3","chart"],"delta":532,"stars":1562,"created_at":"2017-03-16T17:46:24.000Z","monthly":[30,31,22,27,32,56,51,34,81,44,70,54]},{"name":"Rythm.js","url":"https://okazari.github.io/Rythm.js/","full_name":"Okazari/Rythm.js","description":"A javascript library that makes your page dance.","owner_id":5747538,"tags":["audio"],"delta":633,"stars":3489,"created_at":"2016-03-12T20:29:07.000Z","monthly":[15,61,210,86,45,17,22,7,32,52,31,55]},{"name":"Lozad","url":"https://apoorv.pro/lozad.js/demo/","full_name":"ApoorvSaxena/lozad.js","description":"🔥  Highly performant, light ~0.9kb and configurable lazy loader in pure JS with no dependencies for","owner_id":307583,"tags":["load"],"delta":1323,"stars":4748,"created_at":"2017-08-28T20:28:52.000Z","monthly":[107,114,148,185,120,76,54,69,130,70,59,191]},{"name":"Fastify","url":"https://www.fastify.io","full_name":"fastify/fastify","description":"Fast and low overhead web framework, for Node.js","owner_id":24939410,"tags":["nodejs-framework"],"delta":3377,"stars":9216,"created_at":"2016-09-28T19:10:14.000Z","monthly":[371,262,307,308,271,229,238,296,314,196,168,417]},{"name":"AssemblyScript","url":"https://assemblyscript.org","full_name":"AssemblyScript/assemblyscript","description":"A TypeScript to WebAssembly compiler 🚀","owner_id":28916798,"tags":["webassembly"],"delta":3349,"stars":3591,"created_at":"2017-09-28T11:06:50.000Z","monthly":[385,337,464,264,299,302,268,198,279,159,204,190]},{"name":"wojtekmaj/react-pdf","url":"http://projects.wojtekmaj.pl/react-pdf","full_name":"wojtekmaj/react-pdf","description":"Display PDFs in your React app as easily as if they were images.","owner_id":5426427,"tags":["react","pdf"],"delta":751,"stars":1526,"created_at":"2016-08-01T13:46:02.000Z","monthly":[58,62,78,55,68,76,65,62,70,65,54,38]},{"name":"Elm","url":"http://elm-lang.org/","full_name":"elm/compiler","description":"Compiler for Elm, a functional language for reliable webapps.","owner_id":20698192,"tags":["compiler","fp"],"delta":710,"stars":4958,"created_at":"2012-04-19T06:24:43.000Z","monthly":[57,61,63,78,94,12,29,59,46,44,75,92]},{"name":"Formik","url":"https://jaredpalmer.com/formik","full_name":"jaredpalmer/formik","description":"Build forms in React, without the tears 😭 ","owner_id":4060187,"tags":["react","form"],"delta":7853,"stars":12076,"created_at":"2017-06-14T19:50:59.000Z","twitter":"","monthly":[645,718,853,673,685,902,589,603,485,495,662,543],"icon":"formik.svg"},{"name":"Modern JavaScript Cheatsheet","url":"https://mbeaudru.github.io/modern-js-cheatsheet/","full_name":"mbeaudru/modern-js-cheatsheet","description":"Cheatsheet for the JavaScript knowledge you will frequently encounter in modern projects.","owner_id":8942633,"tags":["learning"],"delta":2839,"stars":17855,"created_at":"2017-09-18T14:56:00.000Z","monthly":[91,96,127,128,155,265,120,140,261,249,303,904]},{"name":"freeCodeCamp","url":"","full_name":"freeCodeCamp/freeCodeCamp","description":"The https://www.freeCodeCamp.org open source codebase and curriculum. Learn to code for free togethe","owner_id":9892522,"tags":["learning"],"delta":5182,"stars":296822,"created_at":"2014-12-24T17:49:19.000Z","monthly":[432,235,1816,382,617,745,232,152,261,205,71,34]},{"name":"styled-system","url":"https://jxnblk.com/styled-system/","full_name":"jxnblk/styled-system","description":":sparkles: Responsive, theme-based style props for building design systems with React","owner_id":3451712,"tags":[],"delta":1957,"stars":2925,"created_at":"2017-06-14T23:21:17.000Z","twitter":"","monthly":[140,120,162,141,237,229,148,166,146,181,199,88]},{"name":"Every Programmer Should Know","url":"","full_name":"mtdvio/every-programmer-should-know","description":"A collection of (mostly) technical things every software developer should know","owner_id":33053074,"tags":["meta"],"delta":4792,"stars":35930,"created_at":"2017-08-24T13:18:26.000Z","monthly":[278,311,267,287,333,357,336,689,428,490,490,526]},{"name":"Draggable","url":"https://shopify.github.io/draggable","full_name":"Shopify/draggable","description":"The JavaScript Drag & Drop library your grandparents warned you about.","owner_id":8085,"tags":["dnd"],"delta":2757,"stars":12384,"created_at":"2017-09-27T15:31:23.000Z","monthly":[126,203,309,258,220,181,140,166,282,285,312,275]},{"name":"Polaris","url":"https://polaris.shopify.com","full_name":"Shopify/polaris-react","description":"Shopify’s product component library","owner_id":8085,"tags":["component","react"],"delta":981,"stars":2111,"created_at":"2017-04-20T18:26:34.000Z","monthly":[85,101,83,102,80,67,141,89,41,60,57,75]},{"name":"TensorFlow.js Core API","url":"https://js.tensorflow.org","full_name":"tensorflow/tfjs-core","description":"WebGL-accelerated ML // linear algebra // automatic differentiation for JavaScript.","owner_id":15658638,"tags":["ml"],"delta":2858,"stars":8268,"created_at":"2017-08-02T14:45:47.000Z","twitter":"","monthly":[80,78,81,88,138,128,114,146,377,527,439,662]},{"name":"GraphiQL","url":"","full_name":"graphql/graphiql","description":"An in-browser IDE for exploring GraphQL.","owner_id":12972006,"tags":["graphql"],"delta":2674,"stars":7385,"created_at":"2015-08-11T02:56:22.000Z","monthly":[210,209,197,218,241,213,239,216,234,232,214,251]},{"name":"GraphQL Playground","url":"","full_name":"prisma/graphql-playground","description":"🎮  GraphQL IDE for better development workflows (GraphQL Subscriptions, interactive docs & collabor","owner_id":17219288,"tags":["graphql"],"delta":2195,"stars":3537,"created_at":"2017-01-25T13:19:29.000Z","monthly":[202,148,188,140,194,204,234,251,146,141,155,192]},{"name":"Material Design for Angular","url":"https://material.angular.io","full_name":"angular/material2","description":"Material Design components for Angular","owner_id":139426,"tags":["material","angular"],"delta":4313,"stars":16901,"created_at":"2016-01-04T18:50:02.000Z","monthly":[255,286,422,299,342,324,385,426,427,394,350,403]},{"name":"React Static","url":"https://react-static.js.org","full_name":"nozzle/react-static","description":"⚛️ 🚀 A progressive static site generator for React.","owner_id":5400727,"tags":["react","ssg"],"delta":3312,"stars":6345,"created_at":"2017-09-09T22:10:32.000Z","monthly":[227,172,291,160,142,172,199,189,543,409,538,270]},{"name":"vuera","url":"","full_name":"akxcv/vuera","description":":eyes: Vue in React, React in Vue. Seamless integration of the two. :dancers:","owner_id":17192674,"tags":["react","vue"],"delta":592,"stars":2058,"created_at":"2017-09-27T21:26:27.000Z","monthly":[51,52,43,31,82,37,89,24,47,56,31,49]},{"name":"Node.js for Mobile Apps","url":"https://code.janeasystems.com/nodejs-mobile","full_name":"janeasystems/nodejs-mobile","description":"Full-fledged Node.js on Android and iOS","owner_id":9194778,"tags":["mobile","runtime"],"delta":590,"stars":1328,"created_at":"2017-08-24T13:43:56.000Z","twitter":"","monthly":[29,55,46,68,52,37,62,58,45,47,42,49]},{"name":"react-reveal","url":"https://www.react-reveal.com/","full_name":"rnosov/react-reveal","description":"Easily add reveal on scroll animations to your React app","owner_id":6701272,"tags":["react","scrolling"],"delta":620,"stars":933,"created_at":"2016-10-11T17:58:52.000Z","monthly":[35,34,35,41,53,34,29,26,39,245,28,21]},{"name":"maptalks","url":"https://maptalks.org","full_name":"maptalks/maptalks.js","description":"A light and plugable JavaScript library for integrated 2D/3D maps.","owner_id":13678959,"tags":["map","3d"],"delta":872,"stars":1989,"created_at":"2016-02-03T02:41:32.000Z","monthly":[36,58,46,78,105,67,60,50,66,106,87,113]},{"name":"Node API boilerplate","url":"https://github.com/talyssonoc/node-api-boilerplate/wiki","full_name":"talyssonoc/node-api-boilerplate","description":"DDD/Clean Architecture inspired boilerplate for Node web APIs","owner_id":4325587,"tags":["boilerplate","nodejs-framework"],"delta":608,"stars":998,"created_at":"2017-03-13T21:16:09.000Z","twitter":"","monthly":[220,49,44,47,47,30,41,30,33,29,17,21]},{"name":"napajs","url":"","full_name":"Microsoft/napajs","description":"Napa.js: a multi-threaded JavaScript runtime","owner_id":6154722,"tags":["runtime"],"delta":1078,"stars":8463,"created_at":"2017-07-18T21:41:10.000Z","twitter":"","monthly":[53,68,58,42,48,56,117,151,117,105,98,165]},{"name":"CKEditor 5","url":"https://ckeditor.com","full_name":"ckeditor/ckeditor5","description":"Development environment for CKEditor 5 – the best browser-based rich text editor.","owner_id":825710,"tags":["rich-text-editor"],"delta":1109,"stars":1735,"created_at":"2015-01-08T12:13:59.000Z","monthly":[106,80,139,88,77,95,80,113,158,62,44,67]},{"name":"Emoji Mart","url":"https://missive.github.io/emoji-mart","full_name":"missive/emoji-mart","description":"One component to pick them all 👊🏼","owner_id":6352330,"tags":["react"],"delta":1094,"stars":1978,"created_at":"2016-07-11T18:23:47.000Z","monthly":[66,110,76,76,129,116,162,77,76,98,52,56]},{"name":"perfect-scrollbar","url":"http://utatti.github.io/perfect-scrollbar","full_name":"utatti/perfect-scrollbar","description":"Minimalistic but perfect custom scrollbar plugin","owner_id":1013641,"tags":["scrolling"],"delta":1380,"stars":6849,"created_at":"2012-11-06T12:17:46.000Z","monthly":[112,107,106,114,114,109,140,110,159,114,102,93]},{"name":"jQuery.NiceScroll","url":"https://nicescroll.areaaperta.com/","full_name":"inuyaksa/jquery.nicescroll","description":"nicescroll plugin for jquery - scrollbars like iphone/ipad","owner_id":444506,"tags":["scrolling"],"delta":340,"stars":3233,"created_at":"2011-10-26T21:21:11.000Z"},{"name":"Practical Node.js","url":"http://practicalnodebook.com","full_name":"azat-co/practicalnode","description":"Practical Node.js, 1st and 2nd Editions [Apress] 📓","owner_id":1137314,"tags":["learning","book"],"delta":406,"stars":3312,"created_at":"2013-12-21T18:17:53.000Z"},{"name":"Owl Carousel 2","url":"http://owlcarousel2.github.io/OwlCarousel2/","full_name":"OwlCarousel2/OwlCarousel2","description":"jQuery Responsive Carousel.","owner_id":18146764,"tags":["nav"],"delta":1149,"stars":6251,"created_at":"2014-04-15T01:13:48.000Z","monthly":[67,63,98,92,75,92,98,106,122,126,108,102]},{"name":"Modern JavaScript Tutorial","url":"https://javascript.info","full_name":"iliakan/javascript-tutorial-en","description":"Modern JavaScript Tutorial ","owner_id":349336,"tags":["learning"],"delta":1724,"stars":4114,"created_at":"2017-06-03T14:27:57.000Z","monthly":[221,139,152,132,120,104,185,98,156,146,126,145]},{"name":"Cypress","url":"https://www.cypress.io","full_name":"cypress-io/cypress","description":"Fast, easy and reliable testing for anything that runs in a browser.","owner_id":8908513,"tags":["test","auto"],"delta":6221,"stars":9431,"created_at":"2015-03-04T00:46:28.000Z","monthly":[392,528,513,540,627,529,542,611,493,525,408,513]},{"name":"Froala Design Blocks ","url":"https://www.froala.com/design-blocks","full_name":"froala/design-blocks","description":"A set of 170+ Bootstrap based design blocks ready to be used to create clean modern websites.","owner_id":7966884,"tags":["html"],"delta":2044,"stars":11285,"created_at":"2017-08-03T13:22:43.000Z","monthly":[431,66,54,64,50,91,99,98,107,207,275,502]},{"name":"Front-End Checklist","url":"https://frontendchecklist.io","full_name":"thedaviddias/Front-End-Checklist","description":"🗂 The perfect Front-End Checklist for modern websites and meticulous developers","owner_id":237229,"tags":["learning"],"delta":8474,"stars":32801,"created_at":"2017-10-16T10:12:36.000Z","twitter":"","monthly":[325,292,407,1501,960,1074,370,467,546,977,685,870],"icon":"frontendchecklist.jpg"},{"name":"GraphQL.js","url":"","full_name":"f/graphql.js","description":"A Simple and Isomorphic GraphQL Client for JavaScript","owner_id":196477,"tags":["graphql"],"delta":1412,"stars":1848,"created_at":"2017-02-10T08:26:13.000Z","monthly":[32,94,1173,2,7,20,15,20,15,9,11,14]},{"name":"HEML","url":"https://heml.io","full_name":"SparkPost/heml","description":"HEML is an open source markup language for building responsive email.","owner_id":9406778,"tags":["email"],"delta":536,"stars":4061,"created_at":"2017-10-09T23:16:05.000Z","monthly":[7,11,13,9,20,18,76,24,35,39,78,206]},{"name":"react-snap","url":"","full_name":"stereobooster/react-snap","description":"👻 Zero-configuration framework-agnostic static prerendering for SPAs","owner_id":179534,"tags":["react","auto","prerender"],"delta":988,"stars":1774,"created_at":"2017-10-01T01:56:32.000Z","twitter":"","monthly":[67,62,85,33,112,82,123,105,48,46,151,74]},{"name":"Prisma","url":"https://www.prisma.io","full_name":"prisma/prisma","description":"⚡️ Prisma enables seamless type-safe database access & declarative data modeling","owner_id":17219288,"tags":["graphql"],"delta":7950,"stars":12013,"created_at":"2016-09-25T12:54:40.000Z","twitter":"graphcool","monthly":[449,500,558,462,399,452,560,1282,469,571,747,1501]},{"name":"SVGR","url":"https://smooth-code.com/open-source/svgr/","full_name":"smooth-code/svgr","description":"Transform SVGs into React components 🦁","owner_id":26206404,"tags":["react","svg"],"delta":1967,"stars":4051,"created_at":"2017-09-01T21:38:42.000Z","twitter":"","monthly":[110,263,503,149,120,121,119,190,89,133,92,78]},{"name":"Frappé Charts","url":"https://frappe.io/charts","full_name":"frappe/charts","description":"Simple, responsive, modern SVG Charts with zero dependencies","owner_id":836974,"tags":["chart","svg"],"delta":2009,"stars":12067,"created_at":"2017-10-26T10:13:21.000Z","monthly":[136,203,478,45,46,39,57,91,88,330,213,283]},{"name":"react-native-navigation","url":"https://wix.github.io/react-native-navigation/","full_name":"wix/react-native-navigation","description":"A complete native navigation solution for React Native","owner_id":686511,"tags":["react-native","nav"],"delta":3673,"stars":9413,"created_at":"2016-03-11T11:22:54.000Z","monthly":[190,183,244,285,327,335,330,336,364,382,352,345]},{"name":"Ant Design Pro","url":"http://pro.ant.design/","full_name":"ant-design/ant-design-pro","description":"👨🏻‍💻👩🏻‍💻 Use Ant Design like a Pro!","owner_id":12101536,"tags":["dashboard","react"],"delta":9531,"stars":15335,"created_at":"2017-08-25T10:40:44.000Z","monthly":[842,750,680,1162,630,671,591,759,663,812,576,1395]},{"name":"Bottender","url":"https://bottender.js.org","full_name":"Yoctol/bottender","description":"⚡️ Make Bots Your Way. Fast and Flexible.","owner_id":10671553,"tags":["bot"],"delta":813,"stars":2719,"created_at":"2017-10-16T09:40:49.000Z","monthly":[30,33,72,79,90,53,34,53,85,78,96,110]},{"name":"Tailwind CSS","url":"https://tailwindcss.com/","full_name":"tailwindcss/tailwindcss","description":"A utility-first CSS framework for rapid UI development.","owner_id":30317862,"tags":["css-lib"],"delta":4933,"stars":8392,"created_at":"2017-10-06T14:59:14.000Z","monthly":[419,542,410,662,383,365,317,371,296,368,456,344]},{"name":"Devhints","url":"https://devhints.io","full_name":"rstacruz/cheatsheets","description":"My cheatsheets","owner_id":74385,"tags":["learning"],"delta":2632,"stars":5252,"created_at":"2012-03-16T06:17:34.000Z","monthly":[247,308,217,198,274,311,200,188,171,168,186,164]},{"name":"Server.js","url":"https://serverjs.io/","full_name":"franciscop/server","description":":desktop_computer: Simple and powerful server for Node.js","owner_id":2801252,"tags":["nodejs-framework","express"],"delta":322,"stars":3248,"created_at":"2016-12-20T20:51:08.000Z","twitter":"","icon":"server.svg"},{"name":"Dockly","url":"","full_name":"lirantal/dockly","description":"Immersive terminal interface for managing docker containers and services","owner_id":316371,"tags":["cli"],"delta":1375,"stars":1546,"created_at":"2016-10-22T21:47:48.000Z","monthly":[69,85,45,67,91,45,122,75,482,70,100,124]},{"name":"Wretch","url":"https://elbywan.github.io/wretch","full_name":"elbywan/wretch","description":"A tiny wrapper built around fetch with an intuitive syntax. :candy:","owner_id":3428394,"tags":["http"],"delta":926,"stars":1445,"created_at":"2017-09-13T18:27:25.000Z","monthly":[20,23,20,43,171,537,26,16,7,10,23,30]},{"name":"React Konva","url":"https://konvajs.github.io/docs/react/","full_name":"konvajs/react-konva","description":"React + Canvas = Love. JavaScript library for drawing complex canvas graphics using React.","owner_id":10717820,"tags":["react","canvas"],"delta":865,"stars":2390,"created_at":"2016-01-03T08:14:17.000Z","monthly":[53,87,62,69,67,82,79,52,56,79,112,67]},{"name":"cube-ui","url":"https://didi.github.io/cube-ui/","full_name":"didi/cube-ui","description":":large_orange_diamond: A fantastic mobile ui lib implement by Vue","owner_id":27521938,"tags":["vue","mobile"],"delta":2954,"stars":5068,"created_at":"2017-11-03T06:17:27.000Z","monthly":[297,419,125,157,208,211,174,278,375,218,158,334]},{"name":"chimee","url":"http://chimee.org/","full_name":"Chimeejs/chimee","description":"a video player framework aims to bring wonderful experience on browser","owner_id":29886630,"tags":["video"],"delta":583,"stars":1567,"created_at":"2017-06-30T02:22:02.000Z","monthly":[35,30,24,31,35,53,76,53,45,57,56,88]},{"name":"Reason","url":"http://reasonml.github.io","full_name":"facebook/reason","description":"Simple, fast & type safe code that leverages the JavaScript & OCaml ecosystems","owner_id":69631,"tags":["compiler"],"delta":2761,"stars":7044,"created_at":"2015-11-16T08:22:32.000Z","twitter":"reasonml","monthly":[133,279,192,149,165,137,208,243,150,200,286,619],"icon":"reason.svg"},{"name":"ClojureScript","url":"http://clojurescript.org/","full_name":"clojure/clojurescript","description":"Clojure to JS compiler","owner_id":317875,"tags":["compiler"],"delta":476,"stars":7944,"created_at":"2011-07-20T23:29:13.000Z"},{"name":"Sass","url":"https://npmjs.org/package/node-sass","full_name":"sass/node-sass","description":":rainbow: Node.js bindings to libsass","owner_id":317889,"tags":["css-tool"],"delta":1244,"stars":5854,"created_at":"2012-04-24T18:46:30.000Z","monthly":[84,111,99,84,106,117,100,157,99,97,91,99]},{"name":"npm-run-all","url":"","full_name":"mysticatea/npm-run-all","description":"A CLI tool to run multiple npm-scripts in parallel or sequential.","owner_id":1937871,"tags":["cli"],"delta":860,"stars":2382,"created_at":"2015-03-23T11:18:26.000Z","monthly":[107,72,59,54,64,74,76,74,62,74,76,68]},{"name":"best-resume-ever","url":"https://salomonelli.github.io/best-resume-ever","full_name":"salomonelli/best-resume-ever","description":":necktie: :briefcase: Build fast :rocket: and easy multiple beautiful resumes and create your best C","owner_id":12084165,"tags":["vue"],"delta":2595,"stars":11324,"created_at":"2017-01-30T23:02:00.000Z","monthly":[141,185,163,188,174,140,301,379,189,215,164,356]},{"name":"Papers we love","url":"http://paperswelove.org/","full_name":"papers-we-love/papers-we-love","description":"Papers from the computer science community to read and discuss.","owner_id":6187757,"tags":["learning"],"delta":4790,"stars":32831,"created_at":"2013-12-15T14:31:41.000Z","monthly":[342,378,296,347,324,397,568,359,383,484,435,477]},{"name":"Tech Interview Handbook","url":"","full_name":"yangshun/tech-interview-handbook","description":"💯 Algorithms study materials, behavioral content and tips for rocking your coding interview","owner_id":1315101,"tags":["learning"],"delta":9102,"stars":25021,"created_at":"2016-07-05T05:00:48.000Z","twitter":"","monthly":[406,547,598,671,592,581,524,492,466,1023,2058,1144]},{"name":"Node.js Best Practices","url":"https://twitter.com/nodepractices/","full_name":"i0natan/nodebestpractices","description":"The largest Node.js best practices list (January 2019)","owner_id":8571500,"tags":["learning"],"delta":10265,"stars":22213,"created_at":"2017-09-15T08:33:19.000Z","monthly":[3032,500,641,1214,1702,492,310,369,361,500,552,592]},{"name":"Functional Programming Jargon","url":"http://git.io/fp-jargons","full_name":"hemanth/functional-programming-jargon","description":"Jargon from the functional programming world in simple terms!","owner_id":18315,"tags":["learning","fp"],"delta":1028,"stars":12457,"created_at":"2015-02-22T16:04:42.000Z","monthly":[73,74,82,85,57,71,113,64,90,77,135,107]},{"name":"Probot","url":"https://probot.github.io","full_name":"probot/probot","description":"🤖 A framework for building GitHub Apps to automate and improve your workflow","owner_id":26350515,"tags":["bot"],"delta":2136,"stars":3917,"created_at":"2016-09-16T20:56:13.000Z","monthly":[136,165,285,157,198,163,166,160,171,216,138,181]},{"name":"LinguiJS ","url":"https://lingui.js.org/","full_name":"lingui/js-lingui","description":"🌍📖 A readable, automated, and optimized (5 kb) internationalization for JavaScript","owner_id":11225539,"tags":["react","i18n"],"delta":1125,"stars":2049,"created_at":"2017-01-17T17:26:46.000Z","twitter":"","monthly":[56,81,95,236,470,39,25,22,20,36,27,18]},{"name":"Luxon","url":"https://moment.github.io/luxon","full_name":"moment/luxon","description":"⏱ A library for working with dates and times in JS","owner_id":4129662,"tags":["date"],"delta":2388,"stars":7499,"created_at":"2015-11-30T12:48:48.000Z","monthly":[184,132,166,203,149,116,184,136,267,229,246,376]},{"name":"react-fns","url":"","full_name":"jaredpalmer/react-fns","description":"Browser API's turned into declarative React components and HoC's","owner_id":4060187,"tags":["react"],"delta":1075,"stars":3303,"created_at":"2017-10-14T20:19:51.000Z","monthly":[46,120,101,52,54,51,85,73,90,106,161,136]},{"name":"XState","url":"https://xstate.js.org/docs","full_name":"davidkpiano/xstate","description":"State machines and statecharts for the modern web.","owner_id":1093738,"tags":["state-machine"],"delta":3243,"stars":4023,"created_at":"2015-09-14T15:04:15.000Z","monthly":[263,936,204,225,309,242,130,96,213,157,164,304]},{"name":"Purgecss","url":"https://www.purgecss.com","full_name":"FullHuman/purgecss","description":"Remove unused css","owner_id":28688397,"tags":["css-tool"],"delta":2582,"stars":2876,"created_at":"2017-07-01T15:01:43.000Z","monthly":[116,112,75,62,161,172,130,99,94,120,360,1081]},{"name":"QUnit","url":"https://qunitjs.com","full_name":"qunitjs/qunit","description":"An easy-to-use JavaScript Unit Testing framework.","owner_id":23195278,"tags":["test-framework","test"],"delta":80,"stars":3800,"created_at":"2009-07-24T16:26:23.000Z"},{"name":"Protractor","url":"http://www.protractortest.org","full_name":"angular/protractor","description":"E2E test framework for Angular apps","owner_id":139426,"tags":["test","angular"],"delta":773,"stars":7977,"created_at":"2013-01-16T04:30:53.000Z","monthly":[39,66,35,49,69,72,71,70,69,78,80,75]},{"name":"Shaka Player","url":"","full_name":"google/shaka-player","description":"JavaScript player library / DASH & HLS client / MSE-EME player","owner_id":1342004,"tags":["video"],"delta":800,"stars":2615,"created_at":"2014-12-19T21:12:18.000Z","monthly":[72,62,58,41,76,57,59,73,73,81,88,60]},{"name":"Scrollama","url":"https://russellgoldenberg.github.io/scrollama/basic","full_name":"russellgoldenberg/scrollama","description":"Scrollytelling with IntersectionObserver.","owner_id":324631,"tags":["scrolling"],"delta":1066,"stars":3836,"created_at":"2017-10-20T13:05:29.000Z","monthly":[42,40,100,67,93,69,57,52,68,53,81,344]},{"name":"imaskjs","url":"https://unmanner.github.io/imaskjs/","full_name":"uNmAnNeR/imaskjs","description":"vanilla javascript input mask","owner_id":1927921,"tags":["plugin"],"delta":522,"stars":1581,"created_at":"2016-11-10T13:04:29.000Z","monthly":[219,16,34,32,34,28,21,64,13,15,14,32]},{"name":"Clappr","url":"http://clappr.io","full_name":"clappr/clappr","description":":clapper: An extensible media player for the web.","owner_id":10685859,"tags":["video"],"delta":583,"stars":4518,"created_at":"2014-02-14T17:36:40.000Z","monthly":[54,44,47,36,41,59,49,44,52,59,36,62]},{"name":"React Final Form","url":"","full_name":"final-form/react-final-form","description":"🏁 High performance subscription-based form state management for React","owner_id":34044827,"tags":["react","form"],"delta":2242,"stars":3400,"created_at":"2017-11-22T22:26:16.000Z","monthly":[120,207,186,153,137,150,262,167,199,223,240,198]},{"name":"Functional-Light JavaScript","url":"http://FLJSBook.com","full_name":"getify/Functional-Light-JS","description":"Pragmatic, balanced FP in JavaScript. @FLJSBook on twitter.","owner_id":150330,"tags":["fp","book"],"delta":3631,"stars":9951,"created_at":"2016-08-17T01:40:50.000Z","monthly":[177,227,319,266,174,155,223,322,290,237,240,1001]},{"name":"Superstruct","url":"","full_name":"ianstormtaylor/superstruct","description":"A simple and composable way  to validate data in Javascript.","owner_id":311752,"tags":["validation","json"],"delta":913,"stars":3692,"created_at":"2017-11-23T03:03:25.000Z","monthly":[53,37,50,84,80,28,20,42,110,76,63,270]},{"name":"Super Tiny Social Icons","url":"","full_name":"edent/SuperTinyIcons","description":"Under 1KB each! Super Tiny Icons are miniscule SVG versions of your favourite website and app logos","owner_id":837136,"tags":["icon"],"delta":1094,"stars":7171,"created_at":"2017-04-13T23:28:34.000Z","monthly":[25,33,53,47,49,29,21,40,33,66,153,545]},{"name":"Lottie","url":"","full_name":"airbnb/lottie-web","description":"Render After Effects animations natively on Web, Android and iOS, and React Native. http://airbnb.io","owner_id":698437,"tags":["animation"],"delta":5230,"stars":14781,"created_at":"2015-02-20T21:02:59.000Z","monthly":[354,368,339,277,566,401,713,438,491,506,319,458]},{"name":"Parcel","url":"https://parceljs.org","full_name":"parcel-bundler/parcel","description":"📦🚀 Blazing fast, zero configuration web application bundler","owner_id":32607881,"tags":["module","build"],"delta":14867,"stars":28953,"created_at":"2017-08-07T16:36:47.000Z","twitter":"parceljs","monthly":[543,619,767,673,865,1532,1175,766,933,1164,1463,4367]},{"name":"Stacktrace.js","url":"https://www.stacktracejs.com/","full_name":"stacktracejs/stacktrace.js","description":"Generate, parse, and enhance JavaScript stack traces in all web browsers","owner_id":6131251,"tags":["debug"],"delta":319,"stars":3281,"created_at":"2010-01-20T16:20:47.000Z"},{"name":"30 seconds of code","url":"https://30secondsofcode.org/","full_name":"30-seconds/30-seconds-of-code","description":"Curated collection of useful JavaScript snippets that you can understand in 30 seconds or less.","owner_id":43479428,"tags":["learning"],"delta":21876,"stars":35950,"created_at":"2017-11-29T17:35:03.000Z","monthly":[2122,2311,6802,2538,333,357,559,477,476,1168,1445,3288]},{"name":"Docusaurus","url":"https://docusaurus.io","full_name":"facebook/Docusaurus","description":"Easy to maintain open source documentation websites.","owner_id":69631,"tags":["doc","react"],"delta":6989,"stars":10152,"created_at":"2017-06-20T16:13:53.000Z","twitter":"","monthly":[316,384,337,509,353,283,320,334,264,381,563,2945],"icon":"docusaurus.svg"},{"name":"Microbundle","url":"","full_name":"developit/microbundle","description":"📦 Zero-configuration bundler for tiny modules.","owner_id":105127,"tags":["module","build"],"delta":1276,"stars":2892,"created_at":"2017-12-11T21:51:02.000Z","monthly":[141,109,55,87,123,68,121,67,51,77,145,232]},{"name":"NVD3","url":"http://nvd3.org/","full_name":"novus/nvd3","description":"A reusable charting library written in d3.js","owner_id":293390,"tags":["chart","d3"],"delta":466,"stars":6779,"created_at":"2012-11-15T18:51:59.000Z"},{"name":"Walt","url":"https://ballercat.github.io/walt/","full_name":"ballercat/walt","description":":zap: Walt is a JavaScript-like syntax for WebAssembly text format :zap:","owner_id":743990,"tags":["webassembly"],"delta":2624,"stars":3984,"created_at":"2017-05-13T01:52:46.000Z","monthly":[56,114,1822,31,78,38,60,104,61,61,82,117]},{"name":"Boardgame","url":"https://boardgame.io/","full_name":"nicolodavis/boardgame.io","description":"Open Source Game Engine for Turn-Based Games","owner_id":236078,"tags":["state"],"delta":2279,"stars":7094,"created_at":"2017-11-21T23:47:35.000Z","monthly":[73,79,46,108,228,140,96,120,120,222,335,712]},{"name":"x0","url":"https://compositor.io/x0/","full_name":"c8r/x0","description":"Document & develop React components without breaking a sweat","owner_id":19245838,"tags":["ssg","react"],"delta":751,"stars":1544,"created_at":"2017-09-13T02:00:34.000Z","monthly":[18,41,20,17,123,109,72,210,35,46,31,29]},{"name":"Sapper","url":"https://sapper.svelte.technology","full_name":"sveltejs/sapper","description":"Military-grade progressive web apps, powered by Svelte","owner_id":23617963,"tags":["boilerplate","isomorphic","react"],"delta":1111,"stars":1270,"created_at":"2017-12-11T13:54:33.000Z","monthly":[67,52,45,68,51,110,52,31,54,62,63,456]},{"name":"Vue Styleguidist","url":"https://vue-styleguidist.github.io","full_name":"vue-styleguidist/vue-styleguidist","description":"Created from react styleguidist for Vue Components with a living style guide","owner_id":29342568,"tags":["vue","styleguide"],"delta":663,"stars":1004,"created_at":"2017-06-11T20:44:36.000Z","monthly":[28,44,40,59,49,53,67,42,62,87,90,42]},{"name":"vue-i18n","url":"https://kazupon.github.io/vue-i18n/","full_name":"kazupon/vue-i18n","description":":globe_with_meridians: Internationalization plugin for Vue.js","owner_id":72989,"tags":["vue","i18n"],"delta":1810,"stars":3743,"created_at":"2014-05-02T17:32:14.000Z","monthly":[126,141,140,147,207,201,133,150,153,143,132,137]},{"name":"Pkg","url":"","full_name":"zeit/pkg","description":"Package your Node.js project into an executable","owner_id":14985020,"tags":["node.js","package"],"delta":3938,"stars":12461,"created_at":"2016-08-08T19:41:59.000Z","monthly":[309,735,230,261,331,312,243,276,255,344,297,345]},{"name":"TSLint","url":"http://palantir.github.io/tslint/","full_name":"palantir/tslint","description":":vertical_traffic_light: An extensible linter for the TypeScript language","owner_id":303157,"tags":["lint"],"delta":1735,"stars":4497,"created_at":"2013-07-25T22:19:18.000Z","monthly":[191,140,138,133,179,139,126,163,164,126,120,116]},{"name":"AT UI","url":"https://at.aotu.io","full_name":"AT-UI/at-ui","description":"A fresh and flat UI-Kit specially for desktop application, made with ♥ by Vue.js 2.0","owner_id":31005236,"tags":["component","desktop"],"delta":673,"stars":1756,"created_at":"2017-06-21T02:40:23.000Z","monthly":[37,45,46,60,71,51,82,72,41,51,40,77]},{"name":"React Content Loader","url":"http://danilowoz.com/create-content-loader/","full_name":"danilowoz/react-content-loader","description":":white_circle: SVG component to create placeholder loading, like Facebook cards loading. ","owner_id":4838076,"tags":["react","svg"],"delta":2744,"stars":5869,"created_at":"2017-01-20T00:30:11.000Z","monthly":[210,214,295,163,207,225,205,185,216,259,205,360]},{"name":"Mint UI","url":"http://mint-ui.github.io/#!/en","full_name":"ElemeFE/mint-ui","description":"Mobile UI elements for Vue.js","owner_id":12810740,"tags":["vue","component","mobile"],"delta":4127,"stars":13223,"created_at":"2016-05-17T09:54:10.000Z","monthly":[265,320,213,257,319,325,372,407,443,468,270,468]},{"name":"Purescript","url":"http://purescript.org","full_name":"purescript/purescript","description":"A strongly-typed language that compiles to Javascript","owner_id":6556677,"tags":["compiler","types"],"delta":1038,"stars":5389,"created_at":"2013-09-30T05:29:23.000Z","twitter":"","monthly":[59,76,77,80,101,127,53,85,94,127,66,93]},{"name":"Uppy","url":"https://uppy.io","full_name":"transloadit/uppy","description":"The next open source file uploader for web browsers :dog: ","owner_id":125754,"tags":["upload"],"delta":7334,"stars":12632,"created_at":"2015-11-16T12:32:33.000Z","twitter":"","monthly":[219,200,200,291,217,355,307,273,295,356,652,3969]},{"name":"Themer","url":"https://themer.mjswensen.com","full_name":"mjswensen/themer","description":"🎨 themer takes a set of colors and generates themes for your apps (editors, terminals, wallpapers, ","owner_id":1591879,"tags":["color"],"delta":594,"stars":1759,"created_at":"2016-11-21T13:42:28.000Z","monthly":[24,33,19,20,18,18,21,18,20,39,31,333]},{"name":"vue-meta","url":"","full_name":"declandewet/vue-meta","description":"Manage page meta info in Vue 2.0 components. SSR + Streaming supported.","owner_id":1918632,"tags":["vue"],"delta":1177,"stars":2127,"created_at":"2016-10-29T22:00:54.000Z","twitter":"","monthly":[94,109,97,80,103,89,134,115,99,87,91,79]},{"name":"Weex","url":"https://weex.apache.org","full_name":"apache/incubator-weex","description":"A framework for building Mobile cross-platform UI.","owner_id":47359,"tags":["vue","mobile"],"delta":4363,"stars":11482,"created_at":"2017-01-06T08:00:06.000Z","twitter":"","monthly":[228,302,215,215,252,283,366,459,452,521,401,669],"icon":"weex.svg"},{"name":"Nerv","url":"https://nerv.aotu.io","full_name":"NervJS/nerv","description":"A blazing fast React alternative, compatible with IE8 and React 16.","owner_id":30794937,"tags":["framework","vdom"],"delta":3570,"stars":4514,"created_at":"2017-05-07T17:20:01.000Z","twitter":"","monthly":[71,66,47,72,89,111,273,199,219,603,204,1616]},{"name":"Workerize","url":"https://github.com/developit/workerize-loader","full_name":"developit/workerize","description":"🏗️ Run a module in a Web Worker.","owner_id":105127,"tags":["webworker"],"delta":2253,"stars":3171,"created_at":"2018-01-09T21:59:27.000Z","twitter":"","monthly":[68,31,32,27,36,29,28,87,75,87,214,1539]},{"name":"KaTeX","url":"https://katex.org","full_name":"KaTeX/KaTeX","description":"Fast math typesetting for the web.","owner_id":31191489,"tags":["math"],"delta":1974,"stars":9410,"created_at":"2013-07-05T09:01:54.000Z","twitter":"","monthly":[106,123,146,161,205,141,133,156,201,134,181,287]},{"name":"ToastUI Editor ","url":"http://ui.toast.com/tui-editor","full_name":"nhnent/tui.editor","description":"🍞📝 Markdown WYSIWYG Editor. GFM Standard + Chart & UML Extensible.","owner_id":7907400,"tags":["md"],"delta":6562,"stars":7779,"created_at":"2015-07-27T06:57:23.000Z","twitter":"","monthly":[353,116,96,93,133,223,133,231,281,330,682,3891]},{"name":"Scala.js","url":"https://www.scala-js.org/","full_name":"scala-js/scala-js","description":"Scala.js, the Scala to JavaScript compiler","owner_id":6039724,"tags":["compiler"],"delta":293,"stars":3541,"created_at":"2013-02-18T16:33:55.000Z","twitter":""},{"name":"Polka","url":"","full_name":"lukeed/polka","description":"A micro web server so fast, it'll make you dance! :dancers:","owner_id":5855893,"tags":["nodejs-framework"],"delta":2125,"stars":2784,"created_at":"2017-12-22T05:55:41.000Z","twitter":"","monthly":[72,75,145,68,101,113,121,119,89,94,188,940]},{"name":"Tone.js","url":"https://tonejs.github.io","full_name":"Tonejs/Tone.js","description":"A Web Audio framework for making interactive music in the browser.","owner_id":11019186,"tags":["audio"],"delta":2006,"stars":5992,"created_at":"2014-03-11T04:56:45.000Z","twitter":"","monthly":[102,117,151,161,538,105,123,144,218,154,96,97]},{"name":"After.js","url":"","full_name":"jaredpalmer/after.js","description":"Next.js-like framework for server-rendered React apps built with React Router 4","owner_id":4060187,"tags":["nodejs-framework","react","isomorphic"],"delta":1944,"stars":2912,"created_at":"2017-11-12T03:17:02.000Z","twitter":"","monthly":[57,56,78,47,70,97,76,83,109,151,201,919]},{"name":"Xterm.js","url":"https://xtermjs.org/","full_name":"xtermjs/xterm.js","description":"A terminal for the web","owner_id":11927490,"tags":["cli"],"delta":2456,"stars":5446,"created_at":"2014-03-24T16:04:04.000Z","twitter":"","monthly":[179,195,195,198,277,298,212,187,225,190,160,140]},{"name":"Propel","url":"http://propelml.org/","full_name":"propelml/propel","description":"Differential Programming in JavaScript.","owner_id":33702266,"tags":["math"],"delta":2727,"stars":2825,"created_at":"2017-11-16T15:42:09.000Z","twitter":"","monthly":[0,5,-4,-4,0,-2,23,-2,80,1515,1045,71]},{"name":"ngx-admin","url":"http://akveo.com/ngx-admin/","full_name":"akveo/ngx-admin","description":"Admin dashboard template based on Angular 7+, Bootstrap 4 (previously known as ng2-admin)","owner_id":11921694,"tags":["angular","dashboard"],"delta":4841,"stars":14650,"created_at":"2016-05-25T10:09:03.000Z","twitter":"","monthly":[400,466,412,365,382,421,419,408,480,486,388,214]},{"name":"React Native Typography","url":"","full_name":"hectahertz/react-native-typography","description":"Pixel–perfect, native–looking typographic styles for React Native ✒️","owner_id":24622853,"tags":["react-native","typo"],"delta":768,"stars":2368,"created_at":"2017-12-04T16:12:46.000Z","twitter":"","monthly":[44,62,61,63,90,67,61,64,61,56,75,64]},{"name":"Verdaccio","url":"https://www.verdaccio.org/","full_name":"verdaccio/verdaccio","description":"📦🔐A lightweight private npm proxy registry","owner_id":18487506,"tags":["package"],"delta":3181,"stars":5270,"created_at":"2016-04-15T16:21:12.000Z","twitter":"","monthly":[248,254,263,293,353,374,410,267,193,220,233,73]},{"name":"Altair","url":"https://altair.sirmuel.design/","full_name":"imolorhe/altair","description":"✨⚡️ A beautiful feature-rich GraphQL Client for all platforms.","owner_id":4608143,"tags":["graphql"],"delta":558,"stars":770,"created_at":"2017-03-25T21:08:30.000Z","twitter":"","monthly":[52,56,56,61,60,49,63,41,45,43,25,7]},{"name":"Jarvis","url":"","full_name":"zouhir/jarvis","description":"A very intelligent browser based Webpack dashboard","owner_id":5052316,"tags":["dashboard"],"delta":1471,"stars":4943,"created_at":"2017-08-18T00:43:12.000Z","twitter":"","monthly":[28,22,10,44,54,14,16,46,114,220,576,327]},{"name":"Micron","url":"https://webkul.github.io/micron/","full_name":"webkul/micron","description":"a [μ] microInteraction library built with CSS Animations and controlled by JavaScript Power","owner_id":519857,"tags":["animation"],"delta":962,"stars":1995,"created_at":"2018-01-21T12:29:28.000Z","twitter":"","monthly":[48,15,15,15,11,26,32,26,56,157,268,293]},{"name":"urql","url":"","full_name":"FormidableLabs/urql","description":"Universal React Query Library","owner_id":5078602,"tags":["graphql","react"],"delta":1616,"stars":1766,"created_at":"2018-01-24T01:44:42.000Z","twitter":"","monthly":[78,47,22,33,38,63,67,83,66,87,535,497]},{"name":"Tabulator","url":"http://tabulator.info","full_name":"olifolkerd/tabulator","description":"Interactive Tables and Data Grids for JavaScript","owner_id":6840524,"tags":["table"],"delta":1453,"stars":1966,"created_at":"2015-10-24T13:28:31.000Z","twitter":"","monthly":[653,173,235,189,35,33,26,16,37,25,31]},{"name":"ag-grid","url":"http://www.ag-grid.com","full_name":"ag-grid/ag-grid","description":"Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components","owner_id":30720768,"tags":["table"],"delta":947,"stars":4632,"created_at":"2014-12-23T16:20:14.000Z","twitter":"","monthly":[81,132,70,90,78,127,76,79,92,85,37]},{"name":"Unstated","url":"https://unstated.io","full_name":"jamiebuilds/unstated","description":"State so simple, it goes without saying","owner_id":952783,"tags":["state"],"delta":4742,"stars":5699,"created_at":"2018-01-31T13:56:02.000Z","twitter":"","monthly":[224,409,577,87,174,193,224,290,504,909,1151]},{"name":"node-clinic","url":"https://clinicjs.org","full_name":"nearform/node-clinic","description":"Clinic diagnoses your Node.js performance issues","owner_id":1544687,"tags":["process"],"delta":1368,"stars":2171,"created_at":"2018-01-17T12:54:38.000Z","twitter":"","monthly":[97,167,57,58,246,131,186,30,57,108,231]},{"name":"Automerge","url":"","full_name":"automerge/automerge","description":"A JSON-like data structure (a CRDT) that can be modified concurrently by different users, and merged","owner_id":29780209,"tags":["data-structure"],"delta":3632,"stars":6152,"created_at":"2017-04-19T15:25:24.000Z","twitter":"","monthly":[64,158,137,37,58,75,88,111,139,353,2412]},{"name":"Hygen","url":"http://hygen.io","full_name":"jondot/hygen","description":"The simple, fast, and scalable code generator that lives in your project.","owner_id":83390,"tags":["scaffolding"],"delta":1187,"stars":1557,"created_at":"2017-08-13T07:38:43.000Z","twitter":"","monthly":[55,74,96,80,29,44,49,65,106,118,471]},{"name":"Objection.js","url":"http://vincit.github.io/objection.js","full_name":"Vincit/objection.js","description":"An SQL-friendly ORM for Node.js","owner_id":710715,"tags":["db"],"delta":1228,"stars":3354,"created_at":"2015-04-14T10:36:51.000Z","twitter":"","monthly":[76,92,92,65,86,103,90,89,105,152,278]},{"name":"React Material Web Components","url":"https://jamesmfriedman.github.io/rmwc/","full_name":"jamesmfriedman/rmwc","description":"A React wrapper for Material Design (Web) Components","owner_id":975256,"tags":["react","component","material"],"delta":583,"stars":933,"created_at":"2017-08-15T11:55:31.000Z","twitter":"","monthly":[29,56,33,42,31,51,58,125,55,57,46]},{"name":"Rematch","url":"https://rematch.gitbooks.io/rematch","full_name":"rematch/rematch","description":"A Redux Framework","owner_id":32424830,"tags":["redux"],"delta":4528,"stars":4844,"created_at":"2017-10-01T01:29:27.000Z","twitter":"","monthly":[89,139,170,99,146,225,377,401,354,2444,84]},{"name":"React-Draggable","url":"","full_name":"mzabriskie/react-draggable","description":"React draggable component","owner_id":199035,"tags":["react","dnd"],"delta":1272,"stars":4074,"created_at":"2014-07-24T22:32:16.000Z","twitter":"","monthly":[75,81,94,95,127,202,86,93,88,170,161]},{"name":"Pressure.js","url":"https://pressurejs.com","full_name":"stuyam/pressure","description":":point_down::boom:  JavaScript library for handling Force Touch, 3D Touch, and Pointer Pressure.","owner_id":1553779,"tags":["touch"],"delta":516,"stars":2348,"created_at":"2015-10-23T06:30:29.000Z","twitter":"","monthly":[26,17,22,12,19,26,27,24,80,170,93]},{"name":"30 Seconds of CSS","url":"https://30-seconds.github.io/30-seconds-of-css/","full_name":"30-seconds/30-seconds-of-css","description":"A curated collection of useful CSS snippets you can understand in 30 seconds or less.","owner_id":43479428,"tags":["learning"],"delta":8526,"stars":11047,"created_at":"2018-02-25T13:22:25.000Z","twitter":"","monthly":[317,514,1005,263,157,183,295,257,645,4890]},{"name":"React Morph","url":"https://brunnolou.github.io/react-morph/?down=0","full_name":"brunnolou/react-morph","description":"Morphing Ui transitions made simple","owner_id":2729225,"tags":["react","animation"],"delta":784,"stars":2230,"created_at":"2018-02-12T00:14:52.000Z","twitter":"","monthly":[-1,28,34,2,7,19,10,26,36,623]},{"name":"Prompts","url":"","full_name":"terkelg/prompts","description":"❯ Lightweight, beautiful and user-friendly interactive prompts.","owner_id":2302254,"tags":["cli"],"delta":3251,"stars":4530,"created_at":"2018-02-24T10:11:47.000Z","twitter":"","monthly":[82,62,72,78,159,98,46,58,147,2449]},{"name":"vue-cli","url":"https://cli.vuejs.org/","full_name":"vuejs/vue-cli","description":"🛠️ Standard Tooling for Vue.js Development","owner_id":6128107,"tags":["vue"],"delta":9807,"stars":18252,"created_at":"2015-12-26T23:11:20.000Z","twitter":"","monthly":[645,653,518,722,1138,847,1090,1088,865,956,694,591]},{"name":"Flatbush","url":"","full_name":"mourner/flatbush","description":"A very fast static spatial index for 2D points and rectangles in JavaScript","owner_id":25395,"tags":["map"],"delta":600,"stars":817,"created_at":"2018-02-27T08:57:21.000Z","twitter":"","monthly":[5,27,431,-1,4,9,9,14,13,89]},{"name":"BasicScroll","url":"https://basicscroll.electerious.com","full_name":"electerious/basicScroll","description":"Standalone parallax scrolling for mobile and desktop with CSS variables.","owner_id":499088,"tags":["scrolling"],"delta":1174,"stars":2981,"created_at":"2016-10-30T22:37:00.000Z","twitter":"","monthly":[22,51,23,31,118,32,55,99,121,622]},{"name":"Pandora","url":"http://www.midwayjs.org/pandora","full_name":"midwayjs/pandora","description":"A Manageable, Measurable and Traceable Node.js Application Manager represented by Alibaba powered by","owner_id":32128461,"tags":["process"],"delta":1107,"stars":2524,"created_at":"2017-10-02T11:59:49.000Z","twitter":"","monthly":[36,45,32,44,50,59,78,96,145,522]},{"name":"Konva","url":"http://konvajs.github.io/","full_name":"konvajs/konva","description":"Konva.js is an HTML5 Canvas JavaScript framework that extends the 2d context by enabling canvas inte","owner_id":10717820,"tags":["canvas"],"delta":934,"stars":3305,"created_at":"2015-01-09T10:14:35.000Z","twitter":"","monthly":[83,88,94,107,68,62,76,75,119,162]},{"name":"React Cosmos","url":"https://react-cosmos.github.io/","full_name":"react-cosmos/react-cosmos","description":"Dev tool for creating reusable React components","owner_id":23018767,"tags":["react","test"],"delta":1073,"stars":4564,"created_at":"2014-02-05T18:48:27.000Z","twitter":"","monthly":[115,59,102,78,105,96,111,135,170,102]},{"name":"React Live","url":"https://react-live.kitten.sh/","full_name":"FormidableLabs/react-live","description":"A production-focused playground for live editing React components","owner_id":5078602,"tags":["react","test"],"delta":533,"stars":1397,"created_at":"2017-04-01T05:07:34.000Z","twitter":"","monthly":[38,31,70,55,162,25,38,54,31,29]},{"name":"Awaity.js","url":"","full_name":"asfktz/Awaity.js","description":"A functional, lightweight alternative to bluebird.js, built with async / await in mind.","owner_id":199747,"tags":["flow"],"delta":604,"stars":767,"created_at":"2018-02-24T19:43:46.000Z","twitter":"","monthly":[2,6,7,-3,13,3,14,54,188,320]},{"name":"Workly","url":"","full_name":"pshihn/workly","description":"A really simple way to move a function or class to a web worker. 🏋️‍♀️→ 😄","owner_id":833927,"tags":["webworker"],"delta":1507,"stars":1656,"created_at":"2018-02-22T22:23:19.000Z","twitter":"","monthly":[5,10,12,4,33,36,52,137,120,1098]},{"name":"Driver.js","url":"http://kamranahmed.info/driver.js","full_name":"kamranahmedse/driver.js","description":"A light-weight, no-dependency, vanilla JavaScript engine to drive the user's focus across the page","owner_id":4921183,"tags":["presentation"],"delta":4737,"stars":9109,"created_at":"2018-03-11T19:52:13.000Z","twitter":"","monthly":[71,122,108,105,145,154,152,296,1258,2326]},{"name":"Rough.js","url":"http://roughjs.com","full_name":"pshihn/rough","description":"Create graphics with a hand-drawn, sketchy, appearance","owner_id":833927,"tags":["drawing","canvas"],"delta":4729,"stars":10128,"created_at":"2016-12-13T09:12:55.000Z","twitter":"","monthly":[87,71,94,88,127,257,847,505,930,1723]},{"name":"ToastUI Chart","url":"http://ui.toast.com/tui-chart/","full_name":"nhnent/tui.chart","description":"🍞📊  Beautiful chart for data visualization.","owner_id":7907400,"tags":["chart"],"delta":2404,"stars":4006,"created_at":"2015-07-31T01:18:56.000Z","twitter":"","monthly":[28,18,17,13,42,67,36,193,599,1391]},{"name":"Stimulus","url":"https://stimulusjs.org/","full_name":"stimulusjs/stimulus","description":"A modest JavaScript framework for the HTML you already have","owner_id":32970053,"tags":["framework"],"delta":1409,"stars":6692,"created_at":"2016-12-17T00:19:29.000Z","twitter":"","monthly":[86,114,161,136,244,158,96,118,196,100]},{"name":"NGXS","url":"http://ngxs.io","full_name":"ngxs/store","description":"🚀 NGXS - State Management for Angular ","owner_id":37132593,"tags":["state","angular"],"delta":1416,"stars":1764,"created_at":"2018-02-13T18:55:44.000Z","twitter":"","monthly":[78,93,97,93,114,114,201,192,320,114]},{"name":"Filepond","url":"https://pqina.nl/filepond","full_name":"pqina/filepond","description":"🌊 A flexible and fun JavaScript file upload library","owner_id":22966117,"tags":["upload","react","vue"],"delta":2505,"stars":4717,"created_at":"2017-10-09T12:17:44.000Z","twitter":"","monthly":[132,166,192,125,169,200,233,556,621,111]},{"name":"Webdash","url":"https://webdash.xyz","full_name":"jadjoubran/webdash","description":"🔥 Orchestrate your web project with Webdash the customizable web dashboard","owner_id":2265232,"tags":["dashboard"],"delta":632,"stars":1426,"created_at":"2018-01-31T09:13:53.000Z","twitter":"","monthly":[1,8,7,9,11,20,19,51,249,257]},{"name":"Noty","url":"https://ned.im/noty","full_name":"needim/noty","description":"Dependency-free notification library that makes it easy to create alert - success - error - warning ","owner_id":271912,"tags":["notify"],"delta":364,"stars":6183,"created_at":"2012-01-28T09:15:14.000Z","twitter":""},{"name":"Hotkeys","url":"https://git.io/hotkeys.js","full_name":"jaywcjlove/hotkeys","description":"➷ A robust Javascript library for capturing keyboard input. It has no dependencies. ","owner_id":1680273,"tags":["keyboard"],"delta":1812,"stars":2986,"created_at":"2015-05-18T17:49:52.000Z","twitter":"","monthly":[52,65,133,51,46,61,99,905,400]},{"name":"TensorFlow.js","url":"https://js.tensorflow.org","full_name":"tensorflow/tfjs","description":"A WebGL accelerated JavaScript library for training and deploying ML models.","owner_id":15658638,"tags":["ml","webgl"],"delta":7022,"stars":10107,"created_at":"2018-03-05T05:41:02.000Z","twitter":"","monthly":[294,345,314,301,321,449,481,942,3575]},{"name":"Egg","url":"https://eggjs.org","full_name":"eggjs/egg","description":"🥚 Born to build better enterprise frameworks and apps with Node.js & Koa","owner_id":15833670,"tags":["nodejs-framework"],"delta":4897,"stars":11244,"created_at":"2016-06-18T06:53:23.000Z","twitter":"","monthly":[352,376,307,457,353,385,345,522,489,501,305,505]},{"name":"Expo","url":"https://docs.expo.io/","full_name":"expo/expo","description":"The Expo platform for making cross-platform mobile apps","owner_id":12504344,"tags":["mobile","react-native"],"delta":1804,"stars":4922,"created_at":"2016-08-15T17:14:25.000Z","twitter":"","monthly":[205,278,305,139,160,145,204,187,181]},{"name":"react-testing-library","url":"","full_name":"kentcdodds/react-testing-library","description":"🐐 Simple and complete React DOM testing utilities that encourage good testing practices.","owner_id":1500684,"tags":["test","react"],"delta":3061,"stars":4568,"created_at":"2018-03-19T13:39:49.000Z","twitter":"","monthly":[300,495,435,319,313,270,260,316,353]},{"name":"Glide","url":"https://glidejs.com","full_name":"glidejs/glide","description":"A dependency-free JavaScript ES6 slider and carousel. It’s lightweight, flexible and fast. Designed ","owner_id":37380006,"tags":["nav"],"delta":1726,"stars":3802,"created_at":"2013-08-19T10:23:34.000Z","twitter":"","monthly":[73,91,60,74,85,115,86,185,957]},{"name":"colors.js","url":" https://github.com/Marak/colors.js","full_name":"Marak/colors.js","description":"get colors in your node.js console","owner_id":70011,"tags":["cli"],"delta":379,"stars":3487,"created_at":"2010-06-11T06:48:43.000Z","twitter":""},{"name":"Tabler","url":"https://tabler.io/","full_name":"tabler/tabler","description":"Tabler is free and open-source HTML Dashboard UI Kit built on Bootstrap 4","owner_id":35471246,"tags":["html","dashboard"],"delta":10272,"stars":16823,"created_at":"2018-02-01T09:08:59.000Z","twitter":"","monthly":[240,285,288,315,349,471,594,1888,5842]},{"name":"React-spring","url":"https://react-spring.github.io","full_name":"react-spring/react-spring","description":"✌️ A spring physics based React animation library","owner_id":45790596,"tags":["react","animation"],"delta":6232,"stars":9215,"created_at":"2018-03-07T15:39:32.000Z","twitter":"","monthly":[486,451,557,464,754,302,482,901,1835]},{"name":"Javascript State Machine","url":"","full_name":"jakesgordon/javascript-state-machine","description":"A javascript finite state machine library","owner_id":738109,"tags":["state-machine"],"delta":1060,"stars":5864,"created_at":"2011-06-01T22:02:01.000Z","twitter":"","monthly":[90,93,116,84,127,88,73,117,272]},{"name":"Front-End Developer Handbook 2018","url":"https://frontendmasters.com/books/front-end-handbook/2018/","full_name":"FrontendMasters/front-end-handbook-2018","description":"2018 edition of our front-end development handbook","owner_id":5613852,"tags":["learning"],"delta":2220,"stars":3797,"created_at":"2017-11-17T20:44:30.000Z","twitter":"","monthly":[123,104,126,161,119,124,135,241,1087]},{"name":"The JavaScript Way","url":"https://leanpub.com/thejsway","full_name":"bpesquet/thejsway","description":"The JavaScript Way book","owner_id":1837749,"tags":["learning","book"],"delta":274,"stars":6504,"created_at":"2016-12-12T19:49:14.000Z","twitter":""},{"name":"VuePress","url":"https://vuepress.vuejs.org/","full_name":"vuejs/vuepress","description":"📝 Minimalistic Vue-powered static site generator","owner_id":6128107,"tags":["vue","ssg"],"delta":10364,"stars":10647,"created_at":"2018-04-05T16:58:38.000Z","twitter":"","monthly":[425,424,320,473,564,443,532,1194,5989]},{"name":"Dinero.js","url":"https://sarahdayan.github.io/dinero.js","full_name":"sarahdayan/dinero.js","description":"💸 An immutable library to create, calculate and format money.","owner_id":5370675,"tags":["format","money"],"delta":1691,"stars":2490,"created_at":"2018-03-10T23:56:04.000Z","twitter":"","monthly":[47,466,263,24,35,60,115,413,268]},{"name":"Permit","url":"","full_name":"ianstormtaylor/permit","description":"An unopinionated authentication library for building Node.js APIs.","owner_id":311752,"tags":["auth"],"delta":1011,"stars":1229,"created_at":"2018-04-19T00:43:11.000Z","twitter":"","monthly":[94,9,10,1,10,16,42,258,571]},{"name":"React in Patterns","url":"https://www.gitbook.com/book/krasimir/react-in-patterns/","full_name":"krasimir/react-in-patterns","description":"A free book that talks about design patterns/techniques used while developing with React.","owner_id":528677,"tags":["book","learning","react"],"delta":3752,"stars":10148,"created_at":"2016-06-20T07:53:11.000Z","twitter":"","monthly":[47,52,59,71,93,134,200,981,2115]},{"name":"CSS Blocks","url":"http://css-blocks.com/","full_name":"linkedin/css-blocks","description":"High performance, maintainable stylesheets.","owner_id":357098,"tags":["css-tool"],"delta":3827,"stars":5899,"created_at":"2017-04-13T23:44:11.000Z","twitter":"","monthly":[36,42,46,71,76,88,175,1134,2159]},{"name":"Day.js","url":"https://github.com/iamkun/dayjs","full_name":"iamkun/dayjs","description":"⏰ Day.js 2KB immutable date library alternative to Moment.js with the same modern API","owner_id":17680888,"tags":["date"],"delta":14557,"stars":17680,"created_at":"2018-04-10T09:26:44.000Z","twitter":"","monthly":[688,1090,505,1206,1046,417,1305,5034,3266]},{"name":"CCXT","url":"","full_name":"ccxt/ccxt","description":"A JavaScript / Python / PHP cryptocurrency trading library with support for more than 130 bitcoin/al","owner_id":31901609,"tags":["crypto-currency"],"delta":3641,"stars":9696,"created_at":"2017-05-14T15:41:56.000Z","twitter":"","monthly":[268,364,262,359,438,507,613,751,79]},{"name":"TypeORM","url":"http://typeorm.io","full_name":"typeorm/typeorm","description":"ORM for TypeScript and JavaScript (ES7, ES6, ES5). Supports MySQL, PostgreSQL, MariaDB, SQLite, MS S","owner_id":20165699,"tags":["db"],"delta":4118,"stars":10174,"created_at":"2016-02-29T07:41:14.000Z","twitter":"","monthly":[587,485,518,492,448,475,440,554,119]},{"name":"react-copy-write","url":"","full_name":"aweary/react-copy-write","description":"✍️ Immutable state with a mutable API ","owner_id":6886061,"tags":["state","react"],"delta":730,"stars":1698,"created_at":"2018-04-09T01:14:52.000Z","twitter":"","monthly":[11,28,36,309,63,40,51,174,18]},{"name":"ToastUI Calendar","url":"http://ui.toast.com/tui-calendar","full_name":"nhnent/tui.calendar","description":"🍞📅A JavaScript calendar that has everything you need.","owner_id":7907400,"tags":["date"],"delta":4919,"stars":6743,"created_at":"2017-09-11T00:21:04.000Z","twitter":"","monthly":[208,103,59,102,109,253,233,3135,717]},{"name":"MDX","url":"https://mdxjs.com","full_name":"mdx-js/mdx","description":"JSX in Markdown for ambitious projects","owner_id":37453691,"tags":["md"],"delta":3644,"stars":5066,"created_at":"2017-12-24T00:01:48.000Z","twitter":"","monthly":[237,279,279,439,788,426,257,939]},{"name":"ReLaXed","url":"","full_name":"RelaxedJS/ReLaXed","description":"Create PDF documents using web technologies","owner_id":37601651,"tags":["pdf"],"delta":9640,"stars":10533,"created_at":"2018-03-21T08:33:48.000Z","twitter":"","monthly":[55,44,157,112,103,218,913,8038]},{"name":"Big","url":"http://macwright.org/big/demo.html","full_name":"tmcw/big","description":"presentations for busy messy hackers","owner_id":32314,"tags":["presentation"],"delta":1680,"stars":2868,"created_at":"2011-09-13T21:39:10.000Z","twitter":"","monthly":[14,12,10,40,27,25,45,1507]},{"name":"Proton Native","url":"https://proton-native.js.org","full_name":"kusti8/proton-native","description":"A React environment for cross platform native desktop apps","owner_id":9812956,"tags":["desktop"],"delta":4037,"stars":8359,"created_at":"2017-11-21T22:56:18.000Z","twitter":"","monthly":[128,83,108,162,106,146,449,2855]},{"name":"Impact","url":"http://impactjs.com/","full_name":"phoboslab/Impact","description":"HTML5 Game Engine","owner_id":443987,"tags":["game"],"delta":521,"stars":1294,"created_at":"2018-05-03T09:30:19.000Z","twitter":"","monthly":[21,12,27,35,27,20,36,343]},{"name":"LayerJS","url":"https://layerjs.org","full_name":"layerJS/layerJS","description":"layerJS: Javascript UI composition framework","owner_id":20395345,"tags":["layout","nav","touch","animation"],"delta":1055,"stars":1595,"created_at":"2016-07-11T11:36:40.000Z","twitter":"","monthly":[7,13,5,7,16,75,161,771]},{"name":"Ow","url":"","full_name":"sindresorhus/ow","description":"Function argument validation for humans","owner_id":170270,"tags":["validation"],"delta":1313,"stars":2510,"created_at":"2017-09-29T03:46:31.000Z","twitter":"","monthly":[17,37,26,26,33,45,142,987]},{"name":"Guess.js","url":"https://guess-js.github.io/","full_name":"guess-js/guess","description":"Libraries & tools for enabling Machine Learning driven user-experiences on the web","owner_id":37966830,"tags":["ml","performance"],"delta":3996,"stars":4751,"created_at":"2018-04-02T01:58:19.000Z","twitter":"","monthly":[142,160,287,1001,181,242,237,1746]},{"name":"isomorphic-git","url":"https://isomorphic-git.org/","full_name":"isomorphic-git/isomorphic-git","description":"A pure JavaScript implementation of git for node and browsers!","owner_id":34904042,"tags":["serviceworker","webworker"],"delta":3019,"stars":3606,"created_at":"2017-07-30T02:26:00.000Z","twitter":"","monthly":[120,47,40,50,87,84,223,2368]},{"name":"React Sortable Tree","url":"https://frontend-collective.github.io/react-sortable-tree/","full_name":"frontend-collective/react-sortable-tree","description":"Drag-and-drop sortable component for nested data and hierarchies","owner_id":38798818,"tags":["tree","dnd","react"],"delta":544,"stars":2306,"created_at":"2016-07-22T08:36:25.000Z","twitter":"","monthly":[55,62,76,86,82,77,71,35]},{"name":"mobx-state-tree","url":"","full_name":"mobxjs/mobx-state-tree","description":"Model Driven State Management","owner_id":17475736,"tags":["state"],"delta":1104,"stars":3778,"created_at":"2016-09-04T18:28:25.000Z","twitter":"","monthly":[103,142,151,137,177,163,118,113]},{"name":"Vue Element Admin","url":"http://panjiachen.github.io/vue-element-admin","full_name":"PanJiaChen/vue-element-admin","description":"A magical vue admin","owner_id":8121621,"tags":["vue","dashboard"],"delta":17281,"stars":25080,"created_at":"2017-04-17T03:35:49.000Z","twitter":"","monthly":[1582,1545,1350,1708,1578,1838,1604,1602,1324,1370,696,1084],"icon":"vueelementadmin.png"},{"name":"Signale","url":"","full_name":"klaussinani/signale","description":"👋 Hackable console logger","owner_id":12670537,"tags":["log"],"delta":5386,"stars":7085,"created_at":"2018-04-08T16:04:09.000Z","twitter":"","monthly":[226,123,106,225,275,289,913,3229]},{"name":"DefinitelyTyped","url":"http://definitelytyped.org/","full_name":"DefinitelyTyped/DefinitelyTyped","description":"The repository for high quality TypeScript type definitions.","owner_id":3637556,"tags":["types"],"delta":3815,"stars":19550,"created_at":"2012-10-05T16:39:45.000Z","twitter":"","monthly":[615,569,588,490,507,458,451,137]},{"name":"Vuido","url":"https://vuido.mimec.org/","full_name":"mimecorg/vuido","description":"Native desktop applications using Vue.js.","owner_id":36986002,"tags":["desktop","vue"],"delta":3915,"stars":5455,"created_at":"2018-05-17T18:12:02.000Z","twitter":"","monthly":[43,42,100,309,58,210,1034,2119]},{"name":"Omi","url":"http://omijs.org","full_name":"Tencent/omi","description":"Next generation web framework using web components with omio fallback(IE8+) in tiny js. ","owner_id":18461506,"tags":["framework"],"delta":5091,"stars":6727,"created_at":"2015-05-31T14:24:58.000Z","twitter":"","monthly":[691,1134,3060,96,23,28,35,24],"icon":"omi.svg"},{"name":"React Native DOM","url":"https://rntester.now.sh","full_name":"vincentriemer/react-native-dom","description":"An experimental, comprehensive port of React Native to the web.","owner_id":1398555,"tags":["react-native"],"delta":1038,"stars":2937,"created_at":"2017-11-28T20:59:30.000Z","twitter":"","monthly":[58,40,76,46,73,149,219,377]},{"name":"Stylelint","url":"https://stylelint.io/","full_name":"stylelint/stylelint","description":"A mighty, modern style linter","owner_id":10076935,"tags":["lint"],"delta":851,"stars":5777,"created_at":"2014-12-04T16:25:23.000Z","twitter":"","monthly":[92,129,121,85,131,148,115,30]},{"name":"JS Algorithms & Data Structures","url":"","full_name":"trekhleb/javascript-algorithms","description":"📝 Algorithms and data structures implemented in JavaScript with explanations and links to further r","owner_id":3000285,"tags":["learning","data-structure"],"delta":38986,"stars":41938,"created_at":"2018-03-24T07:47:04.000Z","twitter":"","monthly":[1971,1061,961,1805,4604,5896,8274,14414]},{"name":"Saber.js","url":"","full_name":"egoist/saber.js","description":"A minimalistic framework for building static website using Vue.js","owner_id":8784712,"tags":["vue","ssg"],"delta":638,"stars":846,"created_at":"2018-05-23T16:41:21.000Z","twitter":"","monthly":[-1,2,3,-2,13,28,134,461]},{"name":"hybrids","url":"https://hybrids.js.org","full_name":"hybridsjs/hybrids","description":"🖍 UI library for creating Web Components with simple and functional API","owner_id":22907385,"tags":["webcomponent"],"delta":730,"stars":878,"created_at":"2016-12-06T20:19:43.000Z","twitter":"","monthly":[51,58,30,2,24,58,150,357]},{"name":"wired-elements","url":"https://wiredjs.com","full_name":"wiredjs/wired-elements","description":"Collection of elements that appear hand drawn. Great for wireframes.","owner_id":29725493,"tags":["component","webcomponent"],"delta":4821,"stars":6403,"created_at":"2017-08-28T06:12:03.000Z","twitter":"","monthly":[45,62,62,33,53,221,1597,2748]},{"name":"Web Components","url":"http://webcomponents.org/polyfills/","full_name":"webcomponents/webcomponentsjs","description":"A suite of polyfills supporting the HTML Web Components specs","owner_id":1905708,"tags":["webcomponent"],"delta":468,"stars":3312,"created_at":"2014-10-09T18:56:42.000Z","twitter":""},{"name":"Hoodie","url":"http://hood.ie","full_name":"hoodiehq/hoodie","description":":dog: The Offline First JavaScript Backend","owner_id":1888826,"tags":["offline"],"delta":187,"stars":3390,"created_at":"2012-06-25T10:44:38.000Z","twitter":""},{"name":"Deno","url":"https://deno.land/","full_name":"denoland/deno","description":"A secure TypeScript runtime on V8","owner_id":42048915,"tags":["runtime"],"delta":21636,"stars":28926,"created_at":"2018-05-15T01:34:26.000Z","twitter":"","monthly":[1015,817,908,835,1413,1881,14767]},{"name":"Reach Router","url":"https://reach.tech/router","full_name":"reach/router","description":"Next Generation Routing for React","owner_id":38740568,"tags":["react","routing","access"],"delta":3428,"stars":4605,"created_at":"2018-05-25T04:47:48.000Z","twitter":"","monthly":[131,213,235,326,432,157,1934]},{"name":"Critters","url":"","full_name":"GoogleChromeLabs/critters","description":"🦔 A Webpack plugin to inline your critical CSS and lazy-load the rest.","owner_id":31970254,"tags":["performance"],"delta":1179,"stars":1966,"created_at":"2018-05-30T18:01:01.000Z","twitter":"","monthly":[72,65,31,28,26,77,880]},{"name":"Sucrase","url":"https://sucrase.io","full_name":"alangpierce/sucrase","description":"Super-fast alternative to Babel for when you can target modern JS runtimes","owner_id":211605,"tags":["compiler"],"delta":516,"stars":1038,"created_at":"2017-10-03T16:54:00.000Z","twitter":"","monthly":[50,12,24,22,11,66,331]},{"name":"Comlink","url":"","full_name":"GoogleChromeLabs/comlink","description":"Comlink makes WebWorkers enjoyable.","owner_id":31970254,"tags":["webworker"],"delta":632,"stars":1573,"created_at":"2017-09-06T11:43:38.000Z","twitter":"","monthly":[65,103,134,19,41,70,200]},{"name":"react-modal","url":"https://reactjs.github.io/react-modal","full_name":"reactjs/react-modal","description":"Accessible modal dialog component for React","owner_id":6412038,"tags":["react","modal"],"delta":667,"stars":4407,"created_at":"2014-09-21T01:30:33.000Z","twitter":"","monthly":[83,95,96,81,109,106,97]},{"name":"react-ideal-image","url":"https://github.com/stereobooster/react-ideal-image/blob/master/introduction.md","full_name":"stereobooster/react-ideal-image","description":"🖼️ An Almost Ideal React Image Component","owner_id":179534,"tags":["react","load"],"delta":1470,"stars":2859,"created_at":"2018-05-20T19:38:51.000Z","twitter":"","monthly":[25,14,45,110,52,164,1060]},{"name":"30 Seconds of Interviews","url":"https://30secondsofinterviews.org","full_name":"30-seconds/30-seconds-of-interviews","description":"A curated collection of common interview questions to help you prepare for your next interview.","owner_id":43479428,"tags":["learning"],"delta":3946,"stars":5303,"created_at":"2018-04-07T20:11:31.000Z","twitter":"","monthly":[287,256,537,319,910,190,1447]},{"name":"Pickr","url":"https://simonwep.github.io/pickr/","full_name":"Simonwep/pickr","description":"Flat, simple, responsive and hackable Color-Picker. No dependencies, no jQuery. Compatible with all ","owner_id":30767528,"tags":["color"],"delta":1208,"stars":1282,"created_at":"2018-05-27T19:39:23.000Z","twitter":"","monthly":[16,17,24,18,69,83,981]},{"name":"G6","url":"https://antv.alipay.com/zh-cn/g6/1.x/index.html","full_name":"antvis/g6","description":"A Graph Visualization Framework in JavaScript","owner_id":19199542,"tags":["chart"],"delta":1328,"stars":3440,"created_at":"2017-02-13T10:00:43.000Z","twitter":"","monthly":[121,116,106,231,165,163,426]},{"name":"ml5.js","url":"https://ml5js.org","full_name":"ml5js/ml5-library","description":"Friendly machine learning for the web! 🤖 ","owner_id":36965392,"tags":["ml"],"delta":1564,"stars":2182,"created_at":"2017-10-03T20:45:07.000Z","twitter":"","monthly":[73,115,65,64,135,148,964]},{"name":"Vivid.js","url":"https://webkul.github.io/vivid","full_name":"webkul/vivid","description":"a JavaScript library which is built to easily customize and use the SVG Icons with a blaze.","owner_id":519857,"tags":["icon","svg"],"delta":1071,"stars":1576,"created_at":"2018-06-10T18:26:20.000Z","twitter":"","monthly":[7,12,15,14,15,118,890]},{"name":"Sonar","url":"https://fbflipper.com/","full_name":"facebook/flipper","description":"A desktop debugging platform for mobile developers.","owner_id":69631,"tags":["mobile"],"delta":3139,"stars":4593,"created_at":"2018-04-12T16:47:36.000Z","twitter":"","monthly":[94,140,113,194,145,374,2079]},{"name":"Vue Native","url":"https://vue-native.io","full_name":"GeekyAnts/vue-native-core","description":"Vue Native is a framework to build cross platform native mobile apps using JavaScript","owner_id":18482943,"tags":["mobile","vue"],"delta":3453,"stars":5384,"created_at":"2018-02-23T11:44:30.000Z","twitter":"","monthly":[181,152,160,174,220,322,2244]},{"name":"Docz","url":"https://docz.site","full_name":"pedronauck/docz","description":"✍🏻It has never been so easy to document your things!","owner_id":2029172,"tags":["react","doc"],"delta":9157,"stars":12488,"created_at":"2018-03-17T04:24:10.000Z","twitter":"","monthly":[595,487,517,1092,2117,1486,2863],"icon":"docz.png"},{"name":"Polly.JS","url":"https://netflix.github.io/pollyjs","full_name":"Netflix/pollyjs","description":"Record, Replay, and Stub HTTP Interactions.","owner_id":913567,"tags":["test"],"delta":3906,"stars":7063,"created_at":"2018-05-31T20:39:44.000Z","twitter":"","monthly":[56,220,77,105,254,814,2380]},{"name":"Vuesax","url":"https://lusaxweb.github.io/vuesax/","full_name":"lusaxweb/vuesax","description":"New Framework Components for Vue.js 2","owner_id":35979086,"tags":["vue","component"],"delta":1435,"stars":2645,"created_at":"2018-01-30T23:53:19.000Z","twitter":"","monthly":[55,83,202,545,159,144,247]},{"name":"SpriteJS","url":"http://spritejs.org","full_name":"spritejs/spritejs","description":"Draw graphics on a canvas through simple object-oriented dom-like API. Vue & React/Preact supported.","owner_id":29911379,"tags":["canvas","animation"],"delta":1338,"stars":2533,"created_at":"2017-07-05T07:04:45.000Z","twitter":"","monthly":[43,81,51,53,120,447,543]},{"name":"Xmysql","url":"","full_name":"o1lab/xmysql","description":":rocket: One command to generate REST APIs for any MySql Database. ","owner_id":5435402,"tags":["db"],"delta":597,"stars":3425,"created_at":"2017-10-29T18:51:48.000Z","twitter":"","monthly":[25,61,90,54,53,122,192]},{"name":"Cucumber.js","url":"https://cucumber.io/","full_name":"cucumber/cucumber-js","description":"Cucumber for JavaScript","owner_id":320565,"tags":["test","auto"],"delta":234,"stars":3374,"created_at":"2011-05-27T21:27:17.000Z","twitter":""},{"name":"Material Dashboard","url":"https://demos.creative-tim.com/material-dashboard/examples/dashboard.html","full_name":"creativetimofficial/material-dashboard","description":"Material Dashboard - Open Source Bootstrap 4 Material Design Admin","owner_id":20172349,"tags":["dashboard"],"delta":3102,"stars":7438,"created_at":"2016-09-19T15:36:24.000Z","twitter":"","monthly":[79,139,64,102,126,821,1771]},{"name":"Bit","url":"https://bitsrc.io","full_name":"teambit/bit","description":"Easily share code between projects with your team.","owner_id":24789812,"tags":["package"],"delta":2032,"stars":5215,"created_at":"2017-01-22T14:51:43.000Z","twitter":"","monthly":[379,315,385,180,205,478,90]},{"name":"lit-html","url":"https://lit-html.polymer-project.org/","full_name":"Polymer/lit-html","description":"An efficient, expressive, extensible HTML templating library for JavaScript.","owner_id":2159051,"tags":["template"],"delta":991,"stars":3652,"created_at":"2017-06-29T16:27:16.000Z","twitter":"","monthly":[177,239,179,115,116,165]},{"name":"face-api.js","url":"","full_name":"justadudewhohacks/face-api.js","description":"JavaScript API for face detection and face recognition in the browser and nodejs with tensorflow.js","owner_id":31125521,"tags":["ml"],"delta":3061,"stars":4435,"created_at":"2018-05-19T06:14:53.000Z","twitter":"","monthly":[279,731,444,251,279,1077]},{"name":"esm","url":"","full_name":"standard-things/esm","description":"Tomorrow's ECMAScript modules today!","owner_id":26613658,"tags":["module"],"delta":529,"stars":3241,"created_at":"2017-05-25T16:46:17.000Z","twitter":"","monthly":[103,92,84,70,104,76]},{"name":"Canner","url":"https://www.cannercms.com","full_name":"Canner/canner","description":"⚡️CMS for developers, a flexible CMS create CMS fast and easy. Support data sources such as Firebase","owner_id":7250217,"tags":["cms","graphql"],"delta":2301,"stars":2318,"created_at":"2018-03-01T04:42:17.000Z","twitter":"","monthly":[34,56,51,30,115,1529,486]},{"name":"Linaria","url":"https://linaria.now.sh","full_name":"callstack/linaria","description":"Zero-runtime CSS in JS library","owner_id":42239399,"tags":["css-in-js"],"delta":1662,"stars":2087,"created_at":"2017-05-23T00:52:34.000Z","twitter":"","monthly":[97,146,191,692,19,285,177,27,10,18]},{"name":"Gio.js","url":"https://giojs.org","full_name":"syt123450/giojs","description":"🌏  A Declarative 3D Globe Data Visualization Library built with Three.js","owner_id":7977100,"tags":["3d","chart"],"delta":576,"stars":873,"created_at":"2018-01-02T23:19:02.000Z","twitter":"","monthly":[18,25,13,27,50,443]},{"name":"Rogue","url":"","full_name":"alidcastano/rogue.js","description":"Rogue.js -  the \"nearly invisible\" way to server-render React applications","owner_id":11031952,"tags":["react","isomorphic"],"delta":1387,"stars":1933,"created_at":"2018-06-24T17:19:31.000Z","twitter":"","monthly":[20,-3,10,4,77,1279]},{"name":"Microstates.js","url":"https://github.com/microstates","full_name":"microstates/microstates.js","description":"Composable State Primitives for JavaScript","owner_id":32446710,"tags":["state"],"delta":975,"stars":1180,"created_at":"2016-06-24T05:45:06.000Z","twitter":"","monthly":[19,92,58,24,85,697]},{"name":"Theia","url":"http://theia-ide.org","full_name":"theia-ide/theia","description":"Theia is a cloud & desktop IDE framework implemented in TypeScript.","owner_id":28530323,"tags":["ide"],"delta":1205,"stars":2357,"created_at":"2017-02-24T14:42:05.000Z","twitter":"","monthly":[223,195,193,244,270,80]},{"name":"ToastUI Image Editor","url":"http://ui.toast.com/tui-image-editor","full_name":"nhnent/tui.image-editor","description":"🍞🎨 Full-featured photo image editor using canvas. It is really easy, and it comes with great filte","owner_id":7907400,"tags":["image","viewer","canvas"],"delta":1041,"stars":1692,"created_at":"2016-04-28T01:50:33.000Z","twitter":"","monthly":[70,77,74,82,120,618]},{"name":"Phenomenon","url":"","full_name":"vaneenige/phenomenon","description":"⚡️ A fast 2kB low-level WebGL API.","owner_id":9073496,"tags":["webgl","canvas"],"delta":697,"stars":1249,"created_at":"2018-07-11T05:49:34.000Z","twitter":"","monthly":[10,24,31,42,98,492]},{"name":"v8n","url":"https://imbrn.github.io/v8n","full_name":"imbrn/v8n","description":"☑️ JavaScript fluent validation library","owner_id":1906977,"tags":["validation"],"delta":2638,"stars":3134,"created_at":"2018-06-25T20:06:33.000Z","twitter":"","monthly":[17,15,89,110,351,2056]},{"name":"Pushbar.js","url":"https://oncebot.github.io/pushbar.js/","full_name":"oncebot/pushbar.js","description":"Tiny javascript plugin for creating sliding drawers in web apps","owner_id":7911857,"tags":["nav"],"delta":615,"stars":768,"created_at":"2018-07-15T09:17:59.000Z","twitter":"","monthly":[4,10,10,47,246,298]},{"name":"ndb","url":"","full_name":"GoogleChromeLabs/ndb","description":"ndb is an improved debugging experience for Node.js, enabled by Chrome DevTools","owner_id":31970254,"tags":["debug"],"delta":6426,"stars":8716,"created_at":"2018-07-20T18:37:47.000Z","twitter":"","monthly":[123,262,369,337,1378,3957]},{"name":"Evergreen","url":"https://evergreen.segment.com/","full_name":"segmentio/evergreen","description":"🌲 Evergreen React UI Framework by Segment","owner_id":819518,"tags":["react","component"],"delta":6111,"stars":6869,"created_at":"2017-07-30T10:03:14.000Z","twitter":"","monthly":[222,548,2645,238,784,1674]},{"name":"React Window","url":"https://react-window.now.sh/","full_name":"bvaughn/react-window","description":"React components for efficiently rendering large lists and tabular data","owner_id":29597,"tags":["react","scrolling"],"delta":2002,"stars":2638,"created_at":"2018-05-07T14:45:51.000Z","twitter":"","monthly":[262,234,156,183,842,325]},{"name":"Hasura GraphQL Engine","url":"https://hasura.io","full_name":"hasura/graphql-engine","description":"Blazing fast, instant realtime GraphQL APIs on Postgres with fine grained access control, also trigg","owner_id":13966722,"tags":["graphql"],"delta":2604,"stars":5780,"created_at":"2018-06-18T07:57:36.000Z","twitter":"","monthly":[390,509,844,327,480,54]},{"name":"Hypernova","url":"","full_name":"airbnb/hypernova","description":"A service for server-side rendering your JavaScript views","owner_id":698437,"tags":["isomorphic"],"delta":291,"stars":4865,"created_at":"2016-06-01T00:34:24.000Z","twitter":""},{"name":"ApexCharts","url":"https://apexcharts.com","full_name":"apexcharts/apexcharts.js","description":"📊 Interactive SVG Charts","owner_id":37190687,"tags":["chart"],"delta":4445,"stars":4554,"created_at":"2018-07-24T15:22:23.000Z","twitter":"","monthly":[103,108,242,356,2736,900]},{"name":"mdx-deck","url":"https://jxnblk.com/mdx-deck","full_name":"jxnblk/mdx-deck","description":":spades: MDX-based presentation decks","owner_id":3451712,"tags":["presentation","md","react"],"delta":5835,"stars":5984,"created_at":"2018-07-28T22:36:10.000Z","twitter":"","monthly":[175,301,242,580,3447,1090]},{"name":"Dumper.js","url":"","full_name":"ziishaned/dumper.js","description":"A better and pretty variable inspector for your Node.js applications","owner_id":16267321,"tags":["debug"],"delta":524,"stars":2168,"created_at":"2018-08-05T17:16:26.000Z","twitter":"","monthly":[9,22,49,191,253]},{"name":"dc.js","url":"","full_name":"dc-js/dc.js","description":"Multi-Dimensional charting built to work natively with crossfilter rendered with d3.js","owner_id":6378965,"tags":["chart","d3"],"delta":116,"stars":6446,"created_at":"2012-06-19T14:20:30.000Z","twitter":""},{"name":"TheoremJS","url":"https://theorem.js.org","full_name":"arguiot/TheoremJS","description":"A Math library for computation in JavaScript 📕","owner_id":18022260,"tags":["math"],"delta":532,"stars":846,"created_at":"2017-11-23T11:33:54.000Z","twitter":"","monthly":[17,10,54,47,404]},{"name":"Puppeteer Recorder","url":"https://checklyhq.com/puppeteer-recorder","full_name":"checkly/puppeteer-recorder","description":"Puppeteer recorder is a Chrome extension that records your browser interactions and generates a  Pup","owner_id":25982255,"tags":["auto"],"delta":3094,"stars":4243,"created_at":"2018-08-13T19:31:11.000Z","twitter":"","monthly":[89,127,162,683,2033]},{"name":"WorkerDOM","url":"","full_name":"ampproject/worker-dom","description":"The same DOM API and Frameworks you know, but in a Web Worker.","owner_id":14114390,"tags":["webworker"],"delta":1083,"stars":1841,"created_at":"2018-08-16T21:06:04.000Z","twitter":"","monthly":[59,169,363,195,297]},{"name":"Immer","url":"","full_name":"mweststrate/immer","description":"Create the next immutable state by mutating the current one","owner_id":1820292,"tags":["state"],"delta":2938,"stars":8795,"created_at":"2017-12-29T12:25:47.000Z","twitter":"","monthly":[398,435,611,1338,156],"icon":"immer.png"},{"name":"fs-extra","url":"","full_name":"jprichardson/node-fs-extra","description":"Node.js: extra methods for the fs object like copy(), remove(), mkdirs()","owner_id":150063,"tags":["filesystem"],"delta":532,"stars":5181,"created_at":"2011-11-16T21:50:51.000Z","twitter":"","monthly":[122,129,136,122,23]},{"name":"Code Surfer ","url":"https://codesurfer.js.org/sample/","full_name":"pomber/code-surfer","description":"React component for scrolling, zooming and highlighting code samples <🏄/>","owner_id":1911623,"tags":["highlight","react"],"delta":1227,"stars":2314,"created_at":"2018-08-19T00:16:54.000Z","twitter":"","monthly":[36,55,100,489,547]},{"name":"Reach UI","url":"https://ui.reach.tech","full_name":"reach/reach-ui","description":"The Accessible Foundation for React Apps and Design Systems.","owner_id":38740568,"tags":["access","react","nav","modal"],"delta":844,"stars":1468,"created_at":"2018-07-31T05:41:40.000Z","twitter":"","monthly":[41,73,160,348,222]},{"name":"F2","url":"https://antv.alipay.com/zh-cn/f2/3.x/index.html","full_name":"antvis/f2","description":"📱📈An elegant, interactive and flexible charting library for mobile.","owner_id":19199542,"tags":["chart","canvas"],"delta":2845,"stars":5903,"created_at":"2016-08-29T06:26:23.000Z","twitter":"","monthly":[138,163,228,1500,816]},{"name":"BizCharts","url":"http://bizcharts.net/products/bizCharts","full_name":"alibaba/BizCharts","description":"Powerful data visualization library based on G2 and React.","owner_id":1961952,"tags":["chart","react"],"delta":1071,"stars":3391,"created_at":"2017-11-10T08:27:54.000Z","twitter":"","monthly":[136,142,138,368,287]},{"name":"Front-End Performance Checklist","url":"https://frontendchecklist.io(soon on)","full_name":"thedaviddias/Front-End-Performance-Checklist","description":"🎮 The only Front-End Performance Checklist that runs faster than the others","owner_id":237229,"tags":["learning","performance"],"delta":1017,"stars":10043,"created_at":"2018-07-03T14:33:01.000Z","twitter":"","monthly":[132,127,235,523]},{"name":"umi","url":"https://umijs.org/","full_name":"umijs/umi","description":"🌋 Pluggable enterprise-level react application framework.","owner_id":33895495,"tags":["nodejs-framework","react"],"delta":3226,"stars":3330,"created_at":"2017-11-22T10:09:36.000Z","twitter":"","monthly":[326,323,230,469,364,187,68,209,176,257,456,161]},{"name":"Ky","url":"","full_name":"sindresorhus/ky","description":"Tiny and elegant HTTP client based on the browser Fetch API","owner_id":170270,"tags":["http"],"delta":2762,"stars":3137,"created_at":"2018-09-04T16:26:42.000Z","twitter":"","monthly":[75,104,251,2332]},{"name":"PWA","url":"https://pwa.cafe","full_name":"lukeed/pwa","description":"(WIP) Universal PWA Builder","owner_id":5855893,"tags":["boilerplate","react","vue","serviceworker"],"delta":707,"stars":2564,"created_at":"2018-06-21T08:21:51.000Z","twitter":"","monthly":[26,39,144,498]},{"name":"Sqorn","url":"https://sqorn.org","full_name":"sqorn/sqorn","description":"A Javascript library for building SQL queries","owner_id":43126638,"tags":["db"],"delta":1551,"stars":1649,"created_at":"2018-07-21T21:50:30.000Z","twitter":"","monthly":[24,34,142,1351]},{"name":"Microjob","url":"https://wilk.github.io/microjob/","full_name":"wilk/microjob","description":"A tiny wrapper for turning Node.js worker threads into easy-to-use routines for heavy CPU loads.","owner_id":647020,"tags":["queue"],"delta":941,"stars":1509,"created_at":"2018-08-26T09:31:59.000Z","twitter":"","monthly":[20,18,119,784]},{"name":"WatermelonDB","url":"https://watermelondb.now.sh","full_name":"Nozbe/WatermelonDB","description":"🍉 High-performance reactive database for powerful React and React Native apps ⚡️","owner_id":1301067,"tags":["db","offline"],"delta":4588,"stars":5020,"created_at":"2018-08-28T15:32:05.000Z","twitter":"","monthly":[97,251,676,3564]},{"name":"Material Design Paper","url":"https://callstack.github.io/react-native-paper/","full_name":"callstack/react-native-paper","description":"Material Design for React Native (Android & iOS)","owner_id":42239399,"tags":["react-native","material"],"delta":757,"stars":2510,"created_at":"2016-10-19T05:56:53.000Z","twitter":"","monthly":[116,160,167,314]},{"name":"StREST","url":"","full_name":"eykrehbein/strest","description":"⚡️ Set up tests for REST in seconds with YAML","owner_id":21179825,"tags":["test"],"delta":580,"stars":1538,"created_at":"2018-09-08T11:33:38.000Z","twitter":"","monthly":[11,36,87,446]},{"name":"NLP.js","url":"","full_name":"axa-group/nlp.js","description":"An NLP library built in node over Natural, with entity extraction, sentiment analysis, automatic lan","owner_id":15005905,"tags":["ml"],"delta":1356,"stars":1803,"created_at":"2018-07-30T17:46:04.000Z","twitter":"","monthly":[49,88,222,997]},{"name":"Tink","url":"","full_name":"npm/tink","description":"a dependency unwinder for javascript ","owner_id":6078720,"tags":["package"],"delta":1119,"stars":1354,"created_at":"2018-07-27T16:57:34.000Z","twitter":"","monthly":[44,137,69,869]},{"name":"Npm","url":"https://npm.community","full_name":"npm/cli","description":"a package manager for JavaScript, report bugs and get support at:","owner_id":6078720,"tags":["node.js","package"],"delta":508,"stars":1048,"created_at":"2018-07-05T23:26:52.000Z","twitter":"","monthly":[147,141,151,69]},{"name":"react-admin","url":"http://marmelab.com/react-admin","full_name":"marmelab/react-admin","description":"A frontend Framework for building admin applications running in the browser on top of REST/GraphQL A","owner_id":3116319,"tags":["dashboard","react","redux","material"],"delta":1002,"stars":6429,"created_at":"2016-07-13T07:58:54.000Z","twitter":"","monthly":[300,311,282,109]},{"name":"worker-plugin","url":"","full_name":"GoogleChromeLabs/worker-plugin","description":"🐳 Adds native Web Worker bundling support to Webpack.","owner_id":31970254,"tags":["webworker"],"delta":520,"stars":1059,"created_at":"2018-09-18T15:45:18.000Z","twitter":"","monthly":[24,115,110,271]},{"name":"create-react-library","url":"","full_name":"transitive-bullshit/create-react-library","description":"⚡CLI for easily creating reusable react libraries.","owner_id":552829,"tags":["react","scaffolding"],"delta":822,"stars":1939,"created_at":"2018-03-04T20:44:14.000Z","twitter":"","monthly":[91,99,164,468]},{"name":"Vapid","url":"https://www.vapid.com","full_name":"vapid/vapid","description":"Vapid is an intentionally simple content management system built on the idea that you can create a c","owner_id":25934833,"tags":["cms"],"delta":858,"stars":1257,"created_at":"2017-12-11T18:55:42.000Z","twitter":"","monthly":[47,49,162,600]},{"name":"Apify","url":"https://sdk.apify.com/","full_name":"apifytech/apify-js","description":"Apify SDK — The scalable web crawling and scraping library for JavaScript. Enables development of da","owner_id":24586296,"tags":["scraping"],"delta":761,"stars":1532,"created_at":"2016-08-26T18:35:03.000Z","twitter":"","monthly":[47,86,334,294]},{"name":"PostGraphile","url":"https://graphile.org/postgraphile","full_name":"graphile/postgraphile","description":"Execute one command (or mount one Node.js middleware) and get an instant high-performance GraphQL AP","owner_id":30540084,"tags":["graphql","db"],"delta":578,"stars":6519,"created_at":"2016-04-14T21:29:19.000Z","twitter":"","monthly":[114,176,288]},{"name":"tiptap","url":"https://tiptap.scrumpy.io","full_name":"scrumpy/tiptap","description":"A rich-text editor for Vue.js","owner_id":37333181,"tags":["vue","rich-text-editor"],"delta":1950,"stars":2624,"created_at":"2018-08-20T19:58:58.000Z","twitter":"","monthly":[184,539,1227]},{"name":"libreact","url":"","full_name":"streamich/libreact","description":"Collection of useful React components","owner_id":9773803,"tags":["react","util"],"delta":1013,"stars":1907,"created_at":"2018-06-09T14:52:36.000Z","twitter":"","monthly":[31,92,890]},{"name":"Truffle","url":"https://truffleframework.com","full_name":"trufflesuite/truffle","description":"The most popular blockchain development framework","owner_id":22205159,"tags":["crypto-currency"],"delta":380,"stars":7466,"created_at":"2015-06-29T19:46:53.000Z","twitter":""},{"name":"Percollate","url":"","full_name":"danburzo/percollate","description":"🌐 → 📖 A command-line tool to turn web pages into beautifully formatted PDFs","owner_id":205375,"tags":["scraping","pdf"],"delta":1695,"stars":2790,"created_at":"2018-09-28T16:32:56.000Z","twitter":"","monthly":[52,250,1393]},{"name":"Carbon","url":"https://dawnlabs.io/carbon","full_name":"dawnlabs/carbon","description":"🎨 Create and share beautiful images of your source code","owner_id":25232884,"tags":["highlight"],"delta":1819,"stars":17486,"created_at":"2017-06-16T02:50:28.000Z","twitter":"","monthly":[959,430,430]},{"name":"Gridsome","url":"https://gridsome.org","full_name":"gridsome/gridsome","description":"⚡️  Build super fast, modern websites with Vue.js","owner_id":17981963,"tags":["ssg","vue","graphql"],"delta":1403,"stars":1484,"created_at":"2018-07-31T22:55:06.000Z","twitter":"","monthly":[222,319,861,1]},{"name":"Cesium","url":"http://cesiumjs.org/","full_name":"AnalyticalGraphicsInc/cesium","description":"An open-source JavaScript library for world-class 3D globes and maps :earth_americas:","owner_id":1490220,"tags":["3d","webgl","map"],"delta":202,"stars":3826,"created_at":"2012-03-02T22:27:14.000Z","twitter":""},{"name":"Dat","url":"http://datproject.org","full_name":"datproject/dat","description":":floppy_disk: Share & live sync files anywhere via command line","owner_id":7143718,"tags":["decentralized","filesystem","offline"],"delta":135,"stars":7248,"created_at":"2013-06-27T03:12:34.000Z","twitter":""},{"name":"Graphpack","url":"https://codesandbox.io/s/k3qrkl8qlv","full_name":"glennreyes/graphpack","description":"☄️ A minimalistic zero-config GraphQL server.","owner_id":5080854,"tags":["graphql"],"delta":590,"stars":1595,"created_at":"2018-07-11T07:06:29.000Z","twitter":"","monthly":[62,234,294]},{"name":"33 JS Concepts","url":"","full_name":"leonardomso/33-js-concepts","description":"📜 33 concepts every JavaScript developer should know.","owner_id":8030067,"tags":["learning"],"delta":10176,"stars":23774,"created_at":"2018-09-04T13:27:04.000Z","twitter":"","monthly":[3145,4274,2757]},{"name":"The Platform","url":"","full_name":"palmerhq/the-platform","description":"Web. Components. 😂","owner_id":10245696,"tags":["react"],"delta":1648,"stars":3354,"created_at":"2018-08-15T23:22:09.000Z","twitter":"","monthly":[92,644,912]},{"name":"react-use","url":"http://streamich.github.io/react-use","full_name":"streamich/react-use","description":"React Hooks — 👍","owner_id":9773803,"tags":["react"],"delta":1322,"stars":1804,"created_at":"2018-10-27T10:16:05.000Z","twitter":"","monthly":[166,941,215]},{"name":"Carlo","url":"","full_name":"GoogleChromeLabs/carlo","description":"Web rendering surface for Node applications","owner_id":31970254,"tags":["auto","desktop"],"delta":4027,"stars":7932,"created_at":"2018-10-28T17:15:20.000Z","twitter":"","monthly":[584,3443]},{"name":"Ervy","url":"https://www.chunqiuyiyu.com/ervy/","full_name":"chunqiuyiyu/ervy","description":"Bring charts to terminal.","owner_id":7722205,"tags":["chart","cli"],"delta":711,"stars":1287,"created_at":"2018-10-20T07:47:06.000Z","twitter":"","monthly":[96,615]},{"name":"SimpleBar","url":"http://grsmto.github.io/simplebar/","full_name":"Grsmto/simplebar","description":"Custom scrollbars vanilla javascript library with native scroll, done simple, lightweight, easy to u","owner_id":527559,"tags":["scrolling"],"delta":516,"stars":2085,"created_at":"2013-05-29T20:39:40.000Z","twitter":"","monthly":[104,412]},{"name":"Eva icons","url":"https://akveo.github.io/eva-icons/","full_name":"akveo/eva-icons","description":"A pack of more than 480 beautifully crafted Open Source icons. SVG, Sketch, Web Font and Animations ","owner_id":11921694,"tags":["svg","icon"],"delta":4269,"stars":5736,"created_at":"2018-10-30T18:36:44.000Z","twitter":"","monthly":[630,3639]},{"name":"Angular CLI","url":"https://cli.angular.io/","full_name":"angular/angular-cli","description":"CLI tool for Angular","owner_id":139426,"tags":["angular","scaffolding"],"delta":5947,"stars":20709,"created_at":"2015-06-04T19:49:37.000Z","twitter":"","monthly":[221,298,393,353,414,778,235,698,596,645,658,658]},{"name":"NgRx","url":"https://ngrx.io","full_name":"ngrx/platform","description":"Reactive libraries for Angular","owner_id":16272733,"tags":["angular","reactive","state"],"delta":2453,"stars":4220,"created_at":"2017-03-02T19:34:15.000Z","twitter":"","monthly":[158,177,176,140,265,68,501,213,270,237,248]},{"name":"ngx-bootstrap","url":"https://valor-software.com/ngx-bootstrap","full_name":"valor-software/ngx-bootstrap","description":"Fast and reliable Bootstrap widgets in Angular","owner_id":6849042,"tags":["angular","component","material"],"delta":104,"stars":4508,"created_at":"2015-08-08T13:13:57.000Z","twitter":""},{"name":"PrimeNG","url":"https://www.primefaces.org/primeng","full_name":"primefaces/primeng","description":"UI Components for Angular","owner_id":3494069,"tags":["angular","component"],"delta":1342,"stars":4871,"created_at":"2016-01-16T09:23:28.000Z","twitter":"","monthly":[94,76,730,12,4,9,8,3,131,130,145]},{"name":"NG Bootstrap","url":"https://ng-bootstrap.github.io","full_name":"ng-bootstrap/ng-bootstrap","description":"Angular powered Bootstrap","owner_id":14283866,"tags":["angular","component"],"delta":1935,"stars":6427,"created_at":"2015-09-14T22:55:53.000Z","twitter":"","monthly":[100,95,150,138,157,223,56,188,210,182,197,239]},{"name":"OnsenUI","url":"https://onsen.io/","full_name":"OnsenUI/OnsenUI","description":"Mobile app development framework and SDK using HTML5 and JavaScript. Create beautiful and performant","owner_id":5972822,"tags":["mobile","react","vue","angular","webcomponent"],"delta":128,"stars":7015,"created_at":"2013-09-11T11:52:41.000Z","twitter":""},{"name":"Redbird","url":"","full_name":"OptimalBits/redbird","description":"A modern reverse proxy for node","owner_id":945399,"tags":["routing","websocket"],"delta":821,"stars":3716,"created_at":"2014-08-05T13:33:11.000Z","twitter":"","monthly":[60,761]},{"name":"Enquirer","url":"","full_name":"enquirer/enquirer","description":"Stylish, intuitive and user-friendly prompts.","owner_id":21160645,"tags":["cli"],"delta":2016,"stars":3629,"created_at":"2016-08-29T01:43:26.000Z","twitter":"","monthly":[375,1641]},{"name":"Glider.js","url":"https://nickpiscitelli.github.io/Glider.js","full_name":"NickPiscitelli/Glider.js","description":"A fast, lightweight, dependency free, native scrolling carousel alternative!","owner_id":1686933,"tags":["nav"],"delta":1323,"stars":1581,"created_at":"2018-10-15T22:43:41.000Z","twitter":"","monthly":[272,1051]},{"name":"fx","url":"","full_name":"antonmedv/fx","description":"Command-line tool and terminal JSON viewer 🔥","owner_id":141232,"tags":["cli","json"],"delta":2233,"stars":4645,"created_at":"2018-01-25T17:29:43.000Z","twitter":"","monthly":[425,1808]},{"name":"Rawact","url":"","full_name":"sokra/rawact","description":"[POC] A babel plugin which compiles React.js components into native DOM instructions to eliminate th","owner_id":1365881,"tags":["react"],"delta":935,"stars":2434,"created_at":"2018-11-06T09:11:57.000Z","twitter":"","monthly":[113,822]},{"name":"TensorSpace.js","url":"https://tensorspace.org","full_name":"tensorspace-team/tensorspace","description":"Neural network 3D visualization framework, build interactive and intuitive model in browsers, suppor","owner_id":43156133,"tags":["ml","neural"],"delta":2535,"stars":3479,"created_at":"2018-07-22T14:14:29.000Z","twitter":"","monthly":[358,2177]},{"name":"Reagent","url":"http://reagent-project.github.io/","full_name":"reagent-project/reagent","description":"A minimalistic ClojureScript interface to React.js","owner_id":9254615,"tags":["react"],"delta":43,"stars":3260,"created_at":"2013-12-18T18:12:03.000Z","twitter":""},{"name":"MongoDB","url":"http://mongodb.github.com/node-mongodb-native/","full_name":"mongodb/node-mongodb-native","description":"Mongo DB Native NodeJS Driver","owner_id":45120,"tags":["db"],"delta":102,"stars":7554,"created_at":"2010-01-07T12:50:50.000Z","twitter":""},{"name":"Squoosh","url":"https://squoosh.app","full_name":"GoogleChromeLabs/squoosh","description":"Make images smaller using best-in-class codecs, right in the browser.","owner_id":31970254,"tags":["image"],"delta":1989,"stars":5811,"created_at":"2018-03-07T22:42:03.000Z","twitter":"","monthly":[913,1076]},{"name":"Imba","url":"http://imba.io","full_name":"imba/imba","description":"The new programming language for web apps","owner_id":45297010,"tags":["framework"],"delta":908,"stars":3167,"created_at":"2014-06-14T18:58:32.000Z","twitter":"","monthly":[196,712]},{"name":"autoComplete.js","url":"","full_name":"TarekRaafat/autoComplete.js","description":"Simple autocomplete pure vanilla Javascript library.","owner_id":3501930,"tags":["autocomplete"],"delta":1179,"stars":1462,"created_at":"2018-11-17T11:35:48.000Z","twitter":"","monthly":[927,252]},{"name":"HTM","url":"","full_name":"developit/htm","description":"Hyperscript Tagged Markup: JSX alternative using standard tagged templates, with compiler support.","owner_id":105127,"tags":["template","vdom"],"delta":2387,"stars":4197,"created_at":"2018-07-30T19:04:49.000Z","twitter":"","monthly":[1149,1238]},{"name":"CMS.js","url":"http://chrisdiana.github.io/cms.js","full_name":"chrisdiana/cms.js","description":"Client-Side JavaScript Site Generator","owner_id":4675420,"tags":["cms"],"delta":709,"stars":2874,"created_at":"2016-01-08T03:45:51.000Z","twitter":"","monthly":[131,578]},{"name":"LearnGitBranching","url":"https://pcottle.github.com/learnGitBranching/?demo","full_name":"pcottle/learnGitBranching","description":"An interactive git visualization to challenge and educate!","owner_id":1135007,"tags":["learning"],"delta":2591,"stars":11024,"created_at":"2012-08-13T22:36:09.000Z","twitter":"","monthly":[1710,881]},{"name":"ncc","url":"","full_name":"zeit/ncc","description":"Compile a Node.js project into a single file. Supports TypeScript, binary addons, dynamic requires.","owner_id":14985020,"tags":["package"],"delta":1020,"stars":2298,"created_at":"2018-11-13T04:00:21.000Z","twitter":"","monthly":[1020]},{"name":"Screenshoteer","url":"","full_name":"vladocar/screenshoteer","description":"Make website screenshots and mobile emulations from the command line.","owner_id":34764,"tags":["auto"],"delta":561,"stars":1397,"created_at":"2018-12-02T10:11:41.000Z","twitter":"","monthly":[561]},{"name":"Pageres","url":"","full_name":"sindresorhus/pageres","description":"Capture website screenshots","owner_id":170270,"tags":["auto"],"delta":16,"stars":8482,"created_at":"2014-02-07T18:15:18.000Z","twitter":""},{"name":"Forg.js","url":"","full_name":"oussamahamdaoui/forgJs","description":"ForgJs is a javascript lightweight object validator. Go check the Quick start section and start codi","owner_id":37545214,"tags":["validation"],"delta":857,"stars":1411,"created_at":"2018-11-23T16:28:06.000Z","twitter":"","monthly":[857]},{"name":"Quicklink","url":"","full_name":"GoogleChromeLabs/quicklink","description":"⚡️Faster subsequent page-loads by prefetching in-viewport links during idle time","owner_id":31970254,"tags":["performance"],"delta":2718,"stars":4715,"created_at":"2018-11-23T20:10:04.000Z","twitter":"","monthly":[2718]},{"name":"Magic Grid","url":"","full_name":"e-oj/Magic-Grid","description":"A simple, lightweight Javascript library for dynamic grid layouts.","owner_id":9700116,"tags":["layout"],"delta":609,"stars":1662,"created_at":"2018-11-11T22:35:29.000Z","twitter":"","monthly":[609]},{"name":"IPFS","url":"https://ipfs.io","full_name":"ipfs/js-ipfs","description":"IPFS implementation in JavaScript","owner_id":10536621,"tags":["decentralized"],"delta":12,"stars":3250,"created_at":"2014-05-30T00:31:06.000Z","twitter":""},{"name":"Vant","url":"https://youzan.github.io/vant","full_name":"youzan/vant","description":"Lightweight Mobile UI Components built on Vue","owner_id":11404085,"tags":["vue","component"],"delta":3,"stars":7125,"created_at":"2017-04-19T07:55:31.000Z","twitter":""},{"name":"Primer","url":"http://primer.style","full_name":"primer/primer","description":"The CSS design system that powers GitHub","owner_id":7143434,"tags":["css-lib"],"delta":6,"stars":7891,"created_at":"2015-03-19T23:31:21.000Z","twitter":""},{"name":"Basscss","url":"http://basscss.com","full_name":"basscss/basscss","description":"Low-level CSS Toolkit","owner_id":11900178,"tags":["css-lib"],"delta":3,"stars":5097,"created_at":"2013-10-19T19:20:49.000Z","twitter":""}]}

/***/ }),
/* 421 */
/***/ (function(module, exports) {

	module.exports = [{"key":"all","excluded":["js-algorithms-and-data-structures","awesome","you-dont-know-js","airbnb-style-guide","front-end-job-interview-questions","front-end-checklist","30-seconds-of-code","nodejs-best-practices","tech-interview-handbook","30-seconds-of-css","33-js-concepts","project-guidelines"],"limit":10,"count":50},{"key":"framework","count":20},{"key":"nodejs-framework","tags":["nodejs-framework"],"count":20},{"key":"react","tags":["react","react-native"],"count":20,"excluded":["react","react-native","storybook"]},{"key":"vue","count":10,"excluded":["vuejs","storybook"],"guest":"atinux"},{"key":"angular","count":10,"excluded":["angular","angular-1","storybook","nativescript"],"guest":"bblackwo"},{"key":"test-framework","tags":["test","test-framework","auto"],"excluded":["json-server"],"count":10,"availableComments":["en","ja"]},{"key":"mobile","excluded":[],"count":10,"availableComments":[]},{"key":"compiler","count":5,"availableComments":[]},{"key":"build","count":5,"availableComments":[]},{"key":"ide","count":5,"disabled":true},{"key":"css-in-js","count":10,"excluded":["typographyjs"],"availableComments":[]},{"key":"ssg","count":10,"disabled":true},{"key":"graphql","count":10,"disabled":false,"availableComments":[]},{"key":"learning","count":10,"availableComments":[],"disabled":false}]

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	module.exports = {"date":"2020-01-14T12:45:53.263Z","count":214,"projects":[{"name":"Vue.js","full_name":"vuejs/vue","description":"A progressive, incrementally-adoptable framework for building UI on the web","stars":155562,"delta":31350,"monthly":[1747,1817,2215,1713,2146,2365,2437,2727,3347,4494,2298,3074],"tags":["framework","vdom","vue"],"owner_id":6128107,"created_at":"2013-07-29T03:24:51.000Z","url":"http://vuejs.org","icon":"vue.svg"},{"name":"Awesome","full_name":"sindresorhus/awesome","description":"Awesome lists about all kinds of interesting topics","stars":123659,"delta":23687,"monthly":[2185,1717,1721,1654,1803,1825,1876,1799,2206,2414,1728,2029],"tags":["meta"],"owner_id":170270,"created_at":"2014-07-11T13:42:37.000Z","icon":"awesome.svg"},{"name":"VS Code","full_name":"microsoft/vscode","description":"Visual Studio Code","stars":90044,"delta":22980,"monthly":[1759,2331,1471,1627,1572,1514,1694,2582,1959,2478,1666,1719],"tags":["ide"],"owner_id":6154722,"created_at":"2015-09-03T20:23:38.000Z","url":"https://code.visualstudio.com","icon":"vscode.svg"},{"name":"React","full_name":"facebook/react","description":"A declarative, efficient, and flexible JavaScript library for building user interfaces.","stars":142251,"delta":22918,"monthly":[1375,1478,1660,1633,1656,1686,1583,2014,1992,2418,2108,2375],"tags":["framework","vdom","react"],"owner_id":69631,"created_at":"2013-05-24T16:15:54.000Z","url":"https://reactjs.org","icon":"react.svg"},{"name":"Vue Element Admin","full_name":"PanJiaChen/vue-element-admin","description":"A magical vue admin","stars":48069,"delta":22717,"monthly":[1578,1741,1897,2153,1765,1895,1745,2039,2198,1867,1037,2084],"tags":["vue","dashboard"],"owner_id":8121621,"created_at":"2017-04-17T03:35:49.000Z","icon":"vueelementadmin.png"},{"name":"You Don't Know JS","full_name":"getify/You-Dont-Know-JS","description":"A book series on JavaScript","stars":114696,"delta":20079,"monthly":[1622,1647,1627,1276,1712,1650,1565,1526,1829,1921,1379,1752],"tags":["learning","book"],"owner_id":150330,"created_at":"2013-11-16T02:37:24.000Z","icon":"js.svg"},{"name":"Svelte","full_name":"sveltejs/svelte","description":"Cybernetically enhanced web apps","stars":29406,"delta":20030,"monthly":[1654,1340,1556,1107,1132,1857,2006,4586,3268,238,293,207],"tags":["framework"],"owner_id":23617963,"created_at":"2016-11-20T18:13:05.000Z","url":"https://svelte.dev","icon":"svelte.svg"},{"name":"30 seconds of code","full_name":"30-seconds/30-seconds-of-code","description":"Short JavaScript code snippets for all your development needs","stars":53794,"delta":18115,"monthly":[806,1644,1657,997,885,921,1054,1506,1691,1944,1774,2715],"tags":["learning"],"owner_id":43479428,"created_at":"2017-11-29T17:35:03.000Z","url":"https://www.30secondsofcode.org/js/p/1"},{"name":"JS Algorithms & Data Structures","full_name":"trekhleb/javascript-algorithms","description":"Algorithms and data structures implemented in JavaScript with explanations and links to further readings","stars":60268,"delta":17777,"monthly":[2733,888,1173,1273,1214,1520,940,936,1364,1502,1683,2029],"tags":["learning","data-structure"],"owner_id":3000285,"created_at":"2018-03-24T07:47:04.000Z"},{"name":"Node.js Best Practices","full_name":"goldbergyoni/nodebestpractices","description":"The largest Node.js best practices list (December 2019)","stars":38135,"delta":16076,"monthly":[1372,1173,1379,1107,897,874,974,2415,791,732,1063,2894],"tags":["learning"],"owner_id":8571500,"created_at":"2017-09-15T08:33:19.000Z"},{"name":"Axios","full_name":"axios/axios","description":"Promise based HTTP client for the browser and node.js","stars":68643,"delta":15142,"monthly":[1029,1006,1009,1035,1229,1300,1246,1374,1411,1470,1220,1314],"tags":["http"],"owner_id":32372333,"created_at":"2014-08-18T22:30:27.000Z"},{"name":"Ant Design","full_name":"ant-design/ant-design","description":"A UI Design Language and React UI library","stars":55416,"delta":14606,"monthly":[939,922,1037,982,1215,1445,1084,1265,1324,1362,1013,1604],"tags":["react","component"],"owner_id":12101536,"created_at":"2015-04-24T15:37:24.000Z","url":"https://ant.design","icon":"ant.svg"},{"name":"TypeScript","full_name":"microsoft/TypeScript","description":"A superset of JavaScript that compiles to clean JavaScript output.","stars":57222,"delta":13873,"monthly":[779,827,1008,1009,1037,1158,1113,1346,1204,1379,1149,1376],"tags":["compiler","types"],"owner_id":6154722,"created_at":"2014-06-17T15:28:39.000Z","url":"https://www.typescriptlang.org","icon":"typescript.svg"},{"name":"Puppeteer","full_name":"puppeteer/puppeteer","description":"Headless Chrome Node.js API","stars":57494,"delta":13870,"monthly":[812,938,920,1064,1038,1385,1005,1222,1142,1369,1078,1464],"tags":["auto"],"owner_id":6906516,"created_at":"2017-05-09T22:16:13.000Z","url":"https://pptr.dev/","icon":"puppeteer.svg"},{"name":"Create React App","full_name":"facebook/create-react-app","description":"Set up a modern web app by running one command.","stars":75202,"delta":13507,"monthly":[983,777,896,903,980,1033,953,1075,1307,1403,1257,1523],"tags":["boilerplate","react","serviceworker"],"owner_id":69631,"created_at":"2016-07-17T14:55:11.000Z","url":"https://create-react-app.dev","icon":"cra.svg"},{"name":"Tech Interview Handbook","full_name":"yangshun/tech-interview-handbook","description":"Materials to help you rock your next coding interview","stars":38699,"delta":13039,"monthly":[923,570,766,3024,3104,558,864,583,608,572,492,629],"tags":["learning"],"owner_id":1315101,"created_at":"2016-07-05T05:00:48.000Z","url":"https://yangshun.github.io/tech-interview-handbook/"},{"name":"Storybook","full_name":"storybookjs/storybook","description":"UI component dev & test: React, Vue, Angular, React Native, Ember, Web Components & more!","stars":44739,"delta":11986,"monthly":[733,863,951,849,827,838,796,1187,1122,1530,806,1057],"tags":["react","vue","angular","test"],"owner_id":22632046,"created_at":"2016-03-18T04:23:44.000Z","url":"https://storybook.js.org","icon":"storybook.svg"},{"name":"Angular","full_name":"angular/angular","description":"One framework. Mobile & desktop.","stars":56348,"delta":11979,"monthly":[1059,1260,1249,1313,869,612,630,1035,941,896,808,913],"tags":["framework","angular"],"owner_id":139426,"created_at":"2014-09-18T16:12:01.000Z","url":"https://angular.io","icon":"angular.svg"},{"name":"Deno","full_name":"denoland/deno","description":"A secure JavaScript and TypeScript runtime","stars":40835,"delta":11868,"monthly":[779,556,582,738,503,1421,793,1146,1328,980,934,1811],"tags":["runtime","types"],"owner_id":42048915,"created_at":"2018-05-15T01:34:26.000Z","url":"https://deno.land/","icon":"deno.svg"},{"name":"Electron","full_name":"electron/electron","description":"Build cross-platform desktop apps with JavaScript, HTML, and CSS","stars":80059,"delta":11533,"monthly":[736,788,851,700,899,902,854,1057,1032,1130,892,1304],"tags":["desktop"],"owner_id":13409222,"created_at":"2013-04-12T01:47:36.000Z","url":"https://electronjs.org","icon":"electron.svg"},{"name":"Gatsby","full_name":"gatsbyjs/gatsby","description":"Build blazing fast, modern apps and websites with React","stars":41401,"delta":11524,"monthly":[582,749,997,881,859,785,829,844,927,1174,1080,1408],"tags":["ssg","react","graphql","prefetch"],"owner_id":12551863,"created_at":"2015-05-21T22:43:05.000Z","url":"https://www.gatsbyjs.org","icon":"gatsby.svg"},{"name":"Airbnb Style Guide","full_name":"airbnb/javascript","description":"JavaScript Style Guide","stars":91798,"delta":11489,"monthly":[688,743,774,760,880,939,796,1167,1107,1237,925,1176],"tags":["learning"],"owner_id":698437,"created_at":"2012-11-01T23:13:50.000Z"},{"name":"Nest","full_name":"nestjs/nest","description":"A progressive Node.js framework for building efficient, scalable, and enterprise-grade server-side applications on top of TypeScript & JavaScript (ES6, ES7, ES8)","stars":23249,"delta":11458,"monthly":[944,928,879,925,822,960,936,993,1129,987,833,808],"tags":["nodejs-framework","microservice"],"owner_id":28507035,"created_at":"2017-02-04T20:12:52.000Z","url":"https://nestjs.com/","icon":"nest.svg"},{"name":"React Native","full_name":"facebook/react-native","description":"A framework for building native apps with React.","stars":84103,"delta":11261,"monthly":[649,689,819,847,1000,897,880,1107,892,1069,1106,952],"tags":["mobile","react-native"],"owner_id":69631,"created_at":"2015-01-09T18:10:16.000Z","url":"https://facebook.github.io/react-native/","icon":"react-native.svg"},{"name":"freeCodeCamp","full_name":"freeCodeCamp/freeCodeCamp","description":"The https://www.freeCodeCamp.org open source codebase and curriculum. Learn to code for free together with millions of people.","stars":308088,"delta":11065,"monthly":[685,1190,633,628,458,542,403,892,2458,2020,411,435],"tags":["learning"],"owner_id":9892522,"created_at":"2014-12-24T17:49:19.000Z"},{"name":"Next.js","full_name":"zeit/next.js","description":"The React Framework","stars":43976,"delta":10595,"monthly":[716,759,800,750,890,1057,649,850,775,886,1049,1129],"tags":["isomorphic","react","nodejs-framework","ssg","prefetch"],"owner_id":14985020,"created_at":"2016-10-05T23:32:51.000Z","url":"https://nextjs.org","icon":"nextjs.svg"},{"name":"Strapi","full_name":"strapi/strapi","description":"Open source Node.js Headless CMS to easily build customisable APIs","stars":21028,"delta":10209,"monthly":[804,883,1123,753,607,844,803,724,790,1160,666,767],"tags":["nodejs-framework","cms"],"owner_id":19872173,"created_at":"2015-09-30T15:34:48.000Z","url":"https://strapi.io","icon":"strapi.svg"},{"name":"Material UI","full_name":"mui-org/material-ui","description":"React components for faster and easier web development. Build your own design system, or start with Material Design.","stars":53603,"delta":10171,"monthly":[741,763,770,828,866,864,873,1010,741,870,677,875],"tags":["material","react","component"],"owner_id":33663932,"created_at":"2014-08-18T19:11:54.000Z","url":"https://material-ui.com/","icon":"material-ui.svg"},{"name":"Node.js","full_name":"nodejs/node","description":"Node.js JavaScript runtime","stars":67100,"delta":9985,"monthly":[697,745,770,604,723,717,733,894,1088,1044,727,906],"tags":["node.js","runtime"],"owner_id":9950313,"created_at":"2014-11-26T19:57:11.000Z","url":"https://nodejs.org/","icon":"nodejs.svg"},{"name":"Three.js","full_name":"mrdoob/three.js","description":"JavaScript 3D library.","stars":57821,"delta":9943,"monthly":[756,817,900,716,772,757,695,914,926,1010,591,772],"tags":["3d"],"owner_id":97088,"created_at":"2010-03-23T18:58:01.000Z","url":"https://threejs.org/"},{"name":"Tailwind CSS","full_name":"tailwindcss/tailwindcss","description":"A utility-first CSS framework for rapid UI development.","stars":18488,"delta":9744,"monthly":[799,1603,674,694,689,624,782,1167,901,629,440,446],"tags":["css-lib"],"owner_id":30317862,"created_at":"2017-10-06T14:59:14.000Z","url":"https://tailwindcss.com/","icon":"tailwindcss.svg"},{"name":"Element","full_name":"ElemeFE/element","description":"A Vue.js 2.0 UI Toolkit for Web","stars":43450,"delta":9373,"monthly":[645,630,591,653,968,806,734,849,862,908,550,913],"tags":["vue","component"],"owner_id":12810740,"created_at":"2016-09-03T06:19:26.000Z","url":"https://element.eleme.io/","icon":"element.svg"},{"name":"Uppy","full_name":"transloadit/uppy","description":"The next open source file uploader for web browsers","stars":21684,"delta":8994,"monthly":[170,163,201,257,405,260,505,1172,1914,522,2745,172],"tags":["upload"],"owner_id":125754,"created_at":"2015-11-16T12:32:33.000Z","url":"https://uppy.io","icon":"uppy.svg"},{"name":"anime.js","full_name":"juliangarnier/anime","description":"JavaScript animation engine","stars":33666,"delta":8503,"monthly":[341,266,307,283,349,400,296,328,417,489,872,3957],"tags":["animation"],"owner_id":1268691,"created_at":"2016-03-13T21:37:45.000Z","url":"https://animejs.com","icon":"anime.svg"},{"name":"Bootstrap","full_name":"twbs/bootstrap","description":"The most popular HTML, CSS, and JavaScript framework for developing responsive, mobile first projects on the web.","stars":138094,"delta":8181,"monthly":[538,727,551,513,543,625,629,693,817,898,743,657],"tags":["css-lib","bootstrap"],"owner_id":2918581,"created_at":"2011-07-29T21:19:00.000Z","url":"https://getbootstrap.com","icon":"bootstrap.svg"},{"name":"Hasura GraphQL Engine","full_name":"hasura/graphql-engine","description":"Blazing fast, instant realtime GraphQL APIs on Postgres with fine grained access control, also trigger webhooks on database events.","stars":13975,"delta":8135,"monthly":[628,481,593,453,446,500,1008,609,713,915,481,1043],"tags":["graphql"],"owner_id":13966722,"created_at":"2018-06-18T07:57:36.000Z","url":"https://hasura.io","icon":"hasura.svg"},{"name":"Ant Design Pro","full_name":"ant-design/ant-design-pro","description":"Use Ant Design like a Pro!","stars":23418,"delta":8053,"monthly":[432,509,591,764,568,675,616,636,782,874,580,770],"tags":["dashboard","react"],"owner_id":12101536,"created_at":"2017-08-25T10:40:44.000Z","url":"http://pro.ant.design/","icon":"ant.svg"},{"name":"D3","full_name":"d3/d3","description":"Bring data to life with SVG, Canvas and HTML.","stars":89516,"delta":8004,"monthly":[476,550,527,698,656,714,575,674,731,838,595,752],"tags":["chart","d3","svg","canvas"],"owner_id":1562726,"created_at":"2010-09-27T17:22:42.000Z","url":"https://d3js.org","icon":"d3.svg"},{"name":"Formik","full_name":"jaredpalmer/formik","description":"Build forms in React, without the tears","stars":20003,"delta":7879,"monthly":[435,598,639,574,569,632,594,759,660,720,693,766],"tags":["react","form"],"owner_id":4060187,"created_at":"2017-06-14T19:50:59.000Z","url":"https://jaredpalmer.com/formik","icon":"formik.svg"},{"name":"Cypress","full_name":"cypress-io/cypress","description":"Fast, easy and reliable testing for anything that runs in a browser.","stars":17556,"delta":7844,"monthly":[710,837,725,475,651,569,540,762,693,578,545,537],"tags":["test","auto"],"owner_id":8908513,"created_at":"2015-03-04T00:46:28.000Z","url":"https://www.cypress.io","icon":"cypress.svg"},{"name":"react-use","full_name":"streamich/react-use","description":"Collection of essential React Hooks","stars":9962,"delta":7822,"monthly":[630,617,589,484,705,487,563,861,1154,847,473,133],"tags":["react"],"owner_id":9773803,"created_at":"2018-10-27T10:16:05.000Z","url":"http://streamich.github.io/react-use"},{"name":"Day.js","full_name":"iamkun/dayjs","description":"Day.js 2KB immutable date library alternative to Moment.js with the same modern API","stars":25313,"delta":7665,"monthly":[654,413,380,486,450,459,540,476,868,1241,651,807],"tags":["date"],"owner_id":17680888,"created_at":"2018-04-10T09:26:44.000Z"},{"name":"json-server","full_name":"typicode/json-server","description":"Get a full fake REST API with zero coding in less than 30 seconds (seriously)","stars":44831,"delta":7643,"monthly":[523,529,559,592,601,670,548,634,628,675,626,806],"tags":["test","filesystem"],"owner_id":5502029,"created_at":"2013-11-27T13:21:13.000Z"},{"name":"Animate.css","full_name":"daneden/animate.css","description":"A cross-browser library of CSS animations. As easy to use as an easy thing.","stars":64249,"delta":7529,"monthly":[542,593,511,544,599,643,635,619,651,817,488,653],"tags":["animation"],"owner_id":439365,"created_at":"2011-10-12T10:07:38.000Z","url":"http://daneden.github.io/animate.css"},{"name":"Vuetify","full_name":"vuetifyjs/vuetify","description":"Material Component Framework for Vue","stars":23333,"delta":7501,"monthly":[395,442,468,456,612,884,644,591,651,755,689,701],"tags":["vue","material","component"],"owner_id":22138497,"created_at":"2016-09-12T00:39:35.000Z","url":"https://vuetifyjs.com","icon":"vuetify.svg"},{"name":"Nuxt","full_name":"nuxt/nuxt.js","description":"The Vue.js Framework","stars":24805,"delta":7420,"monthly":[771,613,672,415,508,549,517,665,585,665,579,639],"tags":["vue","isomorphic","nodejs-framework","ssg"],"owner_id":23360933,"created_at":"2016-10-26T11:18:47.000Z","url":"https://nuxtjs.org","icon":"nuxt.svg"},{"name":"33 JS Concepts","full_name":"leonardomso/33-js-concepts","description":"33 concepts every JavaScript developer should know.","stars":30727,"delta":7306,"monthly":[210,594,640,462,296,377,320,393,479,539,921,1879],"tags":["learning"],"owner_id":8030067,"created_at":"2018-09-04T13:27:04.000Z"},{"name":"Echarts","full_name":"apache/incubator-echarts","description":"A powerful, interactive charting and visualization library for browser","stars":39012,"delta":6909,"monthly":[664,621,666,584,559,586,523,607,659,522,289,427],"tags":["chart"],"owner_id":47359,"created_at":"2013-04-03T03:18:59.000Z","url":"http://echarts.apache.org/"},{"name":"Pixi.js","full_name":"pixijs/pixi.js","description":"The HTML5 Creation Engine: Create beautiful digital content with the fastest, most flexible 2D WebGL renderer.","stars":28271,"delta":6885,"monthly":[259,285,295,505,719,830,909,1447,330,319,315,462],"tags":["game"],"owner_id":5406849,"created_at":"2013-01-21T22:40:50.000Z","url":"http://pixijs.com"},{"name":"TypeORM","full_name":"typeorm/typeorm","description":"ORM for TypeScript and JavaScript (ES7, ES6, ES5). Supports MySQL, PostgreSQL, MariaDB, SQLite, MS SQL Server, Oracle, SAP Hana, WebSQL databases. Works in NodeJS, Browser, Ionic, Cordova and Electron platforms.","stars":17004,"delta":6799,"monthly":[465,496,477,500,510,533,488,619,566,623,629,713],"tags":["db"],"owner_id":20165699,"created_at":"2016-02-29T07:41:14.000Z","url":"http://typeorm.io"},{"name":"ngx-admin","full_name":"akveo/ngx-admin","description":"Customizable admin dashboard template based on Angular 8+","stars":19473,"delta":4807,"monthly":[230,265,360,544,381,519,373,322,340,452,346,545],"tags":["angular","dashboard"],"owner_id":11921694,"created_at":"2016-05-25T10:09:03.000Z","url":"https://akveo.github.io/ngx-admin/"},{"name":"Material Design for Angular","full_name":"angular/components","description":"Component infrastructure and Material Design components for Angular","stars":19253,"delta":2370,"monthly":[91,174,169,105,210,145,194,260,213,228,230,263],"tags":["material","angular","component"],"owner_id":139426,"created_at":"2016-01-04T18:50:02.000Z","url":"https://material.angular.io"},{"name":"NativeScript","full_name":"NativeScript/NativeScript","description":"NativeScript is an open source framework for building truly native mobile apps with JavaScript. Use web skills, like Angular and Vue.js, FlexBox and CSS, and get native UI and performance on iOS and Android.","stars":18054,"delta":2201,"monthly":[119,105,114,134,169,196,167,204,221,234,248,222],"tags":["mobile","angular","vue"],"owner_id":7392261,"created_at":"2015-03-01T09:47:08.000Z","url":"https://www.nativescript.org","icon":"nativescript.svg"},{"name":"Angular CLI","full_name":"angular/angular-cli","description":"CLI tool for Angular","stars":22867,"delta":2137,"monthly":[94,158,137,156,162,179,154,182,198,197,192,251],"tags":["angular","scaffolding"],"owner_id":139426,"created_at":"2015-06-04T19:49:37.000Z","url":"https://cli.angular.io/"},{"name":"NG-ZORRO","full_name":"NG-ZORRO/ng-zorro-antd","description":"An enterprise-class UI components based on Ant Design and Angular.","stars":5988,"delta":1695,"monthly":[123,120,129,136,150,139,135,183,181,123,89,139],"tags":["angular","component"],"owner_id":30223759,"created_at":"2017-08-08T14:59:33.000Z","url":"https://ng.ant.design"},{"name":"NgRx","full_name":"ngrx/platform","description":"Reactive libraries for Angular","stars":5533,"delta":1329,"monthly":[85,87,93,73,94,103,124,117,125,126,112,144],"tags":["angular","reactive","state"],"owner_id":16272733,"created_at":"2017-03-02T19:34:15.000Z","url":"https://ngrx.io"},{"name":"ag-grid","full_name":"ag-grid/ag-grid","description":"Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components","stars":5905,"delta":1262,"monthly":[96,91,99,114,96,125,94,100,116,120,85,95],"tags":["table","react","angular"],"owner_id":30720768,"created_at":"2014-12-23T16:20:14.000Z","url":"http://www.ag-grid.com"},{"name":"Clarity Design System","full_name":"vmware/clarity","description":"UX guidelines, HTML/CSS framework, and Angular components working together to craft exceptional experiences","stars":5492,"delta":1076,"monthly":[77,64,93,85,86,105,82,82,88,94,69,118],"tags":["angular","component"],"owner_id":473334,"created_at":"2016-09-29T17:24:17.000Z","url":"http://clarity.design"},{"name":"NG Bootstrap","full_name":"ng-bootstrap/ng-bootstrap","description":"Angular powered Bootstrap","stars":7306,"delta":875,"monthly":[62,38,41,33,33,53,91,92,121,109,74,90],"tags":["angular","component","bootstrap"],"owner_id":14283866,"created_at":"2015-09-14T22:55:53.000Z","url":"https://ng-bootstrap.github.io"},{"name":"PrimeNG","full_name":"primefaces/primeng","description":"The Most Complete UI Component Library for Angular","stars":5741,"delta":855,"monthly":[54,63,60,57,57,59,69,65,74,115,60,93],"tags":["angular","component"],"owner_id":3494069,"created_at":"2016-01-16T09:23:28.000Z","url":"https://www.primefaces.org/primeng"},{"name":"NGXS","full_name":"ngxs/store","description":"NGXS - State Management for Angular","stars":2597,"delta":839,"monthly":[45,42,71,39,54,45,57,79,90,106,90,98],"tags":["state","angular"],"owner_id":37132593,"created_at":"2018-02-13T18:55:44.000Z","url":"http://ngxs.io"},{"name":"OnsenUI","full_name":"OnsenUI/OnsenUI","description":"Mobile app development framework and SDK using HTML5 and JavaScript. Create beautiful and performant cross-platform mobile apps. Based on Web Components, and provides bindings for Angular 1, 2, React and Vue.js.","stars":7790,"delta":796,"monthly":[31,41,60,47,65,53,32,68,49,59,55,228],"tags":["mobile","react","vue","angular","webcomponent"],"owner_id":5972822,"created_at":"2013-09-11T11:52:41.000Z","url":"https://onsen.io/"},{"name":"ngx-datatable","full_name":"swimlane/ngx-datatable","description":"A feature-rich yet lightweight data-table crafted for Angular","stars":3766,"delta":518,"monthly":[46,29,38,34,35,47,46,47,42,54,37,48],"tags":["angular","table"],"owner_id":10552812,"created_at":"2016-05-31T19:25:47.000Z","url":"http://swimlane.github.io/ngx-datatable/"},{"name":"Puppeteer Recorder","full_name":"checkly/puppeteer-recorder","description":"A Chrome extension that records your browser interactions and generates a Puppeteer script.","stars":6499,"delta":2238,"monthly":[119,76,101,205,124,460,529,97,106,143,98,103],"tags":["auto"],"owner_id":25982255,"created_at":"2018-08-13T19:31:11.000Z"},{"name":"TestCafe","full_name":"DevExpress/testcafe","description":"A Node.js tool to automate end-to-end web testing.","stars":7754,"delta":1797,"monthly":[64,81,117,107,122,203,162,172,171,178,185,192],"tags":["auto"],"owner_id":4243232,"created_at":"2015-04-20T13:43:28.000Z","url":"https://devexpress.github.io/testcafe/","icon":"testcafe.svg"},{"name":"react-snap","full_name":"stereobooster/react-snap","description":"Zero-configuration framework-agnostic static prerendering for SPAs","stars":3199,"delta":1407,"monthly":[105,89,86,65,98,101,123,242,127,140,116,74],"tags":["react","auto","prerender"],"owner_id":179534,"created_at":"2017-10-01T01:56:32.000Z"},{"name":"Nightmare","full_name":"segmentio/nightmare","description":"A high-level browser automation library","stars":18059,"delta":1370,"monthly":[68,105,80,98,123,113,98,101,137,144,130,130],"tags":["auto"],"owner_id":819518,"created_at":"2014-04-05T22:19:51.000Z","url":"https://open.segment.com"},{"name":"Carlo","full_name":"GoogleChromeLabs/carlo","description":"Web rendering surface for Node applications","stars":9042,"delta":1176,"monthly":[37,83,42,31,63,51,66,75,86,92,178,337],"tags":["auto","desktop"],"owner_id":31970254,"created_at":"2018-10-28T17:15:20.000Z"},{"name":"Nightwatch","full_name":"nightwatchjs/nightwatch","description":"End-to-end testing framework written in Node.js and using the Webdriver API","stars":9966,"delta":1122,"monthly":[60,85,88,139,75,82,55,129,127,91,76,93],"tags":["auto"],"owner_id":12559275,"created_at":"2012-03-17T21:28:18.000Z","url":"https://nightwatchjs.org"},{"name":"Taiko","full_name":"getgauge/taiko","description":"A node.js library to automate chrome/chromium browser","stars":1751,"delta":978,"monthly":[58,109,180,86,79,170,50,55,49,39,41,27],"tags":["auto","test"],"owner_id":7044589,"created_at":"2017-10-27T05:25:27.000Z","url":"https://taiko.gauge.org"},{"name":"WebdriverIO","full_name":"webdriverio/webdriverio","description":"Next-gen WebDriver test automation framework for Node.js","stars":5418,"delta":901,"monthly":[55,59,42,58,75,74,78,76,125,93,65,77],"tags":["auto"],"owner_id":6512473,"created_at":"2011-08-30T19:02:35.000Z","url":"http://webdriver.io"},{"name":"Webpack","full_name":"webpack/webpack","description":"A bundler for javascript and friends. Packs many modules into a few bundled assets. Code Splitting allows for loading parts of the application on demand. Through \"loaders\", modules can be CommonJs, AMD, ES6 modules, CSS, Images, JSON, Coffeescript, LESS, ... and your custom stuff.","stars":52594,"delta":6293,"monthly":[385,358,423,466,472,553,511,572,576,620,498,667],"tags":["build","module"],"owner_id":2105791,"created_at":"2012-03-10T10:08:14.000Z","url":"https://webpack.js.org","icon":"webpack.svg"},{"name":"Parcel","full_name":"parcel-bundler/parcel","description":"Blazing fast, zero configuration web application bundler","stars":34482,"delta":5382,"monthly":[287,291,381,271,384,297,394,504,573,633,449,742],"tags":["module","build"],"owner_id":32607881,"created_at":"2017-08-07T16:36:47.000Z","url":"https://parceljs.org","icon":"parcel.svg"},{"name":"Rollup","full_name":"rollup/rollup","description":"Next-generation ES module bundler","stars":17318,"delta":2746,"monthly":[165,237,205,218,276,189,233,214,203,278,190,263],"tags":["module","build"],"owner_id":12554859,"created_at":"2015-05-14T22:26:28.000Z","url":"https://rollupjs.org","icon":"rollup.svg"},{"name":"Microbundle","full_name":"developit/microbundle","description":"Zero-configuration bundler for tiny modules.","stars":4222,"delta":1318,"monthly":[74,59,87,66,82,74,119,94,104,238,101,151],"tags":["module","build"],"owner_id":105127,"created_at":"2017-12-11T21:51:02.000Z"},{"name":"Gulp","full_name":"gulpjs/gulp","description":"The streaming build system","stars":31611,"delta":841,"monthly":[41,43,52,66,59,47,53,115,77,75,85,106],"tags":["build"],"owner_id":6200624,"created_at":"2013-07-04T05:26:06.000Z","url":"http://gulpjs.com","icon":"gulp.svg"},{"name":"Browserify","full_name":"browserify/browserify","description":"browser-side require() the node.js way","stars":13041,"delta":631,"monthly":[55,31,55,48,49,37,42,53,63,80,43,62],"tags":["build","module"],"owner_id":6320506,"created_at":"2010-09-22T16:11:32.000Z","url":"http://browserify.org/","icon":"browserify.svg"},{"name":"Poi","full_name":"egoist/poi","description":"A zero-config bundler for JavaScript applications.","stars":4847,"delta":550,"monthly":[29,39,25,32,16,24,51,47,43,54,83,85],"tags":["vue","build"],"owner_id":8784712,"created_at":"2016-04-21T16:21:09.000Z","url":"https://poi.js.org","icon":"poi.png"},{"name":"Babel","full_name":"babel/babel","description":"A compiler for writing next generation JavaScript.","stars":35533,"delta":4207,"monthly":[269,288,259,256,264,408,342,349,341,451,386,457],"tags":["compiler","code-parser"],"owner_id":9637642,"created_at":"2014-09-28T13:38:23.000Z","url":"https://babeljs.io/","icon":"babel.svg"},{"name":"Flow","full_name":"facebook/flow","description":"Adds static typing to JavaScript to improve developer productivity and code quality.","stars":20323,"delta":1663,"monthly":[60,75,100,115,95,144,130,160,136,245,156,176],"tags":["compiler","types"],"owner_id":69631,"created_at":"2014-10-28T17:17:45.000Z","url":"https://flow.org/","icon":"flow.svg"},{"name":"Reason","full_name":"facebook/reason","description":"Simple, fast & type safe code that leverages the JavaScript & OCaml ecosystems","stars":8412,"delta":1337,"monthly":[121,68,89,95,73,67,82,108,159,118,112,198],"tags":["compiler","types"],"owner_id":69631,"created_at":"2015-11-16T08:22:32.000Z","url":"http://reasonml.github.io","icon":"reason.svg"},{"name":"Sucrase","full_name":"alangpierce/sucrase","description":"Super-fast alternative to Babel for when you can target modern JS runtimes","stars":2187,"delta":1129,"monthly":[55,28,33,61,78,109,64,63,60,461,77,23],"tags":["compiler","code-parser"],"owner_id":211605,"created_at":"2017-10-03T16:54:00.000Z","url":"https://sucrase.io"},{"name":"PureScript","full_name":"purescript/purescript","description":"A strongly-typed language that compiles to JavaScript","stars":6214,"delta":810,"monthly":[61,51,63,39,59,74,88,70,54,76,60,75],"tags":["compiler","types"],"owner_id":6556677,"created_at":"2013-09-30T05:29:23.000Z","url":"http://www.purescript.org"},{"name":"Elm","full_name":"elm/compiler","description":"Compiler for Elm, a functional language for reliable webapps.","stars":5710,"delta":738,"monthly":[74,80,108,40,38,61,46,55,60,59,53,49],"tags":["compiler","fp"],"owner_id":20698192,"created_at":"2012-04-19T06:24:43.000Z","url":"https://elm-lang.org/","icon":"elm.svg"},{"name":"Styled Components","full_name":"styled-components/styled-components","description":"Visual primitives for the component age. Use the best bits of ES6 and CSS to style your apps without stress","stars":27412,"delta":6032,"monthly":[366,469,407,432,477,459,493,575,521,559,522,598],"tags":["css-in-js"],"owner_id":20658825,"created_at":"2016-08-16T06:41:32.000Z","url":"https://styled-components.com"},{"name":"Emotion","full_name":"emotion-js/emotion","description":"CSS-in-JS library designed for high performance style composition","stars":9823,"delta":3279,"monthly":[285,225,209,205,223,218,243,306,296,321,292,364],"tags":["css-in-js"],"owner_id":31557565,"created_at":"2017-05-27T04:23:45.000Z","url":"https://emotion.sh/"},{"name":"Linaria","full_name":"callstack/linaria","description":"Zero-runtime CSS in JS library","stars":4750,"delta":2762,"monthly":[198,76,87,78,91,74,110,247,196,343,866,333],"tags":["css-in-js"],"owner_id":42239399,"created_at":"2017-05-23T00:52:34.000Z","url":"https://linaria.now.sh"},{"name":"styled-system","full_name":"styled-system/styled-system","description":"⬢ Style props for rapid UI development","stars":5305,"delta":2377,"monthly":[116,148,117,150,179,208,166,216,238,261,200,290],"tags":["css-in-js"],"owner_id":47362392,"created_at":"2017-06-14T23:21:17.000Z","url":"https://styled-system.com"},{"name":"CSS Modules","full_name":"css-modules/css-modules","description":"Documentation about css-modules","stars":13022,"delta":1827,"monthly":[107,110,120,141,141,129,126,180,167,186,174,185],"tags":["css-in-js"],"owner_id":12612655,"created_at":"2015-05-25T21:54:47.000Z"},{"name":"Polished","full_name":"styled-components/polished","description":"A lightweight toolset for writing styles in JavaScript","stars":5696,"delta":1206,"monthly":[66,81,77,79,80,75,85,90,106,144,170,115],"tags":["css-in-js"],"owner_id":20658825,"created_at":"2016-11-03T14:39:21.000Z","url":"https://polished.js.org/"},{"name":"Styled JSX","full_name":"zeit/styled-jsx","description":"Full CSS support for JSX without compromises","stars":5105,"delta":1136,"monthly":[84,113,77,91,76,85,67,103,97,110,87,117],"tags":["css-in-js"],"owner_id":14985020,"created_at":"2016-12-05T13:58:02.000Z"},{"name":"JSS","full_name":"cssinjs/jss","description":"JSS is an authoring tool for CSS which uses JavaScript as a host language.","stars":5432,"delta":964,"monthly":[76,68,58,71,65,89,61,96,81,91,101,81],"tags":["css-in-js"],"owner_id":9503099,"created_at":"2014-10-12T20:33:53.000Z","url":"https://cssinjs.org"},{"name":"Typography.js","full_name":"KyleAMathews/typography.js","description":"A powerful toolkit for building websites with beautiful design","stars":3033,"delta":714,"monthly":[30,43,46,56,61,50,53,52,83,78,63,77],"tags":["css-in-js","typo"],"owner_id":71047,"created_at":"2015-03-05T23:25:48.000Z","url":"http://kyleamathews.github.io/typography.js/"},{"name":"Omi","full_name":"Tencent/omi","description":"Next Front End Framework","stars":10633,"delta":3846,"monthly":[176,327,147,153,210,230,181,323,446,908,118,328],"tags":["framework"],"owner_id":18461506,"created_at":"2015-05-31T14:24:58.000Z","url":"http://omijs.org","icon":"omi.svg"},{"name":"Preact","full_name":"preactjs/preact","description":"Fast 3kB React alternative with the same modern API. Components & Virtual DOM.","stars":25145,"delta":3819,"monthly":[338,327,537,252,193,263,250,346,291,435,245,233],"tags":["vdom","framework"],"owner_id":26872990,"created_at":"2015-09-11T02:40:18.000Z","url":"https://preactjs.com","icon":"preact.svg"},{"name":"Stencil","full_name":"ionic-team/stencil","description":"A Web Component compiler for building fast, reusable UI components and Progressive Web Apps  Built by the Ionic Framework team","stars":7183,"delta":2509,"monthly":[170,139,152,321,139,161,365,259,233,162,148,185],"tags":["framework","webcomponent"],"owner_id":3171503,"created_at":"2017-02-15T18:57:07.000Z","url":"https://stenciljs.com/","icon":"stencil.svg"},{"name":"dva","full_name":"dvajs/dva","description":"React and redux based, lightweight and elm-style framework. (Inspired by elm and choo)","stars":14337,"delta":2253,"monthly":[133,100,106,124,188,215,186,221,225,300,157,235],"tags":["framework","redux"],"owner_id":20552239,"created_at":"2016-06-24T09:06:16.000Z","url":"https://dvajs.com/"},{"name":"Relay","full_name":"facebook/relay","description":"Relay is a JavaScript framework for building data-driven React applications.","stars":14010,"delta":2124,"monthly":[111,243,137,168,117,104,129,427,103,201,183,129],"tags":["framework","graphql"],"owner_id":69631,"created_at":"2015-08-10T22:09:16.000Z","url":"https://relay.dev","icon":"relay.svg"},{"name":"Mithril","full_name":"MithrilJS/mithril.js","description":"A JavaScript Framework for Building Brilliant Applications","stars":11971,"delta":1486,"monthly":[40,47,40,83,99,236,32,146,169,214,144,188],"tags":["framework","vdom"],"owner_id":19475707,"created_at":"2014-03-17T01:59:39.000Z","url":"https://mithril.js.org","icon":"mithril.svg"},{"name":"Marko","full_name":"marko-js/marko","description":"A declarative, HTML-based language that makes building web apps fun","stars":9364,"delta":1418,"monthly":[46,42,52,36,49,39,57,240,230,213,195,184],"tags":["framework"],"owner_id":11873696,"created_at":"2014-01-07T23:58:21.000Z","url":"https://markojs.com/","icon":"marko.svg"},{"name":"RE:DOM","full_name":"redom/redom","description":"Tiny (2 KB) turboboosted JavaScript library for creating user interfaces.","stars":2830,"delta":1265,"monthly":[28,25,26,38,62,45,43,59,230,49,71,573],"tags":["framework"],"owner_id":21295422,"created_at":"2016-08-28T17:32:43.000Z","url":"https://redom.js.org"},{"name":"Stimulus","full_name":"stimulusjs/stimulus","description":"A modest JavaScript framework for the HTML you already have","stars":7827,"delta":1162,"monthly":[70,80,69,78,82,70,89,113,79,77,126,177],"tags":["framework"],"owner_id":32970053,"created_at":"2016-12-17T00:19:29.000Z","url":"https://stimulusjs.org/"},{"name":"Hyperapp","full_name":"jorgebucaran/hyperapp","description":"The tiny framework for building web interfaces.","stars":17102,"delta":1139,"monthly":[33,43,53,51,36,32,50,92,155,190,157,207],"tags":["framework","state"],"owner_id":56996,"created_at":"2017-01-20T05:20:21.000Z","url":"https://hyperapp.dev","icon":"hyperapp.svg"},{"name":"AMP","full_name":"ampproject/amphtml","description":"The AMP web component framework.","stars":13381,"delta":1100,"monthly":[66,86,84,92,112,87,79,145,109,84,67,53],"tags":["performance","framework","webcomponent"],"owner_id":14114390,"created_at":"2015-09-01T22:10:53.000Z","url":"https://amp.dev","icon":"amp.svg"},{"name":"Rax","full_name":"alibaba/rax","description":"The fastest way to build universal application","stars":5895,"delta":999,"monthly":[219,82,91,55,49,68,38,58,78,112,58,67],"tags":["vdom","framework"],"owner_id":1961952,"created_at":"2016-10-14T07:53:50.000Z","icon":"rax.svg"},{"name":"Ember","full_name":"emberjs/ember.js","description":"Ember.js - A JavaScript framework for creating ambitious web applications","stars":21322,"delta":972,"monthly":[34,20,34,52,31,62,63,59,91,181,94,225],"tags":["framework"],"owner_id":1253363,"created_at":"2011-05-25T23:39:40.000Z","url":"https://emberjs.com","icon":"ember.svg"},{"name":"Hybrids","full_name":"hybridsjs/hybrids","description":"UI library for creating web components with plain objects and pure functions","stars":1679,"delta":800,"monthly":[34,85,32,45,36,71,58,220,45,52,34,58],"tags":["webcomponent","framework"],"owner_id":22907385,"created_at":"2016-12-06T20:19:43.000Z","url":"https://hybrids.js.org","icon":"hybrids.svg"},{"name":"Inferno","full_name":"infernojs/inferno","description":"An extremely fast, React-like JavaScript library for building modern user interfaces","stars":14131,"delta":777,"monthly":[42,67,43,73,65,57,41,79,88,72,72,61],"tags":["vdom","framework"],"owner_id":14214240,"created_at":"2015-02-01T22:07:38.000Z","url":"https://infernojs.org","icon":"inferno.svg"},{"name":"Polymer","full_name":"Polymer/polymer","description":"Our original Web Component library.","stars":21336,"delta":774,"monthly":[33,24,32,52,36,45,57,75,135,105,74,79],"tags":["framework"],"owner_id":2159051,"created_at":"2012-08-23T20:56:30.000Z","url":"https://polymer-library.polymer-project.org/","icon":"polymer.svg"},{"name":"Prisma","full_name":"prisma/prisma","description":"Database Tools incl. ORM, Migrations and Admin UI (Postgres, MySQL & MongoDB)","stars":16536,"delta":4506,"monthly":[227,192,259,239,327,358,375,355,649,537,398,474],"tags":["graphql"],"owner_id":17219288,"created_at":"2016-09-25T12:54:40.000Z","url":"https://www.prisma.io","icon":"prisma.svg"},{"name":"Gridsome","full_name":"gridsome/gridsome","description":"️Build modern JAMstack websites with Vue.js","stars":5248,"delta":3786,"monthly":[218,254,465,277,196,192,264,342,289,472,365,331],"tags":["ssg","vue","graphql"],"owner_id":17981963,"created_at":"2018-07-31T22:55:06.000Z","url":"https://gridsome.org"},{"name":"Apollo client","full_name":"apollographql/apollo-client","description":"A fully-featured, production ready caching GraphQL client for every UI framework and GraphQL server","stars":12999,"delta":3370,"monthly":[219,236,203,292,250,276,314,284,275,291,266,370],"tags":["graphql","caching","data"],"owner_id":17189275,"created_at":"2016-02-26T20:25:00.000Z","url":"https://apollographql.com/client","icon":"apollo.svg"},{"name":"Apollo Server","full_name":"apollographql/apollo-server","description":"GraphQL server for Express, Connect, Hapi, Koa and more","stars":8828,"delta":2766,"monthly":[183,178,237,180,211,251,233,243,229,209,228,299],"tags":["graphql","express"],"owner_id":17189275,"created_at":"2016-04-21T09:26:01.000Z","url":"https://www.apollographql.com/docs/apollo-server/","icon":"apollo.svg"},{"name":"GraphiQL","full_name":"graphql/graphiql","description":"GraphiQL & the GraphQL LSP Reference Ecosystem for building browser & IDE tools.","stars":9852,"delta":2448,"monthly":[170,184,160,172,224,197,177,203,241,227,177,234],"tags":["graphql"],"owner_id":12972006,"created_at":"2015-08-11T02:56:22.000Z"},{"name":"URQL","full_name":"FormidableLabs/urql","description":"A highly customizable and versatile GraphQL client for React","stars":4016,"delta":2201,"monthly":[79,98,119,197,270,91,783,107,114,61,40,36],"tags":["graphql","react"],"owner_id":5078602,"created_at":"2018-01-24T01:44:42.000Z","url":"https://formidable.com/open-source/urql"},{"name":"GraphQL Playground","full_name":"prisma-labs/graphql-playground","description":"GraphQL IDE for better development workflows (GraphQL Subscriptions, interactive docs & collaboration)","stars":5557,"delta":2017,"monthly":[107,133,102,145,154,166,175,191,195,191,175,220],"tags":["graphql"],"owner_id":55085183,"created_at":"2017-01-25T13:19:29.000Z"},{"name":"PostGraphile","full_name":"graphile/postgraphile","description":"Execute one command (or mount one Node.js middleware) and get an instant high-performance GraphQL API for your PostgreSQL database!","stars":8329,"delta":1809,"monthly":[171,157,102,148,119,130,111,212,152,173,150,148],"tags":["graphql","db"],"owner_id":30540084,"created_at":"2016-04-14T21:29:19.000Z","url":"https://graphile.org/postgraphile"},{"name":"GraphQL","full_name":"graphql/graphql-spec","description":"GraphQL is a query language and execution engine tied to any backend service.","stars":12325,"delta":1746,"monthly":[95,92,79,82,111,104,111,93,87,228,242,374],"tags":["data","graphql"],"owner_id":12972006,"created_at":"2015-07-01T01:26:56.000Z","url":"https://spec.graphql.org","icon":"graphql.svg"},{"name":"Altair","full_name":"imolorhe/altair","description":"️ A beautiful feature-rich GraphQL Client for all platforms.","stars":1962,"delta":1182,"monthly":[76,71,83,75,76,72,121,131,108,154,74,86],"tags":["graphql"],"owner_id":4608143,"created_at":"2017-03-25T21:08:30.000Z","url":"https://altair.sirmuel.design/"},{"name":"React Starter Kit","full_name":"kriasoft/react-starter-kit","description":"React Starter Kit — isomorphic web app boilerplate (Node.js, Express, GraphQL, React.js, Babel, PostCSS, Webpack, Browsersync)","stars":19796,"delta":1100,"monthly":[69,78,74,61,88,87,75,95,135,102,125,83],"tags":["react","isomorphic","boilerplate","graphql"],"owner_id":773036,"created_at":"2014-04-16T13:08:18.000Z","url":"https://reactstarter.com"},{"name":"graphql-request","full_name":"prisma-labs/graphql-request","description":"Minimal GraphQL client supporting Node and browsers for scripts or simple apps","stars":2114,"delta":787,"monthly":[40,68,68,54,53,62,70,72,74,53,71,81],"tags":["graphql"],"owner_id":55085183,"created_at":"2017-05-10T20:05:07.000Z"},{"name":"Vulcan","full_name":"VulcanJS/Vulcan","description":"A toolkit to quickly build apps with React, GraphQL & Meteor","stars":7782,"delta":514,"monthly":[72,44,37,28,25,21,41,38,40,56,37,52],"tags":["realtime","meteor","graphql","nodejs-framework"],"owner_id":6634779,"created_at":"2012-09-07T01:13:24.000Z","url":"http://vulcanjs.org"},{"name":"Theia","full_name":"eclipse-theia/theia","description":"Eclipse Theia is a cloud & desktop IDE framework implemented in TypeScript.","stars":6713,"delta":4429,"monthly":[219,266,682,271,292,285,284,273,394,471,333,533],"tags":["ide"],"owner_id":54183333,"created_at":"2017-02-24T14:42:05.000Z","url":"http://theia-ide.org"},{"name":"Atom","full_name":"atom/atom","description":"The hackable text editor","stars":50905,"delta":3361,"monthly":[250,261,263,258,242,305,253,314,311,293,259,213],"tags":["ide"],"owner_id":1089146,"created_at":"2012-01-20T18:18:21.000Z","url":"https://atom.io","icon":"atom.svg"},{"name":"Reactide","full_name":"reactide/reactide","description":"The first dedicated IDE for React web application development","stars":9818,"delta":1314,"monthly":[66,21,34,57,761,34,24,35,57,68,40,100],"tags":["ide"],"owner_id":26257999,"created_at":"2017-03-07T18:30:34.000Z","url":"https://reactide.io"},{"name":"Brackets","full_name":"adobe/brackets","description":"An open source code editor for the web, written in JavaScript, HTML and CSS.","stars":30719,"delta":1187,"monthly":[125,137,144,154,104,84,91,58,63,95,63,20],"tags":["ide"],"owner_id":476009,"created_at":"2011-12-07T21:14:40.000Z","url":"http://brackets.io","icon":"brackets.svg"},{"name":"Lightable","full_name":"LightTable/LightTable","description":"The Light Table IDE","stars":10946,"delta":524,"monthly":[36,34,52,57,28,35,43,34,52,67,44,26],"tags":["ide"],"owner_id":5877010,"created_at":"2012-06-27T22:32:43.000Z"},{"name":"Papers we love","full_name":"papers-we-love/papers-we-love","description":"Papers from the computer science community to read and discuss.","stars":37616,"delta":4670,"monthly":[380,346,323,422,369,351,369,373,403,456,342,398],"tags":["learning"],"owner_id":6187757,"created_at":"2013-12-15T14:31:41.000Z","url":"http://paperswelove.org/"},{"name":"Front-end Job Interview Questions","full_name":"h5bp/Front-end-Developer-Interview-Questions","description":"A list of helpful front-end related questions you can use to interview potential candidates, test yourself or completely ignore.","stars":43301,"delta":4602,"monthly":[216,304,326,303,300,440,309,386,435,583,408,413],"tags":["learning"],"owner_id":1136800,"created_at":"2012-02-09T23:34:10.000Z","url":"https://h5bp.org/Front-end-Developer-Interview-Questions/"},{"name":"Every Programmer Should Know","full_name":"mtdvio/every-programmer-should-know","description":"A collection of (mostly) technical things every software developer should know","stars":40543,"delta":4584,"monthly":[220,296,222,251,214,423,1128,232,303,292,433,448],"tags":["learning"],"owner_id":33053074,"created_at":"2017-08-24T13:18:26.000Z"},{"name":"You Don't Need jQuery","full_name":"nefe/You-Dont-Need-jQuery","description":"Examples of how to do query, style, dom, ajax, event etc like jQuery with plain javascript.","stars":18840,"delta":4422,"monthly":[65,67,67,76,97,70,93,281,2914,121,129,171],"tags":["learning"],"owner_id":33238961,"created_at":"2015-11-21T16:02:26.000Z"},{"name":"Front-End Checklist","full_name":"thedaviddias/Front-End-Checklist","description":"The perfect Front-End Checklist for modern websites and meticulous developers","stars":37177,"delta":4357,"monthly":[266,160,249,466,308,740,305,230,266,346,394,505],"tags":["learning"],"owner_id":237229,"created_at":"2017-10-16T10:12:36.000Z","url":"https://frontendchecklist.io","icon":"frontendchecklist.jpg"},{"name":"Modern JavaScript Tutorial","full_name":"javascript-tutorial/en.javascript.info","description":"Modern JavaScript Tutorial","stars":8554,"delta":4349,"monthly":[254,253,302,232,294,309,257,340,501,992,356,160],"tags":["learning"],"owner_id":49552305,"created_at":"2017-06-03T14:27:57.000Z","url":"https://javascript.info"},{"name":"LearnGitBranching","full_name":"pcottle/learnGitBranching","description":"An interactive git visualization to challenge and educate!","stars":14308,"delta":3354,"monthly":[202,158,125,175,200,211,171,264,326,339,292,804],"tags":["learning"],"owner_id":1135007,"created_at":"2012-08-13T22:36:09.000Z","url":"https://pcottle.github.com/learnGitBranching/?demo"},{"name":"Devhints","full_name":"rstacruz/cheatsheets","description":"My cheatsheets","stars":7937,"delta":2670,"monthly":[173,158,171,168,196,191,190,244,253,273,240,328],"tags":["learning"],"owner_id":74385,"created_at":"2012-03-16T06:17:34.000Z","url":"https://devhints.io"},{"name":"Devdocs.io","full_name":"freeCodeCamp/devdocs","description":"API Documentation Browser","stars":22098,"delta":2481,"monthly":[200,160,201,162,192,237,172,208,205,217,237,201],"tags":["learning"],"owner_id":9892522,"created_at":"2013-10-24T18:16:07.000Z","url":"https://devdocs.io"},{"name":"30 Seconds of CSS","full_name":"30-seconds/30-seconds-of-css","description":"Short CSS code snippets for all your development needs","stars":13357,"delta":2442,"monthly":[92,126,152,116,113,125,157,182,215,271,325,471],"tags":["learning"],"owner_id":43479428,"created_at":"2018-02-25T13:22:25.000Z","url":"https://www.30secondsofcode.org/css/p/1"},{"name":"30 Seconds of Interviews","full_name":"30-seconds/30-seconds-of-interviews","description":"A curated collection of common interview questions to help you prepare for your next interview.","stars":7554,"delta":2293,"monthly":[76,108,142,133,158,164,131,168,179,377,296,297],"tags":["learning"],"owner_id":43479428,"created_at":"2018-04-07T20:11:31.000Z","url":"https://30secondsofinterviews.org"},{"name":"Guide to FP","full_name":"MostlyAdequate/mostly-adequate-guide","description":"Mostly adequate guide to FP (in javascript)","stars":17218,"delta":1992,"monthly":[140,174,152,158,146,163,166,181,179,185,148,142],"tags":["fp","learning","book"],"owner_id":14079115,"created_at":"2015-05-06T01:44:15.000Z"},{"name":"React-spring","full_name":"react-spring/react-spring","description":"A spring physics based React animation library","stars":15652,"delta":6403,"monthly":[334,302,311,273,327,352,554,499,373,614,843,1442],"tags":["react","animation"],"owner_id":45790596,"created_at":"2018-03-07T15:39:32.000Z","url":"https://www.react-spring.io"},{"name":"Ink","full_name":"vadimdemedes/ink","description":"React for interactive command-line apps","stars":12608,"delta":6004,"monthly":[124,152,178,183,105,171,165,487,494,1548,759,1489],"tags":["react","cli"],"owner_id":697676,"created_at":"2017-06-12T06:12:28.000Z"},{"name":"React Testing Library","full_name":"testing-library/react-testing-library","description":"Simple and complete React DOM testing utilities that encourage good testing practices.","stars":10285,"delta":5705,"monthly":[414,339,308,344,522,407,391,525,498,452,901,435],"tags":["test","react"],"owner_id":49996085,"created_at":"2018-03-19T13:39:49.000Z","url":"https://testing-library.com/react"},{"name":"react-beautiful-dnd","full_name":"atlassian/react-beautiful-dnd","description":"Beautiful and accessible drag and drop for lists with React","stars":17601,"delta":5487,"monthly":[326,350,479,366,366,433,559,512,464,719,296,458],"tags":["react","dnd"],"owner_id":168166,"created_at":"2017-08-09T03:37:15.000Z","url":"https://react-beautiful-dnd.netlify.com","icon":"rbd.svg"},{"name":"Docz","full_name":"doczjs/docz","description":"It has never been so easy to document your things!","stars":17798,"delta":5286,"monthly":[279,324,483,318,280,399,358,460,662,599,493,473],"tags":["react","doc"],"owner_id":39714731,"created_at":"2018-03-17T04:24:10.000Z","url":"https://docz.site","icon":"docz.png"},{"name":"Docusaurus","full_name":"facebook/docusaurus","description":"Easy to maintain open source documentation websites.","stars":15080,"delta":4598,"monthly":[281,332,505,231,297,645,329,375,423,323,376,351],"tags":["doc","react"],"owner_id":69631,"created_at":"2017-06-20T16:13:53.000Z","url":"https://docusaurus.io","icon":"docusaurus.svg"},{"name":"React Router","full_name":"ReactTraining/react-router","description":"Declarative routing for React","stars":38831,"delta":4566,"monthly":[253,324,315,363,337,361,298,413,398,578,373,420],"tags":["react","routing"],"owner_id":11823761,"created_at":"2014-05-16T22:22:51.000Z","url":"https://reacttraining.com/react-router/","icon":"react-router.svg"},{"name":"react-admin","full_name":"marmelab/react-admin","description":"A frontend Framework for building B2B applications running in the browser on top of REST/GraphQL APIs, using ES6, React and Material Design","stars":10902,"delta":4400,"monthly":[335,375,351,329,434,310,538,366,294,388,249,293],"tags":["dashboard","react","redux","material"],"owner_id":3116319,"created_at":"2016-07-13T07:58:54.000Z","url":"http://marmelab.com/react-admin"},{"name":"React Window","full_name":"bvaughn/react-window","description":"React components for efficiently rendering large lists and tabular data","stars":6977,"delta":4303,"monthly":[184,265,210,237,231,273,382,313,533,1014,384,179],"tags":["react","scrolling"],"owner_id":29597,"created_at":"2018-05-07T14:45:51.000Z","url":"https://react-window.now.sh/"},{"name":"React Table","full_name":"tannerlinsley/react-table","description":"Hooks for building fast and extendable tables and datagrids for React","stars":9061,"delta":4018,"monthly":[519,1011,276,441,320,212,159,163,200,224,218,161],"tags":["table","react"],"owner_id":5580297,"created_at":"2016-10-20T17:25:08.000Z"},{"name":"React Native for Web","full_name":"necolas/react-native-web","description":"React Native for Web","stars":15581,"delta":3997,"monthly":[175,223,192,199,240,312,467,280,279,385,371,777],"tags":["react-native","component"],"owner_id":239676,"created_at":"2015-06-09T19:25:38.000Z","url":"https://necolas.github.io/react-native-web/docs"},{"name":"Expo","full_name":"expo/expo","description":"An open-source platform for making universal native apps with React. Expo runs on Android, iOS, and the web.","stars":8456,"delta":3489,"monthly":[252,286,272,278,247,216,384,263,269,350,256,306],"tags":["mobile","react-native"],"owner_id":12504344,"created_at":"2016-08-15T17:14:25.000Z","url":"https://docs.expo.io/"},{"name":"React Navigation","full_name":"react-navigation/react-navigation","description":"Routing and navigation for your React Native apps","stars":17167,"delta":2788,"monthly":[150,162,177,222,210,268,215,253,256,274,235,283],"tags":["routing","react-native"],"owner_id":29647600,"created_at":"2017-01-26T19:51:40.000Z","url":"https://reactnavigation.org"},{"name":"Material Design Paper","full_name":"callstack/react-native-paper","description":"Material Design for React Native (Android & iOS)","stars":4864,"delta":2298,"monthly":[179,168,170,184,170,170,144,236,227,207,194,170],"tags":["react-native","material","component"],"owner_id":42239399,"created_at":"2016-10-19T05:56:53.000Z","url":"https://reactnativepaper.com"},{"name":"NativeBase","full_name":"GeekyAnts/NativeBase","description":"Essential cross-platform UI components for React Native","stars":13233,"delta":2241,"monthly":[144,123,147,149,211,226,163,165,204,201,210,236],"tags":["react-native","mobile"],"owner_id":18482943,"created_at":"2016-04-15T11:37:23.000Z","url":"https://nativebase.io/"},{"name":"react-native-ui-kitten","full_name":"akveo/react-native-ui-kitten","description":"React Native UI Library based on Eva Design System  Dark Mode","stars":5599,"delta":2193,"monthly":[189,164,188,203,174,270,461,73,114,85,98,107],"tags":["react-native"],"owner_id":11921694,"created_at":"2016-12-20T08:22:38.000Z","url":"https://akveo.github.io/react-native-ui-kitten/"},{"name":"React Native Navigation","full_name":"wix/react-native-navigation","description":"A complete native navigation solution for React Native","stars":11117,"delta":1717,"monthly":[82,120,73,89,124,161,129,164,149,203,171,184],"tags":["react-native","menu"],"owner_id":686511,"created_at":"2016-03-11T11:22:54.000Z","url":"https://wix.github.io/react-native-navigation/"},{"name":"Ant Design Mobile","full_name":"ant-design/ant-design-mobile","description":"A configurable Mobile UI","stars":7923,"delta":1464,"monthly":[84,86,94,84,119,136,90,137,139,184,112,151],"tags":["mobile","react-native"],"owner_id":12101536,"created_at":"2015-11-30T03:33:06.000Z","url":"https://mobile.ant.design","icon":"ant.svg"},{"name":"Galio","full_name":"galio-org/galio","description":"Galio is a beautifully designed, Free and Open Source React Native Framework","stars":1801,"delta":1170,"monthly":[63,51,70,89,78,105,447,49,43,63,57,29],"tags":["react-native"],"owner_id":40339280,"created_at":"2018-06-17T16:14:11.000Z","url":"https://galio.io/"},{"name":"React Native Tab View","full_name":"react-native-community/react-native-tab-view","description":"A cross-platform Tab View component for React Native","stars":3597,"delta":1038,"monthly":[68,105,68,73,75,86,103,112,69,116,79,61],"tags":["react-native"],"owner_id":20269980,"created_at":"2016-06-15T21:38:19.000Z"},{"name":"React 360","full_name":"facebook/react-360","description":"Create amazing 360 and VR content using React","stars":7762,"delta":995,"monthly":[61,52,56,88,97,98,98,93,90,65,65,98],"tags":["react-native","virtual"],"owner_id":69631,"created_at":"2016-12-12T19:45:37.000Z","url":"https://facebook.github.io/react-360"},{"name":"Metro","full_name":"facebook/metro","description":"The JavaScript bundler for React Native.","stars":3419,"delta":742,"monthly":[50,92,47,38,42,51,52,64,71,74,77,61],"tags":["react-native","module"],"owner_id":69631,"created_at":"2016-12-14T23:02:54.000Z","url":"https://facebook.github.io/metro"},{"name":"ReactXP","full_name":"microsoft/reactxp","description":"Library for cross-platform app development.","stars":8038,"delta":631,"monthly":[46,40,45,44,41,44,31,46,73,111,43,49],"tags":["react-native"],"owner_id":6154722,"created_at":"2017-03-22T19:15:24.000Z","url":"https://microsoft.github.io/reactxp/"},{"name":"Quasar","full_name":"quasarframework/quasar","description":"Responsive Single Page Apps, Server-side Render Apps, Progressive Web Apps, Hybrid Mobile Apps (that look native!) & Electron Apps, all using the same codebase.","stars":13296,"delta":5013,"monthly":[318,372,339,336,392,872,423,375,360,355,455,237],"tags":["mobile","vue"],"owner_id":23064371,"created_at":"2015-10-05T15:45:36.000Z","url":"https://quasar.dev"},{"name":"Ionic","full_name":"ionic-team/ionic","description":"Build amazing Native and Progressive Web Apps with web technologies. One app running on everything","stars":40003,"delta":3645,"monthly":[262,236,292,208,191,246,305,269,297,362,324,539],"tags":["mobile"],"owner_id":3171503,"created_at":"2013-08-20T23:06:02.000Z","url":"https://ionicframework.com/","icon":"ionic.svg"},{"name":"cube-ui","full_name":"didi/cube-ui","description":"A fantastic mobile ui lib implement by Vue","stars":7660,"delta":2577,"monthly":[155,155,141,170,207,208,232,209,281,303,209,227],"tags":["vue","mobile"],"owner_id":27521938,"created_at":"2017-11-03T06:17:27.000Z","url":"https://didi.github.io/cube-ui/"},{"name":"Mint UI","full_name":"ElemeFE/mint-ui","description":"Mobile UI elements for Vue.js","stars":15405,"delta":2182,"monthly":[126,123,97,135,154,144,191,217,299,256,169,195],"tags":["vue","component","mobile"],"owner_id":12810740,"created_at":"2016-05-17T09:54:10.000Z","url":"http://mint-ui.github.io/#!/en","icon":"mint-ui.svg"},{"name":"Weex","full_name":"apache/incubator-weex","description":"A framework for building Mobile cross-platform UI.","stars":13280,"delta":1803,"monthly":[79,87,98,111,124,131,148,167,199,211,161,237],"tags":["vue","mobile"],"owner_id":47359,"created_at":"2017-01-06T08:00:06.000Z","url":"https://weex.apache.org","icon":"weex.svg"},{"name":"Vue Native","full_name":"GeekyAnts/vue-native-core","description":"Vue Native is a framework to build cross platform native mobile apps using JavaScript","stars":6827,"delta":1486,"monthly":[76,93,117,110,104,117,108,104,161,166,121,164],"tags":["mobile","vue"],"owner_id":18482943,"created_at":"2018-02-23T11:44:30.000Z","url":"https://vue-native.io"},{"name":"Framework7","full_name":"framework7io/framework7","description":"Full featured HTML framework for building iOS & Android apps","stars":15092,"delta":1467,"monthly":[94,82,113,96,82,127,98,135,130,170,116,188],"tags":["mobile"],"owner_id":31954178,"created_at":"2014-02-23T12:15:53.000Z","url":"http://framework7.io"},{"name":"Sonar","full_name":"facebook/flipper","description":"A desktop debugging platform for mobile developers.","stars":6073,"delta":1459,"monthly":[126,144,131,103,126,58,55,95,109,120,102,248],"tags":["mobile"],"owner_id":69631,"created_at":"2018-04-12T16:47:36.000Z","url":"https://fbflipper.com/"},{"name":"Express","full_name":"expressjs/express","description":"Fast, unopinionated, minimalist web framework for node.","stars":46905,"delta":5052,"monthly":[397,356,370,319,377,417,360,477,488,469,444,451],"tags":["nodejs-framework","express"],"owner_id":5658226,"created_at":"2009-06-26T18:56:01.000Z","url":"https://expressjs.com","icon":"express.svg"},{"name":"Fastify","full_name":"fastify/fastify","description":"Fast and low overhead web framework, for Node.js","stars":13189,"delta":3870,"monthly":[371,219,251,337,368,271,242,278,480,332,350,247],"tags":["nodejs-framework"],"owner_id":24939410,"created_at":"2016-09-28T19:10:14.000Z","url":"https://www.fastify.io","icon":"fastify.svg"},{"name":"Koa","full_name":"koajs/koa","description":"Expressive middleware for node.js using ES2017 async functions","stars":28296,"delta":3764,"monthly":[240,268,247,262,282,364,248,310,390,378,303,351],"tags":["nodejs-framework"],"owner_id":5055057,"created_at":"2013-07-20T18:53:45.000Z","url":"https://koajs.com"},{"name":"umi","full_name":"umijs/umi","description":"Pluggable enterprise-level react application framework.","stars":6943,"delta":3589,"monthly":[228,359,200,260,266,403,327,281,307,421,163,276],"tags":["nodejs-framework","react"],"owner_id":33895495,"created_at":"2017-11-22T10:09:36.000Z","url":"https://umijs.org/"},{"name":"Egg","full_name":"eggjs/egg","description":"Born to build better enterprise frameworks and apps with Node.js & Koa","stars":14713,"delta":3416,"monthly":[264,227,246,236,295,241,282,277,338,365,220,310],"tags":["nodejs-framework"],"owner_id":15833670,"created_at":"2016-06-18T06:53:23.000Z","url":"https://eggjs.org"},{"name":"Adonis","full_name":"adonisjs/adonis-framework","description":"The Node.js Framework highly focused on developer ergonomics, stability and confidence","stars":7531,"delta":2126,"monthly":[141,195,128,182,147,130,124,186,174,210,240,185],"tags":["nodejs-framework"],"owner_id":13810373,"created_at":"2015-08-15T17:03:54.000Z","url":"https://adonisjs.com"},{"name":"Feathers","full_name":"feathersjs/feathers","description":"A framework for real-time applications and REST APIs with JavaScript and TypeScript","stars":12035,"delta":1729,"monthly":[103,94,168,231,166,132,99,103,148,153,136,154],"tags":["nodejs-framework","realtime","express"],"owner_id":5321853,"created_at":"2011-10-19T22:45:16.000Z","url":"https://feathersjs.com","icon":"feathers.svg"},{"name":"Gun","full_name":"amark/gun","description":"A realtime, decentralized, offline-first, graph protocol to sync the web.","stars":11028,"delta":1570,"monthly":[169,85,116,114,107,121,83,266,124,126,83,120],"tags":["db","realtime","nodejs-framework"],"owner_id":433412,"created_at":"2014-07-31T15:52:10.000Z","url":"https://gun.eco/docs","icon":"gun.svg"},{"name":"Hapi","full_name":"hapijs/hapi","description":"The Simple, Secure Framework Developers Trust","stars":11959,"delta":1331,"monthly":[96,111,150,139,94,70,63,114,126,94,110,121],"tags":["nodejs-framework"],"owner_id":3774533,"created_at":"2011-08-06T00:35:39.000Z","url":"https://hapi.dev","icon":"hapi.svg"},{"name":"Moleculer","full_name":"moleculerjs/moleculer","description":"Progressive microservices framework for Node.js","stars":3185,"delta":1207,"monthly":[91,84,83,119,118,83,77,80,121,100,134,75],"tags":["microservice","nodejs-framework"],"owner_id":25477106,"created_at":"2017-02-17T11:11:35.000Z","url":"https://moleculer.services/"},{"name":"Micro","full_name":"zeit/micro","description":"Asynchronous HTTP microservices","stars":8997,"delta":1142,"monthly":[56,80,60,79,100,90,65,112,101,102,125,123],"tags":["microservice","nodejs-framework"],"owner_id":14985020,"created_at":"2016-01-23T05:17:00.000Z"},{"name":"Sails","full_name":"balderdashy/sails","description":"Realtime MVC Framework for Node.js","stars":21108,"delta":1029,"monthly":[60,76,79,55,70,99,52,102,103,86,97,107],"tags":["nodejs-framework"],"owner_id":1445252,"created_at":"2012-03-18T19:46:15.000Z","url":"https://sailsjs.com","icon":"sails.svg"},{"name":"Node API boilerplate","full_name":"talyssonoc/node-api-boilerplate","description":"DDD/Clean Architecture inspired boilerplate for Node web APIs","stars":1952,"delta":959,"monthly":[137,60,67,54,89,72,58,63,53,84,82,116],"tags":["boilerplate","nodejs-framework"],"owner_id":4325587,"created_at":"2017-03-13T21:16:09.000Z"},{"name":"Meteor","full_name":"meteor/meteor","description":"Meteor, the JavaScript App Platform","stars":41524,"delta":845,"monthly":[54,60,42,50,64,71,63,77,84,96,87,67],"tags":["fullstack","meteor","nodejs-framework"],"owner_id":789528,"created_at":"2012-01-19T01:58:17.000Z","url":"https://www.meteor.com","icon":"meteor.svg"},{"name":"Loopback","full_name":"strongloop/loopback","description":"LoopBack makes it easy to build modern applications that require complex integrations.","stars":12994,"delta":816,"monthly":[46,31,43,33,28,46,25,73,105,126,105,120],"tags":["nodejs-framework"],"owner_id":3020012,"created_at":"2013-04-09T16:02:18.000Z","url":"http://loopback.io","icon":"loopback.svg"},{"name":"Polka","full_name":"lukeed/polka","description":"A micro web server so fast, it'll make you dance!","stars":3547,"delta":767,"monthly":[31,48,42,71,59,90,88,97,47,35,49,86],"tags":["nodejs-framework"],"owner_id":5855893,"created_at":"2017-12-22T05:55:41.000Z"},{"name":"VuePress","full_name":"vuejs/vuepress","description":"Minimalistic Vue-powered static site generator","stars":15238,"delta":4561,"monthly":[279,248,346,370,357,347,381,332,334,487,421,527],"tags":["vue","ssg"],"owner_id":6128107,"created_at":"2018-04-05T16:58:38.000Z","url":"https://vuepress.vuejs.org"},{"name":"Hexo","full_name":"hexojs/hexo","description":"A fast, simple & powerful blog framework, powered by Node.js.","stars":29279,"delta":4429,"monthly":[326,348,317,302,339,454,357,387,390,412,299,377],"tags":["ssg","blog"],"owner_id":6375567,"created_at":"2012-09-23T15:17:08.000Z","url":"https://hexo.io","icon":"hexo.svg"},{"name":"React Static","full_name":"react-static/react-static","description":"A progressive static-site framework for React.","stars":8213,"delta":1850,"monthly":[87,88,108,142,117,124,122,152,228,247,165,185],"tags":["react","ssg","prefetch"],"owner_id":52937112,"created_at":"2017-09-09T22:10:32.000Z","url":"https://react-static.js.org"},{"name":"Jest","full_name":"facebook/jest","description":"Delightful JavaScript Testing.","stars":29185,"delta":6511,"monthly":[446,406,413,415,505,538,442,543,501,733,609,743],"tags":["test-framework","test"],"owner_id":69631,"created_at":"2013-12-10T00:18:04.000Z","url":"https://jestjs.io","icon":"jest.svg"},{"name":"Mocha","full_name":"mochajs/mocha","description":"️ simple, flexible, fun javascript test framework for node.js & the browser","stars":18864,"delta":1936,"monthly":[93,125,114,129,139,169,131,195,190,196,219,189],"tags":["test-framework","test"],"owner_id":8770005,"created_at":"2011-03-07T18:44:25.000Z","url":"https://mochajs.org","icon":"mocha.svg"},{"name":"AVA","full_name":"avajs/ava","description":"JavaScript test runner","stars":17361,"delta":1875,"monthly":[193,104,115,133,115,142,141,160,155,173,188,212],"tags":["test-framework","test"],"owner_id":8527916,"created_at":"2014-11-18T17:20:26.000Z","icon":"ava.svg"},{"name":"Jasmine","full_name":"jasmine/jasmine","description":"Simple JavaScript testing framework for browsers and node.js","stars":14663,"delta":578,"monthly":[24,41,30,39,60,19,36,68,71,49,72,46],"tags":["test-framework","test"],"owner_id":4624349,"created_at":"2008-12-02T23:46:37.000Z","url":"http://jasmine.github.io/","icon":"jasmine.svg"},{"name":"Enzyme","full_name":"airbnb/enzyme","description":"JavaScript Testing utilities for React","stars":18348,"delta":2212,"monthly":[97,113,119,154,140,222,159,241,209,264,226,217],"tags":["test","react"],"owner_id":698437,"created_at":"2015-11-10T21:45:38.000Z","url":"https://airbnb.io/enzyme/"},{"name":"jsdom","full_name":"jsdom/jsdom","description":"A JavaScript implementation of various web standards, for use with Node.js","stars":13429,"delta":2021,"monthly":[134,148,139,141,176,172,132,179,199,191,165,188],"tags":["test"],"owner_id":9271229,"created_at":"2010-01-19T06:55:19.000Z","icon":"jsdom.svg"},{"name":"nock","full_name":"nock/nock","description":"HTTP server mocking and expectations library for Node.js","stars":9026,"delta":1616,"monthly":[91,144,173,143,154,120,115,100,110,116,107,182],"tags":["test"],"owner_id":17545810,"created_at":"2011-09-22T10:08:03.000Z"},{"name":"SuperTest","full_name":"visionmedia/supertest","description":"🕷Super-agent driven library for testing node.js HTTP servers using a fluent API.","stars":9379,"delta":1538,"monthly":[102,86,115,108,123,123,106,140,139,140,131,184],"tags":["test"],"owner_id":9285252,"created_at":"2012-06-27T20:56:12.000Z"},{"name":"React Cosmos","full_name":"react-cosmos/react-cosmos","description":"A dev environment for building scalable, high-quality user interfaces","stars":5859,"delta":1288,"monthly":[221,53,42,50,189,113,77,97,73,105,60,175],"tags":["react","test"],"owner_id":23018767,"created_at":"2014-02-05T18:48:27.000Z"},{"name":"Polly.JS","full_name":"Netflix/pollyjs","description":"Record, Replay, and Stub HTTP Interactions.","stars":8253,"delta":1194,"monthly":[72,37,41,66,103,177,47,61,154,72,145,187],"tags":["test"],"owner_id":913567,"created_at":"2018-05-31T20:39:44.000Z","url":"https://netflix.github.io/pollyjs"},{"name":"Sinon.JS","full_name":"sinonjs/sinon","description":"Test spies, stubs and mocks for JavaScript.","stars":7732,"delta":977,"monthly":[60,62,58,100,90,82,50,89,87,95,85,86],"tags":["test"],"owner_id":6570253,"created_at":"2010-06-29T21:15:32.000Z","url":"https://sinonjs.org/"},{"name":"Artillery","full_name":"artilleryio/artillery","description":"Artillery is a load testing and functional testing toolkit. Modern, powerful, and easy to use. Use it to ship scalable backends, APIs & services that stay performant & resilient under high load.","stars":3353,"delta":906,"monthly":[70,70,72,71,79,65,52,70,77,99,71,81],"tags":["test"],"owner_id":12608521,"created_at":"2015-05-28T12:31:42.000Z","url":"https://artillery.io"},{"name":"Istanbul","full_name":"istanbuljs/nyc","description":" Code coverage tool that computes statement, line, function and branch coverage","stars":3957,"delta":857,"monthly":[57,68,69,60,75,78,51,74,58,94,80,75],"tags":["test"],"owner_id":13523395,"created_at":"2015-05-09T02:55:45.000Z","url":"https://istanbul.js.org/","icon":"istanbul.svg"},{"name":"Chai","full_name":"chaijs/chai","description":"BDD / TDD assertion framework for node.js and the browser that can be paired with any testing framework.","stars":6668,"delta":709,"monthly":[27,47,56,52,40,53,62,91,66,65,60,77],"tags":["test"],"owner_id":1515293,"created_at":"2011-12-07T08:06:35.000Z","url":"http://chaijs.com","icon":"chai.svg"},{"name":"fast-check","full_name":"dubzzz/fast-check","description":"Property based testing framework for JavaScript (like QuickCheck) written in TypeScript","stars":959,"delta":667,"monthly":[76,39,46,50,70,55,56,57,49,77,30,43],"tags":["test"],"owner_id":5300235,"created_at":"2017-10-30T23:41:11.000Z"},{"name":"Karma","full_name":"karma-runner/karma","description":"Spectacular Test Runner for JavaScript","stars":11039,"delta":617,"monthly":[19,45,53,77,40,54,33,41,44,56,53,68],"tags":["test"],"owner_id":3284117,"created_at":"2011-10-12T07:55:46.000Z","url":"http://karma-runner.github.io","icon":"karma.svg"},{"name":"vue-cli","full_name":"vuejs/vue-cli","description":"Standard Tooling for Vue.js Development","stars":24019,"delta":5780,"monthly":[324,364,436,372,427,425,436,512,617,656,446,588],"tags":["vue"],"owner_id":6128107,"created_at":"2015-12-26T23:11:20.000Z","url":"https://cli.vuejs.org/"},{"name":"Vant","full_name":"youzan/vant","description":"Lightweight Mobile UI Components built on Vue","stars":12378,"delta":5124,"monthly":[399,502,552,440,605,408,472,382,372,348,227,291],"tags":["vue","component"],"owner_id":11404085,"created_at":"2017-04-19T07:55:31.000Z","url":"https://youzan.github.io/vant"},{"name":"Vuex","full_name":"vuejs/vuex","description":"Centralized State Management for Vue.js.","stars":22576,"delta":4122,"monthly":[243,238,246,259,290,329,319,412,403,508,341,389],"tags":["flux","vue","state"],"owner_id":6128107,"created_at":"2015-07-16T04:21:26.000Z","url":"https://vuex.vuejs.org"},{"name":"iView","full_name":"iview/iview","description":"A high quality UI Toolkit built on Vue.js 2.0","stars":22955,"delta":3819,"monthly":[99,113,136,193,232,345,286,390,537,550,290,521],"tags":["vue","component"],"owner_id":20693613,"created_at":"2016-07-28T01:52:59.000Z","url":"http://iview.talkingdata.com","icon":"iview.svg"},{"name":"Filepond","full_name":"pqina/filepond","description":"A flexible and fun JavaScript file upload library","stars":8494,"delta":3745,"monthly":[203,147,136,302,402,292,847,283,212,231,417,182],"tags":["upload","react","vue"],"owner_id":22966117,"created_at":"2017-10-09T12:17:44.000Z","url":"https://pqina.nl/filepond"},{"name":"tiptap","full_name":"scrumpy/tiptap","description":"A rich-text editor for Vue.js","stars":6359,"delta":3710,"monthly":[110,168,295,164,150,201,542,1282,191,210,173,134],"tags":["vue","rich-text-editor"],"owner_id":37333181,"created_at":"2018-08-20T19:58:58.000Z","url":"https://tiptap.scrumpy.io"},{"name":"BootstrapVue","full_name":"bootstrap-vue/bootstrap-vue","description":"BootstrapVue, with over 40 plugins, more than 80 custom components and over 300 icons, provides one of the most comprehensive implementations of Bootstrap v4 components and grid system for Vue.js. With extensive and automated WAI-ARIA accessibility markup.","stars":10694,"delta":3200,"monthly":[172,179,191,236,235,285,243,274,349,310,311,319],"tags":["vue","component","bootstrap"],"owner_id":22965283,"created_at":"2016-10-08T15:59:35.000Z","url":"https://bootstrap-vue.js.org"},{"name":"vue-router","full_name":"vuejs/vue-router","description":"The official router for Vue.js.","stars":15469,"delta":3052,"monthly":[203,190,207,213,250,224,224,281,297,332,231,289],"tags":["vue","routing"],"owner_id":6128107,"created_at":"2013-12-11T19:37:46.000Z","url":"http://router.vuejs.org/"},{"name":"Buefy","full_name":"buefy/buefy","description":"Lightweight UI components for Vue.js based on Bulma","stars":6842,"delta":2459,"monthly":[124,154,171,203,200,163,159,160,207,290,373,173],"tags":["vue","component"],"owner_id":26799900,"created_at":"2017-03-31T16:44:48.000Z","url":"https://buefy.org"}]}

/***/ }),
/* 423 */
/***/ (function(module, exports) {

	module.exports = [{"code":"en","text":"English"},{"code":"zh","text":"中文"},{"code":"ja","text":"日本語"},{"code":"fr","text":"Français"},{"code":"es","text":"Español"},{"code":"id","text":"Indonesia"}]

/***/ }),
/* 424 */
/***/ (function(module, exports) {

	module.exports = [{"year":2016,"languages":["en","zh","ja"]},{"year":2017,"languages":["en","zh","ja","fr","es","id"]},{"year":2018,"languages":["en","zh","es"]},{"year":2019,"languages":["en","zh","es","ja"]}]

/***/ }),
/* 425 */
/***/ (function(module, exports) {

	module.exports = {"AElig":"Æ","AMP":"&","Aacute":"Á","Acirc":"Â","Agrave":"À","Aring":"Å","Atilde":"Ã","Auml":"Ä","COPY":"©","Ccedil":"Ç","ETH":"Ð","Eacute":"É","Ecirc":"Ê","Egrave":"È","Euml":"Ë","GT":">","Iacute":"Í","Icirc":"Î","Igrave":"Ì","Iuml":"Ï","LT":"<","Ntilde":"Ñ","Oacute":"Ó","Ocirc":"Ô","Ograve":"Ò","Oslash":"Ø","Otilde":"Õ","Ouml":"Ö","QUOT":"\"","REG":"®","THORN":"Þ","Uacute":"Ú","Ucirc":"Û","Ugrave":"Ù","Uuml":"Ü","Yacute":"Ý","aacute":"á","acirc":"â","acute":"´","aelig":"æ","agrave":"à","amp":"&","aring":"å","atilde":"ã","auml":"ä","brvbar":"¦","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","curren":"¤","deg":"°","divide":"÷","eacute":"é","ecirc":"ê","egrave":"è","eth":"ð","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","iacute":"í","icirc":"î","iexcl":"¡","igrave":"ì","iquest":"¿","iuml":"ï","laquo":"«","lt":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","ntilde":"ñ","oacute":"ó","ocirc":"ô","ograve":"ò","ordf":"ª","ordm":"º","oslash":"ø","otilde":"õ","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","raquo":"»","reg":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","thorn":"þ","times":"×","uacute":"ú","ucirc":"û","ugrave":"ù","uml":"¨","uuml":"ü","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 426 */
/***/ (function(module, exports) {

	module.exports = {"0":"�","128":"€","130":"‚","131":"ƒ","132":"„","133":"…","134":"†","135":"‡","136":"ˆ","137":"‰","138":"Š","139":"‹","140":"Œ","142":"Ž","145":"‘","146":"’","147":"“","148":"”","149":"•","150":"–","151":"—","152":"˜","153":"™","154":"š","155":"›","156":"œ","158":"ž","159":"Ÿ"}

/***/ }),
/* 427 */
/***/ (function(module, exports) {

	module.exports = ["address","article","aside","base","basefont","blockquote","body","caption","center","col","colgroup","dd","details","dialog","dir","div","dl","dt","fieldset","figcaption","figure","footer","form","frame","frameset","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","iframe","legend","li","link","main","menu","menuitem","meta","nav","noframes","ol","optgroup","option","p","param","pre","section","source","title","summary","table","tbody","td","tfoot","th","thead","title","tr","track","ul"]

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	module.exports = {"page":{"title":"2016 JavaScript Rising Stars","description":"A complete overview of the JavaScript landscape in 2016: trends about front-end and node.js frameworks, tooling, IDE, Static site generators..."},"header":{"title":"2016 JavaScript Rising Stars"},"introduction":{"table_of_contents":"Table of Contents","explanation":"The following graphs compare the number of stars added on Github over the last 12 months. We analyzed projects coming from {link}, a curated list of the best projects related to the web platform."},"conclusion":"Conclusion","categories":{"all":"Most Popular Projects in 2016","framework":"Front-end Frameworks","nodejsframework":"Node.js Frameworks","react":"React Ecosystem","mobile":"Mobile","compiler":"Compilers","build":"Build Tools","testframework":"Testing Frameworks","ide":"IDE","ssg":"Static Site Generators"},"social":{"text":"Check the JavaScript landscape in 2016"}}

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	module.exports = {"page":{"title":"JavaScript ベスト・オブ・ザ・イヤー 2016","description":"2016年 JavaScript 白書: フロントエンド、Node.jsフレームワーク、ツールチェーン、IDE、静的サイトジェネレータなど、2016年のJavaScriptの動向を完全網羅"},"header":{"title":"JavaScript ベスト・オブ・ザ・イヤー 2016"},"introduction":{"table_of_contents":"目次","explanation":"本サイトに掲載したチャートは、2016年の12か月間にGithubでカウントされたスター数をプロジェクト別に比較したものです。分析対象のプロジェクトは {link} から収集したものです。 {link} では、Webテクノロジに関連するベストプロジェクトをまとめています。"},"conclusion":"おわりに","categories":{"all":"2016年人気プロジェクトランキング","framework":"フロントエンドフレームワーク","nodejsframework":"Node.jsフレームワーク","react":"Reactボイラープレート","mobile":"モバイル","compiler":"コンパイラ","build":"ビルドツール","testframework":"テスティングフレームワーク","ide":"統合開発環境（IDE）","ssg":"静的サイトジェネレータ"},"social":{"text":"「2016年 JavaScript 白書」をチェックする"}}

/***/ }),
/* 430 */
/***/ (function(module, exports) {

	module.exports = {"page":{"title":"2016 年崛起的 JS 项目","description":"对 2016 年 JS 领域的完整回顾，内容包括：框架、工具、IDE、静态网站生成器..."},"header":{"title":"2016 年崛起的 JS 项目"},"introduction":{"table_of_contents":"目录","explanation":"下列图表对比了各个项目 Github 上 2016 年新增 star 的数量。分析的项目主要来自 {link}，这里列出了 WEB 领域的最佳项目。"},"conclusion":"总结","categories":{"all":"最受欢迎项目","framework":"前端框架","nodejsframework":"Node.js 框架","react":"React 项目模板","mobile":"移动开发","compiler":"编译工具","build":"构建工具","testframework":"测试框架","ide":"IDE","ssg":"静态网站生成器"},"social":{"text":"了解 2016 年崛起的 JS 项目"}}

/***/ }),
/* 431 */
/***/ (function(module, exports) {

	module.exports = {"page":{"title":"2017 JavaScript Rising Stars","description":"A complete overview of the JavaScript landscape in 2017: trends about front-end and node.js frameworks, tooling, IDE, Static site generators..."},"header":{"title":"2017 JavaScript Rising Stars"},"introduction":{"table_of_contents":"Table of Contents","explanation":"The following graphs compare the number of stars added on Github over the last 12 months. We analyzed projects coming from {link}, a curated list of the best projects related to the web platform. Note that you can click on a project to get more info."},"conclusion":"Conclusion","categories":{"all":"Most Popular Projects Overall","framework":"Front-end Frameworks","nodejsframework":"Node.js Frameworks","react":"React Ecosystem","vue":"Vue Ecosystem","mobile":"Mobile","compiler":"Compilers","build":"Build Tools","testframework":"Testing Frameworks","ide":"IDEs & Editors","ssg":"Static Sites","cssinjs":"CSS in JavaScript","graphql":"GraphQL","misc":"Miscellaneous"},"categories-share":{"all":"JavaScript project","framework":"front-end framework","nodejsframework":"Node project","react":"React library","vue":"Vue library","mobile":"mobile framework","compiler":"JavaScript compiler","build":"build tool","testframework":"JavaScript testing framework","ide":"IDE","ssg":"JavaScript static site generator","cssinjs":"CSS-in-JS library","graphql":"JavaScript GraphQL project"},"social":{"text":"Check the JavaScript landscape in 2017"}}

/***/ }),
/* 432 */
/***/ (function(module, exports) {

	module.exports = {"page":{"title":"Los mejores proyectos JavaScript del 2017","description":"Un completo análisis del universo JavaScript en 2017: tendencias en front-end y frameworks node.js, herramientas, IDE, Generadores de páginas estáticas..."},"header":{"title":"Los mejores proyectos JavaScript del 2017"},"introduction":{"table_of_contents":"Categorías","explanation":"Los siguientes gráficos comparan el número de estrellas añadidas en GitHub durante los últimos 12 meses. Hemos analizado proyectos procedentes de {link}, una lista de los proyectos más destacados del mundo web cuidadosamente seleccionados. Si lo deseas, puedes hacer click en cualquier proyecto para conseguir más información."},"conclusion":"Conclusión","categories":{"all":"Proyectos más populares del 2017","framework":"Frameworks Front-end","nodejsframework":"Frameworks Node.js","react":"Ecosistema React","vue":"Ecosistema Vue","mobile":"Móvil","compiler":"Compiladores JS","build":"Build","testframework":"Testing","ide":"Editores","ssg":"SSG","cssinjs":"CSS en JavaScript","graphql":"GraphQL","misc":"Miscelánea"},"categories-share":{"all":"Proyecto JavaScript","framework":"Framework front-end","nodejsframework":"Proyecto Node","react":"Librería React","vue":"Librería Vue","mobile":"Framework móvil","compiler":"Compilador JavaScript","build":"Build","testframework":"Testing","ide":"Editor","ssg":"SSG","cssinjs":"Librería CSS-en-JS","graphql":"Proyecto GraphQL JavaScript"},"social":{"text":"Echa una vistazo al universo JavaScript del 2017"}}

/***/ }),
/* 433 */
/***/ (function(module, exports) {

	module.exports = {"page":{"title":"Les Meilleurs Projets JavaScript en 2017","description":"Un panorama complet du paysage du language JavaScript en 2017, côté client, serveur, mobile..."},"header":{"title":"Les Meilleurs Projets JavaScript en 2017"},"introduction":{"table_of_contents":"Sommaire","explanation":"Les chiffres présentés sont les nombres d'étoiles ajoutées sur GitHub au cours de l'année 2017. Les projets présentés proviennent de {link}, une application web qui rassemble toutes les tendances liées au développement web."},"conclusion":"Conclusion","categories":{"all":"Projets les plus populaires en 2017","framework":"Frameworks côté client","nodejsframework":"Frameworks node.js","react":"Eco-système React","vue":"Eco-système Vue","mobile":"Mobile","compiler":"Compilateurs JavaScript","build":"Outils de construction","testframework":"Frameworks de test","ide":"Editeurs de texte","ssg":"Générateurs de Site Statique","cssinjs":"Feuilles de style en JavaScript","graphql":"GraphQL","misc":"Divers"},"categories-share":{"all":"le projet JavaScript","framework":"le framework JavaScript côté client","nodejsframework":"le framework Node.js","react":"le projet React","vue":"le project Vue.js","mobile":"le framework JavaScript pour mobiles","compiler":"le compilateur JavaScript","build":"l'outil de construction JavaScript","testframework":"le framework de test JavaScript","ide":"l'éditeur de texte","ssg":"le générateur de site statique JavaScript","cssinjs":"l'outil CSS-dans-JavaScript","graphql":"le projet GraphQL JavaScript"},"social":{"text":"Retour sur les tendances de l'année 2017 sur la planète JavaScript"}}

/***/ }),
/* 434 */
/***/ (function(module, exports) {

	module.exports = {"page":{"title":"JavaScript Rising Stars 2017","description":"Sebuah pandangan lengkap tentang dunia JavaScript di tahun 2017: tren seputar frameworks front-end dan node.js, tooling, IDE, Static site generators..."},"header":{"title":"JavaScript Rising Stars 2017"},"introduction":{"table_of_contents":"Daftar Isi","explanation":"Grafik berikut membandingkan jumlah bintang yang diterima di GitHub selama 12 terakhir. Kami menganalisa proyek-proyek dari {link}, sebuah daftar proyek-proyek terbaik di dunia web. Ingat bahwa anda bisa mengklik salah satu proyek untuk mendapatkan informasi lebih lengkap."},"conclusion":"Kesimpulan","categories":{"all":"Proyek Paling Populer Secara Keseluruhan","framework":"Front-end Frameworks","nodejsframework":"Node.js Frameworks","react":"React Ecosystem","vue":"Vue Ecosystem","mobile":"Mobile","compiler":"Compilers","build":"Build Tools","testframework":"Testing Frameworks","ide":"IDEs & Editors","ssg":"Static Sites","cssinjs":"CSS in JavaScript","graphql":"GraphQL"},"categories-share":{"all":"JavaScript project","framework":"front-end framework","nodejsframework":"Node project","react":"React library","vue":"Vue library","mobile":"mobile framework","compiler":"JavaScript compiler","build":"build tool","testframework":"JavaScript testing framework","ide":"IDE","ssg":"JavaScript static site generator","cssinjs":"CSS-in-JS library","graphql":"JavaScript GraphQL project"},"social":{"text":"Cari tahu proyek JavaScript paling populer tahun 2017"}}

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	module.exports = {"page":{"title":"JavaScript ベスト・オブ・ザ・イヤー 2017","description":"2017年 JavaScript 白書: フロントエンド、Node.jsフレームワーク、ツールチェーン、IDE、静的サイトジェネレータなど、2017年のJavaScriptの動向を完全網羅"},"header":{"title":"JavaScript ベスト・オブ・ザ・イヤー 2017"},"introduction":{"table_of_contents":"目次","explanation":"本サイトに掲載したチャートは、2017年の12か月間にGithubでカウントされたスター数をプロジェクト別に比較したものです。分析対象のプロジェクトは {link} から収集したものです。 {link} では、Webテクノロジに関連するベストプロジェクトをまとめています。"},"conclusion":"おわりに","categories":{"all":"2017年人気プロジェクトランキング","framework":"フロントエンドフレームワーク","nodejsframework":"Node.jsフレームワーク","react":"Reactボイラープレート","vue":"Vue Ecosystem","mobile":"モバイル","compiler":"コンパイラ","build":"ビルドツール","testframework":"テスティングフレームワーク","ide":"統合開発環境（IDE）","ssg":"静的サイトジェネレータ","cssinjs":"CSS in JavaScript","graphql":"GraphQL","misc":"番外編"},"social":{"text":"「2017年 JavaScript 白書」をチェックする"}}

/***/ }),
/* 436 */
/***/ (function(module, exports) {

	module.exports = {"page":{"title":"2017年 JavaScript 明星项目","description":"对2017年 JavaScript 领域，在前端框架、Node.js 框架、编译工具、构建工具、测试框架、IDE、静态网站生成器...等各方面进行完整的回顾"},"header":{"title":"2017年 JavaScript 明星项目"},"introduction":{"table_of_contents":"目录","explanation":"下列图表对比了各个项目在 Github 上于过去 12 个月新增的 star 数量。分析的数据来源为 {link} 网站 ，一个 WEB 领域优秀项目的精选网站。通过点击项目，可以查看更多信息。"},"conclusion":"总结","categories":{"all":"最受欢迎项目","framework":"前端框架","nodejsframework":"Node.js 框架","react":"React 生态圈","vue":"Vue 生态圈","mobile":"移动开发","compiler":"编译工具","build":"构建工具","testframework":"测试框架","ide":"IDE 和编辑器","ssg":"静态网站生成器","cssinjs":"CSS in JavaScript","graphql":"GraphQL","misc":"杂项"},"categories-share":{"all":"JavaScript 项目","framework":"前端框架","nodejsframework":"Node.js 框架","react":"React 生态圈","vue":"Vue 生态圈","mobile":"移动开发","compiler":"编译工具","build":"构建工具","testframework":"JavaScript 测试框架","ide":"IDE","ssg":"静态网站","cssinjs":"CSS in JavaScript","graphql":"Javascript GraphQL 项目"},"social":{"text":"2017年 JavaScript 领域回顾"}}

/***/ }),
/* 437 */
/***/ (function(module, exports) {

	module.exports = {"page":{"title":"2018 JavaScript Rising Stars","description":"A complete overview of the JavaScript landscape in 2018: trends about front-end and node.js frameworks, tooling, IDE, Static site generators..."},"header":{"title":"2018 JavaScript Rising Stars"},"introduction":{"table_of_contents":"Table of Contents","explanation":"The following graphs compare the number of stars added on Github over the last 12 months. We analyzed projects coming from {link}, a curated list of the best projects related to the web platform. Note that you can click on a project to get more info."},"conclusion":"Conclusion","categories":{"all":"Most Popular Projects Overall","framework":"Front-end Frameworks","nodejsframework":"Node.js Frameworks","react":"React Ecosystem","vue":"Vue Ecosystem","angular":"Angular Ecosystem","mobile":"Mobile","compiler":"Compilers","build":"Build Tools","testframework":"Testing Frameworks","ide":"IDEs & Editors","ssg":"Static Sites","cssinjs":"CSS in JavaScript","graphql":"GraphQL","misc":"Miscellaneous","learning":"Learning Resource"},"categories-share":{"all":"JavaScript project","framework":"front-end framework","nodejsframework":"Node project","react":"React library","vue":"Vue library","angular":"Angular library","mobile":"mobile framework","compiler":"JavaScript compiler","build":"build tool","testframework":"JavaScript testing framework","ide":"IDE","ssg":"JavaScript static site generator","cssinjs":"CSS-in-JS library","graphql":"JavaScript GraphQL project","learning":"Learning Resource"},"social":{"text":"Check the JavaScript landscape in 2018"}}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	module.exports = {"page":{"title":"Los mejores proyectos JavaScript del 2018","description":"Un completo análisis del universo JavaScript en 2018: tendencias en front-end y frameworks node.js, herramientas, IDE, Generadores de páginas estáticas..."},"header":{"title":"Los mejores proyectos JavaScript del 2018"},"introduction":{"table_of_contents":"Categorías","explanation":"Los siguientes gráficos comparan el número de estrellas añadidas en GitHub durante los últimos 12 meses. Hemos analizado proyectos procedentes de {link}, una lista de los proyectos más destacados del mundo web cuidadosamente seleccionados. Si lo deseas, puedes hacer click en cualquier proyecto para conseguir más información."},"conclusion":"Conclusión","categories":{"all":"Proyectos más populares del 2018","framework":"Frameworks Front-end","nodejsframework":"Frameworks Node.js","react":"Ecosistema React","vue":"Ecosistema Vue","angular":"Ecosistema Angular","mobile":"Móvil","compiler":"Compiladores JS","build":"Build","testframework":"Testing","ide":"Editores","ssg":"SSG","cssinjs":"CSS en JavaScript","graphql":"GraphQL","misc":"Miscelánea","learning":"Recursos de aprendizaje"},"categories-share":{"all":"Proyecto JavaScript","framework":"Framework front-end","nodejsframework":"Proyecto Node","react":"Librería React","vue":"Librería Vue","angular":"Librería Angular","mobile":"Framework móvil","compiler":"Compilador JavaScript","build":"Build","testframework":"Testing","ide":"Editor","ssg":"SSG","cssinjs":"Librería CSS-en-JS","graphql":"Proyecto GraphQL JavaScript","learning":"Recurso de aprendizaje"},"social":{"text":"Echa una vistazo al universo JavaScript del 2018"}}

/***/ }),
/* 439 */
/***/ (function(module, exports) {

	module.exports = {"page":{"title":"Les Meilleurs Projets JavaScript en 2017","description":"Un panorama complet du paysage du language JavaScript en 2017, côté client, serveur, mobile..."},"header":{"title":"Les Meilleurs Projets JavaScript en 2017"},"introduction":{"table_of_contents":"Sommaire","explanation":"Les chiffres présentés sont les nombres d'étoiles ajoutées sur GitHub au cours de l'année 2017. Les projets présentés proviennent de {link}, une application web qui rassemble toutes les tendances liées au développement web."},"conclusion":"Conclusion","categories":{"all":"Projets les plus populaires en 2017","framework":"Frameworks côté client","nodejsframework":"Frameworks node.js","react":"Eco-système React","vue":"Eco-système Vue","mobile":"Mobile","compiler":"Compilateurs JavaScript","build":"Outils de construction","testframework":"Frameworks de test","ide":"Editeurs de texte","ssg":"Générateurs de Site Statique","cssinjs":"Feuilles de style en JavaScript","graphql":"GraphQL","misc":"Divers","learning":"Learning Resource"},"categories-share":{"all":"le projet JavaScript","framework":"le framework JavaScript côté client","nodejsframework":"le framework Node.js","react":"le projet React","vue":"le project Vue.js","mobile":"le framework JavaScript pour mobiles","compiler":"le compilateur JavaScript","build":"l'outil de construction JavaScript","testframework":"le framework de test JavaScript","ide":"l'éditeur de texte","ssg":"le générateur de site statique JavaScript","cssinjs":"l'outil CSS-dans-JavaScript","graphql":"le projet GraphQL JavaScript","learning":"Learning Resource"},"social":{"text":"Retour sur les tendances de l'année 2017 sur la planète JavaScript"}}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	module.exports = {"page":{"title":"JavaScript Rising Stars 2017","description":"Sebuah pandangan lengkap tentang dunia JavaScript di tahun 2017: tren seputar frameworks front-end dan node.js, tooling, IDE, Static site generators..."},"header":{"title":"JavaScript Rising Stars 2017"},"introduction":{"table_of_contents":"Daftar Isi","explanation":"Grafik berikut membandingkan jumlah bintang yang diterima di GitHub selama 12 terakhir. Kami menganalisa proyek-proyek dari {link}, sebuah daftar proyek-proyek terbaik di dunia web. Ingat bahwa anda bisa mengklik salah satu proyek untuk mendapatkan informasi lebih lengkap."},"conclusion":"Kesimpulan","categories":{"all":"Proyek Paling Populer Secara Keseluruhan","framework":"Front-end Frameworks","nodejsframework":"Node.js Frameworks","react":"React Ecosystem","vue":"Vue Ecosystem","mobile":"Mobile","compiler":"Compilers","build":"Build Tools","testframework":"Testing Frameworks","ide":"IDEs & Editors","ssg":"Static Sites","cssinjs":"CSS in JavaScript","graphql":"GraphQL"},"categories-share":{"all":"JavaScript project","framework":"front-end framework","nodejsframework":"Node project","react":"React library","vue":"Vue library","mobile":"mobile framework","compiler":"JavaScript compiler","build":"build tool","testframework":"JavaScript testing framework","ide":"IDE","ssg":"JavaScript static site generator","cssinjs":"CSS-in-JS library","graphql":"JavaScript GraphQL project"},"social":{"text":"Cari tahu proyek JavaScript paling populer tahun 2017"}}

/***/ }),
/* 441 */
/***/ (function(module, exports) {

	module.exports = {"page":{"title":"JavaScript ベスト・オブ・ザ・イヤー 2017","description":"2017年 JavaScript 白書: フロントエンド、Node.jsフレームワーク、ツールチェーン、IDE、静的サイトジェネレータなど、2017年のJavaScriptの動向を完全網羅"},"header":{"title":"JavaScript ベスト・オブ・ザ・イヤー 2017"},"introduction":{"table_of_contents":"目次","explanation":"本サイトに掲載したチャートは、2017年の12か月間にGithubでカウントされたスター数をプロジェクト別に比較したものです。分析対象のプロジェクトは {link} から収集したものです。 {link} では、Webテクノロジに関連するベストプロジェクトをまとめています。"},"conclusion":"おわりに","categories":{"all":"2017年人気プロジェクトランキング","framework":"フロントエンドフレームワーク","nodejsframework":"Node.jsフレームワーク","react":"Reactボイラープレート","vue":"Vue Ecosystem","mobile":"モバイル","compiler":"コンパイラ","build":"ビルドツール","testframework":"テスティングフレームワーク","ide":"統合開発環境（IDE）","ssg":"静的サイトジェネレータ","cssinjs":"CSS in JavaScript","graphql":"GraphQL","misc":"番外編","learning":"Learning Resource"},"social":{"text":"「2017年 JavaScript 白書」をチェックする"}}

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	module.exports = {"page":{"title":"2018年 JavaScript 明星项目","description":"对2018年 JavaScript 领域，在前端框架、Node.js 框架、编译工具、构建工具、测试框架、IDE、静态网站生成器...等各方面进行完整的回顾"},"header":{"title":"2018年 JavaScript 明星项目"},"introduction":{"table_of_contents":"目录","explanation":"下列图表对比了各个项目在 Github 上于过去 12 个月新增的 star 数量。分析的数据来源为 {link} 网站 ，一个 WEB 领域优秀项目的精选网站。通过点击项目，可以查看更多信息。"},"conclusion":"总结","categories":{"all":"最受欢迎项目","framework":"前端框架","nodejsframework":"Node.js 框架","react":"React 生态圈","vue":"Vue 生态圈","angular":"Angular 生态圈","mobile":"移动开发","compiler":"编译工具","build":"构建工具","testframework":"测试框架","ide":"IDE 和编辑器","ssg":"静态网站生成器","cssinjs":"CSS in JavaScript","graphql":"GraphQL","misc":"杂项","learning":"学习资源"},"categories-share":{"all":"JavaScript 项目","framework":"前端框架","nodejsframework":"Node.js 框架","react":"React 生态圈","vue":"Vue 生态圈","angular":"Angular 生态圈","mobile":"移动开发","compiler":"编译工具","build":"构建工具","testframework":"JavaScript 测试框架","ide":"IDE","ssg":"静态网站","cssinjs":"CSS in JavaScript","graphql":"Javascript GraphQL 项目","learning":"学习资源"},"social":{"text":"2018年 JavaScript 领域回顾"}}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	module.exports = {"page":{"title":"2019 JavaScript Rising Stars","description":"A complete overview of the JavaScript landscape in 2019: trends about front-end and node.js frameworks, tooling, IDE, Static site generators..."},"header":{"title":"2019 JavaScript Rising Stars"},"introduction":{"table_of_contents":"Table of Contents","explanation":"The following graphs compare the number of stars added on Github over the last 12 months. We analyzed projects coming from {link}, a curated list of the best projects related to the web platform. Note that you can click on a project to get more info."},"conclusion":"Conclusion","categories":{"all":"Most Popular Projects Overall","framework":"Front-end Frameworks","nodejsframework":"Node.js Frameworks","react":"React Ecosystem","vue":"Vue Ecosystem","angular":"Angular Ecosystem","mobile":"Mobile","compiler":"Compilers","build":"Build Tools","testframework":"Testing","ide":"IDEs & Editors","ssg":"Static Sites","cssinjs":"CSS in JavaScript","graphql":"GraphQL","misc":"Miscellaneous","learning":"Learning Resource"},"categories-share":{"all":"JavaScript project","framework":"front-end framework","nodejsframework":"Node project","react":"React library","vue":"Vue library","angular":"Angular library","mobile":"mobile framework","compiler":"JavaScript compiler","build":"build tool","testframework":"JavaScript testing","ide":"IDE","ssg":"JavaScript static site generator","cssinjs":"CSS-in-JS library","graphql":"JavaScript GraphQL project","learning":"Learning Resource"},"social":{"text":"Check the JavaScript landscape in 2019"}}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	module.exports = {"page":{"title":"Los mejores proyectos JavaScript del 2019","description":"Un completo análisis del universo JavaScript en 2019: tendencias en front-end y frameworks node.js, herramientas, IDE, Generadores de páginas estáticas..."},"header":{"title":"Los mejores proyectos JavaScript del 2019"},"introduction":{"table_of_contents":"Categorías","explanation":"Los siguientes gráficos comparan el número de estrellas añadidas en GitHub durante los últimos 12 meses. Hemos analizado proyectos procedentes de {link}, una lista de los proyectos más destacados del mundo web cuidadosamente seleccionados. Si lo deseas, puedes hacer click en cualquier proyecto para conseguir más información."},"conclusion":"Conclusión","categories":{"all":"Proyectos más populares del 2019","framework":"Frameworks Front-end","nodejsframework":"Frameworks Node.js","react":"Ecosistema React","vue":"Ecosistema Vue","angular":"Ecosistema Angular","mobile":"Móvil","compiler":"Compiladores JS","build":"Build","testframework":"Testing","ide":"Editores","ssg":"SSG","cssinjs":"CSS en JavaScript","graphql":"GraphQL","misc":"Miscelánea","learning":"Recursos de aprendizaje"},"categories-share":{"all":"Proyecto JavaScript","framework":"Framework front-end","nodejsframework":"Proyecto Node","react":"Librería React","vue":"Librería Vue","angular":"Librería Angular","mobile":"Framework móvil","compiler":"Compilador JavaScript","build":"Build","testframework":"Testing","ide":"Editor","ssg":"SSG","cssinjs":"Librería CSS-en-JS","graphql":"Proyecto GraphQL JavaScript","learning":"Recurso de aprendizaje"},"social":{"text":"Echa un vistazo al universo JavaScript del 2019"}}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	module.exports = {"page":{"title":"Les Meilleurs Projets JavaScript en 2017","description":"Un panorama complet du paysage du language JavaScript en 2017, côté client, serveur, mobile..."},"header":{"title":"Les Meilleurs Projets JavaScript en 2017"},"introduction":{"table_of_contents":"Sommaire","explanation":"Les chiffres présentés sont les nombres d'étoiles ajoutées sur GitHub au cours de l'année 2017. Les projets présentés proviennent de {link}, une application web qui rassemble toutes les tendances liées au développement web."},"conclusion":"Conclusion","categories":{"all":"Projets les plus populaires en 2017","framework":"Frameworks côté client","nodejsframework":"Frameworks node.js","react":"Eco-système React","vue":"Eco-système Vue","mobile":"Mobile","compiler":"Compilateurs JavaScript","build":"Outils de construction","testframework":"Frameworks de test","ide":"Editeurs de texte","ssg":"Générateurs de Site Statique","cssinjs":"Feuilles de style en JavaScript","graphql":"GraphQL","misc":"Divers","learning":"Learning Resource"},"categories-share":{"all":"le projet JavaScript","framework":"le framework JavaScript côté client","nodejsframework":"le framework Node.js","react":"le projet React","vue":"le project Vue.js","mobile":"le framework JavaScript pour mobiles","compiler":"le compilateur JavaScript","build":"l'outil de construction JavaScript","testframework":"le framework de test JavaScript","ide":"l'éditeur de texte","ssg":"le générateur de site statique JavaScript","cssinjs":"l'outil CSS-dans-JavaScript","graphql":"le projet GraphQL JavaScript","learning":"Learning Resource"},"social":{"text":"Retour sur les tendances de l'année 2017 sur la planète JavaScript"}}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

	module.exports = {"page":{"title":"JavaScript Rising Stars 2017","description":"Sebuah pandangan lengkap tentang dunia JavaScript di tahun 2017: tren seputar frameworks front-end dan node.js, tooling, IDE, Static site generators..."},"header":{"title":"JavaScript Rising Stars 2017"},"introduction":{"table_of_contents":"Daftar Isi","explanation":"Grafik berikut membandingkan jumlah bintang yang diterima di GitHub selama 12 terakhir. Kami menganalisa proyek-proyek dari {link}, sebuah daftar proyek-proyek terbaik di dunia web. Ingat bahwa anda bisa mengklik salah satu proyek untuk mendapatkan informasi lebih lengkap."},"conclusion":"Kesimpulan","categories":{"all":"Proyek Paling Populer Secara Keseluruhan","framework":"Front-end Frameworks","nodejsframework":"Node.js Frameworks","react":"React Ecosystem","vue":"Vue Ecosystem","mobile":"Mobile","compiler":"Compilers","build":"Build Tools","testframework":"Testing Frameworks","ide":"IDEs & Editors","ssg":"Static Sites","cssinjs":"CSS in JavaScript","graphql":"GraphQL"},"categories-share":{"all":"JavaScript project","framework":"front-end framework","nodejsframework":"Node project","react":"React library","vue":"Vue library","mobile":"mobile framework","compiler":"JavaScript compiler","build":"build tool","testframework":"JavaScript testing framework","ide":"IDE","ssg":"JavaScript static site generator","cssinjs":"CSS-in-JS library","graphql":"JavaScript GraphQL project"},"social":{"text":"Cari tahu proyek JavaScript paling populer tahun 2017"}}

/***/ }),
/* 447 */
/***/ (function(module, exports) {

	module.exports = {"page":{"title":"JavaScript ベスト・オブ・ザ・イヤー 2019","description":"2019年 JavaScript 白書: フロントエンド、Node.jsフレームワーク、ツールチェーン、IDE、静的サイトジェネレータなど、2019年のJavaScriptの動向を完全網羅"},"header":{"title":"JavaScript ベスト・オブ・ザ・イヤー 2019"},"introduction":{"table_of_contents":"目次","explanation":"以下のチャートは、2019年の一年間にGitHubで増加したスターの数を比較したものです。Webプラットフォームに関するベストプロジェクトを集めたリストである{link}からの分析となります。各プロジェクトをクリックすると、プロジェクトの詳細を閲覧することができます。"},"conclusion":"おわりに","categories":{"all":"総合ランキング","framework":"フロントエンドフレームワーク","nodejsframework":"Node.jsフレームワーク","react":"React エコシステム","vue":"Vue エコシステム","angular":"Angular エコシステム","mobile":"モバイル","compiler":"コンパイラ","build":"ビルドツール","testframework":"テスト","ide":"統合開発環境（IDE）","ssg":"静的サイトジェネレータ","cssinjs":"CSS in JavaScript","graphql":"GraphQL","misc":"その他","learning":"学習リソース"},"categories-share":{"all":"JavaScriptプロジェクト","framework":"フロントエンドフレームワーク","nodejsframework":"Node.jsフレームワーク","react":"React ライブラリ","vue":"Vue ライブラリ","angular":"Angular ライブラリ","mobile":"モバイルフレームワーク","compiler":"JavaScript コンパイラ","build":"ビルドツール","testframework":"JavaScript テスト","ide":"IDE","ssg":"JavaScript 静的サイトジェネレータ","cssinjs":"CSS in JavaScript","graphql":"JavaScript GraphQL","learning":"学習リソース"},"social":{"text":"2019年のJavaScript展望ををチェックしよう"}}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

	module.exports = {"page":{"title":"2019年 JavaScript 明星项目","description":"对2019年 JavaScript 领域，在前端框架、Node.js 框架、编译工具、构建工具、测试框架、IDE、静态网站生成器...等各方面进行完整的回顾"},"header":{"title":"2019年 JavaScript 明星项目"},"introduction":{"table_of_contents":"目录","explanation":"下列图表对比了各个项目在 Github 上于过去 12 个月新增的 star 数量。分析的数据来源为 {link} 网站 ，一个 WEB 领域优秀项目的精选网站。通过点击项目，可以查看更多信息。"},"conclusion":"总结","categories":{"all":"最受欢迎项目","framework":"前端框架","nodejsframework":"Node.js 框架","react":"React 生态圈","vue":"Vue 生态圈","angular":"Angular 生态圈","mobile":"移动开发","compiler":"编译工具","build":"构建工具","testframework":"测试框架","ide":"IDE 和编辑器","ssg":"静态网站生成器","cssinjs":"CSS in JavaScript","graphql":"GraphQL","misc":"杂项","learning":"学习资源"},"categories-share":{"all":"JavaScript 项目","framework":"前端框架","nodejsframework":"Node.js 框架","react":"React 生态圈","vue":"Vue 生态圈","angular":"Angular 生态圈","mobile":"移动开发","compiler":"编译工具","build":"构建工具","testframework":"JavaScript 测试框架","ide":"IDE","ssg":"静态网站","cssinjs":"CSS in JavaScript","graphql":"Javascript GraphQL 项目","learning":"学习资源"},"social":{"text":"2019年 JavaScript 领域回顾"}}

/***/ }),
/* 449 */
/***/ (function(module, exports) {

	module.exports = {"newsletter":{"title":"Get the latest JS rankings in your inbox every week","text":"Sign up for {link}'s newsletter, and you'll receive exclusive stats about the most popular JavaScript projects each week.","button":"Sign Up","placeholder":"Your email"},"view_project":{"twitter":{"text":"In {year}, {name} added {delta} stars, making it the #{ranking} most popular {category} on GitHub","action":"Tweet"},"months":"J F M A M J J A S O N D","created":"Created","homepage":"Homepage"}}

/***/ }),
/* 450 */
/***/ (function(module, exports) {

	module.exports = {"newsletter":{"title":"Recibe los últimos rankings de JavaScript en tu email cada semana","text":"Date de alta en la newsletter de {link} y recibirás estadísticas exclusivas sobre los proyectos más populares de JavaScript cada semana.","button":"Suscríbete","placeholder":"Tu email"},"view_project":{"twitter":{"text":"En {year}, {name} consiguió {delta} estrellas, llegando a alcanzar el puesto #{ranking} en {category} en GitHub","action":"Tweet"},"months":"E F M A M J J A S O N D","created":"Creado","homepage":"Home"}}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

	module.exports = {"newsletter":{"title":"Les chiffres de la semaine dans votre boite à lettres","text":"Abonnez-vous à la newsletter {link}, et vous recevrez toutes les semaines un récapitulatif des dernières tendances de l'univers JavaScript!","button":"S'abonner","placeholder":"Votre email"},"view_project":{"twitter":{"text":"En {year}, avec plus de {delta} étoiles gagnées sur GitHub, {name} a été {category} numéro {ranking}.","action":"Tweet"},"months":"J F M A M J J A S O N D","created":"Créé","homepage":"Site web"}}

/***/ }),
/* 452 */
/***/ (function(module, exports) {

	module.exports = {"newsletter":{"title":"Dapatkan rangking JS paling baru di inbox setiap minggu","text":"Daftar untuk newsletter {link} dan anda akan menerima statistik eksklusif tentang proyek JavaScript paling populer setiap minggunya.","button":"Daftar","placeholder":"Email Anda"},"view_project":{"twitter":{"text":"Tahun {year}, {name} menambahkan {delta} bintang, membuatnya berada di posisi #{ranking} paling populer pada kategori {category} di GitHub","action":"Tweet"},"months":"J F M A M J J A S O N D","created":"Created","homepage":"Homepage"}}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

	module.exports = {"newsletter":{"title":"最新のJSランキングを毎週配信します。","text":"{link} ニュースレターに登録すると、いまもっとも熱い JavaScript プロジェクトをウィークリーでお届けします。","button":"登録","placeholder":"あなたのメールアドレス"},"view_project":{"twitter":{"text":"{year}年、{name}はGitHubで{delta}スターを獲得し、{category}カテゴリで{ranking}位になりました。","action":"Tweet"},"months":"1月 2月 3月 4月 5月 6月 7月 8月 9月 10月 11月 12月","created":"作成日","homepage":"WEB サイト"}}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

	module.exports = {"newsletter":{"title":"订阅每周最新 JS 排名","text":"在下面订阅 {link} 周刊，就能每周收到最新最流行的 JavaScript 项目发展趋势独家报告","button":"订   阅","placeholder":"您的邮箱"},"view_project":{"twitter":{"text":"在 {year} 年, {name} 增加了 {delta} 个 star, 在 GitHub {category} 分类中排名第 {ranking}。","action":"Tweet"},"months":"1月 2月 3月 4月 5月 6月 7月 8月 9月 10月 11月 12月","created":"创建于","homepage":"项目主页"}}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    splice = arrayProto.splice;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    splice = arrayProto.splice;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */
	function set(object, path, value) {
	  return object == null ? object : baseSet(object, path, value);
	}
	
	module.exports = set;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 457 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = escapes
	
	var defaults = [
	  '\\',
	  '`',
	  '*',
	  '{',
	  '}',
	  '[',
	  ']',
	  '(',
	  ')',
	  '#',
	  '+',
	  '-',
	  '.',
	  '!',
	  '_',
	  '>'
	]
	
	var gfm = defaults.concat(['~', '|'])
	
	var commonmark = gfm.concat([
	  '\n',
	  '"',
	  '$',
	  '%',
	  '&',
	  "'",
	  ',',
	  '/',
	  ':',
	  ';',
	  '<',
	  '=',
	  '?',
	  '@',
	  '^'
	])
	
	escapes.default = defaults
	escapes.gfm = gfm
	escapes.commonmark = commonmark
	
	// Get markdown escapes.
	function escapes(options) {
	  var settings = options || {}
	
	  if (settings.commonmark) {
	    return commonmark
	  }
	
	  return settings.gfm ? gfm : defaults
	}


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	var visitWithParents = __webpack_require__(639);
	
	function addListMetadata() {
	  return function (ast) {
	    visitWithParents(ast, 'list', function (listNode, parents) {
	      var depth = 0, i, n;
	      for (i = 0, n = parents.length; i < n; i++) {
	        if (parents[i].type === 'list') depth += 1;
	      }
	      for (i = 0, n = listNode.children.length; i < n; i++) {
	        var child = listNode.children[i];
	        child.index = i;
	        child.ordered = listNode.ordered;
	      }
	      listNode.depth = depth;
	    });
	    return ast;
	  };
	}
	
	module.exports = addListMetadata;


/***/ }),
/* 459 */,
/* 460 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
	 * numeral.js
	 * version : 2.0.6
	 * author : Adam Draper
	 * license : MIT
	 * http://adamwdraper.github.com/Numeral-js/
	 */
	
	(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        module.exports = factory();
	    } else {
	        global.numeral = factory();
	    }
	}(this, function () {
	    /************************************
	        Variables
	    ************************************/
	
	    var numeral,
	        _,
	        VERSION = '2.0.6',
	        formats = {},
	        locales = {},
	        defaults = {
	            currentLocale: 'en',
	            zeroFormat: null,
	            nullFormat: null,
	            defaultFormat: '0,0',
	            scalePercentBy100: true
	        },
	        options = {
	            currentLocale: defaults.currentLocale,
	            zeroFormat: defaults.zeroFormat,
	            nullFormat: defaults.nullFormat,
	            defaultFormat: defaults.defaultFormat,
	            scalePercentBy100: defaults.scalePercentBy100
	        };
	
	
	    /************************************
	        Constructors
	    ************************************/
	
	    // Numeral prototype object
	    function Numeral(input, number) {
	        this._input = input;
	
	        this._value = number;
	    }
	
	    numeral = function(input) {
	        var value,
	            kind,
	            unformatFunction,
	            regexp;
	
	        if (numeral.isNumeral(input)) {
	            value = input.value();
	        } else if (input === 0 || typeof input === 'undefined') {
	            value = 0;
	        } else if (input === null || _.isNaN(input)) {
	            value = null;
	        } else if (typeof input === 'string') {
	            if (options.zeroFormat && input === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                for (kind in formats) {
	                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
	
	                    if (regexp && input.match(regexp)) {
	                        unformatFunction = formats[kind].unformat;
	
	                        break;
	                    }
	                }
	
	                unformatFunction = unformatFunction || numeral._.stringToNumber;
	
	                value = unformatFunction(input);
	            }
	        } else {
	            value = Number(input)|| null;
	        }
	
	        return new Numeral(input, value);
	    };
	
	    // version number
	    numeral.version = VERSION;
	
	    // compare numeral object
	    numeral.isNumeral = function(obj) {
	        return obj instanceof Numeral;
	    };
	
	    // helper functions
	    numeral._ = _ = {
	        // formats numbers separators, decimals places, signs, abbreviations
	        numberToFormat: function(value, format, roundingFunction) {
	            var locale = locales[numeral.options.currentLocale],
	                negP = false,
	                optDec = false,
	                leadingCount = 0,
	                abbr = '',
	                trillion = 1000000000000,
	                billion = 1000000000,
	                million = 1000000,
	                thousand = 1000,
	                decimal = '',
	                neg = false,
	                abbrForce, // force abbreviation
	                abs,
	                min,
	                max,
	                power,
	                int,
	                precision,
	                signed,
	                thousands,
	                output;
	
	            // make sure we never format a null value
	            value = value || 0;
	
	            abs = Math.abs(value);
	
	            // see if we should use parentheses for negative number or if we should prefix with a sign
	            // if both are present we default to parentheses
	            if (numeral._.includes(format, '(')) {
	                negP = true;
	                format = format.replace(/[\(|\)]/g, '');
	            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
	                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
	                format = format.replace(/[\+|\-]/g, '');
	            }
	
	            // see if abbreviation is wanted
	            if (numeral._.includes(format, 'a')) {
	                abbrForce = format.match(/a(k|m|b|t)?/);
	
	                abbrForce = abbrForce ? abbrForce[1] : false;
	
	                // check for space before abbreviation
	                if (numeral._.includes(format, ' a')) {
	                    abbr = ' ';
	                }
	
	                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');
	
	                if (abs >= trillion && !abbrForce || abbrForce === 't') {
	                    // trillion
	                    abbr += locale.abbreviations.trillion;
	                    value = value / trillion;
	                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
	                    // billion
	                    abbr += locale.abbreviations.billion;
	                    value = value / billion;
	                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
	                    // million
	                    abbr += locale.abbreviations.million;
	                    value = value / million;
	                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
	                    // thousand
	                    abbr += locale.abbreviations.thousand;
	                    value = value / thousand;
	                }
	            }
	
	            // check for optional decimals
	            if (numeral._.includes(format, '[.]')) {
	                optDec = true;
	                format = format.replace('[.]', '.');
	            }
	
	            // break number and format
	            int = value.toString().split('.')[0];
	            precision = format.split('.')[1];
	            thousands = format.indexOf(',');
	            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;
	
	            if (precision) {
	                if (numeral._.includes(precision, '[')) {
	                    precision = precision.replace(']', '');
	                    precision = precision.split('[');
	                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
	                } else {
	                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
	                }
	
	                int = decimal.split('.')[0];
	
	                if (numeral._.includes(decimal, '.')) {
	                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
	                } else {
	                    decimal = '';
	                }
	
	                if (optDec && Number(decimal.slice(1)) === 0) {
	                    decimal = '';
	                }
	            } else {
	                int = numeral._.toFixed(value, 0, roundingFunction);
	            }
	
	            // check abbreviation again after rounding
	            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
	                int = String(Number(int) / 1000);
	
	                switch (abbr) {
	                    case locale.abbreviations.thousand:
	                        abbr = locale.abbreviations.million;
	                        break;
	                    case locale.abbreviations.million:
	                        abbr = locale.abbreviations.billion;
	                        break;
	                    case locale.abbreviations.billion:
	                        abbr = locale.abbreviations.trillion;
	                        break;
	                }
	            }
	
	
	            // format number
	            if (numeral._.includes(int, '-')) {
	                int = int.slice(1);
	                neg = true;
	            }
	
	            if (int.length < leadingCount) {
	                for (var i = leadingCount - int.length; i > 0; i--) {
	                    int = '0' + int;
	                }
	            }
	
	            if (thousands > -1) {
	                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
	            }
	
	            if (format.indexOf('.') === 0) {
	                int = '';
	            }
	
	            output = int + decimal + (abbr ? abbr : '');
	
	            if (negP) {
	                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
	            } else {
	                if (signed >= 0) {
	                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
	                } else if (neg) {
	                    output = '-' + output;
	                }
	            }
	
	            return output;
	        },
	        // unformats numbers separators, decimals places, signs, abbreviations
	        stringToNumber: function(string) {
	            var locale = locales[options.currentLocale],
	                stringOriginal = string,
	                abbreviations = {
	                    thousand: 3,
	                    million: 6,
	                    billion: 9,
	                    trillion: 12
	                },
	                abbreviation,
	                value,
	                i,
	                regexp;
	
	            if (options.zeroFormat && string === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                value = 1;
	
	                if (locale.delimiters.decimal !== '.') {
	                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
	                }
	
	                for (abbreviation in abbreviations) {
	                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');
	
	                    if (stringOriginal.match(regexp)) {
	                        value *= Math.pow(10, abbreviations[abbreviation]);
	                        break;
	                    }
	                }
	
	                // check for negative number
	                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
	
	                // remove non numbers
	                string = string.replace(/[^0-9\.]+/g, '');
	
	                value *= Number(string);
	            }
	
	            return value;
	        },
	        isNaN: function(value) {
	            return typeof value === 'number' && isNaN(value);
	        },
	        includes: function(string, search) {
	            return string.indexOf(search) !== -1;
	        },
	        insert: function(string, subString, start) {
	            return string.slice(0, start) + subString + string.slice(start);
	        },
	        reduce: function(array, callback /*, initialValue*/) {
	            if (this === null) {
	                throw new TypeError('Array.prototype.reduce called on null or undefined');
	            }
	
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            var t = Object(array),
	                len = t.length >>> 0,
	                k = 0,
	                value;
	
	            if (arguments.length === 3) {
	                value = arguments[2];
	            } else {
	                while (k < len && !(k in t)) {
	                    k++;
	                }
	
	                if (k >= len) {
	                    throw new TypeError('Reduce of empty array with no initial value');
	                }
	
	                value = t[k++];
	            }
	            for (; k < len; k++) {
	                if (k in t) {
	                    value = callback(value, t[k], k, t);
	                }
	            }
	            return value;
	        },
	        /**
	         * Computes the multiplier necessary to make x >= 1,
	         * effectively eliminating miscalculations caused by
	         * finite precision.
	         */
	        multiplier: function (x) {
	            var parts = x.toString().split('.');
	
	            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
	        },
	        /**
	         * Given a variable number of arguments, returns the maximum
	         * multiplier that must be used to normalize an operation involving
	         * all of them.
	         */
	        correctionFactor: function () {
	            var args = Array.prototype.slice.call(arguments);
	
	            return args.reduce(function(accum, next) {
	                var mn = _.multiplier(next);
	                return accum > mn ? accum : mn;
	            }, 1);
	        },
	        /**
	         * Implementation of toFixed() that treats floats more like decimals
	         *
	         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	         * problems for accounting- and finance-related software.
	         */
	        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
	            var splitValue = value.toString().split('.'),
	                minDecimals = maxDecimals - (optionals || 0),
	                boundedPrecision,
	                optionalsRegExp,
	                power,
	                output;
	
	            // Use the smallest precision value possible to avoid errors from floating point representation
	            if (splitValue.length === 2) {
	              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
	            } else {
	              boundedPrecision = minDecimals;
	            }
	
	            power = Math.pow(10, boundedPrecision);
	
	            // Multiply up by precision, round accurately, then divide and use native toFixed():
	            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);
	
	            if (optionals > maxDecimals - boundedPrecision) {
	                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
	                output = output.replace(optionalsRegExp, '');
	            }
	
	            return output;
	        }
	    };
	
	    // avaliable options
	    numeral.options = options;
	
	    // avaliable formats
	    numeral.formats = formats;
	
	    // avaliable formats
	    numeral.locales = locales;
	
	    // This function sets the current locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    numeral.locale = function(key) {
	        if (key) {
	            options.currentLocale = key.toLowerCase();
	        }
	
	        return options.currentLocale;
	    };
	
	    // This function provides access to the loaded locale data.  If
	    // no arguments are passed in, it will simply return the current
	    // global locale object.
	    numeral.localeData = function(key) {
	        if (!key) {
	            return locales[options.currentLocale];
	        }
	
	        key = key.toLowerCase();
	
	        if (!locales[key]) {
	            throw new Error('Unknown locale : ' + key);
	        }
	
	        return locales[key];
	    };
	
	    numeral.reset = function() {
	        for (var property in defaults) {
	            options[property] = defaults[property];
	        }
	    };
	
	    numeral.zeroFormat = function(format) {
	        options.zeroFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.nullFormat = function (format) {
	        options.nullFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.defaultFormat = function(format) {
	        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
	    };
	
	    numeral.register = function(type, name, format) {
	        name = name.toLowerCase();
	
	        if (this[type + 's'][name]) {
	            throw new TypeError(name + ' ' + type + ' already registered.');
	        }
	
	        this[type + 's'][name] = format;
	
	        return format;
	    };
	
	
	    numeral.validate = function(val, culture) {
	        var _decimalSep,
	            _thousandSep,
	            _currSymbol,
	            _valArray,
	            _abbrObj,
	            _thousandRegEx,
	            localeData,
	            temp;
	
	        //coerce val to string
	        if (typeof val !== 'string') {
	            val += '';
	
	            if (console.warn) {
	                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
	            }
	        }
	
	        //trim whitespaces from either sides
	        val = val.trim();
	
	        //if val is just digits return true
	        if (!!val.match(/^\d+$/)) {
	            return true;
	        }
	
	        //if val is empty return false
	        if (val === '') {
	            return false;
	        }
	
	        //get the decimal and thousands separator from numeral.localeData
	        try {
	            //check if the culture is understood by numeral. if not, default it to current locale
	            localeData = numeral.localeData(culture);
	        } catch (e) {
	            localeData = numeral.localeData(numeral.locale());
	        }
	
	        //setup the delimiters and currency symbol based on culture/locale
	        _currSymbol = localeData.currency.symbol;
	        _abbrObj = localeData.abbreviations;
	        _decimalSep = localeData.delimiters.decimal;
	        if (localeData.delimiters.thousands === '.') {
	            _thousandSep = '\\.';
	        } else {
	            _thousandSep = localeData.delimiters.thousands;
	        }
	
	        // validating currency symbol
	        temp = val.match(/^[^\d]+/);
	        if (temp !== null) {
	            val = val.substr(1);
	            if (temp[0] !== _currSymbol) {
	                return false;
	            }
	        }
	
	        //validating abbreviation symbol
	        temp = val.match(/[^\d]+$/);
	        if (temp !== null) {
	            val = val.slice(0, -1);
	            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
	                return false;
	            }
	        }
	
	        _thousandRegEx = new RegExp(_thousandSep + '{2}');
	
	        if (!val.match(/[^\d.,]/g)) {
	            _valArray = val.split(_decimalSep);
	            if (_valArray.length > 2) {
	                return false;
	            } else {
	                if (_valArray.length < 2) {
	                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
	                } else {
	                    if (_valArray[0].length === 1) {
	                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    } else {
	                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    }
	                }
	            }
	        }
	
	        return false;
	    };
	
	
	    /************************************
	        Numeral Prototype
	    ************************************/
	
	    numeral.fn = Numeral.prototype = {
	        clone: function() {
	            return numeral(this);
	        },
	        format: function(inputString, roundingFunction) {
	            var value = this._value,
	                format = inputString || options.defaultFormat,
	                kind,
	                output,
	                formatFunction;
	
	            // make sure we have a roundingFunction
	            roundingFunction = roundingFunction || Math.round;
	
	            // format based on value
	            if (value === 0 && options.zeroFormat !== null) {
	                output = options.zeroFormat;
	            } else if (value === null && options.nullFormat !== null) {
	                output = options.nullFormat;
	            } else {
	                for (kind in formats) {
	                    if (format.match(formats[kind].regexps.format)) {
	                        formatFunction = formats[kind].format;
	
	                        break;
	                    }
	                }
	
	                formatFunction = formatFunction || numeral._.numberToFormat;
	
	                output = formatFunction(value, format, roundingFunction);
	            }
	
	            return output;
	        },
	        value: function() {
	            return this._value;
	        },
	        input: function() {
	            return this._input;
	        },
	        set: function(value) {
	            this._value = Number(value);
	
	            return this;
	        },
	        add: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum + Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;
	
	            return this;
	        },
	        subtract: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum - Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;
	
	            return this;
	        },
	        multiply: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 1);
	
	            return this;
	        },
	        divide: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback);
	
	            return this;
	        },
	        difference: function(value) {
	            return Math.abs(numeral(this._value).subtract(value).value());
	        }
	    };
	
	    /************************************
	        Default Locale && Format
	    ************************************/
	
	    numeral.register('locale', 'en', {
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function(number) {
	            var b = number % 10;
	            return (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$'
	        }
	    });
	
	    
	
	(function() {
	        numeral.register('format', 'bps', {
	            regexps: {
	                format: /(BPS)/,
	                unformat: /(BPS)/
	            },
	            format: function(value, format, roundingFunction) {
	                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
	                    output;
	
	                value = value * 10000;
	
	                // check for space before BPS
	                format = format.replace(/\s?BPS/, '');
	
	                output = numeral._.numberToFormat(value, format, roundingFunction);
	
	                if (numeral._.includes(output, ')')) {
	                    output = output.split('');
	
	                    output.splice(-1, 0, space + 'BPS');
	
	                    output = output.join('');
	                } else {
	                    output = output + space + 'BPS';
	                }
	
	                return output;
	            },
	            unformat: function(string) {
	                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
	            }
	        });
	})();
	
	
	(function() {
	        var decimal = {
	            base: 1000,
	            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
	        },
	        binary = {
	            base: 1024,
	            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
	        };
	
	    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
	            return decimal.suffixes.indexOf(item) < 0;
	        }));
	        var unformatRegex = allSuffixes.join('|');
	        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
	        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';
	
	    numeral.register('format', 'bytes', {
	        regexps: {
	            format: /([0\s]i?b)/,
	            unformat: new RegExp(unformatRegex)
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
	                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
	                power,
	                min,
	                max;
	
	            // check for space before
	            format = format.replace(/\s?i?b/, '');
	
	            for (power = 0; power <= bytes.suffixes.length; power++) {
	                min = Math.pow(bytes.base, power);
	                max = Math.pow(bytes.base, power + 1);
	
	                if (value === null || value === 0 || value >= min && value < max) {
	                    suffix += bytes.suffixes[power];
	
	                    if (min > 0) {
	                        value = value / min;
	                    }
	
	                    break;
	                }
	            }
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + suffix;
	        },
	        unformat: function(string) {
	            var value = numeral._.stringToNumber(string),
	                power,
	                bytesMultiplier;
	
	            if (value) {
	                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
	                    if (numeral._.includes(string, decimal.suffixes[power])) {
	                        bytesMultiplier = Math.pow(decimal.base, power);
	
	                        break;
	                    }
	
	                    if (numeral._.includes(string, binary.suffixes[power])) {
	                        bytesMultiplier = Math.pow(binary.base, power);
	
	                        break;
	                    }
	                }
	
	                value *= (bytesMultiplier || 1);
	            }
	
	            return value;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'currency', {
	        regexps: {
	            format: /(\$)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                symbols = {
	                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
	                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
	                },
	                output,
	                symbol,
	                i;
	
	            // strip format of spaces and $
	            format = format.replace(/\s?\$\s?/, '');
	
	            // format the number
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            // update the before and after based on value
	            if (value >= 0) {
	                symbols.before = symbols.before.replace(/[\-\(]/, '');
	                symbols.after = symbols.after.replace(/[\-\)]/, '');
	            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
	                symbols.before = '-' + symbols.before;
	            }
	
	            // loop through each before symbol
	            for (i = 0; i < symbols.before.length; i++) {
	                symbol = symbols.before[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = numeral._.insert(output, locale.currency.symbol, i);
	                        break;
	                    case ' ':
	                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
	                        break;
	                }
	            }
	
	            // loop through each after symbol
	            for (i = symbols.after.length - 1; i >= 0; i--) {
	                symbol = symbols.after[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
	                        break;
	                    case ' ':
	                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
	                        break;
	                }
	            }
	
	
	            return output;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'exponential', {
	        regexps: {
	            format: /(e\+|e-)/,
	            unformat: /(e\+|e-)/
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
	                parts = exponential.split('e');
	
	            format = format.replace(/e[\+|\-]{1}0/, '');
	
	            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
	
	            return output + 'e' + parts[1];
	        },
	        unformat: function(string) {
	            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
	                value = Number(parts[0]),
	                power = Number(parts[1]);
	
	            power = numeral._.includes(string, 'e-') ? power *= -1 : power;
	
	            function cback(accum, curr, currI, O) {
	                var corrFactor = numeral._.correctionFactor(accum, curr),
	                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
	                return num;
	            }
	
	            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'ordinal', {
	        regexps: {
	            format: /(o)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                output,
	                ordinal = numeral._.includes(format, ' o') ? ' ' : '';
	
	            // check for space before
	            format = format.replace(/\s?o/, '');
	
	            ordinal += locale.ordinal(value);
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + ordinal;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'percentage', {
	        regexps: {
	            format: /(%)/,
	            unformat: /(%)/
	        },
	        format: function(value, format, roundingFunction) {
	            var space = numeral._.includes(format, ' %') ? ' ' : '',
	                output;
	
	            if (numeral.options.scalePercentBy100) {
	                value = value * 100;
	            }
	
	            // check for space before %
	            format = format.replace(/\s?\%/, '');
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            if (numeral._.includes(output, ')')) {
	                output = output.split('');
	
	                output.splice(-1, 0, space + '%');
	
	                output = output.join('');
	            } else {
	                output = output + space + '%';
	            }
	
	            return output;
	        },
	        unformat: function(string) {
	            var number = numeral._.stringToNumber(string);
	            if (numeral.options.scalePercentBy100) {
	                return number * 0.01;
	            }
	            return number;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'time', {
	        regexps: {
	            format: /(:)/,
	            unformat: /(:)/
	        },
	        format: function(value, format, roundingFunction) {
	            var hours = Math.floor(value / 60 / 60),
	                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
	                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));
	
	            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
	        },
	        unformat: function(string) {
	            var timeArray = string.split(':'),
	                seconds = 0;
	
	            // turn hours and minutes into seconds and add them all up
	            if (timeArray.length === 3) {
	                // hours
	                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
	                // minutes
	                seconds = seconds + (Number(timeArray[1]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[2]);
	            } else if (timeArray.length === 2) {
	                // minutes
	                seconds = seconds + (Number(timeArray[0]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[1]);
	            }
	            return Number(seconds);
	        }
	    });
	})();
	
	return numeral;
	}));


/***/ }),
/* 462 */
/***/ (function(module, exports) {

	'use strict'
	
	/* eslint-env browser */
	
	var el
	
	var semicolon = 59 //  ';'
	
	module.exports = decodeEntity
	
	function decodeEntity(characters) {
	  var entity = '&' + characters + ';'
	  var char
	
	  el = el || document.createElement('i')
	  el.innerHTML = entity
	  char = el.textContent
	
	  // Some entities do not require the closing semicolon (`&not` - for instance),
	  // which leads to situations where parsing the assumed entity of &notit; will
	  // result in the string `¬it;`.  When we encounter a trailing semicolon after
	  // parsing and the entity to decode was not a semicolon (`&semi;`), we can
	  // assume that the matching was incomplete
	  if (char.charCodeAt(char.length - 1) === semicolon && characters !== 'semi') {
	    return false
	  }
	
	  // If the decoded string is equal to the input, the entity was not valid
	  return char === entity ? false : char
	}


/***/ }),
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */
/***/ (function(module, exports) {

	'use strict';
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	var hasElementType = typeof Element !== 'undefined';
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a)
	      , arrB = isArray(b)
	      , i
	      , length
	      , key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	
	    var dateA = a instanceof Date
	      , dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	
	    var regexpA = a instanceof RegExp
	      , regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length)
	      return false;
	
	    for (i = length; i-- !== 0;)
	      if (!hasProp.call(b, keys[i])) return false;
	    // end fast-deep-equal
	
	    // start react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element && b instanceof Element)
	      return a === b;
	
	    // custom handling for React
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    }
	    // end react-fast-compare
	
	    // fast-deep-equal index.js 2.0.1
	    return true;
	  }
	
	  return a !== a && b !== b;
	}
	// end fast-deep-equal
	
	module.exports = function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(563);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _reactFastCompare = __webpack_require__(529);
	
	var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);
	
	var _HelmetUtils = __webpack_require__(531);
	
	var _HelmetConstants = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _reactFastCompare2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Object} bodyAttributes: {"className": "root"}
	             * @param {String} defaultTitle: "Default Title"
	             * @param {Boolean} defer: true
	             * @param {Boolean} encodeSpecialCharacters: true
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	             * @param {String} title: "Title"
	             * @param {Object} titleAttributes: {"itemprop": "name"}
	             * @param {String} titleTemplate: "MySite.com - %s"
	             */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var t=String(e).split("."),o=!t[1],n=Number(t[0])==e,r=n&&t[0].slice(-1),i=n&&t[0].slice(-2);return a?1==r&&11!=i?"one":2==r&&12!=i?"two":3==r&&13!=i?"few":"other":1==e&&o?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yr."},past:{one:"{0} yr. ago",other:"{0} yr. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hr."},past:{one:"{0} hr. ago",other:"{0} hr. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} min."},past:{one:"{0} min. ago",other:"{0} min. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} sec."},past:{one:"{0} sec. ago",other:"{0} sec. ago"}}}}},{locale:"en-001",parentLocale:"en",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo",other:"in {0} mo"},past:{one:"{0} mo ago",other:"{0} mo ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yrs"},past:{one:"{0} yr ago",other:"{0} yrs ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"h",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hrs"},past:{one:"{0} hr ago",other:"{0} hrs ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins"},past:{one:"{0} min. ago",other:"{0} mins ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs"},past:{one:"{0} sec. ago",other:"{0} secs ago"}}}}},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yrs."},past:{one:"{0} yr. ago",other:"{0} yrs. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mos."},past:{one:"{0} mo. ago",other:"{0} mos. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hrs."},past:{one:"{0} hr. ago",other:"{0} hrs. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins."},past:{one:"{0} min. ago",other:"{0} mins. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs."},past:{one:"{0} sec. ago",other:"{0} secs. ago"}}}}},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr",1:"next yr","-1":"last yr"},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mth",relative:{0:"this mth",1:"next mth","-1":"last mth"},relativeTime:{future:{one:"in {0} mth",other:"in {0} mth"},past:{one:"{0} mth ago",other:"{0} mth ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.es=a())}(this,function(){"use strict";return[{locale:"es",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-419",parentLocale:"es"},{locale:"es-AR",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} días",other:"dentro de {0} días"},past:{one:"hace {0} días",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"seg.",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} seg.",other:"dentro de {0} seg."},past:{one:"hace {0} seg.",other:"hace {0} seg."}}}}},{locale:"es-BO",parentLocale:"es-419"},{locale:"es-BR",parentLocale:"es-419"},{locale:"es-BZ",parentLocale:"es-419"},{locale:"es-CL",parentLocale:"es-419"},{locale:"es-CO",parentLocale:"es-419"},{locale:"es-CR",parentLocale:"es-419"},{locale:"es-CU",parentLocale:"es-419"},{locale:"es-DO",parentLocale:"es-419",fields:{year:{displayName:"Año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"Mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"Día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"Minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"Segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-EA",parentLocale:"es"},{locale:"es-EC",parentLocale:"es-419"},{locale:"es-GQ",parentLocale:"es"},{locale:"es-GT",parentLocale:"es-419"},{locale:"es-HN",parentLocale:"es-419"},{locale:"es-IC",parentLocale:"es"},{locale:"es-MX",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"en {0} a",other:"en {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} mes",other:"en {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} m",other:"en {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"en {0} día",other:"en {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"en {0} h",other:"en {0} n"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"en {0} min",other:"en {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"en {0} s",other:"en {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-NI",parentLocale:"es-419"},{locale:"es-PA",parentLocale:"es-419"},{locale:"es-PE",parentLocale:"es-419"},{locale:"es-PH",parentLocale:"es"},{locale:"es-PR",parentLocale:"es-419"},{locale:"es-PY",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"seg.",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} seg.",other:"dentro de {0} seg."},past:{one:"hace {0} seg.",other:"hace {0} seg."}}}}},{locale:"es-SV",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-US",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-UY",parentLocale:"es-419"},{locale:"es-VE",parentLocale:"es-419"}]});


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.fr=a())}(this,function(){"use strict";return[{locale:"fr",pluralRuleFunction:function(e,a){return a?1==e?"one":"other":e>=0&&e<2?"one":"other"},fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},"year-short":{displayName:"an",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"j",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"h",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-BE",parentLocale:"fr"},{locale:"fr-BF",parentLocale:"fr"},{locale:"fr-BI",parentLocale:"fr"},{locale:"fr-BJ",parentLocale:"fr"},{locale:"fr-BL",parentLocale:"fr"},{locale:"fr-CA",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"Dans {0} an",other:"Dans {0} ans"},past:{one:"Il y a {0} an",other:"Il y a {0} ans"}}},"year-short":{displayName:"a",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"j",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"h",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-CD",parentLocale:"fr"},{locale:"fr-CF",parentLocale:"fr"},{locale:"fr-CG",parentLocale:"fr"},{locale:"fr-CH",parentLocale:"fr"},{locale:"fr-CI",parentLocale:"fr"},{locale:"fr-CM",parentLocale:"fr"},{locale:"fr-DJ",parentLocale:"fr"},{locale:"fr-DZ",parentLocale:"fr"},{locale:"fr-GA",parentLocale:"fr"},{locale:"fr-GF",parentLocale:"fr"},{locale:"fr-GN",parentLocale:"fr"},{locale:"fr-GP",parentLocale:"fr"},{locale:"fr-GQ",parentLocale:"fr"},{locale:"fr-HT",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},"year-short":{displayName:"an",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"jr.",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"hr",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min.",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-KM",parentLocale:"fr"},{locale:"fr-LU",parentLocale:"fr"},{locale:"fr-MA",parentLocale:"fr"},{locale:"fr-MC",parentLocale:"fr"},{locale:"fr-MF",parentLocale:"fr"},{locale:"fr-MG",parentLocale:"fr"},{locale:"fr-ML",parentLocale:"fr"},{locale:"fr-MQ",parentLocale:"fr"},{locale:"fr-MR",parentLocale:"fr"},{locale:"fr-MU",parentLocale:"fr"},{locale:"fr-NC",parentLocale:"fr"},{locale:"fr-NE",parentLocale:"fr"},{locale:"fr-PF",parentLocale:"fr"},{locale:"fr-PM",parentLocale:"fr"},{locale:"fr-RE",parentLocale:"fr"},{locale:"fr-RW",parentLocale:"fr"},{locale:"fr-SC",parentLocale:"fr"},{locale:"fr-SN",parentLocale:"fr"},{locale:"fr-SY",parentLocale:"fr"},{locale:"fr-TD",parentLocale:"fr"},{locale:"fr-TG",parentLocale:"fr"},{locale:"fr-TN",parentLocale:"fr"},{locale:"fr-VU",parentLocale:"fr"},{locale:"fr-WF",parentLocale:"fr"},{locale:"fr-YT",parentLocale:"fr"}]});


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.id=a())}(this,function(){"use strict";return[{locale:"id",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"tahun",relative:{0:"tahun ini",1:"tahun depan","-1":"tahun lalu"},relativeTime:{future:{other:"dalam {0} tahun"},past:{other:"{0} tahun yang lalu"}}},"year-short":{displayName:"thn.",relative:{0:"tahun ini",1:"tahun depan","-1":"tahun lalu"},relativeTime:{future:{other:"dlm {0} thn"},past:{other:"{0} thn lalu"}}},month:{displayName:"bulan",relative:{0:"bulan ini",1:"bulan berikutnya","-1":"bulan lalu"},relativeTime:{future:{other:"dalam {0} bulan"},past:{other:"{0} bulan yang lalu"}}},"month-short":{displayName:"bln.",relative:{0:"bulan ini",1:"bulan berikutnya","-1":"bulan lalu"},relativeTime:{future:{other:"dlm {0} bln"},past:{other:"{0} bln lalu"}}},day:{displayName:"hari",relative:{0:"hari ini",1:"besok",2:"lusa","-2":"kemarin dulu","-1":"kemarin"},relativeTime:{future:{other:"dalam {0} hari"},past:{other:"{0} hari yang lalu"}}},"day-short":{displayName:"h",relative:{0:"hari ini",1:"besok",2:"lusa","-2":"kemarin dulu","-1":"kemarin"},relativeTime:{future:{other:"dalam {0} h"},past:{other:"{0} h lalu"}}},hour:{displayName:"Jam",relative:{0:"jam ini"},relativeTime:{future:{other:"dalam {0} jam"},past:{other:"{0} jam yang lalu"}}},"hour-short":{displayName:"jam",relative:{0:"jam ini"},relativeTime:{future:{other:"dalam {0} jam"},past:{other:"{0} jam lalu"}}},minute:{displayName:"menit",relative:{0:"menit ini"},relativeTime:{future:{other:"dalam {0} menit"},past:{other:"{0} menit yang lalu"}}},"minute-short":{displayName:"mnt.",relative:{0:"menit ini"},relativeTime:{future:{other:"dlm {0} mnt"},past:{other:"{0} mnt lalu"}}},second:{displayName:"detik",relative:{0:"sekarang"},relativeTime:{future:{other:"dalam {0} detik"},past:{other:"{0} detik yang lalu"}}},"second-short":{displayName:"dtk.",relative:{0:"sekarang"},relativeTime:{future:{other:"dlm {0} dtk"},past:{other:"{0} dtk lalu"}}}}}]});


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ja=t())}(this,function(){"use strict";return[{locale:"ja",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"翌年","-1":"昨年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"翌年","-1":"昨年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"今月",1:"翌月","-1":"先月"},relativeTime:{future:{other:"{0} か月後"},past:{other:"{0} か月前"}}},"month-short":{displayName:"月",relative:{0:"今月",1:"翌月","-1":"先月"},relativeTime:{future:{other:"{0} か月後"},past:{other:"{0} か月前"}}},day:{displayName:"日",relative:{0:"今日",1:"明日",2:"明後日","-2":"一昨日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},"day-short":{displayName:"日",relative:{0:"今日",1:"明日",2:"明後日","-2":"一昨日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},hour:{displayName:"時",relative:{0:"1 時間以内"},relativeTime:{future:{other:"{0} 時間後"},past:{other:"{0} 時間前"}}},"hour-short":{displayName:"時",relative:{0:"1 時間以内"},relativeTime:{future:{other:"{0} 時間後"},past:{other:"{0} 時間前"}}},minute:{displayName:"分",relative:{0:"1 分以内"},relativeTime:{future:{other:"{0} 分後"},past:{other:"{0} 分前"}}},"minute-short":{displayName:"分",relative:{0:"1 分以内"},relativeTime:{future:{other:"{0} 分後"},past:{other:"{0} 分前"}}},second:{displayName:"秒",relative:{0:"今"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}},"second-short":{displayName:"秒",relative:{0:"今"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}}]});


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.zh=t())}(this,function(){"use strict";return[{locale:"zh",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒钟后"},past:{other:"{0}秒钟前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans",parentLocale:"zh"},{locale:"zh-Hans-HK",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-MO",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-SG",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hant",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"後天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0} 天後"},past:{other:"{0} 天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"後天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0} 天後"},past:{other:"{0} 天前"}}},hour:{displayName:"小時",relative:{0:"這一小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},"hour-short":{displayName:"小時",relative:{0:"這一小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relative:{0:"這一分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},"minute-short":{displayName:"分鐘",relative:{0:"這一分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}},"second-short":{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-HK",parentLocale:"zh-Hant",fields:{year:{displayName:"年",relative:{0:"今年",1:"下年","-1":"上年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"下年","-1":"上年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今日",1:"明日",2:"後日","-2":"前日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},"day-short":{displayName:"日",relative:{0:"今日",1:"明日",2:"後日","-2":"前日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},hour:{displayName:"小時",relative:{0:"這個小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},"hour-short":{displayName:"小時",relative:{0:"這個小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relative:{0:"這分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},"minute-short":{displayName:"分鐘",relative:{0:"這分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}},"second-short":{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-MO",parentLocale:"zh-Hant-HK"}]});


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var xtend = __webpack_require__(20);
	
	function astToReact(node, options) {
	  var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	  var renderer = options.renderers[node.type];
	
	  var pos = node.position.start;
	  var key = [node.type, pos.line, pos.column].join('-');
	
	  if (node.type === 'text') {
	    return renderer ? renderer(node.value, key) : node.value;
	  }
	
	  if (typeof renderer !== 'function' && typeof renderer !== 'string' && !isReactFragment(renderer)) {
	    throw new Error('Renderer for type `' + node.type + '` not defined or is not renderable');
	  }
	
	  var nodeProps = getNodeProps(node, key, options, renderer, parent, index);
	
	  return React.createElement(renderer, nodeProps, nodeProps.children || resolveChildren() || undefined);
	
	  function resolveChildren() {
	    return node.children && node.children.map(function (childNode, i) {
	      return astToReact(childNode, options, { node: node, props: nodeProps }, i);
	    });
	  }
	}
	
	function isReactFragment(renderer) {
	  return React.Fragment && React.Fragment === renderer;
	}
	
	// eslint-disable-next-line max-params, complexity
	function getNodeProps(node, key, opts, renderer, parent, index) {
	  var props = { key: key };
	
	  var isTagRenderer = typeof renderer === 'string';
	
	  // `sourcePos` is true if the user wants source information (line/column info from markdown source)
	  if (opts.sourcePos && node.position) {
	    props['data-sourcepos'] = flattenPosition(node.position);
	  }
	
	  if (opts.rawSourcePos && !isTagRenderer) {
	    props.sourcePosition = node.position;
	  }
	
	  // If `includeNodeIndex` is true, pass node index info to all non-tag renderers
	  if (opts.includeNodeIndex && parent.node && parent.node.children && !isTagRenderer) {
	    props.index = parent.node.children.indexOf(node);
	    props.parentChildCount = parent.node.children.length;
	  }
	
	  var ref = node.identifier !== null && node.identifier !== undefined ? opts.definitions[node.identifier] || {} : null;
	
	  switch (node.type) {
	    case 'root':
	      assignDefined(props, { className: opts.className });
	      break;
	    case 'heading':
	      props.level = node.depth;
	      break;
	    case 'list':
	      props.start = node.start;
	      props.ordered = node.ordered;
	      props.tight = !node.loose;
	      props.depth = node.depth;
	      break;
	    case 'listItem':
	      props.checked = node.checked;
	      props.tight = !node.loose;
	      props.ordered = node.ordered;
	      props.index = node.index;
	      props.children = (props.tight ? unwrapParagraphs(node) : node.children).map(function (childNode, i) {
	        return astToReact(childNode, opts, { node: node, props: props }, i);
	      });
	      break;
	    case 'definition':
	      assignDefined(props, { identifier: node.identifier, title: node.title, url: node.url });
	      break;
	    case 'code':
	      assignDefined(props, { language: node.lang && node.lang.split(/\s/, 1)[0] });
	      break;
	    case 'inlineCode':
	      props.children = node.value;
	      props.inline = true;
	      break;
	    case 'link':
	      assignDefined(props, {
	        title: node.title || undefined,
	        target: typeof opts.linkTarget === 'function' ? opts.linkTarget(node.url, node.children, node.title) : opts.linkTarget,
	        href: opts.transformLinkUri ? opts.transformLinkUri(node.url, node.children, node.title) : node.url
	      });
	      break;
	    case 'image':
	      assignDefined(props, {
	        alt: node.alt || undefined,
	        title: node.title || undefined,
	        src: opts.transformImageUri ? opts.transformImageUri(node.url, node.children, node.title, node.alt) : node.url
	      });
	      break;
	    case 'linkReference':
	      assignDefined(props, xtend(ref, {
	        href: opts.transformLinkUri ? opts.transformLinkUri(ref.href) : ref.href
	      }));
	      break;
	    case 'imageReference':
	      assignDefined(props, {
	        src: opts.transformImageUri && ref.href ? opts.transformImageUri(ref.href, node.children, ref.title, node.alt) : ref.href,
	        title: ref.title || undefined,
	        alt: node.alt || undefined
	      });
	      break;
	    case 'table':
	    case 'tableHead':
	    case 'tableBody':
	      props.columnAlignment = node.align;
	      break;
	    case 'tableRow':
	      props.isHeader = parent.node.type === 'tableHead';
	      props.columnAlignment = parent.props.columnAlignment;
	      break;
	    case 'tableCell':
	      assignDefined(props, {
	        isHeader: parent.props.isHeader,
	        align: parent.props.columnAlignment[index]
	      });
	      break;
	    case 'virtualHtml':
	      props.tag = node.tag;
	      break;
	    case 'html':
	      // @todo find a better way than this
	      props.isBlock = node.position.start.line !== node.position.end.line;
	      props.escapeHtml = opts.escapeHtml;
	      props.skipHtml = opts.skipHtml;
	      break;
	    default:
	      assignDefined(props, xtend(node, {
	        type: undefined,
	        position: undefined,
	        children: undefined
	      }));
	  }
	
	  if (!isTagRenderer && node.value) {
	    props.value = node.value;
	  }
	
	  return props;
	}
	
	function assignDefined(target, attrs) {
	  for (var key in attrs) {
	    if (typeof attrs[key] !== 'undefined') {
	      target[key] = attrs[key];
	    }
	  }
	}
	
	function flattenPosition(pos) {
	  return [pos.start.line, ':', pos.start.column, '-', pos.end.line, ':', pos.end.column].map(String).join('');
	}
	
	function unwrapParagraphs(node) {
	  return node.children.reduce(function (array, child) {
	    return array.concat(child.type === 'paragraph' ? child.children || [] : [child]);
	  }, []);
	}
	
	module.exports = astToReact;

/***/ }),
/* 539 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function getDefinitions(node) {
	  var defs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return (node.children || []).reduce(function (definitions, child) {
	    if (child.type === 'definition') {
	      definitions[child.identifier] = {
	        href: child.url,
	        title: child.title
	      };
	    }
	
	    return getDefinitions(child, definitions);
	  }, defs);
	};

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var visit = __webpack_require__(76);
	
	exports.ofType = function (types, mode) {
	  return function (node) {
	    types.forEach(function (type) {
	      return visit(node, type, disallow, true);
	    });
	    return node;
	  };
	
	  function disallow(node, index, parent) {
	    if (parent) {
	      untangle(node, index, parent, mode);
	    }
	  }
	};
	
	exports.ifNotMatch = function (allowNode, mode) {
	  return function (node) {
	    visit(node, disallow, true);
	    return node;
	  };
	
	  function disallow(node, index, parent) {
	    if (parent && !allowNode(node, index, parent)) {
	      untangle(node, index, parent, mode);
	    }
	  }
	};
	
	function untangle(node, index, parent, mode) {
	  if (mode === 'remove') {
	    parent.children.splice(index, 1);
	  } else if (mode === 'unwrap') {
	    var args = [index, 1];
	
	    if (node.children) {
	      args = args.concat(node.children);
	    }
	
	    Array.prototype.splice.apply(parent.children, args);
	  }
	}

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Naive, simple plugin to match inline nodes without attributes
	 * This allows say <strong>foo</strong>, but not <strong class="very">foo</strong>
	 * For proper HTML support, you'll want a different plugin
	 **/
	var visit = __webpack_require__(76);
	
	var type = 'virtualHtml';
	var selfClosingRe = /^<(area|base|br|col|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)\s*\/?>$/i;
	var simpleTagRe = /^<(\/?)([a-z]+)\s*>$/;
	
	module.exports = function (tree) {
	  var open = void 0;
	  var currentParent = void 0;
	  visit(tree, 'html', function (node, index, parent) {
	    if (currentParent !== parent) {
	      open = [];
	      currentParent = parent;
	    }
	
	    var selfClosing = getSelfClosing(node);
	    if (selfClosing) {
	      parent.children.splice(index, 1, {
	        type: type,
	        tag: selfClosing,
	        position: node.position
	      });
	      return true;
	    }
	
	    var current = getSimpleTag(node, parent);
	    if (!current) {
	      return true;
	    }
	
	    var matching = findAndPull(open, current.tag);
	
	    if (matching) {
	      parent.children.splice(index, 0, virtual(current, matching, parent));
	    } else if (!current.opening) {
	      open.push(current);
	    }
	
	    return true;
	  }, true // Iterate in reverse
	  );
	
	  return tree;
	};
	
	function findAndPull(open, matchingTag) {
	  var i = open.length;
	  while (i--) {
	    if (open[i].tag === matchingTag) {
	      return open.splice(i, 1)[0];
	    }
	  }
	
	  return false;
	}
	
	function getSimpleTag(node, parent) {
	  var match = node.value.match(simpleTagRe);
	  return match ? { tag: match[2], opening: !match[1], node: node } : false;
	}
	
	function getSelfClosing(node) {
	  var match = node.value.match(selfClosingRe);
	  return match ? match[1] : false;
	}
	
	function virtual(fromNode, toNode, parent) {
	  var fromIndex = parent.children.indexOf(fromNode.node);
	  var toIndex = parent.children.indexOf(toNode.node);
	
	  var extracted = parent.children.splice(fromIndex, toIndex - fromIndex + 1);
	  var children = extracted.slice(1, -1);
	  return {
	    type: type,
	    children: children,
	    tag: fromNode.tag,
	    position: {
	      start: fromNode.node.position.start,
	      end: toNode.node.position.end,
	      indent: []
	    }
	  };
	}

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var xtend = __webpack_require__(20);
	var unified = __webpack_require__(635);
	var parse = __webpack_require__(582);
	var PropTypes = __webpack_require__(7);
	var addListMetadata = __webpack_require__(458);
	var naiveHtml = __webpack_require__(541);
	var disallowNode = __webpack_require__(540);
	var astToReact = __webpack_require__(538);
	var wrapTableRows = __webpack_require__(545);
	var getDefinitions = __webpack_require__(539);
	var uriTransformer = __webpack_require__(544);
	var defaultRenderers = __webpack_require__(543);
	
	var allTypes = Object.keys(defaultRenderers);
	
	var ReactMarkdown = function ReactMarkdown(props) {
	  var src = props.source || props.children || '';
	
	  if (props.allowedTypes && props.disallowedTypes) {
	    throw new Error('Only one of `allowedTypes` and `disallowedTypes` should be defined');
	  }
	
	  var renderers = xtend(defaultRenderers, props.renderers);
	
	  var plugins = [parse].concat(props.plugins || []);
	  var parser = plugins.reduce(applyParserPlugin, unified());
	
	  var rawAst = parser.parse(src);
	  var renderProps = xtend(props, {
	    renderers: renderers,
	    definitions: getDefinitions(rawAst)
	  });
	
	  var astPlugins = determineAstPlugins(props);
	  var ast = astPlugins.reduce(function (node, plugin) {
	    return plugin(node, renderProps);
	  }, rawAst);
	
	  return astToReact(ast, renderProps);
	};
	
	function applyParserPlugin(parser, plugin) {
	  return Array.isArray(plugin) ? parser.use.apply(parser, _toConsumableArray(plugin)) : parser.use(plugin);
	}
	
	function determineAstPlugins(props) {
	  var plugins = [wrapTableRows, addListMetadata()];
	
	  var disallowedTypes = props.disallowedTypes;
	  if (props.allowedTypes) {
	    disallowedTypes = allTypes.filter(function (type) {
	      return type !== 'root' && props.allowedTypes.indexOf(type) === -1;
	    });
	  }
	
	  var removalMethod = props.unwrapDisallowed ? 'unwrap' : 'remove';
	  if (disallowedTypes && disallowedTypes.length > 0) {
	    plugins.push(disallowNode.ofType(disallowedTypes, removalMethod));
	  }
	
	  if (props.allowNode) {
	    plugins.push(disallowNode.ifNotMatch(props.allowNode, removalMethod));
	  }
	
	  var renderHtml = !props.escapeHtml && !props.skipHtml;
	  if (renderHtml) {
	    plugins.push(naiveHtml);
	  }
	
	  return props.astPlugins ? plugins.concat(props.astPlugins) : plugins;
	}
	
	ReactMarkdown.defaultProps = {
	  renderers: {},
	  escapeHtml: true,
	  skipHtml: false,
	  sourcePos: false,
	  rawSourcePos: false,
	  transformLinkUri: uriTransformer,
	  astPlugins: [],
	  plugins: []
	};
	
	ReactMarkdown.propTypes = {
	  className: PropTypes.string,
	  source: PropTypes.string,
	  children: PropTypes.string,
	  sourcePos: PropTypes.bool,
	  rawSourcePos: PropTypes.bool,
	  escapeHtml: PropTypes.bool,
	  skipHtml: PropTypes.bool,
	  allowNode: PropTypes.func,
	  allowedTypes: PropTypes.arrayOf(PropTypes.oneOf(allTypes)),
	  disallowedTypes: PropTypes.arrayOf(PropTypes.oneOf(allTypes)),
	  transformLinkUri: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
	  linkTarget: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
	  transformImageUri: PropTypes.func,
	  astPlugins: PropTypes.arrayOf(PropTypes.func),
	  unwrapDisallowed: PropTypes.bool,
	  renderers: PropTypes.object,
	  plugins: PropTypes.array
	};
	
	ReactMarkdown.types = allTypes;
	ReactMarkdown.renderers = defaultRenderers;
	ReactMarkdown.uriTransformer = uriTransformer;
	
	module.exports = ReactMarkdown;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable react/prop-types, react/no-multi-comp */
	'use strict';
	
	var xtend = __webpack_require__(20);
	var React = __webpack_require__(1);
	var createElement = React.createElement;
	
	module.exports = {
	  root: 'div',
	  break: 'br',
	  paragraph: 'p',
	  emphasis: 'em',
	  strong: 'strong',
	  thematicBreak: 'hr',
	  blockquote: 'blockquote',
	  delete: 'del',
	  link: 'a',
	  image: 'img',
	  linkReference: 'a',
	  imageReference: 'img',
	  table: SimpleRenderer.bind(null, 'table'),
	  tableHead: SimpleRenderer.bind(null, 'thead'),
	  tableBody: SimpleRenderer.bind(null, 'tbody'),
	  tableRow: SimpleRenderer.bind(null, 'tr'),
	  tableCell: TableCell,
	
	  list: List,
	  listItem: ListItem,
	  definition: NullRenderer,
	  heading: Heading,
	  inlineCode: InlineCode,
	  code: CodeBlock,
	  html: Html,
	  virtualHtml: VirtualHtml
	};
	
	function SimpleRenderer(tag, props) {
	  return createElement(tag, getCoreProps(props), props.children);
	}
	
	function TableCell(props) {
	  var style = props.align ? { textAlign: props.align } : undefined;
	  var coreProps = getCoreProps(props);
	  return createElement(props.isHeader ? 'th' : 'td', style ? xtend({ style: style }, coreProps) : coreProps, props.children);
	}
	
	function Heading(props) {
	  return createElement('h' + props.level, getCoreProps(props), props.children);
	}
	
	function List(props) {
	  var attrs = getCoreProps(props);
	  if (props.start !== null && props.start !== 1) {
	    attrs.start = props.start.toString();
	  }
	
	  return createElement(props.ordered ? 'ol' : 'ul', attrs, props.children);
	}
	
	function ListItem(props) {
	  var checkbox = null;
	  if (props.checked !== null) {
	    var checked = props.checked;
	    checkbox = createElement('input', { type: 'checkbox', checked: checked, readOnly: true });
	  }
	
	  return createElement('li', getCoreProps(props), checkbox, props.children);
	}
	
	function CodeBlock(props) {
	  var className = props.language && 'language-' + props.language;
	  var code = createElement('code', className ? { className: className } : null, props.value);
	  return createElement('pre', getCoreProps(props), code);
	}
	
	function InlineCode(props) {
	  return createElement('code', getCoreProps(props), props.children);
	}
	
	function Html(props) {
	  if (props.skipHtml) {
	    return null;
	  }
	
	  var tag = props.isBlock ? 'div' : 'span';
	  if (props.escapeHtml) {
	    // @todo when fiber lands, we can simply render props.value
	    return createElement(tag, null, props.value);
	  }
	
	  var nodeProps = { dangerouslySetInnerHTML: { __html: props.value } };
	  return createElement(tag, nodeProps);
	}
	
	function VirtualHtml(props) {
	  return createElement(props.tag, getCoreProps(props), props.children);
	}
	
	function NullRenderer() {
	  return null;
	}
	
	function getCoreProps(props) {
	  return props['data-sourcepos'] ? { 'data-sourcepos': props['data-sourcepos'] } : {};
	}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	'use strict';
	
	var protocols = ['http', 'https', 'mailto', 'tel'];
	
	module.exports = function uriTransformer(uri) {
	  var url = (uri || '').trim();
	  var first = url.charAt(0);
	
	  if (first === '#' || first === '/') {
	    return url;
	  }
	
	  var colon = url.indexOf(':');
	  if (colon === -1) {
	    return url;
	  }
	
	  var length = protocols.length;
	  var index = -1;
	
	  while (++index < length) {
	    var protocol = protocols[index];
	
	    if (colon === protocol.length && url.slice(0, protocol.length) === protocol) {
	      return url;
	    }
	  }
	
	  index = url.indexOf('?');
	  if (index !== -1 && colon > index) {
	    return url;
	  }
	
	  index = url.indexOf('#');
	  if (index !== -1 && colon > index) {
	    return url;
	  }
	
	  // eslint-disable-next-line no-script-url
	  return 'javascript:void(0)';
	};

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var visit = __webpack_require__(76);
	
	module.exports = function (node) {
	  visit(node, 'table', wrap);
	  return node;
	};
	
	function wrap(table) {
	  var children = table.children;
	  table.children = [{
	    type: 'tableHead',
	    align: table.align,
	    children: [children[0]],
	    position: children[0].position
	  }];
	  if (children.length > 1) {
	    table.children.push({
	      type: 'tableBody',
	      align: table.align,
	      children: children.slice(1),
	      position: {
	        start: children[1].position.start,
	        end: children[children.length - 1].position.end
	      }
	    });
	  }
	}

/***/ }),
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var shallowEqual = _interopDefault(__webpack_require__(627));
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(SideEffect, _Component);
	
	      function SideEffect() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      // Try to use displayName of wrapped component
	      // Expose canUseDOM so tests can monkeypatch it
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      var _proto = SideEffect.prototype;
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      _proto.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      _proto.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      _proto.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
	
	    _defineProperty(SideEffect, "canUseDOM", canUseDOM);
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var shallowEqual = _interopDefault(__webpack_require__(67));
	var hoistNonReactStatics = _interopDefault(__webpack_require__(68));
	var changeEmitter = __webpack_require__(267);
	var $$observable = _interopDefault(__webpack_require__(629));
	
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	    return BaseComponent;
	  };
	};
	
	var setDisplayName = function setDisplayName(displayName) {
	  return setStatic('displayName', displayName);
	};
	
	var getDisplayName = function getDisplayName(Component$$1) {
	  if (typeof Component$$1 === 'string') {
	    return Component$$1;
	  }
	
	  if (!Component$$1) {
	    return undefined;
	  }
	
	  return Component$$1.displayName || Component$$1.name || 'Component';
	};
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + '(' + getDisplayName(BaseComponent) + ')';
	};
	
	var mapProps = function mapProps(propsMapper) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var MapProps = function MapProps(props) {
	      return factory(propsMapper(props));
	    };
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
	    }
	    return MapProps;
	  };
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	
	
	
	
	
	
	
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var withProps = function withProps(input) {
	  var hoc = mapProps(function (props) {
	    return _extends({}, props, typeof input === 'function' ? input(props) : input);
	  });
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	var pick = function pick(obj, keys) {
	  var result = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (obj.hasOwnProperty(key)) {
	      result[key] = obj[key];
	    }
	  }
	  return result;
	};
	
	var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
	      return !shallowEqual(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
	    };
	
	    var WithPropsOnChange = function (_Component) {
	      inherits(WithPropsOnChange, _Component);
	
	      function WithPropsOnChange() {
	        var _temp, _this, _ret;
	
	        classCallCheck(this, WithPropsOnChange);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
	      }
	
	      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (shouldMap(this.props, nextProps)) {
	          this.computedProps = propsMapper(nextProps);
	        }
	      };
	
	      WithPropsOnChange.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.computedProps));
	      };
	
	      return WithPropsOnChange;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
	    }
	    return WithPropsOnChange;
	  };
	};
	
	var mapValues = function mapValues(obj, func) {
	  var result = {};
	  /* eslint-disable no-restricted-syntax */
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      result[key] = func(obj[key], key);
	    }
	  }
	  /* eslint-enable no-restricted-syntax */
	  return result;
	};
	
	/* eslint-disable no-console */
	var withHandlers = function withHandlers(handlers) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithHandlers = function (_Component) {
	      inherits(WithHandlers, _Component);
	
	      function WithHandlers() {
	        var _temp, _this, _ret;
	
	        classCallCheck(this, WithHandlers);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
	      }
	
	      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	        this.cachedHandlers = {};
	      };
	
	      WithHandlers.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.handlers));
	      };
	
	      return WithHandlers;
	    }(React.Component);
	
	    var _initialiseProps = function _initialiseProps() {
	      var _this2 = this;
	
	      this.cachedHandlers = {};
	      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
	        return function () {
	          var cachedHandler = _this2.cachedHandlers[handlerName];
	          if (cachedHandler) {
	            return cachedHandler.apply(undefined, arguments);
	          }
	
	          var handler = createHandler(_this2.props);
	          _this2.cachedHandlers[handlerName] = handler;
	
	          if (false) {
	            console.error(
	            // eslint-disable-line no-console
	            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
	          }
	
	          return handler.apply(undefined, arguments);
	        };
	      });
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
	    }
	    return WithHandlers;
	  };
	};
	
	var defaultProps = function defaultProps(props) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var DefaultProps = function DefaultProps(ownerProps) {
	      return factory(ownerProps);
	    };
	    DefaultProps.defaultProps = props;
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
	    }
	    return DefaultProps;
	  };
	};
	
	var omit = function omit(obj, keys) {
	  var rest = objectWithoutProperties(obj, []);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (rest.hasOwnProperty(key)) {
	      delete rest[key];
	    }
	  }
	  return rest;
	};
	
	var renameProp = function renameProp(oldName, newName) {
	  var hoc = mapProps(function (props) {
	    var _babelHelpers$extends;
	
	    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
	  });
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	var keys = Object.keys;
	
	
	var mapKeys = function mapKeys(obj, func) {
	  return keys(obj).reduce(function (result, key) {
	    var val = obj[key];
	    /* eslint-disable no-param-reassign */
	    result[func(val, key)] = val;
	    /* eslint-enable no-param-reassign */
	    return result;
	  }, {});
	};
	
	var renameProps = function renameProps(nameMap) {
	  var hoc = mapProps(function (props) {
	    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
	      return nameMap[oldName];
	    }));
	  });
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	var flattenProp = function flattenProp(propName) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var FlattenProp = function FlattenProp(props) {
	      return factory(_extends({}, props, props[propName]));
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
	    }
	    return FlattenProp;
	  };
	};
	
	var withState = function withState(stateName, stateUpdaterName, initialState) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithState = function (_Component) {
	      inherits(WithState, _Component);
	
	      function WithState() {
	        var _temp, _this, _ret;
	
	        classCallCheck(this, WithState);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
	        }, _this.updateStateValue = function (updateFn, callback) {
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
	            };
	          }, callback);
	        }, _temp), possibleConstructorReturn(_this, _ret);
	      }
	
	      WithState.prototype.render = function render() {
	        var _babelHelpers$extends;
	
	        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
	      };
	
	      return WithState;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
	    }
	    return WithState;
	  };
	};
	
	var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithStateHandlers = function (_Component) {
	      inherits(WithStateHandlers, _Component);
	
	      function WithStateHandlers() {
	        var _temp, _this, _ret;
	
	        classCallCheck(this, WithStateHandlers);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
	      }
	
	      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	        var propsChanged = nextProps !== this.props;
	        // the idea is to skip render if stateUpdater handler return undefined
	        // this allows to create no state update handlers with access to state and props
	        var stateChanged = !shallowEqual(nextState, this.state);
	        return propsChanged || stateChanged;
	      };
	
	      WithStateHandlers.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
	      };
	
	      return WithStateHandlers;
	    }(React.Component);
	
	    var _initialiseProps = function _initialiseProps() {
	      var _this2 = this;
	
	      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
	      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
	        return function (mayBeEvent) {
	          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	            args[_key2 - 1] = arguments[_key2];
	          }
	
	          // Having that functional form of setState can be called async
	          // we need to persist SyntheticEvent
	          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
	            mayBeEvent.persist();
	          }
	
	          _this2.setState(function (state, props) {
	            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
	          });
	        };
	      });
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
	    }
	    return WithStateHandlers;
	  };
	};
	
	var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithReducer = function (_Component) {
	      inherits(WithReducer, _Component);
	
	      function WithReducer() {
	        var _temp, _this, _ret;
	
	        classCallCheck(this, WithReducer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	          stateValue: _this.initializeStateValue()
	        }, _this.dispatch = function (action) {
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: reducer(stateValue, action)
	            };
	          });
	        }, _temp), possibleConstructorReturn(_this, _ret);
	      }
	
	      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
	        if (initialState !== undefined) {
	          return typeof initialState === 'function' ? initialState(this.props) : initialState;
	        }
	        return reducer(undefined, { type: '@@recompose/INIT' });
	      };
	
	      WithReducer.prototype.render = function render() {
	        var _babelHelpers$extends;
	
	        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
	      };
	
	      return WithReducer;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
	    }
	    return WithReducer;
	  };
	};
	
	var identity = function identity(Component$$1) {
	  return Component$$1;
	};
	
	var branch = function branch(test, left) {
	  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
	  return function (BaseComponent) {
	    var leftFactory = void 0;
	    var rightFactory = void 0;
	    var Branch = function Branch(props) {
	      if (test(props)) {
	        leftFactory = leftFactory || React.createFactory(left(BaseComponent));
	        return leftFactory(props);
	      }
	      rightFactory = rightFactory || React.createFactory(right(BaseComponent));
	      return rightFactory(props);
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
	    }
	    return Branch;
	  };
	};
	
	var renderComponent = function renderComponent(Component$$1) {
	  return function (_) {
	    var factory = React.createFactory(Component$$1);
	    var RenderComponent = function RenderComponent(props) {
	      return factory(props);
	    };
	    if (false) {
	      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
	    }
	    return RenderComponent;
	  };
	};
	
	var Nothing = function (_Component) {
	  inherits(Nothing, _Component);
	
	  function Nothing() {
	    classCallCheck(this, Nothing);
	    return possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Nothing.prototype.render = function render() {
	    return null;
	  };
	
	  return Nothing;
	}(React.Component);
	
	var renderNothing = function renderNothing(_) {
	  return Nothing;
	};
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var ShouldUpdate = function (_Component) {
	      inherits(ShouldUpdate, _Component);
	
	      function ShouldUpdate() {
	        classCallCheck(this, ShouldUpdate);
	        return possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      ShouldUpdate.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return ShouldUpdate;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
	    }
	    return ShouldUpdate;
	  };
	};
	
	var pure = function pure(BaseComponent) {
	  var hoc = shouldUpdate(function (props, nextProps) {
	    return !shallowEqual(props, nextProps);
	  });
	
	  if (false) {
	    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
	  }
	
	  return hoc(BaseComponent);
	};
	
	var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
	  var hoc = shouldUpdate(function (props, nextProps) {
	    return !shallowEqual(pick(nextProps, propKeys), pick(props, propKeys));
	  });
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
	  var propTypes = BaseComponent.propTypes;
	
	  if (false) {
	    if (!propTypes) {
	      /* eslint-disable */
	      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
	      /* eslint-enable */
	    }
	  }
	
	  var propKeys = Object.keys(propTypes || {});
	  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);
	
	  if (false) {
	    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
	  }
	  return OnlyUpdateForPropTypes;
	};
	
	var withContext = function withContext(childContextTypes, getChildContext) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithContext = function (_Component) {
	      inherits(WithContext, _Component);
	
	      function WithContext() {
	        var _temp, _this, _ret;
	
	        classCallCheck(this, WithContext);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
	          return getChildContext(_this.props);
	        }, _temp), possibleConstructorReturn(_this, _ret);
	      }
	
	      WithContext.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return WithContext;
	    }(React.Component);
	
	    WithContext.childContextTypes = childContextTypes;
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
	    }
	    return WithContext;
	  };
	};
	
	var getContext = function getContext(contextTypes) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var GetContext = function GetContext(ownerProps, context) {
	      return factory(_extends({}, ownerProps, context));
	    };
	
	    GetContext.contextTypes = contextTypes;
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
	    }
	    return GetContext;
	  };
	};
	
	/* eslint-disable no-console */
	var lifecycle = function lifecycle(spec) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    if (false) {
	      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
	    }
	
	    var Lifecycle = function (_Component) {
	      inherits(Lifecycle, _Component);
	
	      function Lifecycle() {
	        classCallCheck(this, Lifecycle);
	        return possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      Lifecycle.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.state));
	      };
	
	      return Lifecycle;
	    }(React.Component);
	
	    Object.keys(spec).forEach(function (hook) {
	      return Lifecycle.prototype[hook] = spec[hook];
	    });
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
	    }
	    return Lifecycle;
	  };
	};
	
	var isClassComponent = function isClassComponent(Component$$1) {
	  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
	};
	
	var toClass = function toClass(baseComponent) {
	  if (isClassComponent(baseComponent)) {
	    return baseComponent;
	  }
	
	  var ToClass = function (_Component) {
	    inherits(ToClass, _Component);
	
	    function ToClass() {
	      classCallCheck(this, ToClass);
	      return possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    ToClass.prototype.render = function render() {
	      if (typeof baseComponent === 'string') {
	        return React__default.createElement(baseComponent, this.props);
	      }
	      return baseComponent(this.props, this.context);
	    };
	
	    return ToClass;
	  }(React.Component);
	
	  ToClass.displayName = getDisplayName(baseComponent);
	  ToClass.propTypes = baseComponent.propTypes;
	  ToClass.contextTypes = baseComponent.contextTypes;
	  ToClass.defaultProps = baseComponent.defaultProps;
	
	  return ToClass;
	};
	
	var setPropTypes = function setPropTypes(propTypes) {
	  return setStatic('propTypes', propTypes);
	};
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}
	
	var createSink = function createSink(callback) {
	  return function (_Component) {
	    inherits(Sink, _Component);
	
	    function Sink() {
	      classCallCheck(this, Sink);
	      return possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Sink.prototype.componentWillMount = function componentWillMount() {
	      callback(this.props);
	    };
	
	    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      callback(nextProps);
	    };
	
	    Sink.prototype.render = function render() {
	      return null;
	    };
	
	    return Sink;
	  }(React.Component);
	};
	
	var componentFromProp = function componentFromProp(propName) {
	  var Component$$1 = function Component$$1(props) {
	    return React.createElement(props[propName], omit(props, [propName]));
	  };
	  Component$$1.displayName = 'componentFromProp(' + propName + ')';
	  return Component$$1;
	};
	
	var nest = function nest() {
	  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
	    Components[_key] = arguments[_key];
	  }
	
	  var factories = Components.map(React.createFactory);
	  var Nest = function Nest(_ref) {
	    var props = objectWithoutProperties(_ref, []),
	        children = _ref.children;
	    return factories.reduceRight(function (child, factory) {
	      return factory(props, child);
	    }, children);
	  };
	
	  if (false) {
	    var displayNames = Components.map(getDisplayName);
	    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
	  }
	
	  return Nest;
	};
	
	var hoistStatics = function hoistStatics(higherOrderComponent) {
	  return function (BaseComponent) {
	    var NewComponent = higherOrderComponent(BaseComponent);
	    hoistNonReactStatics(NewComponent, BaseComponent);
	    return NewComponent;
	  };
	};
	
	var _config = {
	  fromESObservable: null,
	  toESObservable: null
	};
	
	var configureObservable = function configureObservable(c) {
	  _config = c;
	};
	
	var config = {
	  fromESObservable: function fromESObservable(observable) {
	    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
	  },
	  toESObservable: function toESObservable(stream) {
	    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
	  }
	};
	
	var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
	  return function (propsToVdom) {
	    return function (_Component) {
	      inherits(ComponentFromStream, _Component);
	
	      function ComponentFromStream() {
	        var _config$fromESObserva;
	
	        var _temp, _this, _ret;
	
	        classCallCheck(this, ComponentFromStream);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = changeEmitter.createChangeEmitter(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
	          subscribe: function subscribe(observer) {
	            var unsubscribe = _this.propsEmitter.listen(function (props) {
	              if (props) {
	                observer.next(props);
	              } else {
	                observer.complete();
	              }
	            });
	            return { unsubscribe: unsubscribe };
	          }
	        }, _config$fromESObserva[$$observable] = function () {
	          return this;
	        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
	      }
	
	      // Stream of props
	
	
	      // Stream of vdom
	
	
	      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        // Subscribe to child prop changes so we know when to re-render
	        this.subscription = this.vdom$.subscribe({
	          next: function next(vdom) {
	            _this2.setState({ vdom: vdom });
	          }
	        });
	        this.propsEmitter.emit(this.props);
	      };
	
	      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        // Receive new props from the owner
	        this.propsEmitter.emit(nextProps);
	      };
	
	      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	        return nextState.vdom !== this.state.vdom;
	      };
	
	      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
	        // Call without arguments to complete stream
	        this.propsEmitter.emit();
	
	        // Clean-up subscription before un-mounting
	        this.subscription.unsubscribe();
	      };
	
	      ComponentFromStream.prototype.render = function render() {
	        return this.state.vdom;
	      };
	
	      return ComponentFromStream;
	    }(React.Component);
	  };
	};
	
	var componentFromStream = function componentFromStream(propsToVdom) {
	  return componentFromStreamWithConfig(config)(propsToVdom);
	};
	
	var identity$1 = function identity(t) {
	  return t;
	};
	
	var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
	  var componentFromStream = componentFromStreamWithConfig({
	    fromESObservable: identity$1,
	    toESObservable: identity$1
	  });
	  return function (transform) {
	    return function (BaseComponent) {
	      var factory = React.createFactory(BaseComponent);
	      var fromESObservable = config$$1.fromESObservable,
	          toESObservable = config$$1.toESObservable;
	
	      return componentFromStream(function (props$) {
	        var _ref;
	
	        return _ref = {
	          subscribe: function subscribe(observer) {
	            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
	              next: function next(childProps) {
	                return observer.next(factory(childProps));
	              }
	            });
	            return {
	              unsubscribe: function unsubscribe() {
	                return subscription.unsubscribe();
	              }
	            };
	          }
	        }, _ref[$$observable] = function () {
	          return this;
	        }, _ref;
	      });
	    };
	  };
	};
	
	var mapPropsStream = function mapPropsStream(transform) {
	  var hoc = mapPropsStreamWithConfig(config)(transform);
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
	  return function () {
	    var _config$fromESObserva;
	
	    var emitter = changeEmitter.createChangeEmitter();
	    var stream = config$$1.fromESObservable((_config$fromESObserva = {
	      subscribe: function subscribe(observer) {
	        var unsubscribe = emitter.listen(function (value) {
	          return observer.next(value);
	        });
	        return { unsubscribe: unsubscribe };
	      }
	    }, _config$fromESObserva[$$observable] = function () {
	      return this;
	    }, _config$fromESObserva));
	    return {
	      handler: emitter.emit,
	      stream: stream
	    };
	  };
	};
	
	var createEventHandler = createEventHandlerWithConfig(config);
	
	// Higher-order component helpers
	
	exports.mapProps = mapProps;
	exports.withProps = withProps;
	exports.withPropsOnChange = withPropsOnChange;
	exports.withHandlers = withHandlers;
	exports.defaultProps = defaultProps;
	exports.renameProp = renameProp;
	exports.renameProps = renameProps;
	exports.flattenProp = flattenProp;
	exports.withState = withState;
	exports.withStateHandlers = withStateHandlers;
	exports.withReducer = withReducer;
	exports.branch = branch;
	exports.renderComponent = renderComponent;
	exports.renderNothing = renderNothing;
	exports.shouldUpdate = shouldUpdate;
	exports.pure = pure;
	exports.onlyUpdateForKeys = onlyUpdateForKeys;
	exports.onlyUpdateForPropTypes = onlyUpdateForPropTypes;
	exports.withContext = withContext;
	exports.getContext = getContext;
	exports.lifecycle = lifecycle;
	exports.toClass = toClass;
	exports.setStatic = setStatic;
	exports.setPropTypes = setPropTypes;
	exports.setDisplayName = setDisplayName;
	exports.compose = compose;
	exports.getDisplayName = getDisplayName;
	exports.wrapDisplayName = wrapDisplayName;
	exports.shallowEqual = shallowEqual;
	exports.isClassComponent = isClassComponent;
	exports.createSink = createSink;
	exports.componentFromProp = componentFromProp;
	exports.nest = nest;
	exports.hoistStatics = hoistStatics;
	exports.componentFromStream = componentFromStream;
	exports.componentFromStreamWithConfig = componentFromStreamWithConfig;
	exports.mapPropsStream = mapPropsStream;
	exports.mapPropsStreamWithConfig = mapPropsStreamWithConfig;
	exports.createEventHandler = createEventHandler;
	exports.createEventHandlerWithConfig = createEventHandlerWithConfig;
	exports.setObservableConfig = configureObservable;


/***/ }),
/* 577 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var getDisplayName = function getDisplayName(Component) {
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (!Component) {
	    return undefined;
	  }
	
	  return Component.displayName || Component.name || 'Component';
	};
	
	exports.default = getDisplayName;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setStatic = __webpack_require__(579);
	
	var _setStatic2 = _interopRequireDefault(_setStatic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setDisplayName = function setDisplayName(displayName) {
	  return (0, _setStatic2.default)('displayName', displayName);
	};
	
	exports.default = setDisplayName;

/***/ }),
/* 579 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	    return BaseComponent;
	  };
	};
	
	exports.default = setStatic;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _setDisplayName = __webpack_require__(578);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(581);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withState = function withState(stateName, stateUpdaterName, initialState) {
	  return function (BaseComponent) {
	    var factory = (0, _react.createFactory)(BaseComponent);
	
	    var WithState = function (_Component) {
	      _inherits(WithState, _Component);
	
	      function WithState() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WithState);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
	        }, _this.updateStateValue = function (updateFn, callback) {
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
	            };
	          }, callback);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      WithState.prototype.render = function render() {
	        var _extends2;
	
	        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[stateUpdaterName] = this.updateStateValue, _extends2)));
	      };
	
	      return WithState;
	    }(_react.Component);
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withState'))(WithState);
	    }
	    return WithState;
	  };
	};
	
	exports.default = withState;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getDisplayName = __webpack_require__(577);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
	};
	
	exports.default = wrapDisplayName;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var unherit = __webpack_require__(634);
	var xtend = __webpack_require__(20);
	var Parser = __webpack_require__(592);
	
	module.exports = parse;
	parse.Parser = Parser;
	
	function parse(options) {
	  var Local = unherit(Parser);
	  Local.prototype.options = xtend(Local.prototype.options, this.data('settings'), options);
	  this.Parser = Local;
	}


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(20);
	var entities = __webpack_require__(97);
	
	module.exports = factory;
	
	/* Factory to create an entity decoder. */
	function factory(ctx) {
	  decoder.raw = decodeRaw;
	
	  return decoder;
	
	  /* Normalize `position` to add an `indent`. */
	  function normalize(position) {
	    var offsets = ctx.offset;
	    var line = position.line;
	    var result = [];
	
	    while (++line) {
	      if (!(line in offsets)) {
	        break;
	      }
	
	      result.push((offsets[line] || 0) + 1);
	    }
	
	    return {
	      start: position,
	      indent: result
	    };
	  }
	
	  /* Handle a warning.
	   * See https://github.com/wooorm/parse-entities
	   * for the warnings. */
	  function handleWarning(reason, position, code) {
	    if (code === 3) {
	      return;
	    }
	
	    ctx.file.message(reason, position);
	  }
	
	  /* Decode `value` (at `position`) into text-nodes. */
	  function decoder(value, position, handler) {
	    entities(value, {
	      position: normalize(position),
	      warning: handleWarning,
	      text: handler,
	      reference: handler,
	      textContext: ctx,
	      referenceContext: ctx
	    });
	  }
	
	  /* Decode `value` (at `position`) into a string. */
	  function decodeRaw(value, position, options) {
	    return entities(value, xtend(options, {
	      position: normalize(position),
	      warning: handleWarning
	    }));
	  }
	}


/***/ }),
/* 584 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var index = value.indexOf('\n', fromIndex);
	
	  while (index > fromIndex) {
	    if (value.charAt(index - 1) !== ' ') {
	      break;
	    }
	
	    index--;
	  }
	
	  return index;
	}


/***/ }),
/* 585 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('`', fromIndex);
	}


/***/ }),
/* 586 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('~~', fromIndex);
	}


/***/ }),
/* 587 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var asterisk = value.indexOf('*', fromIndex);
	  var underscore = value.indexOf('_', fromIndex);
	
	  if (underscore === -1) {
	    return asterisk;
	  }
	
	  if (asterisk === -1) {
	    return underscore;
	  }
	
	  return underscore < asterisk ? underscore : asterisk;
	}


/***/ }),
/* 588 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('\\', fromIndex);
	}


/***/ }),
/* 589 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var asterisk = value.indexOf('**', fromIndex);
	  var underscore = value.indexOf('__', fromIndex);
	
	  if (underscore === -1) {
	    return asterisk;
	  }
	
	  if (asterisk === -1) {
	    return underscore;
	  }
	
	  return underscore < asterisk ? underscore : asterisk;
	}


/***/ }),
/* 590 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	var PROTOCOLS = ['https://', 'http://', 'mailto:'];
	
	function locate(value, fromIndex) {
	  var length = PROTOCOLS.length;
	  var index = -1;
	  var min = -1;
	  var position;
	
	  if (!this.options.gfm) {
	    return -1;
	  }
	
	  while (++index < length) {
	    position = value.indexOf(PROTOCOLS[index], fromIndex);
	
	    if (position !== -1 && (position < min || min === -1)) {
	      min = position;
	    }
	  }
	
	  return min;
	}


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(20);
	var removePosition = __webpack_require__(637);
	
	module.exports = parse;
	
	var C_NEWLINE = '\n';
	var EXPRESSION_LINE_BREAKS = /\r\n|\r/g;
	
	/* Parse the bound file. */
	function parse() {
	  var self = this;
	  var value = String(self.file);
	  var start = {line: 1, column: 1, offset: 0};
	  var content = xtend(start);
	  var node;
	
	  /* Clean non-unix newlines: `\r\n` and `\r` are all
	   * changed to `\n`.  This should not affect positional
	   * information. */
	  value = value.replace(EXPRESSION_LINE_BREAKS, C_NEWLINE);
	
	  if (value.charCodeAt(0) === 0xFEFF) {
	    value = value.slice(1);
	
	    content.column++;
	    content.offset++;
	  }
	
	  node = {
	    type: 'root',
	    children: self.tokenizeBlock(value, content),
	    position: {
	      start: start,
	      end: self.eof || xtend(start)
	    }
	  };
	
	  if (!self.options.position) {
	    removePosition(node, true);
	  }
	
	  return node;
	}


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(20);
	var toggle = __webpack_require__(628);
	var vfileLocation = __webpack_require__(646);
	var unescape = __webpack_require__(620);
	var decode = __webpack_require__(583);
	var tokenizer = __webpack_require__(619);
	
	module.exports = Parser;
	
	function Parser(doc, file) {
	  this.file = file;
	  this.offset = {};
	  this.options = xtend(this.options);
	  this.setOptions({});
	
	  this.inList = false;
	  this.inBlock = false;
	  this.inLink = false;
	  this.atStart = true;
	
	  this.toOffset = vfileLocation(file).toOffset;
	  this.unescape = unescape(this, 'escape');
	  this.decode = decode(this);
	}
	
	var proto = Parser.prototype;
	
	/* Expose core. */
	proto.setOptions = __webpack_require__(593);
	proto.parse = __webpack_require__(591);
	
	/* Expose `defaults`. */
	proto.options = __webpack_require__(195);
	
	/* Enter and exit helpers. */
	proto.exitStart = toggle('atStart', true);
	proto.enterList = toggle('inList', false);
	proto.enterLink = toggle('inLink', false);
	proto.enterBlock = toggle('inBlock', false);
	
	/* Nodes that can interupt a paragraph:
	 *
	 * ```markdown
	 * A paragraph, followed by a thematic break.
	 * ___
	 * ```
	 *
	 * In the above example, the thematic break “interupts”
	 * the paragraph. */
	proto.interruptParagraph = [
	  ['thematicBreak'],
	  ['atxHeading'],
	  ['fencedCode'],
	  ['blockquote'],
	  ['html'],
	  ['setextHeading', {commonmark: false}],
	  ['definition', {commonmark: false}],
	  ['footnote', {commonmark: false}]
	];
	
	/* Nodes that can interupt a list:
	 *
	 * ```markdown
	 * - One
	 * ___
	 * ```
	 *
	 * In the above example, the thematic break “interupts”
	 * the list. */
	proto.interruptList = [
	  ['atxHeading', {pedantic: false}],
	  ['fencedCode', {pedantic: false}],
	  ['thematicBreak', {pedantic: false}],
	  ['definition', {commonmark: false}],
	  ['footnote', {commonmark: false}]
	];
	
	/* Nodes that can interupt a blockquote:
	 *
	 * ```markdown
	 * > A paragraph.
	 * ___
	 * ```
	 *
	 * In the above example, the thematic break “interupts”
	 * the blockquote. */
	proto.interruptBlockquote = [
	  ['indentedCode', {commonmark: true}],
	  ['fencedCode', {commonmark: true}],
	  ['atxHeading', {commonmark: true}],
	  ['setextHeading', {commonmark: true}],
	  ['thematicBreak', {commonmark: true}],
	  ['html', {commonmark: true}],
	  ['list', {commonmark: true}],
	  ['definition', {commonmark: false}],
	  ['footnote', {commonmark: false}]
	];
	
	/* Handlers. */
	proto.blockTokenizers = {
	  newline: __webpack_require__(611),
	  indentedCode: __webpack_require__(598),
	  fencedCode: __webpack_require__(597),
	  blockquote: __webpack_require__(595),
	  atxHeading: __webpack_require__(605),
	  thematicBreak: __webpack_require__(617),
	  list: __webpack_require__(610),
	  setextHeading: __webpack_require__(606),
	  html: __webpack_require__(607),
	  footnote: __webpack_require__(604),
	  definition: __webpack_require__(600),
	  table: __webpack_require__(615),
	  paragraph: __webpack_require__(612)
	};
	
	proto.inlineTokenizers = {
	  escape: __webpack_require__(603),
	  autoLink: __webpack_require__(594),
	  url: __webpack_require__(618),
	  html: __webpack_require__(608),
	  link: __webpack_require__(609),
	  reference: __webpack_require__(613),
	  strong: __webpack_require__(614),
	  emphasis: __webpack_require__(602),
	  deletion: __webpack_require__(601),
	  code: __webpack_require__(599),
	  break: __webpack_require__(596),
	  text: __webpack_require__(616)
	};
	
	/* Expose precedence. */
	proto.blockMethods = keys(proto.blockTokenizers);
	proto.inlineMethods = keys(proto.inlineTokenizers);
	
	/* Tokenizers. */
	proto.tokenizeBlock = tokenizer('block');
	proto.tokenizeInline = tokenizer('inline');
	proto.tokenizeFactory = tokenizer;
	
	/* Get all keys in `value`. */
	function keys(value) {
	  var result = [];
	  var key;
	
	  for (key in value) {
	    result.push(key);
	  }
	
	  return result;
	}


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(20);
	var escapes = __webpack_require__(457);
	var defaults = __webpack_require__(195);
	
	module.exports = setOptions;
	
	function setOptions(options) {
	  var self = this;
	  var current = self.options;
	  var key;
	  var value;
	
	  if (options == null) {
	    options = {};
	  } else if (typeof options === 'object') {
	    options = xtend(options);
	  } else {
	    throw new Error(
	      'Invalid value `' + options + '` ' +
	      'for setting `options`'
	    );
	  }
	
	  for (key in defaults) {
	    value = options[key];
	
	    if (value == null) {
	      value = current[key];
	    }
	
	    if (
	      (key !== 'blocks' && typeof value !== 'boolean') ||
	      (key === 'blocks' && typeof value !== 'object')
	    ) {
	      throw new Error('Invalid value `' + value + '` for setting `options.' + key + '`');
	    }
	
	    options[key] = value;
	  }
	
	  self.options = options;
	  self.escape = escapes(options);
	
	  return self;
	}


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(10);
	var decode = __webpack_require__(97);
	var locate = __webpack_require__(197);
	
	module.exports = autoLink;
	autoLink.locator = locate;
	autoLink.notInLink = true;
	
	var C_LT = '<';
	var C_GT = '>';
	var C_AT_SIGN = '@';
	var C_SLASH = '/';
	var MAILTO = 'mailto:';
	var MAILTO_LENGTH = MAILTO.length;
	
	/* Tokenise a link. */
	function autoLink(eat, value, silent) {
	  var self;
	  var subvalue;
	  var length;
	  var index;
	  var queue;
	  var character;
	  var hasAtCharacter;
	  var link;
	  var now;
	  var content;
	  var tokenizers;
	  var exit;
	
	  if (value.charAt(0) !== C_LT) {
	    return;
	  }
	
	  self = this;
	  subvalue = '';
	  length = value.length;
	  index = 0;
	  queue = '';
	  hasAtCharacter = false;
	  link = '';
	
	  index++;
	  subvalue = C_LT;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      whitespace(character) ||
	      character === C_GT ||
	      character === C_AT_SIGN ||
	      (character === ':' && value.charAt(index + 1) === C_SLASH)
	    ) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  link += queue;
	  queue = '';
	
	  character = value.charAt(index);
	  link += character;
	  index++;
	
	  if (character === C_AT_SIGN) {
	    hasAtCharacter = true;
	  } else {
	    if (
	      character !== ':' ||
	      value.charAt(index + 1) !== C_SLASH
	    ) {
	      return;
	    }
	
	    link += C_SLASH;
	    index++;
	  }
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (whitespace(character) || character === C_GT) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (!queue || character !== C_GT) {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  link += queue;
	  content = link;
	  subvalue += link + character;
	  now = eat.now();
	  now.column++;
	  now.offset++;
	
	  if (hasAtCharacter) {
	    if (link.slice(0, MAILTO_LENGTH).toLowerCase() === MAILTO) {
	      content = content.substr(MAILTO_LENGTH);
	      now.column += MAILTO_LENGTH;
	      now.offset += MAILTO_LENGTH;
	    } else {
	      link = MAILTO + link;
	    }
	  }
	
	  /* Temporarily remove all tokenizers except text in autolinks. */
	  tokenizers = self.inlineTokenizers;
	  self.inlineTokenizers = {text: tokenizers.text};
	
	  exit = self.enterLink();
	
	  content = self.tokenizeInline(content, now);
	
	  self.inlineTokenizers = tokenizers;
	  exit();
	
	  return eat(subvalue)({
	    type: 'link',
	    title: null,
	    url: decode(link, {nonTerminated: false}),
	    children: content
	  });
	}


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(41);
	var interrupt = __webpack_require__(118);
	
	module.exports = blockquote;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_GT = '>';
	
	/* Tokenise a blockquote. */
	function blockquote(eat, value, silent) {
	  var self = this;
	  var offsets = self.offset;
	  var tokenizers = self.blockTokenizers;
	  var interruptors = self.interruptBlockquote;
	  var now = eat.now();
	  var currentLine = now.line;
	  var length = value.length;
	  var values = [];
	  var contents = [];
	  var indents = [];
	  var add;
	  var index = 0;
	  var character;
	  var rest;
	  var nextIndex;
	  var content;
	  var line;
	  var startIndex;
	  var prefixed;
	  var exit;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    index++;
	  }
	
	  if (value.charAt(index) !== C_GT) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  index = 0;
	
	  while (index < length) {
	    nextIndex = value.indexOf(C_NEWLINE, index);
	    startIndex = index;
	    prefixed = false;
	
	    if (nextIndex === -1) {
	      nextIndex = length;
	    }
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== C_SPACE && character !== C_TAB) {
	        break;
	      }
	
	      index++;
	    }
	
	    if (value.charAt(index) === C_GT) {
	      index++;
	      prefixed = true;
	
	      if (value.charAt(index) === C_SPACE) {
	        index++;
	      }
	    } else {
	      index = startIndex;
	    }
	
	    content = value.slice(index, nextIndex);
	
	    if (!prefixed && !trim(content)) {
	      index = startIndex;
	      break;
	    }
	
	    if (!prefixed) {
	      rest = value.slice(index);
	
	      /* Check if the following code contains a possible
	       * block. */
	      if (interrupt(interruptors, tokenizers, self, [eat, rest, true])) {
	        break;
	      }
	    }
	
	    line = startIndex === index ? content : value.slice(startIndex, nextIndex);
	
	    indents.push(index - startIndex);
	    values.push(line);
	    contents.push(content);
	
	    index = nextIndex + 1;
	  }
	
	  index = -1;
	  length = indents.length;
	  add = eat(values.join(C_NEWLINE));
	
	  while (++index < length) {
	    offsets[currentLine] = (offsets[currentLine] || 0) + indents[index];
	    currentLine++;
	  }
	
	  exit = self.enterBlock();
	  contents = self.tokenizeBlock(contents.join(C_NEWLINE), now);
	  exit();
	
	  return add({
	    type: 'blockquote',
	    children: contents
	  });
	}


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var locate = __webpack_require__(584);
	
	module.exports = hardBreak;
	hardBreak.locator = locate;
	
	var MIN_BREAK_LENGTH = 2;
	
	function hardBreak(eat, value, silent) {
	  var length = value.length;
	  var index = -1;
	  var queue = '';
	  var character;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character === '\n') {
	      if (index < MIN_BREAK_LENGTH) {
	        return;
	      }
	
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      queue += character;
	
	      return eat(queue)({type: 'break'});
	    }
	
	    if (character !== ' ') {
	      return;
	    }
	
	    queue += character;
	  }
	}


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(121);
	
	module.exports = fencedCode;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_TILDE = '~';
	var C_TICK = '`';
	
	var MIN_FENCE_COUNT = 3;
	var CODE_INDENT_COUNT = 4;
	
	function fencedCode(eat, value, silent) {
	  var self = this;
	  var settings = self.options;
	  var length = value.length + 1;
	  var index = 0;
	  var subvalue = '';
	  var fenceCount;
	  var marker;
	  var character;
	  var flag;
	  var queue;
	  var content;
	  var exdentedContent;
	  var closing;
	  var exdentedClosing;
	  var indent;
	  var now;
	
	  if (!settings.gfm) {
	    return;
	  }
	
	  /* Eat initial spacing. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  indent = index;
	
	  /* Eat the fence. */
	  character = value.charAt(index);
	
	  if (character !== C_TILDE && character !== C_TICK) {
	    return;
	  }
	
	  index++;
	  marker = character;
	  fenceCount = 1;
	  subvalue += character;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== marker) {
	      break;
	    }
	
	    subvalue += character;
	    fenceCount++;
	    index++;
	  }
	
	  if (fenceCount < MIN_FENCE_COUNT) {
	    return;
	  }
	
	  /* Eat spacing before flag. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  /* Eat flag. */
	  flag = '';
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character === C_NEWLINE ||
	      character === C_TILDE ||
	      character === C_TICK
	    ) {
	      break;
	    }
	
	    if (character === C_SPACE || character === C_TAB) {
	      queue += character;
	    } else {
	      flag += queue + character;
	      queue = '';
	    }
	
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (character && character !== C_NEWLINE) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  now = eat.now();
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	
	  subvalue += flag;
	  flag = self.decode.raw(self.unescape(flag), now);
	
	  if (queue) {
	    subvalue += queue;
	  }
	
	  queue = '';
	  closing = '';
	  exdentedClosing = '';
	  content = '';
	  exdentedContent = '';
	
	  /* Eat content. */
	  while (index < length) {
	    character = value.charAt(index);
	    content += closing;
	    exdentedContent += exdentedClosing;
	    closing = '';
	    exdentedClosing = '';
	
	    if (character !== C_NEWLINE) {
	      content += character;
	      exdentedClosing += character;
	      index++;
	      continue;
	    }
	
	    /* Add the newline to `subvalue` if its the first
	     * character.  Otherwise, add it to the `closing`
	     * queue. */
	    if (content) {
	      closing += character;
	      exdentedClosing += character;
	    } else {
	      subvalue += character;
	    }
	
	    queue = '';
	    index++;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== C_SPACE) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    closing += queue;
	    exdentedClosing += queue.slice(indent);
	
	    if (queue.length >= CODE_INDENT_COUNT) {
	      continue;
	    }
	
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== marker) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    closing += queue;
	    exdentedClosing += queue;
	
	    if (queue.length < fenceCount) {
	      continue;
	    }
	
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== C_SPACE && character !== C_TAB) {
	        break;
	      }
	
	      closing += character;
	      exdentedClosing += character;
	      index++;
	    }
	
	    if (!character || character === C_NEWLINE) {
	      break;
	    }
	  }
	
	  subvalue += content + closing;
	
	  return eat(subvalue)({
	    type: 'code',
	    lang: flag || null,
	    value: trim(exdentedContent)
	  });
	}


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var repeat = __webpack_require__(120);
	var trim = __webpack_require__(121);
	
	module.exports = indentedCode;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	
	var CODE_INDENT_COUNT = 4;
	var CODE_INDENT = repeat(C_SPACE, CODE_INDENT_COUNT);
	
	/* Tokenise indented code. */
	function indentedCode(eat, value, silent) {
	  var index = -1;
	  var length = value.length;
	  var subvalue = '';
	  var content = '';
	  var subvalueQueue = '';
	  var contentQueue = '';
	  var character;
	  var blankQueue;
	  var indent;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (indent) {
	      indent = false;
	
	      subvalue += subvalueQueue;
	      content += contentQueue;
	      subvalueQueue = '';
	      contentQueue = '';
	
	      if (character === C_NEWLINE) {
	        subvalueQueue = character;
	        contentQueue = character;
	      } else {
	        subvalue += character;
	        content += character;
	
	        while (++index < length) {
	          character = value.charAt(index);
	
	          if (!character || character === C_NEWLINE) {
	            contentQueue = character;
	            subvalueQueue = character;
	            break;
	          }
	
	          subvalue += character;
	          content += character;
	        }
	      }
	    } else if (
	      character === C_SPACE &&
	      value.charAt(index + 1) === character &&
	      value.charAt(index + 2) === character &&
	      value.charAt(index + 3) === character
	    ) {
	      subvalueQueue += CODE_INDENT;
	      index += 3;
	      indent = true;
	    } else if (character === C_TAB) {
	      subvalueQueue += character;
	      indent = true;
	    } else {
	      blankQueue = '';
	
	      while (character === C_TAB || character === C_SPACE) {
	        blankQueue += character;
	        character = value.charAt(++index);
	      }
	
	      if (character !== C_NEWLINE) {
	        break;
	      }
	
	      subvalueQueue += blankQueue + character;
	      contentQueue += character;
	    }
	  }
	
	  if (content) {
	    if (silent) {
	      return true;
	    }
	
	    return eat(subvalue)({
	      type: 'code',
	      lang: null,
	      value: trim(content)
	    });
	  }
	}


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(10);
	var locate = __webpack_require__(585);
	
	module.exports = inlineCode;
	inlineCode.locator = locate;
	
	var C_TICK = '`';
	
	/* Tokenise inline code. */
	function inlineCode(eat, value, silent) {
	  var length = value.length;
	  var index = 0;
	  var queue = '';
	  var tickQueue = '';
	  var contentQueue;
	  var subqueue;
	  var count;
	  var openingCount;
	  var subvalue;
	  var character;
	  var found;
	  var next;
	
	  while (index < length) {
	    if (value.charAt(index) !== C_TICK) {
	      break;
	    }
	
	    queue += C_TICK;
	    index++;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  subvalue = queue;
	  openingCount = index;
	  queue = '';
	  next = value.charAt(index);
	  count = 0;
	
	  while (index < length) {
	    character = next;
	    next = value.charAt(index + 1);
	
	    if (character === C_TICK) {
	      count++;
	      tickQueue += character;
	    } else {
	      count = 0;
	      queue += character;
	    }
	
	    if (count && next !== C_TICK) {
	      if (count === openingCount) {
	        subvalue += queue + tickQueue;
	        found = true;
	        break;
	      }
	
	      queue += tickQueue;
	      tickQueue = '';
	    }
	
	    index++;
	  }
	
	  if (!found) {
	    if (openingCount % 2 !== 0) {
	      return;
	    }
	
	    queue = '';
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  contentQueue = '';
	  subqueue = '';
	  length = queue.length;
	  index = -1;
	
	  while (++index < length) {
	    character = queue.charAt(index);
	
	    if (whitespace(character)) {
	      subqueue += character;
	      continue;
	    }
	
	    if (subqueue) {
	      if (contentQueue) {
	        contentQueue += subqueue;
	      }
	
	      subqueue = '';
	    }
	
	    contentQueue += character;
	  }
	
	  return eat(subvalue)({
	    type: 'inlineCode',
	    value: contentQueue
	  });
	}


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(10);
	var normalize = __webpack_require__(119);
	
	module.exports = definition;
	definition.notInList = true;
	definition.notInBlock = true;
	
	var C_DOUBLE_QUOTE = '"';
	var C_SINGLE_QUOTE = '\'';
	var C_BACKSLASH = '\\';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_PAREN_OPEN = '(';
	var C_PAREN_CLOSE = ')';
	var C_COLON = ':';
	var C_LT = '<';
	var C_GT = '>';
	
	function definition(eat, value, silent) {
	  var self = this;
	  var commonmark = self.options.commonmark;
	  var index = 0;
	  var length = value.length;
	  var subvalue = '';
	  var beforeURL;
	  var beforeTitle;
	  var queue;
	  var character;
	  var test;
	  var identifier;
	  var url;
	  var title;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (character !== C_BRACKET_OPEN) {
	    return;
	  }
	
	  index++;
	  subvalue += character;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_CLOSE) {
	      break;
	    } else if (character === C_BACKSLASH) {
	      queue += character;
	      index++;
	      character = value.charAt(index);
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (
	    !queue ||
	    value.charAt(index) !== C_BRACKET_CLOSE ||
	    value.charAt(index + 1) !== C_COLON
	  ) {
	    return;
	  }
	
	  identifier = queue;
	  subvalue += queue + C_BRACKET_CLOSE + C_COLON;
	  index = subvalue.length;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character !== C_TAB &&
	      character !== C_SPACE &&
	      character !== C_NEWLINE
	    ) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	  queue = '';
	  beforeURL = subvalue;
	
	  if (character === C_LT) {
	    index++;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (!isEnclosedURLCharacter(character)) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (character === isEnclosedURLCharacter.delimiter) {
	      subvalue += C_LT + queue + character;
	      index++;
	    } else {
	      if (commonmark) {
	        return;
	      }
	
	      index -= queue.length + 1;
	      queue = '';
	    }
	  }
	
	  if (!queue) {
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (!isUnclosedURLCharacter(character)) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    subvalue += queue;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  url = queue;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character !== C_TAB &&
	      character !== C_SPACE &&
	      character !== C_NEWLINE
	    ) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	  test = null;
	
	  if (character === C_DOUBLE_QUOTE) {
	    test = C_DOUBLE_QUOTE;
	  } else if (character === C_SINGLE_QUOTE) {
	    test = C_SINGLE_QUOTE;
	  } else if (character === C_PAREN_OPEN) {
	    test = C_PAREN_CLOSE;
	  }
	
	  if (!test) {
	    queue = '';
	    index = subvalue.length;
	  } else if (queue) {
	    subvalue += queue + character;
	    index = subvalue.length;
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === test) {
	        break;
	      }
	
	      if (character === C_NEWLINE) {
	        index++;
	        character = value.charAt(index);
	
	        if (character === C_NEWLINE || character === test) {
	          return;
	        }
	
	        queue += C_NEWLINE;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (character !== test) {
	      return;
	    }
	
	    beforeTitle = subvalue;
	    subvalue += queue + character;
	    index++;
	    title = queue;
	    queue = '';
	  } else {
	    return;
	  }
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (!character || character === C_NEWLINE) {
	    if (silent) {
	      return true;
	    }
	
	    beforeURL = eat(beforeURL).test().end;
	    url = self.decode.raw(self.unescape(url), beforeURL, {nonTerminated: false});
	
	    if (title) {
	      beforeTitle = eat(beforeTitle).test().end;
	      title = self.decode.raw(self.unescape(title), beforeTitle);
	    }
	
	    return eat(subvalue)({
	      type: 'definition',
	      identifier: normalize(identifier),
	      title: title || null,
	      url: url
	    });
	  }
	}
	
	/* Check if `character` can be inside an enclosed URI. */
	function isEnclosedURLCharacter(character) {
	  return character !== C_GT &&
	    character !== C_BRACKET_OPEN &&
	    character !== C_BRACKET_CLOSE;
	}
	
	isEnclosedURLCharacter.delimiter = C_GT;
	
	/* Check if `character` can be inside an unclosed URI. */
	function isUnclosedURLCharacter(character) {
	  return character !== C_BRACKET_OPEN &&
	    character !== C_BRACKET_CLOSE &&
	    !whitespace(character);
	}


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(10);
	var locate = __webpack_require__(586);
	
	module.exports = strikethrough;
	strikethrough.locator = locate;
	
	var C_TILDE = '~';
	var DOUBLE = '~~';
	
	function strikethrough(eat, value, silent) {
	  var self = this;
	  var character = '';
	  var previous = '';
	  var preceding = '';
	  var subvalue = '';
	  var index;
	  var length;
	  var now;
	
	  if (
	    !self.options.gfm ||
	    value.charAt(0) !== C_TILDE ||
	    value.charAt(1) !== C_TILDE ||
	    whitespace(value.charAt(2))
	  ) {
	    return;
	  }
	
	  index = 1;
	  length = value.length;
	  now = eat.now();
	  now.column += 2;
	  now.offset += 2;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (
	      character === C_TILDE &&
	      previous === C_TILDE &&
	      (!preceding || !whitespace(preceding))
	    ) {
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      return eat(DOUBLE + subvalue + DOUBLE)({
	        type: 'delete',
	        children: self.tokenizeInline(subvalue, now)
	      });
	    }
	
	    subvalue += previous;
	    preceding = previous;
	    previous = character;
	  }
	}


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(41);
	var word = __webpack_require__(395);
	var whitespace = __webpack_require__(10);
	var locate = __webpack_require__(587);
	
	module.exports = emphasis;
	emphasis.locator = locate;
	
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	
	function emphasis(eat, value, silent) {
	  var self = this;
	  var index = 0;
	  var character = value.charAt(index);
	  var now;
	  var pedantic;
	  var marker;
	  var queue;
	  var subvalue;
	  var length;
	  var prev;
	
	  if (character !== C_ASTERISK && character !== C_UNDERSCORE) {
	    return;
	  }
	
	  pedantic = self.options.pedantic;
	  subvalue = character;
	  marker = character;
	  length = value.length;
	  index++;
	  queue = '';
	  character = '';
	
	  if (pedantic && whitespace(value.charAt(index))) {
	    return;
	  }
	
	  while (index < length) {
	    prev = character;
	    character = value.charAt(index);
	
	    if (character === marker && (!pedantic || !whitespace(prev))) {
	      character = value.charAt(++index);
	
	      if (character !== marker) {
	        if (!trim(queue) || prev === marker) {
	          return;
	        }
	
	        if (!pedantic && marker === C_UNDERSCORE && word(character)) {
	          queue += marker;
	          continue;
	        }
	
	        /* istanbul ignore if - never used (yet) */
	        if (silent) {
	          return true;
	        }
	
	        now = eat.now();
	        now.column++;
	        now.offset++;
	
	        return eat(subvalue + queue + marker)({
	          type: 'emphasis',
	          children: self.tokenizeInline(queue, now)
	        });
	      }
	
	      queue += marker;
	    }
	
	    if (!pedantic && character === '\\') {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    queue += character;
	    index++;
	  }
	}


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var locate = __webpack_require__(588);
	
	module.exports = escape;
	escape.locator = locate;
	
	function escape(eat, value, silent) {
	  var self = this;
	  var character;
	  var node;
	
	  if (value.charAt(0) === '\\') {
	    character = value.charAt(1);
	
	    if (self.escape.indexOf(character) !== -1) {
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      if (character === '\n') {
	        node = {type: 'break'};
	      } else {
	        node = {
	          type: 'text',
	          value: character
	        };
	      }
	
	      return eat('\\' + character)(node);
	    }
	  }
	}


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(10);
	var normalize = __webpack_require__(119);
	
	module.exports = footnoteDefinition;
	footnoteDefinition.notInList = true;
	footnoteDefinition.notInBlock = true;
	
	var C_BACKSLASH = '\\';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_CARET = '^';
	var C_COLON = ':';
	
	var EXPRESSION_INITIAL_TAB = /^( {4}|\t)?/gm;
	
	function footnoteDefinition(eat, value, silent) {
	  var self = this;
	  var offsets = self.offset;
	  var index;
	  var length;
	  var subvalue;
	  var now;
	  var currentLine;
	  var content;
	  var queue;
	  var subqueue;
	  var character;
	  var identifier;
	  var add;
	  var exit;
	
	  if (!self.options.footnotes) {
	    return;
	  }
	
	  index = 0;
	  length = value.length;
	  subvalue = '';
	  now = eat.now();
	  currentLine = now.line;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  if (
	    value.charAt(index) !== C_BRACKET_OPEN ||
	    value.charAt(index + 1) !== C_CARET
	  ) {
	    return;
	  }
	
	  subvalue += C_BRACKET_OPEN + C_CARET;
	  index = subvalue.length;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_CLOSE) {
	      break;
	    } else if (character === C_BACKSLASH) {
	      queue += character;
	      index++;
	      character = value.charAt(index);
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (
	    !queue ||
	    value.charAt(index) !== C_BRACKET_CLOSE ||
	    value.charAt(index + 1) !== C_COLON
	  ) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  identifier = normalize(queue);
	  subvalue += queue + C_BRACKET_CLOSE + C_COLON;
	  index = subvalue.length;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	  queue = '';
	  content = '';
	  subqueue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_NEWLINE) {
	      subqueue = character;
	      index++;
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character !== C_NEWLINE) {
	          break;
	        }
	
	        subqueue += character;
	        index++;
	      }
	
	      queue += subqueue;
	      subqueue = '';
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character !== C_SPACE) {
	          break;
	        }
	
	        subqueue += character;
	        index++;
	      }
	
	      if (subqueue.length === 0) {
	        break;
	      }
	
	      queue += subqueue;
	    }
	
	    if (queue) {
	      content += queue;
	      queue = '';
	    }
	
	    content += character;
	    index++;
	  }
	
	  subvalue += content;
	
	  content = content.replace(EXPRESSION_INITIAL_TAB, function (line) {
	    offsets[currentLine] = (offsets[currentLine] || 0) + line.length;
	    currentLine++;
	
	    return '';
	  });
	
	  add = eat(subvalue);
	
	  exit = self.enterBlock();
	  content = self.tokenizeBlock(content, now);
	  exit();
	
	  return add({
	    type: 'footnoteDefinition',
	    identifier: identifier,
	    children: content
	  });
	}


/***/ }),
/* 605 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = atxHeading;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_HASH = '#';
	
	var MAX_ATX_COUNT = 6;
	
	function atxHeading(eat, value, silent) {
	  var self = this;
	  var settings = self.options;
	  var length = value.length + 1;
	  var index = -1;
	  var now = eat.now();
	  var subvalue = '';
	  var content = '';
	  var character;
	  var queue;
	  var depth;
	
	  /* Eat initial spacing. */
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      index--;
	      break;
	    }
	
	    subvalue += character;
	  }
	
	  /* Eat hashes. */
	  depth = 0;
	
	  while (++index <= length) {
	    character = value.charAt(index);
	
	    if (character !== C_HASH) {
	      index--;
	      break;
	    }
	
	    subvalue += character;
	    depth++;
	  }
	
	  if (depth > MAX_ATX_COUNT) {
	    return;
	  }
	
	  if (
	    !depth ||
	    (!settings.pedantic && value.charAt(index + 1) === C_HASH)
	  ) {
	    return;
	  }
	
	  length = value.length + 1;
	
	  /* Eat intermediate white-space. */
	  queue = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      index--;
	      break;
	    }
	
	    queue += character;
	  }
	
	  /* Exit when not in pedantic mode without spacing. */
	  if (
	    !settings.pedantic &&
	    queue.length === 0 &&
	    character &&
	    character !== C_NEWLINE
	  ) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  /* Eat content. */
	  subvalue += queue;
	  queue = '';
	  content = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (!character || character === C_NEWLINE) {
	      break;
	    }
	
	    if (
	      character !== C_SPACE &&
	      character !== C_TAB &&
	      character !== C_HASH
	    ) {
	      content += queue + character;
	      queue = '';
	      continue;
	    }
	
	    while (character === C_SPACE || character === C_TAB) {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    while (character === C_HASH) {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    while (character === C_SPACE || character === C_TAB) {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    index--;
	  }
	
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	  subvalue += content + queue;
	
	  return eat(subvalue)({
	    type: 'heading',
	    depth: depth,
	    children: self.tokenizeInline(content, now)
	  });
	}


/***/ }),
/* 606 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = setextHeading;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_EQUALS = '=';
	var C_DASH = '-';
	
	var MAX_HEADING_INDENT = 3;
	
	/* Map of characters which can be used to mark setext
	 * headers, mapping to their corresponding depth. */
	var SETEXT_MARKERS = {};
	
	SETEXT_MARKERS[C_EQUALS] = 1;
	SETEXT_MARKERS[C_DASH] = 2;
	
	function setextHeading(eat, value, silent) {
	  var self = this;
	  var now = eat.now();
	  var length = value.length;
	  var index = -1;
	  var subvalue = '';
	  var content;
	  var queue;
	  var character;
	  var marker;
	  var depth;
	
	  /* Eat initial indentation. */
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE || index >= MAX_HEADING_INDENT) {
	      index--;
	      break;
	    }
	
	    subvalue += character;
	  }
	
	  /* Eat content. */
	  content = '';
	  queue = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character === C_NEWLINE) {
	      index--;
	      break;
	    }
	
	    if (character === C_SPACE || character === C_TAB) {
	      queue += character;
	    } else {
	      content += queue + character;
	      queue = '';
	    }
	  }
	
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	  subvalue += content + queue;
	
	  /* Ensure the content is followed by a newline and a
	   * valid marker. */
	  character = value.charAt(++index);
	  marker = value.charAt(++index);
	
	  if (character !== C_NEWLINE || !SETEXT_MARKERS[marker]) {
	    return;
	  }
	
	  subvalue += character;
	
	  /* Eat Setext-line. */
	  queue = marker;
	  depth = SETEXT_MARKERS[marker];
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== marker) {
	      if (character !== C_NEWLINE) {
	        return;
	      }
	
	      index--;
	      break;
	    }
	
	    queue += character;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  return eat(subvalue + queue)({
	    type: 'heading',
	    depth: depth,
	    children: self.tokenizeInline(content, now)
	  });
	}


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var openCloseTag = __webpack_require__(199).openCloseTag;
	
	module.exports = blockHTML;
	
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_LT = '<';
	
	function blockHTML(eat, value, silent) {
	  var self = this;
	  var blocks = self.options.blocks;
	  var length = value.length;
	  var index = 0;
	  var next;
	  var line;
	  var offset;
	  var character;
	  var count;
	  var sequence;
	  var subvalue;
	
	  var sequences = [
	    [/^<(script|pre|style)(?=(\s|>|$))/i, /<\/(script|pre|style)>/i, true],
	    [/^<!--/, /-->/, true],
	    [/^<\?/, /\?>/, true],
	    [/^<![A-Za-z]/, />/, true],
	    [/^<!\[CDATA\[/, /\]\]>/, true],
	    [new RegExp('^</?(' + blocks.join('|') + ')(?=(\\s|/?>|$))', 'i'), /^$/, true],
	    [new RegExp(openCloseTag.source + '\\s*$'), /^$/, false]
	  ];
	
	  /* Eat initial spacing. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    index++;
	  }
	
	  if (value.charAt(index) !== C_LT) {
	    return;
	  }
	
	  next = value.indexOf(C_NEWLINE, index + 1);
	  next = next === -1 ? length : next;
	  line = value.slice(index, next);
	  offset = -1;
	  count = sequences.length;
	
	  while (++offset < count) {
	    if (sequences[offset][0].test(line)) {
	      sequence = sequences[offset];
	      break;
	    }
	  }
	
	  if (!sequence) {
	    return;
	  }
	
	  if (silent) {
	    return sequence[2];
	  }
	
	  index = next;
	
	  if (!sequence[1].test(line)) {
	    while (index < length) {
	      next = value.indexOf(C_NEWLINE, index + 1);
	      next = next === -1 ? length : next;
	      line = value.slice(index + 1, next);
	
	      if (sequence[1].test(line)) {
	        if (line) {
	          index = next;
	        }
	
	        break;
	      }
	
	      index = next;
	    }
	  }
	
	  subvalue = value.slice(0, index);
	
	  return eat(subvalue)({type: 'html', value: subvalue});
	}


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var alphabetical = __webpack_require__(156);
	var locate = __webpack_require__(197);
	var tag = __webpack_require__(199).tag;
	
	module.exports = inlineHTML;
	inlineHTML.locator = locate;
	
	var EXPRESSION_HTML_LINK_OPEN = /^<a /i;
	var EXPRESSION_HTML_LINK_CLOSE = /^<\/a>/i;
	
	function inlineHTML(eat, value, silent) {
	  var self = this;
	  var length = value.length;
	  var character;
	  var subvalue;
	
	  if (value.charAt(0) !== '<' || length < 3) {
	    return;
	  }
	
	  character = value.charAt(1);
	
	  if (
	    !alphabetical(character) &&
	    character !== '?' &&
	    character !== '!' &&
	    character !== '/'
	  ) {
	    return;
	  }
	
	  subvalue = value.match(tag);
	
	  if (!subvalue) {
	    return;
	  }
	
	  /* istanbul ignore if - not used yet. */
	  if (silent) {
	    return true;
	  }
	
	  subvalue = subvalue[0];
	
	  if (!self.inLink && EXPRESSION_HTML_LINK_OPEN.test(subvalue)) {
	    self.inLink = true;
	  } else if (self.inLink && EXPRESSION_HTML_LINK_CLOSE.test(subvalue)) {
	    self.inLink = false;
	  }
	
	  return eat(subvalue)({type: 'html', value: subvalue});
	}


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(10);
	var locate = __webpack_require__(196);
	
	module.exports = link;
	link.locator = locate;
	
	var own = {}.hasOwnProperty;
	
	var C_BACKSLASH = '\\';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_PAREN_OPEN = '(';
	var C_PAREN_CLOSE = ')';
	var C_LT = '<';
	var C_GT = '>';
	var C_TICK = '`';
	var C_DOUBLE_QUOTE = '"';
	var C_SINGLE_QUOTE = '\'';
	
	/* Map of characters, which can be used to mark link
	 * and image titles. */
	var LINK_MARKERS = {};
	
	LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
	LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;
	
	/* Map of characters, which can be used to mark link
	 * and image titles in commonmark-mode. */
	var COMMONMARK_LINK_MARKERS = {};
	
	COMMONMARK_LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
	COMMONMARK_LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;
	COMMONMARK_LINK_MARKERS[C_PAREN_OPEN] = C_PAREN_CLOSE;
	
	function link(eat, value, silent) {
	  var self = this;
	  var subvalue = '';
	  var index = 0;
	  var character = value.charAt(0);
	  var pedantic = self.options.pedantic;
	  var commonmark = self.options.commonmark;
	  var gfm = self.options.gfm;
	  var closed;
	  var count;
	  var opening;
	  var beforeURL;
	  var beforeTitle;
	  var subqueue;
	  var hasMarker;
	  var markers;
	  var isImage;
	  var content;
	  var marker;
	  var length;
	  var title;
	  var depth;
	  var queue;
	  var url;
	  var now;
	  var exit;
	  var node;
	
	  /* Detect whether this is an image. */
	  if (character === '!') {
	    isImage = true;
	    subvalue = character;
	    character = value.charAt(++index);
	  }
	
	  /* Eat the opening. */
	  if (character !== C_BRACKET_OPEN) {
	    return;
	  }
	
	  /* Exit when this is a link and we’re already inside
	   * a link. */
	  if (!isImage && self.inLink) {
	    return;
	  }
	
	  subvalue += character;
	  queue = '';
	  index++;
	
	  /* Eat the content. */
	  length = value.length;
	  now = eat.now();
	  depth = 0;
	
	  now.column += index;
	  now.offset += index;
	
	  while (index < length) {
	    character = value.charAt(index);
	    subqueue = character;
	
	    if (character === C_TICK) {
	      /* Inline-code in link content. */
	      count = 1;
	
	      while (value.charAt(index + 1) === C_TICK) {
	        subqueue += character;
	        index++;
	        count++;
	      }
	
	      if (!opening) {
	        opening = count;
	      } else if (count >= opening) {
	        opening = 0;
	      }
	    } else if (character === C_BACKSLASH) {
	      /* Allow brackets to be escaped. */
	      index++;
	      subqueue += value.charAt(index);
	    /* In GFM mode, brackets in code still count.
	     * In all other modes, they don’t.  This empty
	     * block prevents the next statements are
	     * entered. */
	    } else if ((!opening || gfm) && character === C_BRACKET_OPEN) {
	      depth++;
	    } else if ((!opening || gfm) && character === C_BRACKET_CLOSE) {
	      if (depth) {
	        depth--;
	      } else {
	        /* Allow white-space between content and
	         * url in GFM mode. */
	        if (!pedantic) {
	          while (index < length) {
	            character = value.charAt(index + 1);
	
	            if (!whitespace(character)) {
	              break;
	            }
	
	            subqueue += character;
	            index++;
	          }
	        }
	
	        if (value.charAt(index + 1) !== C_PAREN_OPEN) {
	          return;
	        }
	
	        subqueue += C_PAREN_OPEN;
	        closed = true;
	        index++;
	
	        break;
	      }
	    }
	
	    queue += subqueue;
	    subqueue = '';
	    index++;
	  }
	
	  /* Eat the content closing. */
	  if (!closed) {
	    return;
	  }
	
	  content = queue;
	  subvalue += queue + subqueue;
	  index++;
	
	  /* Eat white-space. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  /* Eat the URL. */
	  character = value.charAt(index);
	  markers = commonmark ? COMMONMARK_LINK_MARKERS : LINK_MARKERS;
	  queue = '';
	  beforeURL = subvalue;
	
	  if (character === C_LT) {
	    index++;
	    beforeURL += C_LT;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === C_GT) {
	        break;
	      }
	
	      if (commonmark && character === '\n') {
	        return;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    if (value.charAt(index) !== C_GT) {
	      return;
	    }
	
	    subvalue += C_LT + queue + C_GT;
	    url = queue;
	    index++;
	  } else {
	    character = null;
	    subqueue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (subqueue && own.call(markers, character)) {
	        break;
	      }
	
	      if (whitespace(character)) {
	        if (!pedantic) {
	          break;
	        }
	
	        subqueue += character;
	      } else {
	        if (character === C_PAREN_OPEN) {
	          depth++;
	        } else if (character === C_PAREN_CLOSE) {
	          if (depth === 0) {
	            break;
	          }
	
	          depth--;
	        }
	
	        queue += subqueue;
	        subqueue = '';
	
	        if (character === C_BACKSLASH) {
	          queue += C_BACKSLASH;
	          character = value.charAt(++index);
	        }
	
	        queue += character;
	      }
	
	      index++;
	    }
	
	    subvalue += queue;
	    url = queue;
	    index = subvalue.length;
	  }
	
	  /* Eat white-space. */
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	  subvalue += queue;
	
	  /* Eat the title. */
	  if (queue && own.call(markers, character)) {
	    index++;
	    subvalue += character;
	    queue = '';
	    marker = markers[character];
	    beforeTitle = subvalue;
	
	    /* In commonmark-mode, things are pretty easy: the
	     * marker cannot occur inside the title.
	     *
	     * Non-commonmark does, however, support nested
	     * delimiters. */
	    if (commonmark) {
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character === marker) {
	          break;
	        }
	
	        if (character === C_BACKSLASH) {
	          queue += C_BACKSLASH;
	          character = value.charAt(++index);
	        }
	
	        index++;
	        queue += character;
	      }
	
	      character = value.charAt(index);
	
	      if (character !== marker) {
	        return;
	      }
	
	      title = queue;
	      subvalue += queue + character;
	      index++;
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (!whitespace(character)) {
	          break;
	        }
	
	        subvalue += character;
	        index++;
	      }
	    } else {
	      subqueue = '';
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character === marker) {
	          if (hasMarker) {
	            queue += marker + subqueue;
	            subqueue = '';
	          }
	
	          hasMarker = true;
	        } else if (!hasMarker) {
	          queue += character;
	        } else if (character === C_PAREN_CLOSE) {
	          subvalue += queue + marker + subqueue;
	          title = queue;
	          break;
	        } else if (whitespace(character)) {
	          subqueue += character;
	        } else {
	          queue += marker + subqueue + character;
	          subqueue = '';
	          hasMarker = false;
	        }
	
	        index++;
	      }
	    }
	  }
	
	  if (value.charAt(index) !== C_PAREN_CLOSE) {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  subvalue += C_PAREN_CLOSE;
	
	  url = self.decode.raw(self.unescape(url), eat(beforeURL).test().end, {nonTerminated: false});
	
	  if (title) {
	    beforeTitle = eat(beforeTitle).test().end;
	    title = self.decode.raw(self.unescape(title), beforeTitle);
	  }
	
	  node = {
	    type: isImage ? 'image' : 'link',
	    title: title || null,
	    url: url
	  };
	
	  if (isImage) {
	    node.alt = self.decode.raw(self.unescape(content), now) || null;
	  } else {
	    exit = self.enterLink();
	    node.children = self.tokenizeInline(content, now);
	    exit();
	  }
	
	  return eat(subvalue)(node);
	}


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable max-params */
	
	var trim = __webpack_require__(41);
	var repeat = __webpack_require__(120);
	var decimal = __webpack_require__(69);
	var getIndent = __webpack_require__(198);
	var removeIndent = __webpack_require__(621);
	var interrupt = __webpack_require__(118);
	
	module.exports = list;
	
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	var C_PLUS = '+';
	var C_DASH = '-';
	var C_DOT = '.';
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_PAREN_CLOSE = ')';
	var C_X_LOWER = 'x';
	
	var TAB_SIZE = 4;
	var EXPRESSION_LOOSE_LIST_ITEM = /\n\n(?!\s*$)/;
	var EXPRESSION_TASK_ITEM = /^\[([ \t]|x|X)][ \t]/;
	var EXPRESSION_BULLET = /^([ \t]*)([*+-]|\d+[.)])( {1,4}(?! )| |\t|$|(?=\n))([^\n]*)/;
	var EXPRESSION_PEDANTIC_BULLET = /^([ \t]*)([*+-]|\d+[.)])([ \t]+)/;
	var EXPRESSION_INITIAL_INDENT = /^( {1,4}|\t)?/gm;
	
	/* Map of characters which can be used to mark
	 * list-items. */
	var LIST_UNORDERED_MARKERS = {};
	
	LIST_UNORDERED_MARKERS[C_ASTERISK] = true;
	LIST_UNORDERED_MARKERS[C_PLUS] = true;
	LIST_UNORDERED_MARKERS[C_DASH] = true;
	
	/* Map of characters which can be used to mark
	 * list-items after a digit. */
	var LIST_ORDERED_MARKERS = {};
	
	LIST_ORDERED_MARKERS[C_DOT] = true;
	
	/* Map of characters which can be used to mark
	 * list-items after a digit. */
	var LIST_ORDERED_COMMONMARK_MARKERS = {};
	
	LIST_ORDERED_COMMONMARK_MARKERS[C_DOT] = true;
	LIST_ORDERED_COMMONMARK_MARKERS[C_PAREN_CLOSE] = true;
	
	function list(eat, value, silent) {
	  var self = this;
	  var commonmark = self.options.commonmark;
	  var pedantic = self.options.pedantic;
	  var tokenizers = self.blockTokenizers;
	  var interuptors = self.interruptList;
	  var markers;
	  var index = 0;
	  var length = value.length;
	  var start = null;
	  var size = 0;
	  var queue;
	  var ordered;
	  var character;
	  var marker;
	  var nextIndex;
	  var startIndex;
	  var prefixed;
	  var currentMarker;
	  var content;
	  var line;
	  var prevEmpty;
	  var empty;
	  var items;
	  var allLines;
	  var emptyLines;
	  var item;
	  var enterTop;
	  var exitBlockquote;
	  var isLoose;
	  var node;
	  var now;
	  var end;
	  var indented;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_TAB) {
	      size += TAB_SIZE - (size % TAB_SIZE);
	    } else if (character === C_SPACE) {
	      size++;
	    } else {
	      break;
	    }
	
	    index++;
	  }
	
	  if (size >= TAB_SIZE) {
	    return;
	  }
	
	  character = value.charAt(index);
	
	  markers = commonmark ?
	    LIST_ORDERED_COMMONMARK_MARKERS :
	    LIST_ORDERED_MARKERS;
	
	  if (LIST_UNORDERED_MARKERS[character] === true) {
	    marker = character;
	    ordered = false;
	  } else {
	    ordered = true;
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (!decimal(character)) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (!queue || markers[character] !== true) {
	      return;
	    }
	
	    start = parseInt(queue, 10);
	    marker = character;
	  }
	
	  character = value.charAt(++index);
	
	  if (character !== C_SPACE && character !== C_TAB) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  index = 0;
	  items = [];
	  allLines = [];
	  emptyLines = [];
	
	  while (index < length) {
	    nextIndex = value.indexOf(C_NEWLINE, index);
	    startIndex = index;
	    prefixed = false;
	    indented = false;
	
	    if (nextIndex === -1) {
	      nextIndex = length;
	    }
	
	    end = index + TAB_SIZE;
	    size = 0;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === C_TAB) {
	        size += TAB_SIZE - (size % TAB_SIZE);
	      } else if (character === C_SPACE) {
	        size++;
	      } else {
	        break;
	      }
	
	      index++;
	    }
	
	    if (size >= TAB_SIZE) {
	      indented = true;
	    }
	
	    if (item && size >= item.indent) {
	      indented = true;
	    }
	
	    character = value.charAt(index);
	    currentMarker = null;
	
	    if (!indented) {
	      if (LIST_UNORDERED_MARKERS[character] === true) {
	        currentMarker = character;
	        index++;
	        size++;
	      } else {
	        queue = '';
	
	        while (index < length) {
	          character = value.charAt(index);
	
	          if (!decimal(character)) {
	            break;
	          }
	
	          queue += character;
	          index++;
	        }
	
	        character = value.charAt(index);
	        index++;
	
	        if (queue && markers[character] === true) {
	          currentMarker = character;
	          size += queue.length + 1;
	        }
	      }
	
	      if (currentMarker) {
	        character = value.charAt(index);
	
	        if (character === C_TAB) {
	          size += TAB_SIZE - (size % TAB_SIZE);
	          index++;
	        } else if (character === C_SPACE) {
	          end = index + TAB_SIZE;
	
	          while (index < end) {
	            if (value.charAt(index) !== C_SPACE) {
	              break;
	            }
	
	            index++;
	            size++;
	          }
	
	          if (index === end && value.charAt(index) === C_SPACE) {
	            index -= TAB_SIZE - 1;
	            size -= TAB_SIZE - 1;
	          }
	        } else if (character !== C_NEWLINE && character !== '') {
	          currentMarker = null;
	        }
	      }
	    }
	
	    if (currentMarker) {
	      if (!pedantic && marker !== currentMarker) {
	        break;
	      }
	
	      prefixed = true;
	    } else {
	      if (!commonmark && !indented && value.charAt(startIndex) === C_SPACE) {
	        indented = true;
	      } else if (commonmark && item) {
	        indented = size >= item.indent || size > TAB_SIZE;
	      }
	
	      prefixed = false;
	      index = startIndex;
	    }
	
	    line = value.slice(startIndex, nextIndex);
	    content = startIndex === index ? line : value.slice(index, nextIndex);
	
	    if (
	      currentMarker === C_ASTERISK ||
	      currentMarker === C_UNDERSCORE ||
	      currentMarker === C_DASH
	    ) {
	      if (tokenizers.thematicBreak.call(self, eat, line, true)) {
	        break;
	      }
	    }
	
	    prevEmpty = empty;
	    empty = !trim(content).length;
	
	    if (indented && item) {
	      item.value = item.value.concat(emptyLines, line);
	      allLines = allLines.concat(emptyLines, line);
	      emptyLines = [];
	    } else if (prefixed) {
	      if (emptyLines.length !== 0) {
	        item.value.push('');
	        item.trail = emptyLines.concat();
	      }
	
	      item = {
	        value: [line],
	        indent: size,
	        trail: []
	      };
	
	      items.push(item);
	      allLines = allLines.concat(emptyLines, line);
	      emptyLines = [];
	    } else if (empty) {
	      if (prevEmpty) {
	        break;
	      }
	
	      emptyLines.push(line);
	    } else {
	      if (prevEmpty) {
	        break;
	      }
	
	      if (interrupt(interuptors, tokenizers, self, [eat, line, true])) {
	        break;
	      }
	
	      item.value = item.value.concat(emptyLines, line);
	      allLines = allLines.concat(emptyLines, line);
	      emptyLines = [];
	    }
	
	    index = nextIndex + 1;
	  }
	
	  node = eat(allLines.join(C_NEWLINE)).reset({
	    type: 'list',
	    ordered: ordered,
	    start: start,
	    loose: null,
	    children: []
	  });
	
	  enterTop = self.enterList();
	  exitBlockquote = self.enterBlock();
	  isLoose = false;
	  index = -1;
	  length = items.length;
	
	  while (++index < length) {
	    item = items[index].value.join(C_NEWLINE);
	    now = eat.now();
	
	    item = eat(item)(listItem(self, item, now), node);
	
	    if (item.loose) {
	      isLoose = true;
	    }
	
	    item = items[index].trail.join(C_NEWLINE);
	
	    if (index !== length - 1) {
	      item += C_NEWLINE;
	    }
	
	    eat(item);
	  }
	
	  enterTop();
	  exitBlockquote();
	
	  node.loose = isLoose;
	
	  return node;
	}
	
	function listItem(ctx, value, position) {
	  var offsets = ctx.offset;
	  var fn = ctx.options.pedantic ? pedanticListItem : normalListItem;
	  var checked = null;
	  var task;
	  var indent;
	
	  value = fn.apply(null, arguments);
	
	  if (ctx.options.gfm) {
	    task = value.match(EXPRESSION_TASK_ITEM);
	
	    if (task) {
	      indent = task[0].length;
	      checked = task[1].toLowerCase() === C_X_LOWER;
	      offsets[position.line] += indent;
	      value = value.slice(indent);
	    }
	  }
	
	  return {
	    type: 'listItem',
	    loose: EXPRESSION_LOOSE_LIST_ITEM.test(value) ||
	      value.charAt(value.length - 1) === C_NEWLINE,
	    checked: checked,
	    children: ctx.tokenizeBlock(value, position)
	  };
	}
	
	/* Create a list-item using overly simple mechanics. */
	function pedanticListItem(ctx, value, position) {
	  var offsets = ctx.offset;
	  var line = position.line;
	
	  /* Remove the list-item’s bullet. */
	  value = value.replace(EXPRESSION_PEDANTIC_BULLET, replacer);
	
	  /* The initial line was also matched by the below, so
	   * we reset the `line`. */
	  line = position.line;
	
	  return value.replace(EXPRESSION_INITIAL_INDENT, replacer);
	
	  /* A simple replacer which removed all matches,
	   * and adds their length to `offset`. */
	  function replacer($0) {
	    offsets[line] = (offsets[line] || 0) + $0.length;
	    line++;
	
	    return '';
	  }
	}
	
	/* Create a list-item using sane mechanics. */
	function normalListItem(ctx, value, position) {
	  var offsets = ctx.offset;
	  var line = position.line;
	  var max;
	  var bullet;
	  var rest;
	  var lines;
	  var trimmedLines;
	  var index;
	  var length;
	
	  /* Remove the list-item’s bullet. */
	  value = value.replace(EXPRESSION_BULLET, replacer);
	
	  lines = value.split(C_NEWLINE);
	
	  trimmedLines = removeIndent(value, getIndent(max).indent).split(C_NEWLINE);
	
	  /* We replaced the initial bullet with something
	   * else above, which was used to trick
	   * `removeIndentation` into removing some more
	   * characters when possible.  However, that could
	   * result in the initial line to be stripped more
	   * than it should be. */
	  trimmedLines[0] = rest;
	
	  offsets[line] = (offsets[line] || 0) + bullet.length;
	  line++;
	
	  index = 0;
	  length = lines.length;
	
	  while (++index < length) {
	    offsets[line] = (offsets[line] || 0) +
	      lines[index].length - trimmedLines[index].length;
	    line++;
	  }
	
	  return trimmedLines.join(C_NEWLINE);
	
	  function replacer($0, $1, $2, $3, $4) {
	    bullet = $1 + $2 + $3;
	    rest = $4;
	
	    /* Make sure that the first nine numbered list items
	     * can indent with an extra space.  That is, when
	     * the bullet did not receive an extra final space. */
	    if (Number($2) < 10 && bullet.length % 2 === 1) {
	      $2 = C_SPACE + $2;
	    }
	
	    max = $1 + repeat(C_SPACE, $2.length) + $3;
	
	    return max + rest;
	  }
	}


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(10);
	
	module.exports = newline;
	
	/* Tokenise newline. */
	function newline(eat, value, silent) {
	  var character = value.charAt(0);
	  var length;
	  var subvalue;
	  var queue;
	  var index;
	
	  if (character !== '\n') {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  index = 1;
	  length = value.length;
	  subvalue = character;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    queue += character;
	
	    if (character === '\n') {
	      subvalue += queue;
	      queue = '';
	    }
	
	    index++;
	  }
	
	  eat(subvalue);
	}


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(41);
	var decimal = __webpack_require__(69);
	var trimTrailingLines = __webpack_require__(121);
	var interrupt = __webpack_require__(118);
	
	module.exports = paragraph;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	
	var TAB_SIZE = 4;
	
	/* Tokenise paragraph. */
	function paragraph(eat, value, silent) {
	  var self = this;
	  var settings = self.options;
	  var commonmark = settings.commonmark;
	  var gfm = settings.gfm;
	  var tokenizers = self.blockTokenizers;
	  var interruptors = self.interruptParagraph;
	  var index = value.indexOf(C_NEWLINE);
	  var length = value.length;
	  var position;
	  var subvalue;
	  var character;
	  var size;
	  var now;
	
	  while (index < length) {
	    /* Eat everything if there’s no following newline. */
	    if (index === -1) {
	      index = length;
	      break;
	    }
	
	    /* Stop if the next character is NEWLINE. */
	    if (value.charAt(index + 1) === C_NEWLINE) {
	      break;
	    }
	
	    /* In commonmark-mode, following indented lines
	     * are part of the paragraph. */
	    if (commonmark) {
	      size = 0;
	      position = index + 1;
	
	      while (position < length) {
	        character = value.charAt(position);
	
	        if (character === C_TAB) {
	          size = TAB_SIZE;
	          break;
	        } else if (character === C_SPACE) {
	          size++;
	        } else {
	          break;
	        }
	
	        position++;
	      }
	
	      if (size >= TAB_SIZE) {
	        index = value.indexOf(C_NEWLINE, index + 1);
	        continue;
	      }
	    }
	
	    subvalue = value.slice(index + 1);
	
	    /* Check if the following code contains a possible
	     * block. */
	    if (interrupt(interruptors, tokenizers, self, [eat, subvalue, true])) {
	      break;
	    }
	
	    /* Break if the following line starts a list, when
	     * already in a list, or when in commonmark, or when
	     * in gfm mode and the bullet is *not* numeric. */
	    if (
	      tokenizers.list.call(self, eat, subvalue, true) &&
	      (
	        self.inList ||
	        commonmark ||
	        (gfm && !decimal(trim.left(subvalue).charAt(0)))
	      )
	    ) {
	      break;
	    }
	
	    position = index;
	    index = value.indexOf(C_NEWLINE, index + 1);
	
	    if (index !== -1 && trim(value.slice(position, index)) === '') {
	      index = position;
	      break;
	    }
	  }
	
	  subvalue = value.slice(0, index);
	
	  if (trim(subvalue) === '') {
	    eat(subvalue);
	
	    return null;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  now = eat.now();
	  subvalue = trimTrailingLines(subvalue);
	
	  return eat(subvalue)({
	    type: 'paragraph',
	    children: self.tokenizeInline(subvalue, now)
	  });
	}


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(10);
	var locate = __webpack_require__(196);
	var normalize = __webpack_require__(119);
	
	module.exports = reference;
	reference.locator = locate;
	
	var T_LINK = 'link';
	var T_IMAGE = 'image';
	var T_FOOTNOTE = 'footnote';
	var REFERENCE_TYPE_SHORTCUT = 'shortcut';
	var REFERENCE_TYPE_COLLAPSED = 'collapsed';
	var REFERENCE_TYPE_FULL = 'full';
	var C_CARET = '^';
	var C_BACKSLASH = '\\';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	
	function reference(eat, value, silent) {
	  var self = this;
	  var character = value.charAt(0);
	  var index = 0;
	  var length = value.length;
	  var subvalue = '';
	  var intro = '';
	  var type = T_LINK;
	  var referenceType = REFERENCE_TYPE_SHORTCUT;
	  var content;
	  var identifier;
	  var now;
	  var node;
	  var exit;
	  var queue;
	  var bracketed;
	  var depth;
	
	  /* Check whether we’re eating an image. */
	  if (character === '!') {
	    type = T_IMAGE;
	    intro = character;
	    character = value.charAt(++index);
	  }
	
	  if (character !== C_BRACKET_OPEN) {
	    return;
	  }
	
	  index++;
	  intro += character;
	  queue = '';
	
	  /* Check whether we’re eating a footnote. */
	  if (self.options.footnotes && value.charAt(index) === C_CARET) {
	    /* Exit if `![^` is found, so the `!` will be seen as text after this,
	     * and we’ll enter this function again when `[^` is found. */
	    if (type === T_IMAGE) {
	      return;
	    }
	
	    intro += C_CARET;
	    index++;
	    type = T_FOOTNOTE;
	  }
	
	  /* Eat the text. */
	  depth = 0;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_OPEN) {
	      bracketed = true;
	      depth++;
	    } else if (character === C_BRACKET_CLOSE) {
	      if (!depth) {
	        break;
	      }
	
	      depth--;
	    }
	
	    if (character === C_BACKSLASH) {
	      queue += C_BACKSLASH;
	      character = value.charAt(++index);
	    }
	
	    queue += character;
	    index++;
	  }
	
	  subvalue = queue;
	  content = queue;
	  character = value.charAt(index);
	
	  if (character !== C_BRACKET_CLOSE) {
	    return;
	  }
	
	  index++;
	  subvalue += character;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  /* Inline footnotes cannot have an identifier. */
	  if (type !== T_FOOTNOTE && character === C_BRACKET_OPEN) {
	    identifier = '';
	    queue += character;
	    index++;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === C_BRACKET_OPEN || character === C_BRACKET_CLOSE) {
	        break;
	      }
	
	      if (character === C_BACKSLASH) {
	        identifier += C_BACKSLASH;
	        character = value.charAt(++index);
	      }
	
	      identifier += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_CLOSE) {
	      referenceType = identifier ? REFERENCE_TYPE_FULL : REFERENCE_TYPE_COLLAPSED;
	      queue += identifier + character;
	      index++;
	    } else {
	      identifier = '';
	    }
	
	    subvalue += queue;
	    queue = '';
	  } else {
	    if (!content) {
	      return;
	    }
	
	    identifier = content;
	  }
	
	  /* Brackets cannot be inside the identifier. */
	  if (referenceType !== REFERENCE_TYPE_FULL && bracketed) {
	    return;
	  }
	
	  subvalue = intro + subvalue;
	
	  if (type === T_LINK && self.inLink) {
	    return null;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  if (type === T_FOOTNOTE && content.indexOf(' ') !== -1) {
	    return eat(subvalue)({
	      type: 'footnote',
	      children: this.tokenizeInline(content, eat.now())
	    });
	  }
	
	  now = eat.now();
	  now.column += intro.length;
	  now.offset += intro.length;
	  identifier = referenceType === REFERENCE_TYPE_FULL ? identifier : content;
	
	  node = {
	    type: type + 'Reference',
	    identifier: normalize(identifier)
	  };
	
	  if (type === T_LINK || type === T_IMAGE) {
	    node.referenceType = referenceType;
	  }
	
	  if (type === T_LINK) {
	    exit = self.enterLink();
	    node.children = self.tokenizeInline(content, now);
	    exit();
	  } else if (type === T_IMAGE) {
	    node.alt = self.decode.raw(self.unescape(content), now) || null;
	  }
	
	  return eat(subvalue)(node);
	}


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(41);
	var whitespace = __webpack_require__(10);
	var locate = __webpack_require__(589);
	
	module.exports = strong;
	strong.locator = locate;
	
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	
	function strong(eat, value, silent) {
	  var self = this;
	  var index = 0;
	  var character = value.charAt(index);
	  var now;
	  var pedantic;
	  var marker;
	  var queue;
	  var subvalue;
	  var length;
	  var prev;
	
	  if (
	    (character !== C_ASTERISK && character !== C_UNDERSCORE) ||
	    value.charAt(++index) !== character
	  ) {
	    return;
	  }
	
	  pedantic = self.options.pedantic;
	  marker = character;
	  subvalue = marker + marker;
	  length = value.length;
	  index++;
	  queue = '';
	  character = '';
	
	  if (pedantic && whitespace(value.charAt(index))) {
	    return;
	  }
	
	  while (index < length) {
	    prev = character;
	    character = value.charAt(index);
	
	    if (
	      character === marker &&
	      value.charAt(index + 1) === marker &&
	      (!pedantic || !whitespace(prev))
	    ) {
	      character = value.charAt(index + 2);
	
	      if (character !== marker) {
	        if (!trim(queue)) {
	          return;
	        }
	
	        /* istanbul ignore if - never used (yet) */
	        if (silent) {
	          return true;
	        }
	
	        now = eat.now();
	        now.column += 2;
	        now.offset += 2;
	
	        return eat(subvalue + queue + subvalue)({
	          type: 'strong',
	          children: self.tokenizeInline(queue, now)
	        });
	      }
	    }
	
	    if (!pedantic && character === '\\') {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    queue += character;
	    index++;
	  }
	}


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(10);
	
	module.exports = table;
	
	var C_BACKSLASH = '\\';
	var C_TICK = '`';
	var C_DASH = '-';
	var C_PIPE = '|';
	var C_COLON = ':';
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	
	var MIN_TABLE_COLUMNS = 1;
	var MIN_TABLE_ROWS = 2;
	
	var TABLE_ALIGN_LEFT = 'left';
	var TABLE_ALIGN_CENTER = 'center';
	var TABLE_ALIGN_RIGHT = 'right';
	var TABLE_ALIGN_NONE = null;
	
	function table(eat, value, silent) {
	  var self = this;
	  var index;
	  var alignments;
	  var alignment;
	  var subvalue;
	  var row;
	  var length;
	  var lines;
	  var queue;
	  var character;
	  var hasDash;
	  var align;
	  var cell;
	  var preamble;
	  var count;
	  var opening;
	  var now;
	  var position;
	  var lineCount;
	  var line;
	  var rows;
	  var table;
	  var lineIndex;
	  var pipeIndex;
	  var first;
	
	  /* Exit when not in gfm-mode. */
	  if (!self.options.gfm) {
	    return;
	  }
	
	  /* Get the rows.
	   * Detecting tables soon is hard, so there are some
	   * checks for performance here, such as the minimum
	   * number of rows, and allowed characters in the
	   * alignment row. */
	  index = 0;
	  lineCount = 0;
	  length = value.length + 1;
	  lines = [];
	
	  while (index < length) {
	    lineIndex = value.indexOf(C_NEWLINE, index);
	    pipeIndex = value.indexOf(C_PIPE, index + 1);
	
	    if (lineIndex === -1) {
	      lineIndex = value.length;
	    }
	
	    if (pipeIndex === -1 || pipeIndex > lineIndex) {
	      if (lineCount < MIN_TABLE_ROWS) {
	        return;
	      }
	
	      break;
	    }
	
	    lines.push(value.slice(index, lineIndex));
	    lineCount++;
	    index = lineIndex + 1;
	  }
	
	  /* Parse the alignment row. */
	  subvalue = lines.join(C_NEWLINE);
	  alignments = lines.splice(1, 1)[0] || [];
	  index = 0;
	  length = alignments.length;
	  lineCount--;
	  alignment = false;
	  align = [];
	
	  while (index < length) {
	    character = alignments.charAt(index);
	
	    if (character === C_PIPE) {
	      hasDash = null;
	
	      if (alignment === false) {
	        if (first === false) {
	          return;
	        }
	      } else {
	        align.push(alignment);
	        alignment = false;
	      }
	
	      first = false;
	    } else if (character === C_DASH) {
	      hasDash = true;
	      alignment = alignment || TABLE_ALIGN_NONE;
	    } else if (character === C_COLON) {
	      if (alignment === TABLE_ALIGN_LEFT) {
	        alignment = TABLE_ALIGN_CENTER;
	      } else if (hasDash && alignment === TABLE_ALIGN_NONE) {
	        alignment = TABLE_ALIGN_RIGHT;
	      } else {
	        alignment = TABLE_ALIGN_LEFT;
	      }
	    } else if (!whitespace(character)) {
	      return;
	    }
	
	    index++;
	  }
	
	  if (alignment !== false) {
	    align.push(alignment);
	  }
	
	  /* Exit when without enough columns. */
	  if (align.length < MIN_TABLE_COLUMNS) {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  /* Parse the rows. */
	  position = -1;
	  rows = [];
	
	  table = eat(subvalue).reset({
	    type: 'table',
	    align: align,
	    children: rows
	  });
	
	  while (++position < lineCount) {
	    line = lines[position];
	    row = {type: 'tableRow', children: []};
	
	    /* Eat a newline character when this is not the
	     * first row. */
	    if (position) {
	      eat(C_NEWLINE);
	    }
	
	    /* Eat the row. */
	    eat(line).reset(row, table);
	
	    length = line.length + 1;
	    index = 0;
	    queue = '';
	    cell = '';
	    preamble = true;
	    count = null;
	    opening = null;
	
	    while (index < length) {
	      character = line.charAt(index);
	
	      if (character === C_TAB || character === C_SPACE) {
	        if (cell) {
	          queue += character;
	        } else {
	          eat(character);
	        }
	
	        index++;
	        continue;
	      }
	
	      if (character === '' || character === C_PIPE) {
	        if (preamble) {
	          eat(character);
	        } else {
	          if (character && opening) {
	            queue += character;
	            index++;
	            continue;
	          }
	
	          if ((cell || character) && !preamble) {
	            subvalue = cell;
	
	            if (queue.length > 1) {
	              if (character) {
	                subvalue += queue.slice(0, queue.length - 1);
	                queue = queue.charAt(queue.length - 1);
	              } else {
	                subvalue += queue;
	                queue = '';
	              }
	            }
	
	            now = eat.now();
	
	            eat(subvalue)({
	              type: 'tableCell',
	              children: self.tokenizeInline(cell, now)
	            }, row);
	          }
	
	          eat(queue + character);
	
	          queue = '';
	          cell = '';
	        }
	      } else {
	        if (queue) {
	          cell += queue;
	          queue = '';
	        }
	
	        cell += character;
	
	        if (character === C_BACKSLASH && index !== length - 2) {
	          cell += line.charAt(index + 1);
	          index++;
	        }
	
	        if (character === C_TICK) {
	          count = 1;
	
	          while (line.charAt(index + 1) === character) {
	            cell += character;
	            index++;
	            count++;
	          }
	
	          if (!opening) {
	            opening = count;
	          } else if (count >= opening) {
	            opening = 0;
	          }
	        }
	      }
	
	      preamble = false;
	      index++;
	    }
	
	    /* Eat the alignment row. */
	    if (!position) {
	      eat(C_NEWLINE + alignments);
	    }
	  }
	
	  return table;
	}


/***/ }),
/* 616 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = text;
	
	function text(eat, value, silent) {
	  var self = this;
	  var methods;
	  var tokenizers;
	  var index;
	  var length;
	  var subvalue;
	  var position;
	  var tokenizer;
	  var name;
	  var min;
	  var now;
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  methods = self.inlineMethods;
	  length = methods.length;
	  tokenizers = self.inlineTokenizers;
	  index = -1;
	  min = value.length;
	
	  while (++index < length) {
	    name = methods[index];
	
	    if (name === 'text' || !tokenizers[name]) {
	      continue;
	    }
	
	    tokenizer = tokenizers[name].locator;
	
	    if (!tokenizer) {
	      eat.file.fail('Missing locator: `' + name + '`');
	    }
	
	    position = tokenizer.call(self, value, 1);
	
	    if (position !== -1 && position < min) {
	      min = position;
	    }
	  }
	
	  subvalue = value.slice(0, min);
	  now = eat.now();
	
	  self.decode(subvalue, now, function (content, position, source) {
	    eat(source || content)({
	      type: 'text',
	      value: content
	    });
	  });
	}


/***/ }),
/* 617 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = thematicBreak;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	var C_DASH = '-';
	
	var THEMATIC_BREAK_MARKER_COUNT = 3;
	
	function thematicBreak(eat, value, silent) {
	  var index = -1;
	  var length = value.length + 1;
	  var subvalue = '';
	  var character;
	  var marker;
	  var markerCount;
	  var queue;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    subvalue += character;
	  }
	
	  if (
	    character !== C_ASTERISK &&
	    character !== C_DASH &&
	    character !== C_UNDERSCORE
	  ) {
	    return;
	  }
	
	  marker = character;
	  subvalue += character;
	  markerCount = 1;
	  queue = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character === marker) {
	      markerCount++;
	      subvalue += queue + marker;
	      queue = '';
	    } else if (character === C_SPACE) {
	      queue += character;
	    } else if (
	      markerCount >= THEMATIC_BREAK_MARKER_COUNT &&
	      (!character || character === C_NEWLINE)
	    ) {
	      subvalue += queue;
	
	      if (silent) {
	        return true;
	      }
	
	      return eat(subvalue)({type: 'thematicBreak'});
	    } else {
	      return;
	    }
	  }
	}


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var decode = __webpack_require__(97);
	var whitespace = __webpack_require__(10);
	var locate = __webpack_require__(590);
	
	module.exports = url;
	url.locator = locate;
	url.notInLink = true;
	
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_PAREN_OPEN = '(';
	var C_PAREN_CLOSE = ')';
	var C_LT = '<';
	var C_AT_SIGN = '@';
	
	var HTTP_PROTOCOL = 'http://';
	var HTTPS_PROTOCOL = 'https://';
	var MAILTO_PROTOCOL = 'mailto:';
	
	var PROTOCOLS = [
	  HTTP_PROTOCOL,
	  HTTPS_PROTOCOL,
	  MAILTO_PROTOCOL
	];
	
	var PROTOCOLS_LENGTH = PROTOCOLS.length;
	
	function url(eat, value, silent) {
	  var self = this;
	  var subvalue;
	  var content;
	  var character;
	  var index;
	  var position;
	  var protocol;
	  var match;
	  var length;
	  var queue;
	  var parenCount;
	  var nextCharacter;
	  var exit;
	
	  if (!self.options.gfm) {
	    return;
	  }
	
	  subvalue = '';
	  index = -1;
	  length = PROTOCOLS_LENGTH;
	
	  while (++index < length) {
	    protocol = PROTOCOLS[index];
	    match = value.slice(0, protocol.length);
	
	    if (match.toLowerCase() === protocol) {
	      subvalue = match;
	      break;
	    }
	  }
	
	  if (!subvalue) {
	    return;
	  }
	
	  index = subvalue.length;
	  length = value.length;
	  queue = '';
	  parenCount = 0;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (whitespace(character) || character === C_LT) {
	      break;
	    }
	
	    if (
	      character === '.' ||
	      character === ',' ||
	      character === ':' ||
	      character === ';' ||
	      character === '"' ||
	      character === '\'' ||
	      character === ')' ||
	      character === ']'
	    ) {
	      nextCharacter = value.charAt(index + 1);
	
	      if (!nextCharacter || whitespace(nextCharacter)) {
	        break;
	      }
	    }
	
	    if (character === C_PAREN_OPEN || character === C_BRACKET_OPEN) {
	      parenCount++;
	    }
	
	    if (character === C_PAREN_CLOSE || character === C_BRACKET_CLOSE) {
	      parenCount--;
	
	      if (parenCount < 0) {
	        break;
	      }
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  subvalue += queue;
	  content = subvalue;
	
	  if (protocol === MAILTO_PROTOCOL) {
	    position = queue.indexOf(C_AT_SIGN);
	
	    if (position === -1 || position === length - 1) {
	      return;
	    }
	
	    content = content.substr(MAILTO_PROTOCOL.length);
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  exit = self.enterLink();
	  content = self.tokenizeInline(content, eat.now());
	  exit();
	
	  return eat(subvalue)({
	    type: 'link',
	    title: null,
	    url: decode(subvalue, {nonTerminated: false}),
	    children: content
	  });
	}


/***/ }),
/* 619 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = factory;
	
	var MERGEABLE_NODES = {
	  text: mergeText,
	  blockquote: mergeBlockquote
	};
	
	/* Check whether a node is mergeable with adjacent nodes. */
	function mergeable(node) {
	  var start;
	  var end;
	
	  if (node.type !== 'text' || !node.position) {
	    return true;
	  }
	
	  start = node.position.start;
	  end = node.position.end;
	
	  /* Only merge nodes which occupy the same size as their
	   * `value`. */
	  return start.line !== end.line ||
	      end.column - start.column === node.value.length;
	}
	
	/* Merge two text nodes: `node` into `prev`. */
	function mergeText(prev, node) {
	  prev.value += node.value;
	
	  return prev;
	}
	
	/* Merge two blockquotes: `node` into `prev`, unless in
	 * CommonMark mode. */
	function mergeBlockquote(prev, node) {
	  if (this.options.commonmark) {
	    return node;
	  }
	
	  prev.children = prev.children.concat(node.children);
	
	  return prev;
	}
	
	/* Construct a tokenizer.  This creates both
	 * `tokenizeInline` and `tokenizeBlock`. */
	function factory(type) {
	  return tokenize;
	
	  /* Tokenizer for a bound `type`. */
	  function tokenize(value, location) {
	    var self = this;
	    var offset = self.offset;
	    var tokens = [];
	    var methods = self[type + 'Methods'];
	    var tokenizers = self[type + 'Tokenizers'];
	    var line = location.line;
	    var column = location.column;
	    var index;
	    var length;
	    var method;
	    var name;
	    var matched;
	    var valueLength;
	
	    /* Trim white space only lines. */
	    if (!value) {
	      return tokens;
	    }
	
	    /* Expose on `eat`. */
	    eat.now = now;
	    eat.file = self.file;
	
	    /* Sync initial offset. */
	    updatePosition('');
	
	    /* Iterate over `value`, and iterate over all
	     * tokenizers.  When one eats something, re-iterate
	     * with the remaining value.  If no tokenizer eats,
	     * something failed (should not happen) and an
	     * exception is thrown. */
	    while (value) {
	      index = -1;
	      length = methods.length;
	      matched = false;
	
	      while (++index < length) {
	        name = methods[index];
	        method = tokenizers[name];
	
	        if (
	          method &&
	          /* istanbul ignore next */ (!method.onlyAtStart || self.atStart) &&
	          (!method.notInList || !self.inList) &&
	          (!method.notInBlock || !self.inBlock) &&
	          (!method.notInLink || !self.inLink)
	        ) {
	          valueLength = value.length;
	
	          method.apply(self, [eat, value]);
	
	          matched = valueLength !== value.length;
	
	          if (matched) {
	            break;
	          }
	        }
	      }
	
	      /* istanbul ignore if */
	      if (!matched) {
	        self.file.fail(new Error('Infinite loop'), eat.now());
	      }
	    }
	
	    self.eof = now();
	
	    return tokens;
	
	    /* Update line, column, and offset based on
	     * `value`. */
	    function updatePosition(subvalue) {
	      var lastIndex = -1;
	      var index = subvalue.indexOf('\n');
	
	      while (index !== -1) {
	        line++;
	        lastIndex = index;
	        index = subvalue.indexOf('\n', index + 1);
	      }
	
	      if (lastIndex === -1) {
	        column += subvalue.length;
	      } else {
	        column = subvalue.length - lastIndex;
	      }
	
	      if (line in offset) {
	        if (lastIndex !== -1) {
	          column += offset[line];
	        } else if (column <= offset[line]) {
	          column = offset[line] + 1;
	        }
	      }
	    }
	
	    /* Get offset.  Called before the first character is
	     * eaten to retrieve the range's offsets. */
	    function getOffset() {
	      var indentation = [];
	      var pos = line + 1;
	
	      /* Done.  Called when the last character is
	       * eaten to retrieve the range’s offsets. */
	      return function () {
	        var last = line + 1;
	
	        while (pos < last) {
	          indentation.push((offset[pos] || 0) + 1);
	
	          pos++;
	        }
	
	        return indentation;
	      };
	    }
	
	    /* Get the current position. */
	    function now() {
	      var pos = {line: line, column: column};
	
	      pos.offset = self.toOffset(pos);
	
	      return pos;
	    }
	
	    /* Store position information for a node. */
	    function Position(start) {
	      this.start = start;
	      this.end = now();
	    }
	
	    /* Throw when a value is incorrectly eaten.
	     * This shouldn’t happen but will throw on new,
	     * incorrect rules. */
	    function validateEat(subvalue) {
	      /* istanbul ignore if */
	      if (value.substring(0, subvalue.length) !== subvalue) {
	        /* Capture stack-trace. */
	        self.file.fail(
	          new Error(
	            'Incorrectly eaten value: please report this ' +
	            'warning on http://git.io/vg5Ft'
	          ),
	          now()
	        );
	      }
	    }
	
	    /* Mark position and patch `node.position`. */
	    function position() {
	      var before = now();
	
	      return update;
	
	      /* Add the position to a node. */
	      function update(node, indent) {
	        var prev = node.position;
	        var start = prev ? prev.start : before;
	        var combined = [];
	        var n = prev && prev.end.line;
	        var l = before.line;
	
	        node.position = new Position(start);
	
	        /* If there was already a `position`, this
	         * node was merged.  Fixing `start` wasn’t
	         * hard, but the indent is different.
	         * Especially because some information, the
	         * indent between `n` and `l` wasn’t
	         * tracked.  Luckily, that space is
	         * (should be?) empty, so we can safely
	         * check for it now. */
	        if (prev && indent && prev.indent) {
	          combined = prev.indent;
	
	          if (n < l) {
	            while (++n < l) {
	              combined.push((offset[n] || 0) + 1);
	            }
	
	            combined.push(before.column);
	          }
	
	          indent = combined.concat(indent);
	        }
	
	        node.position.indent = indent || [];
	
	        return node;
	      }
	    }
	
	    /* Add `node` to `parent`s children or to `tokens`.
	     * Performs merges where possible. */
	    function add(node, parent) {
	      var children = parent ? parent.children : tokens;
	      var prev = children[children.length - 1];
	
	      if (
	        prev &&
	        node.type === prev.type &&
	        node.type in MERGEABLE_NODES &&
	        mergeable(prev) &&
	        mergeable(node)
	      ) {
	        node = MERGEABLE_NODES[node.type].call(self, prev, node);
	      }
	
	      if (node !== prev) {
	        children.push(node);
	      }
	
	      if (self.atStart && tokens.length !== 0) {
	        self.exitStart();
	      }
	
	      return node;
	    }
	
	    /* Remove `subvalue` from `value`.
	     * `subvalue` must be at the start of `value`. */
	    function eat(subvalue) {
	      var indent = getOffset();
	      var pos = position();
	      var current = now();
	
	      validateEat(subvalue);
	
	      apply.reset = reset;
	      reset.test = test;
	      apply.test = test;
	
	      value = value.substring(subvalue.length);
	
	      updatePosition(subvalue);
	
	      indent = indent();
	
	      return apply;
	
	      /* Add the given arguments, add `position` to
	       * the returned node, and return the node. */
	      function apply(node, parent) {
	        return pos(add(pos(node), parent), indent);
	      }
	
	      /* Functions just like apply, but resets the
	       * content:  the line and column are reversed,
	       * and the eaten value is re-added.
	       * This is useful for nodes with a single
	       * type of content, such as lists and tables.
	       * See `apply` above for what parameters are
	       * expected. */
	      function reset() {
	        var node = apply.apply(null, arguments);
	
	        line = current.line;
	        column = current.column;
	        value = subvalue + value;
	
	        return node;
	      }
	
	      /* Test the position, after eating, and reverse
	       * to a not-eaten state. */
	      function test() {
	        var result = pos({});
	
	        line = current.line;
	        column = current.column;
	        value = subvalue + value;
	
	        return result.position;
	      }
	    }
	  }
	}


/***/ }),
/* 620 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = factory;
	
	/* Factory to de-escape a value, based on a list at `key`
	 * in `ctx`. */
	function factory(ctx, key) {
	  return unescape;
	
	  /* De-escape a string using the expression at `key`
	   * in `ctx`. */
	  function unescape(value) {
	    var prev = 0;
	    var index = value.indexOf('\\');
	    var escape = ctx[key];
	    var queue = [];
	    var character;
	
	    while (index !== -1) {
	      queue.push(value.slice(prev, index));
	      prev = index + 1;
	      character = value.charAt(prev);
	
	      /* If the following character is not a valid escape,
	       * add the slash. */
	      if (!character || escape.indexOf(character) === -1) {
	        queue.push('\\');
	      }
	
	      index = value.indexOf('\\', prev);
	    }
	
	    queue.push(value.slice(prev));
	
	    return queue.join('');
	  }
	}


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(41);
	var repeat = __webpack_require__(120);
	var getIndent = __webpack_require__(198);
	
	module.exports = indentation;
	
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	
	/* Remove the minimum indent from every line in `value`.
	 * Supports both tab, spaced, and mixed indentation (as
	 * well as possible). */
	function indentation(value, maximum) {
	  var values = value.split(C_NEWLINE);
	  var position = values.length + 1;
	  var minIndent = Infinity;
	  var matrix = [];
	  var index;
	  var indentation;
	  var stops;
	  var padding;
	
	  values.unshift(repeat(C_SPACE, maximum) + '!');
	
	  while (position--) {
	    indentation = getIndent(values[position]);
	
	    matrix[position] = indentation.stops;
	
	    if (trim(values[position]).length === 0) {
	      continue;
	    }
	
	    if (indentation.indent) {
	      if (indentation.indent > 0 && indentation.indent < minIndent) {
	        minIndent = indentation.indent;
	      }
	    } else {
	      minIndent = Infinity;
	
	      break;
	    }
	  }
	
	  if (minIndent !== Infinity) {
	    position = values.length;
	
	    while (position--) {
	      stops = matrix[position];
	      index = minIndent;
	
	      while (index && !(index in stops)) {
	        index--;
	      }
	
	      if (
	        trim(values[position]).length !== 0 &&
	        minIndent &&
	        index !== minIndent
	      ) {
	        padding = C_TAB;
	      } else {
	        padding = '';
	      }
	
	      values[position] = padding + values[position].slice(
	        index in stops ? stops[index] + 1 : 0
	      );
	    }
	  }
	
	  values.shift();
	
	  return values.join(C_NEWLINE);
	}


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var path = __webpack_require__(202);
	
	function replaceExt(npath, ext) {
	  if (typeof npath !== 'string') {
	    return npath;
	  }
	
	  if (npath.length === 0) {
	    return npath;
	  }
	
	  var nFileName = path.basename(npath, path.extname(npath)) + ext;
	  return path.join(path.dirname(npath), nFileName);
	}
	
	module.exports = replaceExt;


/***/ }),
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),
/* 628 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = factory
	
	// Construct a state `toggler`: a function which inverses `property` in context
	// based on its current value.
	// The by `toggler` returned function restores that value.
	function factory(key, state, ctx) {
	  return enter
	
	  function enter() {
	    var context = ctx || this
	    var current = context[key]
	
	    context[key] = !state
	
	    return exit
	
	    function exit() {
	      context[key] = current
	    }
	  }
	}


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(630);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(652)(module)))

/***/ }),
/* 630 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 631 */
/***/ (function(module, exports) {

	'use strict';
	
	//      
	
	/**
	 * We want to represent each subs. type as minimally as possible,
	 * so instead of using strings we just use characters, which lets us
	 * represent 27 individual subs. using a single character each.
	 */
	
	var UserText = 'a';
	var FullMonth = 'b';
	var PartialMonth = 'c';
	var FullYear = 'd';
	var PartialYear = 'e';
	var DayOfTheWeek = 'f';
	var Hour = 'g';
	var Minutes = 'h';
	var Seconds = 'i';
	var PostOrAnteMeridiem = 'j';
	var Day = 'k';
	var DayOfTheMonth = 'l';
	var NumberMonth = 'n';
	var Hour24 = 'm';
	
	var SubToTypeIdentifierMap = {
	  'MMMM': FullMonth,
	  'MM': PartialMonth,
	  'Mo': NumberMonth,
	  'YYYY': FullYear,
	  'YY': PartialYear,
	  'dddd': DayOfTheWeek,
	  'DD': DayOfTheMonth,
	  'Do': Day,
	  'h': Hour,
	  'H': Hour24,
	  'mm': Minutes,
	  'ss': Seconds,
	  'a': PostOrAnteMeridiem
	};
	
	//      
	
	/**
	 * These types help ensure we don't misspell them anywhere. They will be
	 * removed during build.
	 */
	
	var months = ["January", "Febuary", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	
	var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
	
	/**
	 * Takes an integer and returns a string left padded with
	 * a zero to the left. Used to display minutes and hours (1:01:00PM);
	 */
	function paddWithZeros(int) {
	  return int < 10 ? '0' + int : '' + int;
	}
	
	/**
	 * Adds suffix to day, so 16 becomes 16th.
	 */
	function suffix(int) {
	  return int % 10 == 1 && int != 11 ? int + "st" : int % 10 == 2 && int != 12 ? int + "nd" : int % 10 == 3 && int != 13 ? int + "rd" : int + "th";
	}
	
	/**
	 * The compiler takes in our array of tokens returned from the parser
	 * and returns the formed template. It just iterates over the tokens and
	 * appends some text to the returned string depending on the type of token.
	 * @param {Array<Tokens>} tokens
	 * @param {Date} date
	 * @param {TinyTimeOptions} options
	 * @returns {String}
	 */
	function compiler(tokens, date, options) {
	  var month = date.getMonth();
	  var year = date.getFullYear();
	  var hours = date.getHours();
	  var seconds = date.getSeconds();
	  var minutes = date.getMinutes();
	  var day = date.getDate();
	  var compiled = '';
	  var index = 0;
	  while (index < tokens.length) {
	    var token = tokens[index];
	    switch (token.t) {
	      case UserText:
	        // $FlowFixMe flow doesn't know that v is always populated on UserText
	        compiled += token.v;
	        break;
	      case Day:
	        compiled += suffix(day);
	        break;
	      case PartialMonth:
	        compiled += months[month].slice(0, 3);
	        break;
	      case FullMonth:
	        compiled += months[month];
	        break;
	      case NumberMonth:
	        var mnth = month + 1;
	        if (options.padMonth) {
	          mnth = paddWithZeros(mnth);
	        }
	        compiled += mnth;
	        break;
	      case FullYear:
	        compiled += year;
	        break;
	      case PartialYear:
	        compiled += (year + '').slice(2);
	        break;
	      case DayOfTheWeek:
	        compiled += days[date.getDay()];
	        break;
	      case DayOfTheMonth:
	        compiled += options.padDays ? paddWithZeros(day) : day;
	        break;
	      case Hour:
	        var hour = hours === 0 || hours === 12 ? 12 : hours % 12;
	        if (options.padHours) {
	          hour = paddWithZeros(hour);
	        }
	        compiled += hour;
	        break;
	      case Hour24:
	        var hour24 = hours;
	        if (options.padHours) {
	          hour24 = paddWithZeros(hour24);
	        }
	        compiled += hour24;
	        break;
	      case Minutes:
	        compiled += paddWithZeros(minutes);
	        break;
	      case Seconds:
	        compiled += paddWithZeros(seconds);
	        break;
	      case PostOrAnteMeridiem:
	        compiled += hours >= 12 ? 'PM' : 'AM';
	        break;
	    }
	    index++;
	  }
	  return compiled;
	}
	
	//      
	/**
	 * t is type and v is value. Minified property
	 * names are being used because the current minification
	 * step does not mangle property names, and we want to
	 * reduce bundle size as much as possible.
	 */
	
	/**
	 * Rather than using a bunch of potentially confusing regular
	 * expressions to match patterns in templates, we use a simple
	 * parser, taking the aproach of a compiler. This is equivalent
	 * to a lexer as it returns a stream of tokens. Since there is
	 * no additional analysis required for semantics we just call
	 * it a parser.
	 * 
	 * It will return an array of tokens, each corresponding to either
	 * UserText (just text we want to render) or any number of the
	 * subsitution types stored in SubToTypeIdentifierMap.
	 * 
	 */
	function parser(template) {
	  var tokens = [];
	  /**
	   * We iterate through each character in the template string, and track
	   * the index of the character we're processing with `position`. We start
	   * at 0, the first character.
	   */
	  var position = 0;
	  /**
	   * `text` is used to accumulate what we call "UserText", or simply text that
	   * is not a subsitution. For example, in the template:
	   *  
	   *  "The day is {day}."
	   * 
	   * There are two instances of `UserText`, "The day is " and ".", which is the text
	   * befor eand after the subsitution. With this template our tokens would look something like:
	   * 
	   * [
	   *  { type: UserText, value: "The day is "},
	   *  { type : DaySub },
	   *  { type: UserText, value: "." }
	   * ]
	   * 
	   */
	  var text = '';
	  while (position < template.length) {
	    var char = template[position++];
	    /**
	     * A bracket indicates we're starting a subsitution. Any characters after this,
	     * and before the next '}' will be considered part of the subsitution name.
	     */
	    if (char === '{') {
	      // Push any `UserText` we've accumulated and reset the `text` variable.
	      if (text) {
	        tokens.push({
	          t: UserText,
	          v: text
	        });
	      }
	      text = '';
	      var sub = '';
	      char = template[position++];
	      while (char !== '}') {
	        sub += char;
	        char = template[position++];
	      }
	      tokens.push({
	        t: SubToTypeIdentifierMap[sub]
	      });
	    }
	    // Anything not inside brackets is just plain text.
	    else {
	        text += char;
	      }
	  }
	  /**
	   * We might have some text after we're done iterating through the template if
	   * the template ends with some `UserText`.
	   */
	  if (text) {
	    tokens.push({
	      t: UserText,
	      v: text
	    });
	  }
	  return tokens;
	}
	
	//      
	function tinytime(template) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var templateAST = parser(template);
	  return {
	    render: function render(date) {
	      return compiler(templateAST, date, options);
	    }
	  };
	}
	
	module.exports = tinytime;
	//# sourceMappingURL=tinytime.js.map


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var wrap = __webpack_require__(633)
	
	module.exports = trough
	
	trough.wrap = wrap
	
	var slice = [].slice
	
	// Create new middleware.
	function trough() {
	  var fns = []
	  var middleware = {}
	
	  middleware.run = run
	  middleware.use = use
	
	  return middleware
	
	  // Run `fns`.  Last argument must be a completion handler.
	  function run() {
	    var index = -1
	    var input = slice.call(arguments, 0, -1)
	    var done = arguments[arguments.length - 1]
	
	    if (typeof done !== 'function') {
	      throw new Error('Expected function as last argument, not ' + done)
	    }
	
	    next.apply(null, [null].concat(input))
	
	    // Run the next `fn`, if any.
	    function next(err) {
	      var fn = fns[++index]
	      var params = slice.call(arguments, 0)
	      var values = params.slice(1)
	      var length = input.length
	      var pos = -1
	
	      if (err) {
	        done(err)
	        return
	      }
	
	      // Copy non-nully input into values.
	      while (++pos < length) {
	        if (values[pos] === null || values[pos] === undefined) {
	          values[pos] = input[pos]
	        }
	      }
	
	      input = values
	
	      // Next or done.
	      if (fn) {
	        wrap(fn, next).apply(null, input)
	      } else {
	        done.apply(null, [null].concat(input))
	      }
	    }
	  }
	
	  // Add `fn` to the list.
	  function use(fn) {
	    if (typeof fn !== 'function') {
	      throw new Error('Expected `fn` to be a function, not ' + fn)
	    }
	
	    fns.push(fn)
	
	    return middleware
	  }
	}


/***/ }),
/* 633 */
/***/ (function(module, exports) {

	'use strict'
	
	var slice = [].slice
	
	module.exports = wrap
	
	// Wrap `fn`.
	// Can be sync or async; return a promise, receive a completion handler, return
	// new values and errors.
	function wrap(fn, callback) {
	  var invoked
	
	  return wrapped
	
	  function wrapped() {
	    var params = slice.call(arguments, 0)
	    var callback = fn.length > params.length
	    var result
	
	    if (callback) {
	      params.push(done)
	    }
	
	    try {
	      result = fn.apply(null, params)
	    } catch (error) {
	      // Well, this is quite the pickle.
	      // `fn` received a callback and invoked it (thus continuing the pipeline),
	      // but later also threw an error.
	      // We’re not about to restart the pipeline again, so the only thing left
	      // to do is to throw the thing instead.
	      if (callback && invoked) {
	        throw error
	      }
	
	      return done(error)
	    }
	
	    if (!callback) {
	      if (result && typeof result.then === 'function') {
	        result.then(then, done)
	      } else if (result instanceof Error) {
	        done(result)
	      } else {
	        then(result)
	      }
	    }
	  }
	
	  // Invoke `next`, only once.
	  function done() {
	    if (!invoked) {
	      invoked = true
	
	      callback.apply(null, arguments)
	    }
	  }
	
	  // Invoke `done` with one value.
	  // Tracks if an error is passed, too.
	  function then(value) {
	    done(null, value)
	  }
	}


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var xtend = __webpack_require__(20)
	var inherits = __webpack_require__(375)
	
	module.exports = unherit
	
	// Create a custom constructor which can be modified without affecting the
	// original class.
	function unherit(Super) {
	  var result
	  var key
	  var value
	
	  inherits(Of, Super)
	  inherits(From, Of)
	
	  // Clone values.
	  result = Of.prototype
	
	  for (key in result) {
	    value = result[key]
	
	    if (value && typeof value === 'object') {
	      result[key] = 'concat' in value ? value.concat() : xtend(value)
	    }
	  }
	
	  return Of
	
	  // Constructor accepting a single argument, which itself is an `arguments`
	  // object.
	  function From(parameters) {
	    return Super.apply(this, parameters)
	  }
	
	  // Constructor accepting variadic arguments.
	  function Of() {
	    if (!(this instanceof Of)) {
	      return new From(arguments)
	    }
	
	    return Super.apply(this, arguments)
	  }
	}


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict'
	
	/* Dependencies. */
	var extend = __webpack_require__(335)
	var bail = __webpack_require__(266)
	var vfile = __webpack_require__(649)
	var trough = __webpack_require__(632)
	var string = __webpack_require__(653)
	var plain = __webpack_require__(394)
	
	/* Expose a frozen processor. */
	module.exports = unified().freeze()
	
	var slice = [].slice
	var own = {}.hasOwnProperty
	
	/* Process pipeline. */
	var pipeline = trough()
	  .use(pipelineParse)
	  .use(pipelineRun)
	  .use(pipelineStringify)
	
	function pipelineParse(p, ctx) {
	  ctx.tree = p.parse(ctx.file)
	}
	
	function pipelineRun(p, ctx, next) {
	  p.run(ctx.tree, ctx.file, done)
	
	  function done(err, tree, file) {
	    if (err) {
	      next(err)
	    } else {
	      ctx.tree = tree
	      ctx.file = file
	      next()
	    }
	  }
	}
	
	function pipelineStringify(p, ctx) {
	  ctx.file.contents = p.stringify(ctx.tree, ctx.file)
	}
	
	/* Function to create the first processor. */
	function unified() {
	  var attachers = []
	  var transformers = trough()
	  var namespace = {}
	  var frozen = false
	  var freezeIndex = -1
	
	  /* Data management. */
	  processor.data = data
	
	  /* Lock. */
	  processor.freeze = freeze
	
	  /* Plug-ins. */
	  processor.attachers = attachers
	  processor.use = use
	
	  /* API. */
	  processor.parse = parse
	  processor.stringify = stringify
	  processor.run = run
	  processor.runSync = runSync
	  processor.process = process
	  processor.processSync = processSync
	
	  /* Expose. */
	  return processor
	
	  /* Create a new processor based on the processor
	   * in the current scope. */
	  function processor() {
	    var destination = unified()
	    var length = attachers.length
	    var index = -1
	
	    while (++index < length) {
	      destination.use.apply(null, attachers[index])
	    }
	
	    destination.data(extend(true, {}, namespace))
	
	    return destination
	  }
	
	  /* Freeze: used to signal a processor that has finished
	   * configuration.
	   *
	   * For example, take unified itself.  It’s frozen.
	   * Plug-ins should not be added to it.  Rather, it should
	   * be extended, by invoking it, before modifying it.
	   *
	   * In essence, always invoke this when exporting a
	   * processor. */
	  function freeze() {
	    var values
	    var plugin
	    var options
	    var transformer
	
	    if (frozen) {
	      return processor
	    }
	
	    while (++freezeIndex < attachers.length) {
	      values = attachers[freezeIndex]
	      plugin = values[0]
	      options = values[1]
	      transformer = null
	
	      if (options === false) {
	        continue
	      }
	
	      if (options === true) {
	        values[1] = undefined
	      }
	
	      transformer = plugin.apply(processor, values.slice(1))
	
	      if (typeof transformer === 'function') {
	        transformers.use(transformer)
	      }
	    }
	
	    frozen = true
	    freezeIndex = Infinity
	
	    return processor
	  }
	
	  /* Data management.
	   * Getter / setter for processor-specific informtion. */
	  function data(key, value) {
	    if (string(key)) {
	      /* Set `key`. */
	      if (arguments.length === 2) {
	        assertUnfrozen('data', frozen)
	
	        namespace[key] = value
	
	        return processor
	      }
	
	      /* Get `key`. */
	      return (own.call(namespace, key) && namespace[key]) || null
	    }
	
	    /* Set space. */
	    if (key) {
	      assertUnfrozen('data', frozen)
	      namespace = key
	      return processor
	    }
	
	    /* Get space. */
	    return namespace
	  }
	
	  /* Plug-in management.
	   *
	   * Pass it:
	   * *   an attacher and options,
	   * *   a preset,
	   * *   a list of presets, attachers, and arguments (list
	   *     of attachers and options). */
	  function use(value) {
	    var settings
	
	    assertUnfrozen('use', frozen)
	
	    if (value === null || value === undefined) {
	      /* Empty */
	    } else if (typeof value === 'function') {
	      addPlugin.apply(null, arguments)
	    } else if (typeof value === 'object') {
	      if ('length' in value) {
	        addList(value)
	      } else {
	        addPreset(value)
	      }
	    } else {
	      throw new Error('Expected usable value, not `' + value + '`')
	    }
	
	    if (settings) {
	      namespace.settings = extend(namespace.settings || {}, settings)
	    }
	
	    return processor
	
	    function addPreset(result) {
	      addList(result.plugins)
	
	      if (result.settings) {
	        settings = extend(settings || {}, result.settings)
	      }
	    }
	
	    function add(value) {
	      if (typeof value === 'function') {
	        addPlugin(value)
	      } else if (typeof value === 'object') {
	        if ('length' in value) {
	          addPlugin.apply(null, value)
	        } else {
	          addPreset(value)
	        }
	      } else {
	        throw new Error('Expected usable value, not `' + value + '`')
	      }
	    }
	
	    function addList(plugins) {
	      var length
	      var index
	
	      if (plugins === null || plugins === undefined) {
	        /* Empty */
	      } else if (typeof plugins === 'object' && 'length' in plugins) {
	        length = plugins.length
	        index = -1
	
	        while (++index < length) {
	          add(plugins[index])
	        }
	      } else {
	        throw new Error('Expected a list of plugins, not `' + plugins + '`')
	      }
	    }
	
	    function addPlugin(plugin, value) {
	      var entry = find(plugin)
	
	      if (entry) {
	        if (plain(entry[1]) && plain(value)) {
	          value = extend(entry[1], value)
	        }
	
	        entry[1] = value
	      } else {
	        attachers.push(slice.call(arguments))
	      }
	    }
	  }
	
	  function find(plugin) {
	    var length = attachers.length
	    var index = -1
	    var entry
	
	    while (++index < length) {
	      entry = attachers[index]
	
	      if (entry[0] === plugin) {
	        return entry
	      }
	    }
	  }
	
	  /* Parse a file (in string or VFile representation)
	   * into a Unist node using the `Parser` on the
	   * processor. */
	  function parse(doc) {
	    var file = vfile(doc)
	    var Parser
	
	    freeze()
	    Parser = processor.Parser
	    assertParser('parse', Parser)
	
	    if (newable(Parser)) {
	      return new Parser(String(file), file).parse()
	    }
	
	    return Parser(String(file), file) // eslint-disable-line new-cap
	  }
	
	  /* Run transforms on a Unist node representation of a file
	   * (in string or VFile representation), async. */
	  function run(node, file, cb) {
	    assertNode(node)
	    freeze()
	
	    if (!cb && typeof file === 'function') {
	      cb = file
	      file = null
	    }
	
	    if (!cb) {
	      return new Promise(executor)
	    }
	
	    executor(null, cb)
	
	    function executor(resolve, reject) {
	      transformers.run(node, vfile(file), done)
	
	      function done(err, tree, file) {
	        tree = tree || node
	        if (err) {
	          reject(err)
	        } else if (resolve) {
	          resolve(tree)
	        } else {
	          cb(null, tree, file)
	        }
	      }
	    }
	  }
	
	  /* Run transforms on a Unist node representation of a file
	   * (in string or VFile representation), sync. */
	  function runSync(node, file) {
	    var complete = false
	    var result
	
	    run(node, file, done)
	
	    assertDone('runSync', 'run', complete)
	
	    return result
	
	    function done(err, tree) {
	      complete = true
	      bail(err)
	      result = tree
	    }
	  }
	
	  /* Stringify a Unist node representation of a file
	   * (in string or VFile representation) into a string
	   * using the `Compiler` on the processor. */
	  function stringify(node, doc) {
	    var file = vfile(doc)
	    var Compiler
	
	    freeze()
	    Compiler = processor.Compiler
	    assertCompiler('stringify', Compiler)
	    assertNode(node)
	
	    if (newable(Compiler)) {
	      return new Compiler(node, file).compile()
	    }
	
	    return Compiler(node, file) // eslint-disable-line new-cap
	  }
	
	  /* Parse a file (in string or VFile representation)
	   * into a Unist node using the `Parser` on the processor,
	   * then run transforms on that node, and compile the
	   * resulting node using the `Compiler` on the processor,
	   * and store that result on the VFile. */
	  function process(doc, cb) {
	    freeze()
	    assertParser('process', processor.Parser)
	    assertCompiler('process', processor.Compiler)
	
	    if (!cb) {
	      return new Promise(executor)
	    }
	
	    executor(null, cb)
	
	    function executor(resolve, reject) {
	      var file = vfile(doc)
	
	      pipeline.run(processor, {file: file}, done)
	
	      function done(err) {
	        if (err) {
	          reject(err)
	        } else if (resolve) {
	          resolve(file)
	        } else {
	          cb(null, file)
	        }
	      }
	    }
	  }
	
	  /* Process the given document (in string or VFile
	   * representation), sync. */
	  function processSync(doc) {
	    var complete = false
	    var file
	
	    freeze()
	    assertParser('processSync', processor.Parser)
	    assertCompiler('processSync', processor.Compiler)
	    file = vfile(doc)
	
	    process(file, done)
	
	    assertDone('processSync', 'process', complete)
	
	    return file
	
	    function done(err) {
	      complete = true
	      bail(err)
	    }
	  }
	}
	
	/* Check if `func` is a constructor. */
	function newable(value) {
	  return typeof value === 'function' && keys(value.prototype)
	}
	
	/* Check if `value` is an object with keys. */
	function keys(value) {
	  var key
	  for (key in value) {
	    return true
	  }
	  return false
	}
	
	/* Assert a parser is available. */
	function assertParser(name, Parser) {
	  if (typeof Parser !== 'function') {
	    throw new Error('Cannot `' + name + '` without `Parser`')
	  }
	}
	
	/* Assert a compiler is available. */
	function assertCompiler(name, Compiler) {
	  if (typeof Compiler !== 'function') {
	    throw new Error('Cannot `' + name + '` without `Compiler`')
	  }
	}
	
	/* Assert the processor is not frozen. */
	function assertUnfrozen(name, frozen) {
	  if (frozen) {
	    throw new Error(
	      [
	        'Cannot invoke `' + name + '` on a frozen processor.\nCreate a new ',
	        'processor first, by invoking it: use `processor()` instead of ',
	        '`processor`.'
	      ].join('')
	    )
	  }
	}
	
	/* Assert `node` is a Unist node. */
	function assertNode(node) {
	  if (!node || !string(node.type)) {
	    throw new Error('Expected node, got `' + node + '`')
	  }
	}
	
	/* Assert that `complete` is `true`. */
	function assertDone(name, asyncName, complete) {
	  if (!complete) {
	    throw new Error(
	      '`' + name + '` finished async. Use `' + asyncName + '` instead'
	    )
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 636 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = convert
	
	function convert(test) {
	  if (typeof test === 'string') {
	    return typeFactory(test)
	  }
	
	  if (test === null || test === undefined) {
	    return ok
	  }
	
	  if (typeof test === 'object') {
	    return ('length' in test ? anyFactory : matchesFactory)(test)
	  }
	
	  if (typeof test === 'function') {
	    return test
	  }
	
	  throw new Error('Expected function, string, or object as test')
	}
	
	function convertAll(tests) {
	  var results = []
	  var length = tests.length
	  var index = -1
	
	  while (++index < length) {
	    results[index] = convert(tests[index])
	  }
	
	  return results
	}
	
	// Utility assert each property in `test` is represented in `node`, and each
	// values are strictly equal.
	function matchesFactory(test) {
	  return matches
	
	  function matches(node) {
	    var key
	
	    for (key in test) {
	      if (node[key] !== test[key]) {
	        return false
	      }
	    }
	
	    return true
	  }
	}
	
	function anyFactory(tests) {
	  var checks = convertAll(tests)
	  var length = checks.length
	
	  return matches
	
	  function matches() {
	    var index = -1
	
	    while (++index < length) {
	      if (checks[index].apply(this, arguments)) {
	        return true
	      }
	    }
	
	    return false
	  }
	}
	
	// Utility to convert a string into a function which checks a given node’s type
	// for said string.
	function typeFactory(test) {
	  return type
	
	  function type(node) {
	    return Boolean(node && node.type === test)
	  }
	}
	
	// Utility to return true.
	function ok() {
	  return true
	}


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var visit = __webpack_require__(76)
	
	module.exports = removePosition
	
	function removePosition(node, force) {
	  visit(node, force ? hard : soft)
	  return node
	}
	
	function hard(node) {
	  delete node.position
	}
	
	function soft(node) {
	  node.position = undefined
	}


/***/ }),
/* 638 */
/***/ (function(module, exports) {

	'use strict'
	
	var own = {}.hasOwnProperty
	
	module.exports = stringify
	
	function stringify(value) {
	  /* Nothing. */
	  if (!value || typeof value !== 'object') {
	    return null
	  }
	
	  /* Node. */
	  if (own.call(value, 'position') || own.call(value, 'type')) {
	    return position(value.position)
	  }
	
	  /* Position. */
	  if (own.call(value, 'start') || own.call(value, 'end')) {
	    return position(value)
	  }
	
	  /* Point. */
	  if (own.call(value, 'line') || own.call(value, 'column')) {
	    return point(value)
	  }
	
	  /* ? */
	  return null
	}
	
	function point(point) {
	  if (!point || typeof point !== 'object') {
	    point = {}
	  }
	
	  return index(point.line) + ':' + index(point.column)
	}
	
	function position(pos) {
	  if (!pos || typeof pos !== 'object') {
	    pos = {}
	  }
	
	  return point(pos.start) + '-' + point(pos.end)
	}
	
	function index(value) {
	  return value && typeof value === 'number' ? value : 1
	}


/***/ }),
/* 639 */
/***/ (function(module, exports) {

	'use strict'
	
	/* Expose. */
	module.exports = visitParents
	
	/* Visit. */
	function visitParents(tree, type, visitor) {
	  var stack = []
	
	  if (typeof type === 'function') {
	    visitor = type
	    type = null
	  }
	
	  one(tree)
	
	  /* Visit a single node. */
	  function one(node) {
	    var result
	
	    if (!type || node.type === type) {
	      result = visitor(node, stack.concat())
	    }
	
	    if (node.children && result !== false) {
	      return all(node.children, node)
	    }
	
	    return result
	  }
	
	  /* Visit children in `parent`. */
	  function all(children, parent) {
	    var length = children.length
	    var index = -1
	    var child
	
	    stack.push(parent)
	
	    while (++index < length) {
	      child = children[index]
	
	      if (child && one(child) === false) {
	        return false
	      }
	    }
	
	    stack.pop()
	
	    return true
	  }
	}


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = visitParents
	
	var convert = __webpack_require__(636)
	
	var CONTINUE = true
	var SKIP = 'skip'
	var EXIT = false
	
	visitParents.CONTINUE = CONTINUE
	visitParents.SKIP = SKIP
	visitParents.EXIT = EXIT
	
	function visitParents(tree, test, visitor, reverse) {
	  var is
	
	  if (typeof test === 'function' && typeof visitor !== 'function') {
	    reverse = visitor
	    visitor = test
	    test = null
	  }
	
	  is = convert(test)
	
	  one(tree, null, [])
	
	  // Visit a single node.
	  function one(node, index, parents) {
	    var result = []
	    var subresult
	
	    if (!test || is(node, index, parents[parents.length - 1] || null)) {
	      result = toResult(visitor(node, parents))
	
	      if (result[0] === EXIT) {
	        return result
	      }
	    }
	
	    if (node.children && result[0] !== SKIP) {
	      subresult = toResult(all(node.children, parents.concat(node)))
	      return subresult[0] === EXIT ? subresult : result
	    }
	
	    return result
	  }
	
	  // Visit children in `parent`.
	  function all(children, parents) {
	    var min = -1
	    var step = reverse ? -1 : 1
	    var index = (reverse ? children.length : min) + step
	    var result
	
	    while (index > min && index < children.length) {
	      result = one(children[index], index, parents)
	
	      if (result[0] === EXIT) {
	        return result
	      }
	
	      index = typeof result[1] === 'number' ? result[1] : index + step
	    }
	  }
	}
	
	function toResult(value) {
	  if (value !== null && typeof value === 'object' && 'length' in value) {
	    return value
	  }
	
	  if (typeof value === 'number') {
	    return [CONTINUE, value]
	  }
	
	  return [value]
	}


/***/ }),
/* 641 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNFNjUxMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0iZmVhdGhlciBmZWF0aGVyLWdsb2JlIj48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCI+PC9jaXJjbGU+PGxpbmUgeDE9IjIiIHkxPSIxMiIgeDI9IjIyIiB5Mj0iMTIiPjwvbGluZT48cGF0aCBkPSJNMTIgMmExNS4zIDE1LjMgMCAwIDEgNCAxMCAxNS4zIDE1LjMgMCAwIDEtNCAxMCAxNS4zIDE1LjMgMCAwIDEtNC0xMCAxNS4zIDE1LjMgMCAwIDEgNC0xMHoiPjwvcGF0aD48L3N2Zz4="

/***/ }),
/* 642 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgdmlld0JveD0iMCAwIDI1MCAyNTAiPgogIDxwYXRoIGQ9Ik0wLDAgTDExNSwxMTUgTDEzMCwxMTUgTDE0MiwxNDIgTDI1MCwyNTAgTDI1MCwwIFoiIGZpbGw9IiNlNjUwMDAiIC8+CiAgPHBhdGgKICAgIGQ9Ik0xMjguMywxMDkuMCBDMTEzLjgsOTkuNyAxMTkuMCw4OS42IDExOS4wLDg5LjYgQzEyMi4wLDgyLjcgMTIwLjUsNzguNiAxMjAuNSw3OC42IEMxMTkuMiw3Mi4wIDEyMy40LDc2LjMgMTIzLjQsNzYuMyBDMTI3LjMsODAuOSAxMjUuNSw4Ny4zIDEyNS41LDg3LjMgQzEyMi45LDk3LjYgMTMwLjYsMTAxLjkgMTM0LjQsMTAzLjIiCiAgICBmaWxsPSIjZmZmIgogICAgc3R5bGU9InRyYW5zZm9ybS1vcmlnaW46IDEzMHB4IDEwNnB4OyIKICAgIGNsYXNzPSJvY3RvLWFybSIKICAvPgogIDxwYXRoCiAgICBkPSJNMTE1LjAsMTE1LjAgQzExNC45LDExNS4xIDExOC43LDExNi41IDExOS44LDExNS40IEwxMzMuNywxMDEuNiBDMTM2LjksOTkuMiAxMzkuOSw5OC40IDE0Mi4yLDk4LjYgQzEzMy44LDg4LjAgMTI3LjUsNzQuNCAxNDMuOCw1OC4wIEMxNDguNSw1My40IDE1NC4wLDUxLjIgMTU5LjcsNTEuMCBDMTYwLjMsNDkuNCAxNjMuMiw0My42IDE3MS40LDQwLjEgQzE3MS40LDQwLjEgMTc2LjEsNDIuNSAxNzguOCw1Ni4yIEMxODMuMSw1OC42IDE4Ny4yLDYxLjggMTkwLjksNjUuNCBDMTk0LjUsNjkuMCAxOTcuNyw3My4yIDIwMC4xLDc3LjYgQzIxMy44LDgwLjIgMjE2LjMsODQuOSAyMTYuMyw4NC45IEMyMTIuNyw5My4xIDIwNi45LDk2LjAgMjA1LjQsOTYuNiBDMjA1LjEsMTAyLjQgMjAzLjAsMTA3LjggMTk4LjMsMTEyLjUgQzE4MS45LDEyOC45IDE2OC4zLDEyMi41IDE1Ny43LDExNC4xIEMxNTcuOSwxMTYuOSAxNTYuNywxMjAuOSAxNTIuNywxMjQuOSBMMTQxLjAsMTM2LjUgQzEzOS44LDEzNy43IDE0MS42LDE0MS45IDE0MS44LDE0MS44IFoiCiAgICBmaWxsPSIjZmZmIgogICAgY2xhc3M9Im9jdG8tYm9keSIKICAvPgo8L3N2Zz4gICAgICAgIA=="

/***/ }),
/* 643 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjMyIiBjbGFzcz0ib2N0aWNvbiBvY3RpY29uLXN0YXIiIHZpZXdCb3g9IjAgMCAxNCAxNiIgdmVyc2lvbj0iMS4xIiB3aWR0aD0iMjgiIGFyaWEtaGlkZGVuPSJ0cnVlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZmlsbD0iI0ZGQUMyQyIgZD0iTTE0IDZsLTQuOS0uNjRMNyAxIDQuOSA1LjM2IDAgNmwzLjYgMy4yNkwyLjY3IDE0IDcgMTEuNjcgMTEuMzMgMTRsLS45My00Ljc0eiI+PC9wYXRoPgo8L3N2Zz4K"

/***/ }),
/* 644 */,
/* 645 */,
/* 646 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = factory
	
	function factory(file) {
	  var contents = indices(String(file))
	
	  return {
	    toPosition: offsetToPositionFactory(contents),
	    toOffset: positionToOffsetFactory(contents)
	  }
	}
	
	// Factory to get the line and column-based `position` for `offset` in the bound
	// indices.
	function offsetToPositionFactory(indices) {
	  return offsetToPosition
	
	  // Get the line and column-based `position` for `offset` in the bound indices.
	  function offsetToPosition(offset) {
	    var index = -1
	    var length = indices.length
	
	    if (offset < 0) {
	      return {}
	    }
	
	    while (++index < length) {
	      if (indices[index] > offset) {
	        return {
	          line: index + 1,
	          column: offset - (indices[index - 1] || 0) + 1,
	          offset: offset
	        }
	      }
	    }
	
	    return {}
	  }
	}
	
	// Factory to get the `offset` for a line and column-based `position` in the
	// bound indices.
	function positionToOffsetFactory(indices) {
	  return positionToOffset
	
	  // Get the `offset` for a line and column-based `position` in the bound
	  // indices.
	  function positionToOffset(position) {
	    var line = position && position.line
	    var column = position && position.column
	
	    if (!isNaN(line) && !isNaN(column) && line - 1 in indices) {
	      return (indices[line - 2] || 0) + column - 1 || 0
	    }
	
	    return -1
	  }
	}
	
	// Get indices of line-breaks in `value`.
	function indices(value) {
	  var result = []
	  var index = value.indexOf('\n')
	
	  while (index !== -1) {
	    result.push(index + 1)
	    index = value.indexOf('\n', index + 1)
	  }
	
	  result.push(value.length + 1)
	
	  return result
	}


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var stringify = __webpack_require__(638)
	
	module.exports = VMessage
	
	// Inherit from `Error#`.
	function VMessagePrototype() {}
	VMessagePrototype.prototype = Error.prototype
	VMessage.prototype = new VMessagePrototype()
	
	// Message properties.
	var proto = VMessage.prototype
	
	proto.file = ''
	proto.name = ''
	proto.reason = ''
	proto.message = ''
	proto.stack = ''
	proto.fatal = null
	proto.column = null
	proto.line = null
	
	// Construct a new VMessage.
	//
	// Note: We cannot invoke `Error` on the created context, as that adds readonly
	// `line` and `column` attributes on Safari 9, thus throwing and failing the
	// data.
	function VMessage(reason, position, origin) {
	  var parts
	  var range
	  var location
	
	  if (typeof position === 'string') {
	    origin = position
	    position = null
	  }
	
	  parts = parseOrigin(origin)
	  range = stringify(position) || '1:1'
	
	  location = {
	    start: {line: null, column: null},
	    end: {line: null, column: null}
	  }
	
	  // Node.
	  if (position && position.position) {
	    position = position.position
	  }
	
	  if (position) {
	    // Position.
	    if (position.start) {
	      location = position
	      position = position.start
	    } else {
	      // Point.
	      location.start = position
	    }
	  }
	
	  if (reason.stack) {
	    this.stack = reason.stack
	    reason = reason.message
	  }
	
	  this.message = reason
	  this.name = range
	  this.reason = reason
	  this.line = position ? position.line : null
	  this.column = position ? position.column : null
	  this.location = location
	  this.source = parts[0]
	  this.ruleId = parts[1]
	}
	
	function parseOrigin(origin) {
	  var result = [null, null]
	  var index
	
	  if (typeof origin === 'string') {
	    index = origin.indexOf(':')
	
	    if (index === -1) {
	      result[1] = origin
	    } else {
	      result[0] = origin.slice(0, index)
	      result[1] = origin.slice(index + 1)
	    }
	  }
	
	  return result
	}


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var path = __webpack_require__(202);
	var replace = __webpack_require__(622);
	var buffer = __webpack_require__(650);
	
	module.exports = VFile;
	
	var own = {}.hasOwnProperty;
	var proto = VFile.prototype;
	
	proto.toString = toString;
	
	/* Order of setting (least specific to most), we need this because
	 * otherwise `{stem: 'a', path: '~/b.js'}` would throw, as a path
	 * is needed before a stem can be set. */
	var order = [
	  'history',
	  'path',
	  'basename',
	  'stem',
	  'extname',
	  'dirname'
	];
	
	/* Construct a new file. */
	function VFile(options) {
	  var prop;
	  var index;
	  var length;
	
	  if (!options) {
	    options = {};
	  } else if (typeof options === 'string' || buffer(options)) {
	    options = {contents: options};
	  } else if ('message' in options && 'messages' in options) {
	    return options;
	  }
	
	  if (!(this instanceof VFile)) {
	    return new VFile(options);
	  }
	
	  this.data = {};
	  this.messages = [];
	  this.history = [];
	  this.cwd = process.cwd();
	
	  /* Set path related properties in the correct order. */
	  index = -1;
	  length = order.length;
	
	  while (++index < length) {
	    prop = order[index];
	
	    if (own.call(options, prop)) {
	      this[prop] = options[prop];
	    }
	  }
	
	  /* Set non-path related properties. */
	  for (prop in options) {
	    if (order.indexOf(prop) === -1) {
	      this[prop] = options[prop];
	    }
	  }
	}
	
	/* Access full path (`~/index.min.js`). */
	Object.defineProperty(proto, 'path', {
	  get: function () {
	    return this.history[this.history.length - 1];
	  },
	  set: function (path) {
	    assertNonEmpty(path, 'path');
	
	    if (path !== this.path) {
	      this.history.push(path);
	    }
	  }
	});
	
	/* Access parent path (`~`). */
	Object.defineProperty(proto, 'dirname', {
	  get: function () {
	    return typeof this.path === 'string' ? path.dirname(this.path) : undefined;
	  },
	  set: function (dirname) {
	    assertPath(this.path, 'dirname');
	    this.path = path.join(dirname || '', this.basename);
	  }
	});
	
	/* Access basename (`index.min.js`). */
	Object.defineProperty(proto, 'basename', {
	  get: function () {
	    return typeof this.path === 'string' ? path.basename(this.path) : undefined;
	  },
	  set: function (basename) {
	    assertNonEmpty(basename, 'basename');
	    assertPart(basename, 'basename');
	    this.path = path.join(this.dirname || '', basename);
	  }
	});
	
	/* Access extname (`.js`). */
	Object.defineProperty(proto, 'extname', {
	  get: function () {
	    return typeof this.path === 'string' ? path.extname(this.path) : undefined;
	  },
	  set: function (extname) {
	    var ext = extname || '';
	
	    assertPart(ext, 'extname');
	    assertPath(this.path, 'extname');
	
	    if (ext) {
	      if (ext.charAt(0) !== '.') {
	        throw new Error('`extname` must start with `.`');
	      }
	
	      if (ext.indexOf('.', 1) !== -1) {
	        throw new Error('`extname` cannot contain multiple dots');
	      }
	    }
	
	    this.path = replace(this.path, ext);
	  }
	});
	
	/* Access stem (`index.min`). */
	Object.defineProperty(proto, 'stem', {
	  get: function () {
	    return typeof this.path === 'string' ? path.basename(this.path, this.extname) : undefined;
	  },
	  set: function (stem) {
	    assertNonEmpty(stem, 'stem');
	    assertPart(stem, 'stem');
	    this.path = path.join(this.dirname || '', stem + (this.extname || ''));
	  }
	});
	
	/* Get the value of the file. */
	function toString(encoding) {
	  var value = this.contents || '';
	  return buffer(value) ? value.toString(encoding) : String(value);
	}
	
	/* Assert that `part` is not a path (i.e., does
	 * not contain `path.sep`). */
	function assertPart(part, name) {
	  if (part.indexOf(path.sep) !== -1) {
	    throw new Error('`' + name + '` cannot be a path: did not expect `' + path.sep + '`');
	  }
	}
	
	/* Assert that `part` is not empty. */
	function assertNonEmpty(part, name) {
	  if (!part) {
	    throw new Error('`' + name + '` cannot be empty');
	  }
	}
	
	/* Assert `path` exists. */
	function assertPath(path, name) {
	  if (!path) {
	    throw new Error('Setting `' + name + '` requires `path` to be set too');
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var VMessage = __webpack_require__(647);
	var VFile = __webpack_require__(648);
	
	module.exports = VFile;
	
	var proto = VFile.prototype;
	
	proto.message = message;
	proto.info = info;
	proto.fail = fail;
	
	/* Slight backwards compatibility.  Remove in the future. */
	proto.warn = message;
	
	/* Create a message with `reason` at `position`.
	 * When an error is passed in as `reason`, copies the stack. */
	function message(reason, position, origin) {
	  var filePath = this.path;
	  var message = new VMessage(reason, position, origin);
	
	  if (filePath) {
	    message.name = filePath + ':' + message.name;
	    message.file = filePath;
	  }
	
	  message.fatal = false;
	
	  this.messages.push(message);
	
	  return message;
	}
	
	/* Fail. Creates a vmessage, associates it with the file,
	 * and throws it. */
	function fail() {
	  var message = this.message.apply(this, arguments);
	
	  message.fatal = true;
	
	  throw message;
	}
	
	/* Info. Creates a vmessage, associates it with the file,
	 * and marks the fatality as null. */
	function info() {
	  var message = this.message.apply(this, arguments);
	
	  message.fatal = null;
	
	  return message;
	}


/***/ }),
/* 650 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),
/* 651 */,
/* 652 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 653 */
/***/ (function(module, exports) {

	var toString = Object.prototype.toString
	
	module.exports = isString
	
	function isString(obj) {
	    return toString.call(obj) === "[object String]"
	}


/***/ }),
/* 654 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 655 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 656 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// component---src-page-container-js-86c57ba1364f7ee4a6d0.js